
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired6dc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired6dc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("36KFK", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $243622ce5dc9d430$export$ffb0004e005737fa; }, function (v) { return $243622ce5dc9d430$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $243622ce5dc9d430$export$34b9dba7ce09269b; }, function (v) { return $243622ce5dc9d430$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $243622ce5dc9d430$export$25062201e9e25d76; }, function (v) { return $243622ce5dc9d430$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $243622ce5dc9d430$export$ffb0004e005737fa;
var $243622ce5dc9d430$export$34b9dba7ce09269b;
var $243622ce5dc9d430$export$25062201e9e25d76;
"use strict";
var $243622ce5dc9d430$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $243622ce5dc9d430$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $243622ce5dc9d430$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $243622ce5dc9d430$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$243622ce5dc9d430$export$ffb0004e005737fa = $243622ce5dc9d430$var$REACT_FRAGMENT_TYPE;
$243622ce5dc9d430$export$34b9dba7ce09269b = $243622ce5dc9d430$var$jsxProd;
$243622ce5dc9d430$export$25062201e9e25d76 = $243622ce5dc9d430$var$jsxProd;

});

parcelRegister("5nf0E", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $3e9abe51d80d0e33$export$dca3b0875bd9a954; }, function (v) { return $3e9abe51d80d0e33$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $3e9abe51d80d0e33$export$16fa2f45be04daa8; }, function (v) { return $3e9abe51d80d0e33$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $3e9abe51d80d0e33$export$ffb0004e005737fa; }, function (v) { return $3e9abe51d80d0e33$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $3e9abe51d80d0e33$export$e2c29f18771995cb; }, function (v) { return $3e9abe51d80d0e33$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $3e9abe51d80d0e33$export$221d75b3f55bb0bd; }, function (v) { return $3e9abe51d80d0e33$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $3e9abe51d80d0e33$export$5f8d39834fd61797; }, function (v) { return $3e9abe51d80d0e33$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $3e9abe51d80d0e33$export$74bf444e3cd11ea5; }, function (v) { return $3e9abe51d80d0e33$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $3e9abe51d80d0e33$export$1ced07cd6b1985ce; }, function (v) { return $3e9abe51d80d0e33$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "act", function () { return $3e9abe51d80d0e33$export$3ba232387fd5d6dd; }, function (v) { return $3e9abe51d80d0e33$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cache", function () { return $3e9abe51d80d0e33$export$69a3209f1a06c04d; }, function (v) { return $3e9abe51d80d0e33$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $3e9abe51d80d0e33$export$e530037191fcd5d7; }, function (v) { return $3e9abe51d80d0e33$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $3e9abe51d80d0e33$export$fd42f52fd3ae1109; }, function (v) { return $3e9abe51d80d0e33$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $3e9abe51d80d0e33$export$c8a8987d4410bf2d; }, function (v) { return $3e9abe51d80d0e33$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $3e9abe51d80d0e33$export$7d1e3a5e95ceca43; }, function (v) { return $3e9abe51d80d0e33$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $3e9abe51d80d0e33$export$257a8862b851cb5b; }, function (v) { return $3e9abe51d80d0e33$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $3e9abe51d80d0e33$export$a8257692ac88316c; }, function (v) { return $3e9abe51d80d0e33$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $3e9abe51d80d0e33$export$488013bae63b21da; }, function (v) { return $3e9abe51d80d0e33$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $3e9abe51d80d0e33$export$7c73462e0d25e514; }, function (v) { return $3e9abe51d80d0e33$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $3e9abe51d80d0e33$export$7568632d0d33d16d; }, function (v) { return $3e9abe51d80d0e33$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $3e9abe51d80d0e33$export$f93f40ac0ca7e3a8; }, function (v) { return $3e9abe51d80d0e33$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $3e9abe51d80d0e33$export$1f96ae73734a86cc; }, function (v) { return $3e9abe51d80d0e33$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $3e9abe51d80d0e33$export$9a47ced3238df325; }, function (v) { return $3e9abe51d80d0e33$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $3e9abe51d80d0e33$export$35808ee640e87ca7; }, function (v) { return $3e9abe51d80d0e33$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $3e9abe51d80d0e33$export$fae74005e78b1a27; }, function (v) { return $3e9abe51d80d0e33$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $3e9abe51d80d0e33$export$dc8fbce3eb94dc1e; }, function (v) { return $3e9abe51d80d0e33$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $3e9abe51d80d0e33$export$6a7bc4e911dc01cf; }, function (v) { return $3e9abe51d80d0e33$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $3e9abe51d80d0e33$export$6d9c69b0de29b591; }, function (v) { return $3e9abe51d80d0e33$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $3e9abe51d80d0e33$export$f680877a34711e37; }, function (v) { return $3e9abe51d80d0e33$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $3e9abe51d80d0e33$export$d5a552a76deda3c2; }, function (v) { return $3e9abe51d80d0e33$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $3e9abe51d80d0e33$export$aaabe4eda9ed9969; }, function (v) { return $3e9abe51d80d0e33$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $3e9abe51d80d0e33$export$e5c5a5f917a5871c; }, function (v) { return $3e9abe51d80d0e33$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $3e9abe51d80d0e33$export$1538c33de8887b59; }, function (v) { return $3e9abe51d80d0e33$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $3e9abe51d80d0e33$export$fca7f784ae7a249a; }, function (v) { return $3e9abe51d80d0e33$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $3e9abe51d80d0e33$export$13e3392192263954; }, function (v) { return $3e9abe51d80d0e33$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $3e9abe51d80d0e33$export$b8f5890fc79d6aca; }, function (v) { return $3e9abe51d80d0e33$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $3e9abe51d80d0e33$export$60241385465d0a34; }, function (v) { return $3e9abe51d80d0e33$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $3e9abe51d80d0e33$export$306c0aa65ff9ec16; }, function (v) { return $3e9abe51d80d0e33$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $3e9abe51d80d0e33$export$7b286972b8d8ccbf; }, function (v) { return $3e9abe51d80d0e33$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $3e9abe51d80d0e33$export$83d89fbfd8236492; }, function (v) { return $3e9abe51d80d0e33$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3e9abe51d80d0e33$export$dca3b0875bd9a954;
var $3e9abe51d80d0e33$export$16fa2f45be04daa8;
var $3e9abe51d80d0e33$export$ffb0004e005737fa;
var $3e9abe51d80d0e33$export$e2c29f18771995cb;
var $3e9abe51d80d0e33$export$221d75b3f55bb0bd;
var $3e9abe51d80d0e33$export$5f8d39834fd61797;
var $3e9abe51d80d0e33$export$74bf444e3cd11ea5;
var $3e9abe51d80d0e33$export$1ced07cd6b1985ce;
var $3e9abe51d80d0e33$export$3ba232387fd5d6dd;
var $3e9abe51d80d0e33$export$69a3209f1a06c04d;
var $3e9abe51d80d0e33$export$e530037191fcd5d7;
var $3e9abe51d80d0e33$export$fd42f52fd3ae1109;
var $3e9abe51d80d0e33$export$c8a8987d4410bf2d;
var $3e9abe51d80d0e33$export$7d1e3a5e95ceca43;
var $3e9abe51d80d0e33$export$257a8862b851cb5b;
var $3e9abe51d80d0e33$export$a8257692ac88316c;
var $3e9abe51d80d0e33$export$488013bae63b21da;
var $3e9abe51d80d0e33$export$7c73462e0d25e514;
var $3e9abe51d80d0e33$export$7568632d0d33d16d;
var $3e9abe51d80d0e33$export$f93f40ac0ca7e3a8;
var $3e9abe51d80d0e33$export$1f96ae73734a86cc;
var $3e9abe51d80d0e33$export$9a47ced3238df325;
var $3e9abe51d80d0e33$export$35808ee640e87ca7;
var $3e9abe51d80d0e33$export$fae74005e78b1a27;
var $3e9abe51d80d0e33$export$dc8fbce3eb94dc1e;
var $3e9abe51d80d0e33$export$6a7bc4e911dc01cf;
var $3e9abe51d80d0e33$export$6d9c69b0de29b591;
var $3e9abe51d80d0e33$export$f680877a34711e37;
var $3e9abe51d80d0e33$export$d5a552a76deda3c2;
var $3e9abe51d80d0e33$export$aaabe4eda9ed9969;
var $3e9abe51d80d0e33$export$e5c5a5f917a5871c;
var $3e9abe51d80d0e33$export$1538c33de8887b59;
var $3e9abe51d80d0e33$export$fca7f784ae7a249a;
var $3e9abe51d80d0e33$export$13e3392192263954;
var $3e9abe51d80d0e33$export$b8f5890fc79d6aca;
var $3e9abe51d80d0e33$export$60241385465d0a34;
var $3e9abe51d80d0e33$export$306c0aa65ff9ec16;
var $3e9abe51d80d0e33$export$7b286972b8d8ccbf;
var $3e9abe51d80d0e33$export$83d89fbfd8236492;
"use strict";
var $3e9abe51d80d0e33$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $3e9abe51d80d0e33$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $3e9abe51d80d0e33$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $3e9abe51d80d0e33$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $3e9abe51d80d0e33$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $3e9abe51d80d0e33$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $3e9abe51d80d0e33$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $3e9abe51d80d0e33$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $3e9abe51d80d0e33$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $3e9abe51d80d0e33$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $3e9abe51d80d0e33$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $3e9abe51d80d0e33$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $3e9abe51d80d0e33$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $3e9abe51d80d0e33$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$3e9abe51d80d0e33$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $3e9abe51d80d0e33$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $3e9abe51d80d0e33$var$assign = Object.assign, $3e9abe51d80d0e33$var$emptyObject = {};
function $3e9abe51d80d0e33$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $3e9abe51d80d0e33$var$emptyObject;
    this.updater = updater || $3e9abe51d80d0e33$var$ReactNoopUpdateQueue;
}
$3e9abe51d80d0e33$var$Component.prototype.isReactComponent = {};
$3e9abe51d80d0e33$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$3e9abe51d80d0e33$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $3e9abe51d80d0e33$var$ComponentDummy() {}
$3e9abe51d80d0e33$var$ComponentDummy.prototype = $3e9abe51d80d0e33$var$Component.prototype;
function $3e9abe51d80d0e33$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $3e9abe51d80d0e33$var$emptyObject;
    this.updater = updater || $3e9abe51d80d0e33$var$ReactNoopUpdateQueue;
}
var $3e9abe51d80d0e33$var$pureComponentPrototype = $3e9abe51d80d0e33$var$PureComponent.prototype = new $3e9abe51d80d0e33$var$ComponentDummy();
$3e9abe51d80d0e33$var$pureComponentPrototype.constructor = $3e9abe51d80d0e33$var$PureComponent;
$3e9abe51d80d0e33$var$assign($3e9abe51d80d0e33$var$pureComponentPrototype, $3e9abe51d80d0e33$var$Component.prototype);
$3e9abe51d80d0e33$var$pureComponentPrototype.isPureReactComponent = !0;
var $3e9abe51d80d0e33$var$isArrayImpl = Array.isArray, $3e9abe51d80d0e33$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $3e9abe51d80d0e33$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $3e9abe51d80d0e33$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $3e9abe51d80d0e33$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $3e9abe51d80d0e33$var$cloneAndReplaceKey(oldElement, newKey) {
    return $3e9abe51d80d0e33$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $3e9abe51d80d0e33$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $3e9abe51d80d0e33$var$REACT_ELEMENT_TYPE;
}
function $3e9abe51d80d0e33$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $3e9abe51d80d0e33$var$userProvidedKeyEscapeRegex = /\/+/g;
function $3e9abe51d80d0e33$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $3e9abe51d80d0e33$var$escape("" + element.key) : index.toString(36);
}
function $3e9abe51d80d0e33$var$noop$1() {}
function $3e9abe51d80d0e33$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($3e9abe51d80d0e33$var$noop$1, $3e9abe51d80d0e33$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $3e9abe51d80d0e33$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $3e9abe51d80d0e33$var$REACT_ELEMENT_TYPE:
                case $3e9abe51d80d0e33$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $3e9abe51d80d0e33$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $3e9abe51d80d0e33$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $3e9abe51d80d0e33$var$getElementKey(children, 0) : nameSoFar, $3e9abe51d80d0e33$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($3e9abe51d80d0e33$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $3e9abe51d80d0e33$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($3e9abe51d80d0e33$var$isValidElement(callback) && (callback = $3e9abe51d80d0e33$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($3e9abe51d80d0e33$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($3e9abe51d80d0e33$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $3e9abe51d80d0e33$var$getElementKey(nameSoFar, i), invokeCallback += $3e9abe51d80d0e33$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $3e9abe51d80d0e33$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $3e9abe51d80d0e33$var$getElementKey(nameSoFar, i++), invokeCallback += $3e9abe51d80d0e33$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $3e9abe51d80d0e33$var$mapIntoArray($3e9abe51d80d0e33$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $3e9abe51d80d0e33$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $3e9abe51d80d0e33$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $3e9abe51d80d0e33$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $3e9abe51d80d0e33$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $3e9abe51d80d0e33$var$noop() {}
$3e9abe51d80d0e33$export$dca3b0875bd9a954 = {
    map: $3e9abe51d80d0e33$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $3e9abe51d80d0e33$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $3e9abe51d80d0e33$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $3e9abe51d80d0e33$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$3e9abe51d80d0e33$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$3e9abe51d80d0e33$export$16fa2f45be04daa8 = $3e9abe51d80d0e33$var$Component;
$3e9abe51d80d0e33$export$ffb0004e005737fa = $3e9abe51d80d0e33$var$REACT_FRAGMENT_TYPE;
$3e9abe51d80d0e33$export$e2c29f18771995cb = $3e9abe51d80d0e33$var$REACT_PROFILER_TYPE;
$3e9abe51d80d0e33$export$221d75b3f55bb0bd = $3e9abe51d80d0e33$var$PureComponent;
$3e9abe51d80d0e33$export$5f8d39834fd61797 = $3e9abe51d80d0e33$var$REACT_STRICT_MODE_TYPE;
$3e9abe51d80d0e33$export$74bf444e3cd11ea5 = $3e9abe51d80d0e33$var$REACT_SUSPENSE_TYPE;
$3e9abe51d80d0e33$export$1ced07cd6b1985ce = $3e9abe51d80d0e33$var$ReactSharedInternals;
$3e9abe51d80d0e33$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$3e9abe51d80d0e33$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$3e9abe51d80d0e33$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $3e9abe51d80d0e33$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$3e9abe51d80d0e33$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $3e9abe51d80d0e33$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$3e9abe51d80d0e33$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $3e9abe51d80d0e33$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $3e9abe51d80d0e33$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$3e9abe51d80d0e33$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$3e9abe51d80d0e33$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $3e9abe51d80d0e33$var$ReactElement(type, key, void 0, void 0, null, props);
};
$3e9abe51d80d0e33$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$3e9abe51d80d0e33$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $3e9abe51d80d0e33$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$3e9abe51d80d0e33$export$a8257692ac88316c = $3e9abe51d80d0e33$var$isValidElement;
$3e9abe51d80d0e33$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $3e9abe51d80d0e33$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $3e9abe51d80d0e33$var$lazyInitializer
    };
};
$3e9abe51d80d0e33$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $3e9abe51d80d0e33$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$3e9abe51d80d0e33$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $3e9abe51d80d0e33$var$ReactSharedInternals.T, currentTransition = {};
    $3e9abe51d80d0e33$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $3e9abe51d80d0e33$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($3e9abe51d80d0e33$var$noop, $3e9abe51d80d0e33$var$reportGlobalError);
    } catch (error) {
        $3e9abe51d80d0e33$var$reportGlobalError(error);
    } finally{
        $3e9abe51d80d0e33$var$ReactSharedInternals.T = prevTransition;
    }
};
$3e9abe51d80d0e33$export$f93f40ac0ca7e3a8 = function() {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useCacheRefresh();
};
$3e9abe51d80d0e33$export$1f96ae73734a86cc = function(usable) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.use(usable);
};
$3e9abe51d80d0e33$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$3e9abe51d80d0e33$export$35808ee640e87ca7 = function(callback, deps) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$3e9abe51d80d0e33$export$fae74005e78b1a27 = function(Context) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useContext(Context);
};
$3e9abe51d80d0e33$export$dc8fbce3eb94dc1e = function() {};
$3e9abe51d80d0e33$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$3e9abe51d80d0e33$export$6d9c69b0de29b591 = function(create, deps) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useEffect(create, deps);
};
$3e9abe51d80d0e33$export$f680877a34711e37 = function() {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useId();
};
$3e9abe51d80d0e33$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$3e9abe51d80d0e33$export$aaabe4eda9ed9969 = function(create, deps) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$3e9abe51d80d0e33$export$e5c5a5f917a5871c = function(create, deps) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$3e9abe51d80d0e33$export$1538c33de8887b59 = function(create, deps) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useMemo(create, deps);
};
$3e9abe51d80d0e33$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$3e9abe51d80d0e33$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$3e9abe51d80d0e33$export$b8f5890fc79d6aca = function(initialValue) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useRef(initialValue);
};
$3e9abe51d80d0e33$export$60241385465d0a34 = function(initialState) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useState(initialState);
};
$3e9abe51d80d0e33$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$3e9abe51d80d0e33$export$7b286972b8d8ccbf = function() {
    return $3e9abe51d80d0e33$var$ReactSharedInternals.H.useTransition();
};
$3e9abe51d80d0e33$export$83d89fbfd8236492 = "19.0.0";

});

parcelRegister("gQH9B", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $c442fa203ef9538d$export$882461b6382ed46c; }, function (v) { return $c442fa203ef9538d$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c442fa203ef9538d$export$757ceba2d55c277e; }, function (v) { return $c442fa203ef9538d$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $c442fa203ef9538d$export$83d89fbfd8236492; }, function (v) { return $c442fa203ef9538d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c442fa203ef9538d$export$882461b6382ed46c;
var $c442fa203ef9538d$export$757ceba2d55c277e;
var $c442fa203ef9538d$export$83d89fbfd8236492;
"use strict";

var $Qw0kg = parcelRequire("Qw0kg");

var $gIfym = parcelRequire("gIfym");

var $gSDKV = parcelRequire("gSDKV");
function $c442fa203ef9538d$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $c442fa203ef9538d$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $c442fa203ef9538d$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $c442fa203ef9538d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $c442fa203ef9538d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $c442fa203ef9538d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $c442fa203ef9538d$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $c442fa203ef9538d$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $c442fa203ef9538d$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $c442fa203ef9538d$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $c442fa203ef9538d$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $c442fa203ef9538d$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $c442fa203ef9538d$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $c442fa203ef9538d$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $c442fa203ef9538d$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $c442fa203ef9538d$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c442fa203ef9538d$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $c442fa203ef9538d$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $c442fa203ef9538d$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $c442fa203ef9538d$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $c442fa203ef9538d$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$c442fa203ef9538d$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $c442fa203ef9538d$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $c442fa203ef9538d$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $c442fa203ef9538d$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $c442fa203ef9538d$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $c442fa203ef9538d$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $c442fa203ef9538d$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $c442fa203ef9538d$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $c442fa203ef9538d$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $c442fa203ef9538d$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $c442fa203ef9538d$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $c442fa203ef9538d$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $c442fa203ef9538d$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $c442fa203ef9538d$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $c442fa203ef9538d$var$getComponentNameFromType(type.type) || "Memo";
        case $c442fa203ef9538d$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $c442fa203ef9538d$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $c442fa203ef9538d$var$ReactSharedInternals = $gIfym.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c442fa203ef9538d$var$assign = Object.assign, $c442fa203ef9538d$var$prefix, $c442fa203ef9538d$var$suffix;
function $c442fa203ef9538d$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $c442fa203ef9538d$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $c442fa203ef9538d$var$prefix = match && match[1] || "";
        $c442fa203ef9538d$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $c442fa203ef9538d$var$prefix + name + $c442fa203ef9538d$var$suffix;
}
var $c442fa203ef9538d$var$reentry = !1;
function $c442fa203ef9538d$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $c442fa203ef9538d$var$reentry) return "";
    $c442fa203ef9538d$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $c442fa203ef9538d$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $c442fa203ef9538d$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $c442fa203ef9538d$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $c442fa203ef9538d$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $c442fa203ef9538d$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $c442fa203ef9538d$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $c442fa203ef9538d$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $c442fa203ef9538d$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $c442fa203ef9538d$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $c442fa203ef9538d$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $c442fa203ef9538d$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $c442fa203ef9538d$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $c442fa203ef9538d$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $c442fa203ef9538d$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $c442fa203ef9538d$var$assertIsMounted(fiber) {
    if ($c442fa203ef9538d$var$getNearestMountedFiber(fiber) !== fiber) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(188));
}
function $c442fa203ef9538d$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $c442fa203ef9538d$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $c442fa203ef9538d$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $c442fa203ef9538d$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($c442fa203ef9538d$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $c442fa203ef9538d$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $c442fa203ef9538d$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $c442fa203ef9538d$var$isArrayImpl = Array.isArray, $c442fa203ef9538d$var$ReactDOMSharedInternals = $gSDKV.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c442fa203ef9538d$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $c442fa203ef9538d$var$valueStack = [], $c442fa203ef9538d$var$index = -1;
function $c442fa203ef9538d$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $c442fa203ef9538d$var$pop(cursor) {
    0 > $c442fa203ef9538d$var$index || (cursor.current = $c442fa203ef9538d$var$valueStack[$c442fa203ef9538d$var$index], $c442fa203ef9538d$var$valueStack[$c442fa203ef9538d$var$index] = null, $c442fa203ef9538d$var$index--);
}
function $c442fa203ef9538d$var$push(cursor, value) {
    $c442fa203ef9538d$var$index++;
    $c442fa203ef9538d$var$valueStack[$c442fa203ef9538d$var$index] = cursor.current;
    cursor.current = value;
}
var $c442fa203ef9538d$var$contextStackCursor = $c442fa203ef9538d$var$createCursor(null), $c442fa203ef9538d$var$contextFiberStackCursor = $c442fa203ef9538d$var$createCursor(null), $c442fa203ef9538d$var$rootInstanceStackCursor = $c442fa203ef9538d$var$createCursor(null), $c442fa203ef9538d$var$hostTransitionProviderCursor = $c442fa203ef9538d$var$createCursor(null);
function $c442fa203ef9538d$var$pushHostContainer(fiber, nextRootInstance) {
    $c442fa203ef9538d$var$push($c442fa203ef9538d$var$rootInstanceStackCursor, nextRootInstance);
    $c442fa203ef9538d$var$push($c442fa203ef9538d$var$contextFiberStackCursor, fiber);
    $c442fa203ef9538d$var$push($c442fa203ef9538d$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $c442fa203ef9538d$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $c442fa203ef9538d$var$getOwnHostContext(fiber), nextRootInstance = $c442fa203ef9538d$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$contextStackCursor);
    $c442fa203ef9538d$var$push($c442fa203ef9538d$var$contextStackCursor, nextRootInstance);
}
function $c442fa203ef9538d$var$popHostContainer() {
    $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$contextStackCursor);
    $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$contextFiberStackCursor);
    $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$rootInstanceStackCursor);
}
function $c442fa203ef9538d$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $c442fa203ef9538d$var$push($c442fa203ef9538d$var$hostTransitionProviderCursor, fiber);
    var context = $c442fa203ef9538d$var$contextStackCursor.current;
    var JSCompiler_inline_result = $c442fa203ef9538d$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($c442fa203ef9538d$var$push($c442fa203ef9538d$var$contextFiberStackCursor, fiber), $c442fa203ef9538d$var$push($c442fa203ef9538d$var$contextStackCursor, JSCompiler_inline_result));
}
function $c442fa203ef9538d$var$popHostContext(fiber) {
    $c442fa203ef9538d$var$contextFiberStackCursor.current === fiber && ($c442fa203ef9538d$var$pop($c442fa203ef9538d$var$contextStackCursor), $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$contextFiberStackCursor));
    $c442fa203ef9538d$var$hostTransitionProviderCursor.current === fiber && ($c442fa203ef9538d$var$pop($c442fa203ef9538d$var$hostTransitionProviderCursor), $c442fa203ef9538d$var$HostTransitionContext._currentValue = $c442fa203ef9538d$var$sharedNotPendingObject);
}
var $c442fa203ef9538d$var$hasOwnProperty = Object.prototype.hasOwnProperty, $c442fa203ef9538d$var$scheduleCallback$3 = $Qw0kg.unstable_scheduleCallback, $c442fa203ef9538d$var$cancelCallback$1 = $Qw0kg.unstable_cancelCallback, $c442fa203ef9538d$var$shouldYield = $Qw0kg.unstable_shouldYield, $c442fa203ef9538d$var$requestPaint = $Qw0kg.unstable_requestPaint, $c442fa203ef9538d$var$now = $Qw0kg.unstable_now, $c442fa203ef9538d$var$getCurrentPriorityLevel = $Qw0kg.unstable_getCurrentPriorityLevel, $c442fa203ef9538d$var$ImmediatePriority = $Qw0kg.unstable_ImmediatePriority, $c442fa203ef9538d$var$UserBlockingPriority = $Qw0kg.unstable_UserBlockingPriority, $c442fa203ef9538d$var$NormalPriority$1 = $Qw0kg.unstable_NormalPriority, $c442fa203ef9538d$var$LowPriority = $Qw0kg.unstable_LowPriority, $c442fa203ef9538d$var$IdlePriority = $Qw0kg.unstable_IdlePriority, $c442fa203ef9538d$var$log$1 = $Qw0kg.log, $c442fa203ef9538d$var$unstable_setDisableYieldValue = $Qw0kg.unstable_setDisableYieldValue, $c442fa203ef9538d$var$rendererID = null, $c442fa203ef9538d$var$injectedHook = null;
function $c442fa203ef9538d$var$onCommitRoot(root) {
    if ($c442fa203ef9538d$var$injectedHook && "function" === typeof $c442fa203ef9538d$var$injectedHook.onCommitFiberRoot) try {
        $c442fa203ef9538d$var$injectedHook.onCommitFiberRoot($c442fa203ef9538d$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $c442fa203ef9538d$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $c442fa203ef9538d$var$log$1 && $c442fa203ef9538d$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($c442fa203ef9538d$var$injectedHook && "function" === typeof $c442fa203ef9538d$var$injectedHook.setStrictMode) try {
        $c442fa203ef9538d$var$injectedHook.setStrictMode($c442fa203ef9538d$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $c442fa203ef9538d$var$clz32 = Math.clz32 ? Math.clz32 : $c442fa203ef9538d$var$clz32Fallback, $c442fa203ef9538d$var$log = Math.log, $c442fa203ef9538d$var$LN2 = Math.LN2;
function $c442fa203ef9538d$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($c442fa203ef9538d$var$log(x) / $c442fa203ef9538d$var$LN2 | 0) | 0;
}
var $c442fa203ef9538d$var$nextTransitionLane = 128, $c442fa203ef9538d$var$nextRetryLane = 4194304;
function $c442fa203ef9538d$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $c442fa203ef9538d$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $c442fa203ef9538d$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $c442fa203ef9538d$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $c442fa203ef9538d$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $c442fa203ef9538d$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $c442fa203ef9538d$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $c442fa203ef9538d$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $c442fa203ef9538d$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $c442fa203ef9538d$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c442fa203ef9538d$var$claimNextTransitionLane() {
    var lane = $c442fa203ef9538d$var$nextTransitionLane;
    $c442fa203ef9538d$var$nextTransitionLane <<= 1;
    0 === ($c442fa203ef9538d$var$nextTransitionLane & 4194176) && ($c442fa203ef9538d$var$nextTransitionLane = 128);
    return lane;
}
function $c442fa203ef9538d$var$claimNextRetryLane() {
    var lane = $c442fa203ef9538d$var$nextRetryLane;
    $c442fa203ef9538d$var$nextRetryLane <<= 1;
    0 === ($c442fa203ef9538d$var$nextRetryLane & 62914560) && ($c442fa203ef9538d$var$nextRetryLane = 4194304);
    return lane;
}
function $c442fa203ef9538d$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $c442fa203ef9538d$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $c442fa203ef9538d$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $c442fa203ef9538d$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $c442fa203ef9538d$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $c442fa203ef9538d$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $c442fa203ef9538d$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $c442fa203ef9538d$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $c442fa203ef9538d$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $c442fa203ef9538d$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $c442fa203ef9538d$var$resolveUpdatePriority() {
    var updatePriority = $c442fa203ef9538d$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $c442fa203ef9538d$var$getEventPriority(updatePriority.type);
}
function $c442fa203ef9538d$var$runWithPriority(priority, fn) {
    var previousPriority = $c442fa203ef9538d$var$ReactDOMSharedInternals.p;
    try {
        return $c442fa203ef9538d$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $c442fa203ef9538d$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $c442fa203ef9538d$var$randomKey = Math.random().toString(36).slice(2), $c442fa203ef9538d$var$internalInstanceKey = "__reactFiber$" + $c442fa203ef9538d$var$randomKey, $c442fa203ef9538d$var$internalPropsKey = "__reactProps$" + $c442fa203ef9538d$var$randomKey, $c442fa203ef9538d$var$internalContainerInstanceKey = "__reactContainer$" + $c442fa203ef9538d$var$randomKey, $c442fa203ef9538d$var$internalEventHandlersKey = "__reactEvents$" + $c442fa203ef9538d$var$randomKey, $c442fa203ef9538d$var$internalEventHandlerListenersKey = "__reactListeners$" + $c442fa203ef9538d$var$randomKey, $c442fa203ef9538d$var$internalEventHandlesSetKey = "__reactHandles$" + $c442fa203ef9538d$var$randomKey, $c442fa203ef9538d$var$internalRootNodeResourcesKey = "__reactResources$" + $c442fa203ef9538d$var$randomKey, $c442fa203ef9538d$var$internalHoistableMarker = "__reactMarker$" + $c442fa203ef9538d$var$randomKey;
function $c442fa203ef9538d$var$detachDeletedInstance(node) {
    delete node[$c442fa203ef9538d$var$internalInstanceKey];
    delete node[$c442fa203ef9538d$var$internalPropsKey];
    delete node[$c442fa203ef9538d$var$internalEventHandlersKey];
    delete node[$c442fa203ef9538d$var$internalEventHandlerListenersKey];
    delete node[$c442fa203ef9538d$var$internalEventHandlesSetKey];
}
function $c442fa203ef9538d$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$c442fa203ef9538d$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$c442fa203ef9538d$var$internalContainerInstanceKey] || parentNode[$c442fa203ef9538d$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $c442fa203ef9538d$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$c442fa203ef9538d$var$internalInstanceKey]) return parentNode;
                targetNode = $c442fa203ef9538d$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $c442fa203ef9538d$var$getInstanceFromNode(node) {
    if (node = node[$c442fa203ef9538d$var$internalInstanceKey] || node[$c442fa203ef9538d$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $c442fa203ef9538d$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($c442fa203ef9538d$var$formatProdErrorMessage(33));
}
function $c442fa203ef9538d$var$getResourcesFromRoot(root) {
    var resources = root[$c442fa203ef9538d$var$internalRootNodeResourcesKey];
    resources || (resources = root[$c442fa203ef9538d$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $c442fa203ef9538d$var$markNodeAsHoistable(node) {
    node[$c442fa203ef9538d$var$internalHoistableMarker] = !0;
}
var $c442fa203ef9538d$var$allNativeEvents = new Set(), $c442fa203ef9538d$var$registrationNameDependencies = {};
function $c442fa203ef9538d$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $c442fa203ef9538d$var$registerDirectEvent(registrationName, dependencies);
    $c442fa203ef9538d$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $c442fa203ef9538d$var$registerDirectEvent(registrationName, dependencies) {
    $c442fa203ef9538d$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$c442fa203ef9538d$var$allNativeEvents.add(dependencies[registrationName]);
}
var $c442fa203ef9538d$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c442fa203ef9538d$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $c442fa203ef9538d$var$illegalAttributeNameCache = {}, $c442fa203ef9538d$var$validatedAttributeNameCache = {};
function $c442fa203ef9538d$var$isAttributeNameSafe(attributeName) {
    if ($c442fa203ef9538d$var$hasOwnProperty.call($c442fa203ef9538d$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($c442fa203ef9538d$var$hasOwnProperty.call($c442fa203ef9538d$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($c442fa203ef9538d$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $c442fa203ef9538d$var$validatedAttributeNameCache[attributeName] = !0;
    $c442fa203ef9538d$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $c442fa203ef9538d$var$setValueForAttribute(node, name, value) {
    if ($c442fa203ef9538d$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $c442fa203ef9538d$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $c442fa203ef9538d$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $c442fa203ef9538d$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $c442fa203ef9538d$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $c442fa203ef9538d$var$trackValueOnNode(node) {
    var valueField = $c442fa203ef9538d$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $c442fa203ef9538d$var$track(node) {
    node._valueTracker || (node._valueTracker = $c442fa203ef9538d$var$trackValueOnNode(node));
}
function $c442fa203ef9538d$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $c442fa203ef9538d$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $c442fa203ef9538d$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $c442fa203ef9538d$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $c442fa203ef9538d$var$getToStringValue(value);
        } else element.value !== "" + $c442fa203ef9538d$var$getToStringValue(value) && (element.value = "" + $c442fa203ef9538d$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $c442fa203ef9538d$var$setDefaultValue(element, type, $c442fa203ef9538d$var$getToStringValue(value)) : null != defaultValue ? $c442fa203ef9538d$var$setDefaultValue(element, type, $c442fa203ef9538d$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $c442fa203ef9538d$var$getToStringValue(name) : element.removeAttribute("name");
}
function $c442fa203ef9538d$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $c442fa203ef9538d$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $c442fa203ef9538d$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $c442fa203ef9538d$var$setDefaultValue(node, type, value) {
    "number" === type && $c442fa203ef9538d$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $c442fa203ef9538d$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $c442fa203ef9538d$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $c442fa203ef9538d$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $c442fa203ef9538d$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $c442fa203ef9538d$var$getToStringValue(defaultValue) : "";
}
function $c442fa203ef9538d$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(92));
            if ($c442fa203ef9538d$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $c442fa203ef9538d$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $c442fa203ef9538d$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $c442fa203ef9538d$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $c442fa203ef9538d$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $c442fa203ef9538d$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $c442fa203ef9538d$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $c442fa203ef9538d$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $c442fa203ef9538d$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $c442fa203ef9538d$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c442fa203ef9538d$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $c442fa203ef9538d$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $c442fa203ef9538d$var$sanitizeURL(url) {
    return $c442fa203ef9538d$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $c442fa203ef9538d$var$currentReplayingEvent = null;
function $c442fa203ef9538d$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $c442fa203ef9538d$var$restoreTarget = null, $c442fa203ef9538d$var$restoreQueue = null;
function $c442fa203ef9538d$var$restoreStateOfTarget(target) {
    var internalInstance = $c442fa203ef9538d$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$c442fa203ef9538d$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $c442fa203ef9538d$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$c442fa203ef9538d$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(90));
                            $c442fa203ef9538d$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $c442fa203ef9538d$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $c442fa203ef9538d$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $c442fa203ef9538d$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $c442fa203ef9538d$var$isInsideEventHandler = !1;
function $c442fa203ef9538d$var$batchedUpdates$1(fn, a, b) {
    if ($c442fa203ef9538d$var$isInsideEventHandler) return fn(a, b);
    $c442fa203ef9538d$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($c442fa203ef9538d$var$isInsideEventHandler = !1, null !== $c442fa203ef9538d$var$restoreTarget || null !== $c442fa203ef9538d$var$restoreQueue) {
            if ($c442fa203ef9538d$var$flushSyncWork$1(), $c442fa203ef9538d$var$restoreTarget && (a = $c442fa203ef9538d$var$restoreTarget, fn = $c442fa203ef9538d$var$restoreQueue, $c442fa203ef9538d$var$restoreQueue = $c442fa203ef9538d$var$restoreTarget = null, $c442fa203ef9538d$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$c442fa203ef9538d$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $c442fa203ef9538d$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$c442fa203ef9538d$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $c442fa203ef9538d$var$passiveBrowserEventsSupported = !1;
if ($c442fa203ef9538d$var$canUseDOM) try {
    var $c442fa203ef9538d$var$options = {};
    Object.defineProperty($c442fa203ef9538d$var$options, "passive", {
        get: function() {
            $c442fa203ef9538d$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $c442fa203ef9538d$var$options, $c442fa203ef9538d$var$options);
    window.removeEventListener("test", $c442fa203ef9538d$var$options, $c442fa203ef9538d$var$options);
} catch (e) {
    $c442fa203ef9538d$var$passiveBrowserEventsSupported = !1;
}
var $c442fa203ef9538d$var$root = null, $c442fa203ef9538d$var$startText = null, $c442fa203ef9538d$var$fallbackText = null;
function $c442fa203ef9538d$var$getData() {
    if ($c442fa203ef9538d$var$fallbackText) return $c442fa203ef9538d$var$fallbackText;
    var start, startValue = $c442fa203ef9538d$var$startText, startLength = startValue.length, end, endValue = "value" in $c442fa203ef9538d$var$root ? $c442fa203ef9538d$var$root.value : $c442fa203ef9538d$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $c442fa203ef9538d$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $c442fa203ef9538d$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $c442fa203ef9538d$var$functionThatReturnsTrue() {
    return !0;
}
function $c442fa203ef9538d$var$functionThatReturnsFalse() {
    return !1;
}
function $c442fa203ef9538d$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $c442fa203ef9538d$var$functionThatReturnsTrue : $c442fa203ef9538d$var$functionThatReturnsFalse;
        this.isPropagationStopped = $c442fa203ef9538d$var$functionThatReturnsFalse;
        return this;
    }
    $c442fa203ef9538d$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $c442fa203ef9538d$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $c442fa203ef9538d$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $c442fa203ef9538d$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $c442fa203ef9538d$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c442fa203ef9538d$var$SyntheticEvent = $c442fa203ef9538d$var$createSyntheticEvent($c442fa203ef9538d$var$EventInterface), $c442fa203ef9538d$var$UIEventInterface = $c442fa203ef9538d$var$assign({}, $c442fa203ef9538d$var$EventInterface, {
    view: 0,
    detail: 0
}), $c442fa203ef9538d$var$SyntheticUIEvent = $c442fa203ef9538d$var$createSyntheticEvent($c442fa203ef9538d$var$UIEventInterface), $c442fa203ef9538d$var$lastMovementX, $c442fa203ef9538d$var$lastMovementY, $c442fa203ef9538d$var$lastMouseEvent, $c442fa203ef9538d$var$MouseEventInterface = $c442fa203ef9538d$var$assign({}, $c442fa203ef9538d$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c442fa203ef9538d$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $c442fa203ef9538d$var$lastMouseEvent && ($c442fa203ef9538d$var$lastMouseEvent && "mousemove" === event.type ? ($c442fa203ef9538d$var$lastMovementX = event.screenX - $c442fa203ef9538d$var$lastMouseEvent.screenX, $c442fa203ef9538d$var$lastMovementY = event.screenY - $c442fa203ef9538d$var$lastMouseEvent.screenY) : $c442fa203ef9538d$var$lastMovementY = $c442fa203ef9538d$var$lastMovementX = 0, $c442fa203ef9538d$var$lastMouseEvent = event);
        return $c442fa203ef9538d$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $c442fa203ef9538d$var$lastMovementY;
    }
}), $c442fa203ef9538d$var$SyntheticMouseEvent = $c442fa203ef9538d$var$createSyntheticEvent($c442fa203ef9538d$var$MouseEventInterface), $c442fa203ef9538d$var$DragEventInterface = $c442fa203ef9538d$var$assign({}, $c442fa203ef9538d$var$MouseEventInterface, {
    dataTransfer: 0
}), $c442fa203ef9538d$var$SyntheticDragEvent = $c442fa203ef9538d$var$createSyntheticEvent($c442fa203ef9538d$var$DragEventInterface), $c442fa203ef9538d$var$FocusEventInterface = $c442fa203ef9538d$var$assign({}, $c442fa203ef9538d$var$UIEventInterface, {
    relatedTarget: 0
}), $c442fa203ef9538d$var$SyntheticFocusEvent = $c442fa203ef9538d$var$createSyntheticEvent($c442fa203ef9538d$var$FocusEventInterface), $c442fa203ef9538d$var$AnimationEventInterface = $c442fa203ef9538d$var$assign({}, $c442fa203ef9538d$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c442fa203ef9538d$var$SyntheticAnimationEvent = $c442fa203ef9538d$var$createSyntheticEvent($c442fa203ef9538d$var$AnimationEventInterface), $c442fa203ef9538d$var$ClipboardEventInterface = $c442fa203ef9538d$var$assign({}, $c442fa203ef9538d$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $c442fa203ef9538d$var$SyntheticClipboardEvent = $c442fa203ef9538d$var$createSyntheticEvent($c442fa203ef9538d$var$ClipboardEventInterface), $c442fa203ef9538d$var$CompositionEventInterface = $c442fa203ef9538d$var$assign({}, $c442fa203ef9538d$var$EventInterface, {
    data: 0
}), $c442fa203ef9538d$var$SyntheticCompositionEvent = $c442fa203ef9538d$var$createSyntheticEvent($c442fa203ef9538d$var$CompositionEventInterface), $c442fa203ef9538d$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c442fa203ef9538d$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c442fa203ef9538d$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c442fa203ef9538d$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $c442fa203ef9538d$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $c442fa203ef9538d$var$getEventModifierState() {
    return $c442fa203ef9538d$var$modifierStateGetter;
}
var $c442fa203ef9538d$var$KeyboardEventInterface = $c442fa203ef9538d$var$assign({}, $c442fa203ef9538d$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $c442fa203ef9538d$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $c442fa203ef9538d$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $c442fa203ef9538d$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c442fa203ef9538d$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $c442fa203ef9538d$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $c442fa203ef9538d$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $c442fa203ef9538d$var$SyntheticKeyboardEvent = $c442fa203ef9538d$var$createSyntheticEvent($c442fa203ef9538d$var$KeyboardEventInterface), $c442fa203ef9538d$var$PointerEventInterface = $c442fa203ef9538d$var$assign({}, $c442fa203ef9538d$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c442fa203ef9538d$var$SyntheticPointerEvent = $c442fa203ef9538d$var$createSyntheticEvent($c442fa203ef9538d$var$PointerEventInterface), $c442fa203ef9538d$var$TouchEventInterface = $c442fa203ef9538d$var$assign({}, $c442fa203ef9538d$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c442fa203ef9538d$var$getEventModifierState
}), $c442fa203ef9538d$var$SyntheticTouchEvent = $c442fa203ef9538d$var$createSyntheticEvent($c442fa203ef9538d$var$TouchEventInterface), $c442fa203ef9538d$var$TransitionEventInterface = $c442fa203ef9538d$var$assign({}, $c442fa203ef9538d$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c442fa203ef9538d$var$SyntheticTransitionEvent = $c442fa203ef9538d$var$createSyntheticEvent($c442fa203ef9538d$var$TransitionEventInterface), $c442fa203ef9538d$var$WheelEventInterface = $c442fa203ef9538d$var$assign({}, $c442fa203ef9538d$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c442fa203ef9538d$var$SyntheticWheelEvent = $c442fa203ef9538d$var$createSyntheticEvent($c442fa203ef9538d$var$WheelEventInterface), $c442fa203ef9538d$var$ToggleEventInterface = $c442fa203ef9538d$var$assign({}, $c442fa203ef9538d$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $c442fa203ef9538d$var$SyntheticToggleEvent = $c442fa203ef9538d$var$createSyntheticEvent($c442fa203ef9538d$var$ToggleEventInterface), $c442fa203ef9538d$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $c442fa203ef9538d$var$canUseCompositionEvent = $c442fa203ef9538d$var$canUseDOM && "CompositionEvent" in window, $c442fa203ef9538d$var$documentMode = null;
$c442fa203ef9538d$var$canUseDOM && "documentMode" in document && ($c442fa203ef9538d$var$documentMode = document.documentMode);
var $c442fa203ef9538d$var$canUseTextInputEvent = $c442fa203ef9538d$var$canUseDOM && "TextEvent" in window && !$c442fa203ef9538d$var$documentMode, $c442fa203ef9538d$var$useFallbackCompositionData = $c442fa203ef9538d$var$canUseDOM && (!$c442fa203ef9538d$var$canUseCompositionEvent || $c442fa203ef9538d$var$documentMode && 8 < $c442fa203ef9538d$var$documentMode && 11 >= $c442fa203ef9538d$var$documentMode), $c442fa203ef9538d$var$SPACEBAR_CHAR = String.fromCharCode(32), $c442fa203ef9538d$var$hasSpaceKeypress = !1;
function $c442fa203ef9538d$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $c442fa203ef9538d$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c442fa203ef9538d$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $c442fa203ef9538d$var$isComposing = !1;
function $c442fa203ef9538d$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $c442fa203ef9538d$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $c442fa203ef9538d$var$hasSpaceKeypress = !0;
            return $c442fa203ef9538d$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $c442fa203ef9538d$var$SPACEBAR_CHAR && $c442fa203ef9538d$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $c442fa203ef9538d$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($c442fa203ef9538d$var$isComposing) return "compositionend" === domEventName || !$c442fa203ef9538d$var$canUseCompositionEvent && $c442fa203ef9538d$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $c442fa203ef9538d$var$getData(), $c442fa203ef9538d$var$fallbackText = $c442fa203ef9538d$var$startText = $c442fa203ef9538d$var$root = null, $c442fa203ef9538d$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $c442fa203ef9538d$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $c442fa203ef9538d$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c442fa203ef9538d$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$c442fa203ef9538d$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $c442fa203ef9538d$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $c442fa203ef9538d$var$restoreTarget ? $c442fa203ef9538d$var$restoreQueue ? $c442fa203ef9538d$var$restoreQueue.push(target) : $c442fa203ef9538d$var$restoreQueue = [
        target
    ] : $c442fa203ef9538d$var$restoreTarget = target;
    inst = $c442fa203ef9538d$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $c442fa203ef9538d$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $c442fa203ef9538d$var$activeElement$1 = null, $c442fa203ef9538d$var$activeElementInst$1 = null;
function $c442fa203ef9538d$var$runEventInBatch(dispatchQueue) {
    $c442fa203ef9538d$var$processDispatchQueue(dispatchQueue, 0);
}
function $c442fa203ef9538d$var$getInstIfValueChanged(targetInst) {
    var targetNode = $c442fa203ef9538d$var$getNodeFromInstance(targetInst);
    if ($c442fa203ef9538d$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $c442fa203ef9538d$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $c442fa203ef9538d$var$isInputEventSupported = !1;
if ($c442fa203ef9538d$var$canUseDOM) {
    var $c442fa203ef9538d$var$JSCompiler_inline_result$jscomp$283;
    if ($c442fa203ef9538d$var$canUseDOM) {
        var $c442fa203ef9538d$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$c442fa203ef9538d$var$isSupported$jscomp$inline_418) {
            var $c442fa203ef9538d$var$element$jscomp$inline_419 = document.createElement("div");
            $c442fa203ef9538d$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $c442fa203ef9538d$var$isSupported$jscomp$inline_418 = "function" === typeof $c442fa203ef9538d$var$element$jscomp$inline_419.oninput;
        }
        $c442fa203ef9538d$var$JSCompiler_inline_result$jscomp$283 = $c442fa203ef9538d$var$isSupported$jscomp$inline_418;
    } else $c442fa203ef9538d$var$JSCompiler_inline_result$jscomp$283 = !1;
    $c442fa203ef9538d$var$isInputEventSupported = $c442fa203ef9538d$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $c442fa203ef9538d$var$stopWatchingForValueChange() {
    $c442fa203ef9538d$var$activeElement$1 && ($c442fa203ef9538d$var$activeElement$1.detachEvent("onpropertychange", $c442fa203ef9538d$var$handlePropertyChange), $c442fa203ef9538d$var$activeElementInst$1 = $c442fa203ef9538d$var$activeElement$1 = null);
}
function $c442fa203ef9538d$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $c442fa203ef9538d$var$getInstIfValueChanged($c442fa203ef9538d$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $c442fa203ef9538d$var$createAndAccumulateChangeEvent(dispatchQueue, $c442fa203ef9538d$var$activeElementInst$1, nativeEvent, $c442fa203ef9538d$var$getEventTarget(nativeEvent));
        $c442fa203ef9538d$var$batchedUpdates$1($c442fa203ef9538d$var$runEventInBatch, dispatchQueue);
    }
}
function $c442fa203ef9538d$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($c442fa203ef9538d$var$stopWatchingForValueChange(), $c442fa203ef9538d$var$activeElement$1 = target, $c442fa203ef9538d$var$activeElementInst$1 = targetInst, $c442fa203ef9538d$var$activeElement$1.attachEvent("onpropertychange", $c442fa203ef9538d$var$handlePropertyChange)) : "focusout" === domEventName && $c442fa203ef9538d$var$stopWatchingForValueChange();
}
function $c442fa203ef9538d$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $c442fa203ef9538d$var$getInstIfValueChanged($c442fa203ef9538d$var$activeElementInst$1);
}
function $c442fa203ef9538d$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $c442fa203ef9538d$var$getInstIfValueChanged(targetInst);
}
function $c442fa203ef9538d$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $c442fa203ef9538d$var$getInstIfValueChanged(targetInst);
}
function $c442fa203ef9538d$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c442fa203ef9538d$var$objectIs = "function" === typeof Object.is ? Object.is : $c442fa203ef9538d$var$is;
function $c442fa203ef9538d$var$shallowEqual(objA, objB) {
    if ($c442fa203ef9538d$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$c442fa203ef9538d$var$hasOwnProperty.call(objB, currentKey) || !$c442fa203ef9538d$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $c442fa203ef9538d$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $c442fa203ef9538d$var$getNodeForCharacterOffset(root, offset) {
    var node = $c442fa203ef9538d$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $c442fa203ef9538d$var$getLeafNode(node);
    }
}
function $c442fa203ef9538d$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $c442fa203ef9538d$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $c442fa203ef9538d$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $c442fa203ef9538d$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $c442fa203ef9538d$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $c442fa203ef9538d$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $c442fa203ef9538d$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $c442fa203ef9538d$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $c442fa203ef9538d$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $c442fa203ef9538d$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $c442fa203ef9538d$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $c442fa203ef9538d$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $c442fa203ef9538d$var$skipSelectionChangeEvent = $c442fa203ef9538d$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $c442fa203ef9538d$var$activeElement = null, $c442fa203ef9538d$var$activeElementInst = null, $c442fa203ef9538d$var$lastSelection = null, $c442fa203ef9538d$var$mouseDown = !1;
function $c442fa203ef9538d$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $c442fa203ef9538d$var$mouseDown || null == $c442fa203ef9538d$var$activeElement || $c442fa203ef9538d$var$activeElement !== $c442fa203ef9538d$var$getActiveElement(doc) || (doc = $c442fa203ef9538d$var$activeElement, "selectionStart" in doc && $c442fa203ef9538d$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $c442fa203ef9538d$var$lastSelection && $c442fa203ef9538d$var$shallowEqual($c442fa203ef9538d$var$lastSelection, doc) || ($c442fa203ef9538d$var$lastSelection = doc, doc = $c442fa203ef9538d$var$accumulateTwoPhaseListeners($c442fa203ef9538d$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $c442fa203ef9538d$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $c442fa203ef9538d$var$activeElement)));
}
function $c442fa203ef9538d$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $c442fa203ef9538d$var$vendorPrefixes = {
    animationend: $c442fa203ef9538d$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $c442fa203ef9538d$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $c442fa203ef9538d$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $c442fa203ef9538d$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $c442fa203ef9538d$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $c442fa203ef9538d$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $c442fa203ef9538d$var$makePrefixMap("Transition", "TransitionEnd")
}, $c442fa203ef9538d$var$prefixedEventNames = {}, $c442fa203ef9538d$var$style = {};
$c442fa203ef9538d$var$canUseDOM && ($c442fa203ef9538d$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $c442fa203ef9538d$var$vendorPrefixes.animationend.animation, delete $c442fa203ef9538d$var$vendorPrefixes.animationiteration.animation, delete $c442fa203ef9538d$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $c442fa203ef9538d$var$vendorPrefixes.transitionend.transition);
function $c442fa203ef9538d$var$getVendorPrefixedEventName(eventName) {
    if ($c442fa203ef9538d$var$prefixedEventNames[eventName]) return $c442fa203ef9538d$var$prefixedEventNames[eventName];
    if (!$c442fa203ef9538d$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $c442fa203ef9538d$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $c442fa203ef9538d$var$style) return $c442fa203ef9538d$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $c442fa203ef9538d$var$ANIMATION_END = $c442fa203ef9538d$var$getVendorPrefixedEventName("animationend"), $c442fa203ef9538d$var$ANIMATION_ITERATION = $c442fa203ef9538d$var$getVendorPrefixedEventName("animationiteration"), $c442fa203ef9538d$var$ANIMATION_START = $c442fa203ef9538d$var$getVendorPrefixedEventName("animationstart"), $c442fa203ef9538d$var$TRANSITION_RUN = $c442fa203ef9538d$var$getVendorPrefixedEventName("transitionrun"), $c442fa203ef9538d$var$TRANSITION_START = $c442fa203ef9538d$var$getVendorPrefixedEventName("transitionstart"), $c442fa203ef9538d$var$TRANSITION_CANCEL = $c442fa203ef9538d$var$getVendorPrefixedEventName("transitioncancel"), $c442fa203ef9538d$var$TRANSITION_END = $c442fa203ef9538d$var$getVendorPrefixedEventName("transitionend"), $c442fa203ef9538d$var$topLevelEventsToReactNames = new Map(), $c442fa203ef9538d$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $c442fa203ef9538d$var$registerSimpleEvent(domEventName, reactName) {
    $c442fa203ef9538d$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $c442fa203ef9538d$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $c442fa203ef9538d$var$concurrentQueues = [], $c442fa203ef9538d$var$concurrentQueuesIndex = 0, $c442fa203ef9538d$var$concurrentlyUpdatedLanes = 0;
function $c442fa203ef9538d$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $c442fa203ef9538d$var$concurrentQueuesIndex, i = $c442fa203ef9538d$var$concurrentlyUpdatedLanes = $c442fa203ef9538d$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $c442fa203ef9538d$var$concurrentQueues[i];
        $c442fa203ef9538d$var$concurrentQueues[i++] = null;
        var queue = $c442fa203ef9538d$var$concurrentQueues[i];
        $c442fa203ef9538d$var$concurrentQueues[i++] = null;
        var update = $c442fa203ef9538d$var$concurrentQueues[i];
        $c442fa203ef9538d$var$concurrentQueues[i++] = null;
        var lane = $c442fa203ef9538d$var$concurrentQueues[i];
        $c442fa203ef9538d$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $c442fa203ef9538d$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $c442fa203ef9538d$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $c442fa203ef9538d$var$concurrentQueues[$c442fa203ef9538d$var$concurrentQueuesIndex++] = fiber;
    $c442fa203ef9538d$var$concurrentQueues[$c442fa203ef9538d$var$concurrentQueuesIndex++] = queue;
    $c442fa203ef9538d$var$concurrentQueues[$c442fa203ef9538d$var$concurrentQueuesIndex++] = update;
    $c442fa203ef9538d$var$concurrentQueues[$c442fa203ef9538d$var$concurrentQueuesIndex++] = lane;
    $c442fa203ef9538d$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $c442fa203ef9538d$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $c442fa203ef9538d$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $c442fa203ef9538d$var$getRootForUpdatedFiber(fiber);
}
function $c442fa203ef9538d$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $c442fa203ef9538d$var$enqueueUpdate$1(fiber, null, null, lane);
    return $c442fa203ef9538d$var$getRootForUpdatedFiber(fiber);
}
function $c442fa203ef9538d$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $c442fa203ef9538d$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $c442fa203ef9538d$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $c442fa203ef9538d$var$nestedUpdateCount) throw $c442fa203ef9538d$var$nestedUpdateCount = 0, $c442fa203ef9538d$var$rootWithNestedUpdates = null, Error($c442fa203ef9538d$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $c442fa203ef9538d$var$emptyContextObject = {}, $c442fa203ef9538d$var$CapturedStacks = new WeakMap();
function $c442fa203ef9538d$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $c442fa203ef9538d$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $c442fa203ef9538d$var$getStackByFiberInDevAndProd(source)
        };
        $c442fa203ef9538d$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $c442fa203ef9538d$var$getStackByFiberInDevAndProd(source)
    };
}
var $c442fa203ef9538d$var$forkStack = [], $c442fa203ef9538d$var$forkStackIndex = 0, $c442fa203ef9538d$var$treeForkProvider = null, $c442fa203ef9538d$var$treeForkCount = 0, $c442fa203ef9538d$var$idStack = [], $c442fa203ef9538d$var$idStackIndex = 0, $c442fa203ef9538d$var$treeContextProvider = null, $c442fa203ef9538d$var$treeContextId = 1, $c442fa203ef9538d$var$treeContextOverflow = "";
function $c442fa203ef9538d$var$pushTreeFork(workInProgress, totalChildren) {
    $c442fa203ef9538d$var$forkStack[$c442fa203ef9538d$var$forkStackIndex++] = $c442fa203ef9538d$var$treeForkCount;
    $c442fa203ef9538d$var$forkStack[$c442fa203ef9538d$var$forkStackIndex++] = $c442fa203ef9538d$var$treeForkProvider;
    $c442fa203ef9538d$var$treeForkProvider = workInProgress;
    $c442fa203ef9538d$var$treeForkCount = totalChildren;
}
function $c442fa203ef9538d$var$pushTreeId(workInProgress, totalChildren, index) {
    $c442fa203ef9538d$var$idStack[$c442fa203ef9538d$var$idStackIndex++] = $c442fa203ef9538d$var$treeContextId;
    $c442fa203ef9538d$var$idStack[$c442fa203ef9538d$var$idStackIndex++] = $c442fa203ef9538d$var$treeContextOverflow;
    $c442fa203ef9538d$var$idStack[$c442fa203ef9538d$var$idStackIndex++] = $c442fa203ef9538d$var$treeContextProvider;
    $c442fa203ef9538d$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $c442fa203ef9538d$var$treeContextId;
    workInProgress = $c442fa203ef9538d$var$treeContextOverflow;
    var baseLength = 32 - $c442fa203ef9538d$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $c442fa203ef9538d$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $c442fa203ef9538d$var$treeContextId = 1 << 32 - $c442fa203ef9538d$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $c442fa203ef9538d$var$treeContextOverflow = length + workInProgress;
    } else $c442fa203ef9538d$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $c442fa203ef9538d$var$treeContextOverflow = workInProgress;
}
function $c442fa203ef9538d$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($c442fa203ef9538d$var$pushTreeFork(workInProgress, 1), $c442fa203ef9538d$var$pushTreeId(workInProgress, 1, 0));
}
function $c442fa203ef9538d$var$popTreeContext(workInProgress) {
    for(; workInProgress === $c442fa203ef9538d$var$treeForkProvider;)$c442fa203ef9538d$var$treeForkProvider = $c442fa203ef9538d$var$forkStack[--$c442fa203ef9538d$var$forkStackIndex], $c442fa203ef9538d$var$forkStack[$c442fa203ef9538d$var$forkStackIndex] = null, $c442fa203ef9538d$var$treeForkCount = $c442fa203ef9538d$var$forkStack[--$c442fa203ef9538d$var$forkStackIndex], $c442fa203ef9538d$var$forkStack[$c442fa203ef9538d$var$forkStackIndex] = null;
    for(; workInProgress === $c442fa203ef9538d$var$treeContextProvider;)$c442fa203ef9538d$var$treeContextProvider = $c442fa203ef9538d$var$idStack[--$c442fa203ef9538d$var$idStackIndex], $c442fa203ef9538d$var$idStack[$c442fa203ef9538d$var$idStackIndex] = null, $c442fa203ef9538d$var$treeContextOverflow = $c442fa203ef9538d$var$idStack[--$c442fa203ef9538d$var$idStackIndex], $c442fa203ef9538d$var$idStack[$c442fa203ef9538d$var$idStackIndex] = null, $c442fa203ef9538d$var$treeContextId = $c442fa203ef9538d$var$idStack[--$c442fa203ef9538d$var$idStackIndex], $c442fa203ef9538d$var$idStack[$c442fa203ef9538d$var$idStackIndex] = null;
}
var $c442fa203ef9538d$var$hydrationParentFiber = null, $c442fa203ef9538d$var$nextHydratableInstance = null, $c442fa203ef9538d$var$isHydrating = !1, $c442fa203ef9538d$var$hydrationErrors = null, $c442fa203ef9538d$var$rootOrSingletonContext = !1, $c442fa203ef9538d$var$HydrationMismatchException = Error($c442fa203ef9538d$var$formatProdErrorMessage(519));
function $c442fa203ef9538d$var$throwOnHydrationMismatch(fiber) {
    var error = Error($c442fa203ef9538d$var$formatProdErrorMessage(418, ""));
    $c442fa203ef9538d$var$queueHydrationError($c442fa203ef9538d$var$createCapturedValueAtFiber(error, fiber));
    throw $c442fa203ef9538d$var$HydrationMismatchException;
}
function $c442fa203ef9538d$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$c442fa203ef9538d$var$internalInstanceKey] = fiber;
    instance[$c442fa203ef9538d$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("cancel", instance);
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $c442fa203ef9538d$var$mediaEventTypes.length; type++)$c442fa203ef9538d$var$listenToNonDelegatedEvent($c442fa203ef9538d$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("error", instance);
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("invalid", instance);
            $c442fa203ef9538d$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $c442fa203ef9538d$var$track(instance);
            break;
        case "select":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("invalid", instance), $c442fa203ef9538d$var$initTextarea(instance, props.value, props.defaultValue, props.children), $c442fa203ef9538d$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $c442fa203ef9538d$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($c442fa203ef9538d$var$listenToNonDelegatedEvent("beforetoggle", instance), $c442fa203ef9538d$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $c442fa203ef9538d$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $c442fa203ef9538d$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $c442fa203ef9538d$var$noop$1), instance = !0) : instance = !1;
    instance || $c442fa203ef9538d$var$throwOnHydrationMismatch(fiber);
}
function $c442fa203ef9538d$var$popToNextHostParent(fiber) {
    for($c442fa203ef9538d$var$hydrationParentFiber = fiber.return; $c442fa203ef9538d$var$hydrationParentFiber;)switch($c442fa203ef9538d$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $c442fa203ef9538d$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $c442fa203ef9538d$var$rootOrSingletonContext = !1;
            return;
        default:
            $c442fa203ef9538d$var$hydrationParentFiber = $c442fa203ef9538d$var$hydrationParentFiber.return;
    }
}
function $c442fa203ef9538d$var$popHydrationState(fiber) {
    if (fiber !== $c442fa203ef9538d$var$hydrationParentFiber) return !1;
    if (!$c442fa203ef9538d$var$isHydrating) return $c442fa203ef9538d$var$popToNextHostParent(fiber), $c442fa203ef9538d$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $c442fa203ef9538d$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $c442fa203ef9538d$var$nextHydratableInstance && $c442fa203ef9538d$var$throwOnHydrationMismatch(fiber);
    $c442fa203ef9538d$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $c442fa203ef9538d$var$nextHydratableInstance = $c442fa203ef9538d$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $c442fa203ef9538d$var$nextHydratableInstance = null;
        }
    } else $c442fa203ef9538d$var$nextHydratableInstance = $c442fa203ef9538d$var$hydrationParentFiber ? $c442fa203ef9538d$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $c442fa203ef9538d$var$resetHydrationState() {
    $c442fa203ef9538d$var$nextHydratableInstance = $c442fa203ef9538d$var$hydrationParentFiber = null;
    $c442fa203ef9538d$var$isHydrating = !1;
}
function $c442fa203ef9538d$var$queueHydrationError(error) {
    null === $c442fa203ef9538d$var$hydrationErrors ? $c442fa203ef9538d$var$hydrationErrors = [
        error
    ] : $c442fa203ef9538d$var$hydrationErrors.push(error);
}
var $c442fa203ef9538d$var$SuspenseException = Error($c442fa203ef9538d$var$formatProdErrorMessage(460)), $c442fa203ef9538d$var$SuspenseyCommitException = Error($c442fa203ef9538d$var$formatProdErrorMessage(474)), $c442fa203ef9538d$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $c442fa203ef9538d$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $c442fa203ef9538d$var$noop$3() {}
function $c442fa203ef9538d$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($c442fa203ef9538d$var$noop$3, $c442fa203ef9538d$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $c442fa203ef9538d$var$SuspenseException) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($c442fa203ef9538d$var$noop$3, $c442fa203ef9538d$var$noop$3);
            else {
                thenableState = $c442fa203ef9538d$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $c442fa203ef9538d$var$SuspenseException) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $c442fa203ef9538d$var$suspendedThenable = thenable;
            throw $c442fa203ef9538d$var$SuspenseException;
    }
}
var $c442fa203ef9538d$var$suspendedThenable = null;
function $c442fa203ef9538d$var$getSuspendedThenable() {
    if (null === $c442fa203ef9538d$var$suspendedThenable) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(459));
    var thenable = $c442fa203ef9538d$var$suspendedThenable;
    $c442fa203ef9538d$var$suspendedThenable = null;
    return thenable;
}
var $c442fa203ef9538d$var$thenableState$1 = null, $c442fa203ef9538d$var$thenableIndexCounter$1 = 0;
function $c442fa203ef9538d$var$unwrapThenable(thenable) {
    var index = $c442fa203ef9538d$var$thenableIndexCounter$1;
    $c442fa203ef9538d$var$thenableIndexCounter$1 += 1;
    null === $c442fa203ef9538d$var$thenableState$1 && ($c442fa203ef9538d$var$thenableState$1 = []);
    return $c442fa203ef9538d$var$trackUsedThenable($c442fa203ef9538d$var$thenableState$1, thenable, index);
}
function $c442fa203ef9538d$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $c442fa203ef9538d$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $c442fa203ef9538d$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($c442fa203ef9538d$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $c442fa203ef9538d$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $c442fa203ef9538d$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $c442fa203ef9538d$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $c442fa203ef9538d$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $c442fa203ef9538d$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $c442fa203ef9538d$var$REACT_LAZY_TYPE && $c442fa203ef9538d$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $c442fa203ef9538d$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $c442fa203ef9538d$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $c442fa203ef9538d$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $c442fa203ef9538d$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $c442fa203ef9538d$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $c442fa203ef9538d$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c442fa203ef9538d$var$REACT_ELEMENT_TYPE:
                    return lanes = $c442fa203ef9538d$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c442fa203ef9538d$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $c442fa203ef9538d$var$REACT_PORTAL_TYPE:
                    return newChild = $c442fa203ef9538d$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $c442fa203ef9538d$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($c442fa203ef9538d$var$isArrayImpl(newChild) || $c442fa203ef9538d$var$getIteratorFn(newChild)) return newChild = $c442fa203ef9538d$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $c442fa203ef9538d$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c442fa203ef9538d$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $c442fa203ef9538d$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c442fa203ef9538d$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c442fa203ef9538d$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $c442fa203ef9538d$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $c442fa203ef9538d$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($c442fa203ef9538d$var$isArrayImpl(newChild) || $c442fa203ef9538d$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $c442fa203ef9538d$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c442fa203ef9538d$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $c442fa203ef9538d$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c442fa203ef9538d$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c442fa203ef9538d$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $c442fa203ef9538d$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $c442fa203ef9538d$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($c442fa203ef9538d$var$isArrayImpl(newChild) || $c442fa203ef9538d$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $c442fa203ef9538d$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c442fa203ef9538d$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $c442fa203ef9538d$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c442fa203ef9538d$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $c442fa203ef9538d$var$isHydrating && $c442fa203ef9538d$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $c442fa203ef9538d$var$isHydrating && $c442fa203ef9538d$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c442fa203ef9538d$var$isHydrating && $c442fa203ef9538d$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $c442fa203ef9538d$var$isHydrating && $c442fa203ef9538d$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $c442fa203ef9538d$var$isHydrating && $c442fa203ef9538d$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c442fa203ef9538d$var$isHydrating && $c442fa203ef9538d$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $c442fa203ef9538d$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c442fa203ef9538d$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $c442fa203ef9538d$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $c442fa203ef9538d$var$REACT_LAZY_TYPE && $c442fa203ef9538d$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $c442fa203ef9538d$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $c442fa203ef9538d$var$REACT_FRAGMENT_TYPE ? (lanes = $c442fa203ef9538d$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $c442fa203ef9538d$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c442fa203ef9538d$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $c442fa203ef9538d$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $c442fa203ef9538d$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $c442fa203ef9538d$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($c442fa203ef9538d$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($c442fa203ef9538d$var$getIteratorFn(newChild)) {
                key = $c442fa203ef9538d$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c442fa203ef9538d$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c442fa203ef9538d$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c442fa203ef9538d$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c442fa203ef9538d$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $c442fa203ef9538d$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $c442fa203ef9538d$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $c442fa203ef9538d$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $c442fa203ef9538d$var$SuspenseException) throw x;
            var fiber = $c442fa203ef9538d$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $c442fa203ef9538d$var$reconcileChildFibers = $c442fa203ef9538d$var$createChildReconciler(!0), $c442fa203ef9538d$var$mountChildFibers = $c442fa203ef9538d$var$createChildReconciler(!1), $c442fa203ef9538d$var$currentTreeHiddenStackCursor = $c442fa203ef9538d$var$createCursor(null), $c442fa203ef9538d$var$prevEntangledRenderLanesCursor = $c442fa203ef9538d$var$createCursor(0);
function $c442fa203ef9538d$var$pushHiddenContext(fiber, context) {
    fiber = $c442fa203ef9538d$var$entangledRenderLanes;
    $c442fa203ef9538d$var$push($c442fa203ef9538d$var$prevEntangledRenderLanesCursor, fiber);
    $c442fa203ef9538d$var$push($c442fa203ef9538d$var$currentTreeHiddenStackCursor, context);
    $c442fa203ef9538d$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $c442fa203ef9538d$var$reuseHiddenContextOnStack() {
    $c442fa203ef9538d$var$push($c442fa203ef9538d$var$prevEntangledRenderLanesCursor, $c442fa203ef9538d$var$entangledRenderLanes);
    $c442fa203ef9538d$var$push($c442fa203ef9538d$var$currentTreeHiddenStackCursor, $c442fa203ef9538d$var$currentTreeHiddenStackCursor.current);
}
function $c442fa203ef9538d$var$popHiddenContext() {
    $c442fa203ef9538d$var$entangledRenderLanes = $c442fa203ef9538d$var$prevEntangledRenderLanesCursor.current;
    $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$currentTreeHiddenStackCursor);
    $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$prevEntangledRenderLanesCursor);
}
var $c442fa203ef9538d$var$suspenseHandlerStackCursor = $c442fa203ef9538d$var$createCursor(null), $c442fa203ef9538d$var$shellBoundary = null;
function $c442fa203ef9538d$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $c442fa203ef9538d$var$push($c442fa203ef9538d$var$suspenseStackCursor, $c442fa203ef9538d$var$suspenseStackCursor.current & 1);
    $c442fa203ef9538d$var$push($c442fa203ef9538d$var$suspenseHandlerStackCursor, handler);
    null === $c442fa203ef9538d$var$shellBoundary && (null === current || null !== $c442fa203ef9538d$var$currentTreeHiddenStackCursor.current ? $c442fa203ef9538d$var$shellBoundary = handler : null !== current.memoizedState && ($c442fa203ef9538d$var$shellBoundary = handler));
}
function $c442fa203ef9538d$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($c442fa203ef9538d$var$push($c442fa203ef9538d$var$suspenseStackCursor, $c442fa203ef9538d$var$suspenseStackCursor.current), $c442fa203ef9538d$var$push($c442fa203ef9538d$var$suspenseHandlerStackCursor, fiber), null === $c442fa203ef9538d$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($c442fa203ef9538d$var$shellBoundary = fiber);
        }
    } else $c442fa203ef9538d$var$reuseSuspenseHandlerOnStack(fiber);
}
function $c442fa203ef9538d$var$reuseSuspenseHandlerOnStack() {
    $c442fa203ef9538d$var$push($c442fa203ef9538d$var$suspenseStackCursor, $c442fa203ef9538d$var$suspenseStackCursor.current);
    $c442fa203ef9538d$var$push($c442fa203ef9538d$var$suspenseHandlerStackCursor, $c442fa203ef9538d$var$suspenseHandlerStackCursor.current);
}
function $c442fa203ef9538d$var$popSuspenseHandler(fiber) {
    $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$suspenseHandlerStackCursor);
    $c442fa203ef9538d$var$shellBoundary === fiber && ($c442fa203ef9538d$var$shellBoundary = null);
    $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$suspenseStackCursor);
}
var $c442fa203ef9538d$var$suspenseStackCursor = $c442fa203ef9538d$var$createCursor(0);
function $c442fa203ef9538d$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $c442fa203ef9538d$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $c442fa203ef9538d$var$scheduleCallback$2 = $Qw0kg.unstable_scheduleCallback, $c442fa203ef9538d$var$NormalPriority = $Qw0kg.unstable_NormalPriority, $c442fa203ef9538d$var$CacheContext = {
    $$typeof: $c442fa203ef9538d$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $c442fa203ef9538d$var$createCache() {
    return {
        controller: new $c442fa203ef9538d$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $c442fa203ef9538d$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $c442fa203ef9538d$var$scheduleCallback$2($c442fa203ef9538d$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $c442fa203ef9538d$var$currentEntangledListeners = null, $c442fa203ef9538d$var$currentEntangledPendingCount = 0, $c442fa203ef9538d$var$currentEntangledLane = 0, $c442fa203ef9538d$var$currentEntangledActionThenable = null;
function $c442fa203ef9538d$var$entangleAsyncAction(transition, thenable) {
    if (null === $c442fa203ef9538d$var$currentEntangledListeners) {
        var entangledListeners = $c442fa203ef9538d$var$currentEntangledListeners = [];
        $c442fa203ef9538d$var$currentEntangledPendingCount = 0;
        $c442fa203ef9538d$var$currentEntangledLane = $c442fa203ef9538d$var$requestTransitionLane();
        $c442fa203ef9538d$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $c442fa203ef9538d$var$currentEntangledPendingCount++;
    thenable.then($c442fa203ef9538d$var$pingEngtangledActionScope, $c442fa203ef9538d$var$pingEngtangledActionScope);
    return thenable;
}
function $c442fa203ef9538d$var$pingEngtangledActionScope() {
    if (0 === --$c442fa203ef9538d$var$currentEntangledPendingCount && null !== $c442fa203ef9538d$var$currentEntangledListeners) {
        null !== $c442fa203ef9538d$var$currentEntangledActionThenable && ($c442fa203ef9538d$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $c442fa203ef9538d$var$currentEntangledListeners;
        $c442fa203ef9538d$var$currentEntangledListeners = null;
        $c442fa203ef9538d$var$currentEntangledLane = 0;
        $c442fa203ef9538d$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $c442fa203ef9538d$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $c442fa203ef9538d$var$prevOnStartTransitionFinish = $c442fa203ef9538d$var$ReactSharedInternals.S;
$c442fa203ef9538d$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $c442fa203ef9538d$var$entangleAsyncAction(transition, returnValue);
    null !== $c442fa203ef9538d$var$prevOnStartTransitionFinish && $c442fa203ef9538d$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $c442fa203ef9538d$var$resumedCache = $c442fa203ef9538d$var$createCursor(null);
function $c442fa203ef9538d$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $c442fa203ef9538d$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $c442fa203ef9538d$var$workInProgressRoot.pooledCache;
}
function $c442fa203ef9538d$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $c442fa203ef9538d$var$push($c442fa203ef9538d$var$resumedCache, $c442fa203ef9538d$var$resumedCache.current) : $c442fa203ef9538d$var$push($c442fa203ef9538d$var$resumedCache, prevCachePool.pool);
}
function $c442fa203ef9538d$var$getSuspendedCache() {
    var cacheFromPool = $c442fa203ef9538d$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $c442fa203ef9538d$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $c442fa203ef9538d$var$renderLanes = 0, $c442fa203ef9538d$var$currentlyRenderingFiber$1 = null, $c442fa203ef9538d$var$currentHook = null, $c442fa203ef9538d$var$workInProgressHook = null, $c442fa203ef9538d$var$didScheduleRenderPhaseUpdate = !1, $c442fa203ef9538d$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $c442fa203ef9538d$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $c442fa203ef9538d$var$localIdCounter = 0, $c442fa203ef9538d$var$thenableIndexCounter = 0, $c442fa203ef9538d$var$thenableState = null, $c442fa203ef9538d$var$globalClientIdCounter = 0;
function $c442fa203ef9538d$var$throwInvalidHookError() {
    throw Error($c442fa203ef9538d$var$formatProdErrorMessage(321));
}
function $c442fa203ef9538d$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$c442fa203ef9538d$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $c442fa203ef9538d$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $c442fa203ef9538d$var$renderLanes = nextRenderLanes;
    $c442fa203ef9538d$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $c442fa203ef9538d$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $c442fa203ef9538d$var$HooksDispatcherOnMount : $c442fa203ef9538d$var$HooksDispatcherOnUpdate;
    $c442fa203ef9538d$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $c442fa203ef9538d$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $c442fa203ef9538d$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $c442fa203ef9538d$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $c442fa203ef9538d$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $c442fa203ef9538d$var$finishRenderingHooks(current) {
    $c442fa203ef9538d$var$ReactSharedInternals.H = $c442fa203ef9538d$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $c442fa203ef9538d$var$currentHook && null !== $c442fa203ef9538d$var$currentHook.next;
    $c442fa203ef9538d$var$renderLanes = 0;
    $c442fa203ef9538d$var$workInProgressHook = $c442fa203ef9538d$var$currentHook = $c442fa203ef9538d$var$currentlyRenderingFiber$1 = null;
    $c442fa203ef9538d$var$didScheduleRenderPhaseUpdate = !1;
    $c442fa203ef9538d$var$thenableIndexCounter = 0;
    $c442fa203ef9538d$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(300));
    null === current || $c442fa203ef9538d$var$didReceiveUpdate || (current = current.dependencies, null !== current && $c442fa203ef9538d$var$checkIfContextChanged(current) && ($c442fa203ef9538d$var$didReceiveUpdate = !0));
}
function $c442fa203ef9538d$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $c442fa203ef9538d$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $c442fa203ef9538d$var$didScheduleRenderPhaseUpdateDuringThisPass && ($c442fa203ef9538d$var$thenableState = null);
        $c442fa203ef9538d$var$thenableIndexCounter = 0;
        $c442fa203ef9538d$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $c442fa203ef9538d$var$workInProgressHook = $c442fa203ef9538d$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $c442fa203ef9538d$var$ReactSharedInternals.H = $c442fa203ef9538d$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($c442fa203ef9538d$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $c442fa203ef9538d$var$TransitionAwareHostComponent() {
    var dispatcher = $c442fa203ef9538d$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $c442fa203ef9538d$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $c442fa203ef9538d$var$currentHook ? $c442fa203ef9538d$var$currentHook.memoizedState : null) !== dispatcher && ($c442fa203ef9538d$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $c442fa203ef9538d$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $c442fa203ef9538d$var$localIdCounter;
    $c442fa203ef9538d$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $c442fa203ef9538d$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $c442fa203ef9538d$var$resetHooksOnUnwind(workInProgress) {
    if ($c442fa203ef9538d$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $c442fa203ef9538d$var$didScheduleRenderPhaseUpdate = !1;
    }
    $c442fa203ef9538d$var$renderLanes = 0;
    $c442fa203ef9538d$var$workInProgressHook = $c442fa203ef9538d$var$currentHook = $c442fa203ef9538d$var$currentlyRenderingFiber$1 = null;
    $c442fa203ef9538d$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $c442fa203ef9538d$var$thenableIndexCounter = $c442fa203ef9538d$var$localIdCounter = 0;
    $c442fa203ef9538d$var$thenableState = null;
}
function $c442fa203ef9538d$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c442fa203ef9538d$var$workInProgressHook ? $c442fa203ef9538d$var$currentlyRenderingFiber$1.memoizedState = $c442fa203ef9538d$var$workInProgressHook = hook : $c442fa203ef9538d$var$workInProgressHook = $c442fa203ef9538d$var$workInProgressHook.next = hook;
    return $c442fa203ef9538d$var$workInProgressHook;
}
function $c442fa203ef9538d$var$updateWorkInProgressHook() {
    if (null === $c442fa203ef9538d$var$currentHook) {
        var nextCurrentHook = $c442fa203ef9538d$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $c442fa203ef9538d$var$currentHook.next;
    var nextWorkInProgressHook = null === $c442fa203ef9538d$var$workInProgressHook ? $c442fa203ef9538d$var$currentlyRenderingFiber$1.memoizedState : $c442fa203ef9538d$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $c442fa203ef9538d$var$workInProgressHook = nextWorkInProgressHook, $c442fa203ef9538d$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $c442fa203ef9538d$var$currentlyRenderingFiber$1.alternate) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(467));
            throw Error($c442fa203ef9538d$var$formatProdErrorMessage(310));
        }
        $c442fa203ef9538d$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $c442fa203ef9538d$var$currentHook.memoizedState,
            baseState: $c442fa203ef9538d$var$currentHook.baseState,
            baseQueue: $c442fa203ef9538d$var$currentHook.baseQueue,
            queue: $c442fa203ef9538d$var$currentHook.queue,
            next: null
        };
        null === $c442fa203ef9538d$var$workInProgressHook ? $c442fa203ef9538d$var$currentlyRenderingFiber$1.memoizedState = $c442fa203ef9538d$var$workInProgressHook = nextCurrentHook : $c442fa203ef9538d$var$workInProgressHook = $c442fa203ef9538d$var$workInProgressHook.next = nextCurrentHook;
    }
    return $c442fa203ef9538d$var$workInProgressHook;
}
var $c442fa203ef9538d$var$createFunctionComponentUpdateQueue;
$c442fa203ef9538d$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $c442fa203ef9538d$var$useThenable(thenable) {
    var index = $c442fa203ef9538d$var$thenableIndexCounter;
    $c442fa203ef9538d$var$thenableIndexCounter += 1;
    null === $c442fa203ef9538d$var$thenableState && ($c442fa203ef9538d$var$thenableState = []);
    thenable = $c442fa203ef9538d$var$trackUsedThenable($c442fa203ef9538d$var$thenableState, thenable, index);
    index = $c442fa203ef9538d$var$currentlyRenderingFiber$1;
    null === (null === $c442fa203ef9538d$var$workInProgressHook ? index.memoizedState : $c442fa203ef9538d$var$workInProgressHook.next) && (index = index.alternate, $c442fa203ef9538d$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $c442fa203ef9538d$var$HooksDispatcherOnMount : $c442fa203ef9538d$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $c442fa203ef9538d$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $c442fa203ef9538d$var$useThenable(usable);
        if (usable.$$typeof === $c442fa203ef9538d$var$REACT_CONTEXT_TYPE) return $c442fa203ef9538d$var$readContext(usable);
    }
    throw Error($c442fa203ef9538d$var$formatProdErrorMessage(438, String(usable)));
}
function $c442fa203ef9538d$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $c442fa203ef9538d$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $c442fa203ef9538d$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $c442fa203ef9538d$var$createFunctionComponentUpdateQueue(), $c442fa203ef9538d$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $c442fa203ef9538d$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $c442fa203ef9538d$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $c442fa203ef9538d$var$updateReducer(reducer) {
    var hook = $c442fa203ef9538d$var$updateWorkInProgressHook();
    return $c442fa203ef9538d$var$updateReducerImpl(hook, $c442fa203ef9538d$var$currentHook, reducer);
}
function $c442fa203ef9538d$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($c442fa203ef9538d$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($c442fa203ef9538d$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $c442fa203ef9538d$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($c442fa203ef9538d$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $c442fa203ef9538d$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $c442fa203ef9538d$var$currentlyRenderingFiber$1.lanes |= revertLane, $c442fa203ef9538d$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $c442fa203ef9538d$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $c442fa203ef9538d$var$currentlyRenderingFiber$1.lanes |= updateLane, $c442fa203ef9538d$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$c442fa203ef9538d$var$objectIs(pendingQueue, hook.memoizedState) && ($c442fa203ef9538d$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $c442fa203ef9538d$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $c442fa203ef9538d$var$rerenderReducer(reducer) {
    var hook = $c442fa203ef9538d$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $c442fa203ef9538d$var$objectIs(newState, hook.memoizedState) || ($c442fa203ef9538d$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $c442fa203ef9538d$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $c442fa203ef9538d$var$currentlyRenderingFiber$1, hook = $c442fa203ef9538d$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $c442fa203ef9538d$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$c442fa203ef9538d$var$objectIs(($c442fa203ef9538d$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $c442fa203ef9538d$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $c442fa203ef9538d$var$updateEffect($c442fa203ef9538d$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $c442fa203ef9538d$var$workInProgressHook && $c442fa203ef9538d$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $c442fa203ef9538d$var$pushEffect(9, $c442fa203ef9538d$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $c442fa203ef9538d$var$workInProgressRoot) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($c442fa203ef9538d$var$renderLanes & 60) || $c442fa203ef9538d$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $c442fa203ef9538d$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $c442fa203ef9538d$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $c442fa203ef9538d$var$createFunctionComponentUpdateQueue(), $c442fa203ef9538d$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $c442fa203ef9538d$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $c442fa203ef9538d$var$checkIfSnapshotChanged(inst) && $c442fa203ef9538d$var$forceStoreRerender(fiber);
}
function $c442fa203ef9538d$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $c442fa203ef9538d$var$checkIfSnapshotChanged(inst) && $c442fa203ef9538d$var$forceStoreRerender(fiber);
    });
}
function $c442fa203ef9538d$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c442fa203ef9538d$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c442fa203ef9538d$var$forceStoreRerender(fiber) {
    var root = $c442fa203ef9538d$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $c442fa203ef9538d$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $c442fa203ef9538d$var$mountStateImpl(initialState) {
    var hook = $c442fa203ef9538d$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($c442fa203ef9538d$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c442fa203ef9538d$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $c442fa203ef9538d$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c442fa203ef9538d$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $c442fa203ef9538d$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $c442fa203ef9538d$var$updateReducerImpl(hook, $c442fa203ef9538d$var$currentHook, "function" === typeof reducer ? reducer : $c442fa203ef9538d$var$basicStateReducer);
}
function $c442fa203ef9538d$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($c442fa203ef9538d$var$isRenderPhaseUpdate(fiber)) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $c442fa203ef9538d$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $c442fa203ef9538d$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $c442fa203ef9538d$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $c442fa203ef9538d$var$ReactSharedInternals.T, currentTransition = {};
        $c442fa203ef9538d$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $c442fa203ef9538d$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $c442fa203ef9538d$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $c442fa203ef9538d$var$onActionError(actionQueue, node, error);
        } finally{
            $c442fa203ef9538d$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $c442fa203ef9538d$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $c442fa203ef9538d$var$onActionError(actionQueue, node, error$60);
    }
}
function $c442fa203ef9538d$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $c442fa203ef9538d$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $c442fa203ef9538d$var$onActionError(actionQueue, node, error);
    }) : $c442fa203ef9538d$var$onActionSuccess(actionQueue, node, returnValue);
}
function $c442fa203ef9538d$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $c442fa203ef9538d$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $c442fa203ef9538d$var$runActionStateAction(actionQueue, nextState)));
}
function $c442fa203ef9538d$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $c442fa203ef9538d$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $c442fa203ef9538d$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $c442fa203ef9538d$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $c442fa203ef9538d$var$mountActionState(action, initialStateProp) {
    if ($c442fa203ef9538d$var$isHydrating) {
        var ssrFormState = $c442fa203ef9538d$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $c442fa203ef9538d$var$currentlyRenderingFiber$1;
                if ($c442fa203ef9538d$var$isHydrating) {
                    if ($c442fa203ef9538d$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $c442fa203ef9538d$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $c442fa203ef9538d$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $c442fa203ef9538d$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $c442fa203ef9538d$var$nextHydratableInstance = $c442fa203ef9538d$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $c442fa203ef9538d$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $c442fa203ef9538d$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c442fa203ef9538d$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $c442fa203ef9538d$var$dispatchSetState.bind(null, $c442fa203ef9538d$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $c442fa203ef9538d$var$mountStateImpl(!1);
    inRootOrSingleton = $c442fa203ef9538d$var$dispatchOptimisticSetState.bind(null, $c442fa203ef9538d$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $c442fa203ef9538d$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $c442fa203ef9538d$var$dispatchActionState.bind(null, $c442fa203ef9538d$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $c442fa203ef9538d$var$updateActionState(action) {
    var stateHook = $c442fa203ef9538d$var$updateWorkInProgressHook();
    return $c442fa203ef9538d$var$updateActionStateImpl(stateHook, $c442fa203ef9538d$var$currentHook, action);
}
function $c442fa203ef9538d$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $c442fa203ef9538d$var$updateReducerImpl(stateHook, currentStateHook, $c442fa203ef9538d$var$actionStateReducer)[0];
    stateHook = $c442fa203ef9538d$var$updateReducer($c442fa203ef9538d$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $c442fa203ef9538d$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $c442fa203ef9538d$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($c442fa203ef9538d$var$currentlyRenderingFiber$1.flags |= 2048, $c442fa203ef9538d$var$pushEffect(9, $c442fa203ef9538d$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $c442fa203ef9538d$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $c442fa203ef9538d$var$rerenderActionState(action) {
    var stateHook = $c442fa203ef9538d$var$updateWorkInProgressHook(), currentStateHook = $c442fa203ef9538d$var$currentHook;
    if (null !== currentStateHook) return $c442fa203ef9538d$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $c442fa203ef9538d$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $c442fa203ef9538d$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $c442fa203ef9538d$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $c442fa203ef9538d$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $c442fa203ef9538d$var$createFunctionComponentUpdateQueue(), $c442fa203ef9538d$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $c442fa203ef9538d$var$updateRef() {
    return $c442fa203ef9538d$var$updateWorkInProgressHook().memoizedState;
}
function $c442fa203ef9538d$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $c442fa203ef9538d$var$mountWorkInProgressHook();
    $c442fa203ef9538d$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $c442fa203ef9538d$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $c442fa203ef9538d$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $c442fa203ef9538d$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $c442fa203ef9538d$var$currentHook && null !== deps && $c442fa203ef9538d$var$areHookInputsEqual(deps, $c442fa203ef9538d$var$currentHook.memoizedState.deps) ? hook.memoizedState = $c442fa203ef9538d$var$pushEffect(hookFlags, create, inst, deps) : ($c442fa203ef9538d$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $c442fa203ef9538d$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $c442fa203ef9538d$var$mountEffect(create, deps) {
    $c442fa203ef9538d$var$mountEffectImpl(8390656, 8, create, deps);
}
function $c442fa203ef9538d$var$updateEffect(create, deps) {
    $c442fa203ef9538d$var$updateEffectImpl(2048, 8, create, deps);
}
function $c442fa203ef9538d$var$updateInsertionEffect(create, deps) {
    return $c442fa203ef9538d$var$updateEffectImpl(4, 2, create, deps);
}
function $c442fa203ef9538d$var$updateLayoutEffect(create, deps) {
    return $c442fa203ef9538d$var$updateEffectImpl(4, 4, create, deps);
}
function $c442fa203ef9538d$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $c442fa203ef9538d$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $c442fa203ef9538d$var$updateEffectImpl(4, 4, $c442fa203ef9538d$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $c442fa203ef9538d$var$mountDebugValue() {}
function $c442fa203ef9538d$var$updateCallback(callback, deps) {
    var hook = $c442fa203ef9538d$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c442fa203ef9538d$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $c442fa203ef9538d$var$updateMemo(nextCreate, deps) {
    var hook = $c442fa203ef9538d$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c442fa203ef9538d$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($c442fa203ef9538d$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $c442fa203ef9538d$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $c442fa203ef9538d$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $c442fa203ef9538d$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($c442fa203ef9538d$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $c442fa203ef9538d$var$requestDeferredLane();
    $c442fa203ef9538d$var$currentlyRenderingFiber$1.lanes |= hook;
    $c442fa203ef9538d$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $c442fa203ef9538d$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($c442fa203ef9538d$var$objectIs(value, prevValue)) return value;
    if (null !== $c442fa203ef9538d$var$currentTreeHiddenStackCursor.current) return hook = $c442fa203ef9538d$var$mountDeferredValueImpl(hook, value, initialValue), $c442fa203ef9538d$var$objectIs(hook, prevValue) || ($c442fa203ef9538d$var$didReceiveUpdate = !0), hook;
    if (0 === ($c442fa203ef9538d$var$renderLanes & 42)) return $c442fa203ef9538d$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $c442fa203ef9538d$var$requestDeferredLane();
    $c442fa203ef9538d$var$currentlyRenderingFiber$1.lanes |= hook;
    $c442fa203ef9538d$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $c442fa203ef9538d$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $c442fa203ef9538d$var$ReactDOMSharedInternals.p;
    $c442fa203ef9538d$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $c442fa203ef9538d$var$ReactSharedInternals.T, currentTransition = {};
    $c442fa203ef9538d$var$ReactSharedInternals.T = currentTransition;
    $c442fa203ef9538d$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $c442fa203ef9538d$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $c442fa203ef9538d$var$chainThenableValue(returnValue, finishedState);
            $c442fa203ef9538d$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $c442fa203ef9538d$var$requestUpdateLane(fiber));
        } else $c442fa203ef9538d$var$dispatchSetStateInternal(fiber, queue, finishedState, $c442fa203ef9538d$var$requestUpdateLane(fiber));
    } catch (error) {
        $c442fa203ef9538d$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $c442fa203ef9538d$var$requestUpdateLane());
    } finally{
        $c442fa203ef9538d$var$ReactDOMSharedInternals.p = previousPriority, $c442fa203ef9538d$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c442fa203ef9538d$var$noop$2() {}
function $c442fa203ef9538d$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(476));
    var queue = $c442fa203ef9538d$var$ensureFormComponentIsStateful(formFiber).queue;
    $c442fa203ef9538d$var$startTransition(formFiber, queue, pendingState, $c442fa203ef9538d$var$sharedNotPendingObject, null === action ? $c442fa203ef9538d$var$noop$2 : function() {
        $c442fa203ef9538d$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $c442fa203ef9538d$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $c442fa203ef9538d$var$sharedNotPendingObject,
        baseState: $c442fa203ef9538d$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c442fa203ef9538d$var$basicStateReducer,
            lastRenderedState: $c442fa203ef9538d$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c442fa203ef9538d$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $c442fa203ef9538d$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $c442fa203ef9538d$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $c442fa203ef9538d$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $c442fa203ef9538d$var$requestUpdateLane());
}
function $c442fa203ef9538d$var$useHostTransitionStatus() {
    return $c442fa203ef9538d$var$readContext($c442fa203ef9538d$var$HostTransitionContext);
}
function $c442fa203ef9538d$var$updateId() {
    return $c442fa203ef9538d$var$updateWorkInProgressHook().memoizedState;
}
function $c442fa203ef9538d$var$updateRefresh() {
    return $c442fa203ef9538d$var$updateWorkInProgressHook().memoizedState;
}
function $c442fa203ef9538d$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $c442fa203ef9538d$var$requestUpdateLane();
                fiber = $c442fa203ef9538d$var$createUpdate(lane);
                var root$63 = $c442fa203ef9538d$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($c442fa203ef9538d$var$scheduleUpdateOnFiber(root$63, provider, lane), $c442fa203ef9538d$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $c442fa203ef9538d$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $c442fa203ef9538d$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $c442fa203ef9538d$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $c442fa203ef9538d$var$isRenderPhaseUpdate(fiber) ? $c442fa203ef9538d$var$enqueueRenderPhaseUpdate(queue, action) : (action = $c442fa203ef9538d$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($c442fa203ef9538d$var$scheduleUpdateOnFiber(action, fiber, lane), $c442fa203ef9538d$var$entangleTransitionUpdate(action, queue, lane)));
}
function $c442fa203ef9538d$var$dispatchSetState(fiber, queue, action) {
    var lane = $c442fa203ef9538d$var$requestUpdateLane();
    $c442fa203ef9538d$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $c442fa203ef9538d$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c442fa203ef9538d$var$isRenderPhaseUpdate(fiber)) $c442fa203ef9538d$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($c442fa203ef9538d$var$objectIs(eagerState, currentState)) return $c442fa203ef9538d$var$enqueueUpdate$1(fiber, queue, update, 0), null === $c442fa203ef9538d$var$workInProgressRoot && $c442fa203ef9538d$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $c442fa203ef9538d$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $c442fa203ef9538d$var$scheduleUpdateOnFiber(action, fiber, lane), $c442fa203ef9538d$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $c442fa203ef9538d$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $c442fa203ef9538d$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c442fa203ef9538d$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $c442fa203ef9538d$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $c442fa203ef9538d$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $c442fa203ef9538d$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $c442fa203ef9538d$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $c442fa203ef9538d$var$currentlyRenderingFiber$1;
}
function $c442fa203ef9538d$var$enqueueRenderPhaseUpdate(queue, update) {
    $c442fa203ef9538d$var$didScheduleRenderPhaseUpdateDuringThisPass = $c442fa203ef9538d$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $c442fa203ef9538d$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $c442fa203ef9538d$var$markRootEntangled(root, lane);
    }
}
var $c442fa203ef9538d$var$ContextOnlyDispatcher = {
    readContext: $c442fa203ef9538d$var$readContext,
    use: $c442fa203ef9538d$var$use,
    useCallback: $c442fa203ef9538d$var$throwInvalidHookError,
    useContext: $c442fa203ef9538d$var$throwInvalidHookError,
    useEffect: $c442fa203ef9538d$var$throwInvalidHookError,
    useImperativeHandle: $c442fa203ef9538d$var$throwInvalidHookError,
    useLayoutEffect: $c442fa203ef9538d$var$throwInvalidHookError,
    useInsertionEffect: $c442fa203ef9538d$var$throwInvalidHookError,
    useMemo: $c442fa203ef9538d$var$throwInvalidHookError,
    useReducer: $c442fa203ef9538d$var$throwInvalidHookError,
    useRef: $c442fa203ef9538d$var$throwInvalidHookError,
    useState: $c442fa203ef9538d$var$throwInvalidHookError,
    useDebugValue: $c442fa203ef9538d$var$throwInvalidHookError,
    useDeferredValue: $c442fa203ef9538d$var$throwInvalidHookError,
    useTransition: $c442fa203ef9538d$var$throwInvalidHookError,
    useSyncExternalStore: $c442fa203ef9538d$var$throwInvalidHookError,
    useId: $c442fa203ef9538d$var$throwInvalidHookError
};
$c442fa203ef9538d$var$ContextOnlyDispatcher.useCacheRefresh = $c442fa203ef9538d$var$throwInvalidHookError;
$c442fa203ef9538d$var$ContextOnlyDispatcher.useMemoCache = $c442fa203ef9538d$var$throwInvalidHookError;
$c442fa203ef9538d$var$ContextOnlyDispatcher.useHostTransitionStatus = $c442fa203ef9538d$var$throwInvalidHookError;
$c442fa203ef9538d$var$ContextOnlyDispatcher.useFormState = $c442fa203ef9538d$var$throwInvalidHookError;
$c442fa203ef9538d$var$ContextOnlyDispatcher.useActionState = $c442fa203ef9538d$var$throwInvalidHookError;
$c442fa203ef9538d$var$ContextOnlyDispatcher.useOptimistic = $c442fa203ef9538d$var$throwInvalidHookError;
var $c442fa203ef9538d$var$HooksDispatcherOnMount = {
    readContext: $c442fa203ef9538d$var$readContext,
    use: $c442fa203ef9538d$var$use,
    useCallback: function(callback, deps) {
        $c442fa203ef9538d$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $c442fa203ef9538d$var$readContext,
    useEffect: $c442fa203ef9538d$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $c442fa203ef9538d$var$mountEffectImpl(4194308, 4, $c442fa203ef9538d$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $c442fa203ef9538d$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $c442fa203ef9538d$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $c442fa203ef9538d$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($c442fa203ef9538d$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c442fa203ef9538d$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $c442fa203ef9538d$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $c442fa203ef9538d$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($c442fa203ef9538d$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $c442fa203ef9538d$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $c442fa203ef9538d$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $c442fa203ef9538d$var$dispatchReducerAction.bind(null, $c442fa203ef9538d$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $c442fa203ef9538d$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $c442fa203ef9538d$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $c442fa203ef9538d$var$dispatchSetState.bind(null, $c442fa203ef9538d$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $c442fa203ef9538d$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c442fa203ef9538d$var$mountWorkInProgressHook();
        return $c442fa203ef9538d$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $c442fa203ef9538d$var$mountStateImpl(!1);
        stateHook = $c442fa203ef9538d$var$startTransition.bind(null, $c442fa203ef9538d$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $c442fa203ef9538d$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $c442fa203ef9538d$var$currentlyRenderingFiber$1, hook = $c442fa203ef9538d$var$mountWorkInProgressHook();
        if ($c442fa203ef9538d$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $c442fa203ef9538d$var$workInProgressRoot) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(349));
            0 !== ($c442fa203ef9538d$var$workInProgressRootRenderLanes & 60) || $c442fa203ef9538d$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $c442fa203ef9538d$var$mountEffect($c442fa203ef9538d$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $c442fa203ef9538d$var$pushEffect(9, $c442fa203ef9538d$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $c442fa203ef9538d$var$mountWorkInProgressHook(), identifierPrefix = $c442fa203ef9538d$var$workInProgressRoot.identifierPrefix;
        if ($c442fa203ef9538d$var$isHydrating) {
            var JSCompiler_inline_result = $c442fa203ef9538d$var$treeContextOverflow;
            var idWithLeadingBit = $c442fa203ef9538d$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $c442fa203ef9538d$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $c442fa203ef9538d$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $c442fa203ef9538d$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $c442fa203ef9538d$var$mountWorkInProgressHook().memoizedState = $c442fa203ef9538d$var$refreshCache.bind(null, $c442fa203ef9538d$var$currentlyRenderingFiber$1);
    }
};
$c442fa203ef9538d$var$HooksDispatcherOnMount.useMemoCache = $c442fa203ef9538d$var$useMemoCache;
$c442fa203ef9538d$var$HooksDispatcherOnMount.useHostTransitionStatus = $c442fa203ef9538d$var$useHostTransitionStatus;
$c442fa203ef9538d$var$HooksDispatcherOnMount.useFormState = $c442fa203ef9538d$var$mountActionState;
$c442fa203ef9538d$var$HooksDispatcherOnMount.useActionState = $c442fa203ef9538d$var$mountActionState;
$c442fa203ef9538d$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $c442fa203ef9538d$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $c442fa203ef9538d$var$dispatchOptimisticSetState.bind(null, $c442fa203ef9538d$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $c442fa203ef9538d$var$HooksDispatcherOnUpdate = {
    readContext: $c442fa203ef9538d$var$readContext,
    use: $c442fa203ef9538d$var$use,
    useCallback: $c442fa203ef9538d$var$updateCallback,
    useContext: $c442fa203ef9538d$var$readContext,
    useEffect: $c442fa203ef9538d$var$updateEffect,
    useImperativeHandle: $c442fa203ef9538d$var$updateImperativeHandle,
    useInsertionEffect: $c442fa203ef9538d$var$updateInsertionEffect,
    useLayoutEffect: $c442fa203ef9538d$var$updateLayoutEffect,
    useMemo: $c442fa203ef9538d$var$updateMemo,
    useReducer: $c442fa203ef9538d$var$updateReducer,
    useRef: $c442fa203ef9538d$var$updateRef,
    useState: function() {
        return $c442fa203ef9538d$var$updateReducer($c442fa203ef9538d$var$basicStateReducer);
    },
    useDebugValue: $c442fa203ef9538d$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c442fa203ef9538d$var$updateWorkInProgressHook();
        return $c442fa203ef9538d$var$updateDeferredValueImpl(hook, $c442fa203ef9538d$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $c442fa203ef9538d$var$updateReducer($c442fa203ef9538d$var$basicStateReducer)[0], start = $c442fa203ef9538d$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c442fa203ef9538d$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c442fa203ef9538d$var$updateSyncExternalStore,
    useId: $c442fa203ef9538d$var$updateId
};
$c442fa203ef9538d$var$HooksDispatcherOnUpdate.useCacheRefresh = $c442fa203ef9538d$var$updateRefresh;
$c442fa203ef9538d$var$HooksDispatcherOnUpdate.useMemoCache = $c442fa203ef9538d$var$useMemoCache;
$c442fa203ef9538d$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $c442fa203ef9538d$var$useHostTransitionStatus;
$c442fa203ef9538d$var$HooksDispatcherOnUpdate.useFormState = $c442fa203ef9538d$var$updateActionState;
$c442fa203ef9538d$var$HooksDispatcherOnUpdate.useActionState = $c442fa203ef9538d$var$updateActionState;
$c442fa203ef9538d$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $c442fa203ef9538d$var$updateWorkInProgressHook();
    return $c442fa203ef9538d$var$updateOptimisticImpl(hook, $c442fa203ef9538d$var$currentHook, passthrough, reducer);
};
var $c442fa203ef9538d$var$HooksDispatcherOnRerender = {
    readContext: $c442fa203ef9538d$var$readContext,
    use: $c442fa203ef9538d$var$use,
    useCallback: $c442fa203ef9538d$var$updateCallback,
    useContext: $c442fa203ef9538d$var$readContext,
    useEffect: $c442fa203ef9538d$var$updateEffect,
    useImperativeHandle: $c442fa203ef9538d$var$updateImperativeHandle,
    useInsertionEffect: $c442fa203ef9538d$var$updateInsertionEffect,
    useLayoutEffect: $c442fa203ef9538d$var$updateLayoutEffect,
    useMemo: $c442fa203ef9538d$var$updateMemo,
    useReducer: $c442fa203ef9538d$var$rerenderReducer,
    useRef: $c442fa203ef9538d$var$updateRef,
    useState: function() {
        return $c442fa203ef9538d$var$rerenderReducer($c442fa203ef9538d$var$basicStateReducer);
    },
    useDebugValue: $c442fa203ef9538d$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c442fa203ef9538d$var$updateWorkInProgressHook();
        return null === $c442fa203ef9538d$var$currentHook ? $c442fa203ef9538d$var$mountDeferredValueImpl(hook, value, initialValue) : $c442fa203ef9538d$var$updateDeferredValueImpl(hook, $c442fa203ef9538d$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $c442fa203ef9538d$var$rerenderReducer($c442fa203ef9538d$var$basicStateReducer)[0], start = $c442fa203ef9538d$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c442fa203ef9538d$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c442fa203ef9538d$var$updateSyncExternalStore,
    useId: $c442fa203ef9538d$var$updateId
};
$c442fa203ef9538d$var$HooksDispatcherOnRerender.useCacheRefresh = $c442fa203ef9538d$var$updateRefresh;
$c442fa203ef9538d$var$HooksDispatcherOnRerender.useMemoCache = $c442fa203ef9538d$var$useMemoCache;
$c442fa203ef9538d$var$HooksDispatcherOnRerender.useHostTransitionStatus = $c442fa203ef9538d$var$useHostTransitionStatus;
$c442fa203ef9538d$var$HooksDispatcherOnRerender.useFormState = $c442fa203ef9538d$var$rerenderActionState;
$c442fa203ef9538d$var$HooksDispatcherOnRerender.useActionState = $c442fa203ef9538d$var$rerenderActionState;
$c442fa203ef9538d$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $c442fa203ef9538d$var$updateWorkInProgressHook();
    if (null !== $c442fa203ef9538d$var$currentHook) return $c442fa203ef9538d$var$updateOptimisticImpl(hook, $c442fa203ef9538d$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $c442fa203ef9538d$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $c442fa203ef9538d$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $c442fa203ef9538d$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $c442fa203ef9538d$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c442fa203ef9538d$var$requestUpdateLane(), update = $c442fa203ef9538d$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c442fa203ef9538d$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c442fa203ef9538d$var$scheduleUpdateOnFiber(payload, inst, lane), $c442fa203ef9538d$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c442fa203ef9538d$var$requestUpdateLane(), update = $c442fa203ef9538d$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c442fa203ef9538d$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c442fa203ef9538d$var$scheduleUpdateOnFiber(payload, inst, lane), $c442fa203ef9538d$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $c442fa203ef9538d$var$requestUpdateLane(), update = $c442fa203ef9538d$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $c442fa203ef9538d$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($c442fa203ef9538d$var$scheduleUpdateOnFiber(callback, inst, lane), $c442fa203ef9538d$var$entangleTransitions(callback, inst, lane));
    }
};
function $c442fa203ef9538d$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$c442fa203ef9538d$var$shallowEqual(oldProps, newProps) || !$c442fa203ef9538d$var$shallowEqual(oldState, newState) : !0;
}
function $c442fa203ef9538d$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $c442fa203ef9538d$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $c442fa203ef9538d$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $c442fa203ef9538d$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $c442fa203ef9538d$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $c442fa203ef9538d$var$defaultOnUncaughtError(error) {
    $c442fa203ef9538d$var$reportGlobalError(error);
}
function $c442fa203ef9538d$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $c442fa203ef9538d$var$defaultOnRecoverableError(error) {
    $c442fa203ef9538d$var$reportGlobalError(error);
}
function $c442fa203ef9538d$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $c442fa203ef9538d$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $c442fa203ef9538d$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $c442fa203ef9538d$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $c442fa203ef9538d$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $c442fa203ef9538d$var$createClassErrorUpdate(lane) {
    lane = $c442fa203ef9538d$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $c442fa203ef9538d$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $c442fa203ef9538d$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $c442fa203ef9538d$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $c442fa203ef9538d$var$legacyErrorBoundariesThatAlreadyFailed ? $c442fa203ef9538d$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $c442fa203ef9538d$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $c442fa203ef9538d$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $c442fa203ef9538d$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $c442fa203ef9538d$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $c442fa203ef9538d$var$shellBoundary ? $c442fa203ef9538d$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $c442fa203ef9538d$var$workInProgressRootExitStatus && ($c442fa203ef9538d$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $c442fa203ef9538d$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $c442fa203ef9538d$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $c442fa203ef9538d$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $c442fa203ef9538d$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($c442fa203ef9538d$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $c442fa203ef9538d$var$attachPingListener(root, value, rootRenderLanes);
        $c442fa203ef9538d$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($c442fa203ef9538d$var$isHydrating) return returnFiber = $c442fa203ef9538d$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $c442fa203ef9538d$var$HydrationMismatchException && (root = Error($c442fa203ef9538d$var$formatProdErrorMessage(422), {
        cause: value
    }), $c442fa203ef9538d$var$queueHydrationError($c442fa203ef9538d$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $c442fa203ef9538d$var$HydrationMismatchException && (returnFiber = Error($c442fa203ef9538d$var$formatProdErrorMessage(423), {
        cause: value
    }), $c442fa203ef9538d$var$queueHydrationError($c442fa203ef9538d$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $c442fa203ef9538d$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $c442fa203ef9538d$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $c442fa203ef9538d$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $c442fa203ef9538d$var$workInProgressRootExitStatus && ($c442fa203ef9538d$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($c442fa203ef9538d$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $c442fa203ef9538d$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $c442fa203ef9538d$var$workInProgressRootConcurrentErrors ? $c442fa203ef9538d$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $c442fa203ef9538d$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $c442fa203ef9538d$var$workInProgressRootExitStatus && ($c442fa203ef9538d$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $c442fa203ef9538d$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $c442fa203ef9538d$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $c442fa203ef9538d$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $c442fa203ef9538d$var$legacyErrorBoundariesThatAlreadyFailed || !$c442fa203ef9538d$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $c442fa203ef9538d$var$createClassErrorUpdate(rootRenderLanes), $c442fa203ef9538d$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $c442fa203ef9538d$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $c442fa203ef9538d$var$SelectiveHydrationException = Error($c442fa203ef9538d$var$formatProdErrorMessage(461)), $c442fa203ef9538d$var$didReceiveUpdate = !1;
function $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $c442fa203ef9538d$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $c442fa203ef9538d$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $c442fa203ef9538d$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $c442fa203ef9538d$var$prepareToReadContext(workInProgress);
    nextProps = $c442fa203ef9538d$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $c442fa203ef9538d$var$checkDidRenderIdHook();
    if (null !== current && !$c442fa203ef9538d$var$didReceiveUpdate) return $c442fa203ef9538d$var$bailoutHooks(current, workInProgress, renderLanes), $c442fa203ef9538d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c442fa203ef9538d$var$isHydrating && key && $c442fa203ef9538d$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c442fa203ef9538d$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$c442fa203ef9538d$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $c442fa203ef9538d$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $c442fa203ef9538d$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$c442fa203ef9538d$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $c442fa203ef9538d$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $c442fa203ef9538d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $c442fa203ef9538d$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $c442fa203ef9538d$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($c442fa203ef9538d$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($c442fa203ef9538d$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $c442fa203ef9538d$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($c442fa203ef9538d$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $c442fa203ef9538d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $c442fa203ef9538d$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $c442fa203ef9538d$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $c442fa203ef9538d$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $c442fa203ef9538d$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $c442fa203ef9538d$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $c442fa203ef9538d$var$pushHiddenContext(workInProgress, prevState) : $c442fa203ef9538d$var$reuseHiddenContextOnStack(), $c442fa203ef9538d$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $c442fa203ef9538d$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($c442fa203ef9538d$var$pushTransition(workInProgress, prevState.cachePool), $c442fa203ef9538d$var$pushHiddenContext(workInProgress, prevState), $c442fa203ef9538d$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $c442fa203ef9538d$var$pushTransition(workInProgress, null), $c442fa203ef9538d$var$reuseHiddenContextOnStack(), $c442fa203ef9538d$var$reuseSuspenseHandlerOnStack(workInProgress));
    $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $c442fa203ef9538d$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $c442fa203ef9538d$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $c442fa203ef9538d$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $c442fa203ef9538d$var$pushTransition(workInProgress, null);
    $c442fa203ef9538d$var$reuseHiddenContextOnStack();
    $c442fa203ef9538d$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $c442fa203ef9538d$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $c442fa203ef9538d$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $c442fa203ef9538d$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c442fa203ef9538d$var$prepareToReadContext(workInProgress);
    Component = $c442fa203ef9538d$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $c442fa203ef9538d$var$checkDidRenderIdHook();
    if (null !== current && !$c442fa203ef9538d$var$didReceiveUpdate) return $c442fa203ef9538d$var$bailoutHooks(current, workInProgress, renderLanes), $c442fa203ef9538d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c442fa203ef9538d$var$isHydrating && nextProps && $c442fa203ef9538d$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $c442fa203ef9538d$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $c442fa203ef9538d$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $c442fa203ef9538d$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $c442fa203ef9538d$var$finishRenderingHooks(current);
    Component = $c442fa203ef9538d$var$checkDidRenderIdHook();
    if (null !== current && !$c442fa203ef9538d$var$didReceiveUpdate) return $c442fa203ef9538d$var$bailoutHooks(current, workInProgress, renderLanes), $c442fa203ef9538d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c442fa203ef9538d$var$isHydrating && Component && $c442fa203ef9538d$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c442fa203ef9538d$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c442fa203ef9538d$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $c442fa203ef9538d$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $c442fa203ef9538d$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $c442fa203ef9538d$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $c442fa203ef9538d$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $c442fa203ef9538d$var$readContext(contextType) : $c442fa203ef9538d$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($c442fa203ef9538d$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $c442fa203ef9538d$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $c442fa203ef9538d$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $c442fa203ef9538d$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $c442fa203ef9538d$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $c442fa203ef9538d$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $c442fa203ef9538d$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $c442fa203ef9538d$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $c442fa203ef9538d$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c442fa203ef9538d$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c442fa203ef9538d$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $c442fa203ef9538d$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($c442fa203ef9538d$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $c442fa203ef9538d$var$hasForceUpdate || $c442fa203ef9538d$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $c442fa203ef9538d$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $c442fa203ef9538d$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $c442fa203ef9538d$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $c442fa203ef9538d$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $c442fa203ef9538d$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $c442fa203ef9538d$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c442fa203ef9538d$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c442fa203ef9538d$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $c442fa203ef9538d$var$hasForceUpdate || null !== current && null !== current.dependencies && $c442fa203ef9538d$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($c442fa203ef9538d$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $c442fa203ef9538d$var$hasForceUpdate || $c442fa203ef9538d$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $c442fa203ef9538d$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $c442fa203ef9538d$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $c442fa203ef9538d$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $c442fa203ef9538d$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $c442fa203ef9538d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $c442fa203ef9538d$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $c442fa203ef9538d$var$resetHydrationState();
    workInProgress.flags |= 256;
    $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $c442fa203ef9538d$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c442fa203ef9538d$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $c442fa203ef9538d$var$getSuspendedCache()
    };
}
function $c442fa203ef9538d$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $c442fa203ef9538d$var$workInProgressDeferredLane);
    return current;
}
function $c442fa203ef9538d$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($c442fa203ef9538d$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($c442fa203ef9538d$var$isHydrating) {
            showFallback ? $c442fa203ef9538d$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $c442fa203ef9538d$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($c442fa203ef9538d$var$isHydrating) {
                var nextInstance = $c442fa203ef9538d$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $c442fa203ef9538d$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $c442fa203ef9538d$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $c442fa203ef9538d$var$treeContextProvider ? {
                            id: $c442fa203ef9538d$var$treeContextId,
                            overflow: $c442fa203ef9538d$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $c442fa203ef9538d$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $c442fa203ef9538d$var$hydrationParentFiber = workInProgress, $c442fa203ef9538d$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $c442fa203ef9538d$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $c442fa203ef9538d$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $c442fa203ef9538d$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $c442fa203ef9538d$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $c442fa203ef9538d$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $c442fa203ef9538d$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $c442fa203ef9538d$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c442fa203ef9538d$var$SUSPENDED_MARKER, nextProps;
        $c442fa203ef9538d$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $c442fa203ef9538d$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($c442fa203ef9538d$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $c442fa203ef9538d$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($c442fa203ef9538d$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($c442fa203ef9538d$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $c442fa203ef9538d$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $c442fa203ef9538d$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $c442fa203ef9538d$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $c442fa203ef9538d$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $c442fa203ef9538d$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c442fa203ef9538d$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($c442fa203ef9538d$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($c442fa203ef9538d$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $c442fa203ef9538d$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $c442fa203ef9538d$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($c442fa203ef9538d$var$didReceiveUpdate || $c442fa203ef9538d$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $c442fa203ef9538d$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $c442fa203ef9538d$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $c442fa203ef9538d$var$enqueueConcurrentRenderForLane(current, nextProps), $c442fa203ef9538d$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $c442fa203ef9538d$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $c442fa203ef9538d$var$renderDidSuspendDelayIfPossible();
            workInProgress = $c442fa203ef9538d$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $c442fa203ef9538d$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $c442fa203ef9538d$var$nextHydratableInstance = $c442fa203ef9538d$var$getNextHydratable(nextInstance.nextSibling), $c442fa203ef9538d$var$hydrationParentFiber = workInProgress, $c442fa203ef9538d$var$isHydrating = !0, $c442fa203ef9538d$var$hydrationErrors = null, $c442fa203ef9538d$var$rootOrSingletonContext = !1, null !== current && ($c442fa203ef9538d$var$idStack[$c442fa203ef9538d$var$idStackIndex++] = $c442fa203ef9538d$var$treeContextId, $c442fa203ef9538d$var$idStack[$c442fa203ef9538d$var$idStackIndex++] = $c442fa203ef9538d$var$treeContextOverflow, $c442fa203ef9538d$var$idStack[$c442fa203ef9538d$var$idStackIndex++] = $c442fa203ef9538d$var$treeContextProvider, $c442fa203ef9538d$var$treeContextId = current.id, $c442fa203ef9538d$var$treeContextOverflow = current.overflow, $c442fa203ef9538d$var$treeContextProvider = workInProgress), workInProgress = $c442fa203ef9538d$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $c442fa203ef9538d$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $c442fa203ef9538d$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $c442fa203ef9538d$var$createWorkInProgress(digest, showFallback) : (showFallback = $c442fa203ef9538d$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $c442fa203ef9538d$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $c442fa203ef9538d$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $c442fa203ef9538d$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $c442fa203ef9538d$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c442fa203ef9538d$var$SUSPENDED_MARKER, nextProps;
    $c442fa203ef9538d$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $c442fa203ef9538d$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $c442fa203ef9538d$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $c442fa203ef9538d$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $c442fa203ef9538d$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $c442fa203ef9538d$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $c442fa203ef9538d$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $c442fa203ef9538d$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $c442fa203ef9538d$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $c442fa203ef9538d$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $c442fa203ef9538d$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $c442fa203ef9538d$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $c442fa203ef9538d$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $c442fa203ef9538d$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $c442fa203ef9538d$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $c442fa203ef9538d$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $c442fa203ef9538d$var$push($c442fa203ef9538d$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $c442fa203ef9538d$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $c442fa203ef9538d$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $c442fa203ef9538d$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $c442fa203ef9538d$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $c442fa203ef9538d$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $c442fa203ef9538d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $c442fa203ef9538d$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($c442fa203ef9538d$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $c442fa203ef9538d$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $c442fa203ef9538d$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $c442fa203ef9538d$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $c442fa203ef9538d$var$checkIfContextChanged(current) ? !0 : !1;
}
function $c442fa203ef9538d$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $c442fa203ef9538d$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $c442fa203ef9538d$var$pushProvider(workInProgress, $c442fa203ef9538d$var$CacheContext, current.memoizedState.cache);
            $c442fa203ef9538d$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $c442fa203ef9538d$var$pushHostContext(workInProgress);
            break;
        case 4:
            $c442fa203ef9538d$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $c442fa203ef9538d$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $c442fa203ef9538d$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $c442fa203ef9538d$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $c442fa203ef9538d$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $c442fa203ef9538d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $c442fa203ef9538d$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($c442fa203ef9538d$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $c442fa203ef9538d$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $c442fa203ef9538d$var$push($c442fa203ef9538d$var$suspenseStackCursor, $c442fa203ef9538d$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $c442fa203ef9538d$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $c442fa203ef9538d$var$pushProvider(workInProgress, $c442fa203ef9538d$var$CacheContext, current.memoizedState.cache);
    }
    return $c442fa203ef9538d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $c442fa203ef9538d$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $c442fa203ef9538d$var$didReceiveUpdate = !0;
        else {
            if (!$c442fa203ef9538d$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $c442fa203ef9538d$var$didReceiveUpdate = !1, $c442fa203ef9538d$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $c442fa203ef9538d$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $c442fa203ef9538d$var$didReceiveUpdate = !1, $c442fa203ef9538d$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $c442fa203ef9538d$var$pushTreeId(workInProgress, $c442fa203ef9538d$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $c442fa203ef9538d$var$shouldConstruct(lazyComponent) ? (current = $c442fa203ef9538d$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $c442fa203ef9538d$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $c442fa203ef9538d$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $c442fa203ef9538d$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $c442fa203ef9538d$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $c442fa203ef9538d$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $c442fa203ef9538d$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $c442fa203ef9538d$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($c442fa203ef9538d$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $c442fa203ef9538d$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $c442fa203ef9538d$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $c442fa203ef9538d$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $c442fa203ef9538d$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $c442fa203ef9538d$var$cloneUpdateQueue(current, workInProgress);
                $c442fa203ef9538d$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $c442fa203ef9538d$var$pushProvider(workInProgress, $c442fa203ef9538d$var$CacheContext, nextProps);
                nextProps !== init.cache && $c442fa203ef9538d$var$propagateContextChanges(workInProgress, [
                    $c442fa203ef9538d$var$CacheContext
                ], renderLanes, !0);
                $c442fa203ef9538d$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $c442fa203ef9538d$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $c442fa203ef9538d$var$createCapturedValueAtFiber(Error($c442fa203ef9538d$var$formatProdErrorMessage(424)), workInProgress);
                        $c442fa203ef9538d$var$queueHydrationError(lazyComponent);
                        workInProgress = $c442fa203ef9538d$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($c442fa203ef9538d$var$nextHydratableInstance = $c442fa203ef9538d$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $c442fa203ef9538d$var$hydrationParentFiber = workInProgress, $c442fa203ef9538d$var$isHydrating = !0, $c442fa203ef9538d$var$hydrationErrors = null, $c442fa203ef9538d$var$rootOrSingletonContext = !0, renderLanes = $c442fa203ef9538d$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $c442fa203ef9538d$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $c442fa203ef9538d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $c442fa203ef9538d$var$markRef(current, workInProgress), null === current ? (renderLanes = $c442fa203ef9538d$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $c442fa203ef9538d$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $c442fa203ef9538d$var$getOwnerDocumentFromRootContainer($c442fa203ef9538d$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$c442fa203ef9538d$var$internalInstanceKey] = workInProgress, lazyComponent[$c442fa203ef9538d$var$internalPropsKey] = current, $c442fa203ef9538d$var$setInitialProperties(lazyComponent, renderLanes, current), $c442fa203ef9538d$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $c442fa203ef9538d$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $c442fa203ef9538d$var$pushHostContext(workInProgress), null === current && $c442fa203ef9538d$var$isHydrating && (lazyComponent = workInProgress.stateNode = $c442fa203ef9538d$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $c442fa203ef9538d$var$rootInstanceStackCursor.current), $c442fa203ef9538d$var$hydrationParentFiber = workInProgress, $c442fa203ef9538d$var$rootOrSingletonContext = !0, $c442fa203ef9538d$var$nextHydratableInstance = $c442fa203ef9538d$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $c442fa203ef9538d$var$isHydrating ? $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $c442fa203ef9538d$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $c442fa203ef9538d$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $c442fa203ef9538d$var$isHydrating) {
                if (init = lazyComponent = $c442fa203ef9538d$var$nextHydratableInstance) lazyComponent = $c442fa203ef9538d$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $c442fa203ef9538d$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $c442fa203ef9538d$var$hydrationParentFiber = workInProgress, $c442fa203ef9538d$var$nextHydratableInstance = $c442fa203ef9538d$var$getNextHydratable(lazyComponent.firstChild), $c442fa203ef9538d$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $c442fa203ef9538d$var$throwOnHydrationMismatch(workInProgress);
            }
            $c442fa203ef9538d$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $c442fa203ef9538d$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $c442fa203ef9538d$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $c442fa203ef9538d$var$renderWithHooks(current, workInProgress, $c442fa203ef9538d$var$TransitionAwareHostComponent, null, null, renderLanes), $c442fa203ef9538d$var$HostTransitionContext._currentValue = init);
            $c442fa203ef9538d$var$markRef(current, workInProgress);
            $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $c442fa203ef9538d$var$isHydrating) {
                if (current = renderLanes = $c442fa203ef9538d$var$nextHydratableInstance) renderLanes = $c442fa203ef9538d$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $c442fa203ef9538d$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $c442fa203ef9538d$var$hydrationParentFiber = workInProgress, $c442fa203ef9538d$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $c442fa203ef9538d$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $c442fa203ef9538d$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $c442fa203ef9538d$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $c442fa203ef9538d$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $c442fa203ef9538d$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $c442fa203ef9538d$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $c442fa203ef9538d$var$prepareToReadContext(workInProgress), init = $c442fa203ef9538d$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $c442fa203ef9538d$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $c442fa203ef9538d$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $c442fa203ef9538d$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $c442fa203ef9538d$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $c442fa203ef9538d$var$prepareToReadContext(workInProgress), lazyComponent = $c442fa203ef9538d$var$readContext($c442fa203ef9538d$var$CacheContext), null === current ? (init = $c442fa203ef9538d$var$peekCacheFromPool(), null === init && (init = $c442fa203ef9538d$var$workInProgressRoot, nextProps = $c442fa203ef9538d$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $c442fa203ef9538d$var$initializeUpdateQueue(workInProgress), $c442fa203ef9538d$var$pushProvider(workInProgress, $c442fa203ef9538d$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($c442fa203ef9538d$var$cloneUpdateQueue(current, workInProgress), $c442fa203ef9538d$var$processUpdateQueue(workInProgress, null, null, renderLanes), $c442fa203ef9538d$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $c442fa203ef9538d$var$pushProvider(workInProgress, $c442fa203ef9538d$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $c442fa203ef9538d$var$pushProvider(workInProgress, $c442fa203ef9538d$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $c442fa203ef9538d$var$propagateContextChanges(workInProgress, [
                $c442fa203ef9538d$var$CacheContext
            ], renderLanes, !0))), $c442fa203ef9538d$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($c442fa203ef9538d$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $c442fa203ef9538d$var$valueCursor = $c442fa203ef9538d$var$createCursor(null), $c442fa203ef9538d$var$currentlyRenderingFiber = null, $c442fa203ef9538d$var$lastContextDependency = null;
function $c442fa203ef9538d$var$pushProvider(providerFiber, context, nextValue) {
    $c442fa203ef9538d$var$push($c442fa203ef9538d$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $c442fa203ef9538d$var$popProvider(context) {
    context._currentValue = $c442fa203ef9538d$var$valueCursor.current;
    $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$valueCursor);
}
function $c442fa203ef9538d$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $c442fa203ef9538d$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $c442fa203ef9538d$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $c442fa203ef9538d$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $c442fa203ef9538d$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $c442fa203ef9538d$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $c442fa203ef9538d$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($c442fa203ef9538d$var$HostTransitionContext) : current = [
                $c442fa203ef9538d$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $c442fa203ef9538d$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $c442fa203ef9538d$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$c442fa203ef9538d$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $c442fa203ef9538d$var$prepareToReadContext(workInProgress) {
    $c442fa203ef9538d$var$currentlyRenderingFiber = workInProgress;
    $c442fa203ef9538d$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $c442fa203ef9538d$var$readContext(context) {
    return $c442fa203ef9538d$var$readContextForConsumer($c442fa203ef9538d$var$currentlyRenderingFiber, context);
}
function $c442fa203ef9538d$var$readContextDuringReconciliation(consumer, context) {
    null === $c442fa203ef9538d$var$currentlyRenderingFiber && $c442fa203ef9538d$var$prepareToReadContext(consumer);
    return $c442fa203ef9538d$var$readContextForConsumer(consumer, context);
}
function $c442fa203ef9538d$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $c442fa203ef9538d$var$lastContextDependency) {
        if (null === consumer) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(308));
        $c442fa203ef9538d$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $c442fa203ef9538d$var$lastContextDependency = $c442fa203ef9538d$var$lastContextDependency.next = context;
    return value;
}
var $c442fa203ef9538d$var$hasForceUpdate = !1;
function $c442fa203ef9538d$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $c442fa203ef9538d$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $c442fa203ef9538d$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c442fa203ef9538d$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($c442fa203ef9538d$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $c442fa203ef9538d$var$getRootForUpdatedFiber(fiber);
        $c442fa203ef9538d$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $c442fa203ef9538d$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $c442fa203ef9538d$var$getRootForUpdatedFiber(fiber);
}
function $c442fa203ef9538d$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $c442fa203ef9538d$var$markRootEntangled(root, lane);
    }
}
function $c442fa203ef9538d$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $c442fa203ef9538d$var$didReadFromEntangledAsyncAction = !1;
function $c442fa203ef9538d$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($c442fa203ef9538d$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $c442fa203ef9538d$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $c442fa203ef9538d$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $c442fa203ef9538d$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $c442fa203ef9538d$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($c442fa203ef9538d$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $c442fa203ef9538d$var$currentEntangledLane && ($c442fa203ef9538d$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $c442fa203ef9538d$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $c442fa203ef9538d$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $c442fa203ef9538d$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $c442fa203ef9538d$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $c442fa203ef9538d$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$c442fa203ef9538d$var$callCallback(callbacks[updateQueue], context);
}
function $c442fa203ef9538d$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c442fa203ef9538d$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $c442fa203ef9538d$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c442fa203ef9538d$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $c442fa203ef9538d$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $c442fa203ef9538d$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $c442fa203ef9538d$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $c442fa203ef9538d$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c442fa203ef9538d$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $c442fa203ef9538d$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c442fa203ef9538d$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $c442fa203ef9538d$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $c442fa203ef9538d$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $c442fa203ef9538d$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c442fa203ef9538d$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $c442fa203ef9538d$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$c442fa203ef9538d$var$internalPropsKey] = newProps;
    } catch (error) {
        $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c442fa203ef9538d$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $c442fa203ef9538d$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $c442fa203ef9538d$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $c442fa203ef9538d$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $c442fa203ef9538d$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($c442fa203ef9538d$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$c442fa203ef9538d$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $c442fa203ef9538d$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($c442fa203ef9538d$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$c442fa203ef9538d$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $c442fa203ef9538d$var$offscreenSubtreeIsHidden = !1, $c442fa203ef9538d$var$offscreenSubtreeWasHidden = !1, $c442fa203ef9538d$var$needsFormReset = !1, $c442fa203ef9538d$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $c442fa203ef9538d$var$nextEffect = null, $c442fa203ef9538d$var$shouldFireAfterActiveInstanceBlur = !1;
function $c442fa203ef9538d$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $c442fa203ef9538d$var$eventsEnabled = $c442fa203ef9538d$var$_enabled;
    root = $c442fa203ef9538d$var$getActiveElementDeep(root);
    if ($c442fa203ef9538d$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $c442fa203ef9538d$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $c442fa203ef9538d$var$_enabled = !1;
    for($c442fa203ef9538d$var$nextEffect = firstChild; null !== $c442fa203ef9538d$var$nextEffect;)if (firstChild = $c442fa203ef9538d$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $c442fa203ef9538d$var$nextEffect = root;
    else for(; null !== $c442fa203ef9538d$var$nextEffect;){
        firstChild = $c442fa203ef9538d$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $c442fa203ef9538d$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $c442fa203ef9538d$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $c442fa203ef9538d$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $c442fa203ef9538d$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $c442fa203ef9538d$var$nextEffect = root;
            break;
        }
        $c442fa203ef9538d$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $c442fa203ef9538d$var$shouldFireAfterActiveInstanceBlur;
    $c442fa203ef9538d$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $c442fa203ef9538d$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c442fa203ef9538d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c442fa203ef9538d$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $c442fa203ef9538d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $c442fa203ef9538d$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $c442fa203ef9538d$var$commitClassCallbacks(finishedWork);
            flags & 512 && $c442fa203ef9538d$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $c442fa203ef9538d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $c442fa203ef9538d$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $c442fa203ef9538d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $c442fa203ef9538d$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $c442fa203ef9538d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $c442fa203ef9538d$var$commitHostMount(finishedWork);
            flags & 512 && $c442fa203ef9538d$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $c442fa203ef9538d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $c442fa203ef9538d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c442fa203ef9538d$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $c442fa203ef9538d$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $c442fa203ef9538d$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $c442fa203ef9538d$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $c442fa203ef9538d$var$offscreenSubtreeWasHidden;
                $c442fa203ef9538d$var$offscreenSubtreeIsHidden = prevProps;
                ($c442fa203ef9538d$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $c442fa203ef9538d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $c442fa203ef9538d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $c442fa203ef9538d$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $c442fa203ef9538d$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $c442fa203ef9538d$var$safelyAttachRef(finishedWork, finishedWork.return) : $c442fa203ef9538d$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $c442fa203ef9538d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $c442fa203ef9538d$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $c442fa203ef9538d$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $c442fa203ef9538d$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $c442fa203ef9538d$var$hostParent = null, $c442fa203ef9538d$var$hostParentIsContainer = !1;
function $c442fa203ef9538d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$c442fa203ef9538d$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $c442fa203ef9538d$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($c442fa203ef9538d$var$injectedHook && "function" === typeof $c442fa203ef9538d$var$injectedHook.onCommitFiberUnmount) try {
        $c442fa203ef9538d$var$injectedHook.onCommitFiberUnmount($c442fa203ef9538d$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $c442fa203ef9538d$var$offscreenSubtreeWasHidden || $c442fa203ef9538d$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $c442fa203ef9538d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $c442fa203ef9538d$var$offscreenSubtreeWasHidden || $c442fa203ef9538d$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $c442fa203ef9538d$var$hostParent, prevHostParentIsContainer = $c442fa203ef9538d$var$hostParentIsContainer;
            $c442fa203ef9538d$var$hostParent = deletedFiber.stateNode;
            $c442fa203ef9538d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $c442fa203ef9538d$var$detachDeletedInstance(deletedFiber);
            $c442fa203ef9538d$var$hostParent = prevHostParent;
            $c442fa203ef9538d$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $c442fa203ef9538d$var$offscreenSubtreeWasHidden || $c442fa203ef9538d$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $c442fa203ef9538d$var$hostParent;
            var prevHostParentIsContainer$119 = $c442fa203ef9538d$var$hostParentIsContainer;
            $c442fa203ef9538d$var$hostParent = null;
            $c442fa203ef9538d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c442fa203ef9538d$var$hostParent = prevHostParentIsContainer;
            $c442fa203ef9538d$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $c442fa203ef9538d$var$hostParent) {
                if ($c442fa203ef9538d$var$hostParentIsContainer) try {
                    finishedRoot = $c442fa203ef9538d$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $c442fa203ef9538d$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $c442fa203ef9538d$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $c442fa203ef9538d$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $c442fa203ef9538d$var$hostParent && ($c442fa203ef9538d$var$hostParentIsContainer ? (nearestMountedAncestor = $c442fa203ef9538d$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $c442fa203ef9538d$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $c442fa203ef9538d$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $c442fa203ef9538d$var$retryIfBlockedOn(nearestMountedAncestor)) : $c442fa203ef9538d$var$clearSuspenseBoundary($c442fa203ef9538d$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $c442fa203ef9538d$var$hostParent;
            prevHostParentIsContainer = $c442fa203ef9538d$var$hostParentIsContainer;
            $c442fa203ef9538d$var$hostParent = deletedFiber.stateNode.containerInfo;
            $c442fa203ef9538d$var$hostParentIsContainer = !0;
            $c442fa203ef9538d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c442fa203ef9538d$var$hostParent = prevHostParent;
            $c442fa203ef9538d$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $c442fa203ef9538d$var$offscreenSubtreeWasHidden || $c442fa203ef9538d$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $c442fa203ef9538d$var$offscreenSubtreeWasHidden || $c442fa203ef9538d$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $c442fa203ef9538d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $c442fa203ef9538d$var$offscreenSubtreeWasHidden || ($c442fa203ef9538d$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $c442fa203ef9538d$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $c442fa203ef9538d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $c442fa203ef9538d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $c442fa203ef9538d$var$offscreenSubtreeWasHidden || $c442fa203ef9538d$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $c442fa203ef9538d$var$offscreenSubtreeWasHidden = (prevHostParent = $c442fa203ef9538d$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $c442fa203ef9538d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c442fa203ef9538d$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $c442fa203ef9538d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $c442fa203ef9538d$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $c442fa203ef9538d$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c442fa203ef9538d$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $c442fa203ef9538d$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $c442fa203ef9538d$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($c442fa203ef9538d$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $c442fa203ef9538d$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $c442fa203ef9538d$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $c442fa203ef9538d$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $c442fa203ef9538d$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $c442fa203ef9538d$var$hostParent = parent.stateNode;
                    $c442fa203ef9538d$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $c442fa203ef9538d$var$hostParent = parent.stateNode.containerInfo;
                    $c442fa203ef9538d$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $c442fa203ef9538d$var$hostParent = parent.stateNode.containerInfo;
                    $c442fa203ef9538d$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $c442fa203ef9538d$var$hostParent) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(160));
        $c442fa203ef9538d$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $c442fa203ef9538d$var$hostParent = null;
        $c442fa203ef9538d$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$c442fa203ef9538d$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $c442fa203ef9538d$var$currentHoistableRoot = null;
function $c442fa203ef9538d$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c442fa203ef9538d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c442fa203ef9538d$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($c442fa203ef9538d$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $c442fa203ef9538d$var$commitHookEffectListMount(3, finishedWork), $c442fa203ef9538d$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $c442fa203ef9538d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c442fa203ef9538d$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c442fa203ef9538d$var$offscreenSubtreeWasHidden || null === current || $c442fa203ef9538d$var$safelyDetachRef(current, current.return));
            flags & 64 && $c442fa203ef9538d$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $c442fa203ef9538d$var$currentHoistableRoot;
            $c442fa203ef9538d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c442fa203ef9538d$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c442fa203ef9538d$var$offscreenSubtreeWasHidden || null === current || $c442fa203ef9538d$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$c442fa203ef9538d$var$internalHoistableMarker] || currentResource[$c442fa203ef9538d$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $c442fa203ef9538d$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$c442fa203ef9538d$var$internalInstanceKey] = finishedWork;
                                        $c442fa203ef9538d$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $c442fa203ef9538d$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $c442fa203ef9538d$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $c442fa203ef9538d$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $c442fa203ef9538d$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($c442fa203ef9538d$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$c442fa203ef9538d$var$internalInstanceKey] = finishedWork;
                                $c442fa203ef9538d$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $c442fa203ef9538d$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $c442fa203ef9538d$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $c442fa203ef9538d$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $c442fa203ef9538d$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $c442fa203ef9538d$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$c442fa203ef9538d$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $c442fa203ef9538d$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$c442fa203ef9538d$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$c442fa203ef9538d$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $c442fa203ef9538d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c442fa203ef9538d$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c442fa203ef9538d$var$offscreenSubtreeWasHidden || null === current || $c442fa203ef9538d$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $c442fa203ef9538d$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $c442fa203ef9538d$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($c442fa203ef9538d$var$needsFormReset = !0);
            break;
        case 6:
            $c442fa203ef9538d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c442fa203ef9538d$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $c442fa203ef9538d$var$tagCaches = null;
            hoistableRoot = $c442fa203ef9538d$var$currentHoistableRoot;
            $c442fa203ef9538d$var$currentHoistableRoot = $c442fa203ef9538d$var$getHoistableRoot(root.containerInfo);
            $c442fa203ef9538d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c442fa203ef9538d$var$currentHoistableRoot = hoistableRoot;
            $c442fa203ef9538d$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $c442fa203ef9538d$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $c442fa203ef9538d$var$needsFormReset && ($c442fa203ef9538d$var$needsFormReset = !1, $c442fa203ef9538d$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $c442fa203ef9538d$var$currentHoistableRoot;
            $c442fa203ef9538d$var$currentHoistableRoot = $c442fa203ef9538d$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $c442fa203ef9538d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c442fa203ef9538d$var$commitReconciliationEffects(finishedWork);
            $c442fa203ef9538d$var$currentHoistableRoot = flags;
            break;
        case 12:
            $c442fa203ef9538d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c442fa203ef9538d$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $c442fa203ef9538d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c442fa203ef9538d$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($c442fa203ef9538d$var$globalMostRecentFallbackTime = $c442fa203ef9538d$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c442fa203ef9538d$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($c442fa203ef9538d$var$offscreenSubtreeWasHidden || null === current || $c442fa203ef9538d$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $c442fa203ef9538d$var$offscreenSubtreeIsHidden;
            type = $c442fa203ef9538d$var$offscreenSubtreeWasHidden;
            $c442fa203ef9538d$var$offscreenSubtreeIsHidden = nodeName || node;
            $c442fa203ef9538d$var$offscreenSubtreeWasHidden = type || nextNode;
            $c442fa203ef9538d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c442fa203ef9538d$var$offscreenSubtreeWasHidden = type;
            $c442fa203ef9538d$var$offscreenSubtreeIsHidden = nodeName;
            $c442fa203ef9538d$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $c442fa203ef9538d$var$offscreenSubtreeIsHidden || $c442fa203ef9538d$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $c442fa203ef9538d$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $c442fa203ef9538d$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $c442fa203ef9538d$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $c442fa203ef9538d$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $c442fa203ef9538d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c442fa203ef9538d$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c442fa203ef9538d$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $c442fa203ef9538d$var$recursivelyTraverseMutationEffects(root, finishedWork), $c442fa203ef9538d$var$commitReconciliationEffects(finishedWork);
    }
}
function $c442fa203ef9538d$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($c442fa203ef9538d$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($c442fa203ef9538d$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $c442fa203ef9538d$var$getHostSibling(finishedWork);
                        $c442fa203ef9538d$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($c442fa203ef9538d$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $c442fa203ef9538d$var$getHostSibling(finishedWork);
                        $c442fa203ef9538d$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $c442fa203ef9538d$var$getHostSibling(finishedWork);
                        $c442fa203ef9538d$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($c442fa203ef9538d$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $c442fa203ef9538d$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $c442fa203ef9538d$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $c442fa203ef9538d$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$c442fa203ef9538d$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $c442fa203ef9538d$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $c442fa203ef9538d$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $c442fa203ef9538d$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $c442fa203ef9538d$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $c442fa203ef9538d$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $c442fa203ef9538d$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $c442fa203ef9538d$var$safelyDetachRef(finishedWork, finishedWork.return);
                $c442fa203ef9538d$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $c442fa203ef9538d$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $c442fa203ef9538d$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $c442fa203ef9538d$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c442fa203ef9538d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c442fa203ef9538d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $c442fa203ef9538d$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $c442fa203ef9538d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c442fa203ef9538d$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$c442fa203ef9538d$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $c442fa203ef9538d$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $c442fa203ef9538d$var$commitClassCallbacks(finishedWork);
                $c442fa203ef9538d$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $c442fa203ef9538d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $c442fa203ef9538d$var$commitHostMount(finishedWork);
                $c442fa203ef9538d$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $c442fa203ef9538d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $c442fa203ef9538d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $c442fa203ef9538d$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $c442fa203ef9538d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $c442fa203ef9538d$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $c442fa203ef9538d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c442fa203ef9538d$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $c442fa203ef9538d$var$releaseCache(previousCache));
}
function $c442fa203ef9538d$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $c442fa203ef9538d$var$releaseCache(current));
}
function $c442fa203ef9538d$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c442fa203ef9538d$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $c442fa203ef9538d$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c442fa203ef9538d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c442fa203ef9538d$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $c442fa203ef9538d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $c442fa203ef9538d$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $c442fa203ef9538d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $c442fa203ef9538d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $c442fa203ef9538d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $c442fa203ef9538d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $c442fa203ef9538d$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $c442fa203ef9538d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $c442fa203ef9538d$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $c442fa203ef9538d$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $c442fa203ef9538d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c442fa203ef9538d$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $c442fa203ef9538d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $c442fa203ef9538d$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c442fa203ef9538d$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $c442fa203ef9538d$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $c442fa203ef9538d$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $c442fa203ef9538d$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $c442fa203ef9538d$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $c442fa203ef9538d$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c442fa203ef9538d$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $c442fa203ef9538d$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c442fa203ef9538d$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c442fa203ef9538d$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $c442fa203ef9538d$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c442fa203ef9538d$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c442fa203ef9538d$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c442fa203ef9538d$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c442fa203ef9538d$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $c442fa203ef9538d$var$suspenseyCommitFlag = 8192;
function $c442fa203ef9538d$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $c442fa203ef9538d$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$c442fa203ef9538d$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $c442fa203ef9538d$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $c442fa203ef9538d$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $c442fa203ef9538d$var$suspenseyCommitFlag && null !== fiber.memoizedState && $c442fa203ef9538d$var$suspendResource($c442fa203ef9538d$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $c442fa203ef9538d$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $c442fa203ef9538d$var$currentHoistableRoot;
            $c442fa203ef9538d$var$currentHoistableRoot = $c442fa203ef9538d$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $c442fa203ef9538d$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $c442fa203ef9538d$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $c442fa203ef9538d$var$suspenseyCommitFlag, $c442fa203ef9538d$var$suspenseyCommitFlag = 16777216, $c442fa203ef9538d$var$recursivelyAccumulateSuspenseyCommit(fiber), $c442fa203ef9538d$var$suspenseyCommitFlag = previousHoistableRoot) : $c442fa203ef9538d$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $c442fa203ef9538d$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $c442fa203ef9538d$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $c442fa203ef9538d$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c442fa203ef9538d$var$nextEffect = childToDelete;
            $c442fa203ef9538d$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c442fa203ef9538d$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c442fa203ef9538d$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $c442fa203ef9538d$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c442fa203ef9538d$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $c442fa203ef9538d$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $c442fa203ef9538d$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $c442fa203ef9538d$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $c442fa203ef9538d$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $c442fa203ef9538d$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $c442fa203ef9538d$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $c442fa203ef9538d$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c442fa203ef9538d$var$nextEffect = childToDelete;
            $c442fa203ef9538d$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c442fa203ef9538d$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $c442fa203ef9538d$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $c442fa203ef9538d$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $c442fa203ef9538d$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $c442fa203ef9538d$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c442fa203ef9538d$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $c442fa203ef9538d$var$nextEffect;){
        var fiber = $c442fa203ef9538d$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $c442fa203ef9538d$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $c442fa203ef9538d$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $c442fa203ef9538d$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $c442fa203ef9538d$var$nextEffect;){
            cache = $c442fa203ef9538d$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $c442fa203ef9538d$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $c442fa203ef9538d$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $c442fa203ef9538d$var$nextEffect = sibling;
                break a;
            }
            $c442fa203ef9538d$var$nextEffect = returnFiber;
        }
    }
}
function $c442fa203ef9538d$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c442fa203ef9538d$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $c442fa203ef9538d$var$FiberNode(tag, pendingProps, key, mode);
}
function $c442fa203ef9538d$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $c442fa203ef9538d$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $c442fa203ef9538d$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $c442fa203ef9538d$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $c442fa203ef9538d$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $c442fa203ef9538d$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $c442fa203ef9538d$var$isHostHoistableType(type, pendingProps, $c442fa203ef9538d$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $c442fa203ef9538d$var$REACT_FRAGMENT_TYPE:
            return $c442fa203ef9538d$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $c442fa203ef9538d$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $c442fa203ef9538d$var$REACT_PROFILER_TYPE:
            return type = $c442fa203ef9538d$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $c442fa203ef9538d$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $c442fa203ef9538d$var$REACT_SUSPENSE_TYPE:
            return type = $c442fa203ef9538d$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $c442fa203ef9538d$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $c442fa203ef9538d$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $c442fa203ef9538d$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $c442fa203ef9538d$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $c442fa203ef9538d$var$REACT_OFFSCREEN_TYPE:
            return $c442fa203ef9538d$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $c442fa203ef9538d$var$REACT_PROVIDER_TYPE:
                case $c442fa203ef9538d$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $c442fa203ef9538d$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $c442fa203ef9538d$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $c442fa203ef9538d$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $c442fa203ef9538d$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($c442fa203ef9538d$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $c442fa203ef9538d$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $c442fa203ef9538d$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $c442fa203ef9538d$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $c442fa203ef9538d$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $c442fa203ef9538d$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $c442fa203ef9538d$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $c442fa203ef9538d$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $c442fa203ef9538d$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $c442fa203ef9538d$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $c442fa203ef9538d$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $c442fa203ef9538d$var$createFiberFromText(content, mode, lanes) {
    content = $c442fa203ef9538d$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $c442fa203ef9538d$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $c442fa203ef9538d$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $c442fa203ef9538d$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $c442fa203ef9538d$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$c442fa203ef9538d$var$preloadResource(resource)) {
        resource = $c442fa203ef9538d$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($c442fa203ef9538d$var$workInProgressRootRenderLanes & 4194176) === $c442fa203ef9538d$var$workInProgressRootRenderLanes ? null !== $c442fa203ef9538d$var$shellBoundary : ($c442fa203ef9538d$var$workInProgressRootRenderLanes & 62914560) !== $c442fa203ef9538d$var$workInProgressRootRenderLanes && 0 === ($c442fa203ef9538d$var$workInProgressRootRenderLanes & 536870912) || resource !== $c442fa203ef9538d$var$shellBoundary)) throw $c442fa203ef9538d$var$suspendedThenable = $c442fa203ef9538d$var$noopSuspenseyCommitThenable, $c442fa203ef9538d$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $c442fa203ef9538d$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $c442fa203ef9538d$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $c442fa203ef9538d$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $c442fa203ef9538d$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$c442fa203ef9538d$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $c442fa203ef9538d$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $c442fa203ef9538d$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $c442fa203ef9538d$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c442fa203ef9538d$var$bubbleProperties(workInProgress), null;
        case 1:
            return $c442fa203ef9538d$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $c442fa203ef9538d$var$popProvider($c442fa203ef9538d$var$CacheContext);
            $c442fa203ef9538d$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $c442fa203ef9538d$var$popHydrationState(workInProgress) ? $c442fa203ef9538d$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $c442fa203ef9538d$var$hydrationErrors && ($c442fa203ef9538d$var$queueRecoverableErrors($c442fa203ef9538d$var$hydrationErrors), $c442fa203ef9538d$var$hydrationErrors = null));
            $c442fa203ef9538d$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($c442fa203ef9538d$var$markUpdate(workInProgress), null !== renderLanes ? ($c442fa203ef9538d$var$bubbleProperties(workInProgress), $c442fa203ef9538d$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($c442fa203ef9538d$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($c442fa203ef9538d$var$markUpdate(workInProgress), $c442fa203ef9538d$var$bubbleProperties(workInProgress), $c442fa203ef9538d$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($c442fa203ef9538d$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $c442fa203ef9538d$var$markUpdate(workInProgress), $c442fa203ef9538d$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $c442fa203ef9538d$var$popHostContext(workInProgress);
            renderLanes = $c442fa203ef9538d$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c442fa203ef9538d$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(166));
                    $c442fa203ef9538d$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $c442fa203ef9538d$var$contextStackCursor.current;
                $c442fa203ef9538d$var$popHydrationState(workInProgress) ? $c442fa203ef9538d$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $c442fa203ef9538d$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $c442fa203ef9538d$var$markUpdate(workInProgress));
            }
            $c442fa203ef9538d$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $c442fa203ef9538d$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c442fa203ef9538d$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(166));
                    $c442fa203ef9538d$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $c442fa203ef9538d$var$contextStackCursor.current;
                if ($c442fa203ef9538d$var$popHydrationState(workInProgress)) $c442fa203ef9538d$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $c442fa203ef9538d$var$getOwnerDocumentFromRootContainer($c442fa203ef9538d$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$c442fa203ef9538d$var$internalInstanceKey] = workInProgress;
                    current[$c442fa203ef9538d$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($c442fa203ef9538d$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $c442fa203ef9538d$var$markUpdate(workInProgress);
                }
            }
            $c442fa203ef9538d$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c442fa203ef9538d$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(166));
                current = $c442fa203ef9538d$var$rootInstanceStackCursor.current;
                if ($c442fa203ef9538d$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $c442fa203ef9538d$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$c442fa203ef9538d$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $c442fa203ef9538d$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $c442fa203ef9538d$var$throwOnHydrationMismatch(workInProgress);
                } else current = $c442fa203ef9538d$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$c442fa203ef9538d$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $c442fa203ef9538d$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $c442fa203ef9538d$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(317));
                        type[$c442fa203ef9538d$var$internalInstanceKey] = workInProgress;
                    } else $c442fa203ef9538d$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $c442fa203ef9538d$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $c442fa203ef9538d$var$hydrationErrors && ($c442fa203ef9538d$var$queueRecoverableErrors($c442fa203ef9538d$var$hydrationErrors), $c442fa203ef9538d$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $c442fa203ef9538d$var$popSuspenseHandler(workInProgress), workInProgress;
                    $c442fa203ef9538d$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $c442fa203ef9538d$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $c442fa203ef9538d$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $c442fa203ef9538d$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $c442fa203ef9538d$var$popHostContainer(), null === current && $c442fa203ef9538d$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $c442fa203ef9538d$var$bubbleProperties(workInProgress), null;
        case 10:
            return $c442fa203ef9538d$var$popProvider(workInProgress.type), $c442fa203ef9538d$var$bubbleProperties(workInProgress), null;
        case 19:
            $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $c442fa203ef9538d$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $c442fa203ef9538d$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $c442fa203ef9538d$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $c442fa203ef9538d$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $c442fa203ef9538d$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $c442fa203ef9538d$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$c442fa203ef9538d$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $c442fa203ef9538d$var$push($c442fa203ef9538d$var$suspenseStackCursor, $c442fa203ef9538d$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $c442fa203ef9538d$var$now() > $c442fa203ef9538d$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $c442fa203ef9538d$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $c442fa203ef9538d$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $c442fa203ef9538d$var$scheduleRetryEffect(workInProgress, current), $c442fa203ef9538d$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$c442fa203ef9538d$var$isHydrating) return $c442fa203ef9538d$var$bubbleProperties(workInProgress), null;
                    } else 2 * $c442fa203ef9538d$var$now() - type.renderingStartTime > $c442fa203ef9538d$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $c442fa203ef9538d$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $c442fa203ef9538d$var$now(), workInProgress.sibling = null, current = $c442fa203ef9538d$var$suspenseStackCursor.current, $c442fa203ef9538d$var$push($c442fa203ef9538d$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $c442fa203ef9538d$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $c442fa203ef9538d$var$popSuspenseHandler(workInProgress), $c442fa203ef9538d$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($c442fa203ef9538d$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $c442fa203ef9538d$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $c442fa203ef9538d$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $c442fa203ef9538d$var$popProvider($c442fa203ef9538d$var$CacheContext), $c442fa203ef9538d$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($c442fa203ef9538d$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $c442fa203ef9538d$var$unwindWork(current, workInProgress) {
    $c442fa203ef9538d$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $c442fa203ef9538d$var$popProvider($c442fa203ef9538d$var$CacheContext), $c442fa203ef9538d$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $c442fa203ef9538d$var$popHostContext(workInProgress), null;
        case 13:
            $c442fa203ef9538d$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(340));
                $c442fa203ef9538d$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$suspenseStackCursor), null;
        case 4:
            return $c442fa203ef9538d$var$popHostContainer(), null;
        case 10:
            return $c442fa203ef9538d$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $c442fa203ef9538d$var$popSuspenseHandler(workInProgress), $c442fa203ef9538d$var$popHiddenContext(), null !== current && $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $c442fa203ef9538d$var$popProvider($c442fa203ef9538d$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $c442fa203ef9538d$var$unwindInterruptedWork(current, interruptedWork) {
    $c442fa203ef9538d$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $c442fa203ef9538d$var$popProvider($c442fa203ef9538d$var$CacheContext);
            $c442fa203ef9538d$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $c442fa203ef9538d$var$popHostContext(interruptedWork);
            break;
        case 4:
            $c442fa203ef9538d$var$popHostContainer();
            break;
        case 13:
            $c442fa203ef9538d$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$suspenseStackCursor);
            break;
        case 10:
            $c442fa203ef9538d$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $c442fa203ef9538d$var$popSuspenseHandler(interruptedWork);
            $c442fa203ef9538d$var$popHiddenContext();
            null !== current && $c442fa203ef9538d$var$pop($c442fa203ef9538d$var$resumedCache);
            break;
        case 24:
            $c442fa203ef9538d$var$popProvider($c442fa203ef9538d$var$CacheContext);
    }
}
var $c442fa203ef9538d$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $c442fa203ef9538d$var$readContext($c442fa203ef9538d$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $c442fa203ef9538d$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $c442fa203ef9538d$var$executionContext = 0, $c442fa203ef9538d$var$workInProgressRoot = null, $c442fa203ef9538d$var$workInProgress = null, $c442fa203ef9538d$var$workInProgressRootRenderLanes = 0, $c442fa203ef9538d$var$workInProgressSuspendedReason = 0, $c442fa203ef9538d$var$workInProgressThrownValue = null, $c442fa203ef9538d$var$workInProgressRootDidSkipSuspendedSiblings = !1, $c442fa203ef9538d$var$workInProgressRootIsPrerendering = !1, $c442fa203ef9538d$var$workInProgressRootDidAttachPingListener = !1, $c442fa203ef9538d$var$entangledRenderLanes = 0, $c442fa203ef9538d$var$workInProgressRootExitStatus = 0, $c442fa203ef9538d$var$workInProgressRootSkippedLanes = 0, $c442fa203ef9538d$var$workInProgressRootInterleavedUpdatedLanes = 0, $c442fa203ef9538d$var$workInProgressRootPingedLanes = 0, $c442fa203ef9538d$var$workInProgressDeferredLane = 0, $c442fa203ef9538d$var$workInProgressSuspendedRetryLanes = 0, $c442fa203ef9538d$var$workInProgressRootConcurrentErrors = null, $c442fa203ef9538d$var$workInProgressRootRecoverableErrors = null, $c442fa203ef9538d$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $c442fa203ef9538d$var$globalMostRecentFallbackTime = 0, $c442fa203ef9538d$var$workInProgressRootRenderTargetTime = Infinity, $c442fa203ef9538d$var$workInProgressTransitions = null, $c442fa203ef9538d$var$legacyErrorBoundariesThatAlreadyFailed = null, $c442fa203ef9538d$var$rootDoesHavePassiveEffects = !1, $c442fa203ef9538d$var$rootWithPendingPassiveEffects = null, $c442fa203ef9538d$var$pendingPassiveEffectsLanes = 0, $c442fa203ef9538d$var$pendingPassiveEffectsRemainingLanes = 0, $c442fa203ef9538d$var$pendingPassiveTransitions = null, $c442fa203ef9538d$var$nestedUpdateCount = 0, $c442fa203ef9538d$var$rootWithNestedUpdates = null;
function $c442fa203ef9538d$var$requestUpdateLane() {
    if (0 !== ($c442fa203ef9538d$var$executionContext & 2) && 0 !== $c442fa203ef9538d$var$workInProgressRootRenderLanes) return $c442fa203ef9538d$var$workInProgressRootRenderLanes & -$c442fa203ef9538d$var$workInProgressRootRenderLanes;
    if (null !== $c442fa203ef9538d$var$ReactSharedInternals.T) {
        var actionScopeLane = $c442fa203ef9538d$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $c442fa203ef9538d$var$requestTransitionLane();
    }
    return $c442fa203ef9538d$var$resolveUpdatePriority();
}
function $c442fa203ef9538d$var$requestDeferredLane() {
    0 === $c442fa203ef9538d$var$workInProgressDeferredLane && ($c442fa203ef9538d$var$workInProgressDeferredLane = 0 === ($c442fa203ef9538d$var$workInProgressRootRenderLanes & 536870912) || $c442fa203ef9538d$var$isHydrating ? $c442fa203ef9538d$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $c442fa203ef9538d$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $c442fa203ef9538d$var$workInProgressDeferredLane;
}
function $c442fa203ef9538d$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $c442fa203ef9538d$var$workInProgressRoot && 2 === $c442fa203ef9538d$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $c442fa203ef9538d$var$prepareFreshStack(root, 0), $c442fa203ef9538d$var$markRootSuspended(root, $c442fa203ef9538d$var$workInProgressRootRenderLanes, $c442fa203ef9538d$var$workInProgressDeferredLane, !1);
    $c442fa203ef9538d$var$markRootUpdated$1(root, lane);
    if (0 === ($c442fa203ef9538d$var$executionContext & 2) || root !== $c442fa203ef9538d$var$workInProgressRoot) root === $c442fa203ef9538d$var$workInProgressRoot && (0 === ($c442fa203ef9538d$var$executionContext & 2) && ($c442fa203ef9538d$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $c442fa203ef9538d$var$workInProgressRootExitStatus && $c442fa203ef9538d$var$markRootSuspended(root, $c442fa203ef9538d$var$workInProgressRootRenderLanes, $c442fa203ef9538d$var$workInProgressDeferredLane, !1)), $c442fa203ef9538d$var$ensureRootIsScheduled(root);
}
function $c442fa203ef9538d$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($c442fa203ef9538d$var$executionContext & 6)) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $c442fa203ef9538d$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $c442fa203ef9538d$var$renderRootConcurrent(root$jscomp$0, lanes) : $c442fa203ef9538d$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $c442fa203ef9538d$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $c442fa203ef9538d$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $c442fa203ef9538d$var$markRootSuspended(root$jscomp$0, lanes, 0, !$c442fa203ef9538d$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$c442fa203ef9538d$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $c442fa203ef9538d$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $c442fa203ef9538d$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($c442fa203ef9538d$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $c442fa203ef9538d$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($c442fa203ef9538d$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $c442fa203ef9538d$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $c442fa203ef9538d$var$workInProgressRootRecoverableErrors;
                            $c442fa203ef9538d$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $c442fa203ef9538d$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $c442fa203ef9538d$var$prepareFreshStack(root$jscomp$0, 0);
                $c442fa203ef9538d$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($c442fa203ef9538d$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $c442fa203ef9538d$var$markRootSuspended(shouldTimeSlice, lanes, $c442fa203ef9538d$var$workInProgressDeferredLane, !$c442fa203ef9538d$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $c442fa203ef9538d$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($c442fa203ef9538d$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $c442fa203ef9538d$var$globalMostRecentFallbackTime + 300 - $c442fa203ef9538d$var$now(), 10 < renderWasConcurrent)) {
                    $c442fa203ef9538d$var$markRootSuspended(shouldTimeSlice, lanes, $c442fa203ef9538d$var$workInProgressDeferredLane, !$c442fa203ef9538d$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $c442fa203ef9538d$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $c442fa203ef9538d$var$scheduleTimeout($c442fa203ef9538d$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $c442fa203ef9538d$var$workInProgressRootRecoverableErrors, $c442fa203ef9538d$var$workInProgressTransitions, $c442fa203ef9538d$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c442fa203ef9538d$var$workInProgressDeferredLane, $c442fa203ef9538d$var$workInProgressRootInterleavedUpdatedLanes, $c442fa203ef9538d$var$workInProgressSuspendedRetryLanes, $c442fa203ef9538d$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $c442fa203ef9538d$var$commitRootWhenReady(shouldTimeSlice, forceSync, $c442fa203ef9538d$var$workInProgressRootRecoverableErrors, $c442fa203ef9538d$var$workInProgressTransitions, $c442fa203ef9538d$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c442fa203ef9538d$var$workInProgressDeferredLane, $c442fa203ef9538d$var$workInProgressRootInterleavedUpdatedLanes, $c442fa203ef9538d$var$workInProgressSuspendedRetryLanes, $c442fa203ef9538d$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $c442fa203ef9538d$var$ensureRootIsScheduled(root$jscomp$0);
}
function $c442fa203ef9538d$var$queueRecoverableErrors(errors) {
    null === $c442fa203ef9538d$var$workInProgressRootRecoverableErrors ? $c442fa203ef9538d$var$workInProgressRootRecoverableErrors = errors : $c442fa203ef9538d$var$workInProgressRootRecoverableErrors.push.apply($c442fa203ef9538d$var$workInProgressRootRecoverableErrors, errors);
}
function $c442fa203ef9538d$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($c442fa203ef9538d$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $c442fa203ef9538d$var$noop
        }, $c442fa203ef9538d$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $c442fa203ef9538d$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($c442fa203ef9538d$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $c442fa203ef9538d$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $c442fa203ef9538d$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $c442fa203ef9538d$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$c442fa203ef9538d$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $c442fa203ef9538d$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$c442fa203ef9538d$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$c442fa203ef9538d$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $c442fa203ef9538d$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $c442fa203ef9538d$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $c442fa203ef9538d$var$flushSyncWork$1() {
    return 0 === ($c442fa203ef9538d$var$executionContext & 6) ? ($c442fa203ef9538d$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $c442fa203ef9538d$var$resetWorkInProgressStack() {
    if (null !== $c442fa203ef9538d$var$workInProgress) {
        if (0 === $c442fa203ef9538d$var$workInProgressSuspendedReason) var interruptedWork = $c442fa203ef9538d$var$workInProgress.return;
        else interruptedWork = $c442fa203ef9538d$var$workInProgress, $c442fa203ef9538d$var$lastContextDependency = $c442fa203ef9538d$var$currentlyRenderingFiber = null, $c442fa203ef9538d$var$resetHooksOnUnwind(interruptedWork), $c442fa203ef9538d$var$thenableState$1 = null, $c442fa203ef9538d$var$thenableIndexCounter$1 = 0, interruptedWork = $c442fa203ef9538d$var$workInProgress;
        for(; null !== interruptedWork;)$c442fa203ef9538d$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $c442fa203ef9538d$var$workInProgress = null;
    }
}
function $c442fa203ef9538d$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $c442fa203ef9538d$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $c442fa203ef9538d$var$resetWorkInProgressStack();
    $c442fa203ef9538d$var$workInProgressRoot = root;
    $c442fa203ef9538d$var$workInProgress = timeoutHandle = $c442fa203ef9538d$var$createWorkInProgress(root.current, null);
    $c442fa203ef9538d$var$workInProgressRootRenderLanes = lanes;
    $c442fa203ef9538d$var$workInProgressSuspendedReason = 0;
    $c442fa203ef9538d$var$workInProgressThrownValue = null;
    $c442fa203ef9538d$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $c442fa203ef9538d$var$workInProgressRootIsPrerendering = $c442fa203ef9538d$var$checkIfRootIsPrerendering(root, lanes);
    $c442fa203ef9538d$var$workInProgressRootDidAttachPingListener = !1;
    $c442fa203ef9538d$var$workInProgressSuspendedRetryLanes = $c442fa203ef9538d$var$workInProgressDeferredLane = $c442fa203ef9538d$var$workInProgressRootPingedLanes = $c442fa203ef9538d$var$workInProgressRootInterleavedUpdatedLanes = $c442fa203ef9538d$var$workInProgressRootSkippedLanes = $c442fa203ef9538d$var$workInProgressRootExitStatus = 0;
    $c442fa203ef9538d$var$workInProgressRootRecoverableErrors = $c442fa203ef9538d$var$workInProgressRootConcurrentErrors = null;
    $c442fa203ef9538d$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $c442fa203ef9538d$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $c442fa203ef9538d$var$entangledRenderLanes = lanes;
    $c442fa203ef9538d$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $c442fa203ef9538d$var$handleThrow(root, thrownValue) {
    $c442fa203ef9538d$var$currentlyRenderingFiber$1 = null;
    $c442fa203ef9538d$var$ReactSharedInternals.H = $c442fa203ef9538d$var$ContextOnlyDispatcher;
    thrownValue === $c442fa203ef9538d$var$SuspenseException ? (thrownValue = $c442fa203ef9538d$var$getSuspendedThenable(), $c442fa203ef9538d$var$workInProgressSuspendedReason = 3) : thrownValue === $c442fa203ef9538d$var$SuspenseyCommitException ? (thrownValue = $c442fa203ef9538d$var$getSuspendedThenable(), $c442fa203ef9538d$var$workInProgressSuspendedReason = 4) : $c442fa203ef9538d$var$workInProgressSuspendedReason = thrownValue === $c442fa203ef9538d$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $c442fa203ef9538d$var$workInProgressThrownValue = thrownValue;
    null === $c442fa203ef9538d$var$workInProgress && ($c442fa203ef9538d$var$workInProgressRootExitStatus = 1, $c442fa203ef9538d$var$logUncaughtError(root, $c442fa203ef9538d$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $c442fa203ef9538d$var$pushDispatcher() {
    var prevDispatcher = $c442fa203ef9538d$var$ReactSharedInternals.H;
    $c442fa203ef9538d$var$ReactSharedInternals.H = $c442fa203ef9538d$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $c442fa203ef9538d$var$ContextOnlyDispatcher : prevDispatcher;
}
function $c442fa203ef9538d$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $c442fa203ef9538d$var$ReactSharedInternals.A;
    $c442fa203ef9538d$var$ReactSharedInternals.A = $c442fa203ef9538d$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $c442fa203ef9538d$var$renderDidSuspendDelayIfPossible() {
    $c442fa203ef9538d$var$workInProgressRootExitStatus = 4;
    $c442fa203ef9538d$var$workInProgressRootDidSkipSuspendedSiblings || ($c442fa203ef9538d$var$workInProgressRootRenderLanes & 4194176) !== $c442fa203ef9538d$var$workInProgressRootRenderLanes && null !== $c442fa203ef9538d$var$suspenseHandlerStackCursor.current || ($c442fa203ef9538d$var$workInProgressRootIsPrerendering = !0);
    0 === ($c442fa203ef9538d$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($c442fa203ef9538d$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $c442fa203ef9538d$var$workInProgressRoot || $c442fa203ef9538d$var$markRootSuspended($c442fa203ef9538d$var$workInProgressRoot, $c442fa203ef9538d$var$workInProgressRootRenderLanes, $c442fa203ef9538d$var$workInProgressDeferredLane, !1);
}
function $c442fa203ef9538d$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $c442fa203ef9538d$var$executionContext;
    $c442fa203ef9538d$var$executionContext |= 2;
    var prevDispatcher = $c442fa203ef9538d$var$pushDispatcher(), prevAsyncDispatcher = $c442fa203ef9538d$var$pushAsyncDispatcher();
    if ($c442fa203ef9538d$var$workInProgressRoot !== root || $c442fa203ef9538d$var$workInProgressRootRenderLanes !== lanes) $c442fa203ef9538d$var$workInProgressTransitions = null, $c442fa203ef9538d$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $c442fa203ef9538d$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $c442fa203ef9538d$var$workInProgressSuspendedReason && null !== $c442fa203ef9538d$var$workInProgress) {
            var unitOfWork = $c442fa203ef9538d$var$workInProgress, thrownValue = $c442fa203ef9538d$var$workInProgressThrownValue;
            switch($c442fa203ef9538d$var$workInProgressSuspendedReason){
                case 8:
                    $c442fa203ef9538d$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $c442fa203ef9538d$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $c442fa203ef9538d$var$workInProgressSuspendedReason;
                    $c442fa203ef9538d$var$workInProgressSuspendedReason = 0;
                    $c442fa203ef9538d$var$workInProgressThrownValue = null;
                    $c442fa203ef9538d$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $c442fa203ef9538d$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $c442fa203ef9538d$var$workInProgressSuspendedReason, $c442fa203ef9538d$var$workInProgressSuspendedReason = 0, $c442fa203ef9538d$var$workInProgressThrownValue = null, $c442fa203ef9538d$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $c442fa203ef9538d$var$workLoopSync();
        exitStatus = $c442fa203ef9538d$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $c442fa203ef9538d$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $c442fa203ef9538d$var$lastContextDependency = $c442fa203ef9538d$var$currentlyRenderingFiber = null;
    $c442fa203ef9538d$var$executionContext = prevExecutionContext;
    $c442fa203ef9538d$var$ReactSharedInternals.H = prevDispatcher;
    $c442fa203ef9538d$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $c442fa203ef9538d$var$workInProgress && ($c442fa203ef9538d$var$workInProgressRoot = null, $c442fa203ef9538d$var$workInProgressRootRenderLanes = 0, $c442fa203ef9538d$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $c442fa203ef9538d$var$workLoopSync() {
    for(; null !== $c442fa203ef9538d$var$workInProgress;)$c442fa203ef9538d$var$performUnitOfWork($c442fa203ef9538d$var$workInProgress);
}
function $c442fa203ef9538d$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $c442fa203ef9538d$var$executionContext;
    $c442fa203ef9538d$var$executionContext |= 2;
    var prevDispatcher = $c442fa203ef9538d$var$pushDispatcher(), prevAsyncDispatcher = $c442fa203ef9538d$var$pushAsyncDispatcher();
    $c442fa203ef9538d$var$workInProgressRoot !== root || $c442fa203ef9538d$var$workInProgressRootRenderLanes !== lanes ? ($c442fa203ef9538d$var$workInProgressTransitions = null, $c442fa203ef9538d$var$workInProgressRootRenderTargetTime = $c442fa203ef9538d$var$now() + 500, $c442fa203ef9538d$var$prepareFreshStack(root, lanes)) : $c442fa203ef9538d$var$workInProgressRootIsPrerendering = $c442fa203ef9538d$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $c442fa203ef9538d$var$workInProgressSuspendedReason && null !== $c442fa203ef9538d$var$workInProgress) {
            lanes = $c442fa203ef9538d$var$workInProgress;
            var thrownValue = $c442fa203ef9538d$var$workInProgressThrownValue;
            b: switch($c442fa203ef9538d$var$workInProgressSuspendedReason){
                case 1:
                    $c442fa203ef9538d$var$workInProgressSuspendedReason = 0;
                    $c442fa203ef9538d$var$workInProgressThrownValue = null;
                    $c442fa203ef9538d$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($c442fa203ef9538d$var$isThenableResolved(thrownValue)) {
                        $c442fa203ef9538d$var$workInProgressSuspendedReason = 0;
                        $c442fa203ef9538d$var$workInProgressThrownValue = null;
                        $c442fa203ef9538d$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $c442fa203ef9538d$var$workInProgressSuspendedReason && $c442fa203ef9538d$var$workInProgressRoot === root && ($c442fa203ef9538d$var$workInProgressSuspendedReason = 7);
                        $c442fa203ef9538d$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $c442fa203ef9538d$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $c442fa203ef9538d$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $c442fa203ef9538d$var$isThenableResolved(thrownValue) ? ($c442fa203ef9538d$var$workInProgressSuspendedReason = 0, $c442fa203ef9538d$var$workInProgressThrownValue = null, $c442fa203ef9538d$var$replaySuspendedUnitOfWork(lanes)) : ($c442fa203ef9538d$var$workInProgressSuspendedReason = 0, $c442fa203ef9538d$var$workInProgressThrownValue = null, $c442fa203ef9538d$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($c442fa203ef9538d$var$workInProgress.tag){
                        case 26:
                            resource = $c442fa203ef9538d$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $c442fa203ef9538d$var$workInProgress;
                            if (resource ? $c442fa203ef9538d$var$preloadResource(resource) : 1) {
                                $c442fa203ef9538d$var$workInProgressSuspendedReason = 0;
                                $c442fa203ef9538d$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $c442fa203ef9538d$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($c442fa203ef9538d$var$workInProgress = returnFiber, $c442fa203ef9538d$var$completeUnitOfWork(returnFiber)) : $c442fa203ef9538d$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $c442fa203ef9538d$var$workInProgressSuspendedReason = 0;
                    $c442fa203ef9538d$var$workInProgressThrownValue = null;
                    $c442fa203ef9538d$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $c442fa203ef9538d$var$workInProgressSuspendedReason = 0;
                    $c442fa203ef9538d$var$workInProgressThrownValue = null;
                    $c442fa203ef9538d$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $c442fa203ef9538d$var$resetWorkInProgressStack();
                    $c442fa203ef9538d$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($c442fa203ef9538d$var$formatProdErrorMessage(462));
            }
        }
        $c442fa203ef9538d$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $c442fa203ef9538d$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $c442fa203ef9538d$var$lastContextDependency = $c442fa203ef9538d$var$currentlyRenderingFiber = null;
    $c442fa203ef9538d$var$ReactSharedInternals.H = prevDispatcher;
    $c442fa203ef9538d$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $c442fa203ef9538d$var$executionContext = prevExecutionContext;
    if (null !== $c442fa203ef9538d$var$workInProgress) return 0;
    $c442fa203ef9538d$var$workInProgressRoot = null;
    $c442fa203ef9538d$var$workInProgressRootRenderLanes = 0;
    $c442fa203ef9538d$var$finishQueueingConcurrentUpdates();
    return $c442fa203ef9538d$var$workInProgressRootExitStatus;
}
function $c442fa203ef9538d$var$workLoopConcurrent() {
    for(; null !== $c442fa203ef9538d$var$workInProgress && !$c442fa203ef9538d$var$shouldYield();)$c442fa203ef9538d$var$performUnitOfWork($c442fa203ef9538d$var$workInProgress);
}
function $c442fa203ef9538d$var$performUnitOfWork(unitOfWork) {
    var next = $c442fa203ef9538d$var$beginWork(unitOfWork.alternate, unitOfWork, $c442fa203ef9538d$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c442fa203ef9538d$var$completeUnitOfWork(unitOfWork) : $c442fa203ef9538d$var$workInProgress = next;
}
function $c442fa203ef9538d$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $c442fa203ef9538d$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $c442fa203ef9538d$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $c442fa203ef9538d$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $c442fa203ef9538d$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $c442fa203ef9538d$var$resetHooksOnUnwind(next);
        default:
            $c442fa203ef9538d$var$unwindInterruptedWork(current, next), next = $c442fa203ef9538d$var$workInProgress = $c442fa203ef9538d$var$resetWorkInProgress(next, $c442fa203ef9538d$var$entangledRenderLanes), next = $c442fa203ef9538d$var$beginWork(current, next, $c442fa203ef9538d$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c442fa203ef9538d$var$completeUnitOfWork(unitOfWork) : $c442fa203ef9538d$var$workInProgress = next;
}
function $c442fa203ef9538d$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $c442fa203ef9538d$var$lastContextDependency = $c442fa203ef9538d$var$currentlyRenderingFiber = null;
    $c442fa203ef9538d$var$resetHooksOnUnwind(unitOfWork);
    $c442fa203ef9538d$var$thenableState$1 = null;
    $c442fa203ef9538d$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($c442fa203ef9538d$var$throwException(root, returnFiber, unitOfWork, thrownValue, $c442fa203ef9538d$var$workInProgressRootRenderLanes)) {
            $c442fa203ef9538d$var$workInProgressRootExitStatus = 1;
            $c442fa203ef9538d$var$logUncaughtError(root, $c442fa203ef9538d$var$createCapturedValueAtFiber(thrownValue, root.current));
            $c442fa203ef9538d$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $c442fa203ef9538d$var$workInProgress = returnFiber, error;
        $c442fa203ef9538d$var$workInProgressRootExitStatus = 1;
        $c442fa203ef9538d$var$logUncaughtError(root, $c442fa203ef9538d$var$createCapturedValueAtFiber(thrownValue, root.current));
        $c442fa203ef9538d$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($c442fa203ef9538d$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($c442fa203ef9538d$var$workInProgressRootIsPrerendering || 0 !== ($c442fa203ef9538d$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($c442fa203ef9538d$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $c442fa203ef9538d$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $c442fa203ef9538d$var$unwindUnitOfWork(unitOfWork, root);
    } else $c442fa203ef9538d$var$completeUnitOfWork(unitOfWork);
}
function $c442fa203ef9538d$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $c442fa203ef9538d$var$unwindUnitOfWork(completedWork, $c442fa203ef9538d$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $c442fa203ef9538d$var$completeWork(completedWork.alternate, completedWork, $c442fa203ef9538d$var$entangledRenderLanes);
        if (null !== next) {
            $c442fa203ef9538d$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $c442fa203ef9538d$var$workInProgress = completedWork;
            return;
        }
        $c442fa203ef9538d$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $c442fa203ef9538d$var$workInProgressRootExitStatus && ($c442fa203ef9538d$var$workInProgressRootExitStatus = 5);
}
function $c442fa203ef9538d$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $c442fa203ef9538d$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $c442fa203ef9538d$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $c442fa203ef9538d$var$workInProgress = unitOfWork;
            return;
        }
        $c442fa203ef9538d$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $c442fa203ef9538d$var$workInProgressRootExitStatus = 6;
    $c442fa203ef9538d$var$workInProgress = null;
}
function $c442fa203ef9538d$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $c442fa203ef9538d$var$ReactSharedInternals.T, previousUpdateLanePriority = $c442fa203ef9538d$var$ReactDOMSharedInternals.p;
    try {
        $c442fa203ef9538d$var$ReactDOMSharedInternals.p = 2, $c442fa203ef9538d$var$ReactSharedInternals.T = null, $c442fa203ef9538d$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $c442fa203ef9538d$var$ReactSharedInternals.T = prevTransition, $c442fa203ef9538d$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $c442fa203ef9538d$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $c442fa203ef9538d$var$flushPassiveEffects();
    while (null !== $c442fa203ef9538d$var$rootWithPendingPassiveEffects);
    if (0 !== ($c442fa203ef9538d$var$executionContext & 6)) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $c442fa203ef9538d$var$concurrentlyUpdatedLanes;
    $c442fa203ef9538d$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $c442fa203ef9538d$var$workInProgressRoot && ($c442fa203ef9538d$var$workInProgress = $c442fa203ef9538d$var$workInProgressRoot = null, $c442fa203ef9538d$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $c442fa203ef9538d$var$rootDoesHavePassiveEffects || ($c442fa203ef9538d$var$rootDoesHavePassiveEffects = !0, $c442fa203ef9538d$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $c442fa203ef9538d$var$pendingPassiveTransitions = transitions, $c442fa203ef9538d$var$scheduleCallback$1($c442fa203ef9538d$var$NormalPriority$1, function() {
        $c442fa203ef9538d$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $c442fa203ef9538d$var$ReactSharedInternals.T, $c442fa203ef9538d$var$ReactSharedInternals.T = null, spawnedLane = $c442fa203ef9538d$var$ReactDOMSharedInternals.p, $c442fa203ef9538d$var$ReactDOMSharedInternals.p = 2, updatedLanes = $c442fa203ef9538d$var$executionContext, $c442fa203ef9538d$var$executionContext |= 4, $c442fa203ef9538d$var$commitBeforeMutationEffects(root, finishedWork), $c442fa203ef9538d$var$commitMutationEffectsOnFiber(finishedWork, root), $c442fa203ef9538d$var$restoreSelection($c442fa203ef9538d$var$selectionInformation, root.containerInfo), $c442fa203ef9538d$var$_enabled = !!$c442fa203ef9538d$var$eventsEnabled, $c442fa203ef9538d$var$selectionInformation = $c442fa203ef9538d$var$eventsEnabled = null, root.current = finishedWork, $c442fa203ef9538d$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $c442fa203ef9538d$var$requestPaint(), $c442fa203ef9538d$var$executionContext = updatedLanes, $c442fa203ef9538d$var$ReactDOMSharedInternals.p = spawnedLane, $c442fa203ef9538d$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $c442fa203ef9538d$var$rootDoesHavePassiveEffects ? ($c442fa203ef9538d$var$rootDoesHavePassiveEffects = !1, $c442fa203ef9538d$var$rootWithPendingPassiveEffects = root, $c442fa203ef9538d$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $c442fa203ef9538d$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($c442fa203ef9538d$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $c442fa203ef9538d$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $c442fa203ef9538d$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($c442fa203ef9538d$var$pendingPassiveEffectsLanes & 3) && $c442fa203ef9538d$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $c442fa203ef9538d$var$rootWithNestedUpdates ? $c442fa203ef9538d$var$nestedUpdateCount++ : ($c442fa203ef9538d$var$nestedUpdateCount = 0, $c442fa203ef9538d$var$rootWithNestedUpdates = root) : $c442fa203ef9538d$var$nestedUpdateCount = 0;
    $c442fa203ef9538d$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $c442fa203ef9538d$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $c442fa203ef9538d$var$releaseCache(remainingLanes)));
}
function $c442fa203ef9538d$var$flushPassiveEffects() {
    if (null !== $c442fa203ef9538d$var$rootWithPendingPassiveEffects) {
        var root$170 = $c442fa203ef9538d$var$rootWithPendingPassiveEffects, remainingLanes = $c442fa203ef9538d$var$pendingPassiveEffectsRemainingLanes;
        $c442fa203ef9538d$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $c442fa203ef9538d$var$lanesToEventPriority($c442fa203ef9538d$var$pendingPassiveEffectsLanes), prevTransition = $c442fa203ef9538d$var$ReactSharedInternals.T, previousPriority = $c442fa203ef9538d$var$ReactDOMSharedInternals.p;
        try {
            $c442fa203ef9538d$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $c442fa203ef9538d$var$ReactSharedInternals.T = null;
            if (null === $c442fa203ef9538d$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $c442fa203ef9538d$var$pendingPassiveTransitions;
                $c442fa203ef9538d$var$pendingPassiveTransitions = null;
                var root = $c442fa203ef9538d$var$rootWithPendingPassiveEffects, lanes = $c442fa203ef9538d$var$pendingPassiveEffectsLanes;
                $c442fa203ef9538d$var$rootWithPendingPassiveEffects = null;
                $c442fa203ef9538d$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($c442fa203ef9538d$var$executionContext & 6)) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(331));
                var prevExecutionContext = $c442fa203ef9538d$var$executionContext;
                $c442fa203ef9538d$var$executionContext |= 4;
                $c442fa203ef9538d$var$commitPassiveUnmountOnFiber(root.current);
                $c442fa203ef9538d$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $c442fa203ef9538d$var$executionContext = prevExecutionContext;
                $c442fa203ef9538d$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($c442fa203ef9538d$var$injectedHook && "function" === typeof $c442fa203ef9538d$var$injectedHook.onPostCommitFiberRoot) try {
                    $c442fa203ef9538d$var$injectedHook.onPostCommitFiberRoot($c442fa203ef9538d$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $c442fa203ef9538d$var$ReactDOMSharedInternals.p = previousPriority, $c442fa203ef9538d$var$ReactSharedInternals.T = prevTransition, $c442fa203ef9538d$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $c442fa203ef9538d$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $c442fa203ef9538d$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $c442fa203ef9538d$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $c442fa203ef9538d$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($c442fa203ef9538d$var$markRootUpdated$1(rootFiber, 2), $c442fa203ef9538d$var$ensureRootIsScheduled(rootFiber));
}
function $c442fa203ef9538d$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $c442fa203ef9538d$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $c442fa203ef9538d$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $c442fa203ef9538d$var$legacyErrorBoundariesThatAlreadyFailed || !$c442fa203ef9538d$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $c442fa203ef9538d$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $c442fa203ef9538d$var$createClassErrorUpdate(2);
                instance = $c442fa203ef9538d$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($c442fa203ef9538d$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $c442fa203ef9538d$var$markRootUpdated$1(instance, 2), $c442fa203ef9538d$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $c442fa203ef9538d$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $c442fa203ef9538d$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($c442fa203ef9538d$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $c442fa203ef9538d$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $c442fa203ef9538d$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $c442fa203ef9538d$var$workInProgressRoot === root && ($c442fa203ef9538d$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $c442fa203ef9538d$var$workInProgressRootExitStatus || 3 === $c442fa203ef9538d$var$workInProgressRootExitStatus && ($c442fa203ef9538d$var$workInProgressRootRenderLanes & 62914560) === $c442fa203ef9538d$var$workInProgressRootRenderLanes && 300 > $c442fa203ef9538d$var$now() - $c442fa203ef9538d$var$globalMostRecentFallbackTime ? 0 === ($c442fa203ef9538d$var$executionContext & 2) && $c442fa203ef9538d$var$prepareFreshStack(root, 0) : $c442fa203ef9538d$var$workInProgressRootPingedLanes |= pingedLanes, $c442fa203ef9538d$var$workInProgressSuspendedRetryLanes === $c442fa203ef9538d$var$workInProgressRootRenderLanes && ($c442fa203ef9538d$var$workInProgressSuspendedRetryLanes = 0));
    $c442fa203ef9538d$var$ensureRootIsScheduled(root);
}
function $c442fa203ef9538d$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $c442fa203ef9538d$var$claimNextRetryLane());
    boundaryFiber = $c442fa203ef9538d$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($c442fa203ef9538d$var$markRootUpdated$1(boundaryFiber, retryLane), $c442fa203ef9538d$var$ensureRootIsScheduled(boundaryFiber));
}
function $c442fa203ef9538d$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $c442fa203ef9538d$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c442fa203ef9538d$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($c442fa203ef9538d$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $c442fa203ef9538d$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c442fa203ef9538d$var$scheduleCallback$1(priorityLevel, callback) {
    return $c442fa203ef9538d$var$scheduleCallback$3(priorityLevel, callback);
}
var $c442fa203ef9538d$var$firstScheduledRoot = null, $c442fa203ef9538d$var$lastScheduledRoot = null, $c442fa203ef9538d$var$didScheduleMicrotask = !1, $c442fa203ef9538d$var$mightHavePendingSyncWork = !1, $c442fa203ef9538d$var$isFlushingWork = !1, $c442fa203ef9538d$var$currentEventTransitionLane = 0;
function $c442fa203ef9538d$var$ensureRootIsScheduled(root) {
    root !== $c442fa203ef9538d$var$lastScheduledRoot && null === root.next && (null === $c442fa203ef9538d$var$lastScheduledRoot ? $c442fa203ef9538d$var$firstScheduledRoot = $c442fa203ef9538d$var$lastScheduledRoot = root : $c442fa203ef9538d$var$lastScheduledRoot = $c442fa203ef9538d$var$lastScheduledRoot.next = root);
    $c442fa203ef9538d$var$mightHavePendingSyncWork = !0;
    $c442fa203ef9538d$var$didScheduleMicrotask || ($c442fa203ef9538d$var$didScheduleMicrotask = !0, $c442fa203ef9538d$var$scheduleImmediateTask($c442fa203ef9538d$var$processRootScheduleInMicrotask));
}
function $c442fa203ef9538d$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$c442fa203ef9538d$var$isFlushingWork && $c442fa203ef9538d$var$mightHavePendingSyncWork) {
        $c442fa203ef9538d$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $c442fa203ef9538d$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $c442fa203ef9538d$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $c442fa203ef9538d$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $c442fa203ef9538d$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $c442fa203ef9538d$var$getNextLanes(root$172, root$172 === $c442fa203ef9538d$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $c442fa203ef9538d$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $c442fa203ef9538d$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $c442fa203ef9538d$var$isFlushingWork = !1;
    }
}
function $c442fa203ef9538d$var$processRootScheduleInMicrotask() {
    $c442fa203ef9538d$var$mightHavePendingSyncWork = $c442fa203ef9538d$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $c442fa203ef9538d$var$currentEventTransitionLane && ($c442fa203ef9538d$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $c442fa203ef9538d$var$currentEventTransitionLane), $c442fa203ef9538d$var$currentEventTransitionLane = 0);
    for(var currentTime = $c442fa203ef9538d$var$now(), prev = null, root = $c442fa203ef9538d$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $c442fa203ef9538d$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $c442fa203ef9538d$var$firstScheduledRoot = next : prev.next = next, null === next && ($c442fa203ef9538d$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $c442fa203ef9538d$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $c442fa203ef9538d$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $c442fa203ef9538d$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $c442fa203ef9538d$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $c442fa203ef9538d$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $c442fa203ef9538d$var$workInProgressRoot;
    suspendedLanes = $c442fa203ef9538d$var$workInProgressRootRenderLanes;
    suspendedLanes = $c442fa203ef9538d$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $c442fa203ef9538d$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $c442fa203ef9538d$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $c442fa203ef9538d$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $c442fa203ef9538d$var$cancelCallback$1(pingedLanes);
        switch($c442fa203ef9538d$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $c442fa203ef9538d$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $c442fa203ef9538d$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $c442fa203ef9538d$var$IdlePriority;
                break;
            default:
                suspendedLanes = $c442fa203ef9538d$var$NormalPriority$1;
        }
        pingedLanes = $c442fa203ef9538d$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $c442fa203ef9538d$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $c442fa203ef9538d$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $c442fa203ef9538d$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($c442fa203ef9538d$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $c442fa203ef9538d$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $c442fa203ef9538d$var$getNextLanes(root, root === $c442fa203ef9538d$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $c442fa203ef9538d$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $c442fa203ef9538d$var$scheduleTaskForRootDuringMicrotask(root, $c442fa203ef9538d$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $c442fa203ef9538d$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $c442fa203ef9538d$var$performSyncWorkOnRoot(root, lanes) {
    if ($c442fa203ef9538d$var$flushPassiveEffects()) return null;
    $c442fa203ef9538d$var$performWorkOnRoot(root, lanes, !0);
}
function $c442fa203ef9538d$var$scheduleImmediateTask(cb) {
    $c442fa203ef9538d$var$scheduleMicrotask(function() {
        0 !== ($c442fa203ef9538d$var$executionContext & 6) ? $c442fa203ef9538d$var$scheduleCallback$3($c442fa203ef9538d$var$ImmediatePriority, cb) : cb();
    });
}
function $c442fa203ef9538d$var$requestTransitionLane() {
    0 === $c442fa203ef9538d$var$currentEventTransitionLane && ($c442fa203ef9538d$var$currentEventTransitionLane = $c442fa203ef9538d$var$claimNextTransitionLane());
    return $c442fa203ef9538d$var$currentEventTransitionLane;
}
function $c442fa203ef9538d$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $c442fa203ef9538d$var$sanitizeURL("" + actionProp);
}
function $c442fa203ef9538d$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $c442fa203ef9538d$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $c442fa203ef9538d$var$coerceFormActionProp((nativeEventTarget[$c442fa203ef9538d$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$c442fa203ef9538d$var$internalPropsKey] || null) ? $c442fa203ef9538d$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $c442fa203ef9538d$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $c442fa203ef9538d$var$currentEventTransitionLane) {
                                var formData = submitter ? $c442fa203ef9538d$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $c442fa203ef9538d$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $c442fa203ef9538d$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $c442fa203ef9538d$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $c442fa203ef9538d$var$i$jscomp$inline_1439 = 0; $c442fa203ef9538d$var$i$jscomp$inline_1439 < $c442fa203ef9538d$var$simpleEventPluginEvents.length; $c442fa203ef9538d$var$i$jscomp$inline_1439++){
    var $c442fa203ef9538d$var$eventName$jscomp$inline_1440 = $c442fa203ef9538d$var$simpleEventPluginEvents[$c442fa203ef9538d$var$i$jscomp$inline_1439], $c442fa203ef9538d$var$domEventName$jscomp$inline_1441 = $c442fa203ef9538d$var$eventName$jscomp$inline_1440.toLowerCase(), $c442fa203ef9538d$var$capitalizedEvent$jscomp$inline_1442 = $c442fa203ef9538d$var$eventName$jscomp$inline_1440[0].toUpperCase() + $c442fa203ef9538d$var$eventName$jscomp$inline_1440.slice(1);
    $c442fa203ef9538d$var$registerSimpleEvent($c442fa203ef9538d$var$domEventName$jscomp$inline_1441, "on" + $c442fa203ef9538d$var$capitalizedEvent$jscomp$inline_1442);
}
$c442fa203ef9538d$var$registerSimpleEvent($c442fa203ef9538d$var$ANIMATION_END, "onAnimationEnd");
$c442fa203ef9538d$var$registerSimpleEvent($c442fa203ef9538d$var$ANIMATION_ITERATION, "onAnimationIteration");
$c442fa203ef9538d$var$registerSimpleEvent($c442fa203ef9538d$var$ANIMATION_START, "onAnimationStart");
$c442fa203ef9538d$var$registerSimpleEvent("dblclick", "onDoubleClick");
$c442fa203ef9538d$var$registerSimpleEvent("focusin", "onFocus");
$c442fa203ef9538d$var$registerSimpleEvent("focusout", "onBlur");
$c442fa203ef9538d$var$registerSimpleEvent($c442fa203ef9538d$var$TRANSITION_RUN, "onTransitionRun");
$c442fa203ef9538d$var$registerSimpleEvent($c442fa203ef9538d$var$TRANSITION_START, "onTransitionStart");
$c442fa203ef9538d$var$registerSimpleEvent($c442fa203ef9538d$var$TRANSITION_CANCEL, "onTransitionCancel");
$c442fa203ef9538d$var$registerSimpleEvent($c442fa203ef9538d$var$TRANSITION_END, "onTransitionEnd");
$c442fa203ef9538d$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c442fa203ef9538d$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c442fa203ef9538d$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c442fa203ef9538d$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c442fa203ef9538d$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c442fa203ef9538d$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c442fa203ef9538d$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c442fa203ef9538d$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c442fa203ef9538d$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c442fa203ef9538d$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c442fa203ef9538d$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c442fa203ef9538d$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($c442fa203ef9538d$var$mediaEventTypes));
function $c442fa203ef9538d$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c442fa203ef9538d$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c442fa203ef9538d$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $c442fa203ef9538d$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$c442fa203ef9538d$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$c442fa203ef9538d$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($c442fa203ef9538d$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $c442fa203ef9538d$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $c442fa203ef9538d$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $c442fa203ef9538d$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $c442fa203ef9538d$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$c442fa203ef9538d$var$listeningMarker]) {
        rootContainerElement[$c442fa203ef9538d$var$listeningMarker] = !0;
        $c442fa203ef9538d$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($c442fa203ef9538d$var$nonDelegatedEvents.has(domEventName) || $c442fa203ef9538d$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $c442fa203ef9538d$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$c442fa203ef9538d$var$listeningMarker] || (ownerDocument[$c442fa203ef9538d$var$listeningMarker] = !0, $c442fa203ef9538d$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $c442fa203ef9538d$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($c442fa203ef9538d$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $c442fa203ef9538d$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $c442fa203ef9538d$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $c442fa203ef9538d$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$c442fa203ef9538d$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $c442fa203ef9538d$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $c442fa203ef9538d$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $c442fa203ef9538d$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $c442fa203ef9538d$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $c442fa203ef9538d$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $c442fa203ef9538d$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticTouchEvent;
                        break;
                    case $c442fa203ef9538d$var$ANIMATION_END:
                    case $c442fa203ef9538d$var$ANIMATION_ITERATION:
                    case $c442fa203ef9538d$var$ANIMATION_START:
                        SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticAnimationEvent;
                        break;
                    case $c442fa203ef9538d$var$TRANSITION_END:
                        SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $c442fa203ef9538d$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $c442fa203ef9538d$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($c442fa203ef9538d$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $c442fa203ef9538d$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($c442fa203ef9538d$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$c442fa203ef9538d$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $c442fa203ef9538d$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $c442fa203ef9538d$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $c442fa203ef9538d$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $c442fa203ef9538d$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $c442fa203ef9538d$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $c442fa203ef9538d$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $c442fa203ef9538d$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $c442fa203ef9538d$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $c442fa203ef9538d$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $c442fa203ef9538d$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $c442fa203ef9538d$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $c442fa203ef9538d$var$getParent(inCapturePhase);
                                reactEventName = $c442fa203ef9538d$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $c442fa203ef9538d$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $c442fa203ef9538d$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $c442fa203ef9538d$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $c442fa203ef9538d$var$getTargetInstForChangeEvent;
                else if ($c442fa203ef9538d$var$isTextInputElement(reactName)) {
                    if ($c442fa203ef9538d$var$isInputEventSupported) getTargetInstFunc = $c442fa203ef9538d$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $c442fa203ef9538d$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $c442fa203ef9538d$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $c442fa203ef9538d$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $c442fa203ef9538d$var$getTargetInstForChangeEvent) : getTargetInstFunc = $c442fa203ef9538d$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $c442fa203ef9538d$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $c442fa203ef9538d$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $c442fa203ef9538d$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($c442fa203ef9538d$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $c442fa203ef9538d$var$activeElement = handleEventFunc, $c442fa203ef9538d$var$activeElementInst = targetInst, $c442fa203ef9538d$var$lastSelection = null;
                    break;
                case "focusout":
                    $c442fa203ef9538d$var$lastSelection = $c442fa203ef9538d$var$activeElementInst = $c442fa203ef9538d$var$activeElement = null;
                    break;
                case "mousedown":
                    $c442fa203ef9538d$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c442fa203ef9538d$var$mouseDown = !1;
                    $c442fa203ef9538d$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($c442fa203ef9538d$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $c442fa203ef9538d$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($c442fa203ef9538d$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $c442fa203ef9538d$var$isComposing ? $c442fa203ef9538d$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($c442fa203ef9538d$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($c442fa203ef9538d$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $c442fa203ef9538d$var$isComposing && (fallbackData = $c442fa203ef9538d$var$getData()) : ($c442fa203ef9538d$var$root = nativeEventTarget, $c442fa203ef9538d$var$startText = "value" in $c442fa203ef9538d$var$root ? $c442fa203ef9538d$var$root.value : $c442fa203ef9538d$var$root.textContent, $c442fa203ef9538d$var$isComposing = !0)), handleEventFunc = $c442fa203ef9538d$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $c442fa203ef9538d$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $c442fa203ef9538d$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $c442fa203ef9538d$var$canUseTextInputEvent ? $c442fa203ef9538d$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $c442fa203ef9538d$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $c442fa203ef9538d$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $c442fa203ef9538d$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $c442fa203ef9538d$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $c442fa203ef9538d$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $c442fa203ef9538d$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $c442fa203ef9538d$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $c442fa203ef9538d$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($c442fa203ef9538d$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $c442fa203ef9538d$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($c442fa203ef9538d$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $c442fa203ef9538d$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $c442fa203ef9538d$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $c442fa203ef9538d$var$getListener(target, registrationName), null != stateNode && listeners.unshift($c442fa203ef9538d$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $c442fa203ef9538d$var$getListener(target, registrationName), null != stateNode && listeners.push($c442fa203ef9538d$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $c442fa203ef9538d$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $c442fa203ef9538d$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $c442fa203ef9538d$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($c442fa203ef9538d$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($c442fa203ef9538d$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $c442fa203ef9538d$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $c442fa203ef9538d$var$normalizeMarkupForTextOrAttribute(clientText);
    return $c442fa203ef9538d$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $c442fa203ef9538d$var$noop$1() {}
function $c442fa203ef9538d$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $c442fa203ef9538d$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $c442fa203ef9538d$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $c442fa203ef9538d$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $c442fa203ef9538d$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $c442fa203ef9538d$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $c442fa203ef9538d$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $c442fa203ef9538d$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c442fa203ef9538d$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $c442fa203ef9538d$var$setProp(domElement, tag, "name", props.name, props, null), $c442fa203ef9538d$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $c442fa203ef9538d$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $c442fa203ef9538d$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($c442fa203ef9538d$var$setProp(domElement, tag, "encType", props.encType, props, null), $c442fa203ef9538d$var$setProp(domElement, tag, "method", props.method, props, null), $c442fa203ef9538d$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c442fa203ef9538d$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c442fa203ef9538d$var$noop$1);
            break;
        case "onScroll":
            null != value && $c442fa203ef9538d$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $c442fa203ef9538d$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $c442fa203ef9538d$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("toggle", domElement);
            $c442fa203ef9538d$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $c442fa203ef9538d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $c442fa203ef9538d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $c442fa203ef9538d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $c442fa203ef9538d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $c442fa203ef9538d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $c442fa203ef9538d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $c442fa203ef9538d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $c442fa203ef9538d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $c442fa203ef9538d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $c442fa203ef9538d$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $c442fa203ef9538d$var$aliases.get(key) || key, $c442fa203ef9538d$var$setValueForAttribute(domElement, key, value);
    }
}
function $c442fa203ef9538d$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $c442fa203ef9538d$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $c442fa203ef9538d$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $c442fa203ef9538d$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $c442fa203ef9538d$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $c442fa203ef9538d$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c442fa203ef9538d$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$c442fa203ef9538d$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$c442fa203ef9538d$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $c442fa203ef9538d$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $c442fa203ef9538d$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("error", domElement);
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($c442fa203ef9538d$var$formatProdErrorMessage(137, tag));
                    default:
                        $c442fa203ef9538d$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $c442fa203ef9538d$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $c442fa203ef9538d$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $c442fa203ef9538d$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $c442fa203ef9538d$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $c442fa203ef9538d$var$track(domElement);
            return;
        case "select":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $c442fa203ef9538d$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $c442fa203ef9538d$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $c442fa203ef9538d$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(91));
                    break;
                default:
                    $c442fa203ef9538d$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $c442fa203ef9538d$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $c442fa203ef9538d$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $c442fa203ef9538d$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("cancel", domElement);
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $c442fa203ef9538d$var$mediaEventTypes.length; hasSrc++)$c442fa203ef9538d$var$listenToNonDelegatedEvent($c442fa203ef9538d$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("error", domElement);
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $c442fa203ef9538d$var$listenToNonDelegatedEvent("error", domElement), $c442fa203ef9538d$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($c442fa203ef9538d$var$formatProdErrorMessage(137, tag));
                default:
                    $c442fa203ef9538d$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($c442fa203ef9538d$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $c442fa203ef9538d$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $c442fa203ef9538d$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $c442fa203ef9538d$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $c442fa203ef9538d$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $c442fa203ef9538d$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $c442fa203ef9538d$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $c442fa203ef9538d$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $c442fa203ef9538d$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $c442fa203ef9538d$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $c442fa203ef9538d$var$updateOptions(domElement, !!lastProps, tag, !0) : $c442fa203ef9538d$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $c442fa203ef9538d$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $c442fa203ef9538d$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $c442fa203ef9538d$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $c442fa203ef9538d$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $c442fa203ef9538d$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $c442fa203ef9538d$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $c442fa203ef9538d$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($c442fa203ef9538d$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $c442fa203ef9538d$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $c442fa203ef9538d$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $c442fa203ef9538d$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $c442fa203ef9538d$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $c442fa203ef9538d$var$eventsEnabled = null, $c442fa203ef9538d$var$selectionInformation = null;
function $c442fa203ef9538d$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $c442fa203ef9538d$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $c442fa203ef9538d$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $c442fa203ef9538d$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $c442fa203ef9538d$var$currentPopstateTransitionEvent = null;
function $c442fa203ef9538d$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $c442fa203ef9538d$var$currentPopstateTransitionEvent) return !1;
        $c442fa203ef9538d$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $c442fa203ef9538d$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $c442fa203ef9538d$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $c442fa203ef9538d$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $c442fa203ef9538d$var$localPromise = "function" === typeof Promise ? Promise : void 0, $c442fa203ef9538d$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c442fa203ef9538d$var$localPromise ? function(callback) {
    return $c442fa203ef9538d$var$localPromise.resolve(null).then(callback).catch($c442fa203ef9538d$var$handleErrorInNextTick);
} : $c442fa203ef9538d$var$scheduleTimeout;
function $c442fa203ef9538d$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $c442fa203ef9538d$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $c442fa203ef9538d$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $c442fa203ef9538d$var$retryIfBlockedOn(suspenseInstance);
}
function $c442fa203ef9538d$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $c442fa203ef9538d$var$clearContainerSparingly(node);
                $c442fa203ef9538d$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $c442fa203ef9538d$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$c442fa203ef9538d$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $c442fa203ef9538d$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $c442fa203ef9538d$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $c442fa203ef9538d$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $c442fa203ef9538d$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $c442fa203ef9538d$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $c442fa203ef9538d$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $c442fa203ef9538d$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($c442fa203ef9538d$var$formatProdErrorMessage(451));
    }
}
var $c442fa203ef9538d$var$preloadPropsMap = new Map(), $c442fa203ef9538d$var$preconnectsSet = new Set();
function $c442fa203ef9538d$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $c442fa203ef9538d$var$previousDispatcher = $c442fa203ef9538d$var$ReactDOMSharedInternals.d;
$c442fa203ef9538d$var$ReactDOMSharedInternals.d = {
    f: $c442fa203ef9538d$var$flushSyncWork,
    r: $c442fa203ef9538d$var$requestFormReset,
    D: $c442fa203ef9538d$var$prefetchDNS,
    C: $c442fa203ef9538d$var$preconnect,
    L: $c442fa203ef9538d$var$preload,
    m: $c442fa203ef9538d$var$preloadModule,
    X: $c442fa203ef9538d$var$preinitScript,
    S: $c442fa203ef9538d$var$preinitStyle,
    M: $c442fa203ef9538d$var$preinitModuleScript
};
function $c442fa203ef9538d$var$flushSyncWork() {
    var previousWasRendering = $c442fa203ef9538d$var$previousDispatcher.f(), wasRendering = $c442fa203ef9538d$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $c442fa203ef9538d$var$requestFormReset(form) {
    var formInst = $c442fa203ef9538d$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $c442fa203ef9538d$var$requestFormReset$1(formInst) : $c442fa203ef9538d$var$previousDispatcher.r(form);
}
var $c442fa203ef9538d$var$globalDocument = "undefined" === typeof document ? null : document;
function $c442fa203ef9538d$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $c442fa203ef9538d$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $c442fa203ef9538d$var$preconnectsSet.has(limitedEscapedHref) || ($c442fa203ef9538d$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $c442fa203ef9538d$var$setInitialProperties(href, "link", rel), $c442fa203ef9538d$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $c442fa203ef9538d$var$prefetchDNS(href) {
    $c442fa203ef9538d$var$previousDispatcher.D(href);
    $c442fa203ef9538d$var$preconnectAs("dns-prefetch", href, null);
}
function $c442fa203ef9538d$var$preconnect(href, crossOrigin) {
    $c442fa203ef9538d$var$previousDispatcher.C(href, crossOrigin);
    $c442fa203ef9538d$var$preconnectAs("preconnect", href, crossOrigin);
}
function $c442fa203ef9538d$var$preload(href, as, options) {
    $c442fa203ef9538d$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $c442fa203ef9538d$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $c442fa203ef9538d$var$getStyleKey(href);
                break;
            case "script":
                key = $c442fa203ef9538d$var$getScriptKey(href);
        }
        $c442fa203ef9538d$var$preloadPropsMap.has(key) || (href = $c442fa203ef9538d$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $c442fa203ef9538d$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($c442fa203ef9538d$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($c442fa203ef9538d$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $c442fa203ef9538d$var$setInitialProperties(as, "link", href), $c442fa203ef9538d$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $c442fa203ef9538d$var$preloadModule(href, options) {
    $c442fa203ef9538d$var$previousDispatcher.m(href, options);
    var ownerDocument = $c442fa203ef9538d$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $c442fa203ef9538d$var$getScriptKey(href);
        }
        if (!$c442fa203ef9538d$var$preloadPropsMap.has(key) && (href = $c442fa203ef9538d$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $c442fa203ef9538d$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($c442fa203ef9538d$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $c442fa203ef9538d$var$setInitialProperties(as, "link", href);
            $c442fa203ef9538d$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $c442fa203ef9538d$var$preinitStyle(href, precedence, options) {
    $c442fa203ef9538d$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $c442fa203ef9538d$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $c442fa203ef9538d$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $c442fa203ef9538d$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($c442fa203ef9538d$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $c442fa203ef9538d$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $c442fa203ef9538d$var$preloadPropsMap.get(key)) && $c442fa203ef9538d$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $c442fa203ef9538d$var$markNodeAsHoistable(link);
                $c442fa203ef9538d$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $c442fa203ef9538d$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $c442fa203ef9538d$var$preinitScript(src, options) {
    $c442fa203ef9538d$var$previousDispatcher.X(src, options);
    var ownerDocument = $c442fa203ef9538d$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c442fa203ef9538d$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c442fa203ef9538d$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c442fa203ef9538d$var$getScriptSelectorFromKey(key)), resource || (src = $c442fa203ef9538d$var$assign({
            src: src,
            async: !0
        }, options), (options = $c442fa203ef9538d$var$preloadPropsMap.get(key)) && $c442fa203ef9538d$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c442fa203ef9538d$var$markNodeAsHoistable(resource), $c442fa203ef9538d$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c442fa203ef9538d$var$preinitModuleScript(src, options) {
    $c442fa203ef9538d$var$previousDispatcher.M(src, options);
    var ownerDocument = $c442fa203ef9538d$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c442fa203ef9538d$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c442fa203ef9538d$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c442fa203ef9538d$var$getScriptSelectorFromKey(key)), resource || (src = $c442fa203ef9538d$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $c442fa203ef9538d$var$preloadPropsMap.get(key)) && $c442fa203ef9538d$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c442fa203ef9538d$var$markNodeAsHoistable(resource), $c442fa203ef9538d$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c442fa203ef9538d$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $c442fa203ef9538d$var$rootInstanceStackCursor.current) ? $c442fa203ef9538d$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $c442fa203ef9538d$var$getStyleKey(pendingProps.href), pendingProps = $c442fa203ef9538d$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $c442fa203ef9538d$var$getStyleKey(pendingProps.href);
                var styles$242 = $c442fa203ef9538d$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($c442fa203ef9538d$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $c442fa203ef9538d$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $c442fa203ef9538d$var$preloadPropsMap.set(type, pendingProps), styles$242 || $c442fa203ef9538d$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $c442fa203ef9538d$var$getScriptKey(pendingProps), pendingProps = $c442fa203ef9538d$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($c442fa203ef9538d$var$formatProdErrorMessage(444, type));
    }
}
function $c442fa203ef9538d$var$getStyleKey(href) {
    return 'href="' + $c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $c442fa203ef9538d$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $c442fa203ef9538d$var$stylesheetPropsFromRawProps(rawProps) {
    return $c442fa203ef9538d$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $c442fa203ef9538d$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $c442fa203ef9538d$var$setInitialProperties(key, "link", preloadProps), $c442fa203ef9538d$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $c442fa203ef9538d$var$getScriptKey(src) {
    return '[src="' + $c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $c442fa203ef9538d$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $c442fa203ef9538d$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $c442fa203ef9538d$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $c442fa203ef9538d$var$markNodeAsHoistable(instance), instance;
            var styleProps = $c442fa203ef9538d$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $c442fa203ef9538d$var$markNodeAsHoistable(instance);
            $c442fa203ef9538d$var$setInitialProperties(instance, "style", styleProps);
            $c442fa203ef9538d$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $c442fa203ef9538d$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($c442fa203ef9538d$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $c442fa203ef9538d$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $c442fa203ef9538d$var$stylesheetPropsFromRawProps(props);
            (styleProps = $c442fa203ef9538d$var$preloadPropsMap.get(styleProps)) && $c442fa203ef9538d$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $c442fa203ef9538d$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c442fa203ef9538d$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $c442fa203ef9538d$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $c442fa203ef9538d$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($c442fa203ef9538d$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $c442fa203ef9538d$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $c442fa203ef9538d$var$preloadPropsMap.get(instance$248)) instance = $c442fa203ef9538d$var$assign({}, props), $c442fa203ef9538d$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $c442fa203ef9538d$var$markNodeAsHoistable(styleProps);
            $c442fa203ef9538d$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($c442fa203ef9538d$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $c442fa203ef9538d$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $c442fa203ef9538d$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $c442fa203ef9538d$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $c442fa203ef9538d$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $c442fa203ef9538d$var$tagCaches = null;
function $c442fa203ef9538d$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $c442fa203ef9538d$var$tagCaches) {
        var cache = new Map();
        var caches = $c442fa203ef9538d$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $c442fa203ef9538d$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$c442fa203ef9538d$var$internalHoistableMarker] || node[$c442fa203ef9538d$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $c442fa203ef9538d$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $c442fa203ef9538d$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $c442fa203ef9538d$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $c442fa203ef9538d$var$suspendedState = null;
function $c442fa203ef9538d$var$noop() {}
function $c442fa203ef9538d$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $c442fa203ef9538d$var$suspendedState) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(475));
    var state = $c442fa203ef9538d$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $c442fa203ef9538d$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($c442fa203ef9538d$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $c442fa203ef9538d$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $c442fa203ef9538d$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $c442fa203ef9538d$var$stylesheetPropsFromRawProps(props);
            (key = $c442fa203ef9538d$var$preloadPropsMap.get(key)) && $c442fa203ef9538d$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $c442fa203ef9538d$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c442fa203ef9538d$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $c442fa203ef9538d$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $c442fa203ef9538d$var$waitForCommitToBeReady() {
    if (null === $c442fa203ef9538d$var$suspendedState) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(475));
    var state = $c442fa203ef9538d$var$suspendedState;
    state.stylesheets && 0 === state.count && $c442fa203ef9538d$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $c442fa203ef9538d$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $c442fa203ef9538d$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $c442fa203ef9538d$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $c442fa203ef9538d$var$precedencesByRoot = null;
function $c442fa203ef9538d$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $c442fa203ef9538d$var$precedencesByRoot = new Map(), resources.forEach($c442fa203ef9538d$var$insertStylesheetIntoRoot, state), $c442fa203ef9538d$var$precedencesByRoot = null, $c442fa203ef9538d$var$onUnsuspend.call(state));
}
function $c442fa203ef9538d$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $c442fa203ef9538d$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $c442fa203ef9538d$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $c442fa203ef9538d$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $c442fa203ef9538d$var$HostTransitionContext = {
    $$typeof: $c442fa203ef9538d$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $c442fa203ef9538d$var$sharedNotPendingObject,
    _currentValue2: $c442fa203ef9538d$var$sharedNotPendingObject,
    _threadCount: 0
};
function $c442fa203ef9538d$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $c442fa203ef9538d$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c442fa203ef9538d$var$createLaneMap(0);
    this.hiddenUpdates = $c442fa203ef9538d$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $c442fa203ef9538d$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $c442fa203ef9538d$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $c442fa203ef9538d$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $c442fa203ef9538d$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $c442fa203ef9538d$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $c442fa203ef9538d$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $c442fa203ef9538d$var$emptyContextObject;
    parentComponent = $c442fa203ef9538d$var$emptyContextObject;
    return parentComponent;
}
function $c442fa203ef9538d$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $c442fa203ef9538d$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $c442fa203ef9538d$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $c442fa203ef9538d$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($c442fa203ef9538d$var$scheduleUpdateOnFiber(element, rootFiber, lane), $c442fa203ef9538d$var$entangleTransitions(element, rootFiber, lane));
}
function $c442fa203ef9538d$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $c442fa203ef9538d$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $c442fa203ef9538d$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $c442fa203ef9538d$var$markRetryLaneImpl(fiber, retryLane);
}
function $c442fa203ef9538d$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $c442fa203ef9538d$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $c442fa203ef9538d$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $c442fa203ef9538d$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $c442fa203ef9538d$var$_enabled = !0;
function $c442fa203ef9538d$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c442fa203ef9538d$var$ReactSharedInternals.T;
    $c442fa203ef9538d$var$ReactSharedInternals.T = null;
    var previousPriority = $c442fa203ef9538d$var$ReactDOMSharedInternals.p;
    try {
        $c442fa203ef9538d$var$ReactDOMSharedInternals.p = 2, $c442fa203ef9538d$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c442fa203ef9538d$var$ReactDOMSharedInternals.p = previousPriority, $c442fa203ef9538d$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c442fa203ef9538d$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c442fa203ef9538d$var$ReactSharedInternals.T;
    $c442fa203ef9538d$var$ReactSharedInternals.T = null;
    var previousPriority = $c442fa203ef9538d$var$ReactDOMSharedInternals.p;
    try {
        $c442fa203ef9538d$var$ReactDOMSharedInternals.p = 8, $c442fa203ef9538d$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c442fa203ef9538d$var$ReactDOMSharedInternals.p = previousPriority, $c442fa203ef9538d$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c442fa203ef9538d$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($c442fa203ef9538d$var$_enabled) {
        var blockedOn = $c442fa203ef9538d$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $c442fa203ef9538d$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c442fa203ef9538d$var$return_targetInst, targetContainer), $c442fa203ef9538d$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($c442fa203ef9538d$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($c442fa203ef9538d$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $c442fa203ef9538d$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $c442fa203ef9538d$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $c442fa203ef9538d$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $c442fa203ef9538d$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $c442fa203ef9538d$var$ensureRootIsScheduled(fiber);
                                0 === ($c442fa203ef9538d$var$executionContext & 6) && ($c442fa203ef9538d$var$workInProgressRootRenderTargetTime = $c442fa203ef9538d$var$now() + 500, $c442fa203ef9538d$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $c442fa203ef9538d$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $c442fa203ef9538d$var$scheduleUpdateOnFiber(root, fiber, 2), $c442fa203ef9538d$var$flushSyncWork$1(), $c442fa203ef9538d$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $c442fa203ef9538d$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $c442fa203ef9538d$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c442fa203ef9538d$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $c442fa203ef9538d$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $c442fa203ef9538d$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $c442fa203ef9538d$var$getEventTarget(nativeEvent);
    return $c442fa203ef9538d$var$findInstanceBlockingTarget(nativeEvent);
}
var $c442fa203ef9538d$var$return_targetInst = null;
function $c442fa203ef9538d$var$findInstanceBlockingTarget(targetNode) {
    $c442fa203ef9538d$var$return_targetInst = null;
    targetNode = $c442fa203ef9538d$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $c442fa203ef9538d$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $c442fa203ef9538d$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $c442fa203ef9538d$var$return_targetInst = targetNode;
    return null;
}
function $c442fa203ef9538d$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($c442fa203ef9538d$var$getCurrentPriorityLevel()){
                case $c442fa203ef9538d$var$ImmediatePriority:
                    return 2;
                case $c442fa203ef9538d$var$UserBlockingPriority:
                    return 8;
                case $c442fa203ef9538d$var$NormalPriority$1:
                case $c442fa203ef9538d$var$LowPriority:
                    return 32;
                case $c442fa203ef9538d$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $c442fa203ef9538d$var$hasScheduledReplayAttempt = !1, $c442fa203ef9538d$var$queuedFocus = null, $c442fa203ef9538d$var$queuedDrag = null, $c442fa203ef9538d$var$queuedMouse = null, $c442fa203ef9538d$var$queuedPointers = new Map(), $c442fa203ef9538d$var$queuedPointerCaptures = new Map(), $c442fa203ef9538d$var$queuedExplicitHydrationTargets = [], $c442fa203ef9538d$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $c442fa203ef9538d$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $c442fa203ef9538d$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $c442fa203ef9538d$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $c442fa203ef9538d$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $c442fa203ef9538d$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c442fa203ef9538d$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $c442fa203ef9538d$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $c442fa203ef9538d$var$getInstanceFromNode(blockedOn), null !== blockedOn && $c442fa203ef9538d$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $c442fa203ef9538d$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $c442fa203ef9538d$var$queuedFocus = $c442fa203ef9538d$var$accumulateOrCreateContinuousQueuedReplayableEvent($c442fa203ef9538d$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $c442fa203ef9538d$var$queuedDrag = $c442fa203ef9538d$var$accumulateOrCreateContinuousQueuedReplayableEvent($c442fa203ef9538d$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $c442fa203ef9538d$var$queuedMouse = $c442fa203ef9538d$var$accumulateOrCreateContinuousQueuedReplayableEvent($c442fa203ef9538d$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $c442fa203ef9538d$var$queuedPointers.set(pointerId, $c442fa203ef9538d$var$accumulateOrCreateContinuousQueuedReplayableEvent($c442fa203ef9538d$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $c442fa203ef9538d$var$queuedPointerCaptures.set(pointerId, $c442fa203ef9538d$var$accumulateOrCreateContinuousQueuedReplayableEvent($c442fa203ef9538d$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $c442fa203ef9538d$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $c442fa203ef9538d$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $c442fa203ef9538d$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $c442fa203ef9538d$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $c442fa203ef9538d$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $c442fa203ef9538d$var$requestUpdateLane(), root = $c442fa203ef9538d$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $c442fa203ef9538d$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $c442fa203ef9538d$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $c442fa203ef9538d$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $c442fa203ef9538d$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $c442fa203ef9538d$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $c442fa203ef9538d$var$currentReplayingEvent = null;
        } else return targetContainers = $c442fa203ef9538d$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $c442fa203ef9538d$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $c442fa203ef9538d$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $c442fa203ef9538d$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $c442fa203ef9538d$var$replayUnblockedEvents() {
    $c442fa203ef9538d$var$hasScheduledReplayAttempt = !1;
    null !== $c442fa203ef9538d$var$queuedFocus && $c442fa203ef9538d$var$attemptReplayContinuousQueuedEvent($c442fa203ef9538d$var$queuedFocus) && ($c442fa203ef9538d$var$queuedFocus = null);
    null !== $c442fa203ef9538d$var$queuedDrag && $c442fa203ef9538d$var$attemptReplayContinuousQueuedEvent($c442fa203ef9538d$var$queuedDrag) && ($c442fa203ef9538d$var$queuedDrag = null);
    null !== $c442fa203ef9538d$var$queuedMouse && $c442fa203ef9538d$var$attemptReplayContinuousQueuedEvent($c442fa203ef9538d$var$queuedMouse) && ($c442fa203ef9538d$var$queuedMouse = null);
    $c442fa203ef9538d$var$queuedPointers.forEach($c442fa203ef9538d$var$attemptReplayContinuousQueuedEventInMap);
    $c442fa203ef9538d$var$queuedPointerCaptures.forEach($c442fa203ef9538d$var$attemptReplayContinuousQueuedEventInMap);
}
function $c442fa203ef9538d$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $c442fa203ef9538d$var$hasScheduledReplayAttempt || ($c442fa203ef9538d$var$hasScheduledReplayAttempt = !0, $Qw0kg.unstable_scheduleCallback($Qw0kg.unstable_NormalPriority, $c442fa203ef9538d$var$replayUnblockedEvents)));
}
var $c442fa203ef9538d$var$lastScheduledReplayQueue = null;
function $c442fa203ef9538d$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $c442fa203ef9538d$var$lastScheduledReplayQueue !== formReplayingQueue && ($c442fa203ef9538d$var$lastScheduledReplayQueue = formReplayingQueue, $Qw0kg.unstable_scheduleCallback($Qw0kg.unstable_NormalPriority, function() {
        $c442fa203ef9538d$var$lastScheduledReplayQueue === formReplayingQueue && ($c442fa203ef9538d$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $c442fa203ef9538d$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $c442fa203ef9538d$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $c442fa203ef9538d$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $c442fa203ef9538d$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $c442fa203ef9538d$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $c442fa203ef9538d$var$queuedFocus && $c442fa203ef9538d$var$scheduleCallbackIfUnblocked($c442fa203ef9538d$var$queuedFocus, unblocked);
    null !== $c442fa203ef9538d$var$queuedDrag && $c442fa203ef9538d$var$scheduleCallbackIfUnblocked($c442fa203ef9538d$var$queuedDrag, unblocked);
    null !== $c442fa203ef9538d$var$queuedMouse && $c442fa203ef9538d$var$scheduleCallbackIfUnblocked($c442fa203ef9538d$var$queuedMouse, unblocked);
    $c442fa203ef9538d$var$queuedPointers.forEach(unblock);
    $c442fa203ef9538d$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $c442fa203ef9538d$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $c442fa203ef9538d$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $c442fa203ef9538d$var$queuedExplicitHydrationTargets.length && (i = $c442fa203ef9538d$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$c442fa203ef9538d$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $c442fa203ef9538d$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$c442fa203ef9538d$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $c442fa203ef9538d$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$c442fa203ef9538d$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $c442fa203ef9538d$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $c442fa203ef9538d$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $c442fa203ef9538d$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c442fa203ef9538d$var$ReactDOMHydrationRoot.prototype.render = $c442fa203ef9538d$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(409));
    var current = root.current, lane = $c442fa203ef9538d$var$requestUpdateLane();
    $c442fa203ef9538d$var$updateContainerImpl(current, lane, children, root, null, null);
};
$c442fa203ef9538d$var$ReactDOMHydrationRoot.prototype.unmount = $c442fa203ef9538d$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $c442fa203ef9538d$var$flushPassiveEffects();
        $c442fa203ef9538d$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $c442fa203ef9538d$var$flushSyncWork$1();
        container[$c442fa203ef9538d$var$internalContainerInstanceKey] = null;
    }
};
function $c442fa203ef9538d$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c442fa203ef9538d$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $c442fa203ef9538d$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $c442fa203ef9538d$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $c442fa203ef9538d$var$queuedExplicitHydrationTargets[i].priority; i++);
        $c442fa203ef9538d$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $c442fa203ef9538d$var$attemptExplicitHydrationTarget(target);
    }
};
var $c442fa203ef9538d$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $gIfym.version;
if ("19.0.0" !== $c442fa203ef9538d$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(527, $c442fa203ef9538d$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$c442fa203ef9538d$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($c442fa203ef9538d$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $c442fa203ef9538d$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $c442fa203ef9538d$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $c442fa203ef9538d$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $c442fa203ef9538d$var$ReactSharedInternals,
    findFiberByHostInstance: $c442fa203ef9538d$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c442fa203ef9538d$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c442fa203ef9538d$var$hook$jscomp$inline_2166.isDisabled && $c442fa203ef9538d$var$hook$jscomp$inline_2166.supportsFiber) try {
        $c442fa203ef9538d$var$rendererID = $c442fa203ef9538d$var$hook$jscomp$inline_2166.inject($c442fa203ef9538d$var$internals$jscomp$inline_2165), $c442fa203ef9538d$var$injectedHook = $c442fa203ef9538d$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$c442fa203ef9538d$export$882461b6382ed46c = function(container, options) {
    if (!$c442fa203ef9538d$var$isValidContainer(container)) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c442fa203ef9538d$var$defaultOnUncaughtError, onCaughtError = $c442fa203ef9538d$var$defaultOnCaughtError, onRecoverableError = $c442fa203ef9538d$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $c442fa203ef9538d$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$c442fa203ef9538d$var$internalContainerInstanceKey] = options.current;
    $c442fa203ef9538d$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $c442fa203ef9538d$var$ReactDOMRoot(options);
};
$c442fa203ef9538d$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$c442fa203ef9538d$var$isValidContainer(container)) throw Error($c442fa203ef9538d$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c442fa203ef9538d$var$defaultOnUncaughtError, onCaughtError = $c442fa203ef9538d$var$defaultOnCaughtError, onRecoverableError = $c442fa203ef9538d$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $c442fa203ef9538d$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $c442fa203ef9538d$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $c442fa203ef9538d$var$requestUpdateLane();
    identifierPrefix = $c442fa203ef9538d$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $c442fa203ef9538d$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $c442fa203ef9538d$var$markRootUpdated$1(initialChildren, isStrictMode);
    $c442fa203ef9538d$var$ensureRootIsScheduled(initialChildren);
    container[$c442fa203ef9538d$var$internalContainerInstanceKey] = initialChildren.current;
    $c442fa203ef9538d$var$listenToAllSupportedEvents(container);
    return new $c442fa203ef9538d$var$ReactDOMHydrationRoot(initialChildren);
};
$c442fa203ef9538d$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("Qw0kg", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kkzav"));

});
parcelRegister("kkzav", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $ecd0f4a1a853ab54$export$c4744153514ff05d; }, function (v) { return $ecd0f4a1a853ab54$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $ecd0f4a1a853ab54$export$3e506c1ccc9cc1a7; }, function (v) { return $ecd0f4a1a853ab54$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $ecd0f4a1a853ab54$export$e26fe2ed2fa76875; }, function (v) { return $ecd0f4a1a853ab54$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $ecd0f4a1a853ab54$export$502329bbf4b505b1; }, function (v) { return $ecd0f4a1a853ab54$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $ecd0f4a1a853ab54$export$6e3807111c4874c4; }, function (v) { return $ecd0f4a1a853ab54$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $ecd0f4a1a853ab54$export$c27134553091fb3a; }, function (v) { return $ecd0f4a1a853ab54$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $ecd0f4a1a853ab54$export$33ee1acdc04fd2a2; }, function (v) { return $ecd0f4a1a853ab54$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $ecd0f4a1a853ab54$export$b00a404bbd5edef2; }, function (v) { return $ecd0f4a1a853ab54$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $ecd0f4a1a853ab54$export$8352ce38b91d0c62; }, function (v) { return $ecd0f4a1a853ab54$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $ecd0f4a1a853ab54$export$d66a1c1c77bd778b; }, function (v) { return $ecd0f4a1a853ab54$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $ecd0f4a1a853ab54$export$d3dfb8e4810cb555; }, function (v) { return $ecd0f4a1a853ab54$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $ecd0f4a1a853ab54$export$839f9183b0465a69; }, function (v) { return $ecd0f4a1a853ab54$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $ecd0f4a1a853ab54$export$72fdf0e06517287b; }, function (v) { return $ecd0f4a1a853ab54$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $ecd0f4a1a853ab54$export$4b844e58a3e414b4; }, function (v) { return $ecd0f4a1a853ab54$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $ecd0f4a1a853ab54$export$816d2913ae6b83b1; }, function (v) { return $ecd0f4a1a853ab54$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $ecd0f4a1a853ab54$export$61bcfe829111a1d0; }, function (v) { return $ecd0f4a1a853ab54$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $ecd0f4a1a853ab54$export$7ee8c9beb337bc3f; }, function (v) { return $ecd0f4a1a853ab54$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $ecd0f4a1a853ab54$export$b5836b71941fa3ed; }, function (v) { return $ecd0f4a1a853ab54$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $ecd0f4a1a853ab54$export$cf845f2c119da08a; }, function (v) { return $ecd0f4a1a853ab54$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ecd0f4a1a853ab54$export$c4744153514ff05d;
var $ecd0f4a1a853ab54$export$3e506c1ccc9cc1a7;
var $ecd0f4a1a853ab54$export$e26fe2ed2fa76875;
var $ecd0f4a1a853ab54$export$502329bbf4b505b1;
var $ecd0f4a1a853ab54$export$6e3807111c4874c4;
var $ecd0f4a1a853ab54$export$c27134553091fb3a;
var $ecd0f4a1a853ab54$export$33ee1acdc04fd2a2;
var $ecd0f4a1a853ab54$export$b00a404bbd5edef2;
var $ecd0f4a1a853ab54$export$8352ce38b91d0c62;
var $ecd0f4a1a853ab54$export$d66a1c1c77bd778b;
var $ecd0f4a1a853ab54$export$d3dfb8e4810cb555;
var $ecd0f4a1a853ab54$export$839f9183b0465a69;
var $ecd0f4a1a853ab54$export$72fdf0e06517287b;
var $ecd0f4a1a853ab54$export$4b844e58a3e414b4;
var $ecd0f4a1a853ab54$export$816d2913ae6b83b1;
var $ecd0f4a1a853ab54$export$61bcfe829111a1d0;
var $ecd0f4a1a853ab54$export$7ee8c9beb337bc3f;
var $ecd0f4a1a853ab54$export$b5836b71941fa3ed;
var $ecd0f4a1a853ab54$export$cf845f2c119da08a;
"use strict";
function $ecd0f4a1a853ab54$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $ecd0f4a1a853ab54$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $ecd0f4a1a853ab54$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $ecd0f4a1a853ab54$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $ecd0f4a1a853ab54$var$compare(left, last)) rightIndex < length && 0 > $ecd0f4a1a853ab54$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $ecd0f4a1a853ab54$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $ecd0f4a1a853ab54$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$ecd0f4a1a853ab54$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ecd0f4a1a853ab54$var$localPerformance = performance;
    $ecd0f4a1a853ab54$export$c4744153514ff05d = function() {
        return $ecd0f4a1a853ab54$var$localPerformance.now();
    };
} else {
    var $ecd0f4a1a853ab54$var$localDate = Date, $ecd0f4a1a853ab54$var$initialTime = $ecd0f4a1a853ab54$var$localDate.now();
    $ecd0f4a1a853ab54$export$c4744153514ff05d = function() {
        return $ecd0f4a1a853ab54$var$localDate.now() - $ecd0f4a1a853ab54$var$initialTime;
    };
}
var $ecd0f4a1a853ab54$var$taskQueue = [], $ecd0f4a1a853ab54$var$timerQueue = [], $ecd0f4a1a853ab54$var$taskIdCounter = 1, $ecd0f4a1a853ab54$var$currentTask = null, $ecd0f4a1a853ab54$var$currentPriorityLevel = 3, $ecd0f4a1a853ab54$var$isPerformingWork = !1, $ecd0f4a1a853ab54$var$isHostCallbackScheduled = !1, $ecd0f4a1a853ab54$var$isHostTimeoutScheduled = !1, $ecd0f4a1a853ab54$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $ecd0f4a1a853ab54$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $ecd0f4a1a853ab54$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $ecd0f4a1a853ab54$var$advanceTimers(currentTime) {
    for(var timer = $ecd0f4a1a853ab54$var$peek($ecd0f4a1a853ab54$var$timerQueue); null !== timer;){
        if (null === timer.callback) $ecd0f4a1a853ab54$var$pop($ecd0f4a1a853ab54$var$timerQueue);
        else if (timer.startTime <= currentTime) $ecd0f4a1a853ab54$var$pop($ecd0f4a1a853ab54$var$timerQueue), timer.sortIndex = timer.expirationTime, $ecd0f4a1a853ab54$var$push($ecd0f4a1a853ab54$var$taskQueue, timer);
        else break;
        timer = $ecd0f4a1a853ab54$var$peek($ecd0f4a1a853ab54$var$timerQueue);
    }
}
function $ecd0f4a1a853ab54$var$handleTimeout(currentTime) {
    $ecd0f4a1a853ab54$var$isHostTimeoutScheduled = !1;
    $ecd0f4a1a853ab54$var$advanceTimers(currentTime);
    if (!$ecd0f4a1a853ab54$var$isHostCallbackScheduled) {
        if (null !== $ecd0f4a1a853ab54$var$peek($ecd0f4a1a853ab54$var$taskQueue)) $ecd0f4a1a853ab54$var$isHostCallbackScheduled = !0, $ecd0f4a1a853ab54$var$requestHostCallback();
        else {
            var firstTimer = $ecd0f4a1a853ab54$var$peek($ecd0f4a1a853ab54$var$timerQueue);
            null !== firstTimer && $ecd0f4a1a853ab54$var$requestHostTimeout($ecd0f4a1a853ab54$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $ecd0f4a1a853ab54$var$isMessageLoopRunning = !1, $ecd0f4a1a853ab54$var$taskTimeoutID = -1, $ecd0f4a1a853ab54$var$frameInterval = 5, $ecd0f4a1a853ab54$var$startTime = -1;
function $ecd0f4a1a853ab54$var$shouldYieldToHost() {
    return $ecd0f4a1a853ab54$export$c4744153514ff05d() - $ecd0f4a1a853ab54$var$startTime < $ecd0f4a1a853ab54$var$frameInterval ? !1 : !0;
}
function $ecd0f4a1a853ab54$var$performWorkUntilDeadline() {
    if ($ecd0f4a1a853ab54$var$isMessageLoopRunning) {
        var currentTime = $ecd0f4a1a853ab54$export$c4744153514ff05d();
        $ecd0f4a1a853ab54$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $ecd0f4a1a853ab54$var$isHostCallbackScheduled = !1;
                $ecd0f4a1a853ab54$var$isHostTimeoutScheduled && ($ecd0f4a1a853ab54$var$isHostTimeoutScheduled = !1, $ecd0f4a1a853ab54$var$localClearTimeout($ecd0f4a1a853ab54$var$taskTimeoutID), $ecd0f4a1a853ab54$var$taskTimeoutID = -1);
                $ecd0f4a1a853ab54$var$isPerformingWork = !0;
                var previousPriorityLevel = $ecd0f4a1a853ab54$var$currentPriorityLevel;
                try {
                    b: {
                        $ecd0f4a1a853ab54$var$advanceTimers(currentTime);
                        for($ecd0f4a1a853ab54$var$currentTask = $ecd0f4a1a853ab54$var$peek($ecd0f4a1a853ab54$var$taskQueue); null !== $ecd0f4a1a853ab54$var$currentTask && !($ecd0f4a1a853ab54$var$currentTask.expirationTime > currentTime && $ecd0f4a1a853ab54$var$shouldYieldToHost());){
                            var callback = $ecd0f4a1a853ab54$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $ecd0f4a1a853ab54$var$currentTask.callback = null;
                                $ecd0f4a1a853ab54$var$currentPriorityLevel = $ecd0f4a1a853ab54$var$currentTask.priorityLevel;
                                var continuationCallback = callback($ecd0f4a1a853ab54$var$currentTask.expirationTime <= currentTime);
                                currentTime = $ecd0f4a1a853ab54$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $ecd0f4a1a853ab54$var$currentTask.callback = continuationCallback;
                                    $ecd0f4a1a853ab54$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $ecd0f4a1a853ab54$var$currentTask === $ecd0f4a1a853ab54$var$peek($ecd0f4a1a853ab54$var$taskQueue) && $ecd0f4a1a853ab54$var$pop($ecd0f4a1a853ab54$var$taskQueue);
                                $ecd0f4a1a853ab54$var$advanceTimers(currentTime);
                            } else $ecd0f4a1a853ab54$var$pop($ecd0f4a1a853ab54$var$taskQueue);
                            $ecd0f4a1a853ab54$var$currentTask = $ecd0f4a1a853ab54$var$peek($ecd0f4a1a853ab54$var$taskQueue);
                        }
                        if (null !== $ecd0f4a1a853ab54$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $ecd0f4a1a853ab54$var$peek($ecd0f4a1a853ab54$var$timerQueue);
                            null !== firstTimer && $ecd0f4a1a853ab54$var$requestHostTimeout($ecd0f4a1a853ab54$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $ecd0f4a1a853ab54$var$currentTask = null, $ecd0f4a1a853ab54$var$currentPriorityLevel = previousPriorityLevel, $ecd0f4a1a853ab54$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $ecd0f4a1a853ab54$var$schedulePerformWorkUntilDeadline() : $ecd0f4a1a853ab54$var$isMessageLoopRunning = !1;
        }
    }
}
var $ecd0f4a1a853ab54$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $ecd0f4a1a853ab54$var$localSetImmediate) $ecd0f4a1a853ab54$var$schedulePerformWorkUntilDeadline = function() {
    $ecd0f4a1a853ab54$var$localSetImmediate($ecd0f4a1a853ab54$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ecd0f4a1a853ab54$var$channel = new MessageChannel(), $ecd0f4a1a853ab54$var$port = $ecd0f4a1a853ab54$var$channel.port2;
    $ecd0f4a1a853ab54$var$channel.port1.onmessage = $ecd0f4a1a853ab54$var$performWorkUntilDeadline;
    $ecd0f4a1a853ab54$var$schedulePerformWorkUntilDeadline = function() {
        $ecd0f4a1a853ab54$var$port.postMessage(null);
    };
} else $ecd0f4a1a853ab54$var$schedulePerformWorkUntilDeadline = function() {
    $ecd0f4a1a853ab54$var$localSetTimeout($ecd0f4a1a853ab54$var$performWorkUntilDeadline, 0);
};
function $ecd0f4a1a853ab54$var$requestHostCallback() {
    $ecd0f4a1a853ab54$var$isMessageLoopRunning || ($ecd0f4a1a853ab54$var$isMessageLoopRunning = !0, $ecd0f4a1a853ab54$var$schedulePerformWorkUntilDeadline());
}
function $ecd0f4a1a853ab54$var$requestHostTimeout(callback, ms) {
    $ecd0f4a1a853ab54$var$taskTimeoutID = $ecd0f4a1a853ab54$var$localSetTimeout(function() {
        callback($ecd0f4a1a853ab54$export$c4744153514ff05d());
    }, ms);
}
$ecd0f4a1a853ab54$export$3e506c1ccc9cc1a7 = 5;
$ecd0f4a1a853ab54$export$e26fe2ed2fa76875 = 1;
$ecd0f4a1a853ab54$export$502329bbf4b505b1 = 4;
$ecd0f4a1a853ab54$export$6e3807111c4874c4 = 3;
$ecd0f4a1a853ab54$export$c27134553091fb3a = null;
$ecd0f4a1a853ab54$export$33ee1acdc04fd2a2 = 2;
$ecd0f4a1a853ab54$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$ecd0f4a1a853ab54$export$8352ce38b91d0c62 = function() {
    $ecd0f4a1a853ab54$var$isHostCallbackScheduled || $ecd0f4a1a853ab54$var$isPerformingWork || ($ecd0f4a1a853ab54$var$isHostCallbackScheduled = !0, $ecd0f4a1a853ab54$var$requestHostCallback());
};
$ecd0f4a1a853ab54$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ecd0f4a1a853ab54$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$ecd0f4a1a853ab54$export$d3dfb8e4810cb555 = function() {
    return $ecd0f4a1a853ab54$var$currentPriorityLevel;
};
$ecd0f4a1a853ab54$export$839f9183b0465a69 = function() {
    return $ecd0f4a1a853ab54$var$peek($ecd0f4a1a853ab54$var$taskQueue);
};
$ecd0f4a1a853ab54$export$72fdf0e06517287b = function(eventHandler) {
    switch($ecd0f4a1a853ab54$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $ecd0f4a1a853ab54$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $ecd0f4a1a853ab54$var$currentPriorityLevel;
    $ecd0f4a1a853ab54$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $ecd0f4a1a853ab54$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$ecd0f4a1a853ab54$export$4b844e58a3e414b4 = function() {};
$ecd0f4a1a853ab54$export$816d2913ae6b83b1 = function() {};
$ecd0f4a1a853ab54$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $ecd0f4a1a853ab54$var$currentPriorityLevel;
    $ecd0f4a1a853ab54$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $ecd0f4a1a853ab54$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$ecd0f4a1a853ab54$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $ecd0f4a1a853ab54$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $ecd0f4a1a853ab54$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $ecd0f4a1a853ab54$var$push($ecd0f4a1a853ab54$var$timerQueue, priorityLevel), null === $ecd0f4a1a853ab54$var$peek($ecd0f4a1a853ab54$var$taskQueue) && priorityLevel === $ecd0f4a1a853ab54$var$peek($ecd0f4a1a853ab54$var$timerQueue) && ($ecd0f4a1a853ab54$var$isHostTimeoutScheduled ? ($ecd0f4a1a853ab54$var$localClearTimeout($ecd0f4a1a853ab54$var$taskTimeoutID), $ecd0f4a1a853ab54$var$taskTimeoutID = -1) : $ecd0f4a1a853ab54$var$isHostTimeoutScheduled = !0, $ecd0f4a1a853ab54$var$requestHostTimeout($ecd0f4a1a853ab54$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $ecd0f4a1a853ab54$var$push($ecd0f4a1a853ab54$var$taskQueue, priorityLevel), $ecd0f4a1a853ab54$var$isHostCallbackScheduled || $ecd0f4a1a853ab54$var$isPerformingWork || ($ecd0f4a1a853ab54$var$isHostCallbackScheduled = !0, $ecd0f4a1a853ab54$var$requestHostCallback()));
    return priorityLevel;
};
$ecd0f4a1a853ab54$export$b5836b71941fa3ed = $ecd0f4a1a853ab54$var$shouldYieldToHost;
$ecd0f4a1a853ab54$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $ecd0f4a1a853ab54$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $ecd0f4a1a853ab54$var$currentPriorityLevel;
        $ecd0f4a1a853ab54$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $ecd0f4a1a853ab54$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("gIfym", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5nf0E"));

});

parcelRegister("gSDKV", function(module, exports) {
'use strict';
function $c4a08725a78d51bf$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c4a08725a78d51bf$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c4a08725a78d51bf$var$checkDCE();

module.exports = (parcelRequire("5YMVn"));

});
parcelRegister("5YMVn", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $45a881bbdfccdf44$export$69ce8ef3fe5cead0; }, function (v) { return $45a881bbdfccdf44$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $45a881bbdfccdf44$export$d39a5bbd09211389; }, function (v) { return $45a881bbdfccdf44$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $45a881bbdfccdf44$export$cd75ccfd720a3cd4; }, function (v) { return $45a881bbdfccdf44$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $45a881bbdfccdf44$export$a0816fa17a9e79be; }, function (v) { return $45a881bbdfccdf44$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $45a881bbdfccdf44$export$7292efcadded39f3; }, function (v) { return $45a881bbdfccdf44$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $45a881bbdfccdf44$export$da407abadb9b8f86; }, function (v) { return $45a881bbdfccdf44$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $45a881bbdfccdf44$export$314cfea32580671c; }, function (v) { return $45a881bbdfccdf44$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $45a881bbdfccdf44$export$513ccb98c53b8039; }, function (v) { return $45a881bbdfccdf44$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $45a881bbdfccdf44$export$dbca993bc2d264a; }, function (v) { return $45a881bbdfccdf44$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $45a881bbdfccdf44$export$4797a8006f0655d0; }, function (v) { return $45a881bbdfccdf44$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $45a881bbdfccdf44$export$c78a37762a8d58e1; }, function (v) { return $45a881bbdfccdf44$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $45a881bbdfccdf44$export$606f11b2eb45ecc6; }, function (v) { return $45a881bbdfccdf44$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $45a881bbdfccdf44$export$f7e8a0bf92324b1e; }, function (v) { return $45a881bbdfccdf44$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $45a881bbdfccdf44$export$83d89fbfd8236492; }, function (v) { return $45a881bbdfccdf44$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $45a881bbdfccdf44$export$69ce8ef3fe5cead0;
var $45a881bbdfccdf44$export$d39a5bbd09211389;
var $45a881bbdfccdf44$export$cd75ccfd720a3cd4;
var $45a881bbdfccdf44$export$a0816fa17a9e79be;
var $45a881bbdfccdf44$export$7292efcadded39f3;
var $45a881bbdfccdf44$export$da407abadb9b8f86;
var $45a881bbdfccdf44$export$314cfea32580671c;
var $45a881bbdfccdf44$export$513ccb98c53b8039;
var $45a881bbdfccdf44$export$dbca993bc2d264a;
var $45a881bbdfccdf44$export$4797a8006f0655d0;
var $45a881bbdfccdf44$export$c78a37762a8d58e1;
var $45a881bbdfccdf44$export$606f11b2eb45ecc6;
var $45a881bbdfccdf44$export$f7e8a0bf92324b1e;
var $45a881bbdfccdf44$export$83d89fbfd8236492;
"use strict";

var $gIfym = parcelRequire("gIfym");
function $45a881bbdfccdf44$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $45a881bbdfccdf44$var$noop() {}
var $45a881bbdfccdf44$var$Internals = {
    d: {
        f: $45a881bbdfccdf44$var$noop,
        r: function() {
            throw Error($45a881bbdfccdf44$var$formatProdErrorMessage(522));
        },
        D: $45a881bbdfccdf44$var$noop,
        C: $45a881bbdfccdf44$var$noop,
        L: $45a881bbdfccdf44$var$noop,
        m: $45a881bbdfccdf44$var$noop,
        X: $45a881bbdfccdf44$var$noop,
        S: $45a881bbdfccdf44$var$noop,
        M: $45a881bbdfccdf44$var$noop
    },
    p: 0,
    findDOMNode: null
}, $45a881bbdfccdf44$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $45a881bbdfccdf44$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $45a881bbdfccdf44$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $45a881bbdfccdf44$var$ReactSharedInternals = $gIfym.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $45a881bbdfccdf44$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$45a881bbdfccdf44$export$69ce8ef3fe5cead0 = $45a881bbdfccdf44$var$Internals;
$45a881bbdfccdf44$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($45a881bbdfccdf44$var$formatProdErrorMessage(299));
    return $45a881bbdfccdf44$var$createPortal$1(children, container, null, key);
};
$45a881bbdfccdf44$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $45a881bbdfccdf44$var$ReactSharedInternals.T, previousUpdatePriority = $45a881bbdfccdf44$var$Internals.p;
    try {
        if ($45a881bbdfccdf44$var$ReactSharedInternals.T = null, $45a881bbdfccdf44$var$Internals.p = 2, fn) return fn();
    } finally{
        $45a881bbdfccdf44$var$ReactSharedInternals.T = previousTransition, $45a881bbdfccdf44$var$Internals.p = previousUpdatePriority, $45a881bbdfccdf44$var$Internals.d.f();
    }
};
$45a881bbdfccdf44$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $45a881bbdfccdf44$var$Internals.d.C(href, options));
};
$45a881bbdfccdf44$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $45a881bbdfccdf44$var$Internals.d.D(href);
};
$45a881bbdfccdf44$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $45a881bbdfccdf44$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $45a881bbdfccdf44$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $45a881bbdfccdf44$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$45a881bbdfccdf44$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $45a881bbdfccdf44$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $45a881bbdfccdf44$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $45a881bbdfccdf44$var$Internals.d.M(href);
    }
};
$45a881bbdfccdf44$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $45a881bbdfccdf44$var$getCrossOriginStringAs(as, options.crossOrigin);
        $45a881bbdfccdf44$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$45a881bbdfccdf44$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $45a881bbdfccdf44$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $45a881bbdfccdf44$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $45a881bbdfccdf44$var$Internals.d.m(href);
    }
};
$45a881bbdfccdf44$export$4797a8006f0655d0 = function(form) {
    $45a881bbdfccdf44$var$Internals.d.r(form);
};
$45a881bbdfccdf44$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$45a881bbdfccdf44$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $45a881bbdfccdf44$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$45a881bbdfccdf44$export$f7e8a0bf92324b1e = function() {
    return $45a881bbdfccdf44$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$45a881bbdfccdf44$export$83d89fbfd8236492 = "19.0.0";

});



parcelRegister("jfo0o", function(module, exports) {
'use strict';

var $aNeVr = parcelRequire("aNeVr");

var $4OK8b = parcelRequire("4OK8b");

var $jXggh = parcelRequire("jXggh");

var $66OX7 = parcelRequire("66OX7");

var $gXqRx = parcelRequire("gXqRx");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $e03209fca4c3e620$var$createInstance(defaultConfig) {
    var context = new $jXggh(defaultConfig);
    var instance = $4OK8b($jXggh.prototype.request, context);
    // Copy axios.prototype to instance
    $aNeVr.extend(instance, $jXggh.prototype, context);
    // Copy context to instance
    $aNeVr.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $e03209fca4c3e620$var$axios = $e03209fca4c3e620$var$createInstance($gXqRx);
// Expose Axios class to allow class inheritance
$e03209fca4c3e620$var$axios.Axios = $jXggh;
// Factory for creating new instances
$e03209fca4c3e620$var$axios.create = function create(instanceConfig) {
    return $e03209fca4c3e620$var$createInstance($66OX7($e03209fca4c3e620$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$e03209fca4c3e620$var$axios.Cancel = (parcelRequire("hLgSx"));

$e03209fca4c3e620$var$axios.CancelToken = (parcelRequire("hKXYi"));

$e03209fca4c3e620$var$axios.isCancel = (parcelRequire("6Jxjx"));
// Expose all/spread
$e03209fca4c3e620$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$e03209fca4c3e620$var$axios.spread = (parcelRequire("4ePap"));

// Expose isAxiosError
$e03209fca4c3e620$var$axios.isAxiosError = (parcelRequire("3kbWu"));
module.exports = $e03209fca4c3e620$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $e03209fca4c3e620$var$axios;

});
parcelRegister("aNeVr", function(module, exports) {
'use strict';

var $4OK8b = parcelRequire("4OK8b");
// utils is a library of generic helper functions non-specific to axios
var $7dba0ee10f9f7ad9$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isArray(val) {
    return $7dba0ee10f9f7ad9$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isBuffer(val) {
    return val !== null && !$7dba0ee10f9f7ad9$var$isUndefined(val) && val.constructor !== null && !$7dba0ee10f9f7ad9$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isArrayBuffer(val) {
    return $7dba0ee10f9f7ad9$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isPlainObject(val) {
    if ($7dba0ee10f9f7ad9$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isDate(val) {
    return $7dba0ee10f9f7ad9$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isFile(val) {
    return $7dba0ee10f9f7ad9$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isBlob(val) {
    return $7dba0ee10f9f7ad9$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isFunction(val) {
    return $7dba0ee10f9f7ad9$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isStream(val) {
    return $7dba0ee10f9f7ad9$var$isObject(val) && $7dba0ee10f9f7ad9$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $7dba0ee10f9f7ad9$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $7dba0ee10f9f7ad9$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $7dba0ee10f9f7ad9$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($7dba0ee10f9f7ad9$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $7dba0ee10f9f7ad9$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($7dba0ee10f9f7ad9$var$isPlainObject(result[key]) && $7dba0ee10f9f7ad9$var$isPlainObject(val)) result[key] = $7dba0ee10f9f7ad9$var$merge(result[key], val);
        else if ($7dba0ee10f9f7ad9$var$isPlainObject(val)) result[key] = $7dba0ee10f9f7ad9$var$merge({}, val);
        else if ($7dba0ee10f9f7ad9$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$7dba0ee10f9f7ad9$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $7dba0ee10f9f7ad9$var$extend(a, b, thisArg) {
    $7dba0ee10f9f7ad9$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $4OK8b(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $7dba0ee10f9f7ad9$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $7dba0ee10f9f7ad9$var$isArray,
    isArrayBuffer: $7dba0ee10f9f7ad9$var$isArrayBuffer,
    isBuffer: $7dba0ee10f9f7ad9$var$isBuffer,
    isFormData: $7dba0ee10f9f7ad9$var$isFormData,
    isArrayBufferView: $7dba0ee10f9f7ad9$var$isArrayBufferView,
    isString: $7dba0ee10f9f7ad9$var$isString,
    isNumber: $7dba0ee10f9f7ad9$var$isNumber,
    isObject: $7dba0ee10f9f7ad9$var$isObject,
    isPlainObject: $7dba0ee10f9f7ad9$var$isPlainObject,
    isUndefined: $7dba0ee10f9f7ad9$var$isUndefined,
    isDate: $7dba0ee10f9f7ad9$var$isDate,
    isFile: $7dba0ee10f9f7ad9$var$isFile,
    isBlob: $7dba0ee10f9f7ad9$var$isBlob,
    isFunction: $7dba0ee10f9f7ad9$var$isFunction,
    isStream: $7dba0ee10f9f7ad9$var$isStream,
    isURLSearchParams: $7dba0ee10f9f7ad9$var$isURLSearchParams,
    isStandardBrowserEnv: $7dba0ee10f9f7ad9$var$isStandardBrowserEnv,
    forEach: $7dba0ee10f9f7ad9$var$forEach,
    merge: $7dba0ee10f9f7ad9$var$merge,
    extend: $7dba0ee10f9f7ad9$var$extend,
    trim: $7dba0ee10f9f7ad9$var$trim,
    stripBOM: $7dba0ee10f9f7ad9$var$stripBOM
};

});
parcelRegister("4OK8b", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("jXggh", function(module, exports) {
'use strict';

var $aNeVr = parcelRequire("aNeVr");

var $1lccI = parcelRequire("1lccI");

var $cSUMR = parcelRequire("cSUMR");

var $bh1fW = parcelRequire("bh1fW");

var $66OX7 = parcelRequire("66OX7");

var $huV9G = parcelRequire("huV9G");
var $e870243985b8da51$var$validators = $huV9G.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $e870243985b8da51$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $cSUMR(),
        response: new $cSUMR()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $e870243985b8da51$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $66OX7(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $huV9G.assertOptions(transitional, {
        silentJSONParsing: $e870243985b8da51$var$validators.transitional($e870243985b8da51$var$validators.boolean, '1.0.0'),
        forcedJSONParsing: $e870243985b8da51$var$validators.transitional($e870243985b8da51$var$validators.boolean, '1.0.0'),
        clarifyTimeoutError: $e870243985b8da51$var$validators.transitional($e870243985b8da51$var$validators.boolean, '1.0.0')
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $bh1fW,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $bh1fW(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$e870243985b8da51$var$Axios.prototype.getUri = function getUri(config) {
    config = $66OX7(this.defaults, config);
    return $1lccI(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$aNeVr.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $e870243985b8da51$var$Axios.prototype[method] = function(url, config) {
        return this.request($66OX7(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$aNeVr.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $e870243985b8da51$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($66OX7(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $e870243985b8da51$var$Axios;

});
parcelRegister("1lccI", function(module, exports) {
'use strict';

var $aNeVr = parcelRequire("aNeVr");
function $0fa13816d630046e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($aNeVr.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $aNeVr.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($aNeVr.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $aNeVr.forEach(val, function parseValue(v) {
                if ($aNeVr.isDate(v)) v = v.toISOString();
                else if ($aNeVr.isObject(v)) v = JSON.stringify(v);
                parts.push($0fa13816d630046e$var$encode(key) + '=' + $0fa13816d630046e$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("cSUMR", function(module, exports) {
'use strict';

var $aNeVr = parcelRequire("aNeVr");
function $961693ee68106526$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $961693ee68106526$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $961693ee68106526$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $961693ee68106526$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $aNeVr.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $961693ee68106526$var$InterceptorManager;

});

parcelRegister("bh1fW", function(module, exports) {
'use strict';

var $aNeVr = parcelRequire("aNeVr");

var $f9ml8 = parcelRequire("f9ml8");

var $6Jxjx = parcelRequire("6Jxjx");

var $gXqRx = parcelRequire("gXqRx");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $835241ad82c58ec5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $835241ad82c58ec5$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $f9ml8.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $aNeVr.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $aNeVr.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $gXqRx.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $835241ad82c58ec5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $f9ml8.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$6Jxjx(reason)) {
            $835241ad82c58ec5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $f9ml8.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("f9ml8", function(module, exports) {
'use strict';

var $aNeVr = parcelRequire("aNeVr");

var $gXqRx = parcelRequire("gXqRx");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $gXqRx;
    /*eslint no-param-reassign:0*/ $aNeVr.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("gXqRx", function(module, exports) {
'use strict';

var $aNeVr = parcelRequire("aNeVr");

var $cUV9u = parcelRequire("cUV9u");

var $hCq42 = parcelRequire("hCq42");
var $c586fe5a57056b7f$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $c586fe5a57056b7f$var$setContentTypeIfUnset(headers, value) {
    if (!$aNeVr.isUndefined(headers) && $aNeVr.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $c586fe5a57056b7f$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("1T0iT"));
    return adapter;
}
function $c586fe5a57056b7f$var$stringifySafely(rawValue, parser, encoder) {
    if ($aNeVr.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $aNeVr.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $c586fe5a57056b7f$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $c586fe5a57056b7f$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $cUV9u(headers, 'Accept');
            $cUV9u(headers, 'Content-Type');
            if ($aNeVr.isFormData(data) || $aNeVr.isArrayBuffer(data) || $aNeVr.isBuffer(data) || $aNeVr.isStream(data) || $aNeVr.isFile(data) || $aNeVr.isBlob(data)) return data;
            if ($aNeVr.isArrayBufferView(data)) return data.buffer;
            if ($aNeVr.isURLSearchParams(data)) {
                $c586fe5a57056b7f$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($aNeVr.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                $c586fe5a57056b7f$var$setContentTypeIfUnset(headers, 'application/json');
                return $c586fe5a57056b7f$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $aNeVr.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $hCq42(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$c586fe5a57056b7f$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$aNeVr.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $c586fe5a57056b7f$var$defaults.headers[method] = {};
});
$aNeVr.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $c586fe5a57056b7f$var$defaults.headers[method] = $aNeVr.merge($c586fe5a57056b7f$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $c586fe5a57056b7f$var$defaults;

});
parcelRegister("cUV9u", function(module, exports) {
'use strict';

var $aNeVr = parcelRequire("aNeVr");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $aNeVr.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("hCq42", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRegister("1T0iT", function(module, exports) {
'use strict';

var $aNeVr = parcelRequire("aNeVr");

var $gvwMZ = parcelRequire("gvwMZ");

var $dZDQk = parcelRequire("dZDQk");

var $1lccI = parcelRequire("1lccI");

var $ggvJb = parcelRequire("ggvJb");

var $2a5OC = parcelRequire("2a5OC");

var $7j2iw = parcelRequire("7j2iw");

var $i1UXS = parcelRequire("i1UXS");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($aNeVr.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $ggvJb(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $1lccI(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $2a5OC(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $gvwMZ(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($i1UXS('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($i1UXS('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($i1UXS(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($aNeVr.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $7j2iw(fullPath)) && config.xsrfCookieName ? $dZDQk.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $aNeVr.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$aNeVr.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("gvwMZ", function(module, exports) {
'use strict';

var $i1UXS = parcelRequire("i1UXS");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($i1UXS('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("i1UXS", function(module, exports) {
'use strict';

var $hCq42 = parcelRequire("hCq42");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $hCq42(error, config, code, request, response);
};

});


parcelRegister("dZDQk", function(module, exports) {
'use strict';

var $aNeVr = parcelRequire("aNeVr");
module.exports = $aNeVr.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($aNeVr.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($aNeVr.isString(path)) cookie.push('path=' + path);
            if ($aNeVr.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("ggvJb", function(module, exports) {
'use strict';

var $BlY7o = parcelRequire("BlY7o");

var $5pRfF = parcelRequire("5pRfF");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$BlY7o(requestedURL)) return $5pRfF(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("BlY7o", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("5pRfF", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("2a5OC", function(module, exports) {
'use strict';

var $aNeVr = parcelRequire("aNeVr");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $193106c7feb4405c$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $aNeVr.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $aNeVr.trim(line.substr(0, i)).toLowerCase();
        val = $aNeVr.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $193106c7feb4405c$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("7j2iw", function(module, exports) {
'use strict';

var $aNeVr = parcelRequire("aNeVr");
module.exports = $aNeVr.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $aNeVr.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("6Jxjx", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("66OX7", function(module, exports) {
'use strict';

var $aNeVr = parcelRequire("aNeVr");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy',
        'params'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'timeoutMessage',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'decompress',
        'maxContentLength',
        'maxBodyLength',
        'maxRedirects',
        'transport',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath',
        'responseEncoding'
    ];
    var directMergeKeys = [
        'validateStatus'
    ];
    function getMergedValue(target, source) {
        if ($aNeVr.isPlainObject(target) && $aNeVr.isPlainObject(source)) return $aNeVr.merge(target, source);
        else if ($aNeVr.isPlainObject(source)) return $aNeVr.merge({}, source);
        else if ($aNeVr.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$aNeVr.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$aNeVr.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $aNeVr.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$aNeVr.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $aNeVr.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $aNeVr.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$aNeVr.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$aNeVr.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $aNeVr.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $aNeVr.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRegister("huV9G", function(module, exports) {
'use strict';

var $3iRQA = parcelRequire("3iRQA");
var $cbd192d8ec56dbf7$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $cbd192d8ec56dbf7$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $cbd192d8ec56dbf7$var$deprecatedWarnings = {};
var $cbd192d8ec56dbf7$var$currentVerArr = $3iRQA.version.split('.');
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $cbd192d8ec56dbf7$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split('.') : $cbd192d8ec56dbf7$var$currentVerArr;
    var destVer = version.split('.');
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $cbd192d8ec56dbf7$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $cbd192d8ec56dbf7$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return '[Axios v' + $3iRQA.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed in ' + version));
        if (isDeprecated && !$cbd192d8ec56dbf7$var$deprecatedWarnings[opt]) {
            $cbd192d8ec56dbf7$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $cbd192d8ec56dbf7$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    isOlderVersion: $cbd192d8ec56dbf7$var$isOlderVersion,
    assertOptions: $cbd192d8ec56dbf7$var$assertOptions,
    validators: $cbd192d8ec56dbf7$var$validators
};

});
parcelRegister("3iRQA", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"axios\",\"version\":\"0.21.4\",\"description\":\"Promise based HTTP client for the browser and node.js\",\"main\":\"index.js\",\"scripts\":{\"test\":\"grunt test\",\"start\":\"node ./sandbox/server.js\",\"build\":\"NODE_ENV=production grunt build\",\"preversion\":\"npm test\",\"version\":\"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json\",\"postversion\":\"git push && git push --tags\",\"examples\":\"node ./examples/server.js\",\"coveralls\":\"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js\",\"fix\":\"eslint --fix lib/**/*.js\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/axios/axios.git\"},\"keywords\":[\"xhr\",\"http\",\"ajax\",\"promise\",\"node\"],\"author\":\"Matt Zabriskie\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/axios/axios/issues\"},\"homepage\":\"https://axios-http.com\",\"devDependencies\":{\"coveralls\":\"^3.0.0\",\"es6-promise\":\"^4.2.4\",\"grunt\":\"^1.3.0\",\"grunt-banner\":\"^0.6.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-clean\":\"^1.1.0\",\"grunt-contrib-watch\":\"^1.0.0\",\"grunt-eslint\":\"^23.0.0\",\"grunt-karma\":\"^4.0.0\",\"grunt-mocha-test\":\"^0.13.3\",\"grunt-ts\":\"^6.0.0-beta.19\",\"grunt-webpack\":\"^4.0.2\",\"istanbul-instrumenter-loader\":\"^1.0.0\",\"jasmine-core\":\"^2.4.1\",\"karma\":\"^6.3.2\",\"karma-chrome-launcher\":\"^3.1.0\",\"karma-firefox-launcher\":\"^2.1.0\",\"karma-jasmine\":\"^1.1.1\",\"karma-jasmine-ajax\":\"^0.1.13\",\"karma-safari-launcher\":\"^1.0.0\",\"karma-sauce-launcher\":\"^4.3.6\",\"karma-sinon\":\"^1.0.5\",\"karma-sourcemap-loader\":\"^0.3.8\",\"karma-webpack\":\"^4.0.2\",\"load-grunt-tasks\":\"^3.5.2\",\"minimist\":\"^1.2.0\",\"mocha\":\"^8.2.1\",\"sinon\":\"^4.5.0\",\"terser-webpack-plugin\":\"^4.2.3\",\"typescript\":\"^4.0.5\",\"url-search-params\":\"^0.10.0\",\"webpack\":\"^4.44.2\",\"webpack-dev-server\":\"^3.11.0\"},\"browser\":{\"./lib/adapters/http.js\":\"./lib/adapters/xhr.js\"},\"jsdelivr\":\"dist/axios.min.js\",\"unpkg\":\"dist/axios.min.js\",\"typings\":\"./index.d.ts\",\"dependencies\":{\"follow-redirects\":\"^1.14.0\"},\"bundlesize\":[{\"path\":\"./dist/axios.min.js\",\"threshold\":\"5kB\"}]}");

});



parcelRegister("hLgSx", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $cee3eb341896ac2c$var$Cancel(message) {
    this.message = message;
}
$cee3eb341896ac2c$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$cee3eb341896ac2c$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $cee3eb341896ac2c$var$Cancel;

});

parcelRegister("hKXYi", function(module, exports) {
'use strict';

var $hLgSx = parcelRequire("hLgSx");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $ced540a01b7d919c$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $hLgSx(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $ced540a01b7d919c$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $ced540a01b7d919c$var$CancelToken.source = function source() {
    var cancel;
    var token = new $ced540a01b7d919c$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $ced540a01b7d919c$var$CancelToken;

});

parcelRegister("4ePap", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("3kbWu", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});


parcelRegister("2hmD9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $1a8eb94159b74387$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$1a8eb94159b74387$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($1a8eb94159b74387$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $1a8eb94159b74387$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("4aO2u", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $309ee94f73526840$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $309ee94f73526840$var$map($309ee94f73526840$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($309ee94f73526840$var$stringifyPrimitive(k)) + eq;
        if ($309ee94f73526840$var$isArray(obj[k])) return $309ee94f73526840$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($309ee94f73526840$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($309ee94f73526840$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($309ee94f73526840$var$stringifyPrimitive(name)) + eq + encodeURIComponent($309ee94f73526840$var$stringifyPrimitive(obj));
};
var $309ee94f73526840$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $309ee94f73526840$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $309ee94f73526840$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});

parcelRegister("kh2Rv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $4H3Nt = parcelRequire("4H3Nt");
function $ec279d803f66d50f$var$emptyFunction() {}
function $ec279d803f66d50f$var$emptyFunctionWithReset() {}
$ec279d803f66d50f$var$emptyFunctionWithReset.resetWarningCache = $ec279d803f66d50f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $4H3Nt) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $ec279d803f66d50f$var$emptyFunctionWithReset,
        resetWarningCache: $ec279d803f66d50f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("4H3Nt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $36ae1f94766f6c68$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $36ae1f94766f6c68$var$ReactPropTypesSecret;

});


parcelRegister("95oGi", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $69d7b9e0f9338877$export$a7c73072b1a182ae; }, function (v) { return $69d7b9e0f9338877$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $69d7b9e0f9338877$export$9f27bc3417b4524d; }, function (v) { return $69d7b9e0f9338877$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $69d7b9e0f9338877$export$db77ccec0bb4ccac; }, function (v) { return $69d7b9e0f9338877$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $69d7b9e0f9338877$export$8392c0c9d3dcbd35; }, function (v) { return $69d7b9e0f9338877$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $69d7b9e0f9338877$export$ffb0004e005737fa; }, function (v) { return $69d7b9e0f9338877$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $69d7b9e0f9338877$export$b624eff549462981; }, function (v) { return $69d7b9e0f9338877$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $69d7b9e0f9338877$export$7897aa7841a5380c; }, function (v) { return $69d7b9e0f9338877$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $69d7b9e0f9338877$export$602eac185826482c; }, function (v) { return $69d7b9e0f9338877$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $69d7b9e0f9338877$export$e2c29f18771995cb; }, function (v) { return $69d7b9e0f9338877$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $69d7b9e0f9338877$export$5f8d39834fd61797; }, function (v) { return $69d7b9e0f9338877$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $69d7b9e0f9338877$export$74bf444e3cd11ea5; }, function (v) { return $69d7b9e0f9338877$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $69d7b9e0f9338877$export$998bcd577473dd93; }, function (v) { return $69d7b9e0f9338877$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $69d7b9e0f9338877$export$92387174baf9b227; }, function (v) { return $69d7b9e0f9338877$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $69d7b9e0f9338877$export$ec112efeb987d9c6; }, function (v) { return $69d7b9e0f9338877$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $69d7b9e0f9338877$export$b706b080d889d2c9; }, function (v) { return $69d7b9e0f9338877$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $69d7b9e0f9338877$export$5be5a87408f70ddc; }, function (v) { return $69d7b9e0f9338877$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $69d7b9e0f9338877$export$45a5e7f76e0caa8d; }, function (v) { return $69d7b9e0f9338877$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $69d7b9e0f9338877$export$455c2e768291efa6; }, function (v) { return $69d7b9e0f9338877$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $69d7b9e0f9338877$export$9522e17588c12572; }, function (v) { return $69d7b9e0f9338877$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $69d7b9e0f9338877$export$2110ac352bb060b9; }, function (v) { return $69d7b9e0f9338877$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $69d7b9e0f9338877$export$56885ab8b9c456ab; }, function (v) { return $69d7b9e0f9338877$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $69d7b9e0f9338877$export$d927fcb6adf8f9de; }, function (v) { return $69d7b9e0f9338877$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $69d7b9e0f9338877$export$b82d16f27459e05a; }, function (v) { return $69d7b9e0f9338877$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $69d7b9e0f9338877$export$522c17b4f5e123e8; }, function (v) { return $69d7b9e0f9338877$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $69d7b9e0f9338877$export$1aabd8a0274ecfd6; }, function (v) { return $69d7b9e0f9338877$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $69d7b9e0f9338877$export$3d6c20d97e46b957; }, function (v) { return $69d7b9e0f9338877$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $69d7b9e0f9338877$export$9b621391a187a31a; }, function (v) { return $69d7b9e0f9338877$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $69d7b9e0f9338877$export$f5bbd400c2f4426f; }, function (v) { return $69d7b9e0f9338877$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $69d7b9e0f9338877$export$a7c73072b1a182ae;
var $69d7b9e0f9338877$export$9f27bc3417b4524d;
var $69d7b9e0f9338877$export$db77ccec0bb4ccac;
var $69d7b9e0f9338877$export$8392c0c9d3dcbd35;
var $69d7b9e0f9338877$export$ffb0004e005737fa;
var $69d7b9e0f9338877$export$b624eff549462981;
var $69d7b9e0f9338877$export$7897aa7841a5380c;
var $69d7b9e0f9338877$export$602eac185826482c;
var $69d7b9e0f9338877$export$e2c29f18771995cb;
var $69d7b9e0f9338877$export$5f8d39834fd61797;
var $69d7b9e0f9338877$export$74bf444e3cd11ea5;
var $69d7b9e0f9338877$export$998bcd577473dd93;
var $69d7b9e0f9338877$export$92387174baf9b227;
var $69d7b9e0f9338877$export$ec112efeb987d9c6;
var $69d7b9e0f9338877$export$b706b080d889d2c9;
var $69d7b9e0f9338877$export$5be5a87408f70ddc;
var $69d7b9e0f9338877$export$45a5e7f76e0caa8d;
var $69d7b9e0f9338877$export$455c2e768291efa6;
var $69d7b9e0f9338877$export$9522e17588c12572;
var $69d7b9e0f9338877$export$2110ac352bb060b9;
var $69d7b9e0f9338877$export$56885ab8b9c456ab;
var $69d7b9e0f9338877$export$d927fcb6adf8f9de;
var $69d7b9e0f9338877$export$b82d16f27459e05a;
var $69d7b9e0f9338877$export$522c17b4f5e123e8;
var $69d7b9e0f9338877$export$1aabd8a0274ecfd6;
var $69d7b9e0f9338877$export$3d6c20d97e46b957;
var $69d7b9e0f9338877$export$9b621391a187a31a;
var $69d7b9e0f9338877$export$f5bbd400c2f4426f;
'use strict';
var $69d7b9e0f9338877$var$b = Symbol.for("react.element"), $69d7b9e0f9338877$var$c = Symbol.for("react.portal"), $69d7b9e0f9338877$var$d = Symbol.for("react.fragment"), $69d7b9e0f9338877$var$e = Symbol.for("react.strict_mode"), $69d7b9e0f9338877$var$f = Symbol.for("react.profiler"), $69d7b9e0f9338877$var$g = Symbol.for("react.provider"), $69d7b9e0f9338877$var$h = Symbol.for("react.context"), $69d7b9e0f9338877$var$k = Symbol.for("react.server_context"), $69d7b9e0f9338877$var$l = Symbol.for("react.forward_ref"), $69d7b9e0f9338877$var$m = Symbol.for("react.suspense"), $69d7b9e0f9338877$var$n = Symbol.for("react.suspense_list"), $69d7b9e0f9338877$var$p = Symbol.for("react.memo"), $69d7b9e0f9338877$var$q = Symbol.for("react.lazy"), $69d7b9e0f9338877$var$t = Symbol.for("react.offscreen"), $69d7b9e0f9338877$var$u;
$69d7b9e0f9338877$var$u = Symbol.for("react.module.reference");
function $69d7b9e0f9338877$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $69d7b9e0f9338877$var$b:
                switch(a = a.type, a){
                    case $69d7b9e0f9338877$var$d:
                    case $69d7b9e0f9338877$var$f:
                    case $69d7b9e0f9338877$var$e:
                    case $69d7b9e0f9338877$var$m:
                    case $69d7b9e0f9338877$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $69d7b9e0f9338877$var$k:
                            case $69d7b9e0f9338877$var$h:
                            case $69d7b9e0f9338877$var$l:
                            case $69d7b9e0f9338877$var$q:
                            case $69d7b9e0f9338877$var$p:
                            case $69d7b9e0f9338877$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $69d7b9e0f9338877$var$c:
                return r;
        }
    }
}
$69d7b9e0f9338877$export$a7c73072b1a182ae = $69d7b9e0f9338877$var$h;
$69d7b9e0f9338877$export$9f27bc3417b4524d = $69d7b9e0f9338877$var$g;
$69d7b9e0f9338877$export$db77ccec0bb4ccac = $69d7b9e0f9338877$var$b;
$69d7b9e0f9338877$export$8392c0c9d3dcbd35 = $69d7b9e0f9338877$var$l;
$69d7b9e0f9338877$export$ffb0004e005737fa = $69d7b9e0f9338877$var$d;
$69d7b9e0f9338877$export$b624eff549462981 = $69d7b9e0f9338877$var$q;
$69d7b9e0f9338877$export$7897aa7841a5380c = $69d7b9e0f9338877$var$p;
$69d7b9e0f9338877$export$602eac185826482c = $69d7b9e0f9338877$var$c;
$69d7b9e0f9338877$export$e2c29f18771995cb = $69d7b9e0f9338877$var$f;
$69d7b9e0f9338877$export$5f8d39834fd61797 = $69d7b9e0f9338877$var$e;
$69d7b9e0f9338877$export$74bf444e3cd11ea5 = $69d7b9e0f9338877$var$m;
$69d7b9e0f9338877$export$998bcd577473dd93 = $69d7b9e0f9338877$var$n;
$69d7b9e0f9338877$export$92387174baf9b227 = function() {
    return !1;
};
$69d7b9e0f9338877$export$ec112efeb987d9c6 = function() {
    return !1;
};
$69d7b9e0f9338877$export$b706b080d889d2c9 = function(a) {
    return $69d7b9e0f9338877$var$v(a) === $69d7b9e0f9338877$var$h;
};
$69d7b9e0f9338877$export$5be5a87408f70ddc = function(a) {
    return $69d7b9e0f9338877$var$v(a) === $69d7b9e0f9338877$var$g;
};
$69d7b9e0f9338877$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $69d7b9e0f9338877$var$b;
};
$69d7b9e0f9338877$export$455c2e768291efa6 = function(a) {
    return $69d7b9e0f9338877$var$v(a) === $69d7b9e0f9338877$var$l;
};
$69d7b9e0f9338877$export$9522e17588c12572 = function(a) {
    return $69d7b9e0f9338877$var$v(a) === $69d7b9e0f9338877$var$d;
};
$69d7b9e0f9338877$export$2110ac352bb060b9 = function(a) {
    return $69d7b9e0f9338877$var$v(a) === $69d7b9e0f9338877$var$q;
};
$69d7b9e0f9338877$export$56885ab8b9c456ab = function(a) {
    return $69d7b9e0f9338877$var$v(a) === $69d7b9e0f9338877$var$p;
};
$69d7b9e0f9338877$export$d927fcb6adf8f9de = function(a) {
    return $69d7b9e0f9338877$var$v(a) === $69d7b9e0f9338877$var$c;
};
$69d7b9e0f9338877$export$b82d16f27459e05a = function(a) {
    return $69d7b9e0f9338877$var$v(a) === $69d7b9e0f9338877$var$f;
};
$69d7b9e0f9338877$export$522c17b4f5e123e8 = function(a) {
    return $69d7b9e0f9338877$var$v(a) === $69d7b9e0f9338877$var$e;
};
$69d7b9e0f9338877$export$1aabd8a0274ecfd6 = function(a) {
    return $69d7b9e0f9338877$var$v(a) === $69d7b9e0f9338877$var$m;
};
$69d7b9e0f9338877$export$3d6c20d97e46b957 = function(a) {
    return $69d7b9e0f9338877$var$v(a) === $69d7b9e0f9338877$var$n;
};
$69d7b9e0f9338877$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $69d7b9e0f9338877$var$d || a === $69d7b9e0f9338877$var$f || a === $69d7b9e0f9338877$var$e || a === $69d7b9e0f9338877$var$m || a === $69d7b9e0f9338877$var$n || a === $69d7b9e0f9338877$var$t || "object" === typeof a && null !== a && (a.$$typeof === $69d7b9e0f9338877$var$q || a.$$typeof === $69d7b9e0f9338877$var$p || a.$$typeof === $69d7b9e0f9338877$var$g || a.$$typeof === $69d7b9e0f9338877$var$h || a.$$typeof === $69d7b9e0f9338877$var$l || a.$$typeof === $69d7b9e0f9338877$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$69d7b9e0f9338877$export$f5bbd400c2f4426f = $69d7b9e0f9338877$var$v;

});

parcelRegister("fdbil", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $17axB = parcelRequire("17axB");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $17axB.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $17axB.default)(Rgb, rgb, (0, $17axB.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $17axB.default)(Hsl, hsl, (0, $17axB.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("17axB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cfe9f1c97469f16$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $0cfe9f1c97469f16$export$8b58be045bf06082; });
function $0cfe9f1c97469f16$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $0cfe9f1c97469f16$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("bjWEU", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    var _$breadcrumbTypes_17 = [
        'navigation',
        'request',
        'process',
        'log',
        'user',
        'state',
        'error',
        'manual'
    ];
    // Array#reduce
    var _$reduce_26 = function(arr, fn, accum) {
        var val = accum;
        for(var i = 0, len = arr.length; i < len; i++)val = fn(val, arr[i], i, arr);
        return val;
    };
    // Array#filter
    var _$filter_21 = function(arr, fn) {
        return _$reduce_26(arr, function(accum, item, i, arr) {
            return !fn(item, i, arr) ? accum : accum.concat(item);
        }, []);
    };
    // Array#includes
    var _$includes_22 = function(arr, x) {
        return _$reduce_26(arr, function(accum, item, i, arr) {
            return accum === true || item === x;
        }, false);
    };
    // Array#isArray
    var _$isArray_23 = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    /* eslint-disable-next-line no-prototype-builtins */ var _hasDontEnumBug = !({
        toString: null
    }).propertyIsEnumerable('toString');
    var _dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    // Object#keys
    var _$keys_24 = function(obj) {
        // stripped down version of
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/Keys
        var result = [];
        var prop;
        for(prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) result.push(prop);
        if (!_hasDontEnumBug) return result;
        for(var i = 0, len = _dontEnums.length; i < len; i++)if (Object.prototype.hasOwnProperty.call(obj, _dontEnums[i])) result.push(_dontEnums[i]);
        return result;
    };
    var _$intRange_33 = function(min, max) {
        if (min === void 0) min = 1;
        if (max === void 0) max = Infinity;
        return function(value) {
            return typeof value === 'number' && parseInt('' + value, 10) === value && value >= min && value <= max;
        };
    };
    var _$listOfFunctions_34 = function(value) {
        return typeof value === 'function' || _$isArray_23(value) && _$filter_21(value, function(f) {
            return typeof f === 'function';
        }).length === value.length;
    };
    var _$stringWithLength_35 = function(value) {
        return typeof value === 'string' && !!value.length;
    };
    var _$config_14 = {};
    var defaultErrorTypes = function() {
        return {
            unhandledExceptions: true,
            unhandledRejections: true
        };
    };
    _$config_14.schema = {
        apiKey: {
            defaultValue: function() {
                return null;
            },
            message: 'is required',
            validate: _$stringWithLength_35
        },
        appVersion: {
            defaultValue: function() {
                return undefined;
            },
            message: 'should be a string',
            validate: function(value) {
                return value === undefined || _$stringWithLength_35(value);
            }
        },
        appType: {
            defaultValue: function() {
                return undefined;
            },
            message: 'should be a string',
            validate: function(value) {
                return value === undefined || _$stringWithLength_35(value);
            }
        },
        autoDetectErrors: {
            defaultValue: function() {
                return true;
            },
            message: 'should be true|false',
            validate: function(value) {
                return value === true || value === false;
            }
        },
        enabledErrorTypes: {
            defaultValue: function() {
                return defaultErrorTypes();
            },
            message: 'should be an object containing the flags { unhandledExceptions:true|false, unhandledRejections:true|false }',
            allowPartialObject: true,
            validate: function(value) {
                // ensure we have an object
                if (typeof value !== 'object' || !value) return false;
                var providedKeys = _$keys_24(value);
                var defaultKeys = _$keys_24(defaultErrorTypes());
                // ensure it only has a subset of the allowed keys
                if (_$filter_21(providedKeys, function(k) {
                    return _$includes_22(defaultKeys, k);
                }).length < providedKeys.length) return false;
                // ensure all of the values are boolean
                if (_$filter_21(_$keys_24(value), function(k) {
                    return typeof value[k] !== 'boolean';
                }).length > 0) return false;
                return true;
            }
        },
        onError: {
            defaultValue: function() {
                return [];
            },
            message: 'should be a function or array of functions',
            validate: _$listOfFunctions_34
        },
        onSession: {
            defaultValue: function() {
                return [];
            },
            message: 'should be a function or array of functions',
            validate: _$listOfFunctions_34
        },
        onBreadcrumb: {
            defaultValue: function() {
                return [];
            },
            message: 'should be a function or array of functions',
            validate: _$listOfFunctions_34
        },
        endpoints: {
            defaultValue: function(endpoints) {
                // only apply the default value if no endpoints have been provided, otherwise prevent delivery by setting to null
                if (typeof endpoints === 'undefined') return {
                    notify: 'https://notify.bugsnag.com',
                    sessions: 'https://sessions.bugsnag.com'
                };
                else return {
                    notify: null,
                    sessions: null
                };
            },
            message: 'should be an object containing endpoint URLs { notify, sessions }',
            validate: function(val) {
                return(// first, ensure it's an object
                val && typeof val === 'object' && // notify and sessions must always be set
                _$stringWithLength_35(val.notify) && _$stringWithLength_35(val.sessions) && // ensure no keys other than notify/session are set on endpoints object
                _$filter_21(_$keys_24(val), function(k) {
                    return !_$includes_22([
                        'notify',
                        'sessions'
                    ], k);
                }).length === 0);
            }
        },
        autoTrackSessions: {
            defaultValue: function(val) {
                return true;
            },
            message: 'should be true|false',
            validate: function(val) {
                return val === true || val === false;
            }
        },
        enabledReleaseStages: {
            defaultValue: function() {
                return null;
            },
            message: 'should be an array of strings',
            validate: function(value) {
                return value === null || _$isArray_23(value) && _$filter_21(value, function(f) {
                    return typeof f === 'string';
                }).length === value.length;
            }
        },
        releaseStage: {
            defaultValue: function() {
                return 'production';
            },
            message: 'should be a string',
            validate: function(value) {
                return typeof value === 'string' && value.length;
            }
        },
        maxBreadcrumbs: {
            defaultValue: function() {
                return 25;
            },
            message: "should be a number \u2264100",
            validate: function(value) {
                return _$intRange_33(0, 100)(value);
            }
        },
        enabledBreadcrumbTypes: {
            defaultValue: function() {
                return _$breadcrumbTypes_17;
            },
            message: "should be null or a list of available breadcrumb types (" + _$breadcrumbTypes_17.join(',') + ")",
            validate: function(value) {
                return value === null || _$isArray_23(value) && _$reduce_26(value, function(accum, maybeType) {
                    if (accum === false) return accum;
                    return _$includes_22(_$breadcrumbTypes_17, maybeType);
                }, true);
            }
        },
        context: {
            defaultValue: function() {
                return undefined;
            },
            message: 'should be a string',
            validate: function(value) {
                return value === undefined || typeof value === 'string';
            }
        },
        user: {
            defaultValue: function() {
                return {};
            },
            message: 'should be an object with { id, email, name } properties',
            validate: function(value) {
                return value === null || value && _$reduce_26(_$keys_24(value), function(accum, key) {
                    return accum && _$includes_22([
                        'id',
                        'email',
                        'name'
                    ], key);
                }, true);
            }
        },
        metadata: {
            defaultValue: function() {
                return {};
            },
            message: 'should be an object',
            validate: function(value) {
                return typeof value === 'object' && value !== null;
            }
        },
        logger: {
            defaultValue: function() {
                return undefined;
            },
            message: 'should be null or an object with methods { debug, info, warn, error }',
            validate: function(value) {
                return !value || value && _$reduce_26([
                    'debug',
                    'info',
                    'warn',
                    'error'
                ], function(accum, method) {
                    return accum && typeof value[method] === 'function';
                }, true);
            }
        },
        redactedKeys: {
            defaultValue: function() {
                return [
                    'password'
                ];
            },
            message: 'should be an array of strings|regexes',
            validate: function(value) {
                return _$isArray_23(value) && value.length === _$filter_21(value, function(s) {
                    return typeof s === 'string' || s && typeof s.test === 'function';
                }).length;
            }
        },
        plugins: {
            defaultValue: function() {
                return [];
            },
            message: 'should be an array of plugin objects',
            validate: function(value) {
                return _$isArray_23(value) && value.length === _$filter_21(value, function(p) {
                    return p && typeof p === 'object' && typeof p.load === 'function';
                }).length;
            }
        },
        featureFlags: {
            defaultValue: function() {
                return [];
            },
            message: 'should be an array of objects that have a "name" property',
            validate: function(value) {
                return _$isArray_23(value) && value.length === _$filter_21(value, function(feature) {
                    return feature && typeof feature === 'object' && typeof feature.name === 'string';
                }).length;
            }
        },
        reportUnhandledPromiseRejectionsAsHandled: {
            defaultValue: function() {
                return false;
            },
            message: 'should be true|false',
            validate: function(value) {
                return value === true || value === false;
            }
        },
        sendPayloadChecksums: {
            defaultValue: function() {
                return false;
            },
            message: 'should be true|false',
            validate: function(value) {
                return value === true || value === false;
            }
        }
    };
    // extends helper from babel
    // https://github.com/babel/babel/blob/916429b516e6466fd06588ee820e40e025d7f3a3/packages/babel-helpers/src/helpers.js#L377-L393
    var _$assign_20 = function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    // Array#map
    var _$map_25 = function(arr, fn) {
        return _$reduce_26(arr, function(accum, item, i, arr) {
            return accum.concat(fn(item, i, arr));
        }, []);
    };
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    var schema = _$config_14.schema;
    var _$config_10 = {
        releaseStage: _$assign_20({}, schema.releaseStage, {
            defaultValue: function() {
                if (/^localhost(:\d+)?$/.test(window.location.host)) return 'development';
                return 'production';
            }
        }),
        appType: _extends({}, schema.appType, {
            defaultValue: function() {
                return 'browser';
            }
        }),
        logger: _$assign_20({}, schema.logger, {
            defaultValue: function() {
                return(// set logger based on browser capability
                typeof console !== 'undefined' && typeof console.debug === 'function' ? getPrefixedConsole() : undefined);
            }
        })
    };
    var getPrefixedConsole = function() {
        var logger = {};
        var consoleLog = console.log;
        _$map_25([
            'debug',
            'info',
            'warn',
            'error'
        ], function(method) {
            var consoleMethod = console[method];
            logger[method] = typeof consoleMethod === 'function' ? consoleMethod.bind(console, '[bugsnag]') : consoleLog.bind(console, '[bugsnag]');
        });
        return logger;
    };
    var Breadcrumb = /*#__PURE__*/ function() {
        function Breadcrumb(message, metadata, type, timestamp) {
            if (timestamp === void 0) timestamp = new Date();
            this.type = type;
            this.message = message;
            this.metadata = metadata;
            this.timestamp = timestamp;
        }
        var _proto = Breadcrumb.prototype;
        _proto.toJSON = function toJSON() {
            return {
                type: this.type,
                name: this.message,
                timestamp: this.timestamp,
                metaData: this.metadata
            };
        };
        return Breadcrumb;
    }();
    var _$Breadcrumb_12 = Breadcrumb;
    var _$stackframe_9 = {};
    (function(root, factory) {
        'use strict';
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('stackframe', [], factory);
        else if (typeof _$stackframe_9 === 'object') _$stackframe_9 = factory();
        else root.StackFrame = factory();
    })(this, function() {
        'use strict';
        function _isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
        function _capitalize(str) {
            return str.charAt(0).toUpperCase() + str.substring(1);
        }
        function _getter(p) {
            return function() {
                return this[p];
            };
        }
        var booleanProps = [
            'isConstructor',
            'isEval',
            'isNative',
            'isToplevel'
        ];
        var numericProps = [
            'columnNumber',
            'lineNumber'
        ];
        var stringProps = [
            'fileName',
            'functionName',
            'source'
        ];
        var arrayProps = [
            'args'
        ];
        var objectProps = [
            'evalOrigin'
        ];
        var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);
        function StackFrame(obj) {
            if (!obj) return;
            for(var i = 0; i < props.length; i++)if (obj[props[i]] !== undefined) this['set' + _capitalize(props[i])](obj[props[i]]);
        }
        StackFrame.prototype = {
            getArgs: function() {
                return this.args;
            },
            setArgs: function(v) {
                if (Object.prototype.toString.call(v) !== '[object Array]') throw new TypeError('Args must be an Array');
                this.args = v;
            },
            getEvalOrigin: function() {
                return this.evalOrigin;
            },
            setEvalOrigin: function(v) {
                if (v instanceof StackFrame) this.evalOrigin = v;
                else if (v instanceof Object) this.evalOrigin = new StackFrame(v);
                else throw new TypeError('Eval Origin must be an Object or StackFrame');
            },
            toString: function() {
                var fileName = this.getFileName() || '';
                var lineNumber = this.getLineNumber() || '';
                var columnNumber = this.getColumnNumber() || '';
                var functionName = this.getFunctionName() || '';
                if (this.getIsEval()) {
                    if (fileName) return '[eval] (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
                    return '[eval]:' + lineNumber + ':' + columnNumber;
                }
                if (functionName) return functionName + ' (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
                return fileName + ':' + lineNumber + ':' + columnNumber;
            }
        };
        StackFrame.fromString = function StackFrame$$fromString(str) {
            var argsStartIndex = str.indexOf('(');
            var argsEndIndex = str.lastIndexOf(')');
            var functionName = str.substring(0, argsStartIndex);
            var args = str.substring(argsStartIndex + 1, argsEndIndex).split(',');
            var locationString = str.substring(argsEndIndex + 1);
            if (locationString.indexOf('@') === 0) {
                var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, '');
                var fileName = parts[1];
                var lineNumber = parts[2];
                var columnNumber = parts[3];
            }
            return new StackFrame({
                functionName: functionName,
                args: args || undefined,
                fileName: fileName,
                lineNumber: lineNumber || undefined,
                columnNumber: columnNumber || undefined
            });
        };
        for(var i = 0; i < booleanProps.length; i++){
            StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
            StackFrame.prototype['set' + _capitalize(booleanProps[i])] = function(p) {
                return function(v) {
                    this[p] = Boolean(v);
                };
            }(booleanProps[i]);
        }
        for(var j = 0; j < numericProps.length; j++){
            StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
            StackFrame.prototype['set' + _capitalize(numericProps[j])] = function(p) {
                return function(v) {
                    if (!_isNumber(v)) throw new TypeError(p + ' must be a Number');
                    this[p] = Number(v);
                };
            }(numericProps[j]);
        }
        for(var k = 0; k < stringProps.length; k++){
            StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
            StackFrame.prototype['set' + _capitalize(stringProps[k])] = function(p) {
                return function(v) {
                    this[p] = String(v);
                };
            }(stringProps[k]);
        }
        return StackFrame;
    });
    var _$stackGenerator_8 = {};
    (function(root, factory) {
        'use strict';
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('stack-generator', [
            'stackframe'
        ], factory);
        else if (typeof _$stackGenerator_8 === 'object') _$stackGenerator_8 = factory(_$stackframe_9);
        else root.StackGenerator = factory(root.StackFrame);
    })(this, function(StackFrame) {
        return {
            backtrace: function StackGenerator$$backtrace(opts) {
                var stack = [];
                var maxStackSize = 10;
                if (typeof opts === 'object' && typeof opts.maxStackSize === 'number') maxStackSize = opts.maxStackSize;
                var curr = arguments.callee;
                while(curr && stack.length < maxStackSize && curr['arguments']){
                    // Allow V8 optimizations
                    var args = new Array(curr['arguments'].length);
                    for(var i = 0; i < args.length; ++i)args[i] = curr['arguments'][i];
                    if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) stack.push(new StackFrame({
                        functionName: RegExp.$1 || undefined,
                        args: args
                    }));
                    else stack.push(new StackFrame({
                        args: args
                    }));
                    try {
                        curr = curr.caller;
                    } catch (e) {
                        break;
                    }
                }
                return stack;
            }
        };
    });
    var _$errorStackParser_6 = {};
    (function(root, factory) {
        'use strict';
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('error-stack-parser', [
            'stackframe'
        ], factory);
        else if (typeof _$errorStackParser_6 === 'object') _$errorStackParser_6 = factory(_$stackframe_9);
        else root.ErrorStackParser = factory(root.StackFrame);
    })(this, function ErrorStackParser(StackFrame) {
        'use strict';
        var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
        var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
        var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;
        return {
            /**
     * Given an Error object, extract the most information from it.
     *
     * @param {Error} error object
     * @return {Array} of StackFrames
     */ parse: function ErrorStackParser$$parse(error) {
                if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') return this.parseOpera(error);
                else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
                else if (error.stack) return this.parseFFOrSafari(error);
                else throw new Error('Cannot parse given Error object');
            },
            // Separate line and column numbers from a string of the form: (URI:Line:Column)
            extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
                // Fail-fast but return locations like "(native)"
                if (urlLike.indexOf(':') === -1) return [
                    urlLike
                ];
                var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
                var parts = regExp.exec(urlLike.replace(/[()]/g, ''));
                return [
                    parts[1],
                    parts[2] || undefined,
                    parts[3] || undefined
                ];
            },
            parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !!line.match(CHROME_IE_STACK_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    if (line.indexOf('(eval ') > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^()]*)|(\),.*$)/g, '');
                    var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '(');
                    // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                    // case it has spaces in it, as the string is split on \s+ later on
                    var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/);
                    // remove the parenthesized location from the line, if it was matched
                    sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;
                    var tokens = sanitizedLine.split(/\s+/).slice(1);
                    // if a location was matched, pass it to extractLocation() otherwise pop the last token
                    var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
                    var functionName = tokens.join(' ') || undefined;
                    var fileName = [
                        'eval',
                        '<anonymous>'
                    ].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
                    return new StackFrame({
                        functionName: functionName,
                        fileName: fileName,
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            },
            parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !line.match(SAFARI_NATIVE_CODE_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    if (line.indexOf(' > eval') > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ':$1');
                    if (line.indexOf('@') === -1 && line.indexOf(':') === -1) // Safari eval frames only have function names and nothing else
                    return new StackFrame({
                        functionName: line
                    });
                    else {
                        var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                        var matches = line.match(functionNameRegex);
                        var functionName = matches && matches[1] ? matches[1] : undefined;
                        var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));
                        return new StackFrame({
                            functionName: functionName,
                            fileName: locationParts[0],
                            lineNumber: locationParts[1],
                            columnNumber: locationParts[2],
                            source: line
                        });
                    }
                }, this);
            },
            parseOpera: function ErrorStackParser$$parseOpera(e) {
                if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) return this.parseOpera9(e);
                else if (!e.stack) return this.parseOpera10(e);
                else return this.parseOpera11(e);
            },
            parseOpera9: function ErrorStackParser$$parseOpera9(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
                var lines = e.message.split('\n');
                var result = [];
                for(var i = 2, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            parseOpera10: function ErrorStackParser$$parseOpera10(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
                var lines = e.stacktrace.split('\n');
                var result = [];
                for(var i = 0, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        functionName: match[3] || undefined,
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            // Opera 10.65+ Error.stack very similar to FF/Safari
            parseOpera11: function ErrorStackParser$$parseOpera11(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
                }, this);
                return filtered.map(function(line) {
                    var tokens = line.split('@');
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionCall = tokens.shift() || '';
                    var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^)]*\)/g, '') || undefined;
                    var argsRaw;
                    if (functionCall.match(/\(([^)]*)\)/)) argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, '$1');
                    var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
                    return new StackFrame({
                        functionName: functionName,
                        args: args,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            }
        };
    });
    var _$errorStackParser_19 = _$errorStackParser_6;
    var _$safeJsonStringify_5 = function(data, replacer, space, opts) {
        var redactedKeys = opts && opts.redactedKeys ? opts.redactedKeys : [];
        var redactedPaths = opts && opts.redactedPaths ? opts.redactedPaths : [];
        return JSON.stringify(prepareObjForSerialization(data, redactedKeys, redactedPaths), replacer, space);
    };
    var MAX_DEPTH = 20;
    var MAX_EDGES = 25000;
    var MIN_PRESERVED_DEPTH = 8;
    var REPLACEMENT_NODE = '...';
    function isError(o) {
        return o instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(o));
    }
    function throwsMessage(err) {
        return '[Throws: ' + (err ? err.message : '?') + ']';
    }
    function find(haystack, needle) {
        for(var i = 0, len = haystack.length; i < len; i++){
            if (haystack[i] === needle) return true;
        }
        return false;
    }
    // returns true if the string `path` starts with any of the provided `paths`
    function isDescendent(paths, path) {
        for(var i = 0, len = paths.length; i < len; i++){
            if (path.indexOf(paths[i]) === 0) return true;
        }
        return false;
    }
    function shouldRedact(patterns, key) {
        for(var i = 0, len = patterns.length; i < len; i++){
            if (typeof patterns[i] === 'string' && patterns[i].toLowerCase() === key.toLowerCase()) return true;
            if (patterns[i] && typeof patterns[i].test === 'function' && patterns[i].test(key)) return true;
        }
        return false;
    }
    function __isArray_5(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    }
    function safelyGetProp(obj, prop) {
        try {
            return obj[prop];
        } catch (err) {
            return throwsMessage(err);
        }
    }
    function prepareObjForSerialization(obj, redactedKeys, redactedPaths) {
        var seen = []; // store references to objects we have seen before
        var edges = 0;
        function visit(obj, path) {
            function edgesExceeded() {
                return path.length > MIN_PRESERVED_DEPTH && edges > MAX_EDGES;
            }
            edges++;
            if (path.length > MAX_DEPTH) return REPLACEMENT_NODE;
            if (edgesExceeded()) return REPLACEMENT_NODE;
            if (obj === null || typeof obj !== 'object') return obj;
            if (find(seen, obj)) return '[Circular]';
            seen.push(obj);
            if (typeof obj.toJSON === 'function') try {
                // we're not going to count this as an edge because it
                // replaces the value of the currently visited object
                edges--;
                var fResult = visit(obj.toJSON(), path);
                seen.pop();
                return fResult;
            } catch (err) {
                return throwsMessage(err);
            }
            var er = isError(obj);
            if (er) {
                edges--;
                var eResult = visit({
                    name: obj.name,
                    message: obj.message
                }, path);
                seen.pop();
                return eResult;
            }
            if (__isArray_5(obj)) {
                var aResult = [];
                for(var i = 0, len = obj.length; i < len; i++){
                    if (edgesExceeded()) {
                        aResult.push(REPLACEMENT_NODE);
                        break;
                    }
                    aResult.push(visit(obj[i], path.concat('[]')));
                }
                seen.pop();
                return aResult;
            }
            var result = {};
            try {
                for(var prop in obj){
                    if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
                    if (isDescendent(redactedPaths, path.join('.')) && shouldRedact(redactedKeys, prop)) {
                        result[prop] = '[REDACTED]';
                        continue;
                    }
                    if (edgesExceeded()) {
                        result[prop] = REPLACEMENT_NODE;
                        break;
                    }
                    result[prop] = visit(safelyGetProp(obj, prop), path.concat(prop));
                }
            } catch (e) {}
            seen.pop();
            return result;
        }
        return visit(obj, []);
    }
    function add(existingFeatures, existingFeatureKeys, name, variant) {
        if (typeof name !== 'string') return;
        if (variant === undefined) variant = null;
        else if (variant !== null && typeof variant !== 'string') variant = _$safeJsonStringify_5(variant);
        var existingIndex = existingFeatureKeys[name];
        if (typeof existingIndex === 'number') {
            existingFeatures[existingIndex] = {
                name: name,
                variant: variant
            };
            return;
        }
        existingFeatures.push({
            name: name,
            variant: variant
        });
        existingFeatureKeys[name] = existingFeatures.length - 1;
    }
    function merge(existingFeatures, newFeatures, existingFeatureKeys) {
        if (!_$isArray_23(newFeatures)) return;
        for(var i = 0; i < newFeatures.length; ++i){
            var feature = newFeatures[i];
            if (feature === null || typeof feature !== 'object') continue;
            // 'add' will handle if 'name' doesn't exist & 'variant' is optional
            add(existingFeatures, existingFeatureKeys, feature.name, feature.variant);
        }
        return existingFeatures;
    }
    // convert feature flags from a map of 'name -> variant' into the format required
    // by the Bugsnag Event API:
    //   [{ featureFlag: 'name', variant: 'variant' }, { featureFlag: 'name 2' }]
    function toEventApi(featureFlags) {
        return _$map_25(_$filter_21(featureFlags, Boolean), function(_ref) {
            var name = _ref.name, variant = _ref.variant;
            var flag = {
                featureFlag: name
            };
            // don't add a 'variant' property unless there's actually a value
            if (typeof variant === 'string') flag.variant = variant;
            return flag;
        });
    }
    function clear(features, featuresIndex, name) {
        var existingIndex = featuresIndex[name];
        if (typeof existingIndex === 'number') {
            features[existingIndex] = null;
            delete featuresIndex[name];
        }
    }
    var _$featureFlagDelegate_27 = {
        add: add,
        clear: clear,
        merge: merge,
        toEventApi: toEventApi
    };
    // Given `err` which may be an error, does it have a stack property which is a string?
    var _$hasStack_28 = function(err) {
        return !!err && (!!err.stack || !!err.stacktrace || !!err['opera#sourceloc']) && typeof (err.stack || err.stacktrace || err['opera#sourceloc']) === 'string' && err.stack !== err.name + ": " + err.message;
    };
    /**
 * Expose `isError`.
 */ var _$isError_7 = __isError_7;
    /**
 * Test whether `value` is error object.
 *
 * @param {*} value
 * @returns {boolean}
 */ function __isError_7(value) {
        switch(Object.prototype.toString.call(value)){
            case '[object Error]':
                return true;
            case '[object Exception]':
                return true;
            case '[object DOMException]':
                return true;
            default:
                return value instanceof Error;
        }
    }
    var _$iserror_29 = _$isError_7;
    var __add_31 = function(state, section, keyOrObj, maybeVal) {
        var _updates;
        if (!section) return;
        var updates;
        // addMetadata("section", null) -> clears section
        if (keyOrObj === null) return __clear_31(state, section);
        // normalise the two supported input types into object form
        if (typeof keyOrObj === 'object') updates = keyOrObj;
        if (typeof keyOrObj === 'string') updates = (_updates = {}, _updates[keyOrObj] = maybeVal, _updates);
        // exit if we don't have an updates object at this point
        if (!updates) return;
        // preventing the __proto__ property from being used as a key
        if (section === '__proto__' || section === 'constructor' || section === 'prototype') return;
        // ensure a section with this name exists
        if (!state[section]) state[section] = {};
        // merge the updates with the existing section
        state[section] = _$assign_20({}, state[section], updates);
    };
    var get = function(state, section, key) {
        if (typeof section !== 'string') return undefined;
        if (!key) return state[section];
        if (state[section]) return state[section][key];
        return undefined;
    };
    var __clear_31 = function(state, section, key) {
        if (typeof section !== 'string') return;
        // clear an entire section
        if (!key) {
            delete state[section];
            return;
        }
        // preventing the __proto__ property from being used as a key
        if (section === '__proto__' || section === 'constructor' || section === 'prototype') return;
        // clear a single value from a section
        if (state[section]) delete state[section][key];
    };
    var _$metadataDelegate_31 = {
        add: __add_31,
        get: get,
        clear: __clear_31
    };
    function ___extends_15() {
        ___extends_15 = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return ___extends_15.apply(this, arguments);
    }
    var Event = /*#__PURE__*/ function() {
        function Event(errorClass, errorMessage, stacktrace, handledState, originalError) {
            if (stacktrace === void 0) stacktrace = [];
            if (handledState === void 0) handledState = defaultHandledState();
            this.apiKey = undefined;
            this.context = undefined;
            this.groupingHash = undefined;
            this.originalError = originalError;
            this._handledState = handledState;
            this.severity = this._handledState.severity;
            this.unhandled = this._handledState.unhandled;
            this.app = {};
            this.device = {};
            this.request = {};
            this.breadcrumbs = [];
            this.threads = [];
            this._metadata = {};
            this._features = [];
            this._featuresIndex = {};
            this._user = {};
            this._session = undefined;
            this._correlation = undefined;
            this.errors = [
                createBugsnagError(errorClass, errorMessage, Event.__type, stacktrace)
            ];
        // Flags.
        // Note these are not initialised unless they are used
        // to save unnecessary bytes in the browser bundle
        /* this.attemptImmediateDelivery, default: true */ }
        var _proto = Event.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_31.add(this._metadata, section, keyOrObj, maybeVal);
        };
        _proto.setTraceCorrelation = function setTraceCorrelation(traceId, spanId) {
            if (typeof traceId === 'string') this._correlation = ___extends_15({
                traceId: traceId
            }, typeof spanId === 'string' ? {
                spanId: spanId
            } : {});
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_31.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_31.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            _$featureFlagDelegate_27.add(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            _$featureFlagDelegate_27.merge(this._features, featureFlags, this._featuresIndex);
        };
        _proto.getFeatureFlags = function getFeatureFlags() {
            return _$featureFlagDelegate_27.toEventApi(this._features);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            _$featureFlagDelegate_27.clear(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                payloadVersion: '4',
                exceptions: _$map_25(this.errors, function(er) {
                    return _$assign_20({}, er, {
                        message: er.errorMessage
                    });
                }),
                severity: this.severity,
                unhandled: this._handledState.unhandled,
                severityReason: this._handledState.severityReason,
                app: this.app,
                device: this.device,
                request: this.request,
                breadcrumbs: this.breadcrumbs,
                context: this.context,
                groupingHash: this.groupingHash,
                metaData: this._metadata,
                user: this._user,
                session: this._session,
                featureFlags: this.getFeatureFlags(),
                correlation: this._correlation
            };
        };
        return Event;
    }(); // takes a stacktrace.js style stackframe (https://github.com/stacktracejs/stackframe)
    // and returns a Bugsnag compatible stackframe (https://docs.bugsnag.com/api/error-reporting/#json-payload)
    var formatStackframe = function(frame) {
        var f = {
            file: frame.fileName,
            method: normaliseFunctionName(frame.functionName),
            lineNumber: frame.lineNumber,
            columnNumber: frame.columnNumber,
            code: undefined,
            inProject: undefined
        };
        // Some instances result in no file:
        // - calling notify() from chrome's terminal results in no file/method.
        // - non-error exception thrown from global code in FF
        // This adds one.
        if (f.lineNumber > -1 && !f.file && !f.method) f.file = 'global code';
        return f;
    };
    var normaliseFunctionName = function(name) {
        return /^global code$/i.test(name) ? 'global code' : name;
    };
    var defaultHandledState = function() {
        return {
            unhandled: false,
            severity: 'warning',
            severityReason: {
                type: 'handledException'
            }
        };
    };
    var ensureString = function(str) {
        return typeof str === 'string' ? str : '';
    };
    function createBugsnagError(errorClass, errorMessage, type, stacktrace) {
        return {
            errorClass: ensureString(errorClass),
            errorMessage: ensureString(errorMessage),
            type: type,
            stacktrace: _$reduce_26(stacktrace, function(accum, frame) {
                var f = formatStackframe(frame);
                // don't include a stackframe if none of its properties are defined
                try {
                    if (JSON.stringify(f) === '{}') return accum;
                    return accum.concat(f);
                } catch (e) {
                    return accum;
                }
            }, [])
        };
    }
    function getCauseStack(error) {
        if (error.cause) return [
            error
        ].concat(getCauseStack(error.cause));
        else return [
            error
        ];
    }
    // Helpers
    Event.getStacktrace = function(error, errorFramesToSkip, backtraceFramesToSkip) {
        if (_$hasStack_28(error)) return _$errorStackParser_19.parse(error).slice(errorFramesToSkip);
        // error wasn't provided or didn't have a stacktrace so try to walk the callstack
        try {
            return _$filter_21(_$stackGenerator_8.backtrace(), function(frame) {
                return (frame.functionName || '').indexOf('StackGenerator$$') === -1;
            }).slice(1 + backtraceFramesToSkip);
        } catch (e) {
            return [];
        }
    };
    Event.create = function(maybeError, tolerateNonErrors, handledState, component, errorFramesToSkip, logger) {
        if (errorFramesToSkip === void 0) errorFramesToSkip = 0;
        var _normaliseError = normaliseError(maybeError, tolerateNonErrors, component, logger), error = _normaliseError[0], internalFrames = _normaliseError[1];
        var event;
        try {
            var stacktrace = Event.getStacktrace(error, // if an error was created/throw in the normaliseError() function, we need to
            // tell the getStacktrace() function to skip the number of frames we know will
            // be from our own functions. This is added to the number of frames deep we
            // were told about
            internalFrames > 0 ? 1 + internalFrames + errorFramesToSkip : 0, // if there's no stacktrace, the callstack may be walked to generated one.
            // this is how many frames should be removed because they come from our library
            1 + errorFramesToSkip);
            event = new Event(error.name, error.message, stacktrace, handledState, maybeError);
        } catch (e) {
            event = new Event(error.name, error.message, [], handledState, maybeError);
        }
        if (error.name === 'InvalidError') event.addMetadata("" + component, 'non-error parameter', makeSerialisable(maybeError));
        if (error.cause) {
            var _event$errors;
            var causes = getCauseStack(error).slice(1);
            var normalisedCauses = _$map_25(causes, function(cause) {
                // Only get stacktrace for error causes that are a valid JS Error and already have a stack
                var stacktrace = _$iserror_29(cause) && _$hasStack_28(cause) ? _$errorStackParser_19.parse(cause) : [];
                var _normaliseError2 = normaliseError(cause, true, 'error cause'), error = _normaliseError2[0];
                if (error.name === 'InvalidError') event.addMetadata('error cause', makeSerialisable(cause));
                return createBugsnagError(error.name, error.message, Event.__type, stacktrace);
            });
            (_event$errors = event.errors).push.apply(_event$errors, normalisedCauses);
        }
        return event;
    };
    var makeSerialisable = function(err) {
        if (err === null) return 'null';
        if (err === undefined) return 'undefined';
        return err;
    };
    var normaliseError = function(maybeError, tolerateNonErrors, component, logger) {
        var error;
        var internalFrames = 0;
        var createAndLogInputError = function(reason) {
            var verb = component === 'error cause' ? 'was' : 'received';
            if (logger) logger.warn(component + " " + verb + " a non-error: \"" + reason + "\"");
            var err = new Error(component + " " + verb + " a non-error. See \"" + component + "\" tab for more detail.");
            err.name = 'InvalidError';
            return err;
        };
        // In some cases:
        //
        //  - the promise rejection handler (both in the browser and node)
        //  - the node uncaughtException handler
        //
        // We are really limited in what we can do to get a stacktrace. So we use the
        // tolerateNonErrors option to ensure that the resulting error communicates as
        // such.
        if (!tolerateNonErrors) {
            if (_$iserror_29(maybeError)) error = maybeError;
            else {
                error = createAndLogInputError(typeof maybeError);
                internalFrames += 2;
            }
        } else switch(typeof maybeError){
            case 'string':
            case 'number':
            case 'boolean':
                error = new Error(String(maybeError));
                internalFrames += 1;
                break;
            case 'function':
                error = createAndLogInputError('function');
                internalFrames += 2;
                break;
            case 'object':
                if (maybeError !== null && _$iserror_29(maybeError)) error = maybeError;
                else if (maybeError !== null && hasNecessaryFields(maybeError)) {
                    error = new Error(maybeError.message || maybeError.errorMessage);
                    error.name = maybeError.name || maybeError.errorClass;
                    internalFrames += 1;
                } else {
                    error = createAndLogInputError(maybeError === null ? 'null' : 'unsupported object');
                    internalFrames += 2;
                }
                break;
            default:
                error = createAndLogInputError('nothing');
                internalFrames += 2;
        }
        if (!_$hasStack_28(error)) // in IE10/11 a new Error() doesn't have a stacktrace until you throw it, so try that here
        try {
            throw error;
        } catch (e) {
            if (_$hasStack_28(e)) {
                error = e;
                // if the error only got a stacktrace after we threw it here, we know it
                // will only have one extra internal frame from this function, regardless
                // of whether it went through createAndLogInputError() or not
                internalFrames = 1;
            }
        }
        return [
            error,
            internalFrames
        ];
    };
    // default value for stacktrace.type
    Event.__type = 'browserjs';
    var hasNecessaryFields = function(error) {
        return (typeof error.name === 'string' || typeof error.errorClass === 'string') && (typeof error.message === 'string' || typeof error.errorMessage === 'string');
    };
    var _$Event_15 = Event;
    // This is a heavily modified/simplified version of
    //   https://github.com/othiym23/async-some
    // with the logic flipped so that it is akin to the
    // synchronous "every" method instead of "some".
    // run the asynchronous test function (fn) over each item in the array (arr)
    // in series until:
    //   - fn(item, cb) => calls cb(null, false)
    //   - or the end of the array is reached
    // the callback (cb) will be passed (null, false) if any of the items in arr
    // caused fn to call back with false, otherwise it will be passed (null, true)
    var _$asyncEvery_16 = function(arr, fn, cb) {
        var index = 0;
        var next = function() {
            if (index >= arr.length) return cb(null, true);
            fn(arr[index], function(err, result) {
                if (err) return cb(err);
                if (result === false) return cb(null, false);
                index++;
                next();
            });
        };
        next();
    };
    var _$callbackRunner_18 = function(callbacks, event, onCallbackError, cb) {
        // This function is how we support different kinds of callback:
        //  - synchronous - return value
        //  - node-style async with callback - cb(err, value)
        //  - promise/thenable - resolve(value)
        // It normalises each of these into the lowest common denominator – a node-style callback
        var runMaybeAsyncCallback = function(fn, cb) {
            if (typeof fn !== 'function') return cb(null);
            try {
                // if function appears sync…
                if (fn.length !== 2) {
                    var ret = fn(event);
                    // check if it returned a "thenable" (promise)
                    if (ret && typeof ret.then === 'function') return ret.then(// resolve
                    function(val) {
                        return setTimeout(function() {
                            return cb(null, val);
                        });
                    }, // reject
                    function(err) {
                        setTimeout(function() {
                            onCallbackError(err);
                            return cb(null, true);
                        });
                    });
                    return cb(null, ret);
                }
                // if function is async…
                fn(event, function(err, result) {
                    if (err) {
                        onCallbackError(err);
                        return cb(null);
                    }
                    cb(null, result);
                });
            } catch (e) {
                onCallbackError(e);
                cb(null);
            }
        };
        _$asyncEvery_16(callbacks, runMaybeAsyncCallback, cb);
    };
    var _$syncCallbackRunner_32 = function(callbacks, callbackArg, callbackType, logger) {
        var ignore = false;
        var cbs = callbacks.slice();
        while(!ignore){
            if (!cbs.length) break;
            try {
                ignore = cbs.pop()(callbackArg) === false;
            } catch (e) {
                logger.error("Error occurred in " + callbackType + " callback, continuing anyway\u2026");
                logger.error(e);
            }
        }
        return ignore;
    };
    var _$pad_4 = function pad(num, size) {
        var s = '000000000' + num;
        return s.substr(s.length - size);
    };
    var env = typeof window === 'object' ? window : self;
    var globalCount = 0;
    for(var prop in env)if (Object.hasOwnProperty.call(env, prop)) globalCount++;
    var mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
    var clientId = _$pad_4((mimeTypesLength + navigator.userAgent.length).toString(36) + globalCount.toString(36), 4);
    var _$fingerprint_2 = function fingerprint() {
        return clientId;
    };
    /**
 * Check the provided value is a valid device id
 * @param {unknown} value
 * @returns
 */ var _$isCuid_3 = function isCuid(value) {
        return typeof value === 'string' && /^c[a-z0-9]{20,32}$/.test(value);
    };
    var c = 0, blockSize = 4, base = 36, discreteValues = Math.pow(base, blockSize);
    function randomBlock() {
        return _$pad_4((Math.random() * discreteValues << 0).toString(base), blockSize);
    }
    function safeCounter() {
        c = c < discreteValues ? c : 0;
        c++; // this is not subliminal
        return c - 1;
    }
    function cuid() {
        // Starting with a lowercase letter makes
        // it HTML element ID friendly.
        var letter = 'c', // hard-coded allows for sequential access
        // timestamp
        // warning: this exposes the exact date and time
        // that the uid was created.
        timestamp = new Date().getTime().toString(base), // Prevent same-machine collisions.
        counter = _$pad_4(safeCounter().toString(base), blockSize), // A few chars to generate distinct ids for different
        // clients (so different computers are far less
        // likely to generate the same id)
        print = _$fingerprint_2(), // Grab some more chars from Math.random()
        random = randomBlock() + randomBlock();
        return letter + timestamp + counter + print + random;
    }
    cuid.fingerprint = _$fingerprint_2;
    cuid.isCuid = _$isCuid_3;
    var _$cuid_1 = cuid;
    var Session = /*#__PURE__*/ function() {
        function Session() {
            this.id = _$cuid_1();
            this.startedAt = new Date();
            this._handled = 0;
            this._unhandled = 0;
            this._user = {};
            this.app = {};
            this.device = {};
        }
        var _proto = Session.prototype;
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                id: this.id,
                startedAt: this.startedAt,
                events: {
                    handled: this._handled,
                    unhandled: this._unhandled
                }
            };
        };
        _proto._track = function _track(event) {
            this[event._handledState.unhandled ? '_unhandled' : '_handled'] += 1;
        };
        return Session;
    }();
    var _$Session_36 = Session;
    var __add_13 = _$featureFlagDelegate_27.add, __clear_13 = _$featureFlagDelegate_27.clear, __merge_13 = _$featureFlagDelegate_27.merge;
    var noop = function() {};
    var Client = /*#__PURE__*/ function() {
        function Client(configuration, schema, internalPlugins, notifier) {
            var _this = this;
            if (schema === void 0) schema = _$config_14.schema;
            if (internalPlugins === void 0) internalPlugins = [];
            // notifier id
            this._notifier = notifier;
            // intialise opts and config
            this._config = {};
            this._schema = schema;
            // i/o
            this._delivery = {
                sendSession: noop,
                sendEvent: noop
            };
            this._logger = {
                debug: noop,
                info: noop,
                warn: noop,
                error: noop
            };
            // plugins
            this._plugins = {};
            // state
            this._breadcrumbs = [];
            this._session = null;
            this._metadata = {};
            this._featuresIndex = {};
            this._features = [];
            this._context = undefined;
            this._user = {};
            // callbacks:
            //  e: onError
            //  s: onSession
            //  sp: onSessionPayload
            //  b: onBreadcrumb
            // (note these names are minified by hand because object
            // properties are not safe to minify automatically)
            this._cbs = {
                e: [],
                s: [],
                sp: [],
                b: []
            };
            // expose internal constructors
            this.Client = Client;
            this.Event = _$Event_15;
            this.Breadcrumb = _$Breadcrumb_12;
            this.Session = _$Session_36;
            this._config = this._configure(configuration, internalPlugins);
            _$map_25(internalPlugins.concat(this._config.plugins), function(pl) {
                if (pl) _this._loadPlugin(pl);
            });
            // when notify() is called we need to know how many frames are from our own source
            // this inital value is 1 not 0 because we wrap notify() to ensure it is always
            // bound to have the client as its `this` value – see below.
            this._depth = 1;
            var self1 = this;
            var notify = this.notify;
            this.notify = function() {
                return notify.apply(self1, arguments);
            };
        }
        var _proto = Client.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_31.add(this._metadata, section, keyOrObj, maybeVal);
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_31.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_31.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            __add_13(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            __merge_13(this._features, featureFlags, this._featuresIndex);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            __clear_13(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getContext = function getContext() {
            return this._context;
        };
        _proto.setContext = function setContext(c) {
            this._context = c;
        };
        _proto._configure = function _configure(opts, internalPlugins) {
            var schema = _$reduce_26(internalPlugins, function(schema, plugin) {
                if (plugin && plugin.configSchema) return _$assign_20({}, schema, plugin.configSchema);
                return schema;
            }, this._schema);
            // sendPayloadChecksums is false by default unless custom endpoints are not specified
            if (!opts.endpoints) opts.sendPayloadChecksums = 'sendPayloadChecksums' in opts ? opts.sendPayloadChecksums : true;
            // accumulate configuration and error messages
            var _reduce = _$reduce_26(_$keys_24(schema), function(accum, key) {
                var defaultValue = schema[key].defaultValue(opts[key]);
                if (opts[key] !== undefined) {
                    var valid = schema[key].validate(opts[key]);
                    if (!valid) {
                        accum.errors[key] = schema[key].message;
                        accum.config[key] = defaultValue;
                    } else if (schema[key].allowPartialObject) accum.config[key] = _$assign_20(defaultValue, opts[key]);
                    else accum.config[key] = opts[key];
                } else accum.config[key] = defaultValue;
                return accum;
            }, {
                errors: {},
                config: {}
            }), errors = _reduce.errors, config = _reduce.config;
            if (schema.apiKey) {
                // missing api key is the only fatal error
                if (!config.apiKey) throw new Error('No Bugsnag API Key set');
                // warn about an apikey that is not of the expected format
                if (!/^[0-9a-f]{32}$/i.test(config.apiKey)) errors.apiKey = 'should be a string of 32 hexadecimal characters';
            }
            // update and elevate some options
            this._metadata = _$assign_20({}, config.metadata);
            __merge_13(this._features, config.featureFlags, this._featuresIndex);
            this._user = _$assign_20({}, config.user);
            this._context = config.context;
            if (config.logger) this._logger = config.logger;
            // add callbacks
            if (config.onError) this._cbs.e = this._cbs.e.concat(config.onError);
            if (config.onBreadcrumb) this._cbs.b = this._cbs.b.concat(config.onBreadcrumb);
            if (config.onSession) this._cbs.s = this._cbs.s.concat(config.onSession);
            // finally warn about any invalid config where we fell back to the default
            if (_$keys_24(errors).length) this._logger.warn(generateConfigErrorMessage(errors, opts));
            return config;
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto._loadPlugin = function _loadPlugin(plugin) {
            var result = plugin.load(this);
            // JS objects are not the safest way to store arbitrarily keyed values,
            // so bookend the key with some characters that prevent tampering with
            // stuff like __proto__ etc. (only store the result if the plugin had a
            // name)
            if (plugin.name) this._plugins["~" + plugin.name + "~"] = result;
        };
        _proto.getPlugin = function getPlugin(name) {
            return this._plugins["~" + name + "~"];
        };
        _proto._setDelivery = function _setDelivery(d) {
            this._delivery = d(this);
        };
        _proto.startSession = function startSession() {
            var session = new _$Session_36();
            session.app.releaseStage = this._config.releaseStage;
            session.app.version = this._config.appVersion;
            session.app.type = this._config.appType;
            session._user = _$assign_20({}, this._user);
            // run onSession callbacks
            var ignore = _$syncCallbackRunner_32(this._cbs.s, session, 'onSession', this._logger);
            if (ignore) {
                this._logger.debug('Session not started due to onSession callback');
                return this;
            }
            return this._sessionDelegate.startSession(this, session);
        };
        _proto.addOnError = function addOnError(fn, front) {
            if (front === void 0) front = false;
            this._cbs.e[front ? 'unshift' : 'push'](fn);
        };
        _proto.removeOnError = function removeOnError(fn) {
            this._cbs.e = _$filter_21(this._cbs.e, function(f) {
                return f !== fn;
            });
        };
        _proto._addOnSessionPayload = function _addOnSessionPayload(fn) {
            this._cbs.sp.push(fn);
        };
        _proto.addOnSession = function addOnSession(fn) {
            this._cbs.s.push(fn);
        };
        _proto.removeOnSession = function removeOnSession(fn) {
            this._cbs.s = _$filter_21(this._cbs.s, function(f) {
                return f !== fn;
            });
        };
        _proto.addOnBreadcrumb = function addOnBreadcrumb(fn, front) {
            if (front === void 0) front = false;
            this._cbs.b[front ? 'unshift' : 'push'](fn);
        };
        _proto.removeOnBreadcrumb = function removeOnBreadcrumb(fn) {
            this._cbs.b = _$filter_21(this._cbs.b, function(f) {
                return f !== fn;
            });
        };
        _proto.pauseSession = function pauseSession() {
            return this._sessionDelegate.pauseSession(this);
        };
        _proto.resumeSession = function resumeSession() {
            return this._sessionDelegate.resumeSession(this);
        };
        _proto.leaveBreadcrumb = function leaveBreadcrumb(message, metadata, type) {
            // coerce bad values so that the defaults get set
            message = typeof message === 'string' ? message : '';
            type = typeof type === 'string' && _$includes_22(_$breadcrumbTypes_17, type) ? type : 'manual';
            metadata = typeof metadata === 'object' && metadata !== null ? metadata : {};
            // if no message, discard
            if (!message) return;
            var crumb = new _$Breadcrumb_12(message, metadata, type);
            // run onBreadcrumb callbacks
            var ignore = _$syncCallbackRunner_32(this._cbs.b, crumb, 'onBreadcrumb', this._logger);
            if (ignore) {
                this._logger.debug('Breadcrumb not attached due to onBreadcrumb callback');
                return;
            }
            // push the valid crumb onto the queue and maintain the length
            this._breadcrumbs.push(crumb);
            if (this._breadcrumbs.length > this._config.maxBreadcrumbs) this._breadcrumbs = this._breadcrumbs.slice(this._breadcrumbs.length - this._config.maxBreadcrumbs);
        };
        _proto._isBreadcrumbTypeEnabled = function _isBreadcrumbTypeEnabled(type) {
            var types = this._config.enabledBreadcrumbTypes;
            return types === null || _$includes_22(types, type);
        };
        _proto.notify = function notify(maybeError, onError, postReportCallback) {
            if (postReportCallback === void 0) postReportCallback = noop;
            var event = _$Event_15.create(maybeError, true, undefined, 'notify()', this._depth + 1, this._logger);
            this._notify(event, onError, postReportCallback);
        };
        _proto._notify = function _notify(event, onError, postReportCallback) {
            var _this2 = this;
            if (postReportCallback === void 0) postReportCallback = noop;
            event.app = _$assign_20({}, event.app, {
                releaseStage: this._config.releaseStage,
                version: this._config.appVersion,
                type: this._config.appType
            });
            event.context = event.context || this._context;
            event._metadata = _$assign_20({}, event._metadata, this._metadata);
            event._user = _$assign_20({}, event._user, this._user);
            event.breadcrumbs = this._breadcrumbs.slice();
            __merge_13(event._features, this._features, event._featuresIndex);
            // exit early if events should not be sent on the current releaseStage
            if (this._config.enabledReleaseStages !== null && !_$includes_22(this._config.enabledReleaseStages, this._config.releaseStage)) {
                this._logger.warn('Event not sent due to releaseStage/enabledReleaseStages configuration');
                return postReportCallback(null, event);
            }
            var originalSeverity = event.severity;
            var onCallbackError = function(err) {
                // errors in callbacks are tolerated but we want to log them out
                _this2._logger.error("Error occurred in onError callback, continuing anyway\u2026");
                _this2._logger.error(err);
            };
            var callbacks = [].concat(this._cbs.e).concat(onError);
            _$callbackRunner_18(callbacks, event, onCallbackError, function(err, shouldSend) {
                if (err) onCallbackError(err);
                if (!shouldSend) {
                    _this2._logger.debug('Event not sent due to onError callback');
                    return postReportCallback(null, event);
                }
                if (_this2._isBreadcrumbTypeEnabled('error')) // only leave a crumb for the error if actually got sent
                Client.prototype.leaveBreadcrumb.call(_this2, event.errors[0].errorClass, {
                    errorClass: event.errors[0].errorClass,
                    errorMessage: event.errors[0].errorMessage,
                    severity: event.severity
                }, 'error');
                if (originalSeverity !== event.severity) event._handledState.severityReason = {
                    type: 'userCallbackSetSeverity'
                };
                if (event.unhandled !== event._handledState.unhandled) {
                    event._handledState.severityReason.unhandledOverridden = true;
                    event._handledState.unhandled = event.unhandled;
                }
                if (_this2._session) {
                    _this2._session._track(event);
                    event._session = _this2._session;
                }
                _this2._delivery.sendEvent({
                    apiKey: event.apiKey || _this2._config.apiKey,
                    notifier: _this2._notifier,
                    events: [
                        event
                    ]
                }, function(err) {
                    return postReportCallback(err, event);
                });
            });
        };
        return Client;
    }();
    var generateConfigErrorMessage = function(errors, rawInput) {
        var er = new Error("Invalid configuration\n" + _$map_25(_$keys_24(errors), function(key) {
            return "  - " + key + " " + errors[key] + ", got " + stringify(rawInput[key]);
        }).join('\n\n'));
        return er;
    };
    var stringify = function(val) {
        switch(typeof val){
            case 'string':
            case 'number':
            case 'object':
                return JSON.stringify(val);
            default:
                return String(val);
        }
    };
    var _$Client_13 = Client;
    var _$jsonPayload_30 = {};
    var EVENT_REDACTION_PATHS = [
        'events.[].metaData',
        'events.[].breadcrumbs.[].metaData',
        'events.[].request'
    ];
    _$jsonPayload_30.event = function(event, redactedKeys) {
        var payload = _$safeJsonStringify_5(event, null, null, {
            redactedPaths: EVENT_REDACTION_PATHS,
            redactedKeys: redactedKeys
        });
        if (payload.length > 10e5) {
            event.events[0]._metadata = {
                notifier: "WARNING!\nSerialized payload was " + payload.length / 10e5 + "MB (limit = 1MB)\nmetadata was removed"
            };
            payload = _$safeJsonStringify_5(event, null, null, {
                redactedPaths: EVENT_REDACTION_PATHS,
                redactedKeys: redactedKeys
            });
        }
        return payload;
    };
    _$jsonPayload_30.session = function(session, redactedKeys) {
        var payload = _$safeJsonStringify_5(session, null, null);
        return payload;
    };
    var _$delivery_37 = {};
    _$delivery_37 = function(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function(event, cb) {
                if (cb === void 0) cb = function() {};
                if (client._config.endpoints.notify === null) {
                    var err = new Error('Event not sent due to incomplete endpoint configuration');
                    return cb(err);
                }
                var url = getApiUrl(client._config, 'notify', '4', win);
                var body = _$jsonPayload_30.event(event, client._config.redactedKeys);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.onerror = function() {
                    var err = new Error('Event failed to send');
                    client._logger.error("Event failed to send\u2026", err);
                    if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                    cb(err);
                };
                req.open('POST', url);
                setTimeout(function() {
                    try {
                        req.send(body);
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            },
            sendSession: function(session, cb) {
                if (cb === void 0) cb = function() {};
                if (client._config.endpoints.sessions === null) {
                    var err = new Error('Session not sent due to incomplete endpoint configuration');
                    return cb(err);
                }
                var url = getApiUrl(client._config, 'sessions', '1', win);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.open('POST', url);
                setTimeout(function() {
                    try {
                        req.send(_$jsonPayload_30.session(session, client._config.redactedKeys));
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            }
        };
    };
    var getApiUrl = function(config, endpoint, version, win) {
        // IE8 doesn't support Date.prototype.toISOstring(), but it does convert a date
        // to an ISO string when you use JSON stringify. Simply parsing the result of
        // JSON.stringify is smaller than using a toISOstring() polyfill.
        var isoDate = JSON.parse(JSON.stringify(new Date()));
        var url = matchPageProtocol(config.endpoints[endpoint], win.location.protocol);
        return url + "?apiKey=" + encodeURIComponent(config.apiKey) + "&payloadVersion=" + version + "&sentAt=" + encodeURIComponent(isoDate);
    };
    var matchPageProtocol = _$delivery_37._matchPageProtocol = function(endpoint, pageProtocol) {
        return pageProtocol === 'http:' ? endpoint.replace(/^https:/, 'http:') : endpoint;
    };
    function getIntegrityHeaderValue(windowOrWorkerGlobalScope, requestBody) {
        if (windowOrWorkerGlobalScope.isSecureContext && windowOrWorkerGlobalScope.crypto && windowOrWorkerGlobalScope.crypto.subtle && windowOrWorkerGlobalScope.crypto.subtle.digest && typeof TextEncoder === 'function') {
            var msgUint8 = new TextEncoder().encode(requestBody);
            return windowOrWorkerGlobalScope.crypto.subtle.digest('SHA-1', msgUint8).then(function(hashBuffer) {
                var hashArray = Array.from(new Uint8Array(hashBuffer));
                var hashHex = hashArray.map(function(b) {
                    return b.toString(16).padStart(2, '0');
                }).join('');
                return 'sha1 ' + hashHex;
            });
        }
        return Promise.resolve();
    }
    var _$delivery_38 = function(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function(event, cb) {
                if (cb === void 0) cb = function() {};
                try {
                    var url = client._config.endpoints.notify;
                    if (url === null) {
                        var err = new Error('Event not sent due to incomplete endpoint configuration');
                        return cb(err);
                    }
                    var req = new win.XMLHttpRequest();
                    var body = _$jsonPayload_30.event(event, client._config.redactedKeys);
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var _err = new Error("Request failed with status " + status);
                                client._logger.error("Event failed to send\u2026", _err);
                                if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                                cb(_err);
                            } else cb(null);
                        }
                    };
                    req.open('POST', url);
                    req.setRequestHeader('Content-Type', 'application/json');
                    req.setRequestHeader('Bugsnag-Api-Key', event.apiKey || client._config.apiKey);
                    req.setRequestHeader('Bugsnag-Payload-Version', '4');
                    req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
                    if (client._config.sendPayloadChecksums && typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) getIntegrityHeaderValue(win, body).then(function(integrity) {
                        if (integrity) req.setRequestHeader('Bugsnag-Integrity', integrity);
                        req.send(body);
                    })["catch"](function(err) {
                        client._logger.error(err);
                        req.send(body);
                    });
                    else req.send(body);
                } catch (e) {
                    client._logger.error(e);
                }
            },
            sendSession: function(session, cb) {
                if (cb === void 0) cb = function() {};
                try {
                    var url = client._config.endpoints.sessions;
                    if (url === null) {
                        var err = new Error('Session not sent due to incomplete endpoint configuration');
                        return cb(err);
                    }
                    var req = new win.XMLHttpRequest();
                    var body = _$jsonPayload_30.session(session, client._config.redactedKeys);
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var _err2 = new Error("Request failed with status " + status);
                                client._logger.error("Session failed to send\u2026", _err2);
                                cb(_err2);
                            } else cb(null);
                        }
                    };
                    req.open('POST', url);
                    req.setRequestHeader('Content-Type', 'application/json');
                    req.setRequestHeader('Bugsnag-Api-Key', client._config.apiKey);
                    req.setRequestHeader('Bugsnag-Payload-Version', '1');
                    req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
                    if (client._config.sendPayloadChecksums && typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) getIntegrityHeaderValue(win, body).then(function(integrity) {
                        if (integrity) req.setRequestHeader('Bugsnag-Integrity', integrity);
                        req.send(body);
                    })["catch"](function(err) {
                        client._logger.error(err);
                        req.send(body);
                    });
                    else req.send(body);
                } catch (e) {
                    client._logger.error(e);
                }
            }
        };
    };
    var appStart = new Date();
    var reset = function() {
        appStart = new Date();
    };
    var _$app_39 = {
        name: 'appDuration',
        load: function(client) {
            client.addOnError(function(event) {
                var now = new Date();
                event.app.duration = now - appStart;
            }, true);
            return {
                reset: reset
            };
        }
    };
    /*
 * Sets the default context to be the current URL
 */ var _$context_40 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                client.addOnError(function(event) {
                    if (event.context !== undefined) return;
                    event.context = win.location.pathname;
                }, true);
            }
        };
    };
    var BUGSNAG_ANONYMOUS_ID_KEY = 'bugsnag-anonymous-id';
    var getDeviceId = function(win) {
        try {
            var storage = win.localStorage;
            var id = storage.getItem(BUGSNAG_ANONYMOUS_ID_KEY);
            // If we get an ID, make sure it looks like a valid cuid. The length can
            // fluctuate slightly, so some leeway is built in
            if (id && /^c[a-z0-9]{20,32}$/.test(id)) return id;
            id = _$cuid_1();
            storage.setItem(BUGSNAG_ANONYMOUS_ID_KEY, id);
            return id;
        } catch (err) {
        // If localStorage is not available (e.g. because it's disabled) then give up
        }
    };
    /*
 * Automatically detects browser device details
 */ var _$device_41 = function(nav, win) {
        if (nav === void 0) nav = navigator;
        if (win === void 0) win = window;
        return {
            load: function(client) {
                var device = {
                    locale: nav.browserLanguage || nav.systemLanguage || nav.userLanguage || nav.language,
                    userAgent: nav.userAgent
                };
                if (win && win.screen && win.screen.orientation && win.screen.orientation.type) device.orientation = win.screen.orientation.type;
                else if (win && win.document) device.orientation = win.document.documentElement.clientWidth > win.document.documentElement.clientHeight ? 'landscape' : 'portrait';
                if (client._config.generateAnonymousId) device.id = getDeviceId(win);
                client.addOnSession(function(session) {
                    session.device = _$assign_20({}, session.device, device);
                    // only set device id if collectUserIp is false
                    if (!client._config.collectUserIp) setDefaultUserId(session);
                });
                // add time just as the event is sent
                client.addOnError(function(event) {
                    event.device = _$assign_20({}, event.device, device, {
                        time: new Date()
                    });
                    if (!client._config.collectUserIp) setDefaultUserId(event);
                }, true);
            },
            configSchema: {
                generateAnonymousId: {
                    validate: function(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function() {
                        return true;
                    },
                    message: 'should be true|false'
                }
            }
        };
    };
    var setDefaultUserId = function(eventOrSession) {
        // device id is also used to populate the user id field, if it's not already set
        var user = eventOrSession.getUser();
        if (!user || !user.id) eventOrSession.setUser(eventOrSession.device.id);
    };
    /*
 * Sets the event request: { url } to be the current href
 */ var _$request_42 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                client.addOnError(function(event) {
                    if (event.request && event.request.url) return;
                    event.request = _$assign_20({}, event.request, {
                        url: win.location.href
                    });
                }, true);
            }
        };
    };
    var _$session_43 = {
        load: function(client) {
            client._sessionDelegate = sessionDelegate;
        }
    };
    var sessionDelegate = {
        startSession: function(client, session) {
            var sessionClient = client;
            sessionClient._session = session;
            sessionClient._pausedSession = null;
            // exit early if the current releaseStage is not enabled
            if (sessionClient._config.enabledReleaseStages !== null && !_$includes_22(sessionClient._config.enabledReleaseStages, sessionClient._config.releaseStage)) {
                sessionClient._logger.warn('Session not sent due to releaseStage/enabledReleaseStages configuration');
                return sessionClient;
            }
            sessionClient._delivery.sendSession({
                notifier: sessionClient._notifier,
                device: session.device,
                app: session.app,
                sessions: [
                    {
                        id: session.id,
                        startedAt: session.startedAt,
                        user: session._user
                    }
                ]
            });
            return sessionClient;
        },
        resumeSession: function(client) {
            // Do nothing if there's already an active session
            if (client._session) return client;
            // If we have a paused session then make it the active session
            if (client._pausedSession) {
                client._session = client._pausedSession;
                client._pausedSession = null;
                return client;
            }
            // Otherwise start a new session
            return client.startSession();
        },
        pauseSession: function(client) {
            client._pausedSession = client._session;
            client._session = null;
        }
    };
    /*
 * Prevent collection of user IPs
 */ var _$clientIp_44 = {
        load: function(client) {
            if (client._config.collectUserIp) return;
            client.addOnError(function(event) {
                // If user.id is explicitly undefined, it will be missing from the payload. It needs
                // removing so that the following line replaces it
                if (event._user && typeof event._user.id === 'undefined') delete event._user.id;
                event._user = _$assign_20({
                    id: '[REDACTED]'
                }, event._user);
                event.request = _$assign_20({
                    clientIp: '[REDACTED]'
                }, event.request);
            });
        },
        configSchema: {
            collectUserIp: {
                defaultValue: function() {
                    return true;
                },
                message: 'should be true|false',
                validate: function(value) {
                    return value === true || value === false;
                }
            }
        }
    };
    var _$consoleBreadcrumbs_45 = {};
    /*
 * Leaves breadcrumbs when console log methods are called
 */ _$consoleBreadcrumbs_45.load = function(client) {
        var isDev = /^(local-)?dev(elopment)?$/.test(client._config.releaseStage);
        if (isDev || !client._isBreadcrumbTypeEnabled('log')) return;
        _$map_25(CONSOLE_LOG_METHODS, function(method) {
            var original = console[method];
            console[method] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                client.leaveBreadcrumb('Console output', _$reduce_26(args, function(accum, arg, i) {
                    // do the best/simplest stringification of each argument
                    var stringified = '[Unknown value]';
                    // this may fail if the input is:
                    // - an object whose [[Prototype]] is null (no toString)
                    // - an object with a broken toString or @@toPrimitive implementation
                    try {
                        stringified = String(arg);
                    } catch (e) {}
                    // if it stringifies to [object Object] attempt to JSON stringify
                    if (stringified === '[object Object]') // catch stringify errors and fallback to [object Object]
                    try {
                        stringified = JSON.stringify(arg);
                    } catch (e) {}
                    accum["[" + i + "]"] = stringified;
                    return accum;
                }, {
                    severity: method.indexOf('group') === 0 ? 'log' : method
                }), 'log');
                original.apply(console, args);
            };
            console[method]._restore = function() {
                console[method] = original;
            };
        });
    };
    var CONSOLE_LOG_METHODS = _$filter_21([
        'log',
        'debug',
        'info',
        'warn',
        'error'
    ], function(method) {
        return typeof console !== 'undefined' && typeof console[method] === 'function';
    });
    var MAX_LINE_LENGTH = 200;
    var MAX_SCRIPT_LENGTH = 500000;
    var _$inlineScriptContent_46 = function(doc, win) {
        if (doc === void 0) doc = document;
        if (win === void 0) win = window;
        return {
            load: function(client) {
                if (!client._config.trackInlineScripts) return;
                var originalLocation = win.location.href;
                var html = '';
                // in IE8-10 the 'interactive' state can fire too soon (before scripts have finished executing), so in those
                // we wait for the 'complete' state before assuming that synchronous scripts are no longer executing
                var isOldIe = !!doc.attachEvent;
                var DOMContentLoaded = isOldIe ? doc.readyState === 'complete' : doc.readyState !== 'loading';
                var getHtml = function() {
                    return doc.documentElement.outerHTML;
                };
                // get whatever HTML exists at this point in time
                html = getHtml();
                var prev = doc.onreadystatechange;
                // then update it when the DOM content has loaded
                doc.onreadystatechange = function() {
                    // IE8 compatible alternative to document#DOMContentLoaded
                    if (doc.readyState === 'interactive') {
                        html = getHtml();
                        DOMContentLoaded = true;
                    }
                    try {
                        prev.apply(this, arguments);
                    } catch (e) {}
                };
                var _lastScript = null;
                var updateLastScript = function(script) {
                    _lastScript = script;
                };
                var getCurrentScript = function() {
                    var script = doc.currentScript || _lastScript;
                    if (!script && !DOMContentLoaded) {
                        var scripts = doc.scripts || doc.getElementsByTagName('script');
                        script = scripts[scripts.length - 1];
                    }
                    return script;
                };
                var addSurroundingCode = function(lineNumber) {
                    // get whatever html has rendered at this point
                    if (!DOMContentLoaded || !html) html = getHtml();
                    // simulate the raw html
                    var htmlLines = [
                        '<!-- DOC START -->'
                    ].concat(html.split('\n'));
                    var zeroBasedLine = lineNumber - 1;
                    var start = Math.max(zeroBasedLine - 3, 0);
                    var end = Math.min(zeroBasedLine + 3, htmlLines.length);
                    return _$reduce_26(htmlLines.slice(start, end), function(accum, line, i) {
                        accum[start + 1 + i] = line.length <= MAX_LINE_LENGTH ? line : line.substr(0, MAX_LINE_LENGTH);
                        return accum;
                    }, {});
                };
                client.addOnError(function(event) {
                    // remove any of our own frames that may be part the stack this
                    // happens before the inline script check as it happens for all errors
                    event.errors[0].stacktrace = _$filter_21(event.errors[0].stacktrace, function(f) {
                        return !/__trace__$/.test(f.method);
                    });
                    var frame = event.errors[0].stacktrace[0];
                    // remove hash and query string from url
                    var cleanUrl = function(url) {
                        return url.replace(/#.*$/, '').replace(/\?.*$/, '');
                    };
                    // if frame.file exists and is not the original location of the page, this can't be an inline script
                    if (frame && frame.file && cleanUrl(frame.file) !== cleanUrl(originalLocation)) return;
                    // grab the last script known to have run
                    var currentScript = getCurrentScript();
                    if (currentScript) {
                        var content = currentScript.innerHTML;
                        event.addMetadata('script', 'content', content.length <= MAX_SCRIPT_LENGTH ? content : content.substr(0, MAX_SCRIPT_LENGTH));
                        // only attempt to grab some surrounding code if we have a line number
                        if (frame && frame.lineNumber) frame.code = addSurroundingCode(frame.lineNumber);
                    }
                }, true);
                // Proxy all the timer functions whose callback is their 0th argument.
                // Keep a reference to the original setTimeout because we need it later
                var _map = _$map_25([
                    'setTimeout',
                    'setInterval',
                    'setImmediate',
                    'requestAnimationFrame'
                ], function(fn) {
                    return __proxy(win, fn, function(original) {
                        return __traceOriginalScript(original, function(args) {
                            return {
                                get: function() {
                                    return args[0];
                                },
                                replace: function(fn) {
                                    args[0] = fn;
                                }
                            };
                        });
                    });
                }), _setTimeout = _map[0];
                // Proxy all the host objects whose prototypes have an addEventListener function
                _$map_25([
                    'EventTarget',
                    'Window',
                    'Node',
                    'ApplicationCache',
                    'AudioTrackList',
                    'ChannelMergerNode',
                    'CryptoOperation',
                    'EventSource',
                    'FileReader',
                    'HTMLUnknownElement',
                    'IDBDatabase',
                    'IDBRequest',
                    'IDBTransaction',
                    'KeyOperation',
                    'MediaController',
                    'MessagePort',
                    'ModalWindow',
                    'Notification',
                    'SVGElementInstance',
                    'Screen',
                    'TextTrack',
                    'TextTrackCue',
                    'TextTrackList',
                    'WebSocket',
                    'WebSocketWorker',
                    'Worker',
                    'XMLHttpRequest',
                    'XMLHttpRequestEventTarget',
                    'XMLHttpRequestUpload'
                ], function(o) {
                    if (!win[o] || !win[o].prototype || !Object.prototype.hasOwnProperty.call(win[o].prototype, 'addEventListener')) return;
                    __proxy(win[o].prototype, 'addEventListener', function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor);
                    });
                    __proxy(win[o].prototype, 'removeEventListener', function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor, true);
                    });
                });
                function __traceOriginalScript(fn, callbackAccessor, alsoCallOriginal) {
                    if (alsoCallOriginal === void 0) alsoCallOriginal = false;
                    return function() {
                        // this is required for removeEventListener to remove anything added with
                        // addEventListener before the functions started being wrapped by Bugsnag
                        var args = [].slice.call(arguments);
                        try {
                            var cba = callbackAccessor(args);
                            var cb = cba.get();
                            if (alsoCallOriginal) fn.apply(this, args);
                            if (typeof cb !== 'function') return fn.apply(this, args);
                            if (cb.__trace__) cba.replace(cb.__trace__);
                            else {
                                var script = getCurrentScript();
                                // this function mustn't be annonymous due to a bug in the stack
                                // generation logic, meaning it gets tripped up
                                // see: https://github.com/stacktracejs/stack-generator/issues/6
                                cb.__trace__ = function __trace__() {
                                    // set the script that called this function
                                    updateLastScript(script);
                                    // immediately unset the currentScript synchronously below, however
                                    // if this cb throws an error the line after will not get run so schedule
                                    // an almost-immediate aysnc update too
                                    _setTimeout(function() {
                                        updateLastScript(null);
                                    }, 0);
                                    var ret = cb.apply(this, arguments);
                                    updateLastScript(null);
                                    return ret;
                                };
                                cb.__trace__.__trace__ = cb.__trace__;
                                cba.replace(cb.__trace__);
                            }
                        } catch (e) {
                        // swallow these errors on Selenium:
                        // Permission denied to access property '__trace__'
                        // WebDriverException: Message: Permission denied to access property "handleEvent"
                        }
                        // IE8 doesn't let you call .apply() on setTimeout/setInterval
                        if (fn.apply) return fn.apply(this, args);
                        switch(args.length){
                            case 1:
                                return fn(args[0]);
                            case 2:
                                return fn(args[0], args[1]);
                            default:
                                return fn();
                        }
                    };
                }
            },
            configSchema: {
                trackInlineScripts: {
                    validate: function(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function() {
                        return true;
                    },
                    message: 'should be true|false'
                }
            }
        };
    };
    function __proxy(host, name, replacer) {
        var original = host[name];
        if (!original) return original;
        var replacement = replacer(original);
        host[name] = replacement;
        return original;
    }
    function eventTargetCallbackAccessor(args) {
        var isEventHandlerObj = !!args[1] && typeof args[1].handleEvent === 'function';
        return {
            get: function() {
                return isEventHandlerObj ? args[1].handleEvent : args[1];
            },
            replace: function(fn) {
                if (isEventHandlerObj) args[1].handleEvent = fn;
                else args[1] = fn;
            }
        };
    }
    /*
 * Leaves breadcrumbs when the user interacts with the DOM
 */ var _$interactionBreadcrumbs_47 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                if (!('addEventListener' in win)) return;
                if (!client._isBreadcrumbTypeEnabled('user')) return;
                win.addEventListener('click', function(event) {
                    var targetText, targetSelector;
                    try {
                        targetText = getNodeText(event.target);
                        targetSelector = getNodeSelector(event.target, win);
                    } catch (e) {
                        targetText = '[hidden]';
                        targetSelector = '[hidden]';
                        client._logger.error('Cross domain error when tracking click event. See docs: https://tinyurl.com/yy3rn63z');
                    }
                    client.leaveBreadcrumb('UI click', {
                        targetText: targetText,
                        targetSelector: targetSelector
                    }, 'user');
                }, true);
            }
        };
    };
    var trim = /^\s*([^\s][\s\S]{0,139}[^\s])?\s*/;
    function getNodeText(el) {
        var text = el.textContent || el.innerText || '';
        if (!text && (el.type === 'submit' || el.type === 'button')) text = el.value;
        text = text.replace(trim, '$1');
        if (text.length > 140) return text.slice(0, 135) + '(...)';
        return text;
    }
    // Create a label from tagname, id and css class of the element
    function getNodeSelector(el, win) {
        var parts = [
            el.tagName
        ];
        if (el.id) parts.push('#' + el.id);
        if (el.className && el.className.length) parts.push("." + el.className.split(' ').join('.'));
        // Can't get much more advanced with the current browser
        if (!win.document.querySelectorAll || !Array.prototype.indexOf) return parts.join('');
        try {
            if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join('');
        } catch (e) {
            // Sometimes the query selector can be invalid just return it as-is
            return parts.join('');
        }
        // try to get a more specific selector if this one matches more than one element
        if (el.parentNode.childNodes.length > 1) {
            var index = Array.prototype.indexOf.call(el.parentNode.childNodes, el) + 1;
            parts.push(":nth-child(" + index + ")");
        }
        if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join('');
        // try prepending the parent node selector
        if (el.parentNode) return getNodeSelector(el.parentNode, win) + " > " + parts.join('');
        return parts.join('');
    }
    var _$navigationBreadcrumbs_48 = {};
    /*
* Leaves breadcrumbs when navigation methods are called or events are emitted
*/ _$navigationBreadcrumbs_48 = function(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function(client) {
                if (!('addEventListener' in win)) return;
                if (!client._isBreadcrumbTypeEnabled('navigation')) return;
                // returns a function that will drop a breadcrumb with a given name
                var drop = function(name) {
                    return function() {
                        return client.leaveBreadcrumb(name, {}, 'navigation');
                    };
                };
                // simple drops – just names, no meta
                win.addEventListener('pagehide', drop('Page hidden'), true);
                win.addEventListener('pageshow', drop('Page shown'), true);
                win.addEventListener('load', drop('Page loaded'), true);
                win.document.addEventListener('DOMContentLoaded', drop('DOMContentLoaded'), true);
                // some browsers like to emit popstate when the page loads, so only add the popstate listener after that
                win.addEventListener('load', function() {
                    return win.addEventListener('popstate', drop('Navigated back'), true);
                });
                // hashchange has some metadata that we care about
                win.addEventListener('hashchange', function(event) {
                    var metadata = event.oldURL ? {
                        from: relativeLocation(event.oldURL, win),
                        to: relativeLocation(event.newURL, win),
                        state: getCurrentState(win)
                    } : {
                        to: relativeLocation(win.location.href, win)
                    };
                    client.leaveBreadcrumb('Hash changed', metadata, 'navigation');
                }, true);
                // the only way to know about replaceState/pushState is to wrap them… >_<
                if (win.history.pushState) wrapHistoryFn(client, win.history, 'pushState', win, true);
                if (win.history.replaceState) wrapHistoryFn(client, win.history, 'replaceState', win);
            }
        };
        return plugin;
    };
    // takes a full url like http://foo.com:1234/pages/01.html?yes=no#section-2 and returns
    // just the path and hash parts, e.g. /pages/01.html?yes=no#section-2
    var relativeLocation = function(url, win) {
        var a = win.document.createElement('A');
        a.href = url;
        return "" + a.pathname + a.search + a.hash;
    };
    var stateChangeToMetadata = function(win, state, title, url) {
        var currentPath = relativeLocation(win.location.href, win);
        return {
            title: title,
            state: state,
            prevState: getCurrentState(win),
            to: url || currentPath,
            from: currentPath
        };
    };
    var wrapHistoryFn = function(client, target, fn, win, resetEventCount) {
        if (resetEventCount === void 0) resetEventCount = false;
        var orig = target[fn];
        target[fn] = function(state, title, url) {
            client.leaveBreadcrumb("History " + fn, stateChangeToMetadata(win, state, title, url), 'navigation');
            // if throttle plugin is in use, reset the event sent count
            if (resetEventCount && typeof client.resetEventCount === 'function') client.resetEventCount();
            // Internet Explorer will convert `undefined` to a string when passed, causing an unintended redirect
            // to '/undefined'. therefore we only pass the url if it's not undefined.
            orig.apply(target, [
                state,
                title
            ].concat(url !== undefined ? url : []));
        };
    };
    var getCurrentState = function(win) {
        try {
            return win.history.state;
        } catch (e) {}
    };
    var BREADCRUMB_TYPE = 'request';
    /*
 * Leaves breadcrumbs when network requests occur
 */ var _$networkBreadcrumbs_49 = function(_ignoredUrls, win) {
        if (_ignoredUrls === void 0) _ignoredUrls = [];
        if (win === void 0) win = window;
        var restoreFunctions = [];
        var plugin = {
            load: function(client) {
                if (!client._isBreadcrumbTypeEnabled('request')) return;
                var ignoredUrls = [
                    client._config.endpoints.notify,
                    client._config.endpoints.sessions
                ].concat(_ignoredUrls);
                monkeyPatchXMLHttpRequest();
                monkeyPatchFetch();
                // XMLHttpRequest monkey patch
                function monkeyPatchXMLHttpRequest() {
                    if (!('addEventListener' in win.XMLHttpRequest.prototype) || !('WeakMap' in win)) return;
                    var trackedRequests = new WeakMap();
                    var requestHandlers = new WeakMap();
                    var originalOpen = win.XMLHttpRequest.prototype.open;
                    win.XMLHttpRequest.prototype.open = function open(method, url) {
                        // it's possible for `this` to be `undefined`, which is not a valid key for a WeakMap
                        if (this) trackedRequests.set(this, {
                            method: method,
                            url: url
                        });
                        originalOpen.apply(this, arguments);
                    };
                    var originalSend = win.XMLHttpRequest.prototype.send;
                    win.XMLHttpRequest.prototype.send = function send(body) {
                        var _this = this;
                        var requestData = trackedRequests.get(this);
                        if (requestData) {
                            // if we have already setup listeners then this request instance is being reused,
                            // so we need to remove the listeners from the previous send
                            var listeners = requestHandlers.get(this);
                            if (listeners) {
                                this.removeEventListener('load', listeners.load);
                                this.removeEventListener('error', listeners.error);
                            }
                            var requestStart = new Date();
                            var error = function() {
                                return handleXHRError(requestData.method, requestData.url, getDuration(requestStart));
                            };
                            var load = function() {
                                return handleXHRLoad(requestData.method, requestData.url, _this.status, getDuration(requestStart));
                            };
                            this.addEventListener('load', load);
                            this.addEventListener('error', error);
                            // it's possible for `this` to be `undefined`, which is not a valid key for a WeakMap
                            if (this) requestHandlers.set(this, {
                                load: load,
                                error: error
                            });
                        }
                        originalSend.apply(this, arguments);
                    };
                }
                function handleXHRLoad(method, url, status, duration) {
                    if (url === undefined) {
                        client._logger.warn('The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.');
                        return;
                    }
                    // an XMLHttpRequest's URL can be an object as long as its 'toString'
                    // returns a URL, e.g. a HTMLAnchorElement
                    if (typeof url === 'string' && _$includes_22(ignoredUrls, url.replace(/\?.*$/, ''))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                    var metadata = {
                        status: status,
                        method: String(method),
                        url: String(url),
                        duration: duration
                    };
                    if (status >= 400) // contacted server but got an error response
                    client.leaveBreadcrumb('XMLHttpRequest failed', metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb('XMLHttpRequest succeeded', metadata, BREADCRUMB_TYPE);
                }
                function handleXHRError(method, url, duration) {
                    if (url === undefined) {
                        client._logger.warn('The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.');
                        return;
                    }
                    if (typeof url === 'string' && _$includes_22(ignoredUrls, url.replace(/\?.*$/, ''))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                    // failed to contact server
                    client.leaveBreadcrumb('XMLHttpRequest error', {
                        method: String(method),
                        url: String(url),
                        duration: duration
                    }, BREADCRUMB_TYPE);
                }
                // window.fetch monkey patch
                function monkeyPatchFetch() {
                    // only patch it if it exists and if it is not a polyfill (patching a polyfilled
                    // fetch() results in duplicate breadcrumbs for the same request because the
                    // implementation uses XMLHttpRequest which is also patched)
                    if (!('fetch' in win) || win.fetch.polyfill) return;
                    var oldFetch = win.fetch;
                    win.fetch = function fetch() {
                        var _arguments = arguments;
                        var urlOrRequest = arguments[0];
                        var options = arguments[1];
                        var method;
                        var url = null;
                        if (urlOrRequest && typeof urlOrRequest === 'object') {
                            url = urlOrRequest.url;
                            if (options && 'method' in options) method = options.method;
                            else if (urlOrRequest && 'method' in urlOrRequest) method = urlOrRequest.method;
                        } else {
                            url = urlOrRequest;
                            if (options && 'method' in options) method = options.method;
                        }
                        if (method === undefined) method = 'GET';
                        return new Promise(function(resolve, reject) {
                            var requestStart = new Date();
                            // pass through to native fetch
                            oldFetch.apply(void 0, _arguments).then(function(response) {
                                handleFetchSuccess(response, method, url, getDuration(requestStart));
                                resolve(response);
                            })["catch"](function(error) {
                                handleFetchError(method, url, getDuration(requestStart));
                                reject(error);
                            });
                        });
                    };
                }
                var handleFetchSuccess = function(response, method, url, duration) {
                    var metadata = {
                        method: String(method),
                        status: response.status,
                        url: String(url),
                        duration: duration
                    };
                    if (response.status >= 400) // when the request comes back with a 4xx or 5xx status it does not reject the fetch promise,
                    client.leaveBreadcrumb('fetch() failed', metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb('fetch() succeeded', metadata, BREADCRUMB_TYPE);
                };
                var handleFetchError = function(method, url, duration) {
                    client.leaveBreadcrumb('fetch() error', {
                        method: String(method),
                        url: String(url),
                        duration: duration
                    }, BREADCRUMB_TYPE);
                };
            }
        };
        return plugin;
    };
    var getDuration = function(startTime) {
        return startTime && new Date() - startTime;
    };
    /*
 * Throttles and dedupes events
 */ var _$throttle_50 = {
        load: function(client) {
            // track sent events for each init of the plugin
            var n = 0;
            // add onError hook
            client.addOnError(function(event) {
                // have max events been sent already?
                if (n >= client._config.maxEvents) {
                    client._logger.warn("Cancelling event send due to maxEvents per session limit of " + client._config.maxEvents + " being reached");
                    return false;
                }
                n++;
            });
            client.resetEventCount = function() {
                n = 0;
            };
        },
        configSchema: {
            maxEvents: {
                defaultValue: function() {
                    return 10;
                },
                message: "should be a positive integer \u2264100",
                validate: function(val) {
                    return _$intRange_33(1, 100)(val);
                }
            }
        }
    };
    var _$stripQueryString_51 = {};
    _$stripQueryString_51 = {
        load: function(client) {
            client.addOnError(function(event) {
                var allFrames = _$reduce_26(event.errors, function(accum, er) {
                    return accum.concat(er.stacktrace);
                }, []);
                _$map_25(allFrames, function(frame) {
                    frame.file = strip(frame.file);
                });
            });
        }
    };
    var strip = _$stripQueryString_51._strip = function(str) {
        return typeof str === 'string' ? str.replace(/\?.*$/, '').replace(/#.*$/, '') : str;
    };
    /*
 * Automatically notifies Bugsnag when window.onerror is called
 */ var _$onerror_52 = function(win, component) {
        if (win === void 0) win = window;
        if (component === void 0) component = 'window onerror';
        return {
            load: function(client) {
                if (!client._config.autoDetectErrors) return;
                if (!client._config.enabledErrorTypes.unhandledExceptions) return;
                function onerror(messageOrEvent, url, lineNo, charNo, error) {
                    // Ignore errors with no info due to CORS settings
                    if (lineNo === 0 && /Script error\.?/.test(messageOrEvent)) client._logger.warn('Ignoring cross-domain or eval script error. See docs: https://tinyurl.com/yy3rn63z');
                    else {
                        // any error sent to window.onerror is unhandled and has severity=error
                        var handledState = {
                            severity: 'error',
                            unhandled: true,
                            severityReason: {
                                type: 'unhandledException'
                            }
                        };
                        var event;
                        // window.onerror can be called in a number of ways. This big if-else is how we
                        // figure out which arguments were supplied, and what kind of values it received.
                        if (error) {
                            // if the last parameter (error) was supplied, this is a modern browser's
                            // way of saying "this value was thrown and not caught"
                            event = client.Event.create(error, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        } else if (// This complex case detects "error" events that are typically synthesised
                        // by jquery's trigger method (although can be created in other ways). In
                        // order to detect this:
                        // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
                        // - the second argument (url) must either not exist or be something other than a string (if it
                        //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
                        //    function)
                        // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
                        typeof messageOrEvent === 'object' && messageOrEvent !== null && (!url || typeof url !== 'string') && !lineNo && !charNo && !error) {
                            // The jQuery event may have a "type" property, if so use it as part of the error message
                            var name = messageOrEvent.type ? "Event: " + messageOrEvent.type : 'Error';
                            // attempt to find a message from one of the conventional properties, but
                            // default to empty string (the event will fill it with a placeholder)
                            var message = messageOrEvent.message || messageOrEvent.detail || '';
                            event = client.Event.create({
                                name: name,
                                message: message
                            }, true, handledState, component, 1);
                            // provide the original thing onerror received – not our error-like object we passed to _notify
                            event.originalError = messageOrEvent;
                            // include the raw input as metadata – it might contain more info than we extracted
                            event.addMetadata(component, {
                                event: messageOrEvent,
                                extraParameters: url
                            });
                        } else {
                            // Lastly, if there was no "error" parameter this event was probably from an old
                            // browser that doesn't support that. Instead we need to generate a stacktrace.
                            event = client.Event.create(messageOrEvent, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        }
                        client._notify(event);
                    }
                    if (typeof prevOnError === 'function') prevOnError.apply(this, arguments);
                }
                var prevOnError = win.onerror;
                win.onerror = onerror;
            }
        };
    };
    // Sometimes the stacktrace has less information than was passed to window.onerror.
    // This function will augment the first stackframe with any useful info that was
    // received as arguments to the onerror callback.
    var decorateStack = function(stack, url, lineNo, charNo) {
        if (!stack[0]) stack.push({});
        var culprit = stack[0];
        if (!culprit.file && typeof url === 'string') culprit.file = url;
        if (!culprit.lineNumber && isActualNumber(lineNo)) culprit.lineNumber = lineNo;
        if (!culprit.columnNumber) {
            if (isActualNumber(charNo)) culprit.columnNumber = charNo;
            else if (window.event && isActualNumber(window.event.errorCharacter)) culprit.columnNumber = window.event.errorCharacter;
        }
    };
    var isActualNumber = function(n) {
        return typeof n === 'number' && String.call(n) !== 'NaN';
    };
    var _listener;
    /*
 * Automatically notifies Bugsnag when window.onunhandledrejection is called
 */ var _$unhandledRejection_53 = function(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function(client) {
                if (!client._config.autoDetectErrors || !client._config.enabledErrorTypes.unhandledRejections) return;
                var listener = function(evt) {
                    var error = evt.reason;
                    var isBluebird = false;
                    // accessing properties on evt.detail can throw errors (see #394)
                    try {
                        if (evt.detail && evt.detail.reason) {
                            error = evt.detail.reason;
                            isBluebird = true;
                        }
                    } catch (e) {}
                    // Report unhandled promise rejections as handled if the user has configured it
                    var unhandled = !client._config.reportUnhandledPromiseRejectionsAsHandled;
                    var event = client.Event.create(error, false, {
                        severity: 'error',
                        unhandled: unhandled,
                        severityReason: {
                            type: 'unhandledPromiseRejection'
                        }
                    }, 'unhandledrejection handler', 1, client._logger);
                    if (isBluebird) _$map_25(event.errors[0].stacktrace, fixBluebirdStacktrace(error));
                    client._notify(event, function(event) {
                        if (_$iserror_29(event.originalError) && !event.originalError.stack) {
                            var _event$addMetadata;
                            event.addMetadata('unhandledRejection handler', (_event$addMetadata = {}, _event$addMetadata[Object.prototype.toString.call(event.originalError)] = {
                                name: event.originalError.name,
                                message: event.originalError.message,
                                code: event.originalError.code
                            }, _event$addMetadata));
                        }
                    });
                };
                if ('addEventListener' in win) win.addEventListener('unhandledrejection', listener);
                else win.onunhandledrejection = function(reason, promise) {
                    listener({
                        detail: {
                            reason: reason,
                            promise: promise
                        }
                    });
                };
                _listener = listener;
            }
        };
        return plugin;
    };
    // The stack parser on bluebird stacks in FF get a suprious first frame:
    //
    // Error: derp
    //   b@http://localhost:5000/bluebird.html:22:24
    //   a@http://localhost:5000/bluebird.html:18:9
    //   @http://localhost:5000/bluebird.html:14:9
    //
    // results in
    //   […]
    //     0: Object { file: "Error: derp", method: undefined, lineNumber: undefined, … }
    //     1: Object { file: "http://localhost:5000/bluebird.html", method: "b", lineNumber: 22, … }
    //     2: Object { file: "http://localhost:5000/bluebird.html", method: "a", lineNumber: 18, … }
    //     3: Object { file: "http://localhost:5000/bluebird.html", lineNumber: 14, columnNumber: 9, … }
    //
    // so the following reduce/accumulator function removes such frames
    //
    // Bluebird pads method names with spaces so trim that too…
    // https://github.com/petkaantonov/bluebird/blob/b7f21399816d02f979fe434585334ce901dcaf44/src/debuggability.js#L568-L571
    var fixBluebirdStacktrace = function(error) {
        return function(frame) {
            if (frame.file === error.toString()) return;
            if (frame.method) frame.method = frame.method.replace(/^\s+/, '');
        };
    };
    var _$notifier_11 = {};
    var name = 'Bugsnag JavaScript';
    var version = '8.2.0';
    var url = 'https://github.com/bugsnag/bugsnag-js';
    // extend the base config schema with some browser-specific options
    var __schema_11 = _$assign_20({}, _$config_14.schema, _$config_10);
    var Bugsnag = {
        _client: null,
        createClient: function(opts) {
            // handle very simple use case where user supplies just the api key as a string
            if (typeof opts === 'string') opts = {
                apiKey: opts
            };
            if (!opts) opts = {};
            var internalPlugins = [
                // add browser-specific plugins
                _$app_39,
                _$device_41(),
                _$context_40(),
                _$request_42(),
                _$throttle_50,
                _$session_43,
                _$clientIp_44,
                _$stripQueryString_51,
                _$onerror_52(),
                _$unhandledRejection_53(),
                _$navigationBreadcrumbs_48(),
                _$interactionBreadcrumbs_47(),
                _$networkBreadcrumbs_49(),
                _$consoleBreadcrumbs_45,
                // this one added last to avoid wrapping functionality before bugsnag uses it
                _$inlineScriptContent_46()
            ];
            // configure a client with user supplied options
            var bugsnag = new _$Client_13(opts, __schema_11, internalPlugins, {
                name: name,
                version: version,
                url: url
            });
            // set delivery based on browser capability (IE 8+9 have an XDomainRequest object)
            bugsnag._setDelivery(window.XDomainRequest ? _$delivery_37 : _$delivery_38);
            bugsnag._logger.debug('Loaded!');
            bugsnag.leaveBreadcrumb('Bugsnag loaded', {}, 'state');
            return bugsnag._config.autoTrackSessions ? bugsnag.startSession() : bugsnag;
        },
        start: function(opts) {
            if (Bugsnag._client) {
                Bugsnag._client._logger.warn('Bugsnag.start() was called more than once. Ignoring.');
                return Bugsnag._client;
            }
            Bugsnag._client = Bugsnag.createClient(opts);
            return Bugsnag._client;
        },
        isStarted: function() {
            return Bugsnag._client != null;
        }
    };
    _$map_25([
        'resetEventCount'
    ].concat(_$keys_24(_$Client_13.prototype)), function(m) {
        if (/^_/.test(m)) return;
        Bugsnag[m] = function() {
            if (!Bugsnag._client) return console.log("Bugsnag." + m + "() was called before Bugsnag.start()");
            Bugsnag._client._depth += 1;
            var ret = Bugsnag._client[m].apply(Bugsnag._client, arguments);
            Bugsnag._client._depth -= 1;
            return ret;
        };
    });
    _$notifier_11 = Bugsnag;
    _$notifier_11.Client = _$Client_13;
    _$notifier_11.Event = _$Event_15;
    _$notifier_11.Session = _$Session_36;
    _$notifier_11.Breadcrumb = _$Breadcrumb_12;
    // Export a "default" property for compatibility with ESM imports
    _$notifier_11["default"] = Bugsnag;
    return _$notifier_11;
});

});

var $14fc2f3a09df08ae$exports = {};
'use strict';

$14fc2f3a09df08ae$exports = (parcelRequire("36KFK"));



var $gIfym = parcelRequire("gIfym");
var $49079038e9e61aa0$exports = {};
'use strict';
function $49079038e9e61aa0$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($49079038e9e61aa0$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$49079038e9e61aa0$var$checkDCE();

$49079038e9e61aa0$exports = (parcelRequire("gQH9B"));


var $9c8166cf7946f78b$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $9c8166cf7946f78b$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $9c8166cf7946f78b$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $9c8166cf7946f78b$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});




var $gIfym = parcelRequire("gIfym");



var $gIfym = parcelRequire("gIfym");

var $gIfym = parcelRequire("gIfym");
const $d776f55cbdbd0b07$export$e6a44b110a0c44d3 = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createContext({
    locationState: undefined,
    setLocationAddress: ()=>{}
});
var $d776f55cbdbd0b07$export$9d467c3b30850351 = /*#__PURE__*/ function(LocationFetchType) {
    LocationFetchType["CACHED_ADDRESS"] = "CACHED_ADDRESS";
    LocationFetchType["BROWSER_GEOLOCATION"] = "BROWSER_GEOLOCATION";
    LocationFetchType["IP_INFO"] = "IP_INFO";
    return LocationFetchType;
}({});


const $58e79092af177c1d$export$5b6c28c7dca07ad7 = '5 Calls';
const $58e79092af177c1d$export$bbd8abc0926efbd6 = 'https://5calls.org';
const $58e79092af177c1d$export$923ea8233b386e99 = 'https://api.5calls.org/v1';
const $58e79092af177c1d$export$6315f07e9b09b82b = `${$58e79092af177c1d$export$923ea8233b386e99}/issues`;
const $58e79092af177c1d$export$74281da0d93ff65a = `${$58e79092af177c1d$export$923ea8233b386e99}/issuesForPublishing`;
const $58e79092af177c1d$export$c0c8be80595ad0a4 = `${$58e79092af177c1d$export$923ea8233b386e99}/reps`;
const $58e79092af177c1d$export$5929f3d33d960184 = `${$58e79092af177c1d$export$923ea8233b386e99}/issues/completed`;
const $58e79092af177c1d$export$7d8de6209b49ac6 = `${$58e79092af177c1d$export$923ea8233b386e99}/report`;
const $58e79092af177c1d$export$a0cd11416aea5ceb = `${$58e79092af177c1d$export$923ea8233b386e99}/users/stats`;
const $58e79092af177c1d$export$13f5ebcfc2a7fe46 = `${$58e79092af177c1d$export$923ea8233b386e99}/users/profile`;
const $58e79092af177c1d$export$73031802601da236 = `${$58e79092af177c1d$export$923ea8233b386e99}/users/updateDistrict`;
const $58e79092af177c1d$export$912b2f0197922df = `${$58e79092af177c1d$export$923ea8233b386e99}/users/refs`;
const $58e79092af177c1d$export$2996a91724e66f2c = `${$58e79092af177c1d$export$923ea8233b386e99}/users/search`;
const $58e79092af177c1d$export$b20ac9bd071a81f6 = `${$58e79092af177c1d$export$923ea8233b386e99}/users/sendAPIToken`;
const $58e79092af177c1d$export$71ef5cacb3fa1019 = `${$58e79092af177c1d$export$923ea8233b386e99}/users/donationStats`;
const $58e79092af177c1d$export$1ced743ad94a4ad = `${$58e79092af177c1d$export$923ea8233b386e99}/remind`;
const $58e79092af177c1d$export$d09dd1b4474f0ce6 = 'https://secure.actblue.com/donate/5calls-donate';
const $58e79092af177c1d$export$c0209fca03424799 = '5iuTAwr4Tnr8EvmUeAN5AsoQ';
const $58e79092af177c1d$export$cab5800d1ed939a7 = 'https://airtable.com/shrJBbpixnJ09iVb3';
const $58e79092af177c1d$export$f94e59c416e14db9 = 'https://shareimages.5calls.org/';
const $58e79092af177c1d$export$2ec53a4c598cbdd5 = {
    DISTRICT: 'district',
    SUBSCRIBER: 'subscriber',
    SETTINGS: 'app_settings',
    CALLER_ID: 'callerID',
    LOCATION_KEY: 'persist:fivecalls',
    COMPLETION_KEY: 'persist:fivecalls-completedIssueMap'
};
const $58e79092af177c1d$export$3ea660d37bd560e4 = /^\d{5}(-\d{4})?$/;
const $58e79092af177c1d$export$8632c16165912b90 = {
    default: 86400000,
    groups: 86400000 // 1 day
};
const $58e79092af177c1d$export$414d047e665c7112 = {
    email: 'hello@5calls.org',
    github: 'https://github.com/5calls',
    twitter: 'https://twitter.com/make5calls',
    facebook: 'https://www.facebook.com/make5calls',
    apps: 'https://crgj.app.link/7R2bEB0R4F'
};
const $58e79092af177c1d$export$7ff69bf5c61582bf = {
    LOCATION_LOADED: 'locationLoaded',
    UPDATE_REPS: 'updateReps',
    ACTIVE_CONTACT: 'activeContact',
    NEXT_CONTACT: 'nextContact',
    LOADED_REPS: 'loadedReps',
    SEARCH_RESULTS_RENDERED: 'searchResultsRendered'
};


const $6c76588335ac048e$var$saveLocation = (location)=>{
    const newStoredData = {
        locationState: JSON.stringify(location)
    };
    localStorage.setItem((0, $58e79092af177c1d$export$2ec53a4c598cbdd5).LOCATION_KEY, JSON.stringify(newStoredData));
};
const $6c76588335ac048e$var$saveCompleted = (completedIssueMap)=>{
    localStorage.setItem((0, $58e79092af177c1d$export$2ec53a4c598cbdd5).COMPLETION_KEY, JSON.stringify(completedIssueMap));
};
const $6c76588335ac048e$var$getStorageAsObject = ()=>{
    const getStoredState = (key)=>{
        const storageString = localStorage.getItem(key) ?? '{}';
        return JSON.parse(storageString);
    };
    const locationData = getStoredState((0, $58e79092af177c1d$export$2ec53a4c598cbdd5).LOCATION_KEY);
    const locationState = JSON.parse(locationData.locationState ?? '{}');
    const completedIssueMap = getStoredState((0, $58e79092af177c1d$export$2ec53a4c598cbdd5).COMPLETION_KEY);
    const appState = {
        locationState: locationState,
        completedIssueMap: completedIssueMap
    };
    return appState;
};
var $6c76588335ac048e$export$2e2bcd8739ae039 = {
    saveLocation: $6c76588335ac048e$var$saveLocation,
    saveCompleted: $6c76588335ac048e$var$saveCompleted,
    getStorageAsObject: $6c76588335ac048e$var$getStorageAsObject
};



var $gIfym = parcelRequire("gIfym");
const $9144ecc2a4f5e1e9$export$fefd3a1b6d6d1f37 = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createContext({
    completedIssueMap: {},
    setCompletedIssueMap: ()=>{}
});



class $b410c744327f470f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    componentDidMount() {
        try {
            this.loadFromStorage();
        } catch (error) {
            console.log('could not parse localstorage, removing:', error);
            localStorage.removeItem('persist:fivecalls');
        }
        // if these events are fired, we should reload from storage
        document.addEventListener($58e79092af177c1d$export$7ff69bf5c61582bf.UPDATE_REPS, ()=>{
            this.loadFromStorage();
        });
    }
    loadFromStorage() {
        const appState = (0, $6c76588335ac048e$export$2e2bcd8739ae039).getStorageAsObject();
        const hadLocation = !!this.state.locationState;
        const newLocationState = appState.locationState;
        this.setState({
            locationState: newLocationState,
            completedIssueMap: appState.completedIssueMap,
            savedStateRestored: true
        });
        // Dispatch event if location became available
        if (!hadLocation && newLocationState) {
            const locationLoadedEvent = new CustomEvent($58e79092af177c1d$export$7ff69bf5c61582bf.LOCATION_LOADED, {
                detail: newLocationState
            });
            document.dispatchEvent(locationLoadedEvent);
        }
    }
    setLocationAddress(address, display, state) {
        // save the location and cached city in localstorage
        // if the backend passes "unknown address" just remove it
        const locationState = {
            address: address,
            cachedCity: display,
            state: state
        };
        (0, $6c76588335ac048e$export$2e2bcd8739ae039).saveLocation(locationState);
        this.setState({
            locationState: locationState
        });
        // Dispatch event when location is updated
        const locationLoadedEvent = new CustomEvent($58e79092af177c1d$export$7ff69bf5c61582bf.LOCATION_LOADED, {
            detail: locationState
        });
        document.dispatchEvent(locationLoadedEvent);
    }
    setCompletedIssueMap(updatedCompletedIssueMap) {
        const newCompletedIssueMap = {
            ...this.state.completedIssueMap,
            ...updatedCompletedIssueMap
        };
        (0, $6c76588335ac048e$export$2e2bcd8739ae039).saveCompleted(newCompletedIssueMap);
        this.setState({
            completedIssueMap: newCompletedIssueMap
        });
    }
    render() {
        // simple version of the redux-persist gate where nothing is rendered until the persisted
        // data is loaded for the first time
        if (!this.state.savedStateRestored) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {});
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d776f55cbdbd0b07$export$e6a44b110a0c44d3).Provider, {
            value: {
                locationState: this.state.locationState,
                setLocationAddress: (address, display, state)=>this.setLocationAddress(address, display, state)
            },
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9144ecc2a4f5e1e9$export$fefd3a1b6d6d1f37).Provider, {
                value: {
                    completedIssueMap: this.state.completedIssueMap || {},
                    setCompletedIssueMap: (issueMapUpdates)=>this.setCompletedIssueMap(issueMapUpdates)
                },
                children: this.props.children
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            locationState: undefined,
            savedStateRestored: false,
            completedIssueMap: {}
        };
    }
}
const $b410c744327f470f$export$71260fd0c34a821 = (Component)=>(props)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d776f55cbdbd0b07$export$e6a44b110a0c44d3).Consumer, {
            children: ({ locationState: locationState, setLocationAddress: setLocationAddress })=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)(Component, {
                    ...props,
                    locationState: locationState,
                    setLocationAddress: setLocationAddress
                })
        });
const $b410c744327f470f$export$1688adba58f7c3f1 = (Component)=>(props)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9144ecc2a4f5e1e9$export$fefd3a1b6d6d1f37).Consumer, {
            children: ({ completedIssueMap: completedIssueMap, setCompletedIssueMap: setCompletedIssueMap })=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)(Component, {
                    ...props,
                    completedIssueMap: completedIssueMap,
                    setCompletedIssueMap: setCompletedIssueMap
                })
        });


const $0dfcc6ce5e98ece8$export$4c6036784fce21c9 = 5000;
const $0dfcc6ce5e98ece8$export$70bad4d91dd06fd0 = 30000;
const $0dfcc6ce5e98ece8$export$a62dbeab5425a473 = ()=>{
    return new Promise((resolve, reject)=>{
        if (navigator.geolocation) {
            const geolocation = navigator.geolocation;
            geolocation.getCurrentPosition(// PositionCallback
            (position)=>{
                const coords = position.coords;
                // tslint:disable-next-line:no-shadowed-variable
                const geolocation = {
                    latitude: coords.latitude,
                    longitude: coords.longitude
                };
                resolve(geolocation);
            }, // PositionErrorCallback
            (e)=>{
                const code = e.code;
                if (code === 3 /* PositionError.POSITION_UNAVAILABLE */  || code === 2 /* PositionError.TIMEOUT */  || code === 1 /* PositionError.PERMISSION_DENIED */ ) {
                    const msg = `Browser geolocation not successfully accomplished;
              PositionError code: ${code};
              PositionError message: ${e.message}`;
                    // send back an undefined location
                    reject(new Error(msg));
                } else {
                    const msg = `Problem doing browser geolocation;
            PositionError code: ${code};
            PositionError message: ${e.message}`;
                    // tslint:disable-next-line:no-console
                    console.error(msg, e);
                    reject(new Error(msg));
                }
            }, // PositionOptions
            {
                enableHighAccuracy: true,
                timeout: $0dfcc6ce5e98ece8$export$4c6036784fce21c9,
                maximumAge: $0dfcc6ce5e98ece8$export$70bad4d91dd06fd0
            });
        } else reject(new Error('Browser Geolocation API not available'));
    });
};


var $211a2c8778873708$exports = {};

$211a2c8778873708$exports = (parcelRequire("jfo0o"));


var $f7c1befdafb30ab2$export$2f872c0f2117be69;
var $f7c1befdafb30ab2$export$98e6a39c04603d36;
var $f7c1befdafb30ab2$export$c564cdbbe6da493;
var $f7c1befdafb30ab2$export$fac44ee5b035f737;
'use strict';

$f7c1befdafb30ab2$export$2f872c0f2117be69 = $f7c1befdafb30ab2$export$98e6a39c04603d36 = (parcelRequire("2hmD9"));

$f7c1befdafb30ab2$export$c564cdbbe6da493 = $f7c1befdafb30ab2$export$fac44ee5b035f737 = (parcelRequire("4aO2u"));


const $8fec4eb0f62d5de4$var$ONESIGNAL_SDK_ID = 'onesignal-sdk';
const $8fec4eb0f62d5de4$var$ONE_SIGNAL_SCRIPT_SRC = 'https://cdn.onesignal.com/sdks/OneSignalSDK.js';
const $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue = [];
// true if the script is successfully loaded from CDN.
let $8fec4eb0f62d5de4$var$isOneSignalInitialized = false;
// true if the script fails to load from CDN. A separate flag is necessary
// to disambiguate between a CDN load failure and a delayed call to
// OneSignal#init.
let $8fec4eb0f62d5de4$var$isOneSignalScriptFailed = false;
const $8fec4eb0f62d5de4$var$doesOneSignalExist = ()=>{
    if (window["OneSignal"]) return true;
    return false;
};
const $8fec4eb0f62d5de4$var$handleOnLoad = (resolve, options)=>{
    $8fec4eb0f62d5de4$var$isOneSignalInitialized = true;
    // OneSignal is assumed to be loaded correctly because this method
    // is called after the script is successfully loaded by CDN, but
    // just in case.
    window["OneSignal"] = window["OneSignal"] || [];
    window["OneSignal"].push(()=>{
        window["OneSignal"].init(options);
    });
    window["OneSignal"].push(()=>{
        $8fec4eb0f62d5de4$var$processQueuedOneSignalFunctions();
        resolve();
    });
};
const $8fec4eb0f62d5de4$var$handleOnError = (resolve)=>{
    $8fec4eb0f62d5de4$var$isOneSignalScriptFailed = true;
    // Ensure that any unresolved functions are cleared from the queue,
    // even in the event of a CDN load failure.
    $8fec4eb0f62d5de4$var$processQueuedOneSignalFunctions();
    resolve();
};
const $8fec4eb0f62d5de4$var$processQueuedOneSignalFunctions = ()=>{
    $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.forEach((element)=>{
        const { name: name, args: args, promiseResolver: promiseResolver } = element;
        if (!!promiseResolver) $8fec4eb0f62d5de4$var$OneSignalReact[name](...args).then((result)=>{
            promiseResolver(result);
        });
        else $8fec4eb0f62d5de4$var$OneSignalReact[name](...args);
    });
};
const $8fec4eb0f62d5de4$var$init = (options)=>new Promise((resolve)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalInitialized) {
            resolve();
            return;
        }
        if (!options || !options.appId) throw new Error('You need to provide your OneSignal appId.');
        if (!document) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.id = $8fec4eb0f62d5de4$var$ONESIGNAL_SDK_ID;
        script.src = $8fec4eb0f62d5de4$var$ONE_SIGNAL_SCRIPT_SRC;
        script.async = true;
        script.onload = ()=>{
            $8fec4eb0f62d5de4$var$handleOnLoad(resolve, options);
        };
        // Always resolve whether or not the script is successfully initialized.
        // This is important for users who may block cdn.onesignal.com w/ adblock.
        script.onerror = ()=>{
            $8fec4eb0f62d5de4$var$handleOnError(resolve);
        };
        document.head.appendChild(script);
    });
function $8fec4eb0f62d5de4$var$on(event, listener) {
    if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
        $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
            name: 'on',
            args: arguments
        });
        return;
    }
    window["OneSignal"].push(()=>{
        window["OneSignal"].on(event, listener);
    });
}
function $8fec4eb0f62d5de4$var$off(event, listener) {
    if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
        $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
            name: 'off',
            args: arguments
        });
        return;
    }
    window["OneSignal"].push(()=>{
        window["OneSignal"].off(event, listener);
    });
}
function $8fec4eb0f62d5de4$var$once(event, listener) {
    if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
        $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
            name: 'once',
            args: arguments
        });
        return;
    }
    window["OneSignal"].push(()=>{
        window["OneSignal"].once(event, listener);
    });
}
function $8fec4eb0f62d5de4$var$isPushNotificationsEnabled(callback) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'isPushNotificationsEnabled',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].isPushNotificationsEnabled(callback).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$showHttpPrompt(options) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'showHttpPrompt',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].showHttpPrompt(options).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$registerForPushNotifications(options) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'registerForPushNotifications',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].registerForPushNotifications(options).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$setDefaultNotificationUrl(url) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'setDefaultNotificationUrl',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].setDefaultNotificationUrl(url).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$setDefaultTitle(title) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'setDefaultTitle',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].setDefaultTitle(title).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$getTags(callback) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'getTags',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].getTags(callback).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$sendTag(key, value, callback) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'sendTag',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].sendTag(key, value, callback).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$sendTags(tags, callback) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'sendTags',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].sendTags(tags, callback).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$deleteTag(tag) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'deleteTag',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].deleteTag(tag).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$deleteTags(tags, callback) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'deleteTags',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].deleteTags(tags, callback).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$addListenerForNotificationOpened(callback) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'addListenerForNotificationOpened',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].addListenerForNotificationOpened(callback).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$setSubscription(newSubscription) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'setSubscription',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].setSubscription(newSubscription).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$showHttpPermissionRequest(options) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'showHttpPermissionRequest',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].showHttpPermissionRequest(options).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$showNativePrompt() {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'showNativePrompt',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].showNativePrompt().then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$showSlidedownPrompt(options) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'showSlidedownPrompt',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].showSlidedownPrompt(options).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$showCategorySlidedown(options) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'showCategorySlidedown',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].showCategorySlidedown(options).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$showSmsSlidedown(options) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'showSmsSlidedown',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].showSmsSlidedown(options).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$showEmailSlidedown(options) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'showEmailSlidedown',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].showEmailSlidedown(options).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$showSmsAndEmailSlidedown(options) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'showSmsAndEmailSlidedown',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].showSmsAndEmailSlidedown(options).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$getNotificationPermission(onComplete) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'getNotificationPermission',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].getNotificationPermission(onComplete).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$getUserId(callback) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'getUserId',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].getUserId(callback).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$getSubscription(callback) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'getSubscription',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].getSubscription(callback).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$setEmail(email, options) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'setEmail',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].setEmail(email, options).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$setSMSNumber(smsNumber, options) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'setSMSNumber',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].setSMSNumber(smsNumber, options).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$logoutEmail() {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'logoutEmail',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].logoutEmail().then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$logoutSMS() {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'logoutSMS',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].logoutSMS().then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$setExternalUserId(externalUserId, authHash) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'setExternalUserId',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].setExternalUserId(externalUserId, authHash).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$removeExternalUserId() {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'removeExternalUserId',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].removeExternalUserId().then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$getExternalUserId() {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'getExternalUserId',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].getExternalUserId().then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$provideUserConsent(consent) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'provideUserConsent',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].provideUserConsent(consent).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$getEmailId(callback) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'getEmailId',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].getEmailId(callback).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$getSMSId(callback) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'getSMSId',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].getSMSId(callback).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $8fec4eb0f62d5de4$var$sendOutcome(outcomeName, outcomeWeight) {
    return new Promise((resolve, reject)=>{
        if ($8fec4eb0f62d5de4$var$isOneSignalScriptFailed) {
            resolve();
            return;
        }
        if (!$8fec4eb0f62d5de4$var$doesOneSignalExist()) {
            $8fec4eb0f62d5de4$var$reactOneSignalFunctionQueue.push({
                name: 'sendOutcome',
                args: arguments,
                promiseResolver: resolve
            });
            return;
        }
        try {
            window["OneSignal"].push(()=>{
                window["OneSignal"].sendOutcome(outcomeName, outcomeWeight).then((value)=>resolve(value)).catch((error)=>reject(error));
            });
        } catch (error) {
            reject(error);
        }
    });
}
const $8fec4eb0f62d5de4$var$OneSignalReact = {
    init: $8fec4eb0f62d5de4$var$init,
    on: $8fec4eb0f62d5de4$var$on,
    off: $8fec4eb0f62d5de4$var$off,
    once: $8fec4eb0f62d5de4$var$once,
    isPushNotificationsEnabled: $8fec4eb0f62d5de4$var$isPushNotificationsEnabled,
    showHttpPrompt: $8fec4eb0f62d5de4$var$showHttpPrompt,
    registerForPushNotifications: $8fec4eb0f62d5de4$var$registerForPushNotifications,
    setDefaultNotificationUrl: $8fec4eb0f62d5de4$var$setDefaultNotificationUrl,
    setDefaultTitle: $8fec4eb0f62d5de4$var$setDefaultTitle,
    getTags: $8fec4eb0f62d5de4$var$getTags,
    sendTag: $8fec4eb0f62d5de4$var$sendTag,
    sendTags: $8fec4eb0f62d5de4$var$sendTags,
    deleteTag: $8fec4eb0f62d5de4$var$deleteTag,
    deleteTags: $8fec4eb0f62d5de4$var$deleteTags,
    addListenerForNotificationOpened: $8fec4eb0f62d5de4$var$addListenerForNotificationOpened,
    setSubscription: $8fec4eb0f62d5de4$var$setSubscription,
    showHttpPermissionRequest: $8fec4eb0f62d5de4$var$showHttpPermissionRequest,
    showNativePrompt: $8fec4eb0f62d5de4$var$showNativePrompt,
    showSlidedownPrompt: $8fec4eb0f62d5de4$var$showSlidedownPrompt,
    showCategorySlidedown: $8fec4eb0f62d5de4$var$showCategorySlidedown,
    showSmsSlidedown: $8fec4eb0f62d5de4$var$showSmsSlidedown,
    showEmailSlidedown: $8fec4eb0f62d5de4$var$showEmailSlidedown,
    showSmsAndEmailSlidedown: $8fec4eb0f62d5de4$var$showSmsAndEmailSlidedown,
    getNotificationPermission: $8fec4eb0f62d5de4$var$getNotificationPermission,
    getUserId: $8fec4eb0f62d5de4$var$getUserId,
    getSubscription: $8fec4eb0f62d5de4$var$getSubscription,
    setEmail: $8fec4eb0f62d5de4$var$setEmail,
    setSMSNumber: $8fec4eb0f62d5de4$var$setSMSNumber,
    logoutEmail: $8fec4eb0f62d5de4$var$logoutEmail,
    logoutSMS: $8fec4eb0f62d5de4$var$logoutSMS,
    setExternalUserId: $8fec4eb0f62d5de4$var$setExternalUserId,
    removeExternalUserId: $8fec4eb0f62d5de4$var$removeExternalUserId,
    getExternalUserId: $8fec4eb0f62d5de4$var$getExternalUserId,
    provideUserConsent: $8fec4eb0f62d5de4$var$provideUserConsent,
    getEmailId: $8fec4eb0f62d5de4$var$getEmailId,
    getSMSId: $8fec4eb0f62d5de4$var$getSMSId,
    sendOutcome: $8fec4eb0f62d5de4$var$sendOutcome
};
var $8fec4eb0f62d5de4$export$2e2bcd8739ae039 = $8fec4eb0f62d5de4$var$OneSignalReact;


var $33d7d2ee27faba8e$export$e0c87ecbc00b9a8c = /*#__PURE__*/ function(ContactArea) {
    ContactArea["USSenate"] = "US Senate";
    ContactArea["USHouse"] = "US House";
    ContactArea["Governor"] = "Governor";
    ContactArea["AttorneysGeneral"] = "AttorneysGeneral";
    ContactArea["SecretaryOfState"] = "SecretaryOfState";
    ContactArea["StateUpper"] = "StateUpper";
    ContactArea["StateLower"] = "StateLower";
    return ContactArea;
}({});
class $33d7d2ee27faba8e$export$909c3b6a9e12845c {
    constructor(){
        this.location = '';
        this.lowAccuracy = false;
        this.state = '';
        this.district = '';
        this.representatives = [];
    }
    senateReps() {
        return this.representatives.filter((contact)=>contact.area === "US Senate");
    }
    // there may be multiple house reps returned here, only return one for now
    houseRep() {
        const contacts = [];
        const houseRep = this.representatives.find((contact)=>contact.area === "US House");
        if (houseRep) contacts.push(houseRep);
        return contacts;
    }
    governor() {
        return this.representatives.filter((contact)=>contact.area === "Governor");
    }
    stateUpper() {
        return this.representatives.filter((contact)=>contact.area === "StateUpper");
    }
    stateLower() {
        return this.representatives.filter((contact)=>contact.area === "StateLower");
    }
    secState() {
        return this.representatives.filter((contact)=>contact.area === "SecretaryOfState");
    }
    attyGeneral() {
        return this.representatives.filter((contact)=>contact.area === "AttorneysGeneral");
    }
    generalizedLocationID() {
        return `${this.state}-${this.district}`;
    }
}



const $173f385a4bb47391$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $173f385a4bb47391$export$2e2bcd8739ae039 = {
    randomUUID: $173f385a4bb47391$var$randomUUID
};


let $a2c929570e8e3b5e$var$getRandomValues;
const $a2c929570e8e3b5e$var$rnds8 = new Uint8Array(16);
function $a2c929570e8e3b5e$export$2e2bcd8739ae039() {
    if (!$a2c929570e8e3b5e$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $a2c929570e8e3b5e$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $a2c929570e8e3b5e$var$getRandomValues($a2c929570e8e3b5e$var$rnds8);
}


var $0a62fc49250e16f3$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $cc67896f0e352e97$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $0a62fc49250e16f3$export$2e2bcd8739ae039).test(uuid);
}
var $cc67896f0e352e97$export$2e2bcd8739ae039 = $cc67896f0e352e97$var$validate;


const $b0a4ca85b1e0ace0$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$b0a4ca85b1e0ace0$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $b0a4ca85b1e0ace0$export$8fb373d660548968(arr, offset = 0) {
    return ($b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 0]] + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 1]] + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 2]] + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 3]] + '-' + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 4]] + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 5]] + '-' + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 6]] + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 7]] + '-' + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 8]] + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 9]] + '-' + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 10]] + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 11]] + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 12]] + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 13]] + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 14]] + $b0a4ca85b1e0ace0$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $b0a4ca85b1e0ace0$var$stringify(arr, offset = 0) {
    const uuid = $b0a4ca85b1e0ace0$export$8fb373d660548968(arr, offset);
    if (!(0, $cc67896f0e352e97$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $b0a4ca85b1e0ace0$export$2e2bcd8739ae039 = $b0a4ca85b1e0ace0$var$stringify;


function $a2ade0d17f89e1c6$var$v4(options, buf, offset) {
    if ((0, $173f385a4bb47391$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $173f385a4bb47391$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $a2c929570e8e3b5e$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $b0a4ca85b1e0ace0$export$8fb373d660548968)(rnds);
}
var $a2ade0d17f89e1c6$export$2e2bcd8739ae039 = $a2ade0d17f89e1c6$var$v4;



const $e90bc56065a3c90c$var$callerID = ()=>{
    const cid = localStorage.getItem((0, $58e79092af177c1d$export$2ec53a4c598cbdd5).CALLER_ID) ?? (0, $a2ade0d17f89e1c6$export$2e2bcd8739ae039)();
    localStorage.setItem((0, $58e79092af177c1d$export$2ec53a4c598cbdd5).CALLER_ID, cid);
    return cid;
};
var $e90bc56065a3c90c$export$2e2bcd8739ae039 = {
    callerID: $e90bc56065a3c90c$var$callerID
};


const $c6a51ca48f202faf$export$7f88f4d244e224ca = Error('no location entered');
const $c6a51ca48f202faf$export$70ff9d70e43e8f10 = async (location, areas = '')=>{
    if (!location || location === '') return Promise.reject($c6a51ca48f202faf$export$7f88f4d244e224ca);
    let areasQuery = '';
    if (areas !== '') areasQuery = `&areas=${encodeURIComponent(areas)},`;
    return (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).get(`${$58e79092af177c1d$export$c0c8be80595ad0a4}?location=${location}${areasQuery}`, {
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        }
    }).then((result)=>{
        const contactList = new (0, $33d7d2ee27faba8e$export$909c3b6a9e12845c)();
        contactList.lowAccuracy = result.data.lowAccuracy;
        contactList.location = result.data.location;
        contactList.representatives = result.data.representatives;
        contactList.state = result.data.state;
        contactList.district = result.data.district;
        if (contactList.generalizedLocationID() !== '-') {
            const districtId = contactList.generalizedLocationID();
            (0, $8fec4eb0f62d5de4$export$2e2bcd8739ae039).sendTag('districtID', districtId);
            localStorage.setItem((0, $58e79092af177c1d$export$2ec53a4c598cbdd5).DISTRICT, districtId);
            // if there's a sub_id in local storage, post it to the server since we've updated the district
            const subId = localStorage.getItem((0, $58e79092af177c1d$export$2ec53a4c598cbdd5).SUBSCRIBER);
            if (subId) $c6a51ca48f202faf$export$873544188ab6667c(subId, districtId);
        }
        return Promise.resolve(contactList);
    }).catch((error)=>{
        // console.error("bad address",error);
        return Promise.reject(error);
    });
};
const $c6a51ca48f202faf$export$ae74c61fbd18f4e6 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).get(`${$58e79092af177c1d$export$7d8de6209b49ac6}`).then((response)=>Promise.resolve(response.data)).catch((e)=>Promise.reject(e));
};
const $c6a51ca48f202faf$export$73d276c9bf905e2e = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).get('https://api.5calls.org/v1/reps/usaSummary').then((response)=>Promise.resolve(response.data)).catch((e)=>Promise.reject(e));
};
const $c6a51ca48f202faf$export$de7b4a26c96c15c6 = (districtId)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).get(`https://api.5calls.org/v1/reps/districtSummary?district=${districtId}`).then((response)=>Promise.resolve(response.data)).catch((e)=>Promise.reject(e));
};
const $c6a51ca48f202faf$export$9848587ec8d73f78 = (group)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).get(`${$58e79092af177c1d$export$7d8de6209b49ac6}?group=${encodeURIComponent(group)}`).then((response)=>Promise.resolve(response.data)).catch((e)=>Promise.reject(e));
};
const $c6a51ca48f202faf$export$3a995e662f5c3b23 = async (data)=>{
    const postData = $f7c1befdafb30ab2$export$fac44ee5b035f737({
        result: data.outcome,
        contactid: data.contactId,
        issueid: data.issueId,
        via: data.via,
        callerid: (0, $e90bc56065a3c90c$export$2e2bcd8739ae039).callerID(),
        ...data.group ? {
            group: data.group
        } : {}
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).post(`${$58e79092af177c1d$export$7d8de6209b49ac6}`, postData, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
};
const $c6a51ca48f202faf$export$4a95b7244775efbe = (email)=>{
    const postData = $f7c1befdafb30ab2$export$fac44ee5b035f737({
        email: email
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).post($58e79092af177c1d$export$b20ac9bd071a81f6, postData);
};
const $c6a51ca48f202faf$export$873544188ab6667c = (sub_id, district)=>{
    const postData = $f7c1befdafb30ab2$export$fac44ee5b035f737({
        subscriber: sub_id,
        district: district,
        cid: (0, $e90bc56065a3c90c$export$2e2bcd8739ae039).callerID()
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).post($58e79092af177c1d$export$73031802601da236, postData, {});
};
const $c6a51ca48f202faf$export$8d44ef4bb75c4dd6 = (gclid)=>{
    $c6a51ca48f202faf$export$a1833bc2b9721531('gclid', window.location.pathname, gclid);
};
const $c6a51ca48f202faf$export$a1833bc2b9721531 = (ref, path, meta)=>{
    const postData = $f7c1befdafb30ab2$export$fac44ee5b035f737({
        ref: ref,
        meta: meta,
        path: path,
        cid: (0, $e90bc56065a3c90c$export$2e2bcd8739ae039).callerID()
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).post($58e79092af177c1d$export$912b2f0197922df, postData, {});
};
const $c6a51ca48f202faf$export$921e5bdaeee2c590 = async (searchTerm)=>{
    try {
        await (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).post($58e79092af177c1d$export$2996a91724e66f2c, {
            query: searchTerm
        });
    } catch (error) {
        // Silently fail - we don't want to disrupt the user experience
        console.debug('Failed to track search term:', error);
    }
};
const $c6a51ca48f202faf$export$f9b588de50666abf = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).get(`${$58e79092af177c1d$export$71ef5cacb3fa1019}`).then((response)=>Promise.resolve(response.data)).catch((e)=>Promise.reject(e));
};
const $c6a51ca48f202faf$export$9781bb1abede0d7e = async (issueId, contactIds, location)=>{
    const params = new URLSearchParams();
    params.append('contact_ids', contactIds.join(','));
    params.append('location', location);
    return (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).get(`${$58e79092af177c1d$export$923ea8233b386e99}/issue/${issueId}/script?${params.toString()}`).then((response)=>Promise.resolve(response.data)).catch((e)=>Promise.reject(e));
};
const $c6a51ca48f202faf$export$d79a4b8fce455323 = async (subscriberId)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).get(`${$58e79092af177c1d$export$923ea8233b386e99}/subscriptions/${subscriberId}`).then((response)=>Promise.resolve(response.data)).catch((e)=>Promise.reject(e));
};
const $c6a51ca48f202faf$export$71d9a332f1450004 = async (subscriberId, preferences)=>{
    // Build the post data as JSON
    const postData = {
        cid: (0, $e90bc56065a3c90c$export$2e2bcd8739ae039).callerID()
    };
    // Add all preference keys as boolean values
    Object.keys(preferences).forEach((key)=>{
        postData[key] = Boolean(preferences[key]);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).post(`${$58e79092af177c1d$export$923ea8233b386e99}/subscriptions/${subscriberId}`, postData, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>Promise.resolve(response.data)).catch((e)=>Promise.reject(e));
};



var $gIfym = parcelRequire("gIfym");
function $8e4f30b640e1a870$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $8e4f30b640e1a870$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $8e4f30b640e1a870$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $8e4f30b640e1a870$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $8e4f30b640e1a870$export$2e2bcd8739ae039 = $8e4f30b640e1a870$export$4f5d2d50c9deca37;


"use client";
function $bfb33a28c1c2ef06$var$Mt(t) {
    if (!t || typeof document == "undefined") return;
    let o = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style");
    e.type = "text/css", o.firstChild ? o.insertBefore(e, o.firstChild) : o.appendChild(e), e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
$bfb33a28c1c2ef06$var$Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var $bfb33a28c1c2ef06$var$L = (t)=>typeof t == "number" && !isNaN(t), $bfb33a28c1c2ef06$var$N = (t)=>typeof t == "string", $bfb33a28c1c2ef06$var$P = (t)=>typeof t == "function", $bfb33a28c1c2ef06$var$mt = (t)=>$bfb33a28c1c2ef06$var$N(t) || $bfb33a28c1c2ef06$var$L(t), $bfb33a28c1c2ef06$var$B = (t)=>$bfb33a28c1c2ef06$var$N(t) || $bfb33a28c1c2ef06$var$P(t) ? t : null, $bfb33a28c1c2ef06$var$pt = (t, o)=>t === !1 || $bfb33a28c1c2ef06$var$L(t) && t > 0 ? t : o, $bfb33a28c1c2ef06$var$z = (t)=>(0, $gIfym.isValidElement)(t) || $bfb33a28c1c2ef06$var$N(t) || $bfb33a28c1c2ef06$var$P(t) || $bfb33a28c1c2ef06$var$L(t);
function $bfb33a28c1c2ef06$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = r + "px", s.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(o, e);
        });
    });
}
function $bfb33a28c1c2ef06$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: s = 300 }) {
    return function({ children: a, position: d, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${d}` : t, S = e ? `${o}--${d}` : o, E = (0, $gIfym.useRef)(0);
        return (0, $gIfym.useLayoutEffect)(()=>{
            let f = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), f.removeEventListener("animationend", b), f.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && f.classList.remove(...p));
            };
            (()=>{
                f.classList.add(...p), f.addEventListener("animationend", b), f.addEventListener("animationcancel", b);
            })();
        }, []), (0, $gIfym.useEffect)(()=>{
            let f = g.current, p = ()=>{
                f.removeEventListener("animationend", p), r ? $bfb33a28c1c2ef06$export$184cca501f1aed7f(f, T, s) : T();
            };
            v || (c ? p() : (()=>{
                E.current = 1, f.className += ` ${S}`, f.addEventListener("animationend", p);
            })());
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Fragment, null, a);
    };
}
function $bfb33a28c1c2ef06$var$J(t, o) {
    return {
        content: $bfb33a28c1c2ef06$var$tt(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $bfb33a28c1c2ef06$var$tt(t, o, e = !1) {
    return (0, $gIfym.isValidElement)(t) && !$bfb33a28c1c2ef06$var$N(t.type) ? (0, $gIfym.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $bfb33a28c1c2ef06$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $bfb33a28c1c2ef06$var$yt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $bfb33a28c1c2ef06$var$gt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: s, className: l, controlledProgress: a, progress: d, rtl: c, isIn: T, theme: g }) {
    let v = s || a && d === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    a && (x.transform = `scaleX(${d})`);
    let C = (0, $8e4f30b640e1a870$export$2e2bcd8739ae039)("Toastify__progress-bar", a ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $bfb33a28c1c2ef06$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $8e4f30b640e1a870$export$2e2bcd8739ae039)(C, l), E = {
        [a && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: a && d < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        className: S,
        style: x,
        ...E
    }));
}
var $bfb33a28c1c2ef06$var$Xt = 1, $bfb33a28c1c2ef06$var$at = ()=>`${$bfb33a28c1c2ef06$var$Xt++}`;
function $bfb33a28c1c2ef06$var$_t(t, o, e) {
    let r = 1, s = 0, l = [], a = [], d = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        a = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        (u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1;
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, f = ()=>{
        s -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($bfb33a28c1c2ef06$var$J(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: d,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: f,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, M = h == null;
            M && s++;
            let A = {
                ...d,
                style: d.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([D, Y])=>Y != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $bfb33a28c1c2ef06$var$B(n.className || d.toastClassName),
                progressClassName: $bfb33a28c1c2ef06$var$B(n.progressClassName || d.progressClassName),
                autoClose: n.isLoading ? !1 : $bfb33a28c1c2ef06$var$pt(n.autoClose, d.autoClose),
                closeToast (D) {
                    c.get(u).removalReason = D, E(u);
                },
                deleteToast () {
                    let D = c.get(u);
                    if (D != null) {
                        if (e($bfb33a28c1c2ef06$var$J(D, "removed")), c.delete(u), s--, s < 0 && (s = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = d.closeButton, n.closeButton === !1 || $bfb33a28c1c2ef06$var$z(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $bfb33a28c1c2ef06$var$z(d.closeButton) ? d.closeButton : !0);
            let R = {
                content: i,
                props: A,
                staleId: _
            };
            d.limit && d.limit > 0 && s > d.limit && M ? l.push(R) : $bfb33a28c1c2ef06$var$L(k) ? setTimeout(()=>{
                p(R);
            }, k) : p(R);
        },
        setProps (i) {
            d = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>a
    };
}
var $bfb33a28c1c2ef06$var$I = new Map, $bfb33a28c1c2ef06$var$F = [], $bfb33a28c1c2ef06$var$st = new Set, $bfb33a28c1c2ef06$var$Vt = (t)=>$bfb33a28c1c2ef06$var$st.forEach((o)=>o(t)), $bfb33a28c1c2ef06$var$bt = ()=>$bfb33a28c1c2ef06$var$I.size > 0;
function $bfb33a28c1c2ef06$var$Qt() {
    $bfb33a28c1c2ef06$var$F.forEach((t)=>$bfb33a28c1c2ef06$var$nt(t.content, t.options)), $bfb33a28c1c2ef06$var$F = [];
}
var $bfb33a28c1c2ef06$var$vt = (t, { containerId: o })=>{
    var e;
    return (e = $bfb33a28c1c2ef06$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $bfb33a28c1c2ef06$var$X(t, o) {
    var r;
    if (o) return !!((r = $bfb33a28c1c2ef06$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $bfb33a28c1c2ef06$var$I.forEach((s)=>{
        s.isToastActive(t) && (e = !0);
    }), e;
}
function $bfb33a28c1c2ef06$var$ht(t) {
    if (!$bfb33a28c1c2ef06$var$bt()) {
        $bfb33a28c1c2ef06$var$F = $bfb33a28c1c2ef06$var$F.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $bfb33a28c1c2ef06$var$mt(t)) $bfb33a28c1c2ef06$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $bfb33a28c1c2ef06$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $bfb33a28c1c2ef06$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $bfb33a28c1c2ef06$var$Ct = (t = {})=>{
    $bfb33a28c1c2ef06$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $bfb33a28c1c2ef06$var$nt(t, o) {
    $bfb33a28c1c2ef06$var$z(t) && ($bfb33a28c1c2ef06$var$bt() || $bfb33a28c1c2ef06$var$F.push({
        content: t,
        options: o
    }), $bfb33a28c1c2ef06$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $bfb33a28c1c2ef06$var$xt(t) {
    var o;
    (o = $bfb33a28c1c2ef06$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $bfb33a28c1c2ef06$var$rt(t, o) {
    $bfb33a28c1c2ef06$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $bfb33a28c1c2ef06$var$Et(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $bfb33a28c1c2ef06$var$_t(o, t, $bfb33a28c1c2ef06$var$Vt);
            $bfb33a28c1c2ef06$var$I.set(o, r);
            let s = r.observe(e);
            return $bfb33a28c1c2ef06$var$Qt(), ()=>{
                s(), $bfb33a28c1c2ef06$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $bfb33a28c1c2ef06$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $bfb33a28c1c2ef06$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $bfb33a28c1c2ef06$var$Pt(t) {
    return $bfb33a28c1c2ef06$var$st.add(t), ()=>{
        $bfb33a28c1c2ef06$var$st.delete(t);
    };
}
function $bfb33a28c1c2ef06$var$Wt(t) {
    return t && ($bfb33a28c1c2ef06$var$N(t.toastId) || $bfb33a28c1c2ef06$var$L(t.toastId)) ? t.toastId : $bfb33a28c1c2ef06$var$at();
}
function $bfb33a28c1c2ef06$var$U(t, o) {
    return $bfb33a28c1c2ef06$var$nt(t, o), o.toastId;
}
function $bfb33a28c1c2ef06$var$V(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $bfb33a28c1c2ef06$var$Wt(o)
    };
}
function $bfb33a28c1c2ef06$var$Q(t) {
    return (o, e)=>$bfb33a28c1c2ef06$var$U(o, $bfb33a28c1c2ef06$var$V(t, e));
}
function $bfb33a28c1c2ef06$export$b410431fab84fa58(t, o) {
    return $bfb33a28c1c2ef06$var$U(t, $bfb33a28c1c2ef06$var$V("default", o));
}
$bfb33a28c1c2ef06$export$b410431fab84fa58.loading = (t, o)=>$bfb33a28c1c2ef06$var$U(t, $bfb33a28c1c2ef06$var$V("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $bfb33a28c1c2ef06$var$Gt(t, { pending: o, error: e, success: r }, s) {
    let l;
    o && (l = $bfb33a28c1c2ef06$var$N(o) ? $bfb33a28c1c2ef06$export$b410431fab84fa58.loading(o, s) : $bfb33a28c1c2ef06$export$b410431fab84fa58.loading(o.render, {
        ...s,
        ...o
    }));
    let a = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, d = (T, g, v)=>{
        if (g == null) {
            $bfb33a28c1c2ef06$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...a,
            ...s,
            data: v
        }, C = $bfb33a28c1c2ef06$var$N(g) ? {
            render: g
        } : g;
        return l ? $bfb33a28c1c2ef06$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $bfb33a28c1c2ef06$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $bfb33a28c1c2ef06$var$P(t) ? t() : t;
    return c.then((T)=>d("success", r, T)).catch((T)=>d("error", e, T)), c;
}
$bfb33a28c1c2ef06$export$b410431fab84fa58.promise = $bfb33a28c1c2ef06$var$Gt;
$bfb33a28c1c2ef06$export$b410431fab84fa58.success = $bfb33a28c1c2ef06$var$Q("success");
$bfb33a28c1c2ef06$export$b410431fab84fa58.info = $bfb33a28c1c2ef06$var$Q("info");
$bfb33a28c1c2ef06$export$b410431fab84fa58.error = $bfb33a28c1c2ef06$var$Q("error");
$bfb33a28c1c2ef06$export$b410431fab84fa58.warning = $bfb33a28c1c2ef06$var$Q("warning");
$bfb33a28c1c2ef06$export$b410431fab84fa58.warn = $bfb33a28c1c2ef06$export$b410431fab84fa58.warning;
$bfb33a28c1c2ef06$export$b410431fab84fa58.dark = (t, o)=>$bfb33a28c1c2ef06$var$U(t, $bfb33a28c1c2ef06$var$V("default", {
        theme: "dark",
        ...o
    }));
function $bfb33a28c1c2ef06$var$qt(t) {
    $bfb33a28c1c2ef06$var$ht(t);
}
$bfb33a28c1c2ef06$export$b410431fab84fa58.dismiss = $bfb33a28c1c2ef06$var$qt;
$bfb33a28c1c2ef06$export$b410431fab84fa58.clearWaitingQueue = $bfb33a28c1c2ef06$var$Ct;
$bfb33a28c1c2ef06$export$b410431fab84fa58.isActive = $bfb33a28c1c2ef06$var$X;
$bfb33a28c1c2ef06$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $bfb33a28c1c2ef06$var$vt(t, o);
    if (e) {
        let { props: r, content: s } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $bfb33a28c1c2ef06$var$at()
        };
        l.toastId !== t && (l.staleId = t);
        let a = l.render || s;
        delete l.render, $bfb33a28c1c2ef06$var$U(a, l);
    }
};
$bfb33a28c1c2ef06$export$b410431fab84fa58.done = (t)=>{
    $bfb33a28c1c2ef06$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$bfb33a28c1c2ef06$export$b410431fab84fa58.onChange = $bfb33a28c1c2ef06$var$Pt;
$bfb33a28c1c2ef06$export$b410431fab84fa58.play = (t)=>$bfb33a28c1c2ef06$var$rt(!0, t);
$bfb33a28c1c2ef06$export$b410431fab84fa58.pause = (t)=>$bfb33a28c1c2ef06$var$rt(!1, t);
function $bfb33a28c1c2ef06$var$It(t) {
    var a;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $gIfym.useRef)($bfb33a28c1c2ef06$var$Et(t)).current;
    r(t);
    let s = (a = (0, $gIfym.useSyncExternalStore)(o, e, e)) == null ? void 0 : a.slice();
    function l(d) {
        if (!s) return [];
        let c = new Map;
        return t.newestOnTop && s.reverse(), s.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>d(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $bfb33a28c1c2ef06$var$X,
        count: s == null ? void 0 : s.length
    };
}
function $bfb33a28c1c2ef06$var$At(t) {
    let [o, e] = (0, $gIfym.useState)(!1), [r, s] = (0, $gIfym.useState)(!1), l = (0, $gIfym.useRef)(null), a = (0, $gIfym.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $bfb33a28c1c2ef06$var$xt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $gIfym.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", f), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", f), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            a.canCloseOnClick = !0, a.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (a.start = m.clientX, a.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (a.start = m.clientY, a.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: M, right: A } = l.current.getBoundingClientRect();
        m.nativeEvent.type !== "touchend" && t.pauseOnHover && m.clientX >= M && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : f();
    }
    function f() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        a.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (a.canDrag && _) {
            a.didMove = !0, o && p(), t.draggableDirection === "x" ? a.delta = m.clientX - a.start : a.delta = m.clientY - a.start, a.start !== m.clientX && (a.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${a.delta}px, var(--y)` : `0, calc(${a.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(a.delta / a.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (a.canDrag && a.didMove && m) {
            if (a.canDrag = !1, Math.abs(a.delta) > a.removalDistance) {
                s(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return d && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = f)), v && (h.onClick = (m)=>{
        g && g(m), a.canCloseOnClick && T(!0);
    }), {
        playToast: f,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $bfb33a28c1c2ef06$var$Ot = typeof window != "undefined" ? (0, $gIfym.useLayoutEffect) : (0, $gIfym.useEffect);
var $bfb33a28c1c2ef06$var$G = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $bfb33a28c1c2ef06$var$ao(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($bfb33a28c1c2ef06$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $bfb33a28c1c2ef06$var$so(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($bfb33a28c1c2ef06$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $bfb33a28c1c2ef06$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($bfb33a28c1c2ef06$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $bfb33a28c1c2ef06$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($bfb33a28c1c2ef06$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $bfb33a28c1c2ef06$var$io() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $bfb33a28c1c2ef06$export$4f13f83fd8bb1dac = {
    info: $bfb33a28c1c2ef06$var$so,
    warning: $bfb33a28c1c2ef06$var$ao,
    success: $bfb33a28c1c2ef06$var$no,
    error: $bfb33a28c1c2ef06$var$ro,
    spinner: $bfb33a28c1c2ef06$var$io
}, $bfb33a28c1c2ef06$var$lo = (t)=>t in $bfb33a28c1c2ef06$export$4f13f83fd8bb1dac;
function $bfb33a28c1c2ef06$var$Nt({ theme: t, type: o, isLoading: e, icon: r }) {
    let s = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($bfb33a28c1c2ef06$var$P(r) ? s = r({
        ...l,
        isLoading: e
    }) : (0, $gIfym.isValidElement)(r) ? s = (0, $gIfym.cloneElement)(r, l) : e ? s = $bfb33a28c1c2ef06$export$4f13f83fd8bb1dac.spinner() : $bfb33a28c1c2ef06$var$lo(o) && (s = $bfb33a28c1c2ef06$export$4f13f83fd8bb1dac[o](l))), s;
}
var $bfb33a28c1c2ef06$var$wt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: s, playToast: l } = $bfb33a28c1c2ef06$var$At(t), { closeButton: a, children: d, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: f, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: M, theme: A, ariaLabel: R } = t, D = (0, $8e4f30b640e1a870$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: M
    }), Y = $bfb33a28c1c2ef06$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: D
    }) : (0, $8e4f30b640e1a870$export$2e2bcd8739ae039)(D, E), ft = $bfb33a28c1c2ef06$var$Nt(t), dt = !!n || !c, j = {
        closeToast: x,
        type: g,
        theme: A
    }, H = null;
    return a === !1 || ($bfb33a28c1c2ef06$var$P(a) ? H = a(j) : (0, $gIfym.isValidElement)(a) ? H = (0, $gIfym.cloneElement)(a, j) : H = $bfb33a28c1c2ef06$var$yt(j)), (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: Y,
        ...s,
        style: f,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": R
        }
    }, ft != null && (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: (0, $8e4f30b640e1a870$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, ft), $bfb33a28c1c2ef06$var$tt(d, t, !o), H, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($bfb33a28c1c2ef06$var$gt, {
        ...b && !dt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: dt,
        progress: n || 0
    })));
};
var $bfb33a28c1c2ef06$var$K = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $bfb33a28c1c2ef06$export$d20e79fdc3899e95 = $bfb33a28c1c2ef06$export$3ff7dc44d332d222($bfb33a28c1c2ef06$var$K("bounce", !0)), $bfb33a28c1c2ef06$export$d8dc01b5c85a37b9 = $bfb33a28c1c2ef06$export$3ff7dc44d332d222($bfb33a28c1c2ef06$var$K("slide", !0)), $bfb33a28c1c2ef06$export$65cfd44a2050f99 = $bfb33a28c1c2ef06$export$3ff7dc44d332d222($bfb33a28c1c2ef06$var$K("zoom")), $bfb33a28c1c2ef06$export$4d2fae537bd90431 = $bfb33a28c1c2ef06$export$3ff7dc44d332d222($bfb33a28c1c2ef06$var$K("flip"));
var $bfb33a28c1c2ef06$var$_o = {
    position: "top-right",
    transition: $bfb33a28c1c2ef06$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $bfb33a28c1c2ef06$export$f2815235e76a62b9(t) {
    let o = {
        ...$bfb33a28c1c2ef06$var$_o,
        ...t
    }, e = t.stacked, [r, s] = (0, $gIfym.useState)(!0), l = (0, $gIfym.useRef)(null), { getToastToRender: a, isToastActive: d, count: c } = $bfb33a28c1c2ef06$var$It(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(f) {
        let p = (0, $8e4f30b640e1a870$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${f}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $bfb33a28c1c2ef06$var$P(T) ? T({
            position: f,
            rtl: v,
            defaultClassName: p
        }) : (0, $8e4f30b640e1a870$export$2e2bcd8739ae039)(p, $bfb33a28c1c2ef06$var$B(T));
    }
    function E() {
        e && (s(!0), $bfb33a28c1c2ef06$export$b410431fab84fa58.play());
    }
    return $bfb33a28c1c2ef06$var$Ot(()=>{
        var f;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (f = o.position) == null ? void 0 : f.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m);
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${1 - (r ? u : 0)}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $gIfym.useEffect)(()=>{
        function f(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b.querySelector('[tabIndex="0"]')) == null || i.focus(), s(!1), $bfb33a28c1c2ef06$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (s(!0), $bfb33a28c1c2ef06$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", f), ()=>{
            document.removeEventListener("keydown", f);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (s(!1), $bfb33a28c1c2ef06$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, a((f, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            tabIndex: -1,
            className: S(f),
            "data-stacked": e,
            style: b,
            key: `c-${f}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($bfb33a28c1c2ef06$var$wt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: d(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}



var $9c71a30a7953d981$var$ComponentLocationState = /*#__PURE__*/ function(ComponentLocationState) {
    ComponentLocationState[ComponentLocationState["NoLocation"] = 0] = "NoLocation";
    ComponentLocationState[ComponentLocationState["BadLocation"] = 1] = "BadLocation";
    ComponentLocationState[ComponentLocationState["HasLocation"] = 2] = "HasLocation";
    ComponentLocationState[ComponentLocationState["GettingAutomatically"] = 3] = "GettingAutomatically";
    ComponentLocationState[ComponentLocationState["EnterManually"] = 4] = "EnterManually";
    return ComponentLocationState;
}($9c71a30a7953d981$var$ComponentLocationState || {});
const $9c71a30a7953d981$var$ERROR_MESSAGE = /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
    children: [
        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            children: "We weren\u2019t able to find that location!"
        }),
        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            children: " Please try again with a different address."
        })
    ]
});
const $9c71a30a7953d981$var$Location = (props)=>{
    const [componentLocationState, setComponentLocationState] = (0, $gIfym.useState)(0);
    const [manualAddress, setManualAddress] = (0, $gIfym.useState)(undefined);
    const [hasGeolocationFailed, setHasGeolocationFailed] = (0, $gIfym.useState)(false);
    (0, $gIfym.useEffect)(()=>{
        if (props.locationState && props.locationState.address) setComponentLocationState(2);
        updateIssueCompletion();
    }, []);
    (0, $gIfym.useEffect)(()=>{
        updateIssueCompletion();
    }, [
        props.completedIssueMap
    ]);
    // Listen for search results rendered event to update completion status
    (0, $gIfym.useEffect)(()=>{
        const handleSearchResultsRendered = ()=>{
            updateIssueCompletion();
        };
        document.addEventListener($58e79092af177c1d$export$7ff69bf5c61582bf.SEARCH_RESULTS_RENDERED, handleSearchResultsRendered);
        return ()=>{
            document.removeEventListener($58e79092af177c1d$export$7ff69bf5c61582bf.SEARCH_RESULTS_RENDERED, handleSearchResultsRendered);
        };
    }, [
        props.completedIssueMap
    ]);
    const updateIssueCompletion = ()=>{
        const completedIssueIds = Object.keys(props.completedIssueMap || {});
        if (completedIssueIds.length === 0) return;
        // Process both static issue list and search results
        const selectors = [
            '.i-bar-list-section .i-bar-item-check>div',
            '.i-bar-search-results .i-bar-item-check>div'
        ];
        selectors.forEach((selector)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($9c8166cf7946f78b$exports)))(selector).each((_, el)=>{
                const itemIssueID = (0, (/*@__PURE__*/$parcel$interopDefault($9c8166cf7946f78b$exports)))(el).data('issue-id');
                if (itemIssueID && completedIssueIds.indexOf(`${itemIssueID}`) !== -1) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($9c8166cf7946f78b$exports)))(el).attr('class', 'i-bar-check-initial');
                    (0, (/*@__PURE__*/$parcel$interopDefault($9c8166cf7946f78b$exports)))(el).find('i').first().attr('class', 'fa fa-check');
                }
            });
        });
    };
    const handleManualAddressChange = (e)=>{
        setManualAddress(e.target.value);
    };
    const changeLocation = (e)=>{
        e.preventDefault();
        setComponentLocationState(4);
    };
    const setLocationManually = (e)=>{
        e.preventDefault();
        if (!manualAddress || manualAddress === '') return;
        // close any possibly open toasts to prevent user confusion
        (0, $bfb33a28c1c2ef06$export$b410431fab84fa58).dismiss();
        (0, $c6a51ca48f202faf$export$70ff9d70e43e8f10)(manualAddress).then((contactList)=>{
            props.setLocationAddress(manualAddress ?? '', contactList.location, contactList.state);
            setComponentLocationState(2);
            document.dispatchEvent(new Event($58e79092af177c1d$export$7ff69bf5c61582bf.UPDATE_REPS));
        }).catch((error)=>{
            console.error(error);
            (0, $bfb33a28c1c2ef06$export$b410431fab84fa58).error($9c71a30a7953d981$var$ERROR_MESSAGE);
            setComponentLocationState(0);
        });
    };
    const setLocationAutomatically = (e)=>{
        e.preventDefault();
        // if we've previously had geolocation fail, go to manually set location
        if (hasGeolocationFailed) {
            setComponentLocationState(4);
            return;
        }
        setComponentLocationState(3);
        // close any possibly open toasts to prevent user confusion
        (0, $bfb33a28c1c2ef06$export$b410431fab84fa58).dismiss();
        (0, $0dfcc6ce5e98ece8$export$a62dbeab5425a473)().then((loc)=>{
            const pairedLoc = `${loc.latitude},${loc.longitude}`;
            (0, $c6a51ca48f202faf$export$70ff9d70e43e8f10)(pairedLoc).then((contactList)=>{
                props.setLocationAddress(pairedLoc, contactList.location, contactList.state);
                setComponentLocationState(2);
                document.dispatchEvent(new Event($58e79092af177c1d$export$7ff69bf5c61582bf.UPDATE_REPS));
            }).catch((error)=>{
                console.log('error getting location after geoloc:', error);
                (0, $bfb33a28c1c2ef06$export$b410431fab84fa58).error($9c71a30a7953d981$var$ERROR_MESSAGE);
                setHasGeolocationFailed(true);
                setComponentLocationState(0);
            });
        }).catch(()=>{
            // this is failure of geolocation permission
            setComponentLocationState(4);
        });
    };
    switch(componentLocationState){
        case 0:
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                        children: "Find your legislators"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("form", {
                        onSubmit: setLocationAutomatically,
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                            className: "button button-small button-red",
                            children: "Set your location"
                        })
                    })
                ]
            });
        case 3:
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("span", {
                        className: "i-bar-loading",
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("i", {
                                className: "fa fa-map-marker"
                            }),
                            ' ',
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("b", {
                                children: "Getting your location automatically\u2026"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("form", {
                        onSubmit: changeLocation,
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                            className: "button-link",
                            children: "Or enter an address manually"
                        })
                    })
                ]
            });
        case 2:
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                        children: "Your location is"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("strong", {
                        children: props.locationState?.cachedCity || props.locationState?.address
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("form", {
                        onSubmit: changeLocation,
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                            className: "button-link",
                            children: "Change location"
                        })
                    })
                ]
            });
        case 4:
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                        children: "Enter an address or ZIP code"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("form", {
                        onSubmit: setLocationManually,
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                                name: "address",
                                type: "text",
                                placeholder: "20500 or 1600 Pennsylvania Ave, Washington, DC",
                                onChange: handleManualAddressChange
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                                className: "button button-small button-red",
                                children: "Go"
                            })
                        ]
                    })
                ]
            });
        case 1:
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                    children: "no reps for that location"
                })
            });
        default:
            return null;
    }
};
var $9c71a30a7953d981$export$2e2bcd8739ae039 = (0, $b410c744327f470f$export$1688adba58f7c3f1)((0, $b410c744327f470f$export$71260fd0c34a821)((props)=>{
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)($9c71a30a7953d981$var$Location, {
            ...props
        })
    });
}));




var $gIfym = parcelRequire("gIfym");





parcelRequire("gIfym");
const $7492649c23e6fda3$var$partyAndState = (contact)=>{
    if (contact.party && contact.state !== '') {
        const partyLetter = contact.party.substring(0, 1);
        return partyLetter.toUpperCase() + '-' + contact.state.toUpperCase();
    } else if (contact.state !== '') return contact.state.toUpperCase();
    return '';
};
const $7492649c23e6fda3$var$allContacts = (contactList)=>{
    const contacts = [];
    // sometimes we pass back multiple house reps, the first is most likely
    const houseReps = contactList.houseRep();
    if (houseReps.length > 0) contacts.push(houseReps[0]);
    contacts.push(...contactList.senateReps());
    contacts.push(...contactList.stateLower());
    contacts.push(...contactList.stateUpper());
    contacts.push(...contactList.governor());
    contacts.push(...contactList.secState());
    contacts.push(...contactList.attyGeneral());
    return contacts;
};
const $7492649c23e6fda3$var$makePhoneLink = (phoneNumber)=>{
    if (phoneNumber) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("a", {
        href: `tel:${phoneNumber.replace(/-| /g, '')}`,
        children: phoneNumber.replace(/^\+1 /, '')
    });
    else return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {});
};
const $7492649c23e6fda3$var$cityFormat = (office, contact)=>{
    if (office.city) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
        children: ` - ${office.city}, ${contact.state}`
    });
    else return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {});
};
var $7492649c23e6fda3$export$2e2bcd8739ae039 = {
    partyAndState: $7492649c23e6fda3$var$partyAndState,
    allContacts: $7492649c23e6fda3$var$allContacts,
    makePhoneLink: $7492649c23e6fda3$var$makePhoneLink,
    cityFormat: $7492649c23e6fda3$var$cityFormat
};



var $gIfym = parcelRequire("gIfym");

function $298b7c465de541c3$export$9115b42802a3e44f() {
    const [callingGroup, setCallingGroup] = (0, $gIfym.useState)('');
    const [isSaved, setIsSaved] = (0, $gIfym.useState)(true);
    (0, $gIfym.useEffect)(()=>{
        const stored = localStorage.getItem((0, $58e79092af177c1d$export$2ec53a4c598cbdd5).SETTINGS);
        if (stored) {
            const settings = JSON.parse(stored);
            setCallingGroup(settings.callingGroup);
        }
    }, []);
    (0, $gIfym.useEffect)(()=>{
        setIsSaved(false);
    }, [
        callingGroup
    ]);
    const saveSettings = ()=>{
        const settings = {
            callingGroup: callingGroup
        };
        localStorage.setItem((0, $58e79092af177c1d$export$2ec53a4c598cbdd5).SETTINGS, JSON.stringify(settings));
        setIsSaved(true);
    };
    return {
        callingGroup: callingGroup,
        setCallingGroup: setCallingGroup,
        saveSettings: saveSettings,
        isSaved: isSaved
    };
}




var $gIfym = parcelRequire("gIfym");



var $gIfym = parcelRequire("gIfym");

class $547848599648e82a$export$fb24aeeb5784e094 extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    render() {
        if (this.props.contact.field_offices == null || this.props.contact.field_offices.length === 0) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {});
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: "contact-local-numbers",
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h3", {
                    children: "Local office numbers:"
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("ul", {
                    children: this.props.contact.field_offices ? this.props.contact.field_offices.map((office, index)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("li", {
                            children: [
                                (0, $7492649c23e6fda3$export$2e2bcd8739ae039).makePhoneLink(office.phone),
                                (0, $7492649c23e6fda3$export$2e2bcd8739ae039).cityFormat(office, this.props.contact)
                            ]
                        }, `${this.props.contact.id}-${office.phone}-${index}`)) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {})
                })
            ]
        });
    }
}
var $547848599648e82a$export$2e2bcd8739ae039 = $547848599648e82a$export$fb24aeeb5784e094;


class $333279c6ff421f64$var$ActiveContact extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    render() {
        let photoURL = '/images/no-rep.png';
        if (this.props.contact.photoURL && this.props.contact.photoURL !== '') photoURL = this.props.contact.photoURL;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: "contact",
            id: "rep-contact",
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "contact-image",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                        alt: this.props.contact.name,
                        src: photoURL,
                        onError: (e)=>{
                            e.currentTarget.src = '/images/no-rep.png';
                        }
                    })
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("h3", {
                            className: "contact-name",
                            children: [
                                this.props.contact.name,
                                " (",
                                (0, $7492649c23e6fda3$export$2e2bcd8739ae039).partyAndState(this.props.contact),
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                            className: "contact-phone",
                            children: (0, $7492649c23e6fda3$export$2e2bcd8739ae039).makePhoneLink(this.props.contact.phone)
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $547848599648e82a$export$2e2bcd8739ae039), {
                            contact: this.props.contact
                        })
                    ]
                })
            ]
        });
    }
}
var $333279c6ff421f64$export$2e2bcd8739ae039 = $333279c6ff421f64$var$ActiveContact;


const $abe909a3f4f45831$var$stateAbbreviationToName = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
    DC: 'District of Columbia',
    PR: 'Puerto Rico',
    VI: 'Virgin Islands',
    AS: 'American Samoa',
    GU: 'Guam',
    MP: 'Northern Mariana Islands'
};
const $abe909a3f4f45831$export$772c9c620e7f9ca7 = (abbreviation)=>{
    return $abe909a3f4f45831$var$stateAbbreviationToName[abbreviation.toUpperCase()] || abbreviation;
};
var $abe909a3f4f45831$export$2e2bcd8739ae039 = $abe909a3f4f45831$export$772c9c620e7f9ca7;



const $cd098264dbb86b3b$var$TOAST_SETTINGS = {
    autoClose: 2500,
    position: 'bottom-center'
};
const $cd098264dbb86b3b$var$TOAST_DELAY = 750;
const $cd098264dbb86b3b$var$createAndSendToast = ({ outcome: outcome, currentContact: currentContact, nextContact: nextContact })=>{
    let outcomeMessage = '';
    if (outcome === 'contact') outcomeMessage = `Contacted ${currentContact?.name}!`;
    else if (outcome === 'voicemail') outcomeMessage = `Left a voicemail for ${currentContact?.name}!`;
    else if (outcome === 'skip') outcomeMessage = `Skipped ${currentContact?.name}.`;
    else if (outcome === 'unavailable') outcomeMessage = `${currentContact?.name} was unavailable.`;
    const finalMessage = /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        style: {
            marginLeft: '.5rem'
        },
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                children: outcomeMessage
            }),
            nextContact?.name && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                style: {
                    marginTop: '.2rem'
                },
                children: [
                    "Next up: call ",
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("b", {
                        children: nextContact?.name
                    }),
                    "."
                ]
            })
        ]
    });
    if (outcome === 'contact' || outcome === 'voicemail') (0, $bfb33a28c1c2ef06$export$b410431fab84fa58).success(finalMessage, $cd098264dbb86b3b$var$TOAST_SETTINGS);
    else (0, $bfb33a28c1c2ef06$export$b410431fab84fa58).info(finalMessage, $cd098264dbb86b3b$var$TOAST_SETTINGS);
};
const $cd098264dbb86b3b$var$RepsWithSettings = (props)=>{
    const { callingGroup: callingGroup } = (0, $298b7c465de541c3$export$9115b42802a3e44f)();
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)($cd098264dbb86b3b$var$Reps, {
        ...props,
        callingGroup: callingGroup
    });
};
class $cd098264dbb86b3b$var$Reps extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    componentDidMount() {
        let areaString = '';
        let requiredState = '';
        const thisComponent = this.componentRef.current;
        if (thisComponent && thisComponent.parentElement) {
            areaString = thisComponent.parentElement.dataset.repAreas ?? '';
            requiredState = thisComponent.parentElement.dataset.requiredState ?? '';
            const areas = areaString.split(',');
            const issueId = thisComponent.parentElement.dataset.issueId ?? '';
            this.setState({
                areas: areas,
                issueId: issueId,
                requiredState: requiredState
            });
        }
        if (!this.state.contactList) // if we don't have contacts, fetch the contacts
        this.updateContacts(areaString.split(','));
        document.addEventListener($58e79092af177c1d$export$7ff69bf5c61582bf.NEXT_CONTACT, (e)=>{
            const outcome = e.detail;
            const contacts = this.contactsForArea(this.state.areas, this.state.contactList ?? {});
            let currentContact;
            if (contacts.length >= this.state.activeContactIndex) currentContact = contacts[this.state.activeContactIndex];
            if (outcome !== 'skip') {
                const viaParameter = window.location.host === '5calls.org' ? 'web' : 'test';
                gtag('event', 'conversion', {
                    send_to: 'AW-16875388196/mI3GCNKZurMaEKT65-4-'
                });
                const outcomeData = {
                    outcome: outcome,
                    issueId: this.state.issueId,
                    contactId: currentContact?.id ?? 'no-contact-id',
                    via: viaParameter,
                    group: this.props.callingGroup
                };
                (0, $c6a51ca48f202faf$export$3a995e662f5c3b23)(outcomeData);
            }
            const isFinished = this.state.activeContactIndex >= contacts.length - 1;
            if (!isFinished) {
                const activeContactIndex = this.state.activeContactIndex + 1;
                this.setState({
                    activeContactIndex: activeContactIndex
                });
                this.reportUpdatedActiveContact(contacts[activeContactIndex]);
                document.getElementById('rep-contact')?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'start'
                });
                setTimeout(()=>{
                    $cd098264dbb86b3b$var$createAndSendToast({
                        outcome: outcome,
                        currentContact: currentContact,
                        nextContact: contacts[activeContactIndex]
                    });
                }, $cd098264dbb86b3b$var$TOAST_DELAY);
            } else {
                this.props.setCompletedIssueMap({
                    [this.state.issueId]: Date.now()
                });
                // if we load the next page too soon, the previous outcome is sometimes skipped
                // 300ms is something arbitrary I picked
                setTimeout(()=>{
                    window.location.pathname = window.location.pathname + '/done/';
                }, 300);
            }
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.locationState?.address !== this.props.locationState?.address) this.updateContacts(this.state.areas);
    }
    reportUpdatedActiveContact(contact) {
        // yuck, I don't have a good way to sync state across different-root components yet
        // so script component just listens to this
        const activeContactEvent = new CustomEvent($58e79092af177c1d$export$7ff69bf5c61582bf.ACTIVE_CONTACT, {
            detail: contact
        });
        document.dispatchEvent(activeContactEvent);
    }
    addAlwaysAvailableAreas(areas) {
        const irrelevantVisibleAreas = [];
        const houseOrSenateAreas = [
            (0, $33d7d2ee27faba8e$export$e0c87ecbc00b9a8c).USHouse,
            (0, $33d7d2ee27faba8e$export$e0c87ecbc00b9a8c).USSenate
        ];
        const hasHouseOrSenate = areas.includes((0, $33d7d2ee27faba8e$export$e0c87ecbc00b9a8c).USHouse) || areas.includes((0, $33d7d2ee27faba8e$export$e0c87ecbc00b9a8c).USSenate);
        if (hasHouseOrSenate) {
            // Show both house and senate if at least one is relevant
            for (const area of houseOrSenateAreas)if (!areas.includes(area)) irrelevantVisibleAreas.push(area);
            return [
                ...areas,
                ...irrelevantVisibleAreas
            ];
        } else // Don't show house and senate if neither is relevant
        return areas;
    }
    updateContacts(areas = []) {
        // Make sure we're fetching all reps even if irrelevant
        const completeAreas = this.addAlwaysAvailableAreas(areas);
        const completeAreasString = completeAreas.join(',');
        if (this.props.locationState) (0, $c6a51ca48f202faf$export$70ff9d70e43e8f10)(this.props.locationState.address, completeAreasString).then((contactList)=>{
            this.setState({
                activeContactIndex: 0,
                contactList: contactList
            });
            const contacts = this.contactsForArea(this.state.areas, contactList);
            if (contacts.length > 0) {
                // start our script component with an active contact
                this.reportUpdatedActiveContact(contacts[0]);
                // report that reps loaded for outcomes to load, include contact IDs for customized scripts
                const contactIds = contacts.map((contact)=>contact.id);
                const loadedRepsEvent = new CustomEvent($58e79092af177c1d$export$7ff69bf5c61582bf.LOADED_REPS, {
                    detail: contactIds
                });
                document.dispatchEvent(loadedRepsEvent);
            }
        }).catch((error)=>{
            console.log('error getting reps:', error);
        });
    }
    contactsForArea(areas, contactList) {
        let contacts = [];
        contacts = (0, $7492649c23e6fda3$export$2e2bcd8739ae039).allContacts(contactList).filter((contact)=>{
            for (const area of areas){
                if (area === contact.area) return true;
            }
            return false;
        });
        return contacts;
    }
    visibleIrrelevantContacts(areas, contactList) {
        let contacts = [];
        // filter out the relevant contacts
        contacts = (0, $7492649c23e6fda3$export$2e2bcd8739ae039).allContacts(contactList).filter((contact)=>{
            for (const area of areas){
                if (area === contact.area) return false;
            }
            return true;
        }).map((contact)=>{
            return {
                ...contact,
                reason: `${contact.area === (0, $33d7d2ee27faba8e$export$e0c87ecbc00b9a8c).USHouse ? 'House reps' : 'Senators'} are not currently relevant to this issue.`
            };
        });
        return contacts;
    }
    vacantHouseSenateSeats(areas, contactList) {
        const missingSeats = [];
        if (!areas.includes((0, $33d7d2ee27faba8e$export$e0c87ecbc00b9a8c).USHouse) && !areas.includes((0, $33d7d2ee27faba8e$export$e0c87ecbc00b9a8c).USSenate)) return missingSeats;
        const party = '';
        const commonVacantSeatProps = {
            name: 'Vacant Seat',
            phone: '',
            party: party,
            state: contactList.state
        };
        // Handle missing Senate seat(s)
        const senateReps = contactList.senateReps();
        if (senateReps.length < 2) {
            // Assuming Senate seat(s) is vacant if there's < 2
            const numVacancies = 2 - senateReps.length; // handle multiple vacancies
            for(let i = 0; i < numVacancies; i++)missingSeats.push({
                id: `vacant-senate-seat-${i + 1}`,
                reason: `This ${(0, $33d7d2ee27faba8e$export$e0c87ecbc00b9a8c).USSenate} seat is currently vacant${areas.includes((0, $33d7d2ee27faba8e$export$e0c87ecbc00b9a8c).USSenate) ? '' : ' and not relevant to this issue'}.`,
                area: (0, $33d7d2ee27faba8e$export$e0c87ecbc00b9a8c).USSenate,
                ...commonVacantSeatProps
            });
        }
        // Handle missing House seat
        const houseReps = contactList.houseRep();
        // Assuming House seat is vacant if there's not at least one
        if (houseReps.length < 1) missingSeats.push({
            id: 'vacant-house-seat',
            reason: `This ${(0, $33d7d2ee27faba8e$export$e0c87ecbc00b9a8c).USHouse} seat is currently vacant${areas.includes((0, $33d7d2ee27faba8e$export$e0c87ecbc00b9a8c).USHouse) ? '' : ' and not relevant to this issue'}.`,
            area: (0, $33d7d2ee27faba8e$export$e0c87ecbc00b9a8c).USHouse,
            ...commonVacantSeatProps
        });
        return missingSeats;
    }
    contactComponent(contact, index, activeIndex, type) {
        let photoURL = '/images/no-rep.png';
        if (contact.photoURL && contact.photoURL !== '') photoURL = contact.photoURL ?? '/images/no-rep.png';
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("li", {
            className: index === activeIndex ? 'active' : '',
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: `rep-info ${type}`,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                        alt: contact.name,
                        src: photoURL,
                        onError: (e)=>{
                            e.currentTarget.src = '/images/no-rep.png';
                        }
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "rep-info-content",
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("h4", {
                                children: [
                                    contact.name,
                                    ' ',
                                    type !== 'vacant' && `(${(0, $7492649c23e6fda3$export$2e2bcd8739ae039).partyAndState(contact)})`
                                ]
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                                children: contact.reason
                            })
                        ]
                    })
                ]
            })
        }, contact.id);
    }
    render() {
        if (!this.state.contactList || !this.props.locationState?.address) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            ref: this.componentRef,
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("ul", {
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                            alt: "No representative found",
                            src: "/images/no-rep.png"
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h4", {
                            children: "No reps available"
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                            children: "Please set your location to find your representatives"
                        })
                    ]
                })
            })
        });
        if (this.state.requiredState !== '' && this.state.requiredState !== this.props.locationState.state) {
            const stateName = (0, $abe909a3f4f45831$export$2e2bcd8739ae039)(this.state.requiredState);
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                ref: this.componentRef,
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("ul", {
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                                alt: "No representative found",
                                src: "/images/no-rep.png"
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h4", {
                                children: "Not available"
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("p", {
                                children: [
                                    "This topic is only available in ",
                                    stateName
                                ]
                            })
                        ]
                    })
                })
            });
        }
        const targetedContacts = this.contactsForArea(this.state.areas, this.state.contactList);
        const irrelevantContacts = this.visibleIrrelevantContacts(this.state.areas, this.state.contactList);
        const vacantSeats = this.vacantHouseSenateSeats(this.state.areas, this.state.contactList);
        let activeContact;
        if (targetedContacts.length > 0) activeContact = targetedContacts[this.state.activeContactIndex];
        let contactWarning = '';
        const hasStateReps = this.state.areas.includes('StateUpper') || this.state.areas.includes('StateLower');
        // only show this contact warning for issues with state reps, but maybe extend to the split zip thing too
        if (hasStateReps && this.state.contactList.lowAccuracy) contactWarning = 'Warning: your location is set to a zip code or other approximate location, please enter an address or zip+4 for accurate state level reps.';
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            ref: this.componentRef,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("ul", {
                    children: [
                        targetedContacts.map((contact, index)=>this.contactComponent(contact, index, this.state.activeContactIndex, 'targeted')),
                        vacantSeats.map((contact)=>this.contactComponent(contact, -1, this.state.activeContactIndex, 'vacant')),
                        irrelevantContacts.map((contact)=>this.contactComponent(contact, -1, this.state.activeContactIndex, 'irrelevant'))
                    ]
                }),
                contactWarning && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("p", {
                    className: "contact-warning",
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("i", {
                            className: "fa-solid fa-triangle-exclamation"
                        }),
                        contactWarning
                    ]
                }),
                activeContact && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $333279c6ff421f64$export$2e2bcd8739ae039), {
                    contact: activeContact
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this._defaultAreas = [], this._defaultContactList = undefined, this.componentRef = /*#__PURE__*/ (0, $gIfym.createRef)(), this.state = {
            areas: this._defaultAreas,
            issueId: '0000',
            requiredState: '',
            contactList: this._defaultContactList,
            activeContactIndex: 0
        };
    }
}
var $cd098264dbb86b3b$export$2e2bcd8739ae039 = (0, $b410c744327f470f$export$71260fd0c34a821)((0, $b410c744327f470f$export$1688adba58f7c3f1)($cd098264dbb86b3b$var$RepsWithSettings));




var $gIfym = parcelRequire("gIfym");
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ 
var $gIfym = parcelRequire("gIfym");
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {Record<string, unknown> & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {'ascii' | 'utf8' | 'utf-8' | 'utf16le' | 'ucs2' | 'ucs-2' | 'base64' | 'base64url' | 'latin1' | 'binary' | 'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *
 *   This is a copy of the types from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Options | URL | Value | VFile} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {Value | null | undefined} [value]
 *   Set `value`.
 * @property {string | null | undefined} [cwd]
 *   Set `cwd`.
 * @property {Array<string> | null | undefined} [history]
 *   Set `history`.
 * @property {URL | string | null | undefined} [path]
 *   Set `path`.
 * @property {string | null | undefined} [basename]
 *   Set `basename`.
 * @property {string | null | undefined} [stem]
 *   Set `stem`.
 * @property {string | null | undefined} [extname]
 *   Set `extname`.
 * @property {string | null | undefined} [dirname]
 *   Set `dirname`.
 * @property {Data | null | undefined} [data]
 *   Set `data`.
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template {ReporterSettings} Settings
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ var $481d8373cee6afa4$exports = {};
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ $481d8373cee6afa4$exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Position | PositionLike | Point | PointLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $51e33f0d9892f114$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $51e33f0d9892f114$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $51e33f0d9892f114$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $51e33f0d9892f114$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $51e33f0d9892f114$var$point(point) {
    return $51e33f0d9892f114$var$index(point && point.line) + ':' + $51e33f0d9892f114$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $51e33f0d9892f114$var$position(pos) {
    return $51e33f0d9892f114$var$point(pos && pos.start) + '-' + $51e33f0d9892f114$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $51e33f0d9892f114$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


class $20eacbe91b19bc30$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // To do: next major: expose `undefined` everywhere instead of `null`.
    constructor(reason, place, origin){
        /** @type {[string | null, string | null]} */ const parts = [
            null,
            null
        ];
        /** @type {Position} */ let position = {
            // @ts-expect-error: we always follows the structure of `position`.
            start: {
                line: null,
                column: null
            },
            // @ts-expect-error: "
            end: {
                line: null,
                column: null
            }
        };
        super();
        if (typeof place === 'string') {
            origin = place;
            place = undefined;
        }
        if (typeof origin === 'string') {
            const index = origin.indexOf(':');
            if (index === -1) parts[1] = origin;
            else {
                parts[0] = origin.slice(0, index);
                parts[1] = origin.slice(index + 1);
            }
        }
        if (place) {
            // Node.
            if ('type' in place || 'position' in place) {
                if (place.position) // To do: next major: deep clone.
                // @ts-expect-error: looks like a position.
                position = place.position;
            } else if ('start' in place || 'end' in place) // @ts-expect-error: looks like a position.
            // To do: next major: deep clone.
            position = place;
            else if ('line' in place || 'column' in place) // To do: next major: deep clone.
            position.start = place;
        }
        // Fields from `Error`.
        /**
     * Serialized positional info of error.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $51e33f0d9892f114$export$c304dd45fe166145)(place) || '1:1';
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = typeof reason === 'object' ? reason.message : reason;
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = '';
        if (typeof reason === 'object' && reason.stack) this.stack = reason.stack;
        /**
     * Reason for message.
     *
     * > 👉 **Note**: you should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /* eslint-disable no-unused-expressions */ /**
     * State of problem.
     *
     * * `true` — marks associated file as no longer processable (error)
     * * `false` — necessitates a (potential) change (warning)
     * * `null | undefined` — for things that might not need changing (info)
     *
     * @type {boolean | null | undefined}
     */ this.fatal;
        /**
     * Starting line of error.
     *
     * @type {number | null}
     */ this.line = position.start.line;
        /**
     * Starting column of error.
     *
     * @type {number | null}
     */ this.column = position.start.column;
        /**
     * Full unist position.
     *
     * @type {Position | null}
     */ this.position = position;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | null}
     */ this.source = parts[0];
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | null}
     */ this.ruleId = parts[1];
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | null}
     */ this.file;
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | null}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | null}
     */ this.expected;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | null}
     */ this.url;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | null}
     */ this.note;
    /* eslint-enable no-unused-expressions */ }
}
$20eacbe91b19bc30$export$752e5c445fe834ef.prototype.file = '';
$20eacbe91b19bc30$export$752e5c445fe834ef.prototype.name = '';
$20eacbe91b19bc30$export$752e5c445fe834ef.prototype.reason = '';
$20eacbe91b19bc30$export$752e5c445fe834ef.prototype.message = '';
$20eacbe91b19bc30$export$752e5c445fe834ef.prototype.stack = '';
$20eacbe91b19bc30$export$752e5c445fe834ef.prototype.fatal = null;
$20eacbe91b19bc30$export$752e5c445fe834ef.prototype.column = null;
$20eacbe91b19bc30$export$752e5c445fe834ef.prototype.line = null;
$20eacbe91b19bc30$export$752e5c445fe834ef.prototype.source = null;
$20eacbe91b19bc30$export$752e5c445fe834ef.prototype.ruleId = null;
$20eacbe91b19bc30$export$752e5c445fe834ef.prototype.position = null;


// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $7e4a2e81ddc0b6a4$export$bb654e07daaf8c3a = {
    basename: $7e4a2e81ddc0b6a4$var$basename,
    dirname: $7e4a2e81ddc0b6a4$var$dirname,
    extname: $7e4a2e81ddc0b6a4$var$extname,
    join: $7e4a2e81ddc0b6a4$var$join,
    sep: '/'
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $7e4a2e81ddc0b6a4$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    $7e4a2e81ddc0b6a4$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (ext === path) return '';
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $7e4a2e81ddc0b6a4$var$dirname(path) {
    $7e4a2e81ddc0b6a4$var$assertPath(path);
    if (path.length === 0) return '.';
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $7e4a2e81ddc0b6a4$var$extname(path) {
    $7e4a2e81ddc0b6a4$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $7e4a2e81ddc0b6a4$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $7e4a2e81ddc0b6a4$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + '/' + segments[index];
    }
    return joined === undefined ? '.' : $7e4a2e81ddc0b6a4$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $7e4a2e81ddc0b6a4$var$normalize(path) {
    $7e4a2e81ddc0b6a4$var$assertPath(path);
    const absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $7e4a2e81ddc0b6a4$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = '.';
    if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $7e4a2e81ddc0b6a4$var$normalizeString(path, allowAboveRoot) {
    let result = '';
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $7e4a2e81ddc0b6a4$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $9d63a5007838c3a4$export$97a5aaf482767187 = {
    cwd: $9d63a5007838c3a4$var$cwd
};
function $9d63a5007838c3a4$var$cwd() {
    return '/';
}


/// <reference lib="dom" />
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */ /**
 * Check if `fileUrlOrPath` looks like a URL.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function $a3cfe9573f81b7e9$export$8304a22d431f958(fileUrlOrPath) {
    return fileUrlOrPath !== null && typeof fileUrlOrPath === 'object' && // @ts-expect-error: indexable.
    fileUrlOrPath.href && // @ts-expect-error: indexable.
    fileUrlOrPath.origin;
}


function $22c75d546b9d21ae$export$9b2b676c902de799(path) {
    if (typeof path === 'string') path = new URL(path);
    else if (!(0, $a3cfe9573f81b7e9$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + '`');
        error.code = 'ERR_INVALID_ARG_TYPE';
        throw error;
    }
    if (path.protocol !== 'file:') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The URL must be of scheme file');
        error.code = 'ERR_INVALID_URL_SCHEME';
        throw error;
    }
    return $22c75d546b9d21ae$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $22c75d546b9d21ae$var$getPathFromURLPosix(url) {
    if (url.hostname !== '') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = 'ERR_INVALID_FILE_URL_HOST';
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.charCodeAt(index) === 37 /* `%` */  && pathname.charCodeAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.charCodeAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL path must not include encoded / characters');
            error.code = 'ERR_INVALID_FILE_URL_PATH';
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 *
 * @type {Array<'basename' | 'dirname' | 'extname' | 'history' | 'path' | 'stem'>}
 */ const $99c37b7e983cdc2d$var$order = [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
class $99c37b7e983cdc2d$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if (typeof value === 'string' || $99c37b7e983cdc2d$var$buffer(value)) options = {
            value: value
        };
        else if ((0, $a3cfe9573f81b7e9$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else options = value;
        /**
     * Place to store custom information (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * List of filepaths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $9d63a5007838c3a4$export$97a5aaf482767187).cwd();
        /* eslint-disable no-unused-expressions */ /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $99c37b7e983cdc2d$var$order.length){
            const prop = $99c37b7e983cdc2d$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === 'history' ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$99c37b7e983cdc2d$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */ set path(path) {
        if ((0, $a3cfe9573f81b7e9$export$8304a22d431f958)(path)) path = (0, $22c75d546b9d21ae$export$9b2b676c902de799)(path);
        $99c37b7e983cdc2d$var$assertNonEmpty(path, 'path');
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the parent path (example: `'~'`).
   */ get dirname() {
        return typeof this.path === 'string' ? (0, $7e4a2e81ddc0b6a4$export$bb654e07daaf8c3a).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */ set dirname(dirname) {
        $99c37b7e983cdc2d$var$assertPath(this.basename, 'dirname');
        this.path = (0, $7e4a2e81ddc0b6a4$export$bb654e07daaf8c3a).join(dirname || '', this.basename);
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */ get basename() {
        return typeof this.path === 'string' ? (0, $7e4a2e81ddc0b6a4$export$bb654e07daaf8c3a).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set basename(basename) {
        $99c37b7e983cdc2d$var$assertNonEmpty(basename, 'basename');
        $99c37b7e983cdc2d$var$assertPart(basename, 'basename');
        this.path = (0, $7e4a2e81ddc0b6a4$export$bb654e07daaf8c3a).join(this.dirname || '', basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   */ get extname() {
        return typeof this.path === 'string' ? (0, $7e4a2e81ddc0b6a4$export$bb654e07daaf8c3a).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */ set extname(extname) {
        $99c37b7e983cdc2d$var$assertPart(extname, 'extname');
        $99c37b7e983cdc2d$var$assertPath(this.dirname, 'extname');
        if (extname) {
            if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
            if (extname.includes('.', 1)) throw new Error('`extname` cannot contain multiple dots');
        }
        this.path = (0, $7e4a2e81ddc0b6a4$export$bb654e07daaf8c3a).join(this.dirname, this.stem + (extname || ''));
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */ get stem() {
        return typeof this.path === 'string' ? (0, $7e4a2e81ddc0b6a4$export$bb654e07daaf8c3a).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set stem(stem) {
        $99c37b7e983cdc2d$var$assertNonEmpty(stem, 'stem');
        $99c37b7e983cdc2d$var$assertPart(stem, 'stem');
        this.path = (0, $7e4a2e81ddc0b6a4$export$bb654e07daaf8c3a).join(this.dirname || '', stem + (this.extname || ''));
    }
    /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        return (this.value || '').toString(encoding || undefined);
    }
    /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(reason, place, origin) {
        const message = new (0, $20eacbe91b19bc30$export$752e5c445fe834ef)(reason, place, origin);
        if (this.path) {
            message.name = this.path + ':' + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = null;
        return message;
    }
    /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */ fail(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = true;
        throw message;
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {void}
 *   Nothing.
 */ function $99c37b7e983cdc2d$var$assertPart(part, name) {
    if (part && part.includes((0, $7e4a2e81ddc0b6a4$export$bb654e07daaf8c3a).sep)) throw new Error('`' + name + '` cannot be a path: did not expect `' + (0, $7e4a2e81ddc0b6a4$export$bb654e07daaf8c3a).sep + '`');
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $99c37b7e983cdc2d$var$assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $99c37b7e983cdc2d$var$assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}
/**
 * Assert `value` is a buffer.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Buffer}
 *   Whether `value` is a Node.js buffer.
 */ function $99c37b7e983cdc2d$var$buffer(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($481d8373cee6afa4$exports)))(value);
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $1ee611a145233875$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}



var $5c740e81bd8893b2$exports = {};
'use strict';
var $5c740e81bd8893b2$var$hasOwn = Object.prototype.hasOwnProperty;
var $5c740e81bd8893b2$var$toStr = Object.prototype.toString;
var $5c740e81bd8893b2$var$defineProperty = Object.defineProperty;
var $5c740e81bd8893b2$var$gOPD = Object.getOwnPropertyDescriptor;
var $5c740e81bd8893b2$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $5c740e81bd8893b2$var$toStr.call(arr) === '[object Array]';
};
var $5c740e81bd8893b2$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $5c740e81bd8893b2$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $5c740e81bd8893b2$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $5c740e81bd8893b2$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $5c740e81bd8893b2$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $5c740e81bd8893b2$var$setProperty = function setProperty(target, options) {
    if ($5c740e81bd8893b2$var$defineProperty && options.name === '__proto__') $5c740e81bd8893b2$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $5c740e81bd8893b2$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$5c740e81bd8893b2$var$hasOwn.call(obj, name)) return void 0;
        else if ($5c740e81bd8893b2$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $5c740e81bd8893b2$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$5c740e81bd8893b2$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $5c740e81bd8893b2$var$getProperty(target, name);
            copy = $5c740e81bd8893b2$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($5c740e81bd8893b2$var$isPlainObject(copy) || (copyIsArray = $5c740e81bd8893b2$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $5c740e81bd8893b2$var$isArray(src) ? src : [];
                    } else clone = src && $5c740e81bd8893b2$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $5c740e81bd8893b2$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $5c740e81bd8893b2$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


function $ee4e28fab87be577$export$2e2bcd8739ae039(value) {
    if (typeof value !== 'object' || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $e3eb83f73c9ef9b3$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== 'function') throw new TypeError('Expected function as last argument, not ' + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $e3eb83f73c9ef9b3$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== 'function') throw new TypeError('Expected `middelware` to be a function, not ' + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $e3eb83f73c9ef9b3$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}



const $97703616b9c45baa$export$7cc1b2fe10c52bb = $97703616b9c45baa$var$base().freeze();
const $97703616b9c45baa$var$own = {}.hasOwnProperty;
// Function to create the first processor.
/**
 * @returns {Processor}
 */ function $97703616b9c45baa$var$base() {
    const transformers = (0, $e3eb83f73c9ef9b3$export$91b56f5ca106aa43)();
    /** @type {Processor['attachers']} */ const attachers = [];
    /** @type {Record<string, unknown>} */ let namespace = {};
    /** @type {boolean|undefined} */ let frozen;
    let freezeIndex = -1;
    // Data management.
    // @ts-expect-error: overloads are handled.
    processor.data = data;
    processor.Parser = undefined;
    processor.Compiler = undefined;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    // @ts-expect-error: overloads are handled.
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    // @ts-expect-error: overloads are handled.
    processor.run = run;
    processor.runSync = runSync;
    // @ts-expect-error: overloads are handled.
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    /** @type {Processor} */ function processor() {
        const destination = $97703616b9c45baa$var$base();
        let index = -1;
        while(++index < attachers.length)destination.use(...attachers[index]);
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($5c740e81bd8893b2$exports)))(true, {}, namespace));
        return destination;
    }
    /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */ function data(key, value) {
        if (typeof key === 'string') {
            // Set `key`.
            if (arguments.length === 2) {
                $97703616b9c45baa$var$assertUnfrozen('data', frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $97703616b9c45baa$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $97703616b9c45baa$var$assertUnfrozen('data', frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    /** @type {Processor['freeze']} */ function freeze() {
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            const [attacher, ...options] = attachers[freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            /** @type {Transformer|void} */ const transformer = attacher.call(processor, ...options);
            if (typeof transformer === 'function') transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Number.POSITIVE_INFINITY;
        return processor;
    }
    /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */ function use(value, ...options) {
        /** @type {Record<string, unknown>|undefined} */ let settings;
        $97703616b9c45baa$var$assertUnfrozen('use', frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === 'function') addPlugin(value, ...options);
        else if (typeof value === 'object') {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError('Expected usable value, not `' + value + '`');
        if (settings) namespace.settings = Object.assign(namespace.settings || {}, settings);
        return processor;
        /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */ function add(value) {
            if (typeof value === 'function') addPlugin(value);
            else if (typeof value === 'object') {
                if (Array.isArray(value)) {
                    const [plugin, ...options] = value;
                    addPlugin(plugin, ...options);
                } else addPreset(value);
            } else throw new TypeError('Expected usable value, not `' + value + '`');
        }
        /**
     * @param {Preset} result
     * @returns {void}
     */ function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = Object.assign(settings || {}, result.settings);
        }
        /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError('Expected a list of plugins, not `' + plugins + '`');
        }
        /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */ function addPlugin(plugin, value) {
            let index = -1;
            /** @type {Processor['attachers'][number]|undefined} */ let entry;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entry = attachers[index];
                break;
            }
            if (entry) {
                if ((0, $ee4e28fab87be577$export$2e2bcd8739ae039)(entry[1]) && (0, $ee4e28fab87be577$export$2e2bcd8739ae039)(value)) value = (0, (/*@__PURE__*/$parcel$interopDefault($5c740e81bd8893b2$exports)))(true, entry[1], value);
                entry[1] = value;
            } else // @ts-expect-error: fine.
            attachers.push([
                ...arguments
            ]);
        }
    }
    /** @type {Processor['parse']} */ function parse(doc) {
        processor.freeze();
        const file = $97703616b9c45baa$var$vfile(doc);
        const Parser = processor.Parser;
        $97703616b9c45baa$var$assertParser('parse', Parser);
        if ($97703616b9c45baa$var$newable(Parser, 'parse')) // @ts-expect-error: `newable` checks this.
        return new Parser(String(file), file).parse();
        // @ts-expect-error: `newable` checks this.
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    /** @type {Processor['stringify']} */ function stringify(node, doc) {
        processor.freeze();
        const file = $97703616b9c45baa$var$vfile(doc);
        const Compiler = processor.Compiler;
        $97703616b9c45baa$var$assertCompiler('stringify', Compiler);
        $97703616b9c45baa$var$assertNode(node);
        if ($97703616b9c45baa$var$newable(Compiler, 'compile')) // @ts-expect-error: `newable` checks this.
        return new Compiler(node, file).compile();
        // @ts-expect-error: `newable` checks this.
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */ function run(node, doc, callback) {
        $97703616b9c45baa$var$assertNode(node);
        processor.freeze();
        if (!callback && typeof doc === 'function') {
            callback = doc;
            doc = undefined;
        }
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
            transformers.run(node, $97703616b9c45baa$var$vfile(doc), done);
            /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */ function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, tree, file);
            }
        }
    }
    /** @type {Processor['runSync']} */ function runSync(node, file) {
        /** @type {Node|undefined} */ let result;
        /** @type {boolean|undefined} */ let complete;
        processor.run(node, file, done);
        $97703616b9c45baa$var$assertDone('runSync', 'run', complete);
        // @ts-expect-error: we either bailed on an error or have a tree.
        return result;
        /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */ function done(error, tree) {
            (0, $1ee611a145233875$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */ function process(doc, callback) {
        processor.freeze();
        $97703616b9c45baa$var$assertParser('process', processor.Parser);
        $97703616b9c45baa$var$assertCompiler('process', processor.Compiler);
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            const file = $97703616b9c45baa$var$vfile(doc);
            processor.run(processor.parse(file), file, (error, tree, file)=>{
                if (error || !tree || !file) done(error);
                else {
                    /** @type {unknown} */ const result = processor.stringify(tree, file);
                    if (result === undefined || result === null) ;
                    else if ($97703616b9c45baa$var$looksLikeAVFileValue(result)) file.value = result;
                    else file.result = result;
                    done(error, file);
                }
            });
            /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */ function done(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, file);
            }
        }
    }
    /** @type {Processor['processSync']} */ function processSync(doc) {
        /** @type {boolean|undefined} */ let complete;
        processor.freeze();
        $97703616b9c45baa$var$assertParser('processSync', processor.Parser);
        $97703616b9c45baa$var$assertCompiler('processSync', processor.Compiler);
        const file = $97703616b9c45baa$var$vfile(doc);
        processor.process(file, done);
        $97703616b9c45baa$var$assertDone('processSync', 'process', complete);
        return file;
        /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */ function done(error) {
            complete = true;
            (0, $1ee611a145233875$export$dd911e13ecb11e05)(error);
        }
    }
}
/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */ function $97703616b9c45baa$var$newable(value, name) {
    return typeof value === 'function' && // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    ($97703616b9c45baa$var$keys(value.prototype) || name in value.prototype);
}
/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */ function $97703616b9c45baa$var$keys(value) {
    /** @type {string} */ let key;
    for(key in value){
        if ($97703616b9c45baa$var$own.call(value, key)) return true;
    }
    return false;
}
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $97703616b9c45baa$var$assertParser(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `Parser`');
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $97703616b9c45baa$var$assertCompiler(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `Compiler`');
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $97703616b9c45baa$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot call `' + name + '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.');
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $97703616b9c45baa$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $ee4e28fab87be577$export$2e2bcd8739ae039)(node) || typeof node.type !== 'string') throw new TypeError('Expected node, got `' + node + '`');
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $97703616b9c45baa$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}
/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */ function $97703616b9c45baa$var$vfile(value) {
    return $97703616b9c45baa$var$looksLikeAVFile(value) ? value : new (0, $99c37b7e983cdc2d$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */ function $97703616b9c45baa$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === 'object' && 'message' in value && 'messages' in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */ function $97703616b9c45baa$var$looksLikeAVFileValue(value) {
    return typeof value === 'string' || (0, (/*@__PURE__*/$parcel$interopDefault($481d8373cee6afa4$exports)))(value);
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */ /**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').StaticPhrasingContent} StaticPhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Root | Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 *
 * @typedef {Omit<UnistParent, 'type' | 'children'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | undefined | null | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Node | Fragment>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {<Key extends keyof CompileData>(key: Key) => CompileData[Key]} getData
 *   Get data from the key/value store.
 * @property {<Key extends keyof CompileData>(key: Key, value?: CompileData[Key]) => void} setData
 *   Set data into the key/value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<Kind extends Node>(this: CompileContext, node: Kind, token: Token, onError?: OnEnterError) => Kind} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ // To do: micromark: create a registry of tokens?
// To do: next major: don’t return given `Node` from `enter`.
// To do: next major: remove setter/getter.
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s.
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML.
 */ /** @type {Options} */ const $3c0c412bd3b19d2f$var$emptyOptions = {};
function $3c0c412bd3b19d2f$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $3c0c412bd3b19d2f$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $3c0c412bd3b19d2f$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $3c0c412bd3b19d2f$var$one(value, includeImageAlt, includeHtml) {
    if ($3c0c412bd3b19d2f$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $3c0c412bd3b19d2f$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $3c0c412bd3b19d2f$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $3c0c412bd3b19d2f$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $3c0c412bd3b19d2f$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Node}
 *   Whether `value` is a node.
 */ function $3c0c412bd3b19d2f$var$node(value) {
    return Boolean(value && typeof value === 'object');
}


/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ /**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ /**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {void}
 *   Nothing.
 */ function $ac97a6279504a515$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $ac97a6279504a515$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $ac97a6279504a515$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


const $f8f68d028a19c473$var$hasOwnProperty = {}.hasOwnProperty;
function $f8f68d028a19c473$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$f8f68d028a19c473$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $f8f68d028a19c473$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $f8f68d028a19c473$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$f8f68d028a19c473$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $f8f68d028a19c473$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {void}
 */ function $f8f68d028a19c473$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $ac97a6279504a515$export$869882364835d202)(existing, 0, 0, before);
}
function $f8f68d028a19c473$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$f8f68d028a19c473$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $f8f68d028a19c473$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $f8f68d028a19c473$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 */ // This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
/**
 * Regular expression that matches a unicode punctuation character.
 */ const $4afc5cc2c8276494$export$85b5101f24802e8c = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;


const $c57804f696751fc2$export$d65d6b62c24d5436 = $c57804f696751fc2$var$regexCheck(/[A-Za-z]/);
const $c57804f696751fc2$export$75c76db11865a9f4 = $c57804f696751fc2$var$regexCheck(/[\dA-Za-z]/);
const $c57804f696751fc2$export$4397998b34fe597d = $c57804f696751fc2$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $c57804f696751fc2$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $c57804f696751fc2$export$ca8b5b1a6c320e6e = $c57804f696751fc2$var$regexCheck(/\d/);
const $c57804f696751fc2$export$eca2752363989806 = $c57804f696751fc2$var$regexCheck(/[\dA-Fa-f]/);
const $c57804f696751fc2$export$35794a7d1db99380 = $c57804f696751fc2$var$regexCheck(/[!-/:-@[-`{-~]/);
function $c57804f696751fc2$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $c57804f696751fc2$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $c57804f696751fc2$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $c57804f696751fc2$export$aa04114dd888a7a0 = $c57804f696751fc2$var$regexCheck((0, $4afc5cc2c8276494$export$85b5101f24802e8c));
const $c57804f696751fc2$export$a0ff789c034ffdf4 = $c57804f696751fc2$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $c57804f696751fc2$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && regex.test(String.fromCharCode(code));
    }
}


function $52a224b996a2386a$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $d858d0c163e49cb9$export$a7db06668cad9adb = {
    tokenize: $d858d0c163e49cb9$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $d858d0c163e49cb9$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, contentStart, 'linePrefix');
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter('paragraph');
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter('chunkText', {
            contentType: 'text',
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit('chunkText');
            effects.exit('paragraph');
            effects.consume(code);
            return;
        }
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit('chunkText');
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 


const $846cdcab270cf160$export$5a7bfc01df82fcd1 = {
    tokenize: $846cdcab270cf160$var$initializeDocument
};
/** @type {Construct} */ const $846cdcab270cf160$var$containerConstruct = {
    tokenize: $846cdcab270cf160$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $846cdcab270cf160$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === 'chunkFlow') {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $ac97a6279504a515$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($846cdcab270cf160$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($846cdcab270cf160$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter('chunkFlow', {
            contentType: 'flow',
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit('chunkFlow'), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit('chunkFlow'));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {void}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === 'chunkFlow') {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $ac97a6279504a515$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {void}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $846cdcab270cf160$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), 'linePrefix', this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $1a5909f288baadcb$export$d50d28ce3ab2a612 = {
    tokenize: $1a5909f288baadcb$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1a5909f288baadcb$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $c57804f696751fc2$export$2c6cf65c1127992a)(code) ? (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, after, 'linePrefix')(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
function $877ff4396a7ae0f2$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === 'chunkFlow' && events[index - 1][1].type === 'listItemPrefix') {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'lineEndingBlank') otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'content') while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === 'content') break;
                if (subevents[otherIndex][1].type === 'chunkText') {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $877ff4396a7ae0f2$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === 'lineEnding' || otherEvent[1].type === 'lineEndingBlank') {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events[lineIndex][1].type = 'lineEndingBlank';
                        otherEvent[1].type = 'lineEnding';
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $ac97a6279504a515$export$869882364835d202)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $877ff4396a7ae0f2$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $ac97a6279504a515$export$869882364835d202)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $5232eda9adc4fed1$export$a7db06668cad9adb = {
    tokenize: $5232eda9adc4fed1$var$tokenizeContent,
    resolve: $5232eda9adc4fed1$var$resolveContent
};
/** @type {Construct} */ const $5232eda9adc4fed1$var$continuationConstruct = {
    tokenize: $5232eda9adc4fed1$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $5232eda9adc4fed1$var$resolveContent(events) {
    (0, $877ff4396a7ae0f2$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5232eda9adc4fed1$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter('content');
        previous = effects.enter('chunkContent', {
            contentType: 'content'
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) return effects.check($5232eda9adc4fed1$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit('chunkContent');
        effects.exit('content');
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit('chunkContent');
        previous.next = effects.enter('chunkContent', {
            contentType: 'content',
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5232eda9adc4fed1$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit('chunkContent');
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, prefixed, 'linePrefix');
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === 'linePrefix' && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $b88ae1e29e4b3768$export$ccc7b0636abaffc3 = {
    tokenize: $b88ae1e29e4b3768$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $b88ae1e29e4b3768$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $1a5909f288baadcb$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $5232eda9adc4fed1$export$a7db06668cad9adb), afterConstruct)), 'linePrefix')));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEndingBlank');
        effects.consume(code);
        effects.exit('lineEndingBlank');
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $8562b73fc47e9af8$export$50397835cbfdbc24 = {
    resolveAll: $8562b73fc47e9af8$var$createResolver()
};
const $8562b73fc47e9af8$export$22b082955e083ec3 = $8562b73fc47e9af8$var$initializeFactory('string');
const $8562b73fc47e9af8$export$6f093cfa640b7166 = $8562b73fc47e9af8$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $8562b73fc47e9af8$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $8562b73fc47e9af8$var$createResolver(field === 'text' ? $8562b73fc47e9af8$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter('data');
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit('data');
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $8562b73fc47e9af8$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === 'data') {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== 'data') {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $8562b73fc47e9af8$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === 'lineEnding') && events[eventIndex - 1][1].type === 'data') {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? 'lineSuffix' : 'hardBreakTrailing',
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {void}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $3e9231666da4ce68$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $5ac114c979455f19$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | void}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $ac97a6279504a515$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $3e9231666da4ce68$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $5ac114c979455f19$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $5ac114c979455f19$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : 'tokenize' in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $ac97a6279504a515$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {void}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $5ac114c979455f19$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $5ac114c979455f19$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = '\r';
                break;
            case -4:
                value = '\n';
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? ' ' : '\t';
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = ' ';
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


var $2f26f8159466612b$exports = {};

$parcel$export($2f26f8159466612b$exports, "document", function () { return $2f26f8159466612b$export$5a7bfc01df82fcd1; });
$parcel$export($2f26f8159466612b$exports, "contentInitial", function () { return $2f26f8159466612b$export$5a2181fb44b58173; });
$parcel$export($2f26f8159466612b$exports, "flowInitial", function () { return $2f26f8159466612b$export$cf8bead395eff824; });
$parcel$export($2f26f8159466612b$exports, "flow", function () { return $2f26f8159466612b$export$ccc7b0636abaffc3; });
$parcel$export($2f26f8159466612b$exports, "string", function () { return $2f26f8159466612b$export$22b082955e083ec3; });
$parcel$export($2f26f8159466612b$exports, "text", function () { return $2f26f8159466612b$export$6f093cfa640b7166; });
$parcel$export($2f26f8159466612b$exports, "insideSpan", function () { return $2f26f8159466612b$export$d44f260a3f9b69f5; });
$parcel$export($2f26f8159466612b$exports, "attentionMarkers", function () { return $2f26f8159466612b$export$b9c0b60d74426aea; });
$parcel$export($2f26f8159466612b$exports, "disable", function () { return $2f26f8159466612b$export$e20fbacbb41798b; });
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
function $29b4e14106025210$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $c57804f696751fc2$export$a30284361b3814b7)(code) || (0, $c57804f696751fc2$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $c57804f696751fc2$export$aa04114dd888a7a0)(code)) return 2;
}



const $a404a8e762491e9d$export$45b92471da762af7 = {
    name: 'attention',
    tokenize: $a404a8e762491e9d$var$tokenizeAttention,
    resolveAll: $a404a8e762491e9d$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ function $a404a8e762491e9d$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $a404a8e762491e9d$var$movePoint(start, -use);
            $a404a8e762491e9d$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? 'strongSequence' : 'emphasisSequence',
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? 'strongSequence' : 'emphasisSequence',
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? 'strongText' : 'emphasisText',
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? 'strong' : 'emphasis',
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $ac97a6279504a515$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $ac97a6279504a515$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $ac97a6279504a515$export$4cbf152802aa238)(nextEvents, (0, $3e9231666da4ce68$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $ac97a6279504a515$export$4cbf152802aa238)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $ac97a6279504a515$export$4cbf152802aa238)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $ac97a6279504a515$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a404a8e762491e9d$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $29b4e14106025210$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $29b4e14106025210$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */ function $a404a8e762491e9d$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $14b5f38afbf58355$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $14b5f38afbf58355$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $14b5f38afbf58355$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('autolink');
        effects.enter('autolinkMarker');
        effects.consume(code);
        effects.exit('autolinkMarker');
        effects.enter('autolinkProtocol');
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $c57804f696751fc2$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $c57804f696751fc2$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $c57804f696751fc2$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit('autolinkProtocol');
            effects.enter('autolinkMarker');
            effects.consume(code);
            effects.exit('autolinkMarker');
            effects.exit('autolink');
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $c57804f696751fc2$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $c57804f696751fc2$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $c57804f696751fc2$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit('autolinkProtocol').type = 'autolinkEmail';
            effects.enter('autolinkMarker');
            effects.consume(code);
            effects.exit('autolinkMarker');
            effects.exit('autolink');
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $c57804f696751fc2$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $528c98595af69f6b$export$200dcd0a5903c968 = {
    name: 'blockQuote',
    tokenize: $528c98595af69f6b$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $528c98595af69f6b$var$tokenizeBlockQuoteContinuation
    },
    exit: $528c98595af69f6b$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $528c98595af69f6b$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter('blockQuote', {
                    _container: true
                });
                state.open = true;
            }
            effects.enter('blockQuotePrefix');
            effects.enter('blockQuoteMarker');
            effects.consume(code);
            effects.exit('blockQuoteMarker');
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) {
            effects.enter('blockQuotePrefixWhitespace');
            effects.consume(code);
            effects.exit('blockQuotePrefixWhitespace');
            effects.exit('blockQuotePrefix');
            return ok;
        }
        effects.exit('blockQuotePrefix');
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $528c98595af69f6b$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, contBefore, 'linePrefix', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($528c98595af69f6b$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $528c98595af69f6b$var$exit(effects) {
    effects.exit('blockQuote');
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $8e4a567e298da283$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $8e4a567e298da283$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8e4a567e298da283$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('characterEscape');
        effects.enter('escapeMarker');
        effects.consume(code);
        effects.exit('escapeMarker');
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $c57804f696751fc2$export$35794a7d1db99380)(code)) {
            effects.enter('characterEscapeValue');
            effects.consume(code);
            effects.exit('characterEscapeValue');
            effects.exit('characterEscape');
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */ const $86deb4e981e5b737$export$ec810d1aafce79a7 = {
    AElig: "\xc6",
    AMP: '&',
    Aacute: "\xc1",
    Abreve: "\u0102",
    Acirc: "\xc2",
    Acy: "\u0410",
    Afr: "\uD835\uDD04",
    Agrave: "\xc0",
    Alpha: "\u0391",
    Amacr: "\u0100",
    And: "\u2A53",
    Aogon: "\u0104",
    Aopf: "\uD835\uDD38",
    ApplyFunction: "\u2061",
    Aring: "\xc5",
    Ascr: "\uD835\uDC9C",
    Assign: "\u2254",
    Atilde: "\xc3",
    Auml: "\xc4",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    Barwed: "\u2306",
    Bcy: "\u0411",
    Because: "\u2235",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Breve: "\u02D8",
    Bscr: "\u212C",
    Bumpeq: "\u224E",
    CHcy: "\u0427",
    COPY: "\xa9",
    Cacute: "\u0106",
    Cap: "\u22D2",
    CapitalDifferentialD: "\u2145",
    Cayleys: "\u212D",
    Ccaron: "\u010C",
    Ccedil: "\xc7",
    Ccirc: "\u0108",
    Cconint: "\u2230",
    Cdot: "\u010A",
    Cedilla: "\xb8",
    CenterDot: "\xb7",
    Cfr: "\u212D",
    Chi: "\u03A7",
    CircleDot: "\u2299",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    Colon: "\u2237",
    Colone: "\u2A74",
    Congruent: "\u2261",
    Conint: "\u222F",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    Coproduct: "\u2210",
    CounterClockwiseContourIntegral: "\u2233",
    Cross: "\u2A2F",
    Cscr: "\uD835\uDC9E",
    Cup: "\u22D3",
    CupCap: "\u224D",
    DD: "\u2145",
    DDotrahd: "\u2911",
    DJcy: "\u0402",
    DScy: "\u0405",
    DZcy: "\u040F",
    Dagger: "\u2021",
    Darr: "\u21A1",
    Dashv: "\u2AE4",
    Dcaron: "\u010E",
    Dcy: "\u0414",
    Del: "\u2207",
    Delta: "\u0394",
    Dfr: "\uD835\uDD07",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: '`',
    DiacriticalTilde: "\u02DC",
    Diamond: "\u22C4",
    DifferentialD: "\u2146",
    Dopf: "\uD835\uDD3B",
    Dot: "\xa8",
    DotDot: "\u20DC",
    DotEqual: "\u2250",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    Downarrow: "\u21D3",
    Dscr: "\uD835\uDC9F",
    Dstrok: "\u0110",
    ENG: "\u014A",
    ETH: "\xd0",
    Eacute: "\xc9",
    Ecaron: "\u011A",
    Ecirc: "\xca",
    Ecy: "\u042D",
    Edot: "\u0116",
    Efr: "\uD835\uDD08",
    Egrave: "\xc8",
    Element: "\u2208",
    Emacr: "\u0112",
    EmptySmallSquare: "\u25FB",
    EmptyVerySmallSquare: "\u25AB",
    Eogon: "\u0118",
    Eopf: "\uD835\uDD3C",
    Epsilon: "\u0395",
    Equal: "\u2A75",
    EqualTilde: "\u2242",
    Equilibrium: "\u21CC",
    Escr: "\u2130",
    Esim: "\u2A73",
    Eta: "\u0397",
    Euml: "\xcb",
    Exists: "\u2203",
    ExponentialE: "\u2147",
    Fcy: "\u0424",
    Ffr: "\uD835\uDD09",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    Fopf: "\uD835\uDD3D",
    ForAll: "\u2200",
    Fouriertrf: "\u2131",
    Fscr: "\u2131",
    GJcy: "\u0403",
    GT: '>',
    Gamma: "\u0393",
    Gammad: "\u03DC",
    Gbreve: "\u011E",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    Gcy: "\u0413",
    Gdot: "\u0120",
    Gfr: "\uD835\uDD0A",
    Gg: "\u22D9",
    Gopf: "\uD835\uDD3E",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    Gt: "\u226B",
    HARDcy: "\u042A",
    Hacek: "\u02C7",
    Hat: '^',
    Hcirc: "\u0124",
    Hfr: "\u210C",
    HilbertSpace: "\u210B",
    Hopf: "\u210D",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    Hstrok: "\u0126",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    IEcy: "\u0415",
    IJlig: "\u0132",
    IOcy: "\u0401",
    Iacute: "\xcd",
    Icirc: "\xce",
    Icy: "\u0418",
    Idot: "\u0130",
    Ifr: "\u2111",
    Igrave: "\xcc",
    Im: "\u2111",
    Imacr: "\u012A",
    ImaginaryI: "\u2148",
    Implies: "\u21D2",
    Int: "\u222C",
    Integral: "\u222B",
    Intersection: "\u22C2",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    Iogon: "\u012E",
    Iopf: "\uD835\uDD40",
    Iota: "\u0399",
    Iscr: "\u2110",
    Itilde: "\u0128",
    Iukcy: "\u0406",
    Iuml: "\xcf",
    Jcirc: "\u0134",
    Jcy: "\u0419",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    Jsercy: "\u0408",
    Jukcy: "\u0404",
    KHcy: "\u0425",
    KJcy: "\u040C",
    Kappa: "\u039A",
    Kcedil: "\u0136",
    Kcy: "\u041A",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    LJcy: "\u0409",
    LT: '<',
    Lacute: "\u0139",
    Lambda: "\u039B",
    Lang: "\u27EA",
    Laplacetrf: "\u2112",
    Larr: "\u219E",
    Lcaron: "\u013D",
    Lcedil: "\u013B",
    Lcy: "\u041B",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    LeftRightArrow: "\u2194",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    Leftarrow: "\u21D0",
    Leftrightarrow: "\u21D4",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    LessLess: "\u2AA1",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    Lfr: "\uD835\uDD0F",
    Ll: "\u22D8",
    Lleftarrow: "\u21DA",
    Lmidot: "\u013F",
    LongLeftArrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    LongRightArrow: "\u27F6",
    Longleftarrow: "\u27F8",
    Longleftrightarrow: "\u27FA",
    Longrightarrow: "\u27F9",
    Lopf: "\uD835\uDD43",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    Lscr: "\u2112",
    Lsh: "\u21B0",
    Lstrok: "\u0141",
    Lt: "\u226A",
    Map: "\u2905",
    Mcy: "\u041C",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    MinusPlus: "\u2213",
    Mopf: "\uD835\uDD44",
    Mscr: "\u2133",
    Mu: "\u039C",
    NJcy: "\u040A",
    Nacute: "\u0143",
    Ncaron: "\u0147",
    Ncedil: "\u0145",
    Ncy: "\u041D",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: '\n',
    Nfr: "\uD835\uDD11",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    Not: "\u2AEC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    Nscr: "\uD835\uDCA9",
    Ntilde: "\xd1",
    Nu: "\u039D",
    OElig: "\u0152",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Ocy: "\u041E",
    Odblac: "\u0150",
    Ofr: "\uD835\uDD12",
    Ograve: "\xd2",
    Omacr: "\u014C",
    Omega: "\u03A9",
    Omicron: "\u039F",
    Oopf: "\uD835\uDD46",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    Or: "\u2A54",
    Oscr: "\uD835\uDCAA",
    Oslash: "\xd8",
    Otilde: "\xd5",
    Otimes: "\u2A37",
    Ouml: "\xd6",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    PartialD: "\u2202",
    Pcy: "\u041F",
    Pfr: "\uD835\uDD13",
    Phi: "\u03A6",
    Pi: "\u03A0",
    PlusMinus: "\xb1",
    Poincareplane: "\u210C",
    Popf: "\u2119",
    Pr: "\u2ABB",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    Prime: "\u2033",
    Product: "\u220F",
    Proportion: "\u2237",
    Proportional: "\u221D",
    Pscr: "\uD835\uDCAB",
    Psi: "\u03A8",
    QUOT: '"',
    Qfr: "\uD835\uDD14",
    Qopf: "\u211A",
    Qscr: "\uD835\uDCAC",
    RBarr: "\u2910",
    REG: "\xae",
    Racute: "\u0154",
    Rang: "\u27EB",
    Rarr: "\u21A0",
    Rarrtl: "\u2916",
    Rcaron: "\u0158",
    Rcedil: "\u0156",
    Rcy: "\u0420",
    Re: "\u211C",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    Rfr: "\u211C",
    Rho: "\u03A1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    Rightarrow: "\u21D2",
    Ropf: "\u211D",
    RoundImplies: "\u2970",
    Rrightarrow: "\u21DB",
    Rscr: "\u211B",
    Rsh: "\u21B1",
    RuleDelayed: "\u29F4",
    SHCHcy: "\u0429",
    SHcy: "\u0428",
    SOFTcy: "\u042C",
    Sacute: "\u015A",
    Sc: "\u2ABC",
    Scaron: "\u0160",
    Scedil: "\u015E",
    Scirc: "\u015C",
    Scy: "\u0421",
    Sfr: "\uD835\uDD16",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    Sigma: "\u03A3",
    SmallCircle: "\u2218",
    Sopf: "\uD835\uDD4A",
    Sqrt: "\u221A",
    Square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    Sscr: "\uD835\uDCAE",
    Star: "\u22C6",
    Sub: "\u22D0",
    Subset: "\u22D0",
    SubsetEqual: "\u2286",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    Sup: "\u22D1",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    Supset: "\u22D1",
    THORN: "\xde",
    TRADE: "\u2122",
    TSHcy: "\u040B",
    TScy: "\u0426",
    Tab: '\t',
    Tau: "\u03A4",
    Tcaron: "\u0164",
    Tcedil: "\u0162",
    Tcy: "\u0422",
    Tfr: "\uD835\uDD17",
    Therefore: "\u2234",
    Theta: "\u0398",
    ThickSpace: "\u205F\u200A",
    ThinSpace: "\u2009",
    Tilde: "\u223C",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    Topf: "\uD835\uDD4B",
    TripleDot: "\u20DB",
    Tscr: "\uD835\uDCAF",
    Tstrok: "\u0166",
    Uacute: "\xda",
    Uarr: "\u219F",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    Ubreve: "\u016C",
    Ucirc: "\xdb",
    Ucy: "\u0423",
    Udblac: "\u0170",
    Ufr: "\uD835\uDD18",
    Ugrave: "\xd9",
    Umacr: "\u016A",
    UnderBar: '_',
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    Uopf: "\uD835\uDD4C",
    UpArrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    UpEquilibrium: "\u296E",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    Uparrow: "\u21D1",
    Updownarrow: "\u21D5",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    Upsilon: "\u03A5",
    Uring: "\u016E",
    Uscr: "\uD835\uDCB0",
    Utilde: "\u0168",
    Uuml: "\xdc",
    VDash: "\u22AB",
    Vbar: "\u2AEB",
    Vcy: "\u0412",
    Vdash: "\u22A9",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    Verbar: "\u2016",
    Vert: "\u2016",
    VerticalBar: "\u2223",
    VerticalLine: '|',
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    Vvdash: "\u22AA",
    Wcirc: "\u0174",
    Wedge: "\u22C0",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    Xfr: "\uD835\uDD1B",
    Xi: "\u039E",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    YAcy: "\u042F",
    YIcy: "\u0407",
    YUcy: "\u042E",
    Yacute: "\xdd",
    Ycirc: "\u0176",
    Ycy: "\u042B",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    Yuml: "\u0178",
    ZHcy: "\u0416",
    Zacute: "\u0179",
    Zcaron: "\u017D",
    Zcy: "\u0417",
    Zdot: "\u017B",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    Zfr: "\u2128",
    Zopf: "\u2124",
    Zscr: "\uD835\uDCB5",
    aacute: "\xe1",
    abreve: "\u0103",
    ac: "\u223E",
    acE: "\u223E\u0333",
    acd: "\u223F",
    acirc: "\xe2",
    acute: "\xb4",
    acy: "\u0430",
    aelig: "\xe6",
    af: "\u2061",
    afr: "\uD835\uDD1E",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    alpha: "\u03B1",
    amacr: "\u0101",
    amalg: "\u2A3F",
    amp: '&',
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    aogon: "\u0105",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apE: "\u2A70",
    apacir: "\u2A6F",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    approx: "\u2248",
    approxeq: "\u224A",
    aring: "\xe5",
    ascr: "\uD835\uDCB6",
    ast: '*',
    asymp: "\u2248",
    asympeq: "\u224D",
    atilde: "\xe3",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    bNot: "\u2AED",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    barvee: "\u22BD",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bnot: "\u2310",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxDL: "\u2557",
    boxDR: "\u2554",
    boxDl: "\u2556",
    boxDr: "\u2553",
    boxH: "\u2550",
    boxHD: "\u2566",
    boxHU: "\u2569",
    boxHd: "\u2564",
    boxHu: "\u2567",
    boxUL: "\u255D",
    boxUR: "\u255A",
    boxUl: "\u255C",
    boxUr: "\u2559",
    boxV: "\u2551",
    boxVH: "\u256C",
    boxVL: "\u2563",
    boxVR: "\u2560",
    boxVh: "\u256B",
    boxVl: "\u2562",
    boxVr: "\u255F",
    boxbox: "\u29C9",
    boxdL: "\u2555",
    boxdR: "\u2552",
    boxdl: "\u2510",
    boxdr: "\u250C",
    boxh: "\u2500",
    boxhD: "\u2565",
    boxhU: "\u2568",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxuL: "\u255B",
    boxuR: "\u2558",
    boxul: "\u2518",
    boxur: "\u2514",
    boxv: "\u2502",
    boxvH: "\u256A",
    boxvL: "\u2561",
    boxvR: "\u255E",
    boxvh: "\u253C",
    boxvl: "\u2524",
    boxvr: "\u251C",
    bprime: "\u2035",
    breve: "\u02D8",
    brvbar: "\xa6",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: '\\',
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    cacute: "\u0107",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    ccaps: "\u2A4D",
    ccaron: "\u010D",
    ccedil: "\xe7",
    ccirc: "\u0109",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    cdot: "\u010B",
    cedil: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    centerdot: "\xb7",
    cfr: "\uD835\uDD20",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    chi: "\u03C7",
    cir: "\u25CB",
    cirE: "\u29C3",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledR: "\xae",
    circledS: "\u24C8",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    clubs: "\u2663",
    clubsuit: "\u2663",
    colon: ':',
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ',',
    commat: '@',
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    conint: "\u222E",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    copy: "\xa9",
    copysr: "\u2117",
    crarr: "\u21B5",
    cross: "\u2717",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    dArr: "\u21D3",
    dHar: "\u2965",
    dagger: "\u2020",
    daleth: "\u2138",
    darr: "\u2193",
    dash: "\u2010",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    dcaron: "\u010F",
    dcy: "\u0434",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    ddotseq: "\u2A77",
    deg: "\xb0",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    dfr: "\uD835\uDD21",
    dharl: "\u21C3",
    dharr: "\u21C2",
    diam: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: '$',
    dopf: "\uD835\uDD55",
    dot: "\u02D9",
    doteq: "\u2250",
    doteqdot: "\u2251",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    downarrow: "\u2193",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    dscr: "\uD835\uDCB9",
    dscy: "\u0455",
    dsol: "\u29F6",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    eDDot: "\u2A77",
    eDot: "\u2251",
    eacute: "\xe9",
    easter: "\u2A6E",
    ecaron: "\u011B",
    ecir: "\u2256",
    ecirc: "\xea",
    ecolon: "\u2255",
    ecy: "\u044D",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    emsp13: "\u2004",
    emsp14: "\u2005",
    emsp: "\u2003",
    eng: "\u014B",
    ensp: "\u2002",
    eogon: "\u0119",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    equals: '=',
    equest: "\u225F",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erDot: "\u2253",
    erarr: "\u2971",
    escr: "\u212F",
    esdot: "\u2250",
    esim: "\u2242",
    eta: "\u03B7",
    eth: "\xf0",
    euml: "\xeb",
    euro: "\u20AC",
    excl: '!',
    exist: "\u2203",
    expectation: "\u2130",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    fjlig: 'fj',
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    fopf: "\uD835\uDD57",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    fscr: "\uD835\uDCBB",
    gE: "\u2267",
    gEl: "\u2A8C",
    gacute: "\u01F5",
    gamma: "\u03B3",
    gammad: "\u03DD",
    gap: "\u2A86",
    gbreve: "\u011F",
    gcirc: "\u011D",
    gcy: "\u0433",
    gdot: "\u0121",
    ge: "\u2265",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    gfr: "\uD835\uDD24",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    gjcy: "\u0453",
    gl: "\u2277",
    glE: "\u2A92",
    gla: "\u2AA5",
    glj: "\u2AA4",
    gnE: "\u2269",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    gopf: "\uD835\uDD58",
    grave: '`',
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    gt: '>',
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    hArr: "\u21D4",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    hardcy: "\u044A",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    hbar: "\u210F",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    hfr: "\uD835\uDD25",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    hstrok: "\u0127",
    hybull: "\u2043",
    hyphen: "\u2010",
    iacute: "\xed",
    ic: "\u2063",
    icirc: "\xee",
    icy: "\u0438",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    ifr: "\uD835\uDD26",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    ijlig: "\u0133",
    imacr: "\u012B",
    image: "\u2111",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    intercal: "\u22BA",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    iocy: "\u0451",
    iogon: "\u012F",
    iopf: "\uD835\uDD5A",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isinE: "\u22F9",
    isindot: "\u22F5",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    itilde: "\u0129",
    iukcy: "\u0456",
    iuml: "\xef",
    jcirc: "\u0135",
    jcy: "\u0439",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    jsercy: "\u0458",
    jukcy: "\u0454",
    kappa: "\u03BA",
    kappav: "\u03F0",
    kcedil: "\u0137",
    kcy: "\u043A",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    khcy: "\u0445",
    kjcy: "\u045C",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    lArr: "\u21D0",
    lAtail: "\u291B",
    lBarr: "\u290E",
    lE: "\u2266",
    lEg: "\u2A8B",
    lHar: "\u2962",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    lambda: "\u03BB",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    laquo: "\xab",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: '{',
    lbrack: '[',
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    lcaron: "\u013E",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: '{',
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    le: "\u2264",
    leftarrow: "\u2190",
    leftarrowtail: "\u21A2",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    leftthreetimes: "\u22CB",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    lessgtr: "\u2276",
    lesssim: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    ljcy: "\u0459",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    llhard: "\u296B",
    lltri: "\u25FA",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnE: "\u2268",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    longleftarrow: "\u27F5",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: '_',
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: '(',
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    lscr: "\uD835\uDCC1",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: '[',
    lsquo: "\u2018",
    lsquor: "\u201A",
    lstrok: "\u0142",
    lt: '<',
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltrPar: "\u2996",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    mDDot: "\u223A",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    mcy: "\u043C",
    mdash: "\u2014",
    measuredangle: "\u2221",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: '*',
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nGg: "\u22D9\u0338",
    nGt: "\u226B\u20D2",
    nGtv: "\u226B\u0338",
    nLeftarrow: "\u21CD",
    nLeftrightarrow: "\u21CE",
    nLl: "\u22D8\u0338",
    nLt: "\u226A\u20D2",
    nLtv: "\u226A\u0338",
    nRightarrow: "\u21CF",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nabla: "\u2207",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    ncaron: "\u0148",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    neArr: "\u21D7",
    nearhk: "\u2924",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    nexist: "\u2204",
    nexists: "\u2204",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    ngsim: "\u2275",
    ngt: "\u226F",
    ngtr: "\u226F",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlE: "\u2266\u0338",
    nlarr: "\u219A",
    nldr: "\u2025",
    nle: "\u2270",
    nleftarrow: "\u219A",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nlsim: "\u2274",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nmid: "\u2224",
    nopf: "\uD835\uDD5F",
    not: "\xac",
    notin: "\u2209",
    notinE: "\u22F9\u0338",
    notindot: "\u22F5\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    nu: "\u03BD",
    num: '#',
    numero: "\u2116",
    numsp: "\u2007",
    nvDash: "\u22AD",
    nvHarr: "\u2904",
    nvap: "\u224D\u20D2",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwArr: "\u21D6",
    nwarhk: "\u2923",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    oS: "\u24C8",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    ocirc: "\xf4",
    ocy: "\u043E",
    odash: "\u229D",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    oelig: "\u0153",
    ofcir: "\u29BF",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    omacr: "\u014D",
    omega: "\u03C9",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    operp: "\u29B9",
    oplus: "\u2295",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oscr: "\u2134",
    oslash: "\xf8",
    osol: "\u2298",
    otilde: "\xf5",
    otimes: "\u2297",
    otimesas: "\u2A36",
    ouml: "\xf6",
    ovbar: "\u233D",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    pcy: "\u043F",
    percnt: '%',
    period: '.',
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    pfr: "\uD835\uDD2D",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: '+',
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    pointint: "\u2A15",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    pr: "\u227A",
    prE: "\u2AB3",
    prap: "\u2AB7",
    prcue: "\u227C",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    prime: "\u2032",
    primes: "\u2119",
    prnE: "\u2AB5",
    prnap: "\u2AB9",
    prnsim: "\u22E8",
    prod: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    pscr: "\uD835\uDCC5",
    psi: "\u03C8",
    puncsp: "\u2008",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: '?',
    questeq: "\u225F",
    quot: '"',
    rAarr: "\u21DB",
    rArr: "\u21D2",
    rAtail: "\u291C",
    rBarr: "\u290F",
    rHar: "\u2964",
    race: "\u223D\u0331",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: '}',
    rbrack: ']',
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    rcaron: "\u0159",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: '}',
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    reg: "\xae",
    rfisht: "\u297D",
    rfloor: "\u230B",
    rfr: "\uD835\uDD2F",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    rho: "\u03C1",
    rhov: "\u03F1",
    rightarrow: "\u2192",
    rightarrowtail: "\u21A3",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    rightthreetimes: "\u22CC",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    rpar: ')',
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    rsaquo: "\u203A",
    rscr: "\uD835\uDCC7",
    rsh: "\u21B1",
    rsqb: ']',
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    ruluhar: "\u2968",
    rx: "\u211E",
    sacute: "\u015B",
    sbquo: "\u201A",
    sc: "\u227B",
    scE: "\u2AB4",
    scap: "\u2AB8",
    scaron: "\u0161",
    sccue: "\u227D",
    sce: "\u2AB0",
    scedil: "\u015F",
    scirc: "\u015D",
    scnE: "\u2AB6",
    scnap: "\u2ABA",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    seArr: "\u21D8",
    searhk: "\u2925",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ';',
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    shchcy: "\u0449",
    shcy: "\u0448",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    shy: "\xad",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    softcy: "\u044C",
    sol: '/',
    solb: "\u29C4",
    solbar: "\u233F",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    square: "\u25A1",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    sub: "\u2282",
    subE: "\u2AC5",
    subdot: "\u2ABD",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    sum: "\u2211",
    sung: "\u266A",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    sup: "\u2283",
    supE: "\u2AC6",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supe: "\u2287",
    supedot: "\u2AC4",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swArr: "\u21D9",
    swarhk: "\u2926",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    target: "\u2316",
    tau: "\u03C4",
    tbrk: "\u23B4",
    tcaron: "\u0165",
    tcedil: "\u0163",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    therefore: "\u2234",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    thinsp: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    thorn: "\xfe",
    tilde: "\u02DC",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    tscr: "\uD835\uDCC9",
    tscy: "\u0446",
    tshcy: "\u045B",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    uArr: "\u21D1",
    uHar: "\u2963",
    uacute: "\xfa",
    uarr: "\u2191",
    ubrcy: "\u045E",
    ubreve: "\u016D",
    ucirc: "\xfb",
    ucy: "\u0443",
    udarr: "\u21C5",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    ufr: "\uD835\uDD32",
    ugrave: "\xf9",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    umacr: "\u016B",
    uml: "\xa8",
    uogon: "\u0173",
    uopf: "\uD835\uDD66",
    uparrow: "\u2191",
    updownarrow: "\u2195",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    upsi: "\u03C5",
    upsih: "\u03D2",
    upsilon: "\u03C5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    uring: "\u016F",
    urtri: "\u25F9",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vArr: "\u21D5",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    vDash: "\u22A8",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    vcy: "\u0432",
    vdash: "\u22A2",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    verbar: '|',
    vert: '|',
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    vzigzag: "\u299A",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    yacute: "\xfd",
    yacy: "\u044F",
    ycirc: "\u0177",
    ycy: "\u044B",
    yen: "\xa5",
    yfr: "\uD835\uDD36",
    yicy: "\u0457",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    yucy: "\u044E",
    yuml: "\xff",
    zacute: "\u017A",
    zcaron: "\u017E",
    zcy: "\u0437",
    zdot: "\u017C",
    zeetrf: "\u2128",
    zeta: "\u03B6",
    zfr: "\uD835\uDD37",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
};


// To do: next major: use `Object.hasOwn`.
const $c4cf43c53fa7590e$var$own = {}.hasOwnProperty;
function $c4cf43c53fa7590e$export$289b6a6320f709b4(value) {
    return $c4cf43c53fa7590e$var$own.call((0, $86deb4e981e5b737$export$ec810d1aafce79a7), value) ? (0, $86deb4e981e5b737$export$ec810d1aafce79a7)[value] : false;
}



const $1119df316abd1f2f$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $1119df316abd1f2f$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1119df316abd1f2f$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('characterReference');
        effects.enter('characterReferenceMarker');
        effects.consume(code);
        effects.exit('characterReferenceMarker');
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter('characterReferenceMarkerNumeric');
            effects.consume(code);
            effects.exit('characterReferenceMarkerNumeric');
            return numeric;
        }
        effects.enter('characterReferenceValue');
        max = 31;
        test = (0, $c57804f696751fc2$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter('characterReferenceMarkerHexadecimal');
            effects.consume(code);
            effects.exit('characterReferenceMarkerHexadecimal');
            effects.enter('characterReferenceValue');
            max = 6;
            test = (0, $c57804f696751fc2$export$eca2752363989806);
            return value;
        }
        effects.enter('characterReferenceValue');
        max = 7;
        test = (0, $c57804f696751fc2$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit('characterReferenceValue');
            if (test === (0, $c57804f696751fc2$export$75c76db11865a9f4) && !(0, $c4cf43c53fa7590e$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter('characterReferenceMarker');
            effects.consume(code);
            effects.exit('characterReferenceMarker');
            effects.exit('characterReference');
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/** @type {Construct} */ const $f9ac66d9e6a830f7$var$nonLazyContinuation = {
    tokenize: $f9ac66d9e6a830f7$var$tokenizeNonLazyContinuation,
    partial: true
};
const $f9ac66d9e6a830f7$export$c23e4921f8d87e7c = {
    name: 'codeFenced',
    tokenize: $f9ac66d9e6a830f7$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f9ac66d9e6a830f7$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === 'linePrefix' ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter('codeFenced');
        effects.enter('codeFencedFence');
        effects.enter('codeFencedFenceSequence');
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit('codeFencedFenceSequence');
        return (0, $c57804f696751fc2$export$2c6cf65c1127992a)(code) ? (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, infoBefore, 'whitespace')(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.exit('codeFencedFence');
            return self.interrupt ? ok(code) : effects.check($f9ac66d9e6a830f7$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter('codeFencedFenceInfo');
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceInfo');
            return infoBefore(code);
        }
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceInfo');
            return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, metaBefore, 'whitespace')(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter('codeFencedFenceMeta');
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceMeta');
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $c57804f696751fc2$export$2c6cf65c1127992a)(code) ? (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, beforeContentChunk, 'linePrefix', initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) return effects.check($f9ac66d9e6a830f7$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter('codeFlowValue');
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.exit('codeFlowValue');
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit('codeFenced');
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter('codeFencedFence');
            return (0, $c57804f696751fc2$export$2c6cf65c1127992a)(code) ? (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, 'linePrefix', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter('codeFencedFenceSequence');
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit('codeFencedFenceSequence');
                return (0, $c57804f696751fc2$export$2c6cf65c1127992a)(code) ? (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, 'whitespace')(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
                effects.exit('codeFencedFence');
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f9ac66d9e6a830f7$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $70a9a42a12e1ec4d$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $70a9a42a12e1ec4d$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $70a9a42a12e1ec4d$var$furtherStart = {
    tokenize: $70a9a42a12e1ec4d$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $70a9a42a12e1ec4d$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter('codeIndented');
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, afterPrefix, 'linePrefix', 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'linePrefix' && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) return effects.attempt($70a9a42a12e1ec4d$var$furtherStart, atBreak, after)(code);
        effects.enter('codeFlowValue');
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.exit('codeFlowValue');
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit('codeIndented');
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $70a9a42a12e1ec4d$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, afterPrefix, 'linePrefix', 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'linePrefix' && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $c57804f696751fc2$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $f37c15dc6a0ce1a2$export$d24f93e715f9df88 = {
    name: 'codeText',
    tokenize: $f37c15dc6a0ce1a2$var$tokenizeCodeText,
    resolve: $f37c15dc6a0ce1a2$var$resolveCodeText,
    previous: $f37c15dc6a0ce1a2$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $f37c15dc6a0ce1a2$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === 'lineEnding' || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === 'lineEnding' || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === 'codeTextData') {
            // Then we have padding.
            events[headEnterIndex][1].type = 'codeTextPadding';
            events[tailExitIndex][1].type = 'codeTextPadding';
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== 'lineEnding') enter = index;
        } else if (index === tailExitIndex || events[index][1].type === 'lineEnding') {
            events[enter][1].type = 'codeTextData';
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $f37c15dc6a0ce1a2$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === 'characterEscape';
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f37c15dc6a0ce1a2$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('codeText');
        effects.enter('codeTextSequence');
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit('codeTextSequence');
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter('codeTextSequence');
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return between;
        }
        // Data.
        effects.enter('codeTextData');
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.exit('codeTextData');
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit('codeTextSequence');
            effects.exit('codeText');
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = 'codeTextData';
        return data(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $12938b3814a22af8$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $c57804f696751fc2$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit('chunkString');
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $c57804f696751fc2$export$a30284361b3814b7)(code))) {
            effects.exit('chunkString');
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $c57804f696751fc2$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $23d50e265094c933$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return atBreak;
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit('chunkString');
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $c57804f696751fc2$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 

function $5506e63dc01722f2$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, atBreak, 'linePrefix');
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.exit('chunkString');
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 

function $5fd1687b9ea7ecac$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            seen = true;
            return start;
        }
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, start, seen ? 'linePrefix' : 'lineSuffix')(code);
        return ok(code);
    }
}



/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $20c2d7c009b57867$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, ' ')// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


const $e6d899c4a34d178e$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $e6d899c4a34d178e$var$tokenizeDefinition
};
/** @type {Construct} */ const $e6d899c4a34d178e$var$titleBefore = {
    tokenize: $e6d899c4a34d178e$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e6d899c4a34d178e$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter('definition');
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $23d50e265094c933$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, 'definitionLabel', 'definitionLabelMarker', 'definitionLabelString')(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $20c2d7c009b57867$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter('definitionMarker');
            effects.consume(code);
            effects.exit('definitionMarker');
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $c57804f696751fc2$export$a30284361b3814b7)(code) ? (0, $5fd1687b9ea7ecac$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $12938b3814a22af8$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, 'definitionDestination', 'definitionDestinationLiteral', 'definitionDestinationLiteralMarker', 'definitionDestinationRaw', 'definitionDestinationString')(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($e6d899c4a34d178e$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $c57804f696751fc2$export$2c6cf65c1127992a)(code) ? (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, afterWhitespace, 'whitespace')(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.exit('definition');
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e6d899c4a34d178e$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $c57804f696751fc2$export$a30284361b3814b7)(code) ? (0, $5fd1687b9ea7ecac$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $5506e63dc01722f2$export$f970569cc855e483)(effects, titleAfter, nok, 'definitionTitle', 'definitionTitleMarker', 'definitionTitleString')(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $c57804f696751fc2$export$2c6cf65c1127992a)(code) ? (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, 'whitespace')(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $11c0421216a6e3c9$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $11c0421216a6e3c9$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $11c0421216a6e3c9$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('hardBreakEscape');
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.exit('hardBreakEscape');
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $07f1caa235975e98$export$3871e9deb360695c = {
    name: 'headingAtx',
    tokenize: $07f1caa235975e98$var$tokenizeHeadingAtx,
    resolve: $07f1caa235975e98$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $07f1caa235975e98$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === 'whitespace') contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === 'whitespace') contentEnd -= 2;
    if (events[contentEnd][1].type === 'atxHeadingSequence' && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === 'whitespace')) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: 'atxHeadingText',
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: 'chunkText',
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: 'text'
        };
        (0, $ac97a6279504a515$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $07f1caa235975e98$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter('atxHeading');
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter('atxHeadingSequence');
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $c57804f696751fc2$export$a30284361b3814b7)(code)) {
            effects.exit('atxHeadingSequence');
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter('atxHeadingSequence');
            return sequenceFurther(code);
        }
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.exit('atxHeading');
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, atBreak, 'whitespace')(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter('atxHeadingText');
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit('atxHeadingSequence');
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $c57804f696751fc2$export$a30284361b3814b7)(code)) {
            effects.exit('atxHeadingText');
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $9100c3e5cc21b821$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $9100c3e5cc21b821$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



const $5a226bd9b2f3be78$export$476ac411cb7d0d8f = {
    name: 'htmlFlow',
    tokenize: $5a226bd9b2f3be78$var$tokenizeHtmlFlow,
    resolveTo: $5a226bd9b2f3be78$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $5a226bd9b2f3be78$var$blankLineBefore = {
    tokenize: $5a226bd9b2f3be78$var$tokenizeBlankLineBefore,
    partial: true
};
const $5a226bd9b2f3be78$var$nonLazyContinuationStart = {
    tokenize: $5a226bd9b2f3be78$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $5a226bd9b2f3be78$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === 'htmlFlow') break;
    }
    if (index > 1 && events[index - 2][1].type === 'linePrefix') {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5a226bd9b2f3be78$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter('htmlFlow');
        effects.enter('htmlFlowData');
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $c57804f696751fc2$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $c57804f696751fc2$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = 'CDATA[';
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $c57804f696751fc2$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $c57804f696751fc2$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $9100c3e5cc21b821$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $9100c3e5cc21b821$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $c57804f696751fc2$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $c57804f696751fc2$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $c57804f696751fc2$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $c57804f696751fc2$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit('htmlFlowData');
            return effects.check($5a226bd9b2f3be78$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.exit('htmlFlowData');
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($5a226bd9b2f3be78$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter('htmlFlowData');
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $9100c3e5cc21b821$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $c57804f696751fc2$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.exit('htmlFlowData');
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit('htmlFlow');
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5a226bd9b2f3be78$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5a226bd9b2f3be78$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return effects.attempt((0, $1a5909f288baadcb$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $c28bb05649964197$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $c28bb05649964197$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c28bb05649964197$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('htmlText');
        effects.enter('htmlTextData');
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $c57804f696751fc2$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $c57804f696751fc2$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = 'CDATA[';
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $c57804f696751fc2$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $c57804f696751fc2$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $c57804f696751fc2$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $c57804f696751fc2$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $c57804f696751fc2$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $c57804f696751fc2$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $c57804f696751fc2$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $c57804f696751fc2$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit('htmlTextData');
            effects.exit('htmlText');
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit('htmlTextData');
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $c57804f696751fc2$export$2c6cf65c1127992a)(code) ? (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, 'linePrefix', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter('htmlTextData');
        return returnState(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 







const $93faafe0cb626adb$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    tokenize: $93faafe0cb626adb$var$tokenizeLabelEnd,
    resolveTo: $93faafe0cb626adb$var$resolveToLabelEnd,
    resolveAll: $93faafe0cb626adb$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $93faafe0cb626adb$var$resourceConstruct = {
    tokenize: $93faafe0cb626adb$var$tokenizeResource
};
/** @type {Construct} */ const $93faafe0cb626adb$var$referenceFullConstruct = {
    tokenize: $93faafe0cb626adb$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $93faafe0cb626adb$var$referenceCollapsedConstruct = {
    tokenize: $93faafe0cb626adb$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $93faafe0cb626adb$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === 'labelImage' || token.type === 'labelLink' || token.type === 'labelEnd') {
            // Remove the marker.
            events.splice(index + 1, token.type === 'labelImage' ? 4 : 2);
            token.type = 'data';
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $93faafe0cb626adb$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === 'link' || token.type === 'labelLink' && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === 'labelLink') token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === 'labelImage' || token.type === 'labelLink') && !token._balanced) {
                open = index;
                if (token.type !== 'labelLink') {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === 'labelEnd') close = index;
    }
    const group = {
        type: events[open][1].type === 'labelLink' ? 'link' : 'image',
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: 'label',
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: 'labelText',
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $ac97a6279504a515$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $ac97a6279504a515$export$4cbf152802aa238)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $ac97a6279504a515$export$4cbf152802aa238)(media, (0, $3e9231666da4ce68$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $ac97a6279504a515$export$4cbf152802aa238)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $ac97a6279504a515$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $ac97a6279504a515$export$4cbf152802aa238)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $ac97a6279504a515$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $93faafe0cb626adb$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === 'labelImage' || self.events[index][1].type === 'labelLink') && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $20c2d7c009b57867$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter('labelEnd');
        effects.enter('labelMarker');
        effects.consume(code);
        effects.exit('labelMarker');
        effects.exit('labelEnd');
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($93faafe0cb626adb$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($93faafe0cb626adb$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($93faafe0cb626adb$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $93faafe0cb626adb$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter('resource');
        effects.enter('resourceMarker');
        effects.consume(code);
        effects.exit('resourceMarker');
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $c57804f696751fc2$export$a30284361b3814b7)(code) ? (0, $5fd1687b9ea7ecac$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $12938b3814a22af8$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, 'resourceDestination', 'resourceDestinationLiteral', 'resourceDestinationLiteralMarker', 'resourceDestinationRaw', 'resourceDestinationString', 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $c57804f696751fc2$export$a30284361b3814b7)(code) ? (0, $5fd1687b9ea7ecac$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $5506e63dc01722f2$export$f970569cc855e483)(effects, resourceTitleAfter, nok, 'resourceTitle', 'resourceTitleMarker', 'resourceTitleString')(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $c57804f696751fc2$export$a30284361b3814b7)(code) ? (0, $5fd1687b9ea7ecac$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter('resourceMarker');
            effects.consume(code);
            effects.exit('resourceMarker');
            effects.exit('resource');
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $93faafe0cb626adb$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $23d50e265094c933$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, 'reference', 'referenceMarker', 'referenceString')(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $20c2d7c009b57867$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $93faafe0cb626adb$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter('reference');
        effects.enter('referenceMarker');
        effects.consume(code);
        effects.exit('referenceMarker');
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter('referenceMarker');
            effects.consume(code);
            effects.exit('referenceMarker');
            effects.exit('reference');
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $92f04395fc34eee3$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    tokenize: $92f04395fc34eee3$var$tokenizeLabelStartImage,
    resolveAll: (0, $93faafe0cb626adb$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $92f04395fc34eee3$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('labelImage');
        effects.enter('labelImageMarker');
        effects.consume(code);
        effects.exit('labelImageMarker');
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter('labelMarker');
            effects.consume(code);
            effects.exit('labelMarker');
            effects.exit('labelImage');
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $10c3205fb5b886b7$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    tokenize: $10c3205fb5b886b7$var$tokenizeLabelStartLink,
    resolveAll: (0, $93faafe0cb626adb$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $10c3205fb5b886b7$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('labelLink');
        effects.enter('labelMarker');
        effects.consume(code);
        effects.exit('labelMarker');
        effects.exit('labelLink');
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $f779e2b3f84abc74$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $f779e2b3f84abc74$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f779e2b3f84abc74$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, ok, 'linePrefix');
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $b718ea4249d3ab32$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $b718ea4249d3ab32$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b718ea4249d3ab32$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('thematicBreak');
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter('thematicBreakSequence');
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code))) {
            effects.exit('thematicBreak');
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit('thematicBreakSequence');
        return (0, $c57804f696751fc2$export$2c6cf65c1127992a)(code) ? (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, atBreak, 'whitespace')(code) : atBreak(code);
    }
}


const $ba54131d455160a8$export$8837f4fc672e936d = {
    name: 'list',
    tokenize: $ba54131d455160a8$var$tokenizeListStart,
    continuation: {
        tokenize: $ba54131d455160a8$var$tokenizeListContinuation
    },
    exit: $ba54131d455160a8$var$tokenizeListEnd
};
/** @type {Construct} */ const $ba54131d455160a8$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $ba54131d455160a8$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $ba54131d455160a8$var$indentConstruct = {
    tokenize: $ba54131d455160a8$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $ba54131d455160a8$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === 'linePrefix' ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? 'listUnordered' : 'listOrdered');
        if (kind === 'listUnordered' ? !self.containerState.marker || code === self.containerState.marker : (0, $c57804f696751fc2$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === 'listUnordered') {
                effects.enter('listItemPrefix');
                return code === 42 || code === 45 ? effects.check((0, $b718ea4249d3ab32$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter('listItemPrefix');
                effects.enter('listItemValue');
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $c57804f696751fc2$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit('listItemValue');
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter('listItemMarker');
        effects.consume(code);
        effects.exit('listItemMarker');
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $1a5909f288baadcb$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($ba54131d455160a8$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) {
            effects.enter('listItemPrefixWhitespace');
            effects.consume(code);
            effects.exit('listItemPrefixWhitespace');
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit('listItemPrefix'), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $ba54131d455160a8$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $1a5909f288baadcb$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, ok, 'listItemIndent', self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $c57804f696751fc2$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($ba54131d455160a8$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, effects.attempt($ba54131d455160a8$export$8837f4fc672e936d, ok, nok), 'linePrefix', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $ba54131d455160a8$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, afterPrefix, 'listItemIndent', self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'listItemIndent' && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $ba54131d455160a8$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $ba54131d455160a8$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, afterPrefix, 'listItemPrefixWhitespace', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $c57804f696751fc2$export$2c6cf65c1127992a)(code) && tail && tail[1].type === 'listItemPrefixWhitespace' ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $0d9035e1471bdf50$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    tokenize: $0d9035e1471bdf50$var$tokenizeSetextUnderline,
    resolveTo: $0d9035e1471bdf50$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $0d9035e1471bdf50$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === 'content') {
            content = index;
            break;
        }
        if (events[index][1].type === 'paragraph') text = index;
    } else {
        if (events[index][1].type === 'content') // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === 'definition') definition = index;
    }
    const heading = {
        type: 'setextHeading',
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = 'setextHeadingText';
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0d9035e1471bdf50$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== 'lineEnding' && self.events[index][1].type !== 'linePrefix' && self.events[index][1].type !== 'content') {
            paragraph = self.events[index][1].type === 'paragraph';
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter('setextHeadingLine');
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter('setextHeadingLineSequence');
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit('setextHeadingLineSequence');
        return (0, $c57804f696751fc2$export$2c6cf65c1127992a)(code) ? (0, $52a224b996a2386a$export$ae105c1eb063a0a2)(effects, after, 'lineSuffix')(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $c57804f696751fc2$export$34a1dff1c0936953)(code)) {
            effects.exit('setextHeadingLine');
            return ok(code);
        }
        return nok(code);
    }
}



const $2f26f8159466612b$export$5a7bfc01df82fcd1 = {
    [42]: (0, $ba54131d455160a8$export$8837f4fc672e936d),
    [43]: (0, $ba54131d455160a8$export$8837f4fc672e936d),
    [45]: (0, $ba54131d455160a8$export$8837f4fc672e936d),
    [48]: (0, $ba54131d455160a8$export$8837f4fc672e936d),
    [49]: (0, $ba54131d455160a8$export$8837f4fc672e936d),
    [50]: (0, $ba54131d455160a8$export$8837f4fc672e936d),
    [51]: (0, $ba54131d455160a8$export$8837f4fc672e936d),
    [52]: (0, $ba54131d455160a8$export$8837f4fc672e936d),
    [53]: (0, $ba54131d455160a8$export$8837f4fc672e936d),
    [54]: (0, $ba54131d455160a8$export$8837f4fc672e936d),
    [55]: (0, $ba54131d455160a8$export$8837f4fc672e936d),
    [56]: (0, $ba54131d455160a8$export$8837f4fc672e936d),
    [57]: (0, $ba54131d455160a8$export$8837f4fc672e936d),
    [62]: (0, $528c98595af69f6b$export$200dcd0a5903c968)
};
const $2f26f8159466612b$export$5a2181fb44b58173 = {
    [91]: (0, $e6d899c4a34d178e$export$69f215ed977cdb73)
};
const $2f26f8159466612b$export$cf8bead395eff824 = {
    [-2]: (0, $70a9a42a12e1ec4d$export$47910b7ab28d1853),
    [-1]: (0, $70a9a42a12e1ec4d$export$47910b7ab28d1853),
    [32]: (0, $70a9a42a12e1ec4d$export$47910b7ab28d1853)
};
const $2f26f8159466612b$export$ccc7b0636abaffc3 = {
    [35]: (0, $07f1caa235975e98$export$3871e9deb360695c),
    [42]: (0, $b718ea4249d3ab32$export$ba7b13e047416c03),
    [45]: [
        (0, $0d9035e1471bdf50$export$e104e2de391dfde9),
        (0, $b718ea4249d3ab32$export$ba7b13e047416c03)
    ],
    [60]: (0, $5a226bd9b2f3be78$export$476ac411cb7d0d8f),
    [61]: (0, $0d9035e1471bdf50$export$e104e2de391dfde9),
    [95]: (0, $b718ea4249d3ab32$export$ba7b13e047416c03),
    [96]: (0, $f9ac66d9e6a830f7$export$c23e4921f8d87e7c),
    [126]: (0, $f9ac66d9e6a830f7$export$c23e4921f8d87e7c)
};
const $2f26f8159466612b$export$22b082955e083ec3 = {
    [38]: (0, $1119df316abd1f2f$export$e31905600aaf3d8e),
    [92]: (0, $8e4a567e298da283$export$2005478564e78d96)
};
const $2f26f8159466612b$export$6f093cfa640b7166 = {
    [-5]: (0, $f779e2b3f84abc74$export$8e62e0ad51c97b2),
    [-4]: (0, $f779e2b3f84abc74$export$8e62e0ad51c97b2),
    [-3]: (0, $f779e2b3f84abc74$export$8e62e0ad51c97b2),
    [33]: (0, $92f04395fc34eee3$export$3d754936e25aa5f5),
    [38]: (0, $1119df316abd1f2f$export$e31905600aaf3d8e),
    [42]: (0, $a404a8e762491e9d$export$45b92471da762af7),
    [60]: [
        (0, $14b5f38afbf58355$export$17ddf85e4c916ad6),
        (0, $c28bb05649964197$export$398af27f284914fe)
    ],
    [91]: (0, $10c3205fb5b886b7$export$5c0cee0701a3b584),
    [92]: [
        (0, $11c0421216a6e3c9$export$86c573ab9e06f418),
        (0, $8e4a567e298da283$export$2005478564e78d96)
    ],
    [93]: (0, $93faafe0cb626adb$export$470a5dafbbf62654),
    [95]: (0, $a404a8e762491e9d$export$45b92471da762af7),
    [96]: (0, $f37c15dc6a0ce1a2$export$d24f93e715f9df88)
};
const $2f26f8159466612b$export$d44f260a3f9b69f5 = {
    null: [
        (0, $a404a8e762491e9d$export$45b92471da762af7),
        (0, $8562b73fc47e9af8$export$50397835cbfdbc24)
    ]
};
const $2f26f8159466612b$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $2f26f8159466612b$export$e20fbacbb41798b = {
    null: []
};


function $0d7511f93876cf28$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $f8f68d028a19c473$export$86a865d89ef3c690)([
        $2f26f8159466612b$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $d858d0c163e49cb9$export$a7db06668cad9adb)),
        document: create((0, $846cdcab270cf160$export$5a7bfc01df82fcd1)),
        flow: create((0, $b88ae1e29e4b3768$export$ccc7b0636abaffc3)),
        string: create((0, $8562b73fc47e9af8$export$22b082955e083ec3)),
        text: create((0, $8562b73fc47e9af8$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $5ac114c979455f19$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $f84357eb47214347$var$search = /[\0\t\n\r]/g;
function $f84357eb47214347$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        // @ts-expect-error `Buffer` does allow an encoding.
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $f84357eb47214347$var$search.lastIndex = startPosition;
            match = $f84357eb47214347$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $19441f0ba87cbc6f$export$bd0e6e1378a871d7(events) {
    while(!(0, $877ff4396a7ae0f2$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $acf207e9e6b35516$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 /* eslint-enable no-bitwise */  || // Out of range
    code > 1114111) return '\uFFFD';
    return String.fromCharCode(code);
}




const $7489229d17108eb2$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $7489229d17108eb2$export$a0fb664af7d0cc44(value) {
    return value.replace($7489229d17108eb2$var$characterEscapeOrReference, $7489229d17108eb2$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $7489229d17108eb2$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $acf207e9e6b35516$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $c4cf43c53fa7590e$export$289b6a6320f709b4)($2) || $0;
}





const $68518aefef467aeb$var$own = {}.hasOwnProperty;
const $68518aefef467aeb$export$d744d789c09bfde6 = /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */ /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */ function(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return $68518aefef467aeb$var$compiler(options)((0, $19441f0ba87cbc6f$export$bd0e6e1378a871d7)((0, $0d7511f93876cf28$export$98e6a39c04603d36)(options).document().write((0, $f84357eb47214347$export$fc37fe19dfda43ee)()(value, encoding, true))));
};
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $68518aefef467aeb$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $68518aefef467aeb$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === 'listOrdered' || events[index][1].type === 'listUnordered') {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($68518aefef467aeb$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $68518aefef467aeb$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $68518aefef467aeb$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $68518aefef467aeb$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            if (event[1].type === 'listUnordered' || event[1].type === 'listOrdered' || event[1].type === 'blockQuote') {
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === 'lineEndingBlank') {
                if (event[0] === 'enter') {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === 'linePrefix' || event[1].type === 'listItemValue' || event[1].type === 'listItemMarker' || event[1].type === 'listItemPrefix' || event[1].type === 'listItemPrefixWhitespace') ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === 'enter' && event[1].type === 'listItemPrefix' || containerBalance === -1 && event[0] === 'exit' && (event[1].type === 'listUnordered' || event[1].type === 'listOrdered')) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === 'lineEnding' || tailEvent[1].type === 'lineEndingBlank') {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = 'lineEndingBlank';
                                listSpread = true;
                            }
                            tailEvent[1].type = 'lineEnding';
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === 'linePrefix' || tailEvent[1].type === 'blockQuotePrefix' || tailEvent[1].type === 'blockQuotePrefixWhitespace' || tailEvent[1].type === 'blockQuoteMarker' || tailEvent[1].type === 'listItemIndent') ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === 'listItemPrefix') {
                    listItem = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    // @ts-expect-error: `listItem` is most definitely defined, TS...
                    events.splice(index, 0, [
                        'enter',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Set data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @param {CompileData[Key]} [value]
   *   New value.
   * @returns {void}
   *   Nothing.
   */ function setData(key, value) {
        data[key] = value;
    }
    /**
   * Get data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @returns {CompileData[Key]}
   *   Value.
   */ function getData(key) {
        return data[key];
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Node} create
   *   Create a node.
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {void}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @template {Node} Kind
   *   Node type.
   * @this {CompileContext}
   *   Context.
   * @param {Kind} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {Kind}
   *   The given node.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
        parent.children.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        // @ts-expect-error: `end` will be patched later.
        node.position = {
            start: $68518aefef467aeb$var$point(token.start)
        };
        return node;
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {Node}
   *   The closed node.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $51e33f0d9892f114$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $68518aefef467aeb$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $68518aefef467aeb$var$point(token.end);
        return node;
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $3c0c412bd3b19d2f$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        setData('expectingFirstListItemValue', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectingFirstListItemValue')) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            setData('expectingFirstListItemValue');
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData('flowCodeInside')) return;
        this.buffer();
        setData('flowCodeInside', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        setData('flowCodeInside');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $20c2d7c009b57867$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('setextHeadingSlurpLineEnding', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        setData('setextHeadingSlurpLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        let tail = node.children[node.children.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            // @ts-expect-error: we’ll add `end` later.
            tail.position = {
                start: $68518aefef467aeb$var$point(token.start)
            };
            // @ts-expect-error: Assume `parent` accepts `text`.
            node.children.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $68518aefef467aeb$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData('atHardBreak')) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $68518aefef467aeb$var$point(token.end);
            setData('atHardBreak');
            return;
        }
        if (!getData('setextHeadingSlurpLineEnding') && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        setData('atHardBreak', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData('inReference')) {
            /** @type {ReferenceType} */ const referenceType = getData('referenceType') || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData('referenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData('inReference')) {
            /** @type {ReferenceType} */ const referenceType = getData('referenceType') || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData('referenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $7489229d17108eb2$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $20c2d7c009b57867$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        setData('inReference', true);
        if (node.type === 'link') {
            /** @type {Array<StaticPhrasingContent>} */ // @ts-expect-error: Assume static phrasing content.
            const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        setData('inReference');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        setData('referenceType', 'collapsed');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $20c2d7c009b57867$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        setData('referenceType', 'full');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = getData('characterReferenceType');
        /** @type {string} */ let value;
        if (type) {
            value = (0, $acf207e9e6b35516$export$15a69557afac2c20)(data, type === 'characterReferenceMarkerNumeric' ? 10 : 16);
            setData('characterReferenceType');
        } else {
            const result = (0, $c4cf43c53fa7590e$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $68518aefef467aeb$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        // @ts-expect-error `depth` will be set later.
        return {
            type: 'heading',
            depth: undefined,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {HTML} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $68518aefef467aeb$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Extension | Array<Extension>>} extensions
 * @returns {void}
 */ function $68518aefef467aeb$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $68518aefef467aeb$var$configure(combined, value);
        else $68518aefef467aeb$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {void}
 */ function $68518aefef467aeb$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($68518aefef467aeb$var$own.call(extension, key)) {
        if (key === 'canContainEols') {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === 'transforms') {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === 'enter' || key === 'exit') {
            const right = extension[key];
            if (right) Object.assign(combined[key], right);
        }
    }
}
/** @type {OnEnterError} */ function $68518aefef467aeb$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $51e33f0d9892f114$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $51e33f0d9892f114$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $51e33f0d9892f114$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


function $c36d7d9fb278a9e7$export$2e2bcd8739ae039(options) {
    /** @type {import('unified').ParserFunction<Root>} */ const parser = (doc)=>{
        // Assume options.
        const settings = /** @type {Options} */ this.data('settings');
        return (0, $68518aefef467aeb$export$d744d789c09bfde6)(doc, Object.assign({}, settings, options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: this.data('micromarkExtensions') || [],
            mdastExtensions: this.data('fromMarkdownExtensions') || []
        }));
    };
    Object.assign(this, {
        Parser: parser
    });
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */ /**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Root} HastRoot
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Root} MdastRoot
 *
 * @typedef {import('./state.js').Options} Options
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 */ /**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ 
const $bca8e3d60b1c85f3$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $bca8e3d60b1c85f3$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return '&' + $bca8e3d60b1c85f3$var$characterReferences[value] + ';';
    }
}


function $243ffcc7c15f11e3$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $bca8e3d60b1c85f3$export$c564cdbbe6da493)($243ffcc7c15f11e3$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $243ffcc7c15f11e3$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $c57804f696751fc2$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $c57804f696751fc2$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = '\uFFFD';
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


function $60d81c026a1498b8$export$adb608be33961c98(state) {
    /** @type {Array<ElementContent>} */ const listItems = [];
    let index = -1;
    while(++index < state.footnoteOrder.length){
        const def = state.footnoteById[state.footnoteOrder[index]];
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $243ffcc7c15f11e3$export$e42a3e39590d28b5)(id.toLowerCase());
        let referenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        while(++referenceIndex <= state.footnoteCounts[id]){
            /** @type {Element} */ const backReference = {
                type: 'element',
                tagName: 'a',
                properties: {
                    href: '#' + state.clobberPrefix + 'fnref-' + safeId + (referenceIndex > 1 ? '-' + referenceIndex : ''),
                    dataFootnoteBackref: true,
                    className: [
                        'data-footnote-backref'
                    ],
                    ariaLabel: state.footnoteBackLabel
                },
                children: [
                    {
                        type: 'text',
                        value: "\u21A9"
                    }
                ]
            };
            if (referenceIndex > 1) backReference.children.push({
                type: 'element',
                tagName: 'sup',
                children: [
                    {
                        type: 'text',
                        value: String(referenceIndex)
                    }
                ]
            });
            if (backReferences.length > 0) backReferences.push({
                type: 'text',
                value: ' '
            });
            backReferences.push(backReference);
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === 'element' && tail.tagName === 'p') {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === 'text') tailTail.value += ' ';
            else tail.children.push({
                type: 'text',
                value: ' '
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: 'element',
            tagName: 'li',
            properties: {
                id: state.clobberPrefix + 'fn-' + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: 'element',
        tagName: 'section',
        properties: {
            dataFootnotes: true,
            className: [
                'footnotes'
            ]
        },
        children: [
            {
                type: 'element',
                tagName: state.footnoteLabelTagName,
                properties: {
                    // To do: use structured clone.
                    ...JSON.parse(JSON.stringify(state.footnoteLabelProperties)),
                    id: 'footnote-label'
                },
                children: [
                    {
                        type: 'text',
                        value: state.footnoteLabel
                    }
                ]
            },
            {
                type: 'text',
                value: '\n'
            },
            {
                type: 'element',
                tagName: 'ol',
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: 'text',
                value: '\n'
            }
        ]
    };
}


/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} MdastRoot
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 * @typedef {Extract<MdastNodes, MdastParent>} MdastParents
 *
 * @typedef EmbeddedHastFields
 *   hast fields.
 * @property {string | null | undefined} [hName]
 *   Generate a specific element with this tag name instead.
 * @property {HastProperties | null | undefined} [hProperties]
 *   Generate an element with these properties instead.
 * @property {Array<HastElementContent> | null | undefined} [hChildren]
 *   Generate an element with this content instead.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} MdastData
 *   mdast data with embedded hast fields.
 *
 * @typedef {MdastNodes & {data?: MdastData | null | undefined}} MdastNodeWithData
 *   mdast node with embedded hast data.
 *
 * @typedef PointLike
 *   Point-like value.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @typedef PositionLike
 *   Position-like value.
 * @property {PointLike | null | undefined} [start]
 *   Point-like value.
 * @property {PointLike | null | undefined} [end]
 *   Point-like value.
 *
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | null | undefined} parent
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 *   Signature of `state` for when props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {HastProperties} props
 *   Properties.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 *   Signature of `state` for when no props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @typedef HFields
 *   Info on `state`.
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {HastProperties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use from backreferences back to their footnote call.
 * @property {(identifier: string) => MdastDefinition | null} definition
 *   Definition cache.
 * @property {Record<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Record<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(from: MdastNodes, node: HastNodes) => void} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => Type | HastElement} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {(node: MdastNodes, parent: MdastParents | null | undefined) => HastElementContent | Array<HastElementContent> | null | undefined} one
 *   Transform an mdast node to hast.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastContent>(nodes: Array<Type>, loose?: boolean | null | undefined) => Array<Type | HastText>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 * @property {(left: MdastNodeWithData | PositionLike | null | undefined, right: HastElementContent) => HastElementContent} augment
 *   Like `state` but lower-level and usable on non-elements.
 *   Deprecated: use `patch` and `applyData`.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent it from
 *   *clobbering*.
 * @property {string | null | undefined} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call (affects
 *   screen readers).
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section (affects screen readers).
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (note that `id: 'footnote-label'`
 *   is always added as footnote calls use it with `aria-describedby` to
 *   provide an accessible label).
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   Tag name to use for the footnote label.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes.
 * @property {Array<string> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Handle nodes.
 *
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} State
 *   Info passed around.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * Check if `Child` can be a child of `Ancestor`.
 *
 * Returns the ancestor when `Child` can be a child of `Ancestor`, or returns
 * `never`.
 *
 * @template {Node} Ancestor
 *   Node type.
 * @template {Node} Child
 *   Node type.
 * @typedef {(
 *   Ancestor extends Parent
 *     ? Child extends Ancestor['children'][number]
 *       ? Ancestor
 *       : never
 *     : never
 * )} ParentsOf
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends Node ? number | null : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends Node ? Ancestor | null : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * Build a typed `Visitor` function from a node and all possible parents.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Visited
 *   Node type.
 * @template {Parent} Ancestor
 *   Parent type.
 * @typedef {Visitor<Visited, ParentsOf<Ancestor, Visited>>} BuildVisitorFromMatch
 */ /**
 * Build a typed `Visitor` function from a list of descendants and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     import('unist-util-visit-parents/complex-types.js').Matches<Descendant, Check>,
 *     Extract<Descendant, Parent>
 *   >
 * )} BuildVisitorFromDescendants
 */ /**
 * Build a typed `Visitor` function from a tree and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} [Tree=Node]
 *   Node type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     import('unist-util-visit-parents/complex-types.js').InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */ /**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @typedef {Record<string, unknown>} Props
 * @typedef {null | undefined | string | Props | TestFunctionAnything | Array<string | Props | TestFunctionAnything>} Test
 *   Check for an arbitrary node, unaware of TypeScript inferral.
 *
 * @callback TestFunctionAnything
 *   Check if a node passes a test, unaware of TypeScript inferral.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | void}
 *   Whether this node passes the test.
 */ /**
 * @template {Node} Kind
 *   Node type.
 * @typedef {Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind> | Array<Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind>>} PredicateTest
 *   Check for a node that can be inferred by TypeScript.
 */ /**
 * Check if a node passes a certain test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback TestFunctionPredicate
 *   Complex test function for a node that can be inferred by TypeScript.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this node passes the test.
 */ /**
 * @callback AssertAnything
 *   Check that an arbitrary value is a node, unaware of TypeScript inferral.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if a node is a node and passes a certain node test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback AssertPredicate
 *   Check that an arbitrary value is a specific node, aware of TypeScript.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @param test
 *   A check for a specific node.
 * @param index
 *   The node’s position in its parent.
 * @param parent
 *   The node’s parent.
 * @returns
 *   Whether `node` is a node and passes a test.
 */ const $8e5b9aec374fa5a1$export$226b3eccf92c9ed9 = /**
   * @type {(
   *   (() => false) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index: number, parent: Parent, context?: unknown) => node is Kind) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index?: null | undefined, parent?: null | undefined, context?: unknown) => node is Kind) &
   *   ((node: unknown, test: Test, index: number, parent: Parent, context?: unknown) => boolean) &
   *   ((node: unknown, test?: Test, index?: null | undefined, parent?: null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function is(node, test, index, parent, context) {
    const check = $8e5b9aec374fa5a1$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!is(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    // @ts-expect-error Looks like a node.
    return node && node.type && typeof node.type === 'string' ? Boolean(check.call(context, node, index, parent)) : false;
};
const $8e5b9aec374fa5a1$export$9c68d69a4c5bbcf9 = /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */ function(test) {
    if (test === undefined || test === null) return $8e5b9aec374fa5a1$var$ok;
    if (typeof test === 'string') return $8e5b9aec374fa5a1$var$typeFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $8e5b9aec374fa5a1$var$anyFactory(test) : $8e5b9aec374fa5a1$var$propsFactory(test);
    if (typeof test === 'function') return $8e5b9aec374fa5a1$var$castFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */ function $8e5b9aec374fa5a1$var$anyFactory(tests) {
    /** @type {Array<AssertAnything>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $8e5b9aec374fa5a1$export$9c68d69a4c5bbcf9(tests[index]);
    return $8e5b9aec374fa5a1$var$castFactory(any);
    /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].call(this, ...parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */ function $8e5b9aec374fa5a1$var$propsFactory(check) {
    return $8e5b9aec374fa5a1$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        /** @type {string} */ let key;
        for(key in check){
            // @ts-expect-error: hush, it sure works as an index.
            if (node[key] !== check[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */ function $8e5b9aec374fa5a1$var$typeFactory(check) {
    return $8e5b9aec374fa5a1$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */ function $8e5b9aec374fa5a1$var$castFactory(check) {
    return assertion;
    /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function assertion(node, ...parameters) {
        return Boolean(node && typeof node === 'object' && 'type' in node && // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters)));
    }
}
function $8e5b9aec374fa5a1$var$ok() {
    return true;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $878e15d80bb51245$export$35e9368ef982300f(d) {
    return d;
}


const $63b66796e35109e6$export$f4d8133c446fe484 = true;
const $63b66796e35109e6$export$7f100f842f565dc9 = false;
const $63b66796e35109e6$export$8773f85c2fb2c116 = 'skip';
const $63b66796e35109e6$export$70008a21eb6de899 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
    }
    const is = (0, $8e5b9aec374fa5a1$export$9c68d69a4c5bbcf9)(test);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */ function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */ // @ts-expect-error: hush
        const value = node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $878e15d80bb51245$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {ActionTuple} */ let result = [];
            /** @type {ActionTuple} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<Parent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $63b66796e35109e6$var$toResult(visitor(node, parents));
                if (result[0] === $63b66796e35109e6$export$7f100f842f565dc9) return result;
            }
            // @ts-expect-error looks like a parent.
            if (node.children && result[0] !== $63b66796e35109e6$export$8773f85c2fb2c116) {
                // @ts-expect-error looks like a parent.
                offset = (reverse ? node.children.length : -1) + step;
                // @ts-expect-error looks like a parent.
                grandparents = parents.concat(node);
                // @ts-expect-error looks like a parent.
                while(offset > -1 && offset < node.children.length){
                    // @ts-expect-error looks like a parent.
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $63b66796e35109e6$export$7f100f842f565dc9) return subresult;
                    offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
};
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */ function $63b66796e35109e6$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $63b66796e35109e6$export$f4d8133c446fe484,
        value
    ];
    return [
        value
    ];
}


const $25164bdc2faf8654$export$bf638b60ea8b89b7 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    (0, $63b66796e35109e6$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(node, parent ? parent.children.indexOf(node) : null, parent);
    }
};


/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $a0e725dc242e4bff$export$771bf3e4949bfbee = $a0e725dc242e4bff$var$point('start');
const $a0e725dc242e4bff$export$da309cdce9dc2a25 = $a0e725dc242e4bff$var$point('end');
function $a0e725dc242e4bff$export$5880b8b5730aff45(node) {
    return {
        start: $a0e725dc242e4bff$export$771bf3e4949bfbee(node),
        end: $a0e725dc242e4bff$export$da309cdce9dc2a25(node)
    };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $a0e725dc242e4bff$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        // To do: next major: don’t return points when invalid.
        return {
            // @ts-expect-error: in practice, null is allowed.
            line: point.line || null,
            // @ts-expect-error: in practice, null is allowed.
            column: point.column || null,
            // @ts-expect-error: in practice, null is allowed.
            offset: point.offset > -1 ? point.offset : null
        };
    }
}


/**
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {PositionLike | null | undefined} [position]
 */ /**
 * Check if `node` is generated.
 *
 * @param {NodeLike | null | undefined} [node]
 *   Node to check.
 * @returns {boolean}
 *   Whether `node` is generated (does not have positional info).
 */ function $2c743888116600ea$export$41ad1363166ec91a(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Definition} Definition
 */ /**
 * @typedef {Root | Content} Node
 *
 * @callback GetDefinition
 *   Get a definition by identifier.
 * @param {string | null | undefined} [identifier]
 *   Identifier of definition.
 * @returns {Definition | null}
 *   Definition corresponding to `identifier` or `null`.
 */ 
const $22352b3de3d55cba$var$own = {}.hasOwnProperty;
function $22352b3de3d55cba$export$d79264f26953ec1(tree) {
    /** @type {Record<string, Definition>} */ const cache = Object.create(null);
    if (!tree || !tree.type) throw new Error('mdast-util-definitions expected node');
    (0, $25164bdc2faf8654$export$bf638b60ea8b89b7)(tree, 'definition', (definition)=>{
        const id = $22352b3de3d55cba$var$clean(definition.identifier);
        if (id && !$22352b3de3d55cba$var$own.call(cache, id)) cache[id] = definition;
    });
    return definition;
    /** @type {GetDefinition} */ function definition(identifier) {
        const id = $22352b3de3d55cba$var$clean(identifier);
        // To do: next major: return `undefined` when not found.
        return id && $22352b3de3d55cba$var$own.call(cache, id) ? cache[id] : null;
    }
}
/**
 * @param {string | null | undefined} [value]
 * @returns {string}
 */ function $22352b3de3d55cba$var$clean(value) {
    return String(value || '').toUpperCase();
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $e8a8fbed2b1d1f09$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'blockquote',
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $b77fca0539084967$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'br',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: 'text',
            value: '\n'
        }
    ];
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $cb92890e6aa975d0$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + '\n' : '';
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    const lang = node.lang ? node.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null;
    /** @type {Properties} */ const properties = {};
    if (lang) properties.className = [
        'language-' + lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: 'element',
        tagName: 'code',
        properties: properties,
        children: [
            {
                type: 'text',
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: 'element',
        tagName: 'pre',
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $13946d1f41b0abc1$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'del',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $24d7797d39e1ee9c$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'em',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('hast').Element} Element
 * @typedef {import('../state.js').State} State
 */ 
function $11370e7412050e8c$export$7f87ee744075c1ba(state, node) {
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $243ffcc7c15f11e3$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    if (index === -1) {
        state.footnoteOrder.push(id);
        state.footnoteCounts[id] = 1;
        counter = state.footnoteOrder.length;
    } else {
        state.footnoteCounts[id]++;
        counter = index + 1;
    }
    const reuseCounter = state.footnoteCounts[id];
    /** @type {Element} */ const link = {
        type: 'element',
        tagName: 'a',
        properties: {
            href: '#' + state.clobberPrefix + 'fn-' + safeId,
            id: state.clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : ''),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                'footnote-label'
            ]
        },
        children: [
            {
                type: 'text',
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../state.js').State} State
 */ 
function $74ea55209ef1bb90$export$3b6a720baa2c20ec(state, node) {
    const footnoteById = state.footnoteById;
    let no = 1;
    while(no in footnoteById)no++;
    const identifier = String(no);
    footnoteById[identifier] = {
        type: 'footnoteDefinition',
        identifier: identifier,
        children: [
            {
                type: 'paragraph',
                children: node.children
            }
        ],
        position: node.position
    };
    return (0, $11370e7412050e8c$export$7f87ee744075c1ba)(state, {
        type: 'footnoteReference',
        identifier: identifier,
        position: node.position
    });
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $833e3b657341e96c$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'h' + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').HTML} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Raw | Element | null}
 *   hast node.
 */ function $7958d458fa8c5b9f$export$c0bb0b647f701bb5(state, node) {
    if (state.dangerous) {
        /** @type {Raw} */ const result = {
            type: 'raw',
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    // To do: next major: return `undefined`.
    return null;
}


/**
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Reference} Reference
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Reference>} References
 */ // To do: next major: always return array.
/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {References} node
 *   Reference node (image, link).
 * @returns {ElementContent | Array<ElementContent>}
 *   hast content.
 */ function $05cdf5bf3d8dbb14$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = ']';
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return {
        type: 'text',
        value: '![' + node.alt + suffix
    };
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift({
        type: 'text',
        value: '['
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push({
        type: 'text',
        value: suffix
    });
    return contents;
}


function $3648f582eb33f222$export$f281796f6bc3b8db(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $05cdf5bf3d8dbb14$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $243ffcc7c15f11e3$export$e42a3e39590d28b5)(def.url || ''),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
function $e1d3762b1182c6be$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $243ffcc7c15f11e3$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $af8945d5eb9c0da0$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: 'text',
        value: node.value.replace(/\r?\n|\r/g, ' ')
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'code',
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 

function $0b2cb91971a1e37b$export$e6c469b1b7b2bc6a(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $05cdf5bf3d8dbb14$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $243ffcc7c15f11e3$export$e42a3e39590d28b5)(def.url || '')
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
function $7b7d8147ca2930e8$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $243ffcc7c15f11e3$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $3a3e6b306e40dea4$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $3a3e6b306e40dea4$var$listLoose(parent) : $3a3e6b306e40dea4$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === 'boolean') {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === 'element' && head.tagName === 'p') paragraph = head;
        else {
            paragraph = {
                type: 'element',
                tagName: 'p',
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: 'text',
            value: ' '
        });
        paragraph.children.unshift({
            type: 'element',
            tagName: 'input',
            properties: {
                type: 'checkbox',
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            'task-list-item'
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== 'element' || child.tagName !== 'p') children.push({
            type: 'text',
            value: '\n'
        });
        if (child.type === 'element' && child.tagName === 'p' && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) children.push({
        type: 'text',
        value: '\n'
    });
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'li',
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $3a3e6b306e40dea4$var$listLoose(node) {
    let loose = false;
    if (node.type === 'list') {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $3a3e6b306e40dea4$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $3a3e6b306e40dea4$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $50b2c7dd4e02e9db$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === 'number' && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === 'element' && child.tagName === 'li' && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes('task-list-item')) {
            properties.className = [
                'contains-task-list'
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: node.ordered ? 'ol' : 'ul',
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $8b3a777b6345d118$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'p',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastRoot | HastElement}
 *   hast node.
 */ function $c61a043f050bc7e8$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: 'root',
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $3d11981daf1cbc12$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'strong',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
function $8fefc411755d6974$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: 'element',
            tagName: 'thead',
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: 'element',
            tagName: 'tbody',
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $a0e725dc242e4bff$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $a0e725dc242e4bff$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start.line && end.line) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'table',
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $f24fb4531933889d$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? 'th' : 'td';
    const align = parent && parent.type === 'table' ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: 'element',
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(node, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'tr',
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $47700c5c6546f6b0$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'td',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ const $7c4844de7a59e160$var$tab = 9 /* `\t` */ ;
const $7c4844de7a59e160$var$space = 32 /* ` ` */ ;
function $7c4844de7a59e160$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($7c4844de7a59e160$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($7c4844de7a59e160$var$trimLine(source.slice(last), last > 0, false));
    return lines.join('');
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $7c4844de7a59e160$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $7c4844de7a59e160$var$tab || code === $7c4844de7a59e160$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $7c4844de7a59e160$var$tab || code === $7c4844de7a59e160$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : '';
}


function $fe2b8c9849335920$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: 'text',
        value: (0, $7c4844de7a59e160$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $c6f2247d7c11e099$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'hr',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $fff7bac6df719534$export$455ce229eb3d2472 = {
    blockquote: $e8a8fbed2b1d1f09$export$67dc04e652a298ca,
    break: (0, $b77fca0539084967$export$371da9dd35aba193),
    code: $cb92890e6aa975d0$export$6565f9f03506010b,
    delete: (0, $13946d1f41b0abc1$export$19426ff118fe8be),
    emphasis: $24d7797d39e1ee9c$export$bef81ba411953b51,
    footnoteReference: $11370e7412050e8c$export$7f87ee744075c1ba,
    footnote: $74ea55209ef1bb90$export$3b6a720baa2c20ec,
    heading: $833e3b657341e96c$export$46e4a324ac90507f,
    html: $7958d458fa8c5b9f$export$c0bb0b647f701bb5,
    imageReference: $3648f582eb33f222$export$f281796f6bc3b8db,
    image: $e1d3762b1182c6be$export$5c452ff88e35e47d,
    inlineCode: $af8945d5eb9c0da0$export$91b9bee19a0d8569,
    linkReference: $0b2cb91971a1e37b$export$e6c469b1b7b2bc6a,
    link: $7b7d8147ca2930e8$export$9c30223ca0a664fb,
    listItem: $3a3e6b306e40dea4$export$76c7e83ecc9cdf05,
    list: $50b2c7dd4e02e9db$export$8837f4fc672e936d,
    paragraph: $8b3a777b6345d118$export$9c206ddddb32a9b,
    root: $c61a043f050bc7e8$export$e8e78c978b129247,
    strong: $3d11981daf1cbc12$export$59ae2c325a998f89,
    table: $8fefc411755d6974$export$9852986a3ec5f6a0,
    tableCell: $47700c5c6546f6b0$export$e1e720e5f4603e6a,
    tableRow: $f24fb4531933889d$export$ce666bf02318c957,
    text: $fe2b8c9849335920$export$6f093cfa640b7166,
    thematicBreak: $c6f2247d7c11e099$export$ba7b13e047416c03,
    toml: $fff7bac6df719534$var$ignore,
    yaml: $fff7bac6df719534$var$ignore,
    definition: $fff7bac6df719534$var$ignore,
    footnoteDefinition: $fff7bac6df719534$var$ignore
};
// Return nothing for nodes that are ignored.
function $fff7bac6df719534$var$ignore() {
    // To do: next major: return `undefined`.
    return null;
}


const $3686fde2f3002e5c$var$own = {}.hasOwnProperty;
function $3686fde2f3002e5c$export$e6a0daad8304de(tree, options) {
    const settings = options || {};
    const dangerous = settings.allowDangerousHtml || false;
    /** @type {Record<string, MdastFootnoteDefinition>} */ const footnoteById = {};
    // To do: next major: add `options` to state, remove:
    // `dangerous`, `clobberPrefix`, `footnoteLabel`, `footnoteLabelTagName`,
    // `footnoteLabelProperties`, `footnoteBackLabel`, `passThrough`,
    // `unknownHandler`.
    // To do: next major: move to `state.options.allowDangerousHtml`.
    state.dangerous = dangerous;
    // To do: next major: move to `state.options`.
    state.clobberPrefix = settings.clobberPrefix === undefined || settings.clobberPrefix === null ? 'user-content-' : settings.clobberPrefix;
    // To do: next major: move to `state.options`.
    state.footnoteLabel = settings.footnoteLabel || 'Footnotes';
    // To do: next major: move to `state.options`.
    state.footnoteLabelTagName = settings.footnoteLabelTagName || 'h2';
    // To do: next major: move to `state.options`.
    state.footnoteLabelProperties = settings.footnoteLabelProperties || {
        className: [
            'sr-only'
        ]
    };
    // To do: next major: move to `state.options`.
    state.footnoteBackLabel = settings.footnoteBackLabel || 'Back to content';
    // To do: next major: move to `state.options`.
    state.unknownHandler = settings.unknownHandler;
    // To do: next major: move to `state.options`.
    state.passThrough = settings.passThrough;
    state.handlers = {
        ...(0, $fff7bac6df719534$export$455ce229eb3d2472),
        ...settings.handlers
    };
    // To do: next major: replace utility with `definitionById` object, so we
    // only walk once (as we need footnotes too).
    state.definition = (0, $22352b3de3d55cba$export$d79264f26953ec1)(tree);
    state.footnoteById = footnoteById;
    /** @type {Array<string>} */ state.footnoteOrder = [];
    /** @type {Record<string, number>} */ state.footnoteCounts = {};
    state.patch = $3686fde2f3002e5c$var$patch;
    state.applyData = $3686fde2f3002e5c$var$applyData;
    state.one = oneBound;
    state.all = allBound;
    state.wrap = $3686fde2f3002e5c$export$4997ffc0176396a6;
    // To do: next major: remove `augment`.
    state.augment = augment;
    (0, $25164bdc2faf8654$export$bf638b60ea8b89b7)(tree, 'footnoteDefinition', (definition)=>{
        const id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$3686fde2f3002e5c$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    });
    // @ts-expect-error Hush, it’s fine!
    return state;
    /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {MdastNodeWithData | PositionLike | null | undefined} left
   * @param {HastElementContent} right
   * @returns {HastElementContent}
   */ /* c8 ignore start */ // To do: next major: remove.
    function augment(left, right) {
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && 'data' in left && left.data) {
            /** @type {MdastData} */ const data = left.data;
            if (data.hName) {
                if (right.type !== 'element') right = {
                    type: 'element',
                    tagName: '',
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === 'element' && data.hProperties) right.properties = {
                ...right.properties,
                ...data.hProperties
            };
            if ('children' in right && right.children && data.hChildren) right.children = data.hChildren;
        }
        if (left) {
            const ctx = 'type' in left ? left : {
                position: left
            };
            if (!(0, $2c743888116600ea$export$41ad1363166ec91a)(ctx)) // @ts-expect-error: fine.
            right.position = {
                start: (0, $a0e725dc242e4bff$export$771bf3e4949bfbee)(ctx),
                end: (0, $a0e725dc242e4bff$export$da309cdce9dc2a25)(ctx)
            };
        }
        return right;
    }
    /* c8 ignore stop */ /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */ /* c8 ignore start */ // To do: next major: remove.
    function state(node, tagName, props, children) {
        if (Array.isArray(props)) {
            children = props;
            props = {};
        }
        // @ts-expect-error augmenting an element yields an element.
        return augment(node, {
            type: 'element',
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    /* c8 ignore stop */ /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | null | undefined} [parent]
   *   Parent of `node`.
   * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
   *   Resulting hast node.
   */ function oneBound(node, parent) {
        // @ts-expect-error: that’s a state :)
        return $3686fde2f3002e5c$export$80bf7733f1207381(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function allBound(parent) {
        // @ts-expect-error: that’s a state :)
        return $3686fde2f3002e5c$export$84bf76cd7afc7469(state, parent);
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {void}
 *   Nothing.
 */ function $3686fde2f3002e5c$var$patch(from, to) {
    if (from.position) to.position = (0, $a0e725dc242e4bff$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {Type | HastElement}
 *   Nothing.
 */ function $3686fde2f3002e5c$var$applyData(from, to) {
    /** @type {Type | HastElement} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === 'string') {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === 'element') result.tagName = hName;
            else result = {
                type: 'element',
                tagName: hName,
                properties: {},
                children: []
            };
        }
        if (result.type === 'element' && hProperties) result.properties = {
            ...result.properties,
            ...hProperties
        };
        if ('children' in result && result.children && hChildren !== null && hChildren !== undefined) // @ts-expect-error: assume valid children are defined.
        result.children = hChildren;
    }
    return result;
}
function $3686fde2f3002e5c$export$80bf7733f1207381(state, node, parent) {
    const type = node && node.type;
    // Fail on non-nodes.
    if (!type) throw new Error('Expected node, got `' + node + '`');
    if ($3686fde2f3002e5c$var$own.call(state.handlers, type)) return state.handlers[type](state, node, parent);
    if (state.passThrough && state.passThrough.includes(type)) // To do: next major: deep clone.
    // @ts-expect-error: types of passed through nodes are expected to be added manually.
    return 'children' in node ? {
        ...node,
        children: $3686fde2f3002e5c$export$84bf76cd7afc7469(state, node)
    } : node;
    if (state.unknownHandler) return state.unknownHandler(state, node, parent);
    return $3686fde2f3002e5c$var$defaultUnknownHandler(state, node);
}
function $3686fde2f3002e5c$export$84bf76cd7afc7469(state, parent) {
    /** @type {Array<HastElementContent>} */ const values = [];
    if ('children' in parent) {
        const nodes = parent.children;
        let index = -1;
        while(++index < nodes.length){
            const result = $3686fde2f3002e5c$export$80bf7733f1207381(state, nodes[index], parent);
            // To do: see if we van clean this? Can we merge texts?
            if (result) {
                if (index && nodes[index - 1].type === 'break') {
                    if (!Array.isArray(result) && result.type === 'text') result.value = result.value.replace(/^\s+/, '');
                    if (!Array.isArray(result) && result.type === 'element') {
                        const head = result.children[0];
                        if (head && head.type === 'text') head.value = head.value.replace(/^\s+/, '');
                    }
                }
                if (Array.isArray(result)) values.push(...result);
                else values.push(result);
            }
        }
    }
    return values;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastText | HastElement}
 *   Resulting hast node.
 */ function $3686fde2f3002e5c$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastText | HastElement} */ const result = 'value' in node && !($3686fde2f3002e5c$var$own.call(data, 'hProperties') || $3686fde2f3002e5c$var$own.call(data, 'hChildren')) ? {
        type: 'text',
        value: node.value
    } : {
        type: 'element',
        tagName: 'div',
        properties: {},
        children: $3686fde2f3002e5c$export$84bf76cd7afc7469(state, node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $3686fde2f3002e5c$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<Type | HastText>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: 'text',
        value: '\n'
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: 'text',
            value: '\n'
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: 'text',
        value: '\n'
    });
    return result;
}


function $a29a308e7a050c9c$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $3686fde2f3002e5c$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, null);
    const foot = (0, $60d81c026a1498b8$export$adb608be33961c98)(state);
    if (foot) // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push({
        type: 'text',
        value: '\n'
    }, foot);
    // To do: next major: always return root?
    return Array.isArray(node) ? {
        type: 'root',
        children: node
    } : node;
}


// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(
/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */ const $65553fdcf071d6cf$var$remarkRehype = /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */ function(destination, options) {
    return destination && 'run' in destination ? $65553fdcf071d6cf$var$bridge(destination, options) : $65553fdcf071d6cf$var$mutate(destination || options);
};
var $65553fdcf071d6cf$export$2e2bcd8739ae039 = $65553fdcf071d6cf$var$remarkRehype;
/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */ function $65553fdcf071d6cf$var$bridge(destination, options) {
    return (node, file, next)=>{
        destination.run((0, $a29a308e7a050c9c$export$c0e4c5cf07538633)(node, options), file, (error)=>{
            next(error);
        });
    };
}
/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */ function $65553fdcf071d6cf$var$mutate(options) {
    // @ts-expect-error: assume a corresponding node is returned by `toHast`.
    return (node)=>(0, $a29a308e7a050c9c$export$c0e4c5cf07538633)(node, options);
}


var $c65bfe520546a474$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c65bfe520546a474$var$ReactIs, $c65bfe520546a474$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$c65bfe520546a474$exports = (parcelRequire("kh2Rv"))();


/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $44cfcc8b5b33dc78$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $44cfcc8b5b33dc78$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $44cfcc8b5b33dc78$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $44cfcc8b5b33dc78$export$19342e026b58ebb7.prototype.space = null;


function $7b894d15d48f94b6$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $44cfcc8b5b33dc78$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $ca44418921669a8e$export$a3295358bff77e(value) {
    return value.toLowerCase();
}



class $7d13373d770e5bd5$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $7d13373d770e5bd5$export$c4868e4a24d48fad.prototype.space = null;
$7d13373d770e5bd5$export$c4868e4a24d48fad.prototype.boolean = false;
$7d13373d770e5bd5$export$c4868e4a24d48fad.prototype.booleanish = false;
$7d13373d770e5bd5$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$7d13373d770e5bd5$export$c4868e4a24d48fad.prototype.number = false;
$7d13373d770e5bd5$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$7d13373d770e5bd5$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$7d13373d770e5bd5$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$7d13373d770e5bd5$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$7d13373d770e5bd5$export$c4868e4a24d48fad.prototype.defined = false;


var $a5ecef05f71bb81c$exports = {};

$parcel$export($a5ecef05f71bb81c$exports, "boolean", function () { return $a5ecef05f71bb81c$export$4a21f16c33752377; });
$parcel$export($a5ecef05f71bb81c$exports, "booleanish", function () { return $a5ecef05f71bb81c$export$55e9e1fbc638dc8f; });
$parcel$export($a5ecef05f71bb81c$exports, "overloadedBoolean", function () { return $a5ecef05f71bb81c$export$242ac3d3042558aa; });
$parcel$export($a5ecef05f71bb81c$exports, "number", function () { return $a5ecef05f71bb81c$export$98e628dec113755e; });
$parcel$export($a5ecef05f71bb81c$exports, "spaceSeparated", function () { return $a5ecef05f71bb81c$export$ab8645c862eb5a3e; });
$parcel$export($a5ecef05f71bb81c$exports, "commaSeparated", function () { return $a5ecef05f71bb81c$export$9c8d678629b3d3; });
$parcel$export($a5ecef05f71bb81c$exports, "commaOrSpaceSeparated", function () { return $a5ecef05f71bb81c$export$2ad25cfebf36cacd; });
let $a5ecef05f71bb81c$var$powers = 0;
const $a5ecef05f71bb81c$export$4a21f16c33752377 = $a5ecef05f71bb81c$var$increment();
const $a5ecef05f71bb81c$export$55e9e1fbc638dc8f = $a5ecef05f71bb81c$var$increment();
const $a5ecef05f71bb81c$export$242ac3d3042558aa = $a5ecef05f71bb81c$var$increment();
const $a5ecef05f71bb81c$export$98e628dec113755e = $a5ecef05f71bb81c$var$increment();
const $a5ecef05f71bb81c$export$ab8645c862eb5a3e = $a5ecef05f71bb81c$var$increment();
const $a5ecef05f71bb81c$export$9c8d678629b3d3 = $a5ecef05f71bb81c$var$increment();
const $a5ecef05f71bb81c$export$2ad25cfebf36cacd = $a5ecef05f71bb81c$var$increment();
function $a5ecef05f71bb81c$var$increment() {
    return 2 ** ++$a5ecef05f71bb81c$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $da4daff51d191e64$var$checks = Object.keys($a5ecef05f71bb81c$exports);
class $da4daff51d191e64$export$ea6b9f0064e88c9b extends (0, $7d13373d770e5bd5$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $da4daff51d191e64$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $da4daff51d191e64$var$checks.length){
            const check = $da4daff51d191e64$var$checks[index];
            $da4daff51d191e64$var$mark(this, $da4daff51d191e64$var$checks[index], (mask & $a5ecef05f71bb81c$exports[check]) === $a5ecef05f71bb81c$exports[check]);
        }
    }
}
$da4daff51d191e64$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $da4daff51d191e64$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}


const $b26ecc23c212812c$var$own = {}.hasOwnProperty;
function $b26ecc23c212812c$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($b26ecc23c212812c$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $da4daff51d191e64$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $ca44418921669a8e$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $ca44418921669a8e$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $44cfcc8b5b33dc78$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $b2fe67e0e59bd752$export$2bd1230ec7600845 = (0, $b26ecc23c212812c$export$185802fd694ee1f5)({
    space: 'xlink',
    transform (_, prop) {
        return 'xlink:' + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $75376bbfd88c2294$export$f2913fe8983302e = (0, $b26ecc23c212812c$export$185802fd694ee1f5)({
    space: 'xml',
    transform (_, prop) {
        return 'xml:' + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $8af21a7f77c223f9$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $415d8e6d945dc80a$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $8af21a7f77c223f9$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $596750341c6faac7$export$e20c24a128671213 = (0, $b26ecc23c212812c$export$185802fd694ee1f5)({
    space: 'xmlns',
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    transform: (0, $415d8e6d945dc80a$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $aa7224329561d752$export$4d2d26490572750a = (0, $b26ecc23c212812c$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        ariaColIndex: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        ariaColSpan: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        ariaControls: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        ariaLevel: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        ariaPressed: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        ariaRowIndex: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        ariaRowSpan: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        ariaSelected: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        ariaValueMin: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        ariaValueNow: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $ce9d5fcb8ac627ed$export$c0bb0b647f701bb5 = (0, $b26ecc23c212812c$export$185802fd694ee1f5)({
    space: 'html',
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    transform: (0, $415d8e6d945dc80a$export$32b9e4cec9c208e1),
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $a5ecef05f71bb81c$export$9c8d678629b3d3),
        acceptCharset: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        accessKey: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        allowPaymentRequest: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        allowUserMedia: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        autoFocus: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        autoPlay: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        blocking: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        cite: null,
        className: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        cols: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        controls: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        controlsList: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        coords: (0, $a5ecef05f71bb81c$export$98e628dec113755e) | (0, $a5ecef05f71bb81c$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        defer: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        download: (0, $a5ecef05f71bb81c$export$242ac3d3042558aa),
        draggable: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        height: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        hidden: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        high: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        httpEquiv: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        itemRef: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        itemScope: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        itemType: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        low: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        multiple: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        muted: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        noValidate: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        optimum: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        pattern: null,
        ping: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        required: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        reversed: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        rows: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        rowSpan: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        sandbox: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        seamless: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        selected: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        shadowRootClonable: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        shadowRootMode: null,
        shape: null,
        size: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        spellCheck: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        useMap: null,
        value: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        width: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        declare: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        leftMargin: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        marginWidth: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        noResize: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        noHref: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        noShade: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        noWrap: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $a5ecef05f71bb81c$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        disableRemotePlayback: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $7b642ebafd4d3f14$export$7ed1367e7fa1ad68 = (0, $b26ecc23c212812c$export$185802fd694ee1f5)({
    space: 'svg',
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    transform: (0, $8af21a7f77c223f9$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $a5ecef05f71bb81c$export$2ad25cfebf36cacd),
        accentHeight: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        amplitude: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        className: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        diffuseConstant: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $a5ecef05f71bb81c$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $a5ecef05f71bb81c$export$9c8d678629b3d3),
        g2: (0, $a5ecef05f71bb81c$export$9c8d678629b3d3),
        glyphName: (0, $a5ecef05f71bb81c$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        horizOriginX: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        horizOriginY: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        id: null,
        ideographic: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        k: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        k1: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        k2: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        k3: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        k4: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        kernelMatrix: (0, $a5ecef05f71bb81c$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        overlineThickness: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $a5ecef05f71bb81c$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        pointsAtY: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        pointsAtZ: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $a5ecef05f71bb81c$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $a5ecef05f71bb81c$export$2ad25cfebf36cacd),
        rev: (0, $a5ecef05f71bb81c$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $a5ecef05f71bb81c$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $a5ecef05f71bb81c$export$2ad25cfebf36cacd),
        requiredFonts: (0, $a5ecef05f71bb81c$export$2ad25cfebf36cacd),
        requiredFormats: (0, $a5ecef05f71bb81c$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        specularExponent: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        strikethroughThickness: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $a5ecef05f71bb81c$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        strokeOpacity: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $a5ecef05f71bb81c$export$2ad25cfebf36cacd),
        tabIndex: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        targetY: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $a5ecef05f71bb81c$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        underlineThickness: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        vMathematical: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        vIdeographic: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        vertOriginX: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        vertOriginY: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $a5ecef05f71bb81c$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ 


const $454a6da6066de284$var$valid = /^data[-\w.:]+$/i;
const $454a6da6066de284$var$dash = /-[a-z]/g;
const $454a6da6066de284$var$cap = /[A-Z]/g;
function $454a6da6066de284$export$71aa6c912b956294(schema, value) {
    const normal = (0, $ca44418921669a8e$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $7d13373d770e5bd5$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $454a6da6066de284$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($454a6da6066de284$var$dash, $454a6da6066de284$var$camelcase);
            prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$454a6da6066de284$var$dash.test(rest)) {
                let dashes = rest.replace($454a6da6066de284$var$cap, $454a6da6066de284$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $da4daff51d191e64$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $454a6da6066de284$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $454a6da6066de284$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}


/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $2d35a7d0373f11c8$export$d8abd7e5fb6871f9 = {
    classId: 'classID',
    dataType: 'datatype',
    itemId: 'itemID',
    strokeDashArray: 'strokeDasharray',
    strokeDashOffset: 'strokeDashoffset',
    strokeLineCap: 'strokeLinecap',
    strokeLineJoin: 'strokeLinejoin',
    strokeMiterLimit: 'strokeMiterlimit',
    typeOf: 'typeof',
    xLinkActuate: 'xlinkActuate',
    xLinkArcRole: 'xlinkArcrole',
    xLinkHref: 'xlinkHref',
    xLinkRole: 'xlinkRole',
    xLinkShow: 'xlinkShow',
    xLinkTitle: 'xlinkTitle',
    xLinkType: 'xlinkType',
    xmlnsXLink: 'xmlnsXlink'
};



const $39a014b88522a962$export$c0bb0b647f701bb5 = (0, $7b894d15d48f94b6$export$4950aa0f605343fb)([
    (0, $75376bbfd88c2294$export$f2913fe8983302e),
    (0, $b2fe67e0e59bd752$export$2bd1230ec7600845),
    (0, $596750341c6faac7$export$e20c24a128671213),
    (0, $aa7224329561d752$export$4d2d26490572750a),
    (0, $ce9d5fcb8ac627ed$export$c0bb0b647f701bb5)
], 'html');
const $39a014b88522a962$export$7ed1367e7fa1ad68 = (0, $7b894d15d48f94b6$export$4950aa0f605343fb)([
    (0, $75376bbfd88c2294$export$f2913fe8983302e),
    (0, $b2fe67e0e59bd752$export$2bd1230ec7600845),
    (0, $596750341c6faac7$export$e20c24a128671213),
    (0, $aa7224329561d752$export$4d2d26490572750a),
    (0, $7b642ebafd4d3f14$export$7ed1367e7fa1ad68)
], 'svg');



function $3fdc03b2a6cd86d2$export$2e2bcd8739ae039(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError('Only one of `allowedElements` and `disallowedElements` should be defined');
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        (0, $25164bdc2faf8654$export$bf638b60ea8b89b7)(tree, 'element', (node, index, parent_)=>{
            const parent = /** @type {Element|Root} */ parent_;
            /** @type {boolean|undefined} */ let remove;
            if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
            else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
            if (!remove && options.allowElement && typeof index === 'number') remove = !options.allowElement(node, index, parent);
            if (remove && typeof index === 'number') {
                if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
            return undefined;
        });
    };
}


/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */ /**
 * @template {import('react').ElementType} T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */ /**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types.js').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'td'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: false}} TableDataCellProps
 * @typedef {ComponentPropsWithoutRef<'th'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: true}} TableHeaderCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableDataCellProps>} TableDataCellComponent
 * @typedef {ComponentType<TableHeaderCellProps>} TableHeaderCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableDataCellComponent|ReactMarkdownNames} td
 * @property {TableHeaderCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types.js').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ 
var $gIfym = parcelRequire("gIfym");
var $2d222ef6f692482f$exports = {};
'use strict';

$2d222ef6f692482f$exports = (parcelRequire("95oGi"));


/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {unknown} thing
 *   Thing to check (typically `Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`).
 *   If a node is passed it must be a `Text` node, whose `value` field is
 *   checked.
 */ function $884a9b365e67f328$export$7af1228ff777d175(thing) {
    /** @type {string} */ const value = // @ts-expect-error looks like a node.
    thing && typeof thing === 'object' && thing.type === 'text' ? thing.value || '' : thing;
    // HTML whitespace expression.
    // See <https://infra.spec.whatwg.org/#ascii-whitespace>.
    return typeof value === 'string' && value.replace(/[ \t\n\f\r]/g, '') === '';
}



/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $3a9f3ae734b0d8e0$export$98e6a39c04603d36(value) {
    const input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $3a9f3ae734b0d8e0$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}


/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $ed3263ffc32b26c3$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || '');
    let index = input.indexOf(',');
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $ed3263ffc32b26c3$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === '' ? [
        ...values,
        ''
    ] : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}


var $83d47c6533981519$exports = {};
var $4bfb2ce95f055780$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $4bfb2ce95f055780$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $4bfb2ce95f055780$var$NEWLINE_REGEX = /\n/g;
var $4bfb2ce95f055780$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $4bfb2ce95f055780$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $4bfb2ce95f055780$var$COLON_REGEX = /^:\s*/;
var $4bfb2ce95f055780$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $4bfb2ce95f055780$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $4bfb2ce95f055780$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $4bfb2ce95f055780$var$NEWLINE = '\n';
var $4bfb2ce95f055780$var$FORWARD_SLASH = '/';
var $4bfb2ce95f055780$var$ASTERISK = '*';
var $4bfb2ce95f055780$var$EMPTY_STRING = '';
// types
var $4bfb2ce95f055780$var$TYPE_COMMENT = 'comment';
var $4bfb2ce95f055780$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $4bfb2ce95f055780$exports = function(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($4bfb2ce95f055780$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($4bfb2ce95f055780$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($4bfb2ce95f055780$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($4bfb2ce95f055780$var$FORWARD_SLASH != style.charAt(0) || $4bfb2ce95f055780$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($4bfb2ce95f055780$var$EMPTY_STRING != style.charAt(i) && ($4bfb2ce95f055780$var$ASTERISK != style.charAt(i) || $4bfb2ce95f055780$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($4bfb2ce95f055780$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $4bfb2ce95f055780$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($4bfb2ce95f055780$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($4bfb2ce95f055780$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($4bfb2ce95f055780$var$VALUE_REGEX);
        var ret = pos({
            type: $4bfb2ce95f055780$var$TYPE_DECLARATION,
            property: $4bfb2ce95f055780$var$trim(prop[0].replace($4bfb2ce95f055780$var$COMMENT_REGEX, $4bfb2ce95f055780$var$EMPTY_STRING)),
            value: val ? $4bfb2ce95f055780$var$trim(val[0].replace($4bfb2ce95f055780$var$COMMENT_REGEX, $4bfb2ce95f055780$var$EMPTY_STRING)) : $4bfb2ce95f055780$var$EMPTY_STRING
        });
        // ;
        match($4bfb2ce95f055780$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $4bfb2ce95f055780$var$trim(str) {
    return str ? str.replace($4bfb2ce95f055780$var$TRIM_REGEX, $4bfb2ce95f055780$var$EMPTY_STRING) : $4bfb2ce95f055780$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $83d47c6533981519$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== 'string') return output;
    var declaration;
    var declarations = $4bfb2ce95f055780$exports(style);
    var hasIterator = typeof iterator === 'function';
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$83d47c6533981519$exports = $83d47c6533981519$var$StyleToObject;
$83d47c6533981519$exports.default = $83d47c6533981519$var$StyleToObject; // ESM support


var $bef4ebf30b555c77$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($83d47c6533981519$exports)));


const $130271a4f3f9045b$var$protocols = [
    'http',
    'https',
    'mailto',
    'tel'
];
function $130271a4f3f9045b$export$b83532a10e2e268b(uri) {
    const url = (uri || '').trim();
    const first = url.charAt(0);
    if (first === '#' || first === '/') return url;
    const colon = url.indexOf(':');
    if (colon === -1) return url;
    let index = -1;
    while(++index < $130271a4f3f9045b$var$protocols.length){
        const protocol = $130271a4f3f9045b$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf('?');
    if (index !== -1 && colon > index) return url;
    index = url.indexOf('#');
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return 'javascript:void(0)';
}


const $260958202aac04d8$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $260958202aac04d8$var$tableElements = new Set([
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr'
]);
function $260958202aac04d8$export$4b745c302603ab5d(context, node) {
    /** @type {Array<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === 'element') children.push($260958202aac04d8$var$toReact(context, child, childIndex, node));
        else if (child.type === 'text') // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we drop it.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        // See: <https://github.com/remarkjs/react-markdown/issues/576>.
        {
            if (node.type !== 'element' || !$260958202aac04d8$var$tableElements.has(node.tagName) || !(0, $884a9b365e67f328$export$7af1228ff777d175)(child)) children.push(child.value);
        } else if (child.type === 'raw' && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $260958202aac04d8$var$toReact(context, node, index, parent) {
    const options = context.options;
    const transform = options.transformLinkUri === undefined ? (0, $130271a4f3f9045b$export$b83532a10e2e268b) : options.transformLinkUri;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Record<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === 'html' && name === 'svg') {
        schema = (0, $39a014b88522a962$export$7ed1367e7fa1ad68);
        context.schema = schema;
    }
    if (node.properties) {
        for(property in node.properties)if ($260958202aac04d8$var$own.call(node.properties, property)) $260958202aac04d8$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === 'ol' || name === 'ul') context.listDepth++;
    const children = $260958202aac04d8$export$4b745c302603ab5d(context, node);
    if (name === 'ol' || name === 'ul') context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the position interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $260958202aac04d8$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === 'string' || component === (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Fragment;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($2d222ef6f692482f$exports))).isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = index;
    if (name === 'a' && options.linkTarget) properties.target = typeof options.linkTarget === 'function' ? options.linkTarget(String(properties.href || ''), node.children, typeof properties.title === 'string' ? properties.title : null) : options.linkTarget;
    if (name === 'a' && transform) properties.href = transform(String(properties.href || ''), node.children, typeof properties.title === 'string' ? properties.title : null);
    if (!basic && name === 'code' && parent.type === 'element' && parent.tagName !== 'pre') properties.inline = true;
    if (!basic && (name === 'h1' || name === 'h2' || name === 'h3' || name === 'h4' || name === 'h5' || name === 'h6')) properties.level = Number.parseInt(name.charAt(1), 10);
    if (name === 'img' && options.transformImageUri) properties.src = options.transformImageUri(String(properties.src || ''), String(properties.alt || ''), typeof properties.title === 'string' ? properties.title : null);
    if (!basic && name === 'li' && parent.type === 'element') {
        const input = $260958202aac04d8$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $260958202aac04d8$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === 'ol';
    }
    if (!basic && (name === 'ol' || name === 'ul')) {
        properties.ordered = name === 'ol';
        properties.depth = context.listDepth;
    }
    if (name === 'td' || name === 'th') {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === 'th';
    }
    if (!basic && name === 'tr' && parent.type === 'element') properties.isHeader = Boolean(parent.tagName === 'thead');
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties['data-sourcepos'] = $260958202aac04d8$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $260958202aac04d8$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $260958202aac04d8$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(component, properties, children) : (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $260958202aac04d8$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === 'element' && child.tagName === 'input') return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $260958202aac04d8$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === 'element') count++;
    }
    return count;
}
/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $260958202aac04d8$var$addProperty(props, prop, value, ctx) {
    const info = (0, $454a6da6066de284$export$71aa6c912b956294)(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (Array.isArray(result)) result = info.commaSeparated ? (0, $ed3263ffc32b26c3$export$fac44ee5b035f737)(result) : (0, $3a9f3ae734b0d8e0$export$fac44ee5b035f737)(result);
    if (info.property === 'style' && typeof result === 'string') result = $260958202aac04d8$var$parseStyle(result);
    if (info.space && info.property) props[$260958202aac04d8$var$own.call((0, $2d35a7d0373f11c8$export$d8abd7e5fb6871f9), info.property) ? (0, $2d35a7d0373f11c8$export$d8abd7e5fb6871f9)[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Record<string, string>}
 */ function $260958202aac04d8$var$parseStyle(value) {
    /** @type {Record<string, string>} */ const result = {};
    try {
        (0, $bef4ebf30b555c77$export$2e2bcd8739ae039)(value, iterator);
    } catch  {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === '-ms-' ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $260958202aac04d8$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $260958202aac04d8$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $260958202aac04d8$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ':',
        pos.start.column,
        '-',
        pos.end.line,
        ':',
        pos.end.column
    ].map(String).join('');
}


const $c42c946472de67cd$var$own = {}.hasOwnProperty;
const $c42c946472de67cd$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/** @type {Record<string, Deprecation>} */ const $c42c946472de67cd$var$deprecated = {
    plugins: {
        to: 'remarkPlugins',
        id: 'change-plugins-to-remarkplugins'
    },
    renderers: {
        to: 'components',
        id: 'change-renderers-to-components'
    },
    astPlugins: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    allowDangerousHtml: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    escapeHtml: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    source: {
        to: 'children',
        id: 'change-source-to-children'
    },
    allowNode: {
        to: 'allowElement',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    allowedTypes: {
        to: 'allowedElements',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    disallowedTypes: {
        to: 'disallowedElements',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    includeNodeIndex: {
        to: 'includeElementIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    }
};
function $c42c946472de67cd$export$83ef7ab426386201(options) {
    for(const key in $c42c946472de67cd$var$deprecated)if ($c42c946472de67cd$var$own.call($c42c946472de67cd$var$deprecated, key) && $c42c946472de67cd$var$own.call(options, key)) {
        const deprecation = $c42c946472de67cd$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : 'remove'} \`${key}\` (see <${$c42c946472de67cd$var$changelog}#${deprecation.id}> for more info)`);
        delete $c42c946472de67cd$var$deprecated[key];
    }
    const processor = (0, $97703616b9c45baa$export$7cc1b2fe10c52bb)().use((0, $c36d7d9fb278a9e7$export$2e2bcd8739ae039)).use(options.remarkPlugins || []).use((0, $65553fdcf071d6cf$export$2e2bcd8739ae039), {
        ...options.remarkRehypeOptions,
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use((0, $3fdc03b2a6cd86d2$export$2e2bcd8739ae039), options);
    const file = new (0, $99c37b7e983cdc2d$export$93dff69eb10dc7ce)();
    if (typeof options.children === 'string') file.value = options.children;
    else if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== 'root') throw new TypeError('Expected a `root` node');
    /** @type {ReactElement} */ let result = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Fragment, {}, (0, $260958202aac04d8$export$4b745c302603ab5d)({
        options: options,
        schema: (0, $39a014b88522a962$export$c0bb0b647f701bb5),
        listDepth: 0
    }, hastNode));
    if (options.className) result = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement('div', {
        className: options.className
    }, result);
    return result;
}
$c42c946472de67cd$export$83ef7ab426386201.propTypes = {
    // Core options:
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    // Layout options:
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    // Filter options:
    allowElement: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    allowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string),
    disallowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string),
    unwrapDisallowed: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    // Plugin options:
    remarkPlugins: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).any)
        ]))
    ])),
    rehypePlugins: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).any)
        ]))
    ])),
    // Transform options:
    sourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    rawSourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    skipHtml: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    includeElementIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    transformLinkUri: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool
    ]),
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string
    ]),
    transformImageUri: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object
};





// Replacement regexes, ideally standardize copy to avoid complex regexs
const $e8f52fff32e142fb$var$titleReg = /\[REP\/SEN NAME\]|\[SENATOR\/REP NAME\]/gi;
const $e8f52fff32e142fb$var$locationReg = /\[CITY,\s?ZIP\]|\[CITY,\s?STATE\]/gi;
class $e8f52fff32e142fb$var$Script extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    componentDidMount() {
        let scriptMarkdown = '';
        let requiredState = undefined;
        let issueId = undefined;
        if (this.scriptRef.current?.parentElement) {
            scriptMarkdown = this.scriptRef.current.parentElement.dataset.scriptMarkdown ?? '';
            requiredState = this.scriptRef.current.parentElement.dataset.requiredState;
            issueId = this.scriptRef.current.parentElement.dataset.issueId;
            this.setState({
                scriptMarkdown: scriptMarkdown,
                requiredState: requiredState,
                issueId: issueId
            });
        }
        document.addEventListener($58e79092af177c1d$export$7ff69bf5c61582bf.ACTIVE_CONTACT, (e)=>{
            const contact = e.detail;
            this.setState({
                currentContact: contact
            });
        });
        document.addEventListener($58e79092af177c1d$export$7ff69bf5c61582bf.LOADED_REPS, (e)=>{
            const contactIds = e.detail;
            this.fetchCustomizedScripts(contactIds);
        });
    }
    render() {
        let contact = this.state.currentContact;
        // if the current location does not match the required state, set the contact back to undefined for the script
        if (this.state.requiredState && this.state.requiredState !== this.props.locationState?.state) contact = undefined;
        // Use customized script if available for the current contact
        let scriptToDisplay = this.state.scriptMarkdown;
        if (contact && this.state.customizedScripts && this.state.customizedScripts[contact.id]) scriptToDisplay = this.state.customizedScripts[contact.id];
        const formattedScriptMarkdown = this.scriptFormat(scriptToDisplay, this.props.locationState, contact);
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
            ref: this.scriptRef,
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: formattedScriptMarkdown.length > 0 ? 'contact-content' : '',
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c42c946472de67cd$export$83ef7ab426386201), {
                    children: formattedScriptMarkdown
                })
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            scriptMarkdown: ''
        }, this.scriptRef = /*#__PURE__*/ (0, $gIfym.createRef)(), this.getContactNameWithTitle = (contact)=>{
            let title = '';
            switch(contact.area){
                case 'US House':
                case 'House':
                    title = 'Rep. ';
                    break;
                case 'US Senate':
                case 'Senate':
                    title = 'Senator ';
                    break;
                case 'StateLower':
                case 'StateUpper':
                    title = 'Legislator ';
                    break;
                case 'Governor':
                    title = 'Governor ';
                    break;
                case 'AttorneysGeneral':
                    title = 'Attorney General ';
                    break;
                case 'SecretaryOfState':
                    title = 'Secretary of State ';
                    break;
                default:
                    title = '';
            }
            return title + contact.name;
        }, this.scriptFormat = (script, locationState, contact)=>{
            const location = locationState?.cachedCity;
            if (location) script = script.replace($e8f52fff32e142fb$var$locationReg, location);
            if (contact) {
                const title = this.getContactNameWithTitle(contact);
                script = script.replace($e8f52fff32e142fb$var$titleReg, title);
            }
            return script;
        }, this.fetchCustomizedScripts = async (contactIds)=>{
            if (!this.state.issueId && !this.props.locationState?.cachedCity) return;
            if (contactIds.length === 0) return;
            try {
                const customizedScripts = await (0, $c6a51ca48f202faf$export$9781bb1abede0d7e)(this.state.issueId || '', contactIds, this.props.locationState?.cachedCity || '');
                this.setState({
                    customizedScripts: customizedScripts
                });
            } catch (error) {
                console.error('Error fetching customized scripts:', error);
            }
        };
    }
}
var $e8f52fff32e142fb$export$2e2bcd8739ae039 = (0, $b410c744327f470f$export$71260fd0c34a821)($e8f52fff32e142fb$var$Script);




var $gIfym = parcelRequire("gIfym");


class $caeedc682adc97d4$var$Outcomes extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    componentDidMount() {
        let requiredState = '';
        if (this.outcomesRef.current && this.outcomesRef.current.parentElement) {
            const outcomes = (this.outcomesRef.current.parentElement.dataset.outcomes ?? '').split(',');
            requiredState = this.outcomesRef.current.parentElement.dataset.requiredState ?? '';
            this.setState({
                outcomes: outcomes,
                requiredState: requiredState
            });
        }
        // Check if reps are already loaded (handles race condition)
        const repsElement = document.getElementById('react-reps');
        if (repsElement && repsElement.querySelector('.rep-info')) this.setState({
            repsLoaded: true
        });
        document.addEventListener($58e79092af177c1d$export$7ff69bf5c61582bf.LOADED_REPS, ()=>{
            this.setState({
                repsLoaded: true
            });
        });
    }
    next(outcome) {
        const event = new CustomEvent($58e79092af177c1d$export$7ff69bf5c61582bf.NEXT_CONTACT, {
            detail: outcome
        });
        document.dispatchEvent(event);
    }
    render() {
        if (!this.state.repsLoaded) // this has to be a real element, not a fragment, because we need a reference to it
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            ref: this.outcomesRef
        });
        if (this.state.requiredState !== '' && this.state.requiredState !== this.props.locationState?.state) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            ref: this.outcomesRef
        });
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            ref: this.outcomesRef,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h3", {
                    children: "After your call, share the result to show the next representative:"
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "outcomes-items",
                    children: this.state.outcomes.map((outcome)=>{
                        const eventClassName = `plausible-event-name=Outcome-${outcome}`;
                        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                            className: eventClassName,
                            onClick: ()=>this.next(outcome),
                            children: outcome
                        }, outcome);
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this._defaultOutcomes = [], this.state = {
            outcomes: this._defaultOutcomes,
            repsLoaded: false,
            requiredState: ''
        }, this.outcomesRef = /*#__PURE__*/ (0, $gIfym.createRef)();
    }
}
var $caeedc682adc97d4$export$2e2bcd8739ae039 = (0, $b410c744327f470f$export$71260fd0c34a821)($caeedc682adc97d4$var$Outcomes);




var $gIfym = parcelRequire("gIfym");

class $52c5cd1f6962a23d$var$Share extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    componentDidMount() {
        const thisComponent = this.componentRef.current;
        if (thisComponent && thisComponent.parentElement) {
            const issueId = thisComponent.parentElement.dataset.issueId ?? '';
            const issueSlug = thisComponent.parentElement.dataset.issueSlug ?? '';
            const issueTitle = thisComponent.parentElement.dataset.issueTitle ?? '';
            this.setState({
                issueSlug: issueSlug,
                issueId: issueId,
                issueTitle: issueTitle
            });
        }
    }
    share(e, type) {
        e.preventDefault();
        const tweet = encodeURIComponent(`I just called my reps with 5 Calls, you should too: 5calls.org`);
        if (type === 'facebook') window.open('https://www.facebook.com/sharer/sharer.php?u=https://5calls.org', 'sharewindow', 'width=500, height=350');
        else if (type === 'bluesky') {
            const bskyTweet = encodeURIComponent(`I just called my reps with @5calls.org, you should too: https://5calls.org`);
            window.open(`https://bsky.app/intent/compose?text=${bskyTweet}`, 'sharewindow', 'width=500, height=350');
        } else if (type === 'threads') window.open(`https://threads.net/intent/post?text=${tweet}`, 'sharewindow', 'width=500, height=350');
        else if (type === 'mastodon') window.open(`https://mastodonshare.com/?text=${tweet}&url=5calls.org`, 'sharewindow', 'width=500, height=350');
        else {
            const issueURL = `${(0, $58e79092af177c1d$export$bbd8abc0926efbd6)}/issue/${this.state.issueSlug}/`;
            window.open(`https://twitter.com/share?url=${issueURL}&text=${tweet}`, 'sharewindow', 'width=500, height=350');
        }
    }
    render() {
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            ref: this.componentRef,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h3", {
                    children: "Share this call"
                }),
                this.state.issueId !== '' ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                    src: `https://api.5calls.org/v1/issue/${this.state.issueId}/share/t`,
                    alt: "Share this issue",
                    className: "call__complete__share__img"
                }) : null,
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: "share-links",
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                            className: "share-bluesky",
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("a", {
                                href: "https://5calls.org",
                                onClick: (e)=>this.share(e, 'bluesky'),
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("i", {
                                        className: "fa-brands fa-bluesky",
                                        "aria-hidden": "true"
                                    }),
                                    "Share on Bluesky"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                            className: "share-threads",
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("a", {
                                href: "https://5calls.org",
                                onClick: (e)=>this.share(e, 'threads'),
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("i", {
                                        className: "fab fa-threads",
                                        "aria-hidden": "true"
                                    }),
                                    "Share on Threads"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                            className: "share-facebook",
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("a", {
                                href: "https://5calls.org",
                                onClick: (e)=>this.share(e, 'facebook'),
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("i", {
                                        className: "fab fa-facebook",
                                        "aria-hidden": "true"
                                    }),
                                    "Share on Facebook"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                            className: "share-mastodon",
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("a", {
                                href: "https://5calls.org",
                                onClick: (e)=>this.share(e, 'mastodon'),
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("i", {
                                        className: "fab fa-mastodon",
                                        "aria-hidden": "true"
                                    }),
                                    "Share on Mastodon"
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.componentRef = /*#__PURE__*/ (0, $gIfym.createRef)(), this.state = {
            issueSlug: '',
            issueId: '',
            issueTitle: ''
        };
    }
}
var $52c5cd1f6962a23d$export$2e2bcd8739ae039 = $52c5cd1f6962a23d$var$Share;





const $86ba9697a5186f8b$var$openDonate = (amount, refcode)=>{
    window.open(`${(0, $58e79092af177c1d$export$d09dd1b4474f0ce6)}?refcode=${refcode}&refcode2=${(0, $e90bc56065a3c90c$export$2e2bcd8739ae039).callerID()}&amount=${amount}`, '_blank');
};
const $86ba9697a5186f8b$var$globalAdditions = {
    openDonate: $86ba9697a5186f8b$var$openDonate
};
window.fivecalls = $86ba9697a5186f8b$var$globalAdditions;







var $gIfym = parcelRequire("gIfym");

// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $b28c6832f534c4f2$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|2[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "(?:01\\d|[24-689])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[235]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                        "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "46"
                    ]
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6|90"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6|7[245]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ]
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "3[2-8]\\d{9,10}",
                    [
                        11,
                        12
                    ]
                ],
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[0135-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(0-$1)",
                    1
                ]
            ],
            "0",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|452|678|86",
                        "[12]|452|6788|86"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]|8(?:0[6-9]|[36])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[0467]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",
            [
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "709\\d{6}|(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "[6-9]\\d{6}|[1-6]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "(?:[2489]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|7[67]|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-359]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-4]|5[1-3]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[59]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[689]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[1245]|3[12])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "(?:[1-6]\\d|71)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[67]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "305209\\d{4}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "00",
            "(?:20|33|[5-9]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ]
                ]
            ]
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[47-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2|39"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|[579]\\d|63)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[235-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "2\\d{8}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                [
                    "348[57]\\d{7}",
                    [
                        11
                    ]
                ],
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


var $44aa0138f2d567ea$var$objectConstructor = {}.constructor;
function $44aa0138f2d567ea$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $44aa0138f2d567ea$var$objectConstructor;
}


function $a4d39dceedf7ded8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a4d39dceedf7ded8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a4d39dceedf7ded8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a4d39dceedf7ded8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a4d39dceedf7ded8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a4d39dceedf7ded8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a4d39dceedf7ded8$var$_slicedToArray(arr, i) {
    return $a4d39dceedf7ded8$var$_arrayWithHoles(arr) || $a4d39dceedf7ded8$var$_iterableToArrayLimit(arr, i) || $a4d39dceedf7ded8$var$_unsupportedIterableToArray(arr, i) || $a4d39dceedf7ded8$var$_nonIterableRest();
}
function $a4d39dceedf7ded8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a4d39dceedf7ded8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a4d39dceedf7ded8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a4d39dceedf7ded8$var$_arrayLikeToArray(o, minLen);
}
function $a4d39dceedf7ded8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a4d39dceedf7ded8$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a4d39dceedf7ded8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a4d39dceedf7ded8$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $a4d39dceedf7ded8$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === 'string') text = arg_1;
    else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === 'string') {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $a4d39dceedf7ded8$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $44aa0138f2d567ea$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $c3f1799a1fbf8600$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $c3f1799a1fbf8600$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $c3f1799a1fbf8600$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $c3f1799a1fbf8600$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $c3f1799a1fbf8600$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $c3f1799a1fbf8600$var$SLASHES = "\uFF0F/";
var $c3f1799a1fbf8600$var$DOTS = "\uFF0E.";
var $c3f1799a1fbf8600$export$20542845033f576e = " \xA0\xAD\u200B\u2060\u3000";
var $c3f1799a1fbf8600$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $c3f1799a1fbf8600$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $c3f1799a1fbf8600$export$7f01587e28f9194 = "".concat($c3f1799a1fbf8600$var$DASHES).concat($c3f1799a1fbf8600$var$SLASHES).concat($c3f1799a1fbf8600$var$DOTS).concat($c3f1799a1fbf8600$export$20542845033f576e).concat($c3f1799a1fbf8600$var$BRACKETS).concat($c3f1799a1fbf8600$var$TILDES);
var $c3f1799a1fbf8600$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $7964f777f49bfcfe$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $7964f777f49bfcfe$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $7964f777f49bfcfe$var$_typeof(obj);
}
function $7964f777f49bfcfe$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7964f777f49bfcfe$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7964f777f49bfcfe$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7964f777f49bfcfe$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7964f777f49bfcfe$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7964f777f49bfcfe$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7964f777f49bfcfe$var$_setPrototypeOf(subClass, superClass);
}
function $7964f777f49bfcfe$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7964f777f49bfcfe$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7964f777f49bfcfe$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7964f777f49bfcfe$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7964f777f49bfcfe$var$_possibleConstructorReturn(this, result);
    };
}
function $7964f777f49bfcfe$var$_possibleConstructorReturn(self, call) {
    if (call && ($7964f777f49bfcfe$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7964f777f49bfcfe$var$_assertThisInitialized(self);
}
function $7964f777f49bfcfe$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7964f777f49bfcfe$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $7964f777f49bfcfe$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$7964f777f49bfcfe$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $7964f777f49bfcfe$var$_construct(Class, arguments, $7964f777f49bfcfe$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $7964f777f49bfcfe$var$_setPrototypeOf(Wrapper, Class);
    };
    return $7964f777f49bfcfe$var$_wrapNativeSuper(Class);
}
function $7964f777f49bfcfe$var$_construct(Parent, args, Class) {
    if ($7964f777f49bfcfe$var$_isNativeReflectConstruct()) $7964f777f49bfcfe$var$_construct = Reflect.construct;
    else $7964f777f49bfcfe$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $7964f777f49bfcfe$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $7964f777f49bfcfe$var$_construct.apply(null, arguments);
}
function $7964f777f49bfcfe$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7964f777f49bfcfe$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $7964f777f49bfcfe$var$_setPrototypeOf(o, p) {
    $7964f777f49bfcfe$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7964f777f49bfcfe$var$_setPrototypeOf(o, p);
}
function $7964f777f49bfcfe$var$_getPrototypeOf(o) {
    $7964f777f49bfcfe$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7964f777f49bfcfe$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $7964f777f49bfcfe$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $7964f777f49bfcfe$var$_inherits(ParseError, _Error);
    var _super = $7964f777f49bfcfe$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $7964f777f49bfcfe$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($7964f777f49bfcfe$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $7964f777f49bfcfe$var$_createClass(ParseError);
}(/*#__PURE__*/ $7964f777f49bfcfe$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $033c71c199e81868$export$2e2bcd8739ae039(a, b) {
    a = a.split('-');
    b = b.split('-');
    var pa = a[0].split('.');
    var pb = b[0].split('.');
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}



function $0590493bd26b93ec$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0590493bd26b93ec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0590493bd26b93ec$var$_typeof(obj);
}
function $0590493bd26b93ec$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0590493bd26b93ec$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0590493bd26b93ec$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0590493bd26b93ec$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0590493bd26b93ec$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $0590493bd26b93ec$var$V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".
var $0590493bd26b93ec$var$V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.
var $0590493bd26b93ec$var$V4 = '1.7.35';
var $0590493bd26b93ec$var$DEFAULT_EXT_PREFIX = ' ext. ';
var $0590493bd26b93ec$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $0590493bd26b93ec$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $0590493bd26b93ec$var$_classCallCheck(this, Metadata);
        $0590493bd26b93ec$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $0590493bd26b93ec$var$setVersion.call(this, metadata);
    }
    $0590493bd26b93ec$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== '001';
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $0590493bd26b93ec$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== '001') {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $0590493bd26b93ec$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $0590493bd26b93ec$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return this.metadata.countries['001'];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $0590493bd26b93ec$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $0590493bd26b93ec$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $0590493bd26b93ec$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $0590493bd26b93ec$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $0590493bd26b93ec$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $0590493bd26b93ec$var$getType(this.types(), _type2)) return new $0590493bd26b93ec$var$Type($0590493bd26b93ec$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $0590493bd26b93ec$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $0590493bd26b93ec$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $0590493bd26b93ec$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $0590493bd26b93ec$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $0590493bd26b93ec$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$0590493bd26b93ec$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $0590493bd26b93ec$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $0590493bd26b93ec$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $0590493bd26b93ec$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $0590493bd26b93ec$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $0590493bd26b93ec$var$getType(types, type) {
    switch(type){
        case 'FIXED_LINE':
            return types[0];
        case 'MOBILE':
            return types[1];
        case 'TOLL_FREE':
            return types[2];
        case 'PREMIUM_RATE':
            return types[3];
        case 'PERSONAL_NUMBER':
            return types[4];
        case 'VOICEMAIL':
            return types[5];
        case 'UAN':
            return types[6];
        case 'PAGER':
            return types[7];
        case 'VOIP':
            return types[8];
        case 'SHARED_COST':
            return types[9];
    }
}
function $0590493bd26b93ec$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
     // `country_phone_code_to_countries` was renamed to `country_calling_codes` in `1.0.18`.
    // For that reason, it's not used in this detection algorithm.
    // Instead, it detects by `countries: {}` property existence.
    if (!(0, $44aa0138f2d567ea$export$2e2bcd8739ae039)(metadata) || !(0, $44aa0138f2d567ea$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $44aa0138f2d567ea$export$2e2bcd8739ae039)(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + $0590493bd26b93ec$var$typeOf(metadata) + ': ' + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $0590493bd26b93ec$var$typeOf = function typeOf(_) {
    return $0590493bd26b93ec$var$_typeof(_);
};
function $0590493bd26b93ec$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $0590493bd26b93ec$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $0590493bd26b93ec$var$DEFAULT_EXT_PREFIX;
}
function $0590493bd26b93ec$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $0590493bd26b93ec$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $0590493bd26b93ec$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $0590493bd26b93ec$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === 'number') {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $033c71c199e81868$export$2e2bcd8739ae039)(version, $0590493bd26b93ec$var$V3) === -1) this.v2 = true;
        else if ((0, $033c71c199e81868$export$2e2bcd8739ae039)(version, $0590493bd26b93ec$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




var $3c5e53da9fefb3e9$var$RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $3c5e53da9fefb3e9$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $c3f1799a1fbf8600$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $3c5e53da9fefb3e9$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = '20';
    /** @type {string} */ var extLimitAfterLikelyLabel = '15';
    /** @type {string} */ var extLimitAfterAmbiguousChar = '9';
    /** @type {string} */ var extLimitWhenNotSure = '6';
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $3c5e53da9fefb3e9$var$RFC3966_EXTN_PREFIX + $3c5e53da9fefb3e9$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $3c5e53da9fefb3e9$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $3c5e53da9fefb3e9$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $3c5e53da9fefb3e9$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $3c5e53da9fefb3e9$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $3c5e53da9fefb3e9$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $d3161e893522ec1c$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + (0, $c3f1799a1fbf8600$export$852d1d4a47329634) + ']{' + (0, $c3f1799a1fbf8600$export$cd8355bcbe13154) + '}'; //
var $d3161e893522ec1c$export$a77dd7471651eee = '[' + (0, $c3f1799a1fbf8600$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $c3f1799a1fbf8600$export$7f01587e28f9194) + ']*' + '[' + (0, $c3f1799a1fbf8600$export$852d1d4a47329634) + ']' + '){3,}' + '[' + (0, $c3f1799a1fbf8600$export$7f01587e28f9194) + (0, $c3f1799a1fbf8600$export$852d1d4a47329634) + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $d3161e893522ec1c$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $c3f1799a1fbf8600$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $c3f1799a1fbf8600$export$7f01587e28f9194) + ']*' + '[' + (0, $c3f1799a1fbf8600$export$852d1d4a47329634) + ']' + '){1,2}' + '$', 'i');
var $d3161e893522ec1c$export$a2d12a04749c087d = $d3161e893522ec1c$export$a77dd7471651eee + // Phone number extensions
'(?:' + (0, $3c5e53da9fefb3e9$export$2e2bcd8739ae039)() + ')?'; // The combined regular expression for valid phone numbers:
//
var $d3161e893522ec1c$var$VALID_PHONE_NUMBER_PATTERN = new RegExp('^' + $d3161e893522ec1c$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + $d3161e893522ec1c$export$a2d12a04749c087d + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
function $d3161e893522ec1c$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $c3f1799a1fbf8600$export$cd8355bcbe13154) && $d3161e893522ec1c$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $d3161e893522ec1c$export$4c3f76c95c05197c(number) {
    return $d3161e893522ec1c$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// 1 or more valid digits, for use when parsing.
var $229e7b00da8416dc$var$EXTN_PATTERN = new RegExp('(?:' + (0, $3c5e53da9fefb3e9$export$2e2bcd8739ae039)() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
function $229e7b00da8416dc$export$2e2bcd8739ae039(number) {
    var start = number.search($229e7b00da8416dc$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($229e7b00da8416dc$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $6825703ef2c60546$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $6825703ef2c60546$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6825703ef2c60546$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6825703ef2c60546$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6825703ef2c60546$var$_arrayLikeToArray(o, minLen);
}
function $6825703ef2c60546$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $6825703ef2c60546$export$2848f3d68c08fe69 = {
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    "\uFF10": '0',
    // Fullwidth digit 0
    "\uFF11": '1',
    // Fullwidth digit 1
    "\uFF12": '2',
    // Fullwidth digit 2
    "\uFF13": '3',
    // Fullwidth digit 3
    "\uFF14": '4',
    // Fullwidth digit 4
    "\uFF15": '5',
    // Fullwidth digit 5
    "\uFF16": '6',
    // Fullwidth digit 6
    "\uFF17": '7',
    // Fullwidth digit 7
    "\uFF18": '8',
    // Fullwidth digit 8
    "\uFF19": '9',
    // Fullwidth digit 9
    "\u0660": '0',
    // Arabic-indic digit 0
    "\u0661": '1',
    // Arabic-indic digit 1
    "\u0662": '2',
    // Arabic-indic digit 2
    "\u0663": '3',
    // Arabic-indic digit 3
    "\u0664": '4',
    // Arabic-indic digit 4
    "\u0665": '5',
    // Arabic-indic digit 5
    "\u0666": '6',
    // Arabic-indic digit 6
    "\u0667": '7',
    // Arabic-indic digit 7
    "\u0668": '8',
    // Arabic-indic digit 8
    "\u0669": '9',
    // Arabic-indic digit 9
    "\u06F0": '0',
    // Eastern-Arabic digit 0
    "\u06F1": '1',
    // Eastern-Arabic digit 1
    "\u06F2": '2',
    // Eastern-Arabic digit 2
    "\u06F3": '3',
    // Eastern-Arabic digit 3
    "\u06F4": '4',
    // Eastern-Arabic digit 4
    "\u06F5": '5',
    // Eastern-Arabic digit 5
    "\u06F6": '6',
    // Eastern-Arabic digit 6
    "\u06F7": '7',
    // Eastern-Arabic digit 7
    "\u06F8": '8',
    // Eastern-Arabic digit 8
    "\u06F9": '9' // Eastern-Arabic digit 9
};
function $6825703ef2c60546$export$1d16fddea1437169(character) {
    return $6825703ef2c60546$export$2848f3d68c08fe69[character];
}
function $6825703ef2c60546$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $6825703ef2c60546$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $6825703ef2c60546$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $e396a6068e8c6718$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $e396a6068e8c6718$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e396a6068e8c6718$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e396a6068e8c6718$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e396a6068e8c6718$var$_arrayLikeToArray(o, minLen);
}
function $e396a6068e8c6718$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e396a6068e8c6718$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $e396a6068e8c6718$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $e396a6068e8c6718$export$13d8790d7fb84c28(character, result) || '';
    }
    return result;
}
function $e396a6068e8c6718$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === '+') {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === 'function') emitEvent('end');
            return;
        }
        return '+';
    } // Allow digits.
    return (0, $6825703ef2c60546$export$1d16fddea1437169)(character);
}




function $e34422b372e8def0$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $e34422b372e8def0$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e34422b372e8def0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e34422b372e8def0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e34422b372e8def0$var$_arrayLikeToArray(o, minLen);
}
function $e34422b372e8def0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e34422b372e8def0$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $e34422b372e8def0$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $0888407f8e63541a$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $0888407f8e63541a$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $0888407f8e63541a$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return 'IS_POSSIBLE';
    if (type === 'FIXED_LINE_OR_MOBILE') {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type('FIXED_LINE')) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $0888407f8e63541a$export$69333f603c7d5931(nationalNumber, 'MOBILE', metadata);
        var mobile_type = metadata.type('MOBILE');
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $e34422b372e8def0$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return 'INVALID_LENGTH';
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return 'IS_POSSIBLE';
    if (minimum_length > actual_length) return 'TOO_SHORT';
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return 'TOO_LONG';
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}


function $aec3897292a25ad6$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $aec3897292a25ad6$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $aec3897292a25ad6$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $0888407f8e63541a$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case 'IS_POSSIBLE':
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $16146d1487a2c594$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || '';
    return new RegExp('^(?:' + regular_expression + ')$').test(text);
}




function $ed5777e409fb1224$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $ed5777e409fb1224$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ed5777e409fb1224$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ed5777e409fb1224$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ed5777e409fb1224$var$_arrayLikeToArray(o, minLen);
}
function $ed5777e409fb1224$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ed5777e409fb1224$var$NON_FIXED_LINE_PHONE_TYPES = [
    'MOBILE',
    'PREMIUM_RATE',
    'TOLL_FREE',
    'SHARED_COST',
    'VOIP',
    'PERSONAL_NUMBER',
    'PAGER',
    'UAN',
    'VOICEMAIL'
]; // Finds out national phone number type (fixed line, mobile, etc)
function $ed5777e409fb1224$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $16146d1487a2c594$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($ed5777e409fb1224$export$7bd37b39ade0214d(nationalNumber, 'FIXED_LINE', metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') return 'FIXED_LINE_OR_MOBILE';
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type('MOBILE')) return 'FIXED_LINE_OR_MOBILE';
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($ed5777e409fb1224$export$7bd37b39ade0214d(nationalNumber, 'MOBILE', metadata)) return 'FIXED_LINE_OR_MOBILE';
        return 'FIXED_LINE';
    }
    for(var _iterator = $ed5777e409fb1224$var$_createForOfIteratorHelperLoose($ed5777e409fb1224$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($ed5777e409fb1224$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $ed5777e409fb1224$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $16146d1487a2c594$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $2253b6de06c34566$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $ed5777e409fb1224$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $16146d1487a2c594$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $63a1873be5ec8242$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $63a1873be5ec8242$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $63a1873be5ec8242$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}




var $0680d02b1fc88304$var$CAPTURING_DIGIT_PATTERN = new RegExp('([' + (0, $c3f1799a1fbf8600$export$852d1d4a47329634) + '])');
function $0680d02b1fc88304$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($0680d02b1fc88304$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === '0') return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $50b3bd43df883fc7$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $fb85905a5345e75c$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $50b3bd43df883fc7$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$fb85905a5345e75c$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$fb85905a5345e75c$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $fb85905a5345e75c$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $16146d1487a2c594$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $16146d1487a2c594$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $fb85905a5345e75c$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $0888407f8e63541a$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $3a9a972ae1ee278c$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $0590493bd26b93ec$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $fb85905a5345e75c$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $fb85905a5345e75c$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $16146d1487a2c594$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $16146d1487a2c594$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $0888407f8e63541a$export$2e2bcd8739ae039)(nationalNumber, metadata) === 'TOO_LONG') return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $5f868a9630f3752d$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== '+') {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $0680d02b1fc88304$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = '+' + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $3a9a972ae1ee278c$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === '0') return {};
    metadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $c3f1799a1fbf8600$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }





function $36604584204e0f97$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $c3f1799a1fbf8600$export$7f01587e28f9194), "]+"), 'g'), ' ').trim();
}


var $6253144a9f60cd76$export$4f32ad1c51a7a6be = /(\$\d)/;
function $6253144a9f60cd76$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($6253144a9f60cd76$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $36604584204e0f97$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $a06ec5ffe4513bce$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $a06ec5ffe4513bce$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($a06ec5ffe4513bce$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $cb10284755d68c11$var$_slicedToArray(arr, i) {
    return $cb10284755d68c11$var$_arrayWithHoles(arr) || $cb10284755d68c11$var$_iterableToArrayLimit(arr, i) || $cb10284755d68c11$var$_unsupportedIterableToArray(arr, i) || $cb10284755d68c11$var$_nonIterableRest();
}
function $cb10284755d68c11$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cb10284755d68c11$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $cb10284755d68c11$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $cb10284755d68c11$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $cb10284755d68c11$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cb10284755d68c11$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cb10284755d68c11$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cb10284755d68c11$var$_arrayLikeToArray(o, minLen);
}
function $cb10284755d68c11$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cb10284755d68c11$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, 'tel=');
    for(var _iterator = $cb10284755d68c11$var$_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split('='), _part$split2 = $cb10284755d68c11$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case 'tel':
                number = value;
                break;
            case 'ext':
                ext = value;
                break;
            case 'phone-context':
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === '+') number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $d3161e893522ec1c$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $cb10284755d68c11$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return '';
    if (number[0] !== '+') throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
    return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}


function $c26f804e0733e220$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c26f804e0733e220$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c26f804e0733e220$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c26f804e0733e220$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c26f804e0733e220$var$_arrayLikeToArray(o, minLen);
}
function $c26f804e0733e220$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c26f804e0733e220$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c26f804e0733e220$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c26f804e0733e220$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c26f804e0733e220$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c26f804e0733e220$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c26f804e0733e220$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c26f804e0733e220$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $c26f804e0733e220$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $c26f804e0733e220$var$_objectSpread($c26f804e0733e220$var$_objectSpread({}, $c26f804e0733e220$var$DEFAULT_OPTIONS), options);
    else options = $c26f804e0733e220$var$DEFAULT_OPTIONS;
    metadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== '001') {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || '';
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case 'NATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return '';
            number = $c26f804e0733e220$var$formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
            return $c26f804e0733e220$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'INTERNATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $c26f804e0733e220$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $c26f804e0733e220$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'E.164':
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case 'RFC3966':
            return (0, $cb10284755d68c11$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case 'IDD':
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $c26f804e0733e220$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $c26f804e0733e220$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
    }
}
function $c26f804e0733e220$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $c26f804e0733e220$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $6253144a9f60cd76$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === 'INTERNATIONAL',
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $c26f804e0733e220$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $c26f804e0733e220$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $16146d1487a2c594$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $c26f804e0733e220$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $c26f804e0733e220$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $0590493bd26b93ec$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $c26f804e0733e220$var$formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === '1') return countryCallingCode + ' ' + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $a06ec5ffe4513bce$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($c26f804e0733e220$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
}


function $06a5e55efa4cfd93$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $06a5e55efa4cfd93$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $06a5e55efa4cfd93$var$ownKeys(Object(source), !0).forEach(function(key) {
            $06a5e55efa4cfd93$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $06a5e55efa4cfd93$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $06a5e55efa4cfd93$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $06a5e55efa4cfd93$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $06a5e55efa4cfd93$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $06a5e55efa4cfd93$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $06a5e55efa4cfd93$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $06a5e55efa4cfd93$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $06a5e55efa4cfd93$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $06a5e55efa4cfd93$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $06a5e55efa4cfd93$var$_classCallCheck(this, PhoneNumber);
        // Validate `countryOrCountryCallingCode` argument.
        if (!countryOrCountryCallingCode) throw new TypeError('First argument is required');
        if (typeof countryOrCountryCallingCode !== 'string') throw new TypeError('First argument must be a string');
         // In case of public API use: `constructor(number, metadata)`.
        // Transform the arguments from `constructor(number, metadata)` to
        // `constructor(countryOrCountryCallingCode, nationalNumber, metadata)`.
        if (typeof countryOrCountryCallingCode === 'string') {
            if (countryOrCountryCallingCode[0] === '+' && !nationalNumber) throw new TypeError('`metadata` argument not passed');
            if ((0, $44aa0138f2d567ea$export$2e2bcd8739ae039)(nationalNumber) && (0, $44aa0138f2d567ea$export$2e2bcd8739ae039)(nationalNumber.countries)) {
                metadata = nationalNumber;
                var e164Number = countryOrCountryCallingCode;
                if (!$06a5e55efa4cfd93$var$E164_NUMBER_REGEXP.test(e164Number)) throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
                var _extractCountryCallin = (0, $5f868a9630f3752d$export$2e2bcd8739ae039)(e164Number, undefined, undefined, metadata), _countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                nationalNumber = number;
                countryOrCountryCallingCode = _countryCallingCode;
                if (!nationalNumber) throw new Error('Invalid `number` argument passed: too short');
            }
        } // Validate `nationalNumber` argument.
        if (!nationalNumber) throw new TypeError('`nationalNumber` argument is required');
        if (typeof nationalNumber !== 'string') throw new TypeError('`nationalNumber` argument must be a string');
         // Validate `metadata` argument.
        (0, $0590493bd26b93ec$export$a0b100d4662a8795)(metadata); // Initialize properties.
        var _getCountryAndCountry = $06a5e55efa4cfd93$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = '+' + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $06a5e55efa4cfd93$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $63a1873be5ec8242$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $aec3897292a25ad6$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $2253b6de06c34566$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $ed5777e409fb1224$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $c26f804e0733e220$export$2e2bcd8739ae039)(this, _format, options ? $06a5e55efa4cfd93$var$_objectSpread($06a5e55efa4cfd93$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format('NATIONAL', options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format('INTERNATIONAL', options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format('RFC3966', options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $06a5e55efa4cfd93$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $06a5e55efa4cfd93$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($06a5e55efa4cfd93$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($06a5e55efa4cfd93$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = '001';
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}
var $06a5e55efa4cfd93$var$E164_NUMBER_REGEXP = /^\+\d+$/;








function $19f718f0b4c89744$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $19f718f0b4c89744$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $19f718f0b4c89744$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $19f718f0b4c89744$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $19f718f0b4c89744$var$_arrayLikeToArray(o, minLen);
}
function $19f718f0b4c89744$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $19f718f0b4c89744$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadata); // const matchingCountries = []
    for(var _iterator = $19f718f0b4c89744$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $ed5777e409fb1224$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) // If both the `defaultCountry` and the "main" one match the phone number,
        // don't prefer the `defaultCountry` over the "main" one.
        // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
        return country; // // If the `defaultCountry` is among the `matchingCountries` then return it.
    } // // Return the first ("main") one of the `matchingCountries`.
// if (matchingCountries.length > 0) {
// 	return matchingCountries[0]
// }
}


var $ffd1da92c05b274f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $ffd1da92c05b274f$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($ffd1da92c05b274f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return '001';
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $19f718f0b4c89744$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}


// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $39bf1a356fa7e92d$export$1ddc7eed78155f68 = '+';
var $39bf1a356fa7e92d$var$RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var $39bf1a356fa7e92d$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $c3f1799a1fbf8600$export$852d1d4a47329634) + ']' + '|' + $39bf1a356fa7e92d$var$RFC3966_VISUAL_SEPARATOR_ + ')';
var $39bf1a356fa7e92d$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $39bf1a356fa7e92d$export$1ddc7eed78155f68 + $39bf1a356fa7e92d$var$RFC3966_PHONE_DIGIT_ + '*' + '[' + (0, $c3f1799a1fbf8600$export$852d1d4a47329634) + ']' + $39bf1a356fa7e92d$var$RFC3966_PHONE_DIGIT_ + '*' + '$';
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $39bf1a356fa7e92d$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($39bf1a356fa7e92d$var$RFC3966_GLOBAL_NUMBER_DIGITS_, 'g'); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $39bf1a356fa7e92d$var$ALPHANUM_ = (0, $c3f1799a1fbf8600$export$852d1d4a47329634);
var $39bf1a356fa7e92d$var$RFC3966_DOMAINLABEL_ = '[' + $39bf1a356fa7e92d$var$ALPHANUM_ + ']+((\\-)*[' + $39bf1a356fa7e92d$var$ALPHANUM_ + '])*';
var $39bf1a356fa7e92d$var$VALID_ALPHA_ = 'a-zA-Z';
var $39bf1a356fa7e92d$var$RFC3966_TOPLABEL_ = '[' + $39bf1a356fa7e92d$var$VALID_ALPHA_ + ']+((\\-)*[' + $39bf1a356fa7e92d$var$ALPHANUM_ + '])*';
var $39bf1a356fa7e92d$var$RFC3966_DOMAINNAME_ = '^(' + $39bf1a356fa7e92d$var$RFC3966_DOMAINLABEL_ + '\\.)*' + $39bf1a356fa7e92d$var$RFC3966_TOPLABEL_ + '\\.?$';
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $39bf1a356fa7e92d$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($39bf1a356fa7e92d$var$RFC3966_DOMAINNAME_, 'g');
var $39bf1a356fa7e92d$export$70d485ce3f6de783 = 'tel:';
var $39bf1a356fa7e92d$export$f6d5879d582c3a27 = ';phone-context=';
var $39bf1a356fa7e92d$export$9e356e12edb00a81 = ';isub=';
function $39bf1a356fa7e92d$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($39bf1a356fa7e92d$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $39bf1a356fa7e92d$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return '';
    var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $39bf1a356fa7e92d$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $39bf1a356fa7e92d$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $39bf1a356fa7e92d$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $23a9e26bd8e4909c$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $39bf1a356fa7e92d$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $39bf1a356fa7e92d$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $7964f777f49bfcfe$export$2e2bcd8739ae039)('NOT_A_NUMBER');
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
    else {
        phoneNumberString = ''; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $39bf1a356fa7e92d$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $39bf1a356fa7e92d$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $39bf1a356fa7e92d$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $39bf1a356fa7e92d$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $39bf1a356fa7e92d$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== '') return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $75b30c8e12f887d0$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $75b30c8e12f887d0$var$PHONE_NUMBER_START_PATTERN = new RegExp('[' + (0, $c3f1799a1fbf8600$export$207c99ccf3902df8) + (0, $c3f1799a1fbf8600$export$852d1d4a47329634) + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $75b30c8e12f887d0$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + (0, $c3f1799a1fbf8600$export$852d1d4a47329634) + '#' + ']+$');
var $75b30c8e12f887d0$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $75b30c8e12f887d0$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $7964f777f49bfcfe$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $75b30c8e12f887d0$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === 'TOO_SHORT') throw new (0, $7964f777f49bfcfe$export$2e2bcd8739ae039)('TOO_SHORT');
            throw new (0, $7964f777f49bfcfe$export$2e2bcd8739ae039)('NOT_A_NUMBER');
        }
        return {};
    }
    var _parsePhoneNumber = $75b30c8e12f887d0$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $7964f777f49bfcfe$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $c3f1799a1fbf8600$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $7964f777f49bfcfe$export$2e2bcd8739ae039)('TOO_SHORT');
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $c3f1799a1fbf8600$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $7964f777f49bfcfe$export$2e2bcd8739ae039)('TOO_LONG');
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $06a5e55efa4cfd93$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $16146d1487a2c594$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $75b30c8e12f887d0$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $aec3897292a25ad6$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $75b30c8e12f887d0$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $75b30c8e12f887d0$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $7964f777f49bfcfe$export$2e2bcd8739ae039)('TOO_LONG');
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($75b30c8e12f887d0$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($75b30c8e12f887d0$var$AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $75b30c8e12f887d0$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $23a9e26bd8e4909c$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $75b30c8e12f887d0$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $d3161e893522ec1c$export$2e2bcd8739ae039)(number)) {
        if ((0, $d3161e893522ec1c$export$4c3f76c95c05197c)(number)) return {
            error: 'TOO_SHORT'
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $229e7b00da8416dc$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $75b30c8e12f887d0$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $75b30c8e12f887d0$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $5f868a9630f3752d$export$2e2bcd8739ae039)((0, $e396a6068e8c6718$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($75b30c8e12f887d0$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = '001';
            }
        }
        countryCallingCode = defaultCallingCode || (0, $0590493bd26b93ec$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $fb85905a5345e75c$export$2e2bcd8739ae039)((0, $e396a6068e8c6718$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $ffd1da92c05b274f$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === '001') ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $b23474fef93a8712$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b23474fef93a8712$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b23474fef93a8712$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b23474fef93a8712$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b23474fef93a8712$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b23474fef93a8712$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b23474fef93a8712$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $75b30c8e12f887d0$export$2e2bcd8739ae039)(text, $b23474fef93a8712$var$_objectSpread($b23474fef93a8712$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}




function $aff667a9cf93a400$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aff667a9cf93a400$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aff667a9cf93a400$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aff667a9cf93a400$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aff667a9cf93a400$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aff667a9cf93a400$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aff667a9cf93a400$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $0590493bd26b93ec$export$bd9e113b8b17202a)(options.defaultCountry, metadata)) options = $aff667a9cf93a400$var$_objectSpread($aff667a9cf93a400$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $b23474fef93a8712$export$2e2bcd8739ae039)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $7964f777f49bfcfe$export$2e2bcd8739ae039)) ;
        else throw error;
    }
}


function $bd937d41ca0f46d3$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $a4d39dceedf7ded8$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $aff667a9cf93a400$export$2e2bcd8739ae039)(text, options, metadata);
}


function $e7443089bac02dfa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e7443089bac02dfa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e7443089bac02dfa$var$_typeof(o);
}
function $e7443089bac02dfa$export$2e2bcd8739ae039(value, format, metadata) {
    if (!metadata) {
        if ($e7443089bac02dfa$var$_typeof(format) === 'object') {
            metadata = format;
            format = 'NATIONAL';
        }
    }
    if (!value) return '';
    var phoneNumber = (0, $bd937d41ca0f46d3$export$2e2bcd8739ae039)(value, metadata);
    if (!phoneNumber) return '';
    // Deprecated.
    // Legacy `format`s.
    switch(format){
        case 'National':
            format = 'NATIONAL';
            break;
        case 'International':
            format = 'INTERNATIONAL';
            break;
    }
    return phoneNumber.format(format);
}
function $e7443089bac02dfa$export$88012462592bc004(value, metadata) {
    return $e7443089bac02dfa$export$2e2bcd8739ae039(value, 'INTERNATIONAL', metadata);
}


function $5c184dd7c0b6e321$export$2e2bcd8739ae039(metadata) {
    return new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadata).getCountries();
}



function $35acff3c1d7a83c5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $35acff3c1d7a83c5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $35acff3c1d7a83c5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $35acff3c1d7a83c5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $35acff3c1d7a83c5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $35acff3c1d7a83c5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $35acff3c1d7a83c5$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $a4d39dceedf7ded8$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $35acff3c1d7a83c5$var$_objectSpread($35acff3c1d7a83c5$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $aff667a9cf93a400$export$2e2bcd8739ae039)(text, options, metadata);
    return phoneNumber && phoneNumber.isPossible() || false;
}



function $9de37dd71e8863e8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9de37dd71e8863e8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9de37dd71e8863e8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9de37dd71e8863e8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9de37dd71e8863e8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9de37dd71e8863e8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9de37dd71e8863e8$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $a4d39dceedf7ded8$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $9de37dd71e8863e8$var$_objectSpread($9de37dd71e8863e8$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $aff667a9cf93a400$export$2e2bcd8739ae039)(text, options, metadata);
    return phoneNumber && phoneNumber.isValid() || false;
}



var $gIfym = parcelRequire("gIfym");


var $gIfym = parcelRequire("gIfym");


var $gIfym = parcelRequire("gIfym");


function $a94d2c98e1ea0b0b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a94d2c98e1ea0b0b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a94d2c98e1ea0b0b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a94d2c98e1ea0b0b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a94d2c98e1ea0b0b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// This "state" object simply holds the state of the "AsYouType" parser:
//
// * `country?: string`
// * `callingCode?: string`
// * `digits: string`
// * `international: boolean`
// * `missingPlus: boolean`
// * `IDDPrefix?: string`
// * `carrierCode?: string`
// * `nationalPrefix?: string`
// * `nationalSignificantNumber?: string`
// * `nationalSignificantNumberMatchesInput: boolean`
// * `complexPrefixBeforeNationalSignificantNumber?: string`
//
// `state.country` and `state.callingCode` aren't required to be in sync.
// For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
// So `state.country` and `state.callingCode` are totally independent.
//
var $a94d2c98e1ea0b0b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeState(_ref) {
        var onCountryChange = _ref.onCountryChange, onCallingCodeChange = _ref.onCallingCodeChange;
        $a94d2c98e1ea0b0b$var$_classCallCheck(this, AsYouTypeState);
        this.onCountryChange = onCountryChange;
        this.onCallingCodeChange = onCallingCodeChange;
    }
    $a94d2c98e1ea0b0b$var$_createClass(AsYouTypeState, [
        {
            key: "reset",
            value: function reset(_ref2) {
                var country = _ref2.country, callingCode = _ref2.callingCode;
                this.international = false;
                this.missingPlus = false;
                this.IDDPrefix = undefined;
                this.callingCode = undefined;
                this.digits = '';
                this.resetNationalSignificantNumber();
                this.initCountryAndCallingCode(country, callingCode);
            }
        },
        {
            key: "resetNationalSignificantNumber",
            value: function resetNationalSignificantNumber() {
                this.nationalSignificantNumber = this.getNationalDigits();
                this.nationalSignificantNumberMatchesInput = true;
                this.nationalPrefix = undefined;
                this.carrierCode = undefined;
                this.complexPrefixBeforeNationalSignificantNumber = undefined;
            }
        },
        {
            key: "update",
            value: function update(properties) {
                for(var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++){
                    var key = _Object$keys[_i];
                    this[key] = properties[key];
                }
            }
        },
        {
            key: "initCountryAndCallingCode",
            value: function initCountryAndCallingCode(country, callingCode) {
                this.setCountry(country);
                this.setCallingCode(callingCode);
            }
        },
        {
            key: "setCountry",
            value: function setCountry(country) {
                this.country = country;
                this.onCountryChange(country);
            }
        },
        {
            key: "setCallingCode",
            value: function setCallingCode(callingCode) {
                this.callingCode = callingCode;
                this.onCallingCodeChange(callingCode, this.country);
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(country, callingCode) {
                // Prepend the `+` to parsed input.
                this.international = true; // If a default country was set then reset it
                // because an explicitly international phone
                // number is being entered.
                this.initCountryAndCallingCode(country, callingCode);
            }
        },
        {
            key: "appendDigits",
            value: function appendDigits(nextDigits) {
                this.digits += nextDigits;
            }
        },
        {
            key: "appendNationalSignificantNumberDigits",
            value: function appendNationalSignificantNumberDigits(nextDigits) {
                this.nationalSignificantNumber += nextDigits;
            }
        },
        {
            key: "getNationalDigits",
            value: function getNationalDigits() {
                if (this.international) return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
                return this.digits;
            }
        },
        {
            key: "getDigitsWithoutInternationalPrefix",
            value: function getDigitsWithoutInternationalPrefix() {
                if (this.international) {
                    if (this.IDDPrefix) return this.digits.slice(this.IDDPrefix.length);
                }
                return this.digits;
            }
        }
    ]);
    return AsYouTypeState;
}();


function $c09677730865ca37$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c09677730865ca37$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c09677730865ca37$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c09677730865ca37$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c09677730865ca37$var$_arrayLikeToArray(o, minLen);
}
function $c09677730865ca37$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $c09677730865ca37$export$2a0174a7c311f338 = 'x'; // '\u2008' (punctuation space)
var $c09677730865ca37$var$DIGIT_PLACEHOLDER_MATCHER = new RegExp($c09677730865ca37$export$2a0174a7c311f338); // Counts all occurences of a symbol in a string.
function $c09677730865ca37$export$af0de81b5898251d(symbol, string) {
    var count = 0; // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for counting brackets it is safe.
    // for (const character of string)
    for(var _iterator = $c09677730865ca37$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        if (character === symbol) count++;
    }
    return count;
} // Repeats a string (or a symbol) N times.
function $c09677730865ca37$export$76d90c956114f2c2(string, times) {
    if (times < 1) return '';
    var result = '';
    while(times > 1){
        if (times & 1) result += string;
        times >>= 1;
        string += string;
    }
    return result + string;
}
function $c09677730865ca37$export$ac095dcff0205861(string, cutBeforeIndex) {
    if (string[cutBeforeIndex] === ')') cutBeforeIndex++;
    return $c09677730865ca37$export$a464e056bc212edb(string.slice(0, cutBeforeIndex));
}
function $c09677730865ca37$export$54ba366c9ffed8f9(template, cut_before) {
    var retained_template = template.slice(0, cut_before);
    var opening_braces = $c09677730865ca37$export$af0de81b5898251d('(', retained_template);
    var closing_braces = $c09677730865ca37$export$af0de81b5898251d(')', retained_template);
    var dangling_braces = opening_braces - closing_braces;
    while(dangling_braces > 0 && cut_before < template.length){
        if (template[cut_before] === ')') dangling_braces--;
        cut_before++;
    }
    return template.slice(0, cut_before);
}
function $c09677730865ca37$export$a464e056bc212edb(string) {
    var dangling_braces = [];
    var i = 0;
    while(i < string.length){
        if (string[i] === '(') dangling_braces.push(i);
        else if (string[i] === ')') dangling_braces.pop();
        i++;
    }
    var start = 0;
    var cleared_string = '';
    dangling_braces.push(string.length);
    for(var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++){
        var index = _dangling_braces[_i];
        cleared_string += string.slice(start, index);
        start = index + 1;
    }
    return cleared_string;
}
function $c09677730865ca37$export$a15547494b55ca4e(template, position, digits) {
    // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for `digits` it is safe.
    // for (const digit of digits)
    for(var _iterator2 = $c09677730865ca37$var$_createForOfIteratorHelperLoose(digits.split('')), _step2; !(_step2 = _iterator2()).done;){
        var digit = _step2.value;
        // If there is room for more digits in current `template`,
        // then set the next digit in the `template`,
        // and return the formatted digits so far.
        // If more digits are entered than the current format could handle.
        if (template.slice(position + 1).search($c09677730865ca37$var$DIGIT_PLACEHOLDER_MATCHER) < 0) return;
        position = template.search($c09677730865ca37$var$DIGIT_PLACEHOLDER_MATCHER);
        template = template.replace($c09677730865ca37$var$DIGIT_PLACEHOLDER_MATCHER, digit);
    }
    return [
        template,
        position
    ];
}





function $157754ecb9de0a29$export$2e2bcd8739ae039(state, format, _ref) {
    var metadata = _ref.metadata, shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
    var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
    if (matcher.test(state.nationalSignificantNumber)) return $157754ecb9de0a29$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
        metadata: metadata,
        shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
}
function $157754ecb9de0a29$export$9e33d25ea5d3e526(nationalSignificantNumber, metadata) {
    return (0, $0888407f8e63541a$export$2e2bcd8739ae039)(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}
function $157754ecb9de0a29$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
    var metadata = _ref2.metadata, shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
    // `format` has already been checked for `nationalPrefix` requirement.
    var nationalSignificantNumber = state.nationalSignificantNumber, international = state.international, nationalPrefix = state.nationalPrefix, carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
    // If the resulting formatted number is a valid formatted number, then return it.
    //
    // Google's AsYouType formatter is different in a way that it doesn't try
    // to format using the "national prefix formatting rule", and instead it
    // simply prepends a national prefix followed by a " " character.
    // This code does that too, but as a fallback.
    // The reason is that "national prefix formatting rule" may use parentheses,
    // which wouldn't be included has it used the simpler Google's way.
    //
    if (shouldTryNationalPrefixFormattingRule(format)) {
        var formattedNumber = $157754ecb9de0a29$var$formatNationalNumber(state, format, {
            useNationalPrefixFormattingRule: true,
            getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
            metadata: metadata
        });
        if (formattedNumber) return formattedNumber;
    } // Format the number without using `national_prefix_formatting_rule`.
    return $157754ecb9de0a29$var$formatNationalNumber(state, format, {
        useNationalPrefixFormattingRule: false,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
        metadata: metadata
    });
}
function $157754ecb9de0a29$var$formatNationalNumber(state, format, _ref3) {
    var metadata = _ref3.metadata, useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
    var formattedNationalNumber = (0, $6253144a9f60cd76$export$2e2bcd8739ae039)(state.nationalSignificantNumber, format, {
        carrierCode: state.carrierCode,
        useInternationalFormat: state.international,
        withNationalPrefix: useNationalPrefixFormattingRule,
        metadata: metadata
    });
    if (!useNationalPrefixFormattingRule) {
        if (state.nationalPrefix) // If a national prefix was extracted, then just prepend it,
        // followed by a " " character.
        formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
        else if (state.complexPrefixBeforeNationalSignificantNumber) formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
    if ($157754ecb9de0a29$var$isValidFormattedNationalNumber(formattedNationalNumber, state)) return formattedNationalNumber;
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//
function $157754ecb9de0a29$var$isValidFormattedNationalNumber(formattedNationalNumber, state) {
    return (0, $6825703ef2c60546$export$2e2bcd8739ae039)(formattedNationalNumber) === state.getNationalDigits();
}


function $3fc266920eda5c83$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3fc266920eda5c83$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3fc266920eda5c83$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3fc266920eda5c83$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3fc266920eda5c83$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $3fc266920eda5c83$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PatternParser() {
        $3fc266920eda5c83$var$_classCallCheck(this, PatternParser);
    }
    $3fc266920eda5c83$var$_createClass(PatternParser, [
        {
            key: "parse",
            value: function parse(pattern) {
                this.context = [
                    {
                        or: true,
                        instructions: []
                    }
                ];
                this.parsePattern(pattern);
                if (this.context.length !== 1) throw new Error('Non-finalized contexts left when pattern parse ended');
                var _this$context$ = this.context[0], branches = _this$context$.branches, instructions = _this$context$.instructions;
                if (branches) return {
                    op: '|',
                    args: branches.concat([
                        $3fc266920eda5c83$var$expandSingleElementArray(instructions)
                    ])
                };
                /* istanbul ignore if */ if (instructions.length === 0) throw new Error('Pattern is required');
                if (instructions.length === 1) return instructions[0];
                return instructions;
            }
        },
        {
            key: "startContext",
            value: function startContext(context) {
                this.context.push(context);
            }
        },
        {
            key: "endContext",
            value: function endContext() {
                this.context.pop();
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.context[this.context.length - 1];
            }
        },
        {
            key: "parsePattern",
            value: function parsePattern(pattern) {
                if (!pattern) throw new Error('Pattern is required');
                var match = pattern.match($3fc266920eda5c83$var$OPERATOR);
                if (!match) {
                    if ($3fc266920eda5c83$var$ILLEGAL_CHARACTER_REGEXP.test(pattern)) throw new Error("Illegal characters found in a pattern: ".concat(pattern));
                    this.getContext().instructions = this.getContext().instructions.concat(pattern.split(''));
                    return;
                }
                var operator = match[1];
                var before = pattern.slice(0, match.index);
                var rightPart = pattern.slice(match.index + operator.length);
                switch(operator){
                    case '(?:':
                        if (before) this.parsePattern(before);
                        this.startContext({
                            or: true,
                            instructions: [],
                            branches: []
                        });
                        break;
                    case ')':
                        if (!this.getContext().or) throw new Error('")" operator must be preceded by "(?:" operator');
                        if (before) this.parsePattern(before);
                        if (this.getContext().instructions.length === 0) throw new Error('No instructions found after "|" operator in an "or" group');
                        var _this$getContext = this.getContext(), branches = _this$getContext.branches;
                        branches.push($3fc266920eda5c83$var$expandSingleElementArray(this.getContext().instructions));
                        this.endContext();
                        this.getContext().instructions.push({
                            op: '|',
                            args: branches
                        });
                        break;
                    case '|':
                        if (!this.getContext().or) throw new Error('"|" operator can only be used inside "or" groups');
                        if (before) this.parsePattern(before);
                         // The top-level is an implicit "or" group, if required.
                        if (!this.getContext().branches) {
                            // `branches` are not defined only for the root implicit "or" operator.
                            /* istanbul ignore else */ if (this.context.length === 1) this.getContext().branches = [];
                            else throw new Error('"branches" not found in an "or" group context');
                        }
                        this.getContext().branches.push($3fc266920eda5c83$var$expandSingleElementArray(this.getContext().instructions));
                        this.getContext().instructions = [];
                        break;
                    case '[':
                        if (before) this.parsePattern(before);
                        this.startContext({
                            oneOfSet: true
                        });
                        break;
                    case ']':
                        if (!this.getContext().oneOfSet) throw new Error('"]" operator must be preceded by "[" operator');
                        this.endContext();
                        this.getContext().instructions.push({
                            op: '[]',
                            args: $3fc266920eda5c83$var$parseOneOfSet(before)
                        });
                        break;
                    /* istanbul ignore next */ default:
                        throw new Error("Unknown operator: ".concat(operator));
                }
                if (rightPart) this.parsePattern(rightPart);
            }
        }
    ]);
    return PatternParser;
}();
function $3fc266920eda5c83$var$parseOneOfSet(pattern) {
    var values = [];
    var i = 0;
    while(i < pattern.length){
        if (pattern[i] === '-') {
            if (i === 0 || i === pattern.length - 1) throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
            var prevValue = pattern[i - 1].charCodeAt(0) + 1;
            var nextValue = pattern[i + 1].charCodeAt(0) - 1;
            var value = prevValue;
            while(value <= nextValue){
                values.push(String.fromCharCode(value));
                value++;
            }
        } else values.push(pattern[i]);
        i++;
    }
    return values;
}
var $3fc266920eda5c83$var$ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
var $3fc266920eda5c83$var$OPERATOR = new RegExp("(\\||\\(\\?\\:|\\)|\\[|\\])");
function $3fc266920eda5c83$var$expandSingleElementArray(array) {
    if (array.length === 1) return array[0];
    return array;
}


function $397406392efc51df$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $397406392efc51df$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $397406392efc51df$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $397406392efc51df$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $397406392efc51df$var$_arrayLikeToArray(o, minLen);
}
function $397406392efc51df$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $397406392efc51df$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $397406392efc51df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $397406392efc51df$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $397406392efc51df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $397406392efc51df$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $397406392efc51df$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PatternMatcher(pattern) {
        $397406392efc51df$var$_classCallCheck(this, PatternMatcher);
        this.matchTree = new (0, $3fc266920eda5c83$export$2e2bcd8739ae039)().parse(pattern);
    }
    $397406392efc51df$var$_createClass(PatternMatcher, [
        {
            key: "match",
            value: function match(string) {
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, allowOverflow = _ref.allowOverflow;
                if (!string) throw new Error('String is required');
                var result = $397406392efc51df$var$_match(string.split(''), this.matchTree, true);
                if (result && result.match) delete result.matchedChars;
                if (result && result.overflow) {
                    if (!allowOverflow) return;
                }
                return result;
            }
        }
    ]);
    return PatternMatcher;
}();
function $397406392efc51df$var$_match(characters, tree, last) {
    // If `tree` is a string, then `tree` is a single character.
    // That's because when a pattern is parsed, multi-character-string parts
    // of a pattern are compiled into arrays of single characters.
    // I still wrote this piece of code for a "general" hypothetical case
    // when `tree` could be a string of several characters, even though
    // such case is not possible with the current implementation.
    if (typeof tree === 'string') {
        var characterString = characters.join('');
        if (tree.indexOf(characterString) === 0) {
            // `tree` is always a single character.
            // If `tree.indexOf(characterString) === 0`
            // then `characters.length === tree.length`.
            /* istanbul ignore else */ if (characters.length === tree.length) return {
                match: true,
                matchedChars: characters
            };
             // `tree` is always a single character.
            // If `tree.indexOf(characterString) === 0`
            // then `characters.length === tree.length`.
            /* istanbul ignore next */ return {
                partialMatch: true // matchedChars: characters
            };
        }
        if (characterString.indexOf(tree) === 0) {
            if (last) {
                // The `else` path is not possible because `tree` is always a single character.
                // The `else` case for `characters.length > tree.length` would be
                // `characters.length <= tree.length` which means `characters.length <= 1`.
                // `characters` array can't be empty, so that means `characters === [tree]`,
                // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
                // that the `if (tree.indexOf(characterString) === 0)` condition before this
                // `if` condition would be entered, and returned from there, not reaching this code.
                /* istanbul ignore else */ if (characters.length > tree.length) return {
                    overflow: true
                };
            }
            return {
                match: true,
                matchedChars: characters.slice(0, tree.length)
            };
        }
        return;
    }
    if (Array.isArray(tree)) {
        var restCharacters = characters.slice();
        var i = 0;
        while(i < tree.length){
            var subtree = tree[i];
            var result = $397406392efc51df$var$_match(restCharacters, subtree, last && i === tree.length - 1);
            if (!result) return;
            else if (result.overflow) return result;
            else if (result.match) {
                // Continue with the next subtree with the rest of the characters.
                restCharacters = restCharacters.slice(result.matchedChars.length);
                if (restCharacters.length === 0) {
                    if (i === tree.length - 1) return {
                        match: true,
                        matchedChars: characters
                    };
                    else return {
                        partialMatch: true // matchedChars: characters
                    };
                }
            } else {
                /* istanbul ignore else */ if (result.partialMatch) return {
                    partialMatch: true // matchedChars: characters
                };
                else throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
            }
            i++;
        } // If `last` then overflow has already been checked
        // by the last element of the `tree` array.
        /* istanbul ignore if */ if (last) return {
            overflow: true
        };
        return {
            match: true,
            matchedChars: characters.slice(0, characters.length - restCharacters.length)
        };
    }
    switch(tree.op){
        case '|':
            var partialMatch;
            for(var _iterator = $397406392efc51df$var$_createForOfIteratorHelperLoose(tree.args), _step; !(_step = _iterator()).done;){
                var branch = _step.value;
                var _result = $397406392efc51df$var$_match(characters, branch, last);
                if (_result) {
                    if (_result.overflow) return _result;
                    else if (_result.match) return {
                        match: true,
                        matchedChars: _result.matchedChars
                    };
                    else {
                        /* istanbul ignore else */ if (_result.partialMatch) partialMatch = true;
                        else throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
                    }
                }
            }
            if (partialMatch) return {
                partialMatch: true // matchedChars: ...
            };
             // Not even a partial match.
            return;
        case '[]':
            for(var _iterator2 = $397406392efc51df$var$_createForOfIteratorHelperLoose(tree.args), _step2; !(_step2 = _iterator2()).done;){
                var _char = _step2.value;
                if (characters[0] === _char) {
                    if (characters.length === 1) return {
                        match: true,
                        matchedChars: characters
                    };
                    if (last) return {
                        overflow: true
                    };
                    return {
                        match: true,
                        matchedChars: [
                            _char
                        ]
                    };
                }
            } // No character matches.
            return;
        /* istanbul ignore next */ default:
            throw new Error("Unsupported instruction tree: ".concat(tree));
    }
}






function $f2576151a817d8c1$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f2576151a817d8c1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f2576151a817d8c1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f2576151a817d8c1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f2576151a817d8c1$var$_arrayLikeToArray(o, minLen);
}
function $f2576151a817d8c1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f2576151a817d8c1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f2576151a817d8c1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f2576151a817d8c1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f2576151a817d8c1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f2576151a817d8c1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// Could be any digit, I guess.
var $f2576151a817d8c1$var$DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`
var $f2576151a817d8c1$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.
var $f2576151a817d8c1$var$LONGEST_DUMMY_PHONE_NUMBER = (0, $c09677730865ca37$export$76d90c956114f2c2)($f2576151a817d8c1$var$DUMMY_DIGIT, $f2576151a817d8c1$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.
var $f2576151a817d8c1$var$NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.
var $f2576151a817d8c1$var$SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".
var $f2576151a817d8c1$var$CREATE_CHARACTER_CLASS_PATTERN = $f2576151a817d8c1$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.
var $f2576151a817d8c1$var$CREATE_STANDALONE_DIGIT_PATTERN = $f2576151a817d8c1$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//
var $f2576151a817d8c1$var$NON_ALTERING_FORMAT_REG_EXP = new RegExp('[' + (0, $c3f1799a1fbf8600$export$7f01587e28f9194) + ']*' + // Google developers say:
// "We require that the first matching group is present in the
//  output pattern to ensure no data is lost while formatting."
'\\$1' + '[' + (0, $c3f1799a1fbf8600$export$7f01587e28f9194) + ']*' + '(\\$\\d[' + (0, $c3f1799a1fbf8600$export$7f01587e28f9194) + ']*)*' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.
var $f2576151a817d8c1$var$MIN_LEADING_DIGITS_LENGTH = 3;
var $f2576151a817d8c1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeFormatter(_ref) {
        var state = _ref.state, metadata = _ref.metadata;
        $f2576151a817d8c1$var$_classCallCheck(this, AsYouTypeFormatter);
        this.metadata = metadata;
        this.resetFormat();
    }
    $f2576151a817d8c1$var$_createClass(AsYouTypeFormatter, [
        {
            key: "resetFormat",
            value: function resetFormat() {
                this.chosenFormat = undefined;
                this.template = undefined;
                this.nationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplatePosition = -1;
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan, state) {
                this.resetFormat();
                if (numberingPlan) {
                    this.isNANP = numberingPlan.callingCode() === '1';
                    this.matchingFormats = numberingPlan.formats();
                    if (state.nationalSignificantNumber) this.narrowDownMatchingFormats(state);
                } else {
                    this.isNANP = undefined;
                    this.matchingFormats = [];
                }
            }
        },
        {
            key: "format",
            value: function format(nextDigits, state) {
                var _this = this;
                // See if the phone number digits can be formatted as a complete phone number.
                // If not, use the results from `formatNationalNumberWithNextDigits()`,
                // which formats based on the chosen formatting pattern.
                //
                // Attempting to format complete phone number first is how it's done
                // in Google's `libphonenumber`, so this library just follows it.
                // Google's `libphonenumber` code doesn't explain in detail why does it
                // attempt to format digits as a complete phone number
                // instead of just going with a previoulsy (or newly) chosen `format`:
                //
                // "Checks to see if there is an exact pattern match for these digits.
                //  If so, we should use this instead of any other formatting template
                //  whose leadingDigitsPattern also matches the input."
                //
                if ((0, $157754ecb9de0a29$export$9e33d25ea5d3e526)(state.nationalSignificantNumber, this.metadata)) for(var _iterator = $f2576151a817d8c1$var$_createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done;){
                    var format = _step.value;
                    var formattedCompleteNumber = (0, $157754ecb9de0a29$export$2e2bcd8739ae039)(state, format, {
                        metadata: this.metadata,
                        shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
                            return _this.shouldTryNationalPrefixFormattingRule(format, {
                                international: state.international,
                                nationalPrefix: state.nationalPrefix
                            });
                        },
                        getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
                            return _this.getSeparatorAfterNationalPrefix(format);
                        }
                    });
                    if (formattedCompleteNumber) {
                        this.resetFormat();
                        this.chosenFormat = format;
                        this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, (0, $c09677730865ca37$export$2a0174a7c311f338)), state);
                        this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
                        // using the old template needs to be reset.
                        this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf((0, $c09677730865ca37$export$2a0174a7c311f338));
                        return formattedCompleteNumber;
                    }
                }
                 // Format the digits as a partial (incomplete) phone number
                // using the previously chosen formatting pattern (or a newly chosen one).
                return this.formatNationalNumberWithNextDigits(nextDigits, state);
            } // Formats the next phone number digits.
        },
        {
            key: "formatNationalNumberWithNextDigits",
            value: function formatNationalNumberWithNextDigits(nextDigits, state) {
                var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.
                var newlyChosenFormat = this.chooseFormat(state);
                if (newlyChosenFormat) {
                    if (newlyChosenFormat === previouslyChosenFormat) // If it can format the next (current) digits
                    // using the previously chosen phone number format
                    // then return the updated formatted number.
                    return this.formatNextNationalNumberDigits(nextDigits);
                    else // If a more appropriate phone number format
                    // has been chosen for these "leading digits",
                    // then re-format the national phone number part
                    // using the newly selected format.
                    return this.formatNextNationalNumberDigits(state.getNationalDigits());
                }
            }
        },
        {
            key: "narrowDownMatchingFormats",
            value: function narrowDownMatchingFormats(_ref2) {
                var _this2 = this;
                var nationalSignificantNumber = _ref2.nationalSignificantNumber, nationalPrefix = _ref2.nationalPrefix, international = _ref2.international;
                var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
                // "leading digits" pattern fitting a maximum of 3 leading digits.
                // So, after a user inputs 3 digits of a national (significant) phone number
                // this national (significant) number can already be formatted.
                // The next "leading digits" pattern is for 4 leading digits max,
                // and the "leading digits" pattern after it is for 5 leading digits max, etc.
                // This implementation is different from Google's
                // in that it searches for a fitting format
                // even if the user has entered less than
                // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
                // Because some leading digit patterns already match for a single first digit.
                var leadingDigitsPatternIndex = leadingDigits.length - $f2576151a817d8c1$var$MIN_LEADING_DIGITS_LENGTH;
                if (leadingDigitsPatternIndex < 0) leadingDigitsPatternIndex = 0;
                this.matchingFormats = this.matchingFormats.filter(function(format) {
                    return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
                }); // If there was a phone number format chosen
                // and it no longer holds given the new leading digits then reset it.
                // The test for this `if` condition is marked as:
                // "Reset a chosen format when it no longer holds given the new leading digits".
                // To construct a valid test case for this one can find a country
                // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
                // and yielding another format for 4 `<leadingDigits>` (Australia in this case).
                if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) this.resetFormat();
            }
        },
        {
            key: "formatSuits",
            value: function formatSuits(format, international, nationalPrefix) {
                // When a prefix before a national (significant) number is
                // simply a national prefix, then it's parsed as `this.nationalPrefix`.
                // In more complex cases, a prefix before national (significant) number
                // could include a national prefix as well as some "capturing groups",
                // and in that case there's no info whether a national prefix has been parsed.
                // If national prefix is not used when formatting a phone number
                // using this format, but a national prefix has been entered by the user,
                // and was extracted, then discard such phone number format.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
                if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
                !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) return false;
                 // If national prefix is mandatory for this phone number format
                // and there're no guarantees that a national prefix is present in user input
                // then discard this phone number format as not suitable.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193
                if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) return false;
                return true;
            }
        },
        {
            key: "formatMatches",
            value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
                var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
                // leading digits pattern then it fits.
                // The test case could be found by searching for "leadingDigitsPatternsCount === 0".
                if (leadingDigitsPatternsCount === 0) return true;
                 // Start narrowing down the list of possible formats based on the leading digits.
                // (only previously matched formats take part in the narrowing down process)
                // `leading_digits_patterns` start with 3 digits min
                // and then go up from there one digit at a time.
                leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
                var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Google imposes a requirement on the leading digits
                // to be minimum 3 digits long in order to be eligible
                // for checking those with a leading digits pattern.
                //
                // Since `leading_digits_patterns` start with 3 digits min,
                // Google's original `libphonenumber` library only starts
                // excluding any non-matching formats only when the
                // national number entered so far is at least 3 digits long,
                // otherwise format matching would give false negatives.
                //
                // For example, when the digits entered so far are `2`
                // and the leading digits pattern is `21` –
                // it's quite obvious in this case that the format could be the one
                // but due to the absence of further digits it would give false negative.
                //
                // Also, `leading_digits_patterns` doesn't always correspond to a single
                // digits count. For example, `60|8` pattern would already match `8`
                // but the `60` part would require having at least two leading digits,
                // so the whole pattern would require inputting two digits first in order to
                // decide on whether it matches the input, even when the input is "80".
                //
                // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
                // even when there's only 1 or 2 digits of the national (significant) number.
                // To do that, it uses a non-strict pattern matcher written specifically for that.
                //
                if (leadingDigits.length < $f2576151a817d8c1$var$MIN_LEADING_DIGITS_LENGTH) // Before leading digits < 3 matching was implemented:
                // return true
                //
                // After leading digits < 3 matching was implemented:
                try {
                    return new (0, $397406392efc51df$export$2e2bcd8739ae039)(leadingDigitsPattern).match(leadingDigits, {
                        allowOverflow: true
                    }) !== undefined;
                } catch (error) /* istanbul ignore next */ {
                    // There's a slight possibility that there could be some undiscovered bug
                    // in the pattern matcher code. Since the "leading digits < 3 matching"
                    // feature is not "essential" for operation, it can fall back to the old way
                    // in case of any issues rather than halting the application's execution.
                    console.error(error);
                    return true;
                }
                 // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
                // available then use the usual regular expression matching.
                //
                // The whole pattern is wrapped in round brackets (`()`) because
                // the pattern can use "or" operator (`|`) at the top level of the pattern.
                //
                return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
            }
        },
        {
            key: "getFormatFormat",
            value: function getFormatFormat(format, international) {
                return international ? format.internationalFormat() : format.format();
            }
        },
        {
            key: "chooseFormat",
            value: function chooseFormat(state) {
                var _this3 = this;
                var _loop = function _loop() {
                    var format = _step2.value;
                    // If this format is currently being used
                    // and is still suitable, then stick to it.
                    if (_this3.chosenFormat === format) return "break";
                     // Sometimes, a formatting rule inserts additional digits in a phone number,
                    // and "as you type" formatter can't do that: it should only use the digits
                    // that the user has input.
                    //
                    // For example, in Argentina, there's a format for mobile phone numbers:
                    //
                    // {
                    //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    //    "leading_digits_patterns": ["91"],
                    //    "national_prefix_formatting_rule": "0$1",
                    //    "format": "$2 15-$3-$4",
                    //    "international_format": "$1 $2 $3-$4"
                    // }
                    //
                    // In that format, `international_format` is used instead of `format`
                    // because `format` inserts `15` in the formatted number,
                    // and `AsYouType` formatter should only use the digits
                    // the user has actually input, without adding any extra digits.
                    // In this case, it wouldn't make a difference, because the `15`
                    // is first stripped when applying `national_prefix_for_parsing`
                    // and then re-added when using `format`, so in reality it doesn't
                    // add any new digits to the number, but to detect that, the code
                    // would have to be more complex: it would have to try formatting
                    // the digits using the format and then see if any digits have
                    // actually been added or removed, and then, every time a new digit
                    // is input, it should re-check whether the chosen format doesn't
                    // alter the digits.
                    //
                    // Google's code doesn't go that far, and so does this library:
                    // it simply requires that a `format` doesn't add any additonal
                    // digits to user's input.
                    //
                    // Also, people in general should move from inputting phone numbers
                    // in national format (possibly with national prefixes)
                    // and use international phone number format instead:
                    // it's a logical thing in the modern age of mobile phones,
                    // globalization and the internet.
                    //
                    /* istanbul ignore if */ if (!$f2576151a817d8c1$var$NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) return "continue";
                    if (!_this3.createTemplateForFormat(format, state)) {
                        // Remove the format if it can't generate a template.
                        _this3.matchingFormats = _this3.matchingFormats.filter(function(_) {
                            return _ !== format;
                        });
                        return "continue";
                    }
                    _this3.chosenFormat = format;
                    return "break";
                };
                // When there are multiple available formats, the formatter uses the first
                // format where a formatting template could be created.
                //
                // For some weird reason, `istanbul` says "else path not taken"
                // for the `for of` line below. Supposedly that means that
                // the loop doesn't ever go over the last element in the list.
                // That's true because there always is `this.chosenFormat`
                // when `this.matchingFormats` is non-empty.
                // And, for some weird reason, it doesn't think that the case
                // with empty `this.matchingFormats` qualifies for a valid "else" path.
                // So simply muting this `istanbul` warning.
                // It doesn't skip the contents of the `for of` loop,
                // it just skips the `for of` line.
                //
                /* istanbul ignore next */ for(var _iterator2 = $f2576151a817d8c1$var$_createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;){
                    var _ret = _loop();
                    if (_ret === "break") break;
                    if (_ret === "continue") continue;
                }
                if (!this.chosenFormat) // No format matches the national (significant) phone number.
                this.resetFormat();
                return this.chosenFormat;
            }
        },
        {
            key: "createTemplateForFormat",
            value: function createTemplateForFormat(format, state) {
                // The formatter doesn't format numbers when numberPattern contains '|', e.g.
                // (20|3)\d{4}. In those cases we quickly return.
                // (Though there's no such format in current metadata)
                /* istanbul ignore if */ if ($f2576151a817d8c1$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) return;
                 // Get formatting template for this phone number format
                var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
                // for any phone number format, then abort.
                if (template) {
                    this.setNationalNumberTemplate(template, state);
                    return true;
                }
            }
        },
        {
            key: "getSeparatorAfterNationalPrefix",
            value: function getSeparatorAfterNationalPrefix(format) {
                // `US` metadata doesn't have a `national_prefix_formatting_rule`,
                // so the `if` condition below doesn't apply to `US`,
                // but in reality there shoudl be a separator
                // between a national prefix and a national (significant) number.
                // So `US` national prefix separator is a "special" "hardcoded" case.
                if (this.isNANP) return ' ';
                 // If a `format` has a `national_prefix_formatting_rule`
                // and that rule has a separator after a national prefix,
                // then it means that there should be a separator
                // between a national prefix and a national (significant) number.
                if (format && format.nationalPrefixFormattingRule() && $f2576151a817d8c1$var$NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) return ' ';
                 // At this point, there seems to be no clear evidence that
                // there should be a separator between a national prefix
                // and a national (significant) number. So don't insert one.
                return '';
            }
        },
        {
            key: "getInternationalPrefixBeforeCountryCallingCode",
            value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
                var IDDPrefix = _ref3.IDDPrefix, missingPlus = _ref3.missingPlus;
                if (IDDPrefix) return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
                if (missingPlus) return '';
                return '+';
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate(state) {
                if (!this.template) return;
                 // `this.template` holds the template for a "complete" phone number.
                // The currently entered phone number is most likely not "complete",
                // so trim all non-populated digits.
                var index = -1;
                var i = 0;
                var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
                    spacing: false
                }) : '';
                while(i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length){
                    index = this.template.indexOf((0, $c09677730865ca37$export$2a0174a7c311f338), index + 1);
                    i++;
                }
                return (0, $c09677730865ca37$export$ac095dcff0205861)(this.template, index + 1);
            }
        },
        {
            key: "setNationalNumberTemplate",
            value: function setNationalNumberTemplate(template, state) {
                this.nationalNumberTemplate = template;
                this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
                // using the old template needs to be reset.
                this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
                // contains the whole international number
                // if the phone number being input is international:
                // 'x' for the '+' sign, 'x'es for the country phone code,
                // a spacebar and then the template for the formatted national number.
                if (state.international) this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, (0, $c09677730865ca37$export$2a0174a7c311f338)) + (0, $c09677730865ca37$export$76d90c956114f2c2)((0, $c09677730865ca37$export$2a0174a7c311f338), state.callingCode.length) + ' ' + template;
                else this.template = template;
            }
        },
        {
            key: "getTemplateForFormat",
            value: function getTemplateForFormat(format, _ref4) {
                var nationalSignificantNumber = _ref4.nationalSignificantNumber, international = _ref4.international, nationalPrefix = _ref4.nationalPrefix, complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber;
                var pattern = format.pattern();
                /* istanbul ignore else */ if ($f2576151a817d8c1$var$SUPPORT_LEGACY_FORMATTING_PATTERNS) pattern = pattern // Replace anything in the form of [..] with \d
                .replace($f2576151a817d8c1$var$CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
                .replace($f2576151a817d8c1$var$CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
                 // Generate a dummy national number (consisting of `9`s)
                // that fits this format's `pattern`.
                //
                // This match will always succeed,
                // because the "longest dummy phone number"
                // has enough length to accomodate any possible
                // national phone number format pattern.
                //
                var digits = $f2576151a817d8c1$var$LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
                // for any phone number format, then abort.
                if (nationalSignificantNumber.length > digits.length) return;
                 // Get a formatting template which can be used to efficiently format
                // a partial number where digits are added one by one.
                // Below `strictPattern` is used for the
                // regular expression (with `^` and `$`).
                // This wasn't originally in Google's `libphonenumber`
                // and I guess they don't really need it
                // because they're not using "templates" to format phone numbers
                // but I added `strictPattern` after encountering
                // South Korean phone number formatting bug.
                //
                // Non-strict regular expression bug demonstration:
                //
                // this.nationalSignificantNumber : `111111111` (9 digits)
                //
                // pattern : (\d{2})(\d{3,4})(\d{4})
                // format : `$1 $2 $3`
                // digits : `9999999999` (10 digits)
                //
                // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
                //
                // template : xx xxxx xxxx
                //
                // But the correct template in this case is `xx xxx xxxx`.
                // The template was generated incorrectly because of the
                // `{3,4}` variability in the `pattern`.
                //
                // The fix is, if `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
                // is used instead of `digits`.
                var strictPattern = new RegExp('^' + pattern + '$');
                var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, $f2576151a817d8c1$var$DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then use it
                // instead of `digits`.
                if (strictPattern.test(nationalNumberDummyDigits)) digits = nationalNumberDummyDigits;
                var numberFormat = this.getFormatFormat(format, international);
                var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
                // and if a `format` does have a national prefix formatting rule,
                // then see if that national prefix formatting rule
                // prepends exactly the same national prefix the user has input.
                // If that's the case, then use the `format` with the national prefix formatting rule.
                // Otherwise, use  the `format` without the national prefix formatting rule,
                // and prepend a national prefix manually to it.
                if (this.shouldTryNationalPrefixFormattingRule(format, {
                    international: international,
                    nationalPrefix: nationalPrefix
                })) {
                    var numberFormatWithNationalPrefix = numberFormat.replace((0, $6253144a9f60cd76$export$4f32ad1c51a7a6be), format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
                    // national prefix at the start of a national (significant) number,
                    // then such formatting can be used with `AsYouType` formatter.
                    // There seems to be no `else` case: everywhere in metadata,
                    // national prefix formatting rule is national prefix + $1,
                    // or `($1)`, in which case such format isn't even considered
                    // when the user has input a national prefix.
                    /* istanbul ignore else */ if ((0, $6825703ef2c60546$export$2e2bcd8739ae039)(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + (0, $6825703ef2c60546$export$2e2bcd8739ae039)('$1')) {
                        numberFormat = numberFormatWithNationalPrefix;
                        nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
                        // with `DIGIT_PLACEHOLDER`s.
                        if (nationalPrefix) {
                            var i = nationalPrefix.length;
                            while(i > 0){
                                numberFormat = numberFormat.replace(/\d/, (0, $c09677730865ca37$export$2a0174a7c311f338));
                                i--;
                            }
                        }
                    }
                } // Generate formatting template for this phone number format.
                var template = digits // Format the dummy phone number according to the format.
                .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
                .replace(new RegExp($f2576151a817d8c1$var$DUMMY_DIGIT, 'g'), (0, $c09677730865ca37$export$2a0174a7c311f338)); // If a prefix of a national (significant) number is not as simple
                // as just a basic national prefix, then just prepend such prefix
                // before the national (significant) number, optionally spacing
                // the two with a whitespace.
                if (!nationalPrefixIncludedInTemplate) {
                    if (complexPrefixBeforeNationalSignificantNumber) // Prepend the prefix to the template manually.
                    template = (0, $c09677730865ca37$export$76d90c956114f2c2)((0, $c09677730865ca37$export$2a0174a7c311f338), complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
                    else if (nationalPrefix) // Prepend national prefix to the template manually.
                    template = (0, $c09677730865ca37$export$76d90c956114f2c2)((0, $c09677730865ca37$export$2a0174a7c311f338), nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
                }
                if (international) template = (0, $36604584204e0f97$export$2e2bcd8739ae039)(template);
                return template;
            }
        },
        {
            key: "formatNextNationalNumberDigits",
            value: function formatNextNationalNumberDigits(digits) {
                var result = (0, $c09677730865ca37$export$a15547494b55ca4e)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);
                if (!result) {
                    // Reset the format.
                    this.resetFormat();
                    return;
                }
                this.populatedNationalNumberTemplate = result[0];
                this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.
                return (0, $c09677730865ca37$export$ac095dcff0205861)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
            // for `react-phone-number-input`'s default input (`InputBasic`).
            // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
            // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
            }
        },
        {
            key: "shouldTryNationalPrefixFormattingRule",
            value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
                var international = _ref5.international, nationalPrefix = _ref5.nationalPrefix;
                if (format.nationalPrefixFormattingRule()) {
                    // In some countries, `national_prefix_formatting_rule` is `($1)`,
                    // so it applies even if the user hasn't input a national prefix.
                    // `format.usesNationalPrefix()` detects such cases.
                    var usesNationalPrefix = format.usesNationalPrefix();
                    if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) return true;
                }
            }
        }
    ]);
    return AsYouTypeFormatter;
}();








function $3fa98be10892a384$var$_slicedToArray(arr, i) {
    return $3fa98be10892a384$var$_arrayWithHoles(arr) || $3fa98be10892a384$var$_iterableToArrayLimit(arr, i) || $3fa98be10892a384$var$_unsupportedIterableToArray(arr, i) || $3fa98be10892a384$var$_nonIterableRest();
}
function $3fa98be10892a384$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3fa98be10892a384$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3fa98be10892a384$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3fa98be10892a384$var$_arrayLikeToArray(o, minLen);
}
function $3fa98be10892a384$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3fa98be10892a384$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3fa98be10892a384$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3fa98be10892a384$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3fa98be10892a384$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3fa98be10892a384$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3fa98be10892a384$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3fa98be10892a384$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $3fa98be10892a384$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + (0, $c3f1799a1fbf8600$export$7f01587e28f9194) + (0, $c3f1799a1fbf8600$export$852d1d4a47329634) + ']+';
var $3fa98be10892a384$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + $3fa98be10892a384$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var $3fa98be10892a384$var$VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + (0, $c3f1799a1fbf8600$export$207c99ccf3902df8) + ']' + '[' + (0, $c3f1799a1fbf8600$export$7f01587e28f9194) + (0, $c3f1799a1fbf8600$export$852d1d4a47329634) + ']*' + '|' + '[' + (0, $c3f1799a1fbf8600$export$7f01587e28f9194) + (0, $c3f1799a1fbf8600$export$852d1d4a47329634) + ']+' + ')';
var $3fa98be10892a384$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + (0, $c3f1799a1fbf8600$export$7f01587e28f9194) + (0, $c3f1799a1fbf8600$export$852d1d4a47329634) + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.
var $3fa98be10892a384$var$COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;
var $3fa98be10892a384$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeParser(_ref) {
        var defaultCountry = _ref.defaultCountry, defaultCallingCode = _ref.defaultCallingCode, metadata = _ref.metadata, onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
        $3fa98be10892a384$var$_classCallCheck(this, AsYouTypeParser);
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.metadata = metadata;
        this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
    }
    $3fa98be10892a384$var$_createClass(AsYouTypeParser, [
        {
            key: "input",
            value: function input(text, state) {
                var _extractFormattedDigi = $3fa98be10892a384$export$84f1aacb72e7dba5(text), _extractFormattedDigi2 = $3fa98be10892a384$var$_slicedToArray(_extractFormattedDigi, 2), formattedDigits = _extractFormattedDigi2[0], hasPlus = _extractFormattedDigi2[1];
                var digits = (0, $6825703ef2c60546$export$2e2bcd8739ae039)(formattedDigits); // Checks for a special case: just a leading `+` has been entered.
                var justLeadingPlus;
                if (hasPlus) {
                    if (!state.digits) {
                        state.startInternationalNumber();
                        if (!digits) justLeadingPlus = true;
                    }
                }
                if (digits) this.inputDigits(digits, state);
                return {
                    digits: digits,
                    justLeadingPlus: justLeadingPlus
                };
            }
        },
        {
            key: "inputDigits",
            value: function inputDigits(nextDigits, state) {
                var digits = state.digits;
                var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.
                state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
                // Some users input their phone number in international format,
                // but in an "out-of-country" dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers as soon as there're at least 3 digits.
                // Google's library attempts to extract IDD prefix at 3 digits,
                // so this library just copies that behavior.
                // I guess that's because the most commot IDD prefixes are
                // `00` (Europe) and `011` (US).
                // There exist really long IDD prefixes too:
                // for example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                // An IDD prefix is extracted here, and then every time when
                // there's a new digit and the number couldn't be formatted.
                if (hasReceivedThreeLeadingDigits) this.extractIddPrefix(state);
                if (this.isWaitingForCountryCallingCode(state)) {
                    if (!this.extractCountryCallingCode(state)) return;
                } else state.appendNationalSignificantNumberDigits(nextDigits);
                 // If a phone number is being input in international format,
                // then it's not valid for it to have a national prefix.
                // Still, some people incorrectly input such numbers with a national prefix.
                // In such cases, only attempt to strip a national prefix if the number becomes too long.
                // (but that is done later, not here)
                if (!state.international) {
                    if (!this.hasExtractedNationalSignificantNumber) this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
                        return state.update(stateUpdate);
                    });
                }
            }
        },
        {
            key: "isWaitingForCountryCallingCode",
            value: function isWaitingForCountryCallingCode(_ref2) {
                var international = _ref2.international, callingCode = _ref2.callingCode;
                return international && !callingCode;
            } // Extracts a country calling code from a number
        },
        {
            key: "extractCountryCallingCode",
            value: function extractCountryCallingCode(state) {
                var _extractCountryCallin = (0, $5f868a9630f3752d$export$2e2bcd8739ae039)('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                if (countryCallingCode) {
                    state.setCallingCode(countryCallingCode);
                    state.update({
                        nationalSignificantNumber: number
                    });
                    return true;
                }
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan) {
                if (numberingPlan) {
                    this.hasSelectedNumberingPlan = true;
                    var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && $3fa98be10892a384$var$COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
                } else {
                    this.hasSelectedNumberingPlan = undefined;
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractNationalSignificantNumber",
            value: function extractNationalSignificantNumber(nationalDigits, setState) {
                if (!this.hasSelectedNumberingPlan) return;
                var _extractNationalNumbe = (0, $50b3bd43df883fc7$export$2e2bcd8739ae039)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe.nationalPrefix, nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
                if (nationalNumber === nationalDigits) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "extractAnotherNationalSignificantNumber",
            value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
                if (!this.hasExtractedNationalSignificantNumber) return this.extractNationalSignificantNumber(nationalDigits, setState);
                if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) return;
                var _extractNationalNumbe2 = (0, $50b3bd43df883fc7$export$2e2bcd8739ae039)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe2.nationalPrefix, nationalNumber = _extractNationalNumbe2.nationalNumber, carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
                // then it's always extracted as additional digits are added.
                // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
                // doesn't do anything different from what it currently does.
                // So, just in case, here's this check, though it doesn't occur.
                /* istanbul ignore if */ if (nationalNumber === prevNationalSignificantNumber) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "onExtractedNationalNumber",
            value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
                var complexPrefixBeforeNationalSignificantNumber;
                var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.
                var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
                // last substring of the `digits`, then it means that it hasn't been altered:
                // no digits have been removed from the national (significant) number
                // while applying `national_prefix_transform_rule`.
                // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
                if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
                    nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
                    // as just a basic national prefix, then such prefix is stored in
                    // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
                    // prepended "as is" to the national (significant) number to produce
                    // a formatted result.
                    var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
                    // because `onExtractedNationalNumber()` isn't called
                    // when a national (significant) number hasn't been actually "extracted":
                    // when a national (significant) number is equal to the national part of `digits`,
                    // then `onExtractedNationalNumber()` doesn't get called.
                    if (prefixBeforeNationalNumber !== nationalPrefix) complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
                }
                setState({
                    nationalPrefix: nationalPrefix,
                    carrierCode: carrierCode,
                    nationalSignificantNumber: nationalSignificantNumber,
                    nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
                    complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
                }); // `onExtractedNationalNumber()` is only called when
                // the national (significant) number actually did change.
                this.hasExtractedNationalSignificantNumber = true;
                this.onNationalSignificantNumberChange();
            }
        },
        {
            key: "reExtractNationalSignificantNumber",
            value: function reExtractNationalSignificantNumber(state) {
                // Attempt to extract a national prefix.
                //
                // Some people incorrectly input national prefix
                // in an international phone number.
                // For example, some people write British phone numbers as `+44(0)...`.
                //
                // Also, in some rare cases, it is valid for a national prefix
                // to be a part of an international phone number.
                // For example, mobile phone numbers in Mexico are supposed to be
                // dialled internationally using a `1` national prefix,
                // so the national prefix will be part of an international number.
                //
                // Quote from:
                // https://www.mexperience.com/dialing-cell-phones-in-mexico/
                //
                // "Dialing a Mexican cell phone from abroad
                // When you are calling a cell phone number in Mexico from outside Mexico,
                // it’s necessary to dial an additional “1” after Mexico’s country code
                // (which is “52”) and before the area code.
                // You also ignore the 045, and simply dial the area code and the
                // cell phone’s number.
                //
                // If you don’t add the “1”, you’ll receive a recorded announcement
                // asking you to redial using it.
                //
                // For example, if you are calling from the USA to a cell phone
                // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
                // (Note that this is different to calling a land line in Mexico City
                // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
                //
                // Google's demo output:
                // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
                //
                if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function(stateUpdate) {
                    return state.update(stateUpdate);
                })) return true;
                 // If no format matches the phone number, then it could be
                // "a really long IDD" (quote from a comment in Google's library).
                // An IDD prefix is first extracted when the user has entered at least 3 digits,
                // and then here — every time when there's a new digit and the number
                // couldn't be formatted.
                // For example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                //
                // Could also check `!hasReceivedThreeLeadingDigits` here
                // to filter out the case when this check duplicates the one
                // already performed when there're 3 leading digits,
                // but it's not a big deal, and in most cases there
                // will be a suitable `format` when there're 3 leading digits.
                //
                if (this.extractIddPrefix(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                } // Google's AsYouType formatter supports sort of an "autocorrection" feature
                // when it "autocorrects" numbers that have been input for a country
                // with that country's calling code.
                // Such "autocorrection" feature looks weird, but different people have been requesting it:
                // https://github.com/catamphetamine/libphonenumber-js/issues/376
                // https://github.com/catamphetamine/libphonenumber-js/issues/375
                // https://github.com/catamphetamine/libphonenumber-js/issues/316
                if (this.fixMissingPlus(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                }
            }
        },
        {
            key: "extractIddPrefix",
            value: function extractIddPrefix(state) {
                // An IDD prefix can't be present in a number written with a `+`.
                // Also, don't re-extract an IDD prefix if has already been extracted.
                var international = state.international, IDDPrefix = state.IDDPrefix, digits = state.digits, nationalSignificantNumber = state.nationalSignificantNumber;
                if (international || IDDPrefix) return;
                 // Some users input their phone number in "out-of-country"
                // dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers.
                var numberWithoutIDD = (0, $0680d02b1fc88304$export$2e2bcd8739ae039)(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
                if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
                    // If an IDD prefix was stripped then convert the IDD-prefixed number
                    // to international number for subsequent parsing.
                    state.update({
                        IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
                    });
                    this.startInternationalNumber(state, {
                        country: undefined,
                        callingCode: undefined
                    });
                    return true;
                }
            }
        },
        {
            key: "fixMissingPlus",
            value: function fixMissingPlus(state) {
                if (!state.international) {
                    var _extractCountryCallin2 = (0, $3a9a972ae1ee278c$export$2e2bcd8739ae039)(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), newCallingCode = _extractCountryCallin2.countryCallingCode, number = _extractCountryCallin2.number;
                    if (newCallingCode) {
                        state.update({
                            missingPlus: true
                        });
                        this.startInternationalNumber(state, {
                            country: state.country,
                            callingCode: newCallingCode
                        });
                        return true;
                    }
                }
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(state, _ref3) {
                var country = _ref3.country, callingCode = _ref3.callingCode;
                state.startInternationalNumber(country, callingCode); // If a national (significant) number has been extracted before, reset it.
                if (state.nationalSignificantNumber) {
                    state.resetNationalSignificantNumber();
                    this.onNationalSignificantNumberChange();
                    this.hasExtractedNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractCallingCodeAndNationalSignificantNumber",
            value: function extractCallingCodeAndNationalSignificantNumber(state) {
                if (this.extractCountryCallingCode(state)) // `this.extractCallingCode()` is currently called when the number
                // couldn't be formatted during the standard procedure.
                // Normally, the national prefix would be re-extracted
                // for an international number if such number couldn't be formatted,
                // but since it's already not able to be formatted,
                // there won't be yet another retry, so also extract national prefix here.
                this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
                    return state.update(stateUpdate);
                });
            }
        }
    ]);
    return AsYouTypeParser;
}();
function $3fa98be10892a384$var$extractFormattedPhoneNumber(text) {
    // Attempt to extract a possible number from the string passed in.
    var startsAt = text.search($3fa98be10892a384$var$VALID_FORMATTED_PHONE_NUMBER_PART);
    if (startsAt < 0) return;
     // Trim everything to the left of the phone number.
    text = text.slice(startsAt); // Trim the `+`.
    var hasPlus;
    if (text[0] === '+') {
        hasPlus = true;
        text = text.slice(1);
    } // Trim everything to the right of the phone number.
    text = text.replace($3fa98be10892a384$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.
    if (hasPlus) text = '+' + text;
    return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */ function $3fa98be10892a384$var$_extractFormattedDigitsAndPlus(text) {
    // Extract a formatted phone number part from text.
    var extractedNumber = $3fa98be10892a384$var$extractFormattedPhoneNumber(text) || ''; // Trim a `+`.
    if (extractedNumber[0] === '+') return [
        extractedNumber.slice(1),
        true
    ];
    return [
        extractedNumber
    ];
}
function $3fa98be10892a384$export$84f1aacb72e7dba5(text) {
    var _extractFormattedDigi3 = $3fa98be10892a384$var$_extractFormattedDigitsAndPlus(text), _extractFormattedDigi4 = $3fa98be10892a384$var$_slicedToArray(_extractFormattedDigi3, 2), formattedDigits = _extractFormattedDigi4[0], hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
    // can possibly be a part of some valid phone number
    // then parse phone number characters from a formatted phone number.
    if (!$3fa98be10892a384$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) formattedDigits = '';
    return [
        formattedDigits,
        hasPlus
    ];
}





function $a8c4ae6b6856ef97$var$_slicedToArray(arr, i) {
    return $a8c4ae6b6856ef97$var$_arrayWithHoles(arr) || $a8c4ae6b6856ef97$var$_iterableToArrayLimit(arr, i) || $a8c4ae6b6856ef97$var$_unsupportedIterableToArray(arr, i) || $a8c4ae6b6856ef97$var$_nonIterableRest();
}
function $a8c4ae6b6856ef97$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a8c4ae6b6856ef97$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a8c4ae6b6856ef97$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a8c4ae6b6856ef97$var$_arrayLikeToArray(o, minLen);
}
function $a8c4ae6b6856ef97$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a8c4ae6b6856ef97$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a8c4ae6b6856ef97$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a8c4ae6b6856ef97$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a8c4ae6b6856ef97$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a8c4ae6b6856ef97$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a8c4ae6b6856ef97$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a8c4ae6b6856ef97$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $a8c4ae6b6856ef97$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $a8c4ae6b6856ef97$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */ function AsYouType(optionsOrDefaultCountry, metadata) {
        $a8c4ae6b6856ef97$var$_classCallCheck(this, AsYouType);
        this.metadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(metadata);
        var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry), _this$getCountryAndCa2 = $a8c4ae6b6856ef97$var$_slicedToArray(_this$getCountryAndCa, 2), defaultCountry = _this$getCountryAndCa2[0], defaultCallingCode = _this$getCountryAndCa2[1]; // `this.defaultCountry` and `this.defaultCallingCode` aren't required to be in sync.
        // For example, `this.defaultCountry` could be `"AR"` and `this.defaultCallingCode` could be `undefined`.
        // So `this.defaultCountry` and `this.defaultCallingCode` are totally independent.
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.reset();
    }
    $a8c4ae6b6856ef97$var$_createClass(AsYouType, [
        {
            key: "getCountryAndCallingCode",
            value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
                // Set `defaultCountry` and `defaultCallingCode` options.
                var defaultCountry;
                var defaultCallingCode; // Turns out `null` also has type "object". Weird.
                if (optionsOrDefaultCountry) {
                    if ((0, $44aa0138f2d567ea$export$2e2bcd8739ae039)(optionsOrDefaultCountry)) {
                        defaultCountry = optionsOrDefaultCountry.defaultCountry;
                        defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
                    } else defaultCountry = optionsOrDefaultCountry;
                }
                if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) defaultCountry = undefined;
                if (defaultCallingCode) {
                    /* istanbul ignore if */ if ($a8c4ae6b6856ef97$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                        if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) defaultCountry = '001';
                    }
                }
                return [
                    defaultCountry,
                    defaultCallingCode
                ];
            }
        },
        {
            key: "input",
            value: function input(text) {
                var _this$parser$input = this.parser.input(text, this.state), digits = _this$parser$input.digits, justLeadingPlus = _this$parser$input.justLeadingPlus;
                if (justLeadingPlus) this.formattedOutput = '+';
                else if (digits) {
                    this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.
                    if (this.state.nationalSignificantNumber) this.formatter.narrowDownMatchingFormats(this.state);
                    var formattedNationalNumber;
                    if (this.metadata.hasSelectedNumberingPlan()) formattedNationalNumber = this.formatter.format(digits, this.state);
                    if (formattedNationalNumber === undefined) // See if another national (significant) number could be re-extracted.
                    {
                        if (this.parser.reExtractNationalSignificantNumber(this.state)) {
                            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.
                            var nationalDigits = this.state.getNationalDigits();
                            if (nationalDigits) formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
                        }
                    }
                    this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
                }
                return this.formattedOutput;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                this.state = new (0, $a94d2c98e1ea0b0b$export$2e2bcd8739ae039)({
                    onCountryChange: function onCountryChange(country) {
                        // Before version `1.6.0`, the official `AsYouType` formatter API
                        // included the `.country` property of an `AsYouType` instance.
                        // Since that property (along with the others) have been moved to
                        // `this.state`, `this.country` property is emulated for compatibility
                        // with the old versions.
                        _this.country = country;
                    },
                    onCallingCodeChange: function onCallingCodeChange(callingCode, country) {
                        _this.metadata.selectNumberingPlan(country, callingCode);
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                        _this.parser.reset(_this.metadata.numberingPlan);
                    }
                });
                this.formatter = new (0, $f2576151a817d8c1$export$2e2bcd8739ae039)({
                    state: this.state,
                    metadata: this.metadata
                });
                this.parser = new (0, $3fa98be10892a384$export$2e2bcd8739ae039)({
                    defaultCountry: this.defaultCountry,
                    defaultCallingCode: this.defaultCallingCode,
                    metadata: this.metadata,
                    state: this.state,
                    onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
                        _this.determineTheCountryIfNeeded();
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                    }
                });
                this.state.reset({
                    country: this.defaultCountry,
                    callingCode: this.defaultCallingCode
                });
                this.formattedOutput = '';
                return this;
            }
        },
        {
            key: "isInternational",
            value: function isInternational() {
                return this.state.international;
            }
        },
        {
            key: "getCallingCode",
            value: function getCallingCode() {
                // If the number is being input in national format and some "default calling code"
                // has been passed to `AsYouType` constructor, then `this.state.callingCode`
                // is equal to that "default calling code".
                //
                // If the number is being input in national format and no "default calling code"
                // has been passed to `AsYouType` constructor, then returns `undefined`,
                // even if a "default country" has been passed to `AsYouType` constructor.
                //
                if (this.isInternational()) return this.state.callingCode;
            } // A legacy alias.
        },
        {
            key: "getCountryCallingCode",
            value: function getCountryCallingCode() {
                return this.getCallingCode();
            }
        },
        {
            key: "getCountry",
            value: function getCountry() {
                var digits = this.state.digits; // Return `undefined` if no digits have been input yet.
                if (digits) return this._getCountry();
            }
        },
        {
            key: "_getCountry",
            value: function _getCountry() {
                var country = this.state.country;
                /* istanbul ignore if */ if ($a8c4ae6b6856ef97$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                    // `AsYouType.getCountry()` returns `undefined`
                    // for "non-geographic" phone numbering plans.
                    if (country === '001') return;
                }
                return country;
            }
        },
        {
            key: "determineTheCountryIfNeeded",
            value: function determineTheCountryIfNeeded() {
                // Suppose a user enters a phone number in international format,
                // and there're several countries corresponding to that country calling code,
                // and a country has been derived from the number, and then
                // a user enters one more digit and the number is no longer
                // valid for the derived country, so the country should be re-derived
                // on every new digit in those cases.
                //
                // If the phone number is being input in national format,
                // then it could be a case when `defaultCountry` wasn't specified
                // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
                // and that "calling code" could correspond to a "non-geographic entity",
                // or there could be several countries corresponding to that country calling code.
                // In those cases, `this.country` is `undefined` and should be derived
                // from the number. Again, if country calling code is ambiguous, then
                // `this.country` should be re-derived with each new digit.
                //
                if (!this.state.country || this.isCountryCallingCodeAmbiguous()) this.determineTheCountry();
            } // Prepends `+CountryCode ` in case of an international phone number
        },
        {
            key: "getFullNumber",
            value: function getFullNumber(formattedNationalNumber) {
                var _this2 = this;
                if (this.isInternational()) {
                    var prefix = function prefix(text) {
                        return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
                            spacing: text ? true : false
                        }) + text;
                    };
                    var callingCode = this.state.callingCode;
                    if (!callingCode) return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
                    if (!formattedNationalNumber) return prefix(callingCode);
                    return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
                }
                return formattedNationalNumber;
            }
        },
        {
            key: "getNonFormattedNationalNumberWithPrefix",
            value: function getNonFormattedNationalNumberWithPrefix() {
                var _this$state = this.state, nationalSignificantNumber = _this$state.nationalSignificantNumber, complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber, nationalPrefix = _this$state.nationalPrefix;
                var number = nationalSignificantNumber;
                var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;
                if (prefix) number = prefix + number;
                return number;
            }
        },
        {
            key: "getNonFormattedNumber",
            value: function getNonFormattedNumber() {
                var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
                return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
            }
        },
        {
            key: "getNonFormattedTemplate",
            value: function getNonFormattedTemplate() {
                var number = this.getNonFormattedNumber();
                if (number) return number.replace(/[\+\d]/g, (0, $c09677730865ca37$export$2a0174a7c311f338));
            }
        },
        {
            key: "isCountryCallingCodeAmbiguous",
            value: function isCountryCallingCodeAmbiguous() {
                var callingCode = this.state.callingCode;
                var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
                return countryCodes && countryCodes.length > 1;
            } // Determines the country of the phone number
        },
        {
            key: "determineTheCountry",
            value: function determineTheCountry() {
                this.state.setCountry((0, $ffd1da92c05b274f$export$2e2bcd8739ae039)(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
                    nationalNumber: this.state.nationalSignificantNumber,
                    defaultCountry: this.defaultCountry,
                    metadata: this.metadata
                }));
            }
        },
        {
            key: "getNumberValue",
            value: function getNumberValue() {
                var _this$state2 = this.state, digits = _this$state2.digits, callingCode = _this$state2.callingCode, country = _this$state2.country, nationalSignificantNumber = _this$state2.nationalSignificantNumber; // Will return `undefined` if no digits have been input.
                if (!digits) return;
                if (this.isInternational()) {
                    if (callingCode) return '+' + callingCode + nationalSignificantNumber;
                    else return '+' + digits;
                } else if (country || callingCode) {
                    var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
                    return '+' + callingCode_ + nationalSignificantNumber;
                }
            }
        },
        {
            key: "getNumber",
            value: function getNumber() {
                var _this$state3 = this.state, nationalSignificantNumber = _this$state3.nationalSignificantNumber, carrierCode = _this$state3.carrierCode, callingCode = _this$state3.callingCode; // `this._getCountry()` is basically same as `this.state.country`
                // with the only change that it return `undefined` in case of a
                // "non-geographic" numbering plan instead of `"001"` "internal use" value.
                var country = this._getCountry();
                if (!nationalSignificantNumber) return;
                 // `state.country` and `state.callingCode` aren't required to be in sync.
                // For example, `country` could be `"AR"` and `callingCode` could be `undefined`.
                // So `country` and `callingCode` are totally independent.
                if (!country && !callingCode) return;
                 // By default, if `defaultCountry` parameter was passed when
                // creating `AsYouType` instance, `state.country` is gonna be
                // that `defaultCountry`, which doesn't entirely conform with
                // `parsePhoneNumber()`'s behavior where it attempts to determine
                // the country more precisely in cases when multiple countries
                // could correspond to the same `countryCallingCode`.
                // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/103#note_1417192969
                //
                // Because `AsYouType.getNumber()` method is supposed to be a 1:1
                // equivalent for `parsePhoneNumber(AsYouType.getNumberValue())`,
                // then it should also behave accordingly in cases of `country` ambiguity.
                // That's how users of this library would expect it to behave anyway.
                //
                if (country) {
                    if (country === this.defaultCountry) {
                        // `state.country` and `state.callingCode` aren't required to be in sync.
                        // For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
                        // So `state.country` and `state.callingCode` are totally independent.
                        var metadata = new (0, $0590493bd26b93ec$export$2e2bcd8739ae039)(this.metadata.metadata);
                        metadata.selectNumberingPlan(country);
                        var _callingCode = metadata.numberingPlan.callingCode();
                        var ambiguousCountries = this.metadata.getCountryCodesForCallingCode(_callingCode);
                        if (ambiguousCountries.length > 1) {
                            var exactCountry = (0, $19f718f0b4c89744$export$2e2bcd8739ae039)(nationalSignificantNumber, {
                                countries: ambiguousCountries,
                                defaultCountry: this.defaultCountry,
                                metadata: this.metadata.metadata
                            });
                            if (exactCountry) country = exactCountry;
                        }
                    }
                }
                var phoneNumber = new (0, $06a5e55efa4cfd93$export$2e2bcd8739ae039)(country || callingCode, nationalSignificantNumber, this.metadata.metadata);
                if (carrierCode) phoneNumber.carrierCode = carrierCode;
                 // Phone number extensions are not supported by "As You Type" formatter.
                return phoneNumber;
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isPossible();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isValid();
            }
        },
        {
            key: "getNationalNumber",
            value: function getNationalNumber() {
                return this.state.nationalSignificantNumber;
            }
        },
        {
            key: "getChars",
            value: function getChars() {
                return (this.state.international ? '+' : '') + this.state.digits;
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate() {
                return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
            }
        }
    ]);
    return AsYouType;
}();



var $2c852dd6caebd193$var$ONLY_DIGITS_REGEXP = /^\d+$/;
function $2c852dd6caebd193$export$2e2bcd8739ae039(country, metadata) {
    // Standard international phone number prefix: "+" and "country calling code".
    var prefix = '+' + (0, $0590493bd26b93ec$export$32876ca2f1919cf0)(country, metadata);
    // "Leading digits" can't be used to rule out any countries.
    // So the "pre-fill with leading digits on country selection" feature had to be reverted.
    // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/10#note_1231042367
    // // Get "leading digits" for a phone number of the country.
    // // If there're "leading digits" then they can be part of the prefix too.
    // // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/10
    // metadata = new Metadata(metadata)
    // metadata.selectNumberingPlan(country)
    // // "Leading digits" patterns are only defined for about 20% of all countries.
    // // By definition, matching "leading digits" is a sufficient but not a necessary
    // // condition for a phone number to belong to a country.
    // // The point of "leading digits" check is that it's the fastest one to get a match.
    // // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
    // const leadingDigits = metadata.numberingPlan.leadingDigits()
    // if (leadingDigits && ONLY_DIGITS_REGEXP.test(leadingDigits)) {
    // 	prefix += leadingDigits
    // }
    return prefix;
}


// Tells if `value: string` is an `E.164` phone number.
//
// Returns a boolean.
//
// It doesn't validate that the minimum national (significant) number length
// is at least 2 characters.
//
function $0e483d81ea4a70b5$export$2e2bcd8739ae039(value) {
    if (value.length < 2) return false;
    if (value[0] !== '+') return false;
    var i = 1;
    while(i < value.length){
        var character = value.charCodeAt(i);
        if (character >= 48 && character <= 57) ;
        else return false;
        i++;
    }
    return true;
}
function $0e483d81ea4a70b5$export$a32cb4373414cedd(value) {
    if (!$0e483d81ea4a70b5$export$2e2bcd8739ae039(value)) console.error('[react-phone-number-input] Expected the initial `value` to be a E.164 phone number. Got', value);
}



function $0c8f6d6671c026e6$export$38cc8c9e484aa66b(_ref) {
    var inputFormat = _ref.inputFormat, country = _ref.country, metadata = _ref.metadata;
    return inputFormat === 'NATIONAL_PART_OF_INTERNATIONAL' ? "+".concat((0, $0590493bd26b93ec$export$32876ca2f1919cf0)(country, metadata)) : '';
}
function $0c8f6d6671c026e6$export$4be51b112e32592b(value, prefix) {
    if (prefix) {
        value = value.slice(prefix.length);
        if (value[0] === ' ') value = value.slice(1);
    }
    return value;
}


function $b310895cad5cc197$var$_slicedToArray(arr, i) {
    return $b310895cad5cc197$var$_arrayWithHoles(arr) || $b310895cad5cc197$var$_iterableToArrayLimit(arr, i) || $b310895cad5cc197$var$_unsupportedIterableToArray(arr, i) || $b310895cad5cc197$var$_nonIterableRest();
}
function $b310895cad5cc197$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b310895cad5cc197$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b310895cad5cc197$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b310895cad5cc197$var$_arrayLikeToArray(o, minLen);
}
function $b310895cad5cc197$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b310895cad5cc197$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b310895cad5cc197$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b310895cad5cc197$export$2e2bcd8739ae039(_ref) {
    var _this = this;
    var value = _ref.value, onChange = _ref.onChange, country = _ref.country, defaultCountry = _ref.defaultCountry, international = _ref.international, withCountryCallingCode = _ref.withCountryCallingCode, useNationalFormatForDefaultCountryValue = _ref.useNationalFormatForDefaultCountryValue, metadata = _ref.metadata;
    // Validate the use of `withCountryCallingCode` property.
    if (typeof withCountryCallingCode === 'boolean' && !(country && international)) console.error('[react-phone-number-input] `withCountryCallingCode` property can only be used together with `country` and `international` properties');
    // Validate the use of `country` and `defaultCountry` properties.
    if (country && defaultCountry) console.error('[react-phone-number-input] When `country` property is passed, `defaultCountry` property has no effect and therefore shouldn\'t be passed');
    // Validate the use of `international` property.
    if (typeof international === 'boolean' && !country) console.error('[react-phone-number-input] `international` property can only be used together with `country` property');
    var inputFormat = $b310895cad5cc197$var$getInputFormat({
        international: international,
        country: country,
        defaultCountry: defaultCountry,
        withCountryCallingCode: withCountryCallingCode
    });
    var countryMismatchDetected = (0, $gIfym.useRef)();
    var onCountryMismatch = function onCountryMismatch(value, country, actualCountry) {
        console.error("[react-phone-number-input] Expected phone number ".concat(value, " to correspond to country ").concat(country, " but ").concat(actualCountry ? 'in reality it corresponds to country ' + actualCountry : 'it doesn\'t', "."));
        countryMismatchDetected.current = true;
    };
    var getInitialPhoneDigits = function getInitialPhoneDigits(options) {
        // Validate that the initially-supplied `value` is in `E.164` format.
        // Because sometimes people attempt to supply a `value` like "+1 (879) 490-8676".
        // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/231#note_2016334796
        if (value) (0, $0e483d81ea4a70b5$export$a32cb4373414cedd)(value);
        return $b310895cad5cc197$var$getPhoneDigitsForValue(value, country, defaultCountry, inputFormat, useNationalFormatForDefaultCountryValue, metadata, function() {
            if (options && options.onCountryMismatch) options.onCountryMismatch();
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            onCountryMismatch.apply(_this, args);
        });
    };
    // This is only used to detect `country` property change.
    var _useState = (0, $gIfym.useState)(country), _useState2 = $b310895cad5cc197$var$_slicedToArray(_useState, 2), prevCountry = _useState2[0], setPrevCountry = _useState2[1];
    // This is only used to detect `defaultCountry` property change.
    var _useState3 = (0, $gIfym.useState)(defaultCountry), _useState4 = $b310895cad5cc197$var$_slicedToArray(_useState3, 2), prevDefaultCountry = _useState4[0], setPrevDefaultCountry = _useState4[1];
    // `phoneDigits` is the a property that gets passed to the `<input/>` component as its "value":
    // * `phoneDigits` is the `<input value/>` property.
    // * `value` is the `<PhoneInput value/>` property.
    var _useState5 = (0, $gIfym.useState)(getInitialPhoneDigits()), _useState6 = $b310895cad5cc197$var$_slicedToArray(_useState5, 2), phoneDigits = _useState6[0], setPhoneDigits = _useState6[1];
    // This is only used to detect `value` property changes.
    var _useState7 = (0, $gIfym.useState)(value), _useState8 = $b310895cad5cc197$var$_slicedToArray(_useState7, 2), valueForPhoneDigits = _useState8[0], setValueForPhoneDigits = _useState8[1];
    // Rerender hack.
    var _useState9 = (0, $gIfym.useState)(), _useState10 = $b310895cad5cc197$var$_slicedToArray(_useState9, 2), rerenderTrigger = _useState10[0], setRerenderTrigger = _useState10[1];
    var rerender = (0, $gIfym.useCallback)(function() {
        return setRerenderTrigger({});
    }, [
        setRerenderTrigger
    ]);
    function getValueForPhoneDigits(phoneDigits) {
        // If the user hasn't input any digits then `value` is `undefined`.
        if (!phoneDigits) return;
        if (inputFormat === 'NATIONAL_PART_OF_INTERNATIONAL') phoneDigits = "+".concat((0, $0590493bd26b93ec$export$32876ca2f1919cf0)(country, metadata)).concat(phoneDigits);
        // Return the E.164 phone number value.
        //
        // Even if no "national (significant) number" digits have been input,
        // still return a non-`undefined` value.
        // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/113
        //
        // For example, if the user has selected country `US` and entered `"1"`
        // then that `"1"` is just a "national prefix" and no "national (significant) number"
        // digits have been input yet. Still, return `"+1"` as `value` in such cases,
        // because otherwise the app would think that the input is empty and mark it as such
        // while in reality it isn't empty, which might be thought of as a "bug", or just
        // a "weird" behavior.
        //
        // The only case when there's any input and `getNumberValue()` still returns `undefined`
        // is when that input is `"+"`.
        //
        var asYouType = new (0, $a8c4ae6b6856ef97$export$2e2bcd8739ae039)(country || defaultCountry, metadata);
        asYouType.input(phoneDigits);
        return asYouType.getNumberValue();
    }
    // If `value` property has been changed externally
    // then re-initialize the component.
    (0, $gIfym.useEffect)(function() {
        if (value !== valueForPhoneDigits) {
            setValueForPhoneDigits(value);
            setPhoneDigits(getInitialPhoneDigits());
        }
    }, [
        value
    ]);
    // If the `country` has been changed then re-initialize the component.
    (0, $gIfym.useEffect)(function() {
        if (country !== prevCountry) {
            setPrevCountry(country);
            var _countryMismatchDetected;
            var _phoneDigits = getInitialPhoneDigits({
                onCountryMismatch: function onCountryMismatch() {
                    _countryMismatchDetected = true;
                }
            });
            setPhoneDigits(_phoneDigits);
            if (_countryMismatchDetected) setValueForPhoneDigits(getValueForPhoneDigits(_phoneDigits));
        }
    }, [
        country
    ]);
    // If the `defaultCountry` has been changed then re-initialize the component.
    (0, $gIfym.useEffect)(function() {
        if (defaultCountry !== prevDefaultCountry) {
            setPrevDefaultCountry(defaultCountry);
            setPhoneDigits(getInitialPhoneDigits());
        }
    }, [
        defaultCountry
    ]);
    // Update the `value` after `valueForPhoneDigits` has been updated.
    (0, $gIfym.useEffect)(function() {
        if (valueForPhoneDigits !== value) onChange(valueForPhoneDigits);
    }, [
        valueForPhoneDigits
    ]);
    var onSetPhoneDigits = (0, $gIfym.useCallback)(function(phoneDigits) {
        var value;
        if (country) {
            if (inputFormat === 'INTERNATIONAL') {
                // The `<input/>` value must start with the country calling code.
                var prefix = (0, $2c852dd6caebd193$export$2e2bcd8739ae039)(country, metadata);
                if (phoneDigits.indexOf(prefix) !== 0) {
                    // If a user tabs into a phone number input field
                    // that is in `withCountryCallingCode` mode,
                    // and then starts inputting local phone number digits,
                    // the first digit would get "swallowed" if the fix below wasn't implemented.
                    // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/43
                    if (phoneDigits && phoneDigits[0] !== '+') phoneDigits = prefix + phoneDigits;
                    else {
                        // // Reset phone digits if they don't start with the correct prefix.
                        // // Undo the `<input/>` value change if it doesn't.
                        if (countryMismatchDetected.current) ;
                        else {
                            // If it simply did `phoneDigits = prefix` here,
                            // then it could have no effect when erasing phone number
                            // via Backspace, because `phoneDigits` in `state` wouldn't change
                            // as a result, because it was `prefix` and it became `prefix`,
                            // so the component wouldn't rerender, and the user would be able
                            // to erase the country calling code part, and that part is
                            // assumed to be non-eraseable. That's why the component is
                            // forcefully rerendered here.
                            setPhoneDigits(prefix);
                            setValueForPhoneDigits(undefined);
                            // Force a re-render of the `<input/>` with previous `phoneDigits` value.
                            return rerender();
                        }
                    }
                }
            } else // Entering phone number either in "NATIONAL" or in "NATIONAL_PART_OF_INTERNATIONAL" format.
            // Therefore, `+` is not allowed.
            if (phoneDigits && phoneDigits[0] === '+') // Remove the `+`.
            phoneDigits = phoneDigits.slice(1);
        } else if (!defaultCountry) // Force a `+` in the beginning of a `value`
        // when no `country` and `defaultCountry` have been specified.
        {
            if (phoneDigits && phoneDigits[0] !== '+') // Prepend a `+`.
            phoneDigits = '+' + phoneDigits;
        }
        // Convert `phoneDigits` to `value`.
        if (phoneDigits) value = getValueForPhoneDigits(phoneDigits);
        setPhoneDigits(phoneDigits);
        setValueForPhoneDigits(value);
    }, [
        country,
        inputFormat,
        defaultCountry,
        metadata,
        setPhoneDigits,
        setValueForPhoneDigits,
        rerender,
        countryMismatchDetected
    ]);
    return {
        phoneDigits: phoneDigits,
        setPhoneDigits: onSetPhoneDigits,
        inputFormat: inputFormat
    };
}
/**
 * Returns phone number input field value for a E.164 phone number `value`.
 * @param  {string} [value]
 * @param  {string} [country]
 * @param  {string} [inputFormat]
 * @param  {string} [defaultCountry]
 * @param  {boolean} [useNationalFormatForDefaultCountryValue]
 * @param  {object} metadata
 * @return {string}
 */ function $b310895cad5cc197$var$getPhoneDigitsForValue(value, country, defaultCountry, inputFormat, useNationalFormatForDefaultCountryValue, metadata, onCountryMismatch) {
    if (country && inputFormat === 'INTERNATIONAL') {
        var prefix = (0, $2c852dd6caebd193$export$2e2bcd8739ae039)(country, metadata);
        if (value) {
            if (value.indexOf(prefix) !== 0) onCountryMismatch(value, country);
            return value;
        }
        return prefix;
    }
    if (!value) return '';
    if (!country && !defaultCountry) return value;
    var asYouType = new (0, $a8c4ae6b6856ef97$export$2e2bcd8739ae039)(undefined, metadata);
    asYouType.input(value);
    var phoneNumber = asYouType.getNumber();
    if (phoneNumber) {
        if (country) {
            // Check for `country` property mismatch for the actual `value`.
            if (phoneNumber.country && phoneNumber.country !== country) onCountryMismatch(value, country, phoneNumber.country);
            else if (phoneNumber.countryCallingCode !== (0, $0590493bd26b93ec$export$32876ca2f1919cf0)(country, metadata)) onCountryMismatch(value, country);
            switch(inputFormat){
                case 'NATIONAL':
                    return (0, $6825703ef2c60546$export$2e2bcd8739ae039)(phoneNumber.formatNational());
                case 'NATIONAL_PART_OF_INTERNATIONAL':
                    return (0, $6825703ef2c60546$export$2e2bcd8739ae039)((0, $0c8f6d6671c026e6$export$4be51b112e32592b)(phoneNumber.formatInternational(), (0, $2c852dd6caebd193$export$2e2bcd8739ae039)(country, metadata)));
                case 'INTERNATIONAL':
                    throw new Error('`inputFormat: "INTERNATIONAL"` case should\'ve already been handled earlier in the code');
                case 'INTERNATIONAL_OR_NATIONAL':
                    throw new Error('`inputFormat: "INTERNATIONAL_OR_NATIONAL"` is not possible when `country` is fixed');
                default:
                    throw new Error("Unknown `inputFormat`: ".concat(inputFormat));
            }
        } else {
            // `phoneNumber.countryCallingCode` is compared here  instead of
            // `phoneNumber.country`, because, for example, a person could have
            // previously input a phone number (in "national" format) that isn't
            // 100% valid for the `defaultCountry`, and if `phoneNumber.country`
            // was compared, then it wouldn't match, and such phone number
            // wouldn't be formatted as a "national" one, and instead would be
            // formatted as an "international" one, confusing the user.
            // Comparing `phoneNumber.countryCallingCode` works around such issues.
            //
            // Example: `defaultCountry="US"` and the `<input/>` is empty.
            // The user inputs: "222 333 4444", which gets formatted to "(222) 333-4444".
            // The user then clicks "Save", the page is refreshed, and the user sees
            // that the `<input/>` value is now "+1 222 333 4444" which confuses the user:
            // the user expected the `<input/>` value to be "(222) 333-4444", same as it
            // was when they've just typed it in. The cause of the issue is that "222 333 4444"
            // is not a valid national number for US, and `phoneNumber.country` is compared
            // instead of `phoneNumber.countryCallingCode`. After the `phoneNumber.country`
            // comparison is replaced with `phoneNumber.countryCallingCode` one, the issue
            // is no longer the case.
            //
            if (phoneNumber.countryCallingCode && phoneNumber.countryCallingCode === (0, $0590493bd26b93ec$export$32876ca2f1919cf0)(defaultCountry, metadata) && useNationalFormatForDefaultCountryValue) return (0, $6825703ef2c60546$export$2e2bcd8739ae039)(phoneNumber.formatNational());
            return value;
        }
    } else return '';
}
function $b310895cad5cc197$var$getInputFormat(_ref2) {
    var international = _ref2.international, country = _ref2.country, defaultCountry = _ref2.defaultCountry, withCountryCallingCode = _ref2.withCountryCallingCode;
    return country ? international ? withCountryCallingCode ? 'INTERNATIONAL' : 'NATIONAL_PART_OF_INTERNATIONAL' : 'NATIONAL' : defaultCountry ? 'INTERNATIONAL_OR_NATIONAL' : 'INTERNATIONAL';
}



var $bc95f1839fbc986c$export$dbb5e893e736e4ee = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
    country_calling_codes: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object.isRequired,
    countries: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object.isRequired
});
var $bc95f1839fbc986c$export$a238cb463698c900 = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string);


var $3160e5ecb25596e0$var$_excluded = [
    "Component",
    "country",
    "defaultCountry",
    "useNationalFormatForDefaultCountryValue",
    "value",
    "onChange",
    "metadata",
    "international",
    "withCountryCallingCode"
];
function $3160e5ecb25596e0$var$_extends() {
    $3160e5ecb25596e0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3160e5ecb25596e0$var$_extends.apply(this, arguments);
}
function $3160e5ecb25596e0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3160e5ecb25596e0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3160e5ecb25596e0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3160e5ecb25596e0$var$PhoneInput(_ref, ref) {
    var Component = _ref.Component, country = _ref.country, defaultCountry = _ref.defaultCountry, _ref$useNationalForma = _ref.useNationalFormatForDefaultCountryValue, useNationalFormatForDefaultCountryValue = _ref$useNationalForma === void 0 ? true : _ref$useNationalForma, value = _ref.value, onChange = _ref.onChange, metadata = _ref.metadata, international = _ref.international, withCountryCallingCode = _ref.withCountryCallingCode, rest = $3160e5ecb25596e0$var$_objectWithoutProperties(_ref, $3160e5ecb25596e0$var$_excluded);
    // "Phone digits" includes not only "digits" but also a `+` sign.
    var _usePhoneDigits = (0, $b310895cad5cc197$export$2e2bcd8739ae039)({
        value: value,
        onChange: onChange,
        country: country,
        defaultCountry: defaultCountry,
        international: international,
        withCountryCallingCode: withCountryCallingCode,
        useNationalFormatForDefaultCountryValue: useNationalFormatForDefaultCountryValue,
        metadata: metadata
    }), phoneDigits = _usePhoneDigits.phoneDigits, setPhoneDigits = _usePhoneDigits.setPhoneDigits, inputFormat = _usePhoneDigits.inputFormat;
    // * Passing `international` property is deprecated.
    // * Passing `withCountryCallingCode` property is deprecated.
    // * Passing `country` property: it should've been called `defaultCountry` instead
    //   because it only applies when the user inputs a phone number in a national format
    //   and is completely ignored when the user inputs a phone number in an international format.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(Component, $3160e5ecb25596e0$var$_extends({}, rest, {
        ref: ref,
        metadata: metadata,
        inputFormat: inputFormat,
        international: international,
        withCountryCallingCode: withCountryCallingCode,
        country: country || defaultCountry,
        value: phoneDigits,
        onChange: setPhoneDigits
    }));
}
$3160e5ecb25596e0$var$PhoneInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef($3160e5ecb25596e0$var$PhoneInput);
$3160e5ecb25596e0$var$PhoneInput.propTypes = {
    /**
   * The phone number (in E.164 format).
   * Examples: `"+12"`, `"+12133734253"`.
   * An "empty" `value` could be represented by any "falsy" value like `undefined`, `null` or an empty string `""`.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    /**
   * A function of `value: string?`.
   * Updates the `value` property (to `undefined` in case it's empty).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
    /**
   * A two-letter country code for formatting `value`
   * as a national phone number (example: `(213) 373-4253`),
   * or as an international phone number without "country calling code"
   * if `international` property is passed (example: `213 373 4253`).
   * Example: "US".
   * If no `country` is passed then `value`
   * is formatted as an international phone number.
   * (example: `+1 213 373 4253`)
   */ country: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    /**
   * A two-letter country code for formatting `value`
   * when a user inputs a national phone number (example: `(213) 373-4253`).
   * The user can still input a phone number in international format.
   * Example: "US".
   * `country` and `defaultCountry` properties are mutually exclusive.
   */ defaultCountry: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    /**
   * If `country` property is passed along with `international={true}` property
   * then the phone number will be input in "international" format for that `country`
   * (without "country calling code").
   * For example, if `country="US"` property is passed to "without country select" input
   * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
   * But if both `country="US"` and `international={true}` properties are passed then
   * the phone number will be input in the "international" format for `US` (`213 373 4253`)
   * (without "country calling code" `+1`).
   */ international: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    /**
   * If `country` and `international` properties are set,
   * then by default it won't include "country calling code" in the input field.
   * To change that, pass `withCountryCallingCode` property,
   * and it will include "country calling code" in the input field.
   */ withCountryCallingCode: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    /**
   * A component that renders the `<input/>` itself and also
   * parses and formats its `value` as the user inputs it.
   * See `InputBasic.js` and `InputSmart.js` for an example.
   */ Component: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).elementType.isRequired,
    /**
   * When `defaultCountry` is defined and the initial `value` corresponds to `defaultCountry`,
   * then the `value` will be formatted as a national phone number by default.
   * To format the initial `value` of `defaultCountry` as an international number instead
   * set `useNationalFormatForDefaultCountryValue` property to `true`.
   */ useNationalFormatForDefaultCountryValue: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    /**
   * `libphonenumber-js` metadata.
   */ metadata: (0, $bc95f1839fbc986c$export$dbb5e893e736e4ee)
};
var $3160e5ecb25596e0$export$2e2bcd8739ae039 = $3160e5ecb25596e0$var$PhoneInput;



var $gIfym = parcelRequire("gIfym");


var $gIfym = parcelRequire("gIfym");


var $gIfym = parcelRequire("gIfym");
// Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
//
// Example:
//
// value - '88005553535'
// caret - 2 // starting from 0; is positioned before the first zero
// operation - 'Backspace'
//
// Returns
// {
// 	value: '8005553535'
// 	caret: 1
// }
//
// Currently supports just 'Delete' and 'Backspace' operations
//
function $321b7de631e03300$export$2e2bcd8739ae039(value, caret, operation) {
    switch(operation){
        case 'Backspace':
            // If there exists the previous character,
            // then erase it and reposition the caret.
            if (caret > 0) {
                // Remove the previous character
                value = value.slice(0, caret - 1) + value.slice(caret); // Position the caret where the previous (erased) character was
                caret--;
            }
            break;
        case 'Delete':
            // Remove current digit (if any)
            value = value.slice(0, caret) + value.slice(caret + 1);
            break;
    }
    return {
        value: value,
        caret: caret
    };
}


// Parses the `text`.
//
// Returns `{ value, caret }` where `caret` is
// the caret position inside `value`
// corresponding to the `caret_position` inside `text`.
//
// The `text` is parsed by feeding each character sequentially to
// `parse_character(character, value, context)` function
// and appending the result (if it's not `undefined`) to `value`.
//
// `context` argument is just a utility empty object that is shared within the bounds
// of parsing a single input string. The `_parse()` function could use that object
// to store any kind of "flags" in it in order to alter its behavior based when
// parsing next characters within the same string. Or it could completely ignore it.
//
// Example:
//
// `text` is `8 (800) 555-35-35`,
// `caret_position` is `4` (before the first `0`).
// `parse_character` is `(character, value) =>
//   if (character >= '0' && character <= '9') { return character }`.
//
// then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
//
function $74a5f58e60daa20e$export$2e2bcd8739ae039(text, caret_position, parse_character) {
    var context = {};
    var value = '';
    var focused_input_character_index = 0;
    var index = 0;
    while(index < text.length){
        var character = parse_character(text[index], value, context);
        if (character !== undefined) {
            value += character;
            if (caret_position !== undefined) {
                if (caret_position === index) focused_input_character_index = value.length - 1;
                else if (caret_position > index) focused_input_character_index = value.length;
            }
        }
        index++;
    } // If caret position wasn't specified
    if (caret_position === undefined) // Then set caret position to "after the last input character"
    focused_input_character_index = value.length;
    var result = {
        value: value,
        caret: focused_input_character_index
    };
    return result;
}


function $05ee8847caef928b$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $05ee8847caef928b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $05ee8847caef928b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $05ee8847caef928b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $05ee8847caef928b$var$_arrayLikeToArray(o, minLen);
}
function $05ee8847caef928b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $05ee8847caef928b$export$15741e15817e73b8(symbol, string) {
    var count = 0; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes)
    // but template placeholder characters don't fall into that range
    // so skipping such miscellaneous "exotic" characters
    // won't matter here for just counting placeholder character occurrences.
    for(var _iterator = $05ee8847caef928b$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        if (character === symbol) count++;
    }
    return count;
}



function $139f9368339838e9$export$2e2bcd8739ae039(retained_template, template) {
    var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
    var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
    var cut_before = retained_template.length;
    var opening_braces = (0, $05ee8847caef928b$export$15741e15817e73b8)('(', retained_template);
    var closing_braces = (0, $05ee8847caef928b$export$15741e15817e73b8)(')', retained_template);
    var dangling_braces = opening_braces - closing_braces;
    while(dangling_braces > 0 && cut_before < template.length){
        retained_template += template[cut_before].replace(placeholder, empty_placeholder);
        if (template[cut_before] === ')') dangling_braces--;
        cut_before++;
    }
    return retained_template;
}


function $0768762b398de4a2$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $0768762b398de4a2$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0768762b398de4a2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0768762b398de4a2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0768762b398de4a2$var$_arrayLikeToArray(o, minLen);
}
function $0768762b398de4a2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0768762b398de4a2$export$2e2bcd8739ae039(template) {
    var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
    var shouldCloseBraces = arguments.length > 2 ? arguments[2] : undefined;
    if (!template) return function(value) {
        return {
            text: value
        };
    };
    var placeholdersCountInTemplate = (0, $05ee8847caef928b$export$15741e15817e73b8)(placeholder, template);
    return function(value) {
        if (!value) return {
            text: '',
            template: template
        };
        var characterIndexInValue = 0;
        var templateWithFilledInPlaceholders = ''; // Using `.split('')` here instead of normal `for ... of`
        // because the importing application doesn't neccessarily include an ES6 polyfill.
        // The `.split('')` approach discards "exotic" UTF-8 characters
        // (the ones consisting of four bytes)
        // but template placeholder characters don't fall into that range
        // and appending UTF-8 characters to a string in parts still works.
        for(var _iterator = $0768762b398de4a2$var$_createForOfIteratorHelperLoose(template.split('')), _step; !(_step = _iterator()).done;){
            var character = _step.value;
            if (character !== placeholder) {
                templateWithFilledInPlaceholders += character;
                continue;
            }
            templateWithFilledInPlaceholders += value[characterIndexInValue];
            characterIndexInValue++; // If the last available value character has been filled in,
            // then return the filled in template
            // (either trim the right part or retain it,
            //  if no more character placeholders in there)
            if (characterIndexInValue === value.length) {
                // If there are more character placeholders
                // in the right part of the template
                // then simply trim it.
                if (value.length < placeholdersCountInTemplate) break;
            }
        }
        if (shouldCloseBraces) templateWithFilledInPlaceholders = (0, $139f9368339838e9$export$2e2bcd8739ae039)(templateWithFilledInPlaceholders, template);
        return {
            text: templateWithFilledInPlaceholders,
            template: template
        };
    };
}


function $6a79fe8b61ee6f19$export$2e2bcd8739ae039(value, caret, formatter) {
    if (typeof formatter === 'string') formatter = (0, $0768762b398de4a2$export$2e2bcd8739ae039)(formatter);
    var _ref = formatter(value) || {}, text = _ref.text, template = _ref.template;
    if (text === undefined) text = value;
    if (template) {
        if (caret === undefined) caret = text.length;
        else {
            var index = 0;
            var found = false;
            var possibly_last_input_character_index = -1;
            while(index < text.length && index < template.length){
                // Character placeholder found
                if (text[index] !== template[index]) {
                    if (caret === 0) {
                        found = true;
                        caret = index;
                        break;
                    }
                    possibly_last_input_character_index = index;
                    caret--;
                }
                index++;
            } // If the caret was positioned after last input character,
            // then the text caret index is just after the last input character.
            if (!found) caret = possibly_last_input_character_index + 1;
        }
    }
    return {
        text: text,
        caret: caret
    };
}


function $33588d380799c0db$export$2498094d90b6ac72(element) {
    return element.hasAttribute('readonly');
} // Gets <input/> selection bounds
function $33588d380799c0db$export$ca798a7e6e94638c(element) {
    // If no selection, return nothing
    if (element.selectionStart === element.selectionEnd) return;
    return {
        start: element.selectionStart,
        end: element.selectionEnd
    };
} // Key codes
var $33588d380799c0db$export$4b0075e5ea5e1f26 = {
    Backspace: 8,
    Delete: 46
}; // Finds out the operation to be intercepted and performed
function $33588d380799c0db$export$d4e837035315abd8(event) {
    switch(event.keyCode){
        case $33588d380799c0db$export$4b0075e5ea5e1f26.Backspace:
            return 'Backspace';
        case $33588d380799c0db$export$4b0075e5ea5e1f26.Delete:
            return 'Delete';
    }
} // Gets <input/> caret position
function $33588d380799c0db$export$7d120213748299d3(element) {
    return element.selectionStart;
} // Sets <input/> caret position
function $33588d380799c0db$export$97ab23b40042f8af(element, caret_position) {
    // Sanity check
    if (caret_position === undefined) return;
     // Set caret position.
    // There has been an issue with caret positioning on Android devices.
    // https://github.com/catamphetamine/input-format/issues/2
    // I was revisiting this issue and looked for similar issues in other libraries.
    // For example, there's [`text-mask`](https://github.com/text-mask/text-mask) library.
    // They've had exactly the same issue when the caret seemingly refused to be repositioned programmatically.
    // The symptoms were the same: whenever the caret passed through a non-digit character of a mask (a whitespace, a bracket, a dash, etc), it looked as if it placed itself one character before its correct position.
    // https://github.com/text-mask/text-mask/issues/300
    // They seem to have found a basic fix for it: calling `input.setSelectionRange()` in a timeout rather than instantly for Android devices.
    // https://github.com/text-mask/text-mask/pull/400/files
    // I've implemented the same workaround here.
    if ($33588d380799c0db$var$isAndroid()) setTimeout(function() {
        return element.setSelectionRange(caret_position, caret_position);
    }, 0);
    else element.setSelectionRange(caret_position, caret_position);
}
function $33588d380799c0db$var$isAndroid() {
    // `navigator` is not defined when running mocha tests.
    if (typeof navigator !== 'undefined') return $33588d380799c0db$var$ANDROID_USER_AGENT_REG_EXP.test(navigator.userAgent);
}
var $33588d380799c0db$var$ANDROID_USER_AGENT_REG_EXP = /Android/i;


function $ca38ea3ab3c8386f$export$330ca67a316b532c(event, input, _parse, _format, on_change) {
    if ((0, $33588d380799c0db$export$2498094d90b6ac72)(input)) return;
     // The actual cut hasn't happened just yet hence the timeout.
    setTimeout(function() {
        return $ca38ea3ab3c8386f$var$formatInputText(input, _parse, _format, undefined, on_change);
    }, 0);
} // Deprecated.
function $ca38ea3ab3c8386f$export$48aae1120b60938a(event, input, _parse, _format, on_change) {
    if ((0, $33588d380799c0db$export$2498094d90b6ac72)(input)) return;
    var selection = (0, $33588d380799c0db$export$ca798a7e6e94638c)(input); // If selection is made,
    // just erase the selected text
    // prior to pasting
    if (selection) $ca38ea3ab3c8386f$var$eraseSelection(input, selection);
    $ca38ea3ab3c8386f$var$formatInputText(input, _parse, _format, undefined, on_change);
}
function $ca38ea3ab3c8386f$export$bd913411069e59d3(event, input, _parse, _format, on_change) {
    $ca38ea3ab3c8386f$var$formatInputText(input, _parse, _format, undefined, on_change);
} // "Delete" and "Backspace" keys are special
function $ca38ea3ab3c8386f$export$de8e1b1372cdb41b(event, input, _parse, _format, on_change) {
    if ((0, $33588d380799c0db$export$2498094d90b6ac72)(input)) return;
    var operation = (0, $33588d380799c0db$export$d4e837035315abd8)(event);
    switch(operation){
        case 'Delete':
        case 'Backspace':
            // Intercept this operation and perform it manually.
            event.preventDefault();
            var selection = (0, $33588d380799c0db$export$ca798a7e6e94638c)(input); // If a selection is made, just erase the selected text.
            if (selection) {
                $ca38ea3ab3c8386f$var$eraseSelection(input, selection);
                return $ca38ea3ab3c8386f$var$formatInputText(input, _parse, _format, undefined, on_change);
            } // Else, perform the (character erasing) operation manually.
            return $ca38ea3ab3c8386f$var$formatInputText(input, _parse, _format, operation, on_change);
        default:
    }
}
/**
 * Erases the selected text inside an `<input/>`.
 * @param  {DOMElement} input
 * @param  {Selection} selection
 */ function $ca38ea3ab3c8386f$var$eraseSelection(input, selection) {
    var text = input.value;
    text = text.slice(0, selection.start) + text.slice(selection.end);
    input.value = text;
    (0, $33588d380799c0db$export$97ab23b40042f8af)(input, selection.start);
}
/**
 * Parses and re-formats `<input/>` textual value.
 * E.g. when a user enters something into the `<input/>`
 * that raw input must first be parsed and the re-formatted properly.
 * Is called either after some user input (e.g. entered a character, pasted something)
 * or after the user performed an `operation` (e.g. "Backspace", "Delete").
 * @param  {DOMElement} input
 * @param  {Function} parse
 * @param  {Function} format
 * @param  {string} [operation] - The operation that triggered `<input/>` textual value change. E.g. "Backspace", "Delete".
 * @param  {Function} onChange
 */ function $ca38ea3ab3c8386f$var$formatInputText(input, _parse, _format, operation, on_change) {
    // Parse `<input/>` textual value.
    // Get the `value` and `caret` position.
    var _parse2 = (0, $74a5f58e60daa20e$export$2e2bcd8739ae039)(input.value, (0, $33588d380799c0db$export$7d120213748299d3)(input), _parse), value = _parse2.value, caret = _parse2.caret; // If a user performed an operation ("Backspace", "Delete")
    // then apply that operation and get the new `value` and `caret` position.
    if (operation) {
        var newValueAndCaret = (0, $321b7de631e03300$export$2e2bcd8739ae039)(value, caret, operation);
        value = newValueAndCaret.value;
        caret = newValueAndCaret.caret;
    } // Format the `value`.
    // (and reposition the caret accordingly)
    var formatted = (0, $6a79fe8b61ee6f19$export$2e2bcd8739ae039)(value, caret, _format);
    var text = formatted.text;
    caret = formatted.caret; // Set `<input/>` textual value manually
    // to prevent React from resetting the caret position
    // later inside a subsequent `render()`.
    // Doesn't work for custom `inputComponent`s for some reason.
    input.value = text; // Position the caret properly.
    (0, $33588d380799c0db$export$97ab23b40042f8af)(input, caret); // If the `<input/>` textual value did change,
    // then the parsed `value` may have changed too.
    if (on_change) on_change(value);
}


var $57a93992fca237d2$var$_excluded = [
    "ref",
    "parse",
    "format",
    "value",
    "defaultValue",
    "controlled",
    "onChange",
    "onKeyDown"
];
function $57a93992fca237d2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $57a93992fca237d2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $57a93992fca237d2$var$ownKeys(Object(source), !0).forEach(function(key) {
            $57a93992fca237d2$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $57a93992fca237d2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $57a93992fca237d2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $57a93992fca237d2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $57a93992fca237d2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $57a93992fca237d2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $57a93992fca237d2$export$2e2bcd8739ae039(_ref) {
    var ref = _ref.ref, parse = _ref.parse, format = _ref.format, value = _ref.value, defaultValue = _ref.defaultValue, _ref$controlled = _ref.controlled, controlled = _ref$controlled === void 0 ? true : _ref$controlled, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, rest = $57a93992fca237d2$var$_objectWithoutProperties(_ref, $57a93992fca237d2$var$_excluded);
    // It doesn't seem to be required to alert a developer about controlled/uncontrolled misuse:
    // if `controlled` is `true` then `defaultValue` is simply ignored.
    //
    // if (defaultValue && controlled) {
    // 	console.error('[input-format] You\'ve passed both `defaultValue` and `controlled: true` properties which is an invalid use case')
    // }
    var internalRef = (0, $gIfym.useRef)();
    var setRef = (0, $gIfym.useCallback)(function(instance) {
        internalRef.current = instance;
        if (ref) {
            if (typeof ref === 'function') ref(instance);
            else ref.current = instance;
        }
    }, [
        ref
    ]);
    var _onChange = (0, $gIfym.useCallback)(function(event) {
        return (0, $ca38ea3ab3c8386f$export$bd913411069e59d3)(event, internalRef.current, parse, format, onChange);
    }, [
        internalRef,
        parse,
        format,
        onChange
    ]);
    var _onKeyDown = (0, $gIfym.useCallback)(function(event) {
        if (onKeyDown) onKeyDown(event);
         // If `onKeyDown()` handler above has called `event.preventDefault()`
        // then ignore this `keydown` event.
        if (event.defaultPrevented) return;
        return (0, $ca38ea3ab3c8386f$export$de8e1b1372cdb41b)(event, internalRef.current, parse, format, onChange);
    }, [
        internalRef,
        parse,
        format,
        onChange,
        onKeyDown
    ]);
    var commonProps = $57a93992fca237d2$var$_objectSpread($57a93992fca237d2$var$_objectSpread({}, rest), {}, {
        ref: setRef,
        onChange: _onChange,
        onKeyDown: _onKeyDown
    });
    if (controlled) return $57a93992fca237d2$var$_objectSpread($57a93992fca237d2$var$_objectSpread({}, commonProps), {}, {
        value: format($57a93992fca237d2$var$isEmptyValue(value) ? '' : value).text
    });
    return $57a93992fca237d2$var$_objectSpread($57a93992fca237d2$var$_objectSpread({}, commonProps), {}, {
        defaultValue: format($57a93992fca237d2$var$isEmptyValue(defaultValue) ? '' : defaultValue).text
    });
}
function $57a93992fca237d2$var$isEmptyValue(value) {
    return value === undefined || value === null;
}


var $0661baec9d1aab71$var$_excluded = [
    "inputComponent",
    "parse",
    "format",
    "value",
    "defaultValue",
    "onChange",
    "controlled",
    "onKeyDown",
    "type"
];
function $0661baec9d1aab71$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0661baec9d1aab71$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0661baec9d1aab71$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0661baec9d1aab71$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0661baec9d1aab71$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0661baec9d1aab71$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0661baec9d1aab71$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0661baec9d1aab71$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0661baec9d1aab71$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
//
// <ReactInput
// 	value={this.state.phone}
// 	onChange={phone => this.setState({ phone })}
// 	parse={character => character}
// 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
//
function $0661baec9d1aab71$var$Input(_ref, ref) {
    var _ref$inputComponent = _ref.inputComponent, InputComponent = _ref$inputComponent === void 0 ? 'input' : _ref$inputComponent, parse = _ref.parse, format = _ref.format, value = _ref.value, defaultValue = _ref.defaultValue, onChange = _ref.onChange, controlled = _ref.controlled, onKeyDown = _ref.onKeyDown, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, rest = $0661baec9d1aab71$var$_objectWithoutProperties(_ref, $0661baec9d1aab71$var$_excluded);
    var inputProps = (0, $57a93992fca237d2$export$2e2bcd8739ae039)($0661baec9d1aab71$var$_objectSpread({
        ref: ref,
        parse: parse,
        format: format,
        value: value,
        defaultValue: defaultValue,
        onChange: onChange,
        controlled: controlled,
        onKeyDown: onKeyDown,
        type: type
    }, rest));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(InputComponent, inputProps);
}
$0661baec9d1aab71$var$Input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef($0661baec9d1aab71$var$Input);
$0661baec9d1aab71$var$Input.propTypes = {
    // Parses a single characher of `<input/>` text.
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
    // Formats `value` into `<input/>` text.
    format: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
    // Renders `<input/>` by default.
    inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).elementType,
    // `<input/>` `type` attribute.
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    // Is parsed from <input/> text.
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    // An initial value for an "uncontrolled" <input/>.
    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    // This handler is called each time `<input/>` text is changed.
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    // Whether this input should be "controlled" or "uncontrolled".
    // The default value is `true` meaning "uncontrolled".
    controlled: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    // Passthrough
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onCut: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onPaste: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func
};
var $0661baec9d1aab71$export$2e2bcd8739ae039 = $0661baec9d1aab71$var$Input;





function $b0cc5494aa7b5bd5$export$2e2bcd8739ae039(character, prevParsedCharacters, context) {
    // `context` argument was added as a third argument of `parse()` function
    // in `input-format` package on Dec 26th, 2023. So it could potentially be
    // `undefined` here if a 3rd-party app somehow ends up with this newer version
    // of `react-phone-number-input` and an older version of `input-format`.
    // Dunno how, but just in case, it could be `undefined` here and it wouldn't break.
    // Maybe it's not required to handle `undefined` case here.
    //
    // The addition of the `context` argument was to fix the slightly-weird behavior
    // of parsing an input string when the user inputs something like `"2+7"
    // https://github.com/catamphetamine/react-phone-number-input/issues/437
    //
    // If the parser encounters an unexpected `+` in a string being parsed
    // then it simply discards that out-of-place `+` and any following characters.
    //
    if (context && context.ignoreRest) return;
    var emitEvent = function emitEvent(eventName) {
        if (context) switch(eventName){
            case 'end':
                context.ignoreRest = true;
                break;
        }
    };
    return (0, $e396a6068e8c6718$export$13d8790d7fb84c28)(character, prevParsedCharacters, emitEvent);
}



var $gIfym = parcelRequire("gIfym");
function $df33da29677c3a83$export$2e2bcd8739ae039(_ref) {
    var onKeyDown = _ref.onKeyDown, inputFormat = _ref.inputFormat;
    return (0, $gIfym.useCallback)(function(event) {
        // Usability:
        // Don't allow the user to erase a leading "+" character when "international" input mode is forced.
        // That indicates to the user that they can't possibly enter the phone number in a non-international format.
        if (event.keyCode === $df33da29677c3a83$var$BACKSPACE_KEY_CODE && inputFormat === 'INTERNATIONAL') {
            // It checks `event.target` here for being an `<input/>` element
            // because "keydown" events may bubble from arbitrary child elements
            // so there's no guarantee that `event.target` represents an `<input/>` element.
            // Also, since `inputComponent` is not neceesarily an `<input/>`, this check is required too.
            if (event.target instanceof HTMLInputElement) {
                if ($df33da29677c3a83$var$getCaretPosition(event.target) === $df33da29677c3a83$var$LEADING_PLUS.length) {
                    event.preventDefault();
                    return;
                }
            }
        }
        if (onKeyDown) onKeyDown(event);
    }, [
        onKeyDown,
        inputFormat
    ]);
}
// Gets the caret position in an `<input/>` field.
// The caret position starts with `0` which means "before the first character".
function $df33da29677c3a83$var$getCaretPosition(element) {
    return element.selectionStart;
}
var $df33da29677c3a83$var$BACKSPACE_KEY_CODE = 8;
var $df33da29677c3a83$var$LEADING_PLUS = '+';


var $d9a94262fc20e593$var$_excluded = [
    "onKeyDown",
    "country",
    "inputFormat",
    "metadata",
    "international",
    "withCountryCallingCode"
];
function $d9a94262fc20e593$var$_extends() {
    $d9a94262fc20e593$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9a94262fc20e593$var$_extends.apply(this, arguments);
}
function $d9a94262fc20e593$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d9a94262fc20e593$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d9a94262fc20e593$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d9a94262fc20e593$export$d80fffb1deb3b97e(defaultMetadata) {
    /**
   * `InputSmart` is a "smarter" implementation of a `Component`
   * that can be passed to `<PhoneInput/>`. It parses and formats
   * the user's and maintains the caret's position in the process.
   * The caret positioning is maintained using `input-format` library.
   * Relies on being run in a DOM environment for calling caret positioning functions.
   */ function InputSmart(_ref, ref) {
        var onKeyDown = _ref.onKeyDown, country = _ref.country, inputFormat = _ref.inputFormat, _ref$metadata = _ref.metadata, metadata = _ref$metadata === void 0 ? defaultMetadata : _ref$metadata, international = _ref.international, withCountryCallingCode = _ref.withCountryCallingCode, rest = $d9a94262fc20e593$var$_objectWithoutProperties(_ref, $d9a94262fc20e593$var$_excluded);
        var format = (0, $gIfym.useCallback)(function(value) {
            // "As you type" formatter.
            var formatter = new (0, $a8c4ae6b6856ef97$export$2e2bcd8739ae039)(country, metadata);
            var prefix = (0, $0c8f6d6671c026e6$export$38cc8c9e484aa66b)({
                inputFormat: inputFormat,
                country: country,
                metadata: metadata
            });
            // Format the number.
            var text = formatter.input(prefix + value);
            var template = formatter.getTemplate();
            if (prefix) {
                text = (0, $0c8f6d6671c026e6$export$4be51b112e32592b)(text, prefix);
                // `AsYouType.getTemplate()` can be `undefined`.
                if (template) template = (0, $0c8f6d6671c026e6$export$4be51b112e32592b)(template, prefix);
            }
            return {
                text: text,
                template: template
            };
        }, [
            country,
            metadata
        ]);
        var _onKeyDown = (0, $df33da29677c3a83$export$2e2bcd8739ae039)({
            onKeyDown: onKeyDown,
            inputFormat: inputFormat
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $0661baec9d1aab71$export$2e2bcd8739ae039), $d9a94262fc20e593$var$_extends({}, rest, {
            ref: ref,
            parse: (0, $b0cc5494aa7b5bd5$export$2e2bcd8739ae039),
            format: format,
            onKeyDown: _onKeyDown
        }));
    }
    InputSmart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef(InputSmart);
    InputSmart.propTypes = {
        /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string.isRequired,
        /**
     * A function of `value: string`.
     * Updates the `value` property.
     */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
        /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
        /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * This property should've been called `defaultCountry`
     * because it only applies when the user inputs a phone number in a national format
     * and is completely ignored when the user inputs a phone number in an international format.
     */ country: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        /**
     * The format that the input field value is being input/output in.
     */ inputFormat: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOf([
            'INTERNATIONAL',
            'NATIONAL_PART_OF_INTERNATIONAL',
            'NATIONAL',
            'INTERNATIONAL_OR_NATIONAL'
        ]).isRequired,
        /**
     * `libphonenumber-js` metadata.
     */ metadata: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object
    };
    return InputSmart;
}
var $d9a94262fc20e593$export$2e2bcd8739ae039 = $d9a94262fc20e593$export$d80fffb1deb3b97e();



var $gIfym = parcelRequire("gIfym");


function $32bfc1f3232349f9$export$2e2bcd8739ae039(value, optionsOrDefaultCountry, metadata) {
    if (!metadata) {
        metadata = optionsOrDefaultCountry;
        optionsOrDefaultCountry = undefined;
    }
    return new (0, $a8c4ae6b6856ef97$export$2e2bcd8739ae039)(optionsOrDefaultCountry, metadata).input(value);
}




var $404e17b66ef38f5f$var$_excluded = [
    "value",
    "onChange",
    "onKeyDown",
    "country",
    "inputFormat",
    "metadata",
    "inputComponent",
    "international",
    "withCountryCallingCode"
];
function $404e17b66ef38f5f$var$_extends() {
    $404e17b66ef38f5f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $404e17b66ef38f5f$var$_extends.apply(this, arguments);
}
function $404e17b66ef38f5f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $404e17b66ef38f5f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $404e17b66ef38f5f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $404e17b66ef38f5f$export$d80fffb1deb3b97e(defaultMetadata) {
    /**
   * `InputBasic` is the most basic implementation of a `Component`
   * that can be passed to `<PhoneInput/>`. It parses and formats
   * the user's input but doesn't control the caret in the process:
   * when erasing or inserting digits in the middle of a phone number
   * the caret usually jumps to the end (this is the expected behavior).
   * Why does `InputBasic` exist when there's `InputSmart`?
   * One reason is working around the [Samsung Galaxy smart caret positioning bug]
   * (https://github.com/catamphetamine/react-phone-number-input/issues/75).
   * Another reason is that, unlike `InputSmart`, it doesn't require DOM environment.
   */ function InputBasic(_ref, ref) {
        var value = _ref.value, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, country = _ref.country, inputFormat = _ref.inputFormat, _ref$metadata = _ref.metadata, metadata = _ref$metadata === void 0 ? defaultMetadata : _ref$metadata, _ref$inputComponent = _ref.inputComponent, Input = _ref$inputComponent === void 0 ? 'input' : _ref$inputComponent, international = _ref.international, withCountryCallingCode = _ref.withCountryCallingCode, rest = $404e17b66ef38f5f$var$_objectWithoutProperties(_ref, $404e17b66ef38f5f$var$_excluded);
        var prefix = (0, $0c8f6d6671c026e6$export$38cc8c9e484aa66b)({
            inputFormat: inputFormat,
            country: country,
            metadata: metadata
        });
        var _onChange = (0, $gIfym.useCallback)(function(event) {
            var newValue = (0, $e396a6068e8c6718$export$2e2bcd8739ae039)(event.target.value);
            // By default, if a value is something like `"(123)"`
            // then Backspace would only erase the rightmost brace
            // becoming something like `"(123"`
            // which would give the same `"123"` value
            // which would then be formatted back to `"(123)"`
            // and so a user wouldn't be able to erase the phone number.
            //
            // This issue is worked around with this simple hack:
            // when "old" and "new" parsed values are the same,
            // it checks if the "new" formatted value could be obtained
            // from the "old" formatted value by erasing some (or no) characters at the right side.
            // If it could then it's likely that the user has hit a Backspace key
            // and what they really intended was to erase a rightmost digit rather than
            // a rightmost punctuation character.
            //
            if (newValue === value) {
                var newValueFormatted = $404e17b66ef38f5f$var$format(prefix, newValue, country, metadata);
                if (newValueFormatted.indexOf(event.target.value) === 0) // Trim the last digit (or plus sign).
                newValue = newValue.slice(0, -1);
            }
            onChange(newValue);
        }, [
            prefix,
            value,
            onChange,
            country,
            metadata
        ]);
        var _onKeyDown = (0, $df33da29677c3a83$export$2e2bcd8739ae039)({
            onKeyDown: onKeyDown,
            inputFormat: inputFormat
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(Input, $404e17b66ef38f5f$var$_extends({}, rest, {
            ref: ref,
            value: $404e17b66ef38f5f$var$format(prefix, value, country, metadata),
            onChange: _onChange,
            onKeyDown: _onKeyDown
        }));
    }
    InputBasic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef(InputBasic);
    InputBasic.propTypes = {
        /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string.isRequired,
        /**
     * A function of `value: string`.
     * Updates the `value` property.
     */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
        /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
        /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * This property should've been called `defaultCountry`
     * because it only applies when the user inputs a phone number in a national format
     * and is completely ignored when the user inputs a phone number in an international format.
     */ country: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        /**
     * The format that the input field value is being input/output in.
     */ inputFormat: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOf([
            'INTERNATIONAL',
            'NATIONAL_PART_OF_INTERNATIONAL',
            'NATIONAL',
            'INTERNATIONAL_OR_NATIONAL'
        ]).isRequired,
        /**
     * `libphonenumber-js` metadata.
     */ metadata: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
        /**
     * The `<input/>` component.
     */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).elementType
    };
    return InputBasic;
}
var $404e17b66ef38f5f$export$2e2bcd8739ae039 = $404e17b66ef38f5f$export$d80fffb1deb3b97e();
function $404e17b66ef38f5f$var$format(prefix, value, country, metadata) {
    return (0, $0c8f6d6671c026e6$export$4be51b112e32592b)((0, $32bfc1f3232349f9$export$2e2bcd8739ae039)(prefix + value, country, metadata), prefix);
}


var $33b98899e2a46665$var$_excluded = [
    "type",
    "autoComplete",
    "smartCaret",
    "metadata"
];
function $33b98899e2a46665$var$_extends() {
    $33b98899e2a46665$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $33b98899e2a46665$var$_extends.apply(this, arguments);
}
function $33b98899e2a46665$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $33b98899e2a46665$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $33b98899e2a46665$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $33b98899e2a46665$export$d80fffb1deb3b97e(defaultMetadata) {
    function PhoneInput(_ref, ref) {
        var _ref$type = _ref.type, type = _ref$type === void 0 ? 'tel' : _ref$type, _ref$autoComplete = _ref.autoComplete, autoComplete = _ref$autoComplete === void 0 ? 'tel' : _ref$autoComplete, _ref$smartCaret = _ref.smartCaret, smartCaret = _ref$smartCaret === void 0 ? true : _ref$smartCaret, _ref$metadata = _ref.metadata, metadata = _ref$metadata === void 0 ? defaultMetadata : _ref$metadata, rest = $33b98899e2a46665$var$_objectWithoutProperties(_ref, $33b98899e2a46665$var$_excluded);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $3160e5ecb25596e0$export$2e2bcd8739ae039), $33b98899e2a46665$var$_extends({}, rest, {
            type: type,
            autoComplete: autoComplete,
            metadata: metadata,
            ref: ref,
            Component: smartCaret ? (0, $d9a94262fc20e593$export$2e2bcd8739ae039) : (0, $404e17b66ef38f5f$export$2e2bcd8739ae039)
        }));
    }
    PhoneInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef(PhoneInput);
    PhoneInput.propTypes = {
        /**
     * HTML `<input/>` `type` attribute.
     */ type: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        /**
     * HTML `<input/>` `autocomplete` attribute.
     */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        /**
     * By default, the caret position is being "intelligently" managed
     * while a user inputs a phone number.
     * This "smart" caret behavior can be turned off
     * by passing `smartCaret={false}` property.
     * This is just an "escape hatch" for any possible caret position issues.
     */ // Is `true` by default.
        smartCaret: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        /**
     * `libphonenumber-js` metadata.
     */ metadata: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object
    };
    return PhoneInput;
}
var $33b98899e2a46665$export$2e2bcd8739ae039 = $33b98899e2a46665$export$d80fffb1deb3b97e();


function $65c063d7a097ebfd$var$call(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $b28c6832f534c4f2$export$2e2bcd8739ae039));
    return func.apply(this, args);
}
var $65c063d7a097ebfd$export$2e2bcd8739ae039 = (0, $33b98899e2a46665$export$d80fffb1deb3b97e)((0, $b28c6832f534c4f2$export$2e2bcd8739ae039));
function $65c063d7a097ebfd$export$da44e4eaa54bc82e() {
    return $65c063d7a097ebfd$var$call((0, $bd937d41ca0f46d3$export$2e2bcd8739ae039), arguments);
}
function $65c063d7a097ebfd$export$842dcfa371c6bb83() {
    return $65c063d7a097ebfd$var$call((0, $e7443089bac02dfa$export$2e2bcd8739ae039), arguments);
}
function $65c063d7a097ebfd$export$88012462592bc004() {
    return $65c063d7a097ebfd$var$call((0, $e7443089bac02dfa$export$88012462592bc004), arguments);
}
function $65c063d7a097ebfd$export$992e2df24bec72ba() {
    return $65c063d7a097ebfd$var$call((0, $9de37dd71e8863e8$export$2e2bcd8739ae039), arguments);
}
function $65c063d7a097ebfd$export$e102acdf1aeb3167() {
    return $65c063d7a097ebfd$var$call((0, $35acff3c1d7a83c5$export$2e2bcd8739ae039), arguments);
}
function $65c063d7a097ebfd$export$44f7508c6c352cc6() {
    return $65c063d7a097ebfd$var$call((0, $5c184dd7c0b6e321$export$2e2bcd8739ae039), arguments);
}
function $65c063d7a097ebfd$export$32876ca2f1919cf0() {
    return $65c063d7a097ebfd$var$call((0, $0590493bd26b93ec$export$32876ca2f1919cf0), arguments);
}
function $65c063d7a097ebfd$export$bd9e113b8b17202a() {
    return $65c063d7a097ebfd$var$call((0, $0590493bd26b93ec$export$bd9e113b8b17202a), arguments);
}


class $bac186090ef192a7$var$PhoneSubscribe extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    render() {
        if (this.state.submitted) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Fragment, {
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("strong", {
                    children: "Subscribed!"
                })
            })
        });
        else return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $65c063d7a097ebfd$export$2e2bcd8739ae039), {
                    country: "US",
                    placeholder: "Phone number",
                    onChange: (phoneValue)=>{
                        this.setState({
                            validPhone: phoneValue ? (0, $65c063d7a097ebfd$export$992e2df24bec72ba)(phoneValue) : false,
                            phone: phoneValue ? phoneValue : ''
                        });
                    }
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                    className: "plausible-event-name=phone-subscribe",
                    disabled: !this.state.validPhone,
                    onClick: ()=>{
                        (0, $8fec4eb0f62d5de4$export$2e2bcd8739ae039).setSMSNumber(this.state.phone).then(()=>{
                            this.setState({
                                submitted: true
                            });
                        });
                    },
                    children: "Subscribe"
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.state = {
            phone: '',
            validPhone: false,
            submitted: false
        };
    }
}
var $bac186090ef192a7$export$2e2bcd8739ae039 = $bac186090ef192a7$var$PhoneSubscribe;




var $gIfym = parcelRequire("gIfym");

const $c380b6b98c2b3956$var$POLLING_INTERVAL_MS = 300000; // 5 minutes
const $c380b6b98c2b3956$var$TICK_INTERVAL_MS = 1000; // Update visual count every 1 second
const $c380b6b98c2b3956$var$MIN_LIVE_CALL_COUNT = 250;
const $c380b6b98c2b3956$var$CallCount = ()=>{
    const [visualCount, setVisualCount] = (0, $gIfym.useState)(null);
    const [totalCount, setTotalCount] = (0, $gIfym.useState)(null);
    const [showTotalCount, setShowTotalCount] = (0, $gIfym.useState)(true);
    const [loading, setLoading] = (0, $gIfym.useState)(true);
    // Use refs to avoid closure issues in setInterval loop
    const targetCountRef = (0, $gIfym.useRef)(0);
    const incrementRateMsRef = (0, $gIfym.useRef)(0); // calls per millisecond
    const accumulatorRef = (0, $gIfym.useRef)(0);
    const lastTickTimeMsRef = (0, $gIfym.useRef)(-1);
    const fetchCount = ()=>{
        (0, $c6a51ca48f202faf$export$ae74c61fbd18f4e6)().then((data)=>{
            setTotalCount(data.count);
            // Sum counts for hours >= local midnight
            const localMidnight = new Date().setHours(0, 0, 0, 0) / 1000;
            const todayCount = data.hourlyCalls.filter((h)=>h.time >= localMidnight).reduce((sum, h)=>sum + h.count, 0);
            const showTotalCount = todayCount < $c380b6b98c2b3956$var$MIN_LIVE_CALL_COUNT || !data.hourlyCalls || data.hourlyCalls.length < 24;
            setShowTotalCount(showTotalCount);
            if (showTotalCount) {
                setLoading(false);
                // If we were previously live, reset live state
                lastTickTimeMsRef.current = -1;
                return;
            }
            const isLiveInitialized = lastTickTimeMsRef.current !== -1;
            if (!isLiveInitialized) {
                // First page load or first time the calls are above the minimum threshold.
                // Set to 0 to mark as initialized but not yet ticked (prevents deltaMs errors).
                lastTickTimeMsRef.current = 0;
                // Calculate approximate current call rate from current and previous hour
                const currentHour = data.hourlyCalls[data.hourlyCalls.length - 1];
                const prevHour = data.hourlyCalls[data.hourlyCalls.length - 2];
                const elapsedSecInCurrentHour = Math.max(0, data.serverTime - currentHour.time);
                const totalCallsInPeriod = (prevHour?.count || 0) + currentHour.count;
                const totalTimeSecInPeriod = 3600 + elapsedSecInCurrentHour;
                // Rate in calls per millisecond
                const ratePerMs = totalCallsInPeriod / totalTimeSecInPeriod / 1000;
                // Start the visual count at the estimated value from one polling interval ago,
                // then count up to the target count over the first polling interval.
                const startingCount = Math.max(0, todayCount - Math.floor(ratePerMs * $c380b6b98c2b3956$var$POLLING_INTERVAL_MS));
                targetCountRef.current = todayCount;
                incrementRateMsRef.current = ratePerMs;
                accumulatorRef.current = startingCount;
                setVisualCount(startingCount);
                setLoading(false);
            } else {
                // Count up based on how many calls have come in since the previous data load.
                const currentVisual = accumulatorRef.current;
                targetCountRef.current = todayCount;
                if (todayCount > currentVisual) // Distribute increments evenly over the polling window
                incrementRateMsRef.current = (todayCount - currentVisual) / $c380b6b98c2b3956$var$POLLING_INTERVAL_MS;
                else // Pause if we have already reached or exceeded the target
                incrementRateMsRef.current = 0;
            }
        }).catch((err)=>{
            console.error('Failed to fetch live call count:', err);
        });
    };
    const tickCounter = ()=>{
        if (lastTickTimeMsRef.current === -1) // Not ticking live right now.
        return;
        if (lastTickTimeMsRef.current === 0) {
            // First tick.
            lastTickTimeMsRef.current = Date.now();
            return;
        }
        const nowMs = Date.now();
        const deltaMs = nowMs - lastTickTimeMsRef.current;
        lastTickTimeMsRef.current = nowMs;
        if (incrementRateMsRef.current > 0) {
            const nextVal = accumulatorRef.current + incrementRateMsRef.current * deltaMs;
            // Cap the accumulator to targetCountRef.current
            accumulatorRef.current = Math.min(targetCountRef.current, nextVal);
            setVisualCount(Math.floor(accumulatorRef.current));
        }
    };
    (0, $gIfym.useEffect)(()=>{
        fetchCount();
        // Poll for new data.
        const pollInterval = setInterval(fetchCount, $c380b6b98c2b3956$var$POLLING_INTERVAL_MS);
        // Update the display.
        const tickInterval = setInterval(tickCounter, $c380b6b98c2b3956$var$TICK_INTERVAL_MS);
        return ()=>{
            clearInterval(pollInterval);
            clearInterval(tickInterval);
        };
    }, []);
    if (showTotalCount && totalCount !== null) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("span", {
        children: [
            "We\u2019ve made ",
            totalCount.toLocaleString(),
            " calls so far. Join\xa0us."
        ]
    });
    if (loading || showTotalCount || visualCount === null) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
        children: "We\u2019ve made more than 13 million calls so far. Join\xa0us."
    });
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
        className: "live-count-wrapper",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("span", {
            children: [
                "We\u2019ve made ",
                totalCount?.toLocaleString(),
                " calls so far and",
                ' ',
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                    className: "live-count-number",
                    children: visualCount.toLocaleString()
                }, visualCount),
                ' ',
                "calls today. Join\xa0us."
            ]
        })
    });
};
var $c380b6b98c2b3956$export$2e2bcd8739ae039 = $c380b6b98c2b3956$var$CallCount;




var $gIfym = parcelRequire("gIfym");

class $74944d1921030697$var$APIForm extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    sendForm(e) {
        e.preventDefault();
        (0, $c6a51ca48f202faf$export$4a95b7244775efbe)(this.state.email).then(()=>{
            this.setState({
                emailSent: true
            });
        }).catch((error)=>{
            const axiosError = error;
            if (axiosError.response) this.setState({
                errorText: axiosError.response.data.error
            });
            else this.setState({
                errorText: 'could not submit email'
            });
        });
    }
    render() {
        if (!this.state.emailSent) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("form", {
            onSubmit: (e)=>this.sendForm(e),
            children: [
                this.state.errorText !== '' ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                    className: "a-ctr error",
                    children: this.state.errorText
                }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {}),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                    className: "a-ctr token-email",
                    onChange: this.updateEmailAddress,
                    placeholder: "email@example.com",
                    type: "email"
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                    className: "a-ctr",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                        className: "button",
                        children: "Get your API Key"
                    })
                })
            ]
        });
        else return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
            className: "a-ctr",
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("strong", {
                children: "Thanks! Check your inbox shortly"
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            emailSent: false,
            email: '',
            errorText: ''
        }, this.updateEmailAddress = (e)=>{
            this.setState({
                email: e.target.value
            });
        };
    }
}
var $74944d1921030697$export$2e2bcd8739ae039 = $74944d1921030697$var$APIForm;



parcelRequire("gIfym");

function $14edbfa9de73b5fc$var$Settings() {
    const { callingGroup: callingGroup, setCallingGroup: setCallingGroup, saveSettings: saveSettings, isSaved: isSaved } = (0, $298b7c465de541c3$export$9115b42802a3e44f)();
    const handleSubmit = (e)=>{
        e.preventDefault();
        saveSettings();
        setTimeout(()=>{
            window.location.href = '/';
        }, 2000);
    };
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h1", {
                className: "",
                children: "Settings"
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("label", {
                        children: "Calling Group"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                        type: "text",
                        value: callingGroup,
                        onChange: (e)=>setCallingGroup(e.target.value),
                        placeholder: "Enter your calling group",
                        className: ""
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                        className: "small",
                        children: "Set a calling group name to track calls with others"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                        type: "submit",
                        className: `button button-small ${isSaved ? 'button-disabled' : ''}`,
                        disabled: isSaved,
                        children: isSaved ? 'Saved' : 'Save'
                    })
                ]
            })
        ]
    });
}
var $14edbfa9de73b5fc$export$2e2bcd8739ae039 = $14edbfa9de73b5fc$var$Settings;




var $gIfym = parcelRequire("gIfym");

class $26e2d871a9745be4$var$GroupCallCount extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    componentDidMount() {
        (0, $c6a51ca48f202faf$export$9848587ec8d73f78)(this.props.group).then((response)=>{
            this.setState({
                issueCounts: response.issueCounts,
                total: response.total,
                isLoading: false
            });
        }).catch(()=>{
            this.setState({
                error: 'Failed to load call counts',
                isLoading: false
            });
        });
    }
    render() {
        const { issueCounts: issueCounts, total: total, isLoading: isLoading, error: error } = this.state;
        if (isLoading) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
            children: "Loading call counts..."
        });
        if (error) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
            children: error
        });
        if (issueCounts.length === 0) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
            children: "No calls recorded yet."
        });
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("h3", {
                    children: [
                        "Call Counts by Issue for ",
                        this.props.group,
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("p", {
                    children: [
                        "Total calls (all-time): ",
                        total.toLocaleString()
                    ]
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                    children: "Issue counts, last 30 days:"
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("ul", {
                    style: {
                        listStyle: 'none',
                        padding: 0
                    },
                    children: issueCounts.map((issue)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("li", {
                            children: [
                                issue.count.toLocaleString(),
                                " calls: ",
                                issue.name
                            ]
                        }, issue.name))
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.state = {
            issueCounts: [],
            total: 0,
            isLoading: true
        };
    }
}
var $26e2d871a9745be4$export$2e2bcd8739ae039 = $26e2d871a9745be4$var$GroupCallCount;




var $gIfym = parcelRequire("gIfym");
class $0992cd7728ed6f24$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $0992cd7728ed6f24$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($0992cd7728ed6f24$var$intern_get(this, key));
    }
    has(key) {
        return super.has($0992cd7728ed6f24$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($0992cd7728ed6f24$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($0992cd7728ed6f24$var$intern_delete(this, key));
    }
}
class $0992cd7728ed6f24$export$55278c3294239828 extends Set {
    constructor(values, key = $0992cd7728ed6f24$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($0992cd7728ed6f24$var$intern_get(this, value));
    }
    add(value) {
        return super.add($0992cd7728ed6f24$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($0992cd7728ed6f24$var$intern_delete(this, value));
    }
}
function $0992cd7728ed6f24$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $0992cd7728ed6f24$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $0992cd7728ed6f24$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $0992cd7728ed6f24$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}


function $38fcc29cf797a881$export$2e2bcd8739ae039(x) {
    return x;
}


function $f15ffc2889c669d7$export$2e2bcd8739ae039(values, ...keys) {
    return $f15ffc2889c669d7$var$nest(values, (0, $38fcc29cf797a881$export$2e2bcd8739ae039), (0, $38fcc29cf797a881$export$2e2bcd8739ae039), keys);
}
function $f15ffc2889c669d7$export$d4abd167df80d226(values, ...keys) {
    return $f15ffc2889c669d7$var$nest(values, Array.from, (0, $38fcc29cf797a881$export$2e2bcd8739ae039), keys);
}
function $f15ffc2889c669d7$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $f15ffc2889c669d7$export$4ed6fc79ae2c51b5(values, ...keys) {
    return $f15ffc2889c669d7$var$flatten($f15ffc2889c669d7$export$d4abd167df80d226(values, ...keys), keys);
}
function $f15ffc2889c669d7$export$788c7294dbcd8e36(values, reduce, ...keys) {
    return $f15ffc2889c669d7$var$flatten($f15ffc2889c669d7$export$24814875ed03194b(values, reduce, ...keys), keys);
}
function $f15ffc2889c669d7$export$97e11c0b0230f130(values, reduce, ...keys) {
    return $f15ffc2889c669d7$var$nest(values, (0, $38fcc29cf797a881$export$2e2bcd8739ae039), reduce, keys);
}
function $f15ffc2889c669d7$export$24814875ed03194b(values, reduce, ...keys) {
    return $f15ffc2889c669d7$var$nest(values, Array.from, reduce, keys);
}
function $f15ffc2889c669d7$export$b610b8812bbcded9(values, ...keys) {
    return $f15ffc2889c669d7$var$nest(values, (0, $38fcc29cf797a881$export$2e2bcd8739ae039), $f15ffc2889c669d7$var$unique, keys);
}
function $f15ffc2889c669d7$export$8b04ba635e5803cd(values, ...keys) {
    return $f15ffc2889c669d7$var$nest(values, Array.from, $f15ffc2889c669d7$var$unique, keys);
}
function $f15ffc2889c669d7$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $f15ffc2889c669d7$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new (0, $0992cd7728ed6f24$export$dcc6fb7d82b5bc7b)();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

function $cc3dca62b9e77dd8$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}


function $958352f6b73fa668$export$2e2bcd8739ae039(x) {
    return x;
}


var $b479890018e3ebe0$var$top = 1, $b479890018e3ebe0$var$right = 2, $b479890018e3ebe0$var$bottom = 3, $b479890018e3ebe0$var$left = 4, $b479890018e3ebe0$var$epsilon = 1e-6;
function $b479890018e3ebe0$var$translateX(x) {
    return "translate(" + x + ",0)";
}
function $b479890018e3ebe0$var$translateY(y) {
    return "translate(0," + y + ")";
}
function $b479890018e3ebe0$var$number(scale) {
    return (d)=>+scale(d);
}
function $b479890018e3ebe0$var$center(scale, offset) {
    offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
    if (scale.round()) offset = Math.round(offset);
    return (d)=>+scale(d) + offset;
}
function $b479890018e3ebe0$var$entering() {
    return !this.__axis;
}
function $b479890018e3ebe0$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === $b479890018e3ebe0$var$top || orient === $b479890018e3ebe0$var$left ? -1 : 1, x = orient === $b479890018e3ebe0$var$left || orient === $b479890018e3ebe0$var$right ? "x" : "y", transform = orient === $b479890018e3ebe0$var$top || orient === $b479890018e3ebe0$var$bottom ? $b479890018e3ebe0$var$translateX : $b479890018e3ebe0$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $958352f6b73fa668$export$2e2bcd8739ae039) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? $b479890018e3ebe0$var$center : $b479890018e3ebe0$var$number)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $b479890018e3ebe0$var$top ? "0em" : orient === $b479890018e3ebe0$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $b479890018e3ebe0$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $b479890018e3ebe0$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
            });
        }
        tickExit.remove();
        path.attr("d", orient === $b479890018e3ebe0$var$left || orient === $b479890018e3ebe0$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d) + offset);
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($b479890018e3ebe0$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $b479890018e3ebe0$var$right ? "start" : orient === $b479890018e3ebe0$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = Array.from(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    axis.offset = function(_) {
        return arguments.length ? (offset = +_, axis) : offset;
    };
    return axis;
}
function $b479890018e3ebe0$export$59b8cfab074bdeb1(scale) {
    return $b479890018e3ebe0$var$axis($b479890018e3ebe0$var$top, scale);
}
function $b479890018e3ebe0$export$b0d2e24dc4f898f0(scale) {
    return $b479890018e3ebe0$var$axis($b479890018e3ebe0$var$right, scale);
}
function $b479890018e3ebe0$export$e5cb22533a15e72e(scale) {
    return $b479890018e3ebe0$var$axis($b479890018e3ebe0$var$bottom, scale);
}
function $b479890018e3ebe0$export$2749afb169a520d2(scale) {
    return $b479890018e3ebe0$var$axis($b479890018e3ebe0$var$left, scale);
}


var $a7ac57445b8c2673$var$noop = {
    value: ()=>{}
};
function $a7ac57445b8c2673$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $a7ac57445b8c2673$var$Dispatch(_);
}
function $a7ac57445b8c2673$var$Dispatch(_) {
    this._ = _;
}
function $a7ac57445b8c2673$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$a7ac57445b8c2673$var$Dispatch.prototype = $a7ac57445b8c2673$var$dispatch.prototype = {
    constructor: $a7ac57445b8c2673$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $a7ac57445b8c2673$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $a7ac57445b8c2673$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $a7ac57445b8c2673$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $a7ac57445b8c2673$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $a7ac57445b8c2673$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $a7ac57445b8c2673$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $a7ac57445b8c2673$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $a7ac57445b8c2673$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $a7ac57445b8c2673$export$2e2bcd8739ae039 = $a7ac57445b8c2673$var$dispatch;



function $8ba95871922ca97a$var$none() {}
function $8ba95871922ca97a$export$2e2bcd8739ae039(selector) {
    return selector == null ? $8ba95871922ca97a$var$none : function() {
        return this.querySelector(selector);
    };
}


function $1077269fb26f8133$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $8ba95871922ca97a$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $b6616ac03e7685f2$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $b158ee8071bed608$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $ac5f3cc81c00e9c1$var$empty() {
    return [];
}
function $ac5f3cc81c00e9c1$export$2e2bcd8739ae039(selector) {
    return selector == null ? $ac5f3cc81c00e9c1$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $c41ef7c6b73f80b6$var$arrayAll(select) {
    return function() {
        return (0, $b158ee8071bed608$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $c41ef7c6b73f80b6$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $c41ef7c6b73f80b6$var$arrayAll(select);
    else select = (0, $ac5f3cc81c00e9c1$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $b6616ac03e7685f2$export$52baac22726c72bf)(subgroups, parents);
}


function $4e08db65925746f5$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $4e08db65925746f5$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $d2807242b57991ae$var$find = Array.prototype.find;
function $d2807242b57991ae$var$childFind(match) {
    return function() {
        return $d2807242b57991ae$var$find.call(this.children, match);
    };
}
function $d2807242b57991ae$var$childFirst() {
    return this.firstElementChild;
}
function $d2807242b57991ae$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $d2807242b57991ae$var$childFirst : $d2807242b57991ae$var$childFind(typeof match === "function" ? match : (0, $4e08db65925746f5$export$90c2759c036528)(match)));
}



var $10ada17f179c5750$var$filter = Array.prototype.filter;
function $10ada17f179c5750$var$children() {
    return Array.from(this.children);
}
function $10ada17f179c5750$var$childrenFilter(match) {
    return function() {
        return $10ada17f179c5750$var$filter.call(this.children, match);
    };
}
function $10ada17f179c5750$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $10ada17f179c5750$var$children : $10ada17f179c5750$var$childrenFilter(typeof match === "function" ? match : (0, $4e08db65925746f5$export$90c2759c036528)(match)));
}




function $24e024eef9e6eee7$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $4e08db65925746f5$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $b6616ac03e7685f2$export$52baac22726c72bf)(subgroups, this._parents);
}



function $ac852ec130acad61$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $5a517c41490027f3$export$2e2bcd8739ae039() {
    return new (0, $b6616ac03e7685f2$export$52baac22726c72bf)(this._enter || this._groups.map((0, $ac852ec130acad61$export$2e2bcd8739ae039)), this._parents);
}
function $5a517c41490027f3$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$5a517c41490027f3$export$67b01759a14cf6a4.prototype = {
    constructor: $5a517c41490027f3$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $3f2fc6340cd4c06a$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $66bd4c8ed5716c38$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $5a517c41490027f3$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $66bd4c8ed5716c38$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $5a517c41490027f3$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $66bd4c8ed5716c38$var$datum(node) {
    return node.__data__;
}
function $66bd4c8ed5716c38$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $66bd4c8ed5716c38$var$datum);
    var bind = key ? $66bd4c8ed5716c38$var$bindKey : $66bd4c8ed5716c38$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $3f2fc6340cd4c06a$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $66bd4c8ed5716c38$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $b6616ac03e7685f2$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $66bd4c8ed5716c38$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $e55163bd03a9ec01$export$2e2bcd8739ae039() {
    return new (0, $b6616ac03e7685f2$export$52baac22726c72bf)(this._exit || this._groups.map((0, $ac852ec130acad61$export$2e2bcd8739ae039)), this._parents);
}


function $f74d644d6a620eb4$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $63e06d2466d6026f$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $b6616ac03e7685f2$export$52baac22726c72bf)(merges, this._parents);
}


function $322c17924bdd7a44$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $3f647bf233d39c39$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $3f647bf233d39c39$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $b6616ac03e7685f2$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $3f647bf233d39c39$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $26476f0b7ffa1856$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $4cabb4b8847b2964$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $db5e82fc13353ec5$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $9b769dfc9ebe21c1$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $5cccd63b2e643672$export$2e2bcd8739ae039() {
    return !this.node();
}


function $c4bbe79c4cf05f57$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $a3413f6c71249316$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $a3413f6c71249316$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $a3413f6c71249316$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $d0955d5598d8ad69$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $a3413f6c71249316$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $a3413f6c71249316$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $28ebea0fad129f44$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $28ebea0fad129f44$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $28ebea0fad129f44$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $28ebea0fad129f44$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $28ebea0fad129f44$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $28ebea0fad129f44$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $28ebea0fad129f44$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $d0955d5598d8ad69$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $28ebea0fad129f44$var$attrRemoveNS : $28ebea0fad129f44$var$attrRemove : typeof value === "function" ? fullname.local ? $28ebea0fad129f44$var$attrFunctionNS : $28ebea0fad129f44$var$attrFunction : fullname.local ? $28ebea0fad129f44$var$attrConstantNS : $28ebea0fad129f44$var$attrConstant)(fullname, value));
}


function $5004dbfa933bafff$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $b45351023b0cd744$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $b45351023b0cd744$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $b45351023b0cd744$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $b45351023b0cd744$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $b45351023b0cd744$var$styleRemove : typeof value === "function" ? $b45351023b0cd744$var$styleFunction : $b45351023b0cd744$var$styleConstant)(name, value, priority == null ? "" : priority)) : $b45351023b0cd744$export$5e3cec964f0b5efd(this.node(), name);
}
function $b45351023b0cd744$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $5004dbfa933bafff$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $1390267cf99421ef$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $1390267cf99421ef$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $1390267cf99421ef$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $1390267cf99421ef$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $1390267cf99421ef$var$propertyRemove : typeof value === "function" ? $1390267cf99421ef$var$propertyFunction : $1390267cf99421ef$var$propertyConstant)(name, value)) : this.node()[name];
}


function $1dbf196e3ef73766$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $1dbf196e3ef73766$var$classList(node) {
    return node.classList || new $1dbf196e3ef73766$var$ClassList(node);
}
function $1dbf196e3ef73766$var$ClassList(node) {
    this._node = node;
    this._names = $1dbf196e3ef73766$var$classArray(node.getAttribute("class") || "");
}
$1dbf196e3ef73766$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $1dbf196e3ef73766$var$classedAdd(node, names) {
    var list = $1dbf196e3ef73766$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $1dbf196e3ef73766$var$classedRemove(node, names) {
    var list = $1dbf196e3ef73766$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $1dbf196e3ef73766$var$classedTrue(names) {
    return function() {
        $1dbf196e3ef73766$var$classedAdd(this, names);
    };
}
function $1dbf196e3ef73766$var$classedFalse(names) {
    return function() {
        $1dbf196e3ef73766$var$classedRemove(this, names);
    };
}
function $1dbf196e3ef73766$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $1dbf196e3ef73766$var$classedAdd : $1dbf196e3ef73766$var$classedRemove)(this, names);
    };
}
function $1dbf196e3ef73766$export$2e2bcd8739ae039(name, value) {
    var names = $1dbf196e3ef73766$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $1dbf196e3ef73766$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $1dbf196e3ef73766$var$classedFunction : value ? $1dbf196e3ef73766$var$classedTrue : $1dbf196e3ef73766$var$classedFalse)(names, value));
}


function $b9e910bf53b383dc$var$textRemove() {
    this.textContent = "";
}
function $b9e910bf53b383dc$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $b9e910bf53b383dc$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $b9e910bf53b383dc$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $b9e910bf53b383dc$var$textRemove : (typeof value === "function" ? $b9e910bf53b383dc$var$textFunction : $b9e910bf53b383dc$var$textConstant)(value)) : this.node().textContent;
}


function $77331a7c06aa0412$var$htmlRemove() {
    this.innerHTML = "";
}
function $77331a7c06aa0412$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $77331a7c06aa0412$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $77331a7c06aa0412$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $77331a7c06aa0412$var$htmlRemove : (typeof value === "function" ? $77331a7c06aa0412$var$htmlFunction : $77331a7c06aa0412$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $63194ae6b0a6b4bb$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $63194ae6b0a6b4bb$export$2e2bcd8739ae039() {
    return this.each($63194ae6b0a6b4bb$var$raise);
}


function $bc671102add14c91$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $bc671102add14c91$export$2e2bcd8739ae039() {
    return this.each($bc671102add14c91$var$lower);
}




function $848123319efca59f$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $a3413f6c71249316$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $a3413f6c71249316$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $848123319efca59f$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $848123319efca59f$export$2e2bcd8739ae039(name) {
    var fullname = (0, $d0955d5598d8ad69$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $848123319efca59f$var$creatorFixed : $848123319efca59f$var$creatorInherit)(fullname);
}


function $c524bba233450472$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $848123319efca59f$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $dda20565b4075b43$var$constantNull() {
    return null;
}
function $dda20565b4075b43$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $848123319efca59f$export$2e2bcd8739ae039)(name), select = before == null ? $dda20565b4075b43$var$constantNull : typeof before === "function" ? before : (0, $8ba95871922ca97a$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $641cebfb09e74a5a$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $641cebfb09e74a5a$export$2e2bcd8739ae039() {
    return this.each($641cebfb09e74a5a$var$remove);
}


function $0a5341b8a7e3086c$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $0a5341b8a7e3086c$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $0a5341b8a7e3086c$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $0a5341b8a7e3086c$var$selection_cloneDeep : $0a5341b8a7e3086c$var$selection_cloneShallow);
}


function $a0cd4613cd03ee45$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $795bae471fe77758$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $795bae471fe77758$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $795bae471fe77758$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $795bae471fe77758$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $795bae471fe77758$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $795bae471fe77758$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $795bae471fe77758$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $795bae471fe77758$var$onAdd : $795bae471fe77758$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $012f35fc3493ebd2$var$dispatchEvent(node, type, params) {
    var window = (0, $5004dbfa933bafff$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $012f35fc3493ebd2$var$dispatchConstant(type, params) {
    return function() {
        return $012f35fc3493ebd2$var$dispatchEvent(this, type, params);
    };
}
function $012f35fc3493ebd2$var$dispatchFunction(type, params) {
    return function() {
        return $012f35fc3493ebd2$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $012f35fc3493ebd2$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $012f35fc3493ebd2$var$dispatchFunction : $012f35fc3493ebd2$var$dispatchConstant)(type, params));
}


function* $178c69f77b3fc188$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $b6616ac03e7685f2$export$e8e78c978b129247 = [
    null
];
function $b6616ac03e7685f2$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $b6616ac03e7685f2$var$selection() {
    return new $b6616ac03e7685f2$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $b6616ac03e7685f2$export$e8e78c978b129247);
}
function $b6616ac03e7685f2$var$selection_selection() {
    return this;
}
$b6616ac03e7685f2$export$52baac22726c72bf.prototype = $b6616ac03e7685f2$var$selection.prototype = {
    constructor: $b6616ac03e7685f2$export$52baac22726c72bf,
    select: (0, $1077269fb26f8133$export$2e2bcd8739ae039),
    selectAll: (0, $c41ef7c6b73f80b6$export$2e2bcd8739ae039),
    selectChild: (0, $d2807242b57991ae$export$2e2bcd8739ae039),
    selectChildren: (0, $10ada17f179c5750$export$2e2bcd8739ae039),
    filter: (0, $24e024eef9e6eee7$export$2e2bcd8739ae039),
    data: (0, $66bd4c8ed5716c38$export$2e2bcd8739ae039),
    enter: (0, $5a517c41490027f3$export$2e2bcd8739ae039),
    exit: (0, $e55163bd03a9ec01$export$2e2bcd8739ae039),
    join: (0, $f74d644d6a620eb4$export$2e2bcd8739ae039),
    merge: (0, $63e06d2466d6026f$export$2e2bcd8739ae039),
    selection: $b6616ac03e7685f2$var$selection_selection,
    order: (0, $322c17924bdd7a44$export$2e2bcd8739ae039),
    sort: (0, $3f647bf233d39c39$export$2e2bcd8739ae039),
    call: (0, $26476f0b7ffa1856$export$2e2bcd8739ae039),
    nodes: (0, $4cabb4b8847b2964$export$2e2bcd8739ae039),
    node: (0, $db5e82fc13353ec5$export$2e2bcd8739ae039),
    size: (0, $9b769dfc9ebe21c1$export$2e2bcd8739ae039),
    empty: (0, $5cccd63b2e643672$export$2e2bcd8739ae039),
    each: (0, $c4bbe79c4cf05f57$export$2e2bcd8739ae039),
    attr: (0, $28ebea0fad129f44$export$2e2bcd8739ae039),
    style: (0, $b45351023b0cd744$export$2e2bcd8739ae039),
    property: (0, $1390267cf99421ef$export$2e2bcd8739ae039),
    classed: (0, $1dbf196e3ef73766$export$2e2bcd8739ae039),
    text: (0, $b9e910bf53b383dc$export$2e2bcd8739ae039),
    html: (0, $77331a7c06aa0412$export$2e2bcd8739ae039),
    raise: (0, $63194ae6b0a6b4bb$export$2e2bcd8739ae039),
    lower: (0, $bc671102add14c91$export$2e2bcd8739ae039),
    append: (0, $c524bba233450472$export$2e2bcd8739ae039),
    insert: (0, $dda20565b4075b43$export$2e2bcd8739ae039),
    remove: (0, $641cebfb09e74a5a$export$2e2bcd8739ae039),
    clone: (0, $0a5341b8a7e3086c$export$2e2bcd8739ae039),
    datum: (0, $a0cd4613cd03ee45$export$2e2bcd8739ae039),
    on: (0, $795bae471fe77758$export$2e2bcd8739ae039),
    dispatch: (0, $012f35fc3493ebd2$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $178c69f77b3fc188$export$2e2bcd8739ae039)
};
var $b6616ac03e7685f2$export$2e2bcd8739ae039 = $b6616ac03e7685f2$var$selection;


function $b0ba9a260c958684$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $b6616ac03e7685f2$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $b6616ac03e7685f2$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $b6616ac03e7685f2$export$e8e78c978b129247));
}


// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $a472fea0a5c55489$export$524615cd03e458cc = {
    passive: false
};
const $a472fea0a5c55489$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $a472fea0a5c55489$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $a472fea0a5c55489$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


function $b4bf2a47d576b8cb$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $b0ba9a260c958684$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $a472fea0a5c55489$export$2e2bcd8739ae039), (0, $a472fea0a5c55489$export$35431a0e47022de1));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $a472fea0a5c55489$export$2e2bcd8739ae039), (0, $a472fea0a5c55489$export$35431a0e47022de1));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $b4bf2a47d576b8cb$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $b0ba9a260c958684$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $a472fea0a5c55489$export$2e2bcd8739ae039), (0, $a472fea0a5c55489$export$35431a0e47022de1));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



var $fdbil = parcelRequire("fdbil");

var $fdbil = parcelRequire("fdbil");
function $cf290da1b4bb5495$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $cf290da1b4bb5495$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $cf290da1b4bb5495$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $f2cc5b06c3b5bfcd$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $cf290da1b4bb5495$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $bf0713baa76d42ff$export$2e2bcd8739ae039 = (x)=>()=>x;


function $85be835d26b0f95f$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $85be835d26b0f95f$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $85be835d26b0f95f$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $85be835d26b0f95f$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $bf0713baa76d42ff$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $85be835d26b0f95f$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $85be835d26b0f95f$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $85be835d26b0f95f$var$exponential(a, b, y) : (0, $bf0713baa76d42ff$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $85be835d26b0f95f$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $85be835d26b0f95f$var$linear(a, d) : (0, $bf0713baa76d42ff$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $de8a204dca978e16$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $85be835d26b0f95f$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $fdbil.rgb)(start)).r, (end = (0, $fdbil.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $85be835d26b0f95f$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $de8a204dca978e16$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $fdbil.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $de8a204dca978e16$export$2c0e28f2e2852d3f = $de8a204dca978e16$var$rgbSpline((0, $cf290da1b4bb5495$export$2e2bcd8739ae039));
var $de8a204dca978e16$export$53d5214f625ccd4c = $de8a204dca978e16$var$rgbSpline((0, $f2cc5b06c3b5bfcd$export$2e2bcd8739ae039));



function $d2e03516cdbd7760$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $d2e03516cdbd7760$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $c2aa8741f7abe917$export$2e2bcd8739ae039(a, b) {
    return ((0, $d2e03516cdbd7760$export$5cd576d1827d40c8)(b) ? (0, $d2e03516cdbd7760$export$2e2bcd8739ae039) : $c2aa8741f7abe917$export$15d09067c6a5ee49)(a, b);
}
function $c2aa8741f7abe917$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $790287a65f557be7$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $fae2d68b1770c371$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $f124178efa7c0f49$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $4e7e0e3fdb37cf76$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $790287a65f557be7$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $49b9f54faa5401c4$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $49b9f54faa5401c4$var$reB = new RegExp($49b9f54faa5401c4$var$reA.source, "g");
function $49b9f54faa5401c4$var$zero(b) {
    return function() {
        return b;
    };
}
function $49b9f54faa5401c4$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $49b9f54faa5401c4$export$2e2bcd8739ae039(a, b) {
    var bi = $49b9f54faa5401c4$var$reA.lastIndex = $49b9f54faa5401c4$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $49b9f54faa5401c4$var$reA.exec(a)) && (bm = $49b9f54faa5401c4$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $f124178efa7c0f49$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $49b9f54faa5401c4$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $49b9f54faa5401c4$var$one(q[0].x) : $49b9f54faa5401c4$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $790287a65f557be7$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $bf0713baa76d42ff$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $f124178efa7c0f49$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $fdbil.default)(b)) ? (b = c, $de8a204dca978e16$export$2e2bcd8739ae039) : (0, $49b9f54faa5401c4$export$2e2bcd8739ae039) : b instanceof (0, $fdbil.default) ? (0, $de8a204dca978e16$export$2e2bcd8739ae039) : b instanceof Date ? (0, $fae2d68b1770c371$export$2e2bcd8739ae039) : (0, $d2e03516cdbd7760$export$5cd576d1827d40c8)(b) ? (0, $d2e03516cdbd7760$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $c2aa8741f7abe917$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $4e7e0e3fdb37cf76$export$2e2bcd8739ae039) : (0, $f124178efa7c0f49$export$2e2bcd8739ae039))(a, b);
}


function $e638c830648723fa$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}


function $3c7b4c5122b1c4f6$export$2e2bcd8739ae039(event, node) {
    event = (0, $e638c830648723fa$export$2e2bcd8739ae039)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}




var $5e8c98c7b2f5bcf8$var$frame = 0, $5e8c98c7b2f5bcf8$var$timeout = 0, $5e8c98c7b2f5bcf8$var$interval = 0, $5e8c98c7b2f5bcf8$var$pokeDelay = 1000, $5e8c98c7b2f5bcf8$var$taskHead, $5e8c98c7b2f5bcf8$var$taskTail, $5e8c98c7b2f5bcf8$var$clockLast = 0, $5e8c98c7b2f5bcf8$var$clockNow = 0, $5e8c98c7b2f5bcf8$var$clockSkew = 0, $5e8c98c7b2f5bcf8$var$clock = typeof performance === "object" && performance.now ? performance : Date, $5e8c98c7b2f5bcf8$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $5e8c98c7b2f5bcf8$export$461939dd4422153() {
    return $5e8c98c7b2f5bcf8$var$clockNow || ($5e8c98c7b2f5bcf8$var$setFrame($5e8c98c7b2f5bcf8$var$clearNow), $5e8c98c7b2f5bcf8$var$clockNow = $5e8c98c7b2f5bcf8$var$clock.now() + $5e8c98c7b2f5bcf8$var$clockSkew);
}
function $5e8c98c7b2f5bcf8$var$clearNow() {
    $5e8c98c7b2f5bcf8$var$clockNow = 0;
}
function $5e8c98c7b2f5bcf8$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$5e8c98c7b2f5bcf8$export$c57e9b2d8b9e4de.prototype = $5e8c98c7b2f5bcf8$export$9dc4ecf953986f04.prototype = {
    constructor: $5e8c98c7b2f5bcf8$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $5e8c98c7b2f5bcf8$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $5e8c98c7b2f5bcf8$var$taskTail !== this) {
            if ($5e8c98c7b2f5bcf8$var$taskTail) $5e8c98c7b2f5bcf8$var$taskTail._next = this;
            else $5e8c98c7b2f5bcf8$var$taskHead = this;
            $5e8c98c7b2f5bcf8$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $5e8c98c7b2f5bcf8$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $5e8c98c7b2f5bcf8$var$sleep();
        }
    }
};
function $5e8c98c7b2f5bcf8$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $5e8c98c7b2f5bcf8$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $5e8c98c7b2f5bcf8$export$d60154c1d7f3990e() {
    $5e8c98c7b2f5bcf8$export$461939dd4422153(); // Get the current time, if not already set.
    ++$5e8c98c7b2f5bcf8$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $5e8c98c7b2f5bcf8$var$taskHead, e;
    while(t){
        if ((e = $5e8c98c7b2f5bcf8$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$5e8c98c7b2f5bcf8$var$frame;
}
function $5e8c98c7b2f5bcf8$var$wake() {
    $5e8c98c7b2f5bcf8$var$clockNow = ($5e8c98c7b2f5bcf8$var$clockLast = $5e8c98c7b2f5bcf8$var$clock.now()) + $5e8c98c7b2f5bcf8$var$clockSkew;
    $5e8c98c7b2f5bcf8$var$frame = $5e8c98c7b2f5bcf8$var$timeout = 0;
    try {
        $5e8c98c7b2f5bcf8$export$d60154c1d7f3990e();
    } finally{
        $5e8c98c7b2f5bcf8$var$frame = 0;
        $5e8c98c7b2f5bcf8$var$nap();
        $5e8c98c7b2f5bcf8$var$clockNow = 0;
    }
}
function $5e8c98c7b2f5bcf8$var$poke() {
    var now = $5e8c98c7b2f5bcf8$var$clock.now(), delay = now - $5e8c98c7b2f5bcf8$var$clockLast;
    if (delay > $5e8c98c7b2f5bcf8$var$pokeDelay) $5e8c98c7b2f5bcf8$var$clockSkew -= delay, $5e8c98c7b2f5bcf8$var$clockLast = now;
}
function $5e8c98c7b2f5bcf8$var$nap() {
    var t0, t1 = $5e8c98c7b2f5bcf8$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $5e8c98c7b2f5bcf8$var$taskHead = t2;
    }
    $5e8c98c7b2f5bcf8$var$taskTail = t0;
    $5e8c98c7b2f5bcf8$var$sleep(time);
}
function $5e8c98c7b2f5bcf8$var$sleep(time) {
    if ($5e8c98c7b2f5bcf8$var$frame) return; // Soonest alarm already set, or will be.
    if ($5e8c98c7b2f5bcf8$var$timeout) $5e8c98c7b2f5bcf8$var$timeout = clearTimeout($5e8c98c7b2f5bcf8$var$timeout);
    var delay = time - $5e8c98c7b2f5bcf8$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $5e8c98c7b2f5bcf8$var$timeout = setTimeout($5e8c98c7b2f5bcf8$var$wake, time - $5e8c98c7b2f5bcf8$var$clock.now() - $5e8c98c7b2f5bcf8$var$clockSkew);
        if ($5e8c98c7b2f5bcf8$var$interval) $5e8c98c7b2f5bcf8$var$interval = clearInterval($5e8c98c7b2f5bcf8$var$interval);
    } else {
        if (!$5e8c98c7b2f5bcf8$var$interval) $5e8c98c7b2f5bcf8$var$clockLast = $5e8c98c7b2f5bcf8$var$clock.now(), $5e8c98c7b2f5bcf8$var$interval = setInterval($5e8c98c7b2f5bcf8$var$poke, $5e8c98c7b2f5bcf8$var$pokeDelay);
        $5e8c98c7b2f5bcf8$var$frame = 1, $5e8c98c7b2f5bcf8$var$setFrame($5e8c98c7b2f5bcf8$var$wake);
    }
}


function $9ea2c51ec23ff9b5$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $5e8c98c7b2f5bcf8$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $0358a71e6ed8b7a4$var$emptyOn = (0, $a7ac57445b8c2673$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $0358a71e6ed8b7a4$var$emptyTween = [];
var $0358a71e6ed8b7a4$export$ff39ebd4bb12b718 = 0;
var $0358a71e6ed8b7a4$export$584530fe98d14a84 = 1;
var $0358a71e6ed8b7a4$export$a5d151aee16efd42 = 2;
var $0358a71e6ed8b7a4$export$fb935ab5849a0db9 = 3;
var $0358a71e6ed8b7a4$export$1573e22b087389af = 4;
var $0358a71e6ed8b7a4$export$a2e792214ded83b2 = 5;
var $0358a71e6ed8b7a4$export$9d38167254403955 = 6;
function $0358a71e6ed8b7a4$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $0358a71e6ed8b7a4$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $0358a71e6ed8b7a4$var$emptyOn,
        tween: $0358a71e6ed8b7a4$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $0358a71e6ed8b7a4$export$ff39ebd4bb12b718
    });
}
function $0358a71e6ed8b7a4$export$2cd8252107eb640b(node, id) {
    var schedule = $0358a71e6ed8b7a4$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $0358a71e6ed8b7a4$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $0358a71e6ed8b7a4$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $0358a71e6ed8b7a4$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $0358a71e6ed8b7a4$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $0358a71e6ed8b7a4$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $0358a71e6ed8b7a4$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $5e8c98c7b2f5bcf8$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $0358a71e6ed8b7a4$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $0358a71e6ed8b7a4$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $0358a71e6ed8b7a4$export$fb935ab5849a0db9) return (0, $9ea2c51ec23ff9b5$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $0358a71e6ed8b7a4$export$1573e22b087389af) {
                o.state = $0358a71e6ed8b7a4$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $0358a71e6ed8b7a4$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $9ea2c51ec23ff9b5$export$2e2bcd8739ae039)(function() {
            if (self.state === $0358a71e6ed8b7a4$export$fb935ab5849a0db9) {
                self.state = $0358a71e6ed8b7a4$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $0358a71e6ed8b7a4$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $0358a71e6ed8b7a4$export$a5d151aee16efd42) return; // interrupted
        self.state = $0358a71e6ed8b7a4$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $0358a71e6ed8b7a4$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $0358a71e6ed8b7a4$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $0358a71e6ed8b7a4$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $b41725ddfae0f3a3$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $0358a71e6ed8b7a4$export$a5d151aee16efd42) && schedule.state < (0, $0358a71e6ed8b7a4$export$a2e792214ded83b2);
        schedule.state = (0, $0358a71e6ed8b7a4$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $7acc86f26e2f32bf$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $b41725ddfae0f3a3$export$2e2bcd8739ae039)(this, name);
    });
}




var $bc1eb909a5b63280$var$degrees = 180 / Math.PI;
var $bc1eb909a5b63280$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $bc1eb909a5b63280$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $bc1eb909a5b63280$var$degrees,
        skewX: Math.atan(skewX) * $bc1eb909a5b63280$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $84263186e1a8c21d$var$svgNode;
function $84263186e1a8c21d$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $bc1eb909a5b63280$export$f0954fd7d5368655) : (0, $bc1eb909a5b63280$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $84263186e1a8c21d$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $bc1eb909a5b63280$export$f0954fd7d5368655;
    if (!$84263186e1a8c21d$var$svgNode) $84263186e1a8c21d$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $84263186e1a8c21d$var$svgNode.setAttribute("transform", value);
    if (!(value = $84263186e1a8c21d$var$svgNode.transform.baseVal.consolidate())) return 0, $bc1eb909a5b63280$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $bc1eb909a5b63280$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $0c97df23f2a24204$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $f124178efa7c0f49$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $f124178efa7c0f49$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $f124178efa7c0f49$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $f124178efa7c0f49$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $f124178efa7c0f49$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $f124178efa7c0f49$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $0c97df23f2a24204$export$56bec7123bb3589a = $0c97df23f2a24204$var$interpolateTransform((0, $84263186e1a8c21d$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $0c97df23f2a24204$export$da8cba906d64c082 = $0c97df23f2a24204$var$interpolateTransform((0, $84263186e1a8c21d$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $0ad9eafbcd422221$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $0358a71e6ed8b7a4$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $0ad9eafbcd422221$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $0358a71e6ed8b7a4$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $0ad9eafbcd422221$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $0358a71e6ed8b7a4$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $0ad9eafbcd422221$var$tweenRemove : $0ad9eafbcd422221$var$tweenFunction)(id, name, value));
}
function $0ad9eafbcd422221$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $0358a71e6ed8b7a4$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $0358a71e6ed8b7a4$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $fdbil = parcelRequire("fdbil");

function $83dedebac20e0c83$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $f124178efa7c0f49$export$2e2bcd8739ae039) : b instanceof (0, $fdbil.default) ? (0, $de8a204dca978e16$export$2e2bcd8739ae039) : (c = (0, $fdbil.default)(b)) ? (b = c, $de8a204dca978e16$export$2e2bcd8739ae039) : (0, $49b9f54faa5401c4$export$2e2bcd8739ae039))(a, b);
}


function $535910b2483555f6$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $535910b2483555f6$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $535910b2483555f6$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $535910b2483555f6$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $535910b2483555f6$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $535910b2483555f6$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $535910b2483555f6$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $d0955d5598d8ad69$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $0c97df23f2a24204$export$da8cba906d64c082) : (0, $83dedebac20e0c83$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $535910b2483555f6$var$attrFunctionNS : $535910b2483555f6$var$attrFunction)(fullname, i, (0, $0ad9eafbcd422221$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $535910b2483555f6$var$attrRemoveNS : $535910b2483555f6$var$attrRemove)(fullname) : (fullname.local ? $535910b2483555f6$var$attrConstantNS : $535910b2483555f6$var$attrConstant)(fullname, i, value));
}



function $1edc53169c5df0ac$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $1edc53169c5df0ac$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $1edc53169c5df0ac$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $1edc53169c5df0ac$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $1edc53169c5df0ac$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $1edc53169c5df0ac$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $1edc53169c5df0ac$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $d0955d5598d8ad69$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $1edc53169c5df0ac$var$attrTweenNS : $1edc53169c5df0ac$var$attrTween)(fullname, value));
}



function $38a4d10baa12874a$var$delayFunction(id, value) {
    return function() {
        (0, $0358a71e6ed8b7a4$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $38a4d10baa12874a$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $0358a71e6ed8b7a4$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $38a4d10baa12874a$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $38a4d10baa12874a$var$delayFunction : $38a4d10baa12874a$var$delayConstant)(id, value)) : (0, $0358a71e6ed8b7a4$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $2845074aeda664be$var$durationFunction(id, value) {
    return function() {
        (0, $0358a71e6ed8b7a4$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $2845074aeda664be$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $0358a71e6ed8b7a4$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $2845074aeda664be$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $2845074aeda664be$var$durationFunction : $2845074aeda664be$var$durationConstant)(id, value)) : (0, $0358a71e6ed8b7a4$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $f9ca8151f74aa145$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $0358a71e6ed8b7a4$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $f9ca8151f74aa145$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($f9ca8151f74aa145$var$easeConstant(id, value)) : (0, $0358a71e6ed8b7a4$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $322ecd376f11b354$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $0358a71e6ed8b7a4$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $322ecd376f11b354$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($322ecd376f11b354$var$easeVarying(this._id, value));
}




function $e431deb4fb5d0c07$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $4e08db65925746f5$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $dc9976c0e92756f3$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $a288c3621fa4bad7$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $dc9976c0e92756f3$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $e3c4656cf0e07043$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $e3c4656cf0e07043$var$onFunction(id, name, listener) {
    var on0, on1, sit = $e3c4656cf0e07043$var$start(name) ? (0, $0358a71e6ed8b7a4$export$2cd8252107eb640b) : (0, $0358a71e6ed8b7a4$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $e3c4656cf0e07043$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $0358a71e6ed8b7a4$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($e3c4656cf0e07043$var$onFunction(id, name, listener));
}


function $cb9b289bbd8a5cca$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $cb9b289bbd8a5cca$export$2e2bcd8739ae039() {
    return this.on("end.remove", $cb9b289bbd8a5cca$var$removeFunction(this._id));
}





function $cc3881dbaa92f58d$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $8ba95871922ca97a$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $0358a71e6ed8b7a4$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $0358a71e6ed8b7a4$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $dc9976c0e92756f3$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $2c03225af2a3ad5c$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $ac5f3cc81c00e9c1$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $0358a71e6ed8b7a4$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $0358a71e6ed8b7a4$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $dc9976c0e92756f3$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $a8699d8eaf9d4076$var$Selection = (0, $b6616ac03e7685f2$export$2e2bcd8739ae039).prototype.constructor;
function $a8699d8eaf9d4076$export$2e2bcd8739ae039() {
    return new $a8699d8eaf9d4076$var$Selection(this._groups, this._parents);
}







function $a106474601f5611f$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $b45351023b0cd744$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $b45351023b0cd744$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $a106474601f5611f$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $a106474601f5611f$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $b45351023b0cd744$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $a106474601f5611f$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $b45351023b0cd744$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $b45351023b0cd744$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $a106474601f5611f$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $0358a71e6ed8b7a4$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $a106474601f5611f$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $a106474601f5611f$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $0c97df23f2a24204$export$56bec7123bb3589a) : (0, $83dedebac20e0c83$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $a106474601f5611f$var$styleNull(name, i)).on("end.style." + name, $a106474601f5611f$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $a106474601f5611f$var$styleFunction(name, i, (0, $0ad9eafbcd422221$export$f78ce6ab10405d82)(this, "style." + name, value))).each($a106474601f5611f$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $a106474601f5611f$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $5070a248448a97a5$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $5070a248448a97a5$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $5070a248448a97a5$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $5070a248448a97a5$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $5070a248448a97a5$var$styleTween(name, value, priority == null ? "" : priority));
}



function $6342800ec70950ca$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $6342800ec70950ca$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $6342800ec70950ca$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $6342800ec70950ca$var$textFunction((0, $0ad9eafbcd422221$export$f78ce6ab10405d82)(this, "text", value)) : $6342800ec70950ca$var$textConstant(value == null ? "" : value + ""));
}


function $9f1bc20a2460e5ed$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $9f1bc20a2460e5ed$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $9f1bc20a2460e5ed$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $9f1bc20a2460e5ed$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $9f1bc20a2460e5ed$var$textTween(value));
}




function $2449c616b4e66bb5$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $dc9976c0e92756f3$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $0358a71e6ed8b7a4$export$3988ae62b71be9a3)(node, id0);
            (0, $0358a71e6ed8b7a4$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $dc9976c0e92756f3$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $3c666b0bd02de697$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $0358a71e6ed8b7a4$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $dc9976c0e92756f3$var$id = 0;
function $dc9976c0e92756f3$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $dc9976c0e92756f3$export$2e2bcd8739ae039(name) {
    return (0, $b6616ac03e7685f2$export$2e2bcd8739ae039)().transition(name);
}
function $dc9976c0e92756f3$export$9ffd10a3fbdc175b() {
    return ++$dc9976c0e92756f3$var$id;
}
var $dc9976c0e92756f3$var$selection_prototype = (0, $b6616ac03e7685f2$export$2e2bcd8739ae039).prototype;
$dc9976c0e92756f3$export$be58926105124dd4.prototype = $dc9976c0e92756f3$export$2e2bcd8739ae039.prototype = {
    constructor: $dc9976c0e92756f3$export$be58926105124dd4,
    select: (0, $cc3881dbaa92f58d$export$2e2bcd8739ae039),
    selectAll: (0, $2c03225af2a3ad5c$export$2e2bcd8739ae039),
    selectChild: $dc9976c0e92756f3$var$selection_prototype.selectChild,
    selectChildren: $dc9976c0e92756f3$var$selection_prototype.selectChildren,
    filter: (0, $e431deb4fb5d0c07$export$2e2bcd8739ae039),
    merge: (0, $a288c3621fa4bad7$export$2e2bcd8739ae039),
    selection: (0, $a8699d8eaf9d4076$export$2e2bcd8739ae039),
    transition: (0, $2449c616b4e66bb5$export$2e2bcd8739ae039),
    call: $dc9976c0e92756f3$var$selection_prototype.call,
    nodes: $dc9976c0e92756f3$var$selection_prototype.nodes,
    node: $dc9976c0e92756f3$var$selection_prototype.node,
    size: $dc9976c0e92756f3$var$selection_prototype.size,
    empty: $dc9976c0e92756f3$var$selection_prototype.empty,
    each: $dc9976c0e92756f3$var$selection_prototype.each,
    on: (0, $e3c4656cf0e07043$export$2e2bcd8739ae039),
    attr: (0, $535910b2483555f6$export$2e2bcd8739ae039),
    attrTween: (0, $1edc53169c5df0ac$export$2e2bcd8739ae039),
    style: (0, $a106474601f5611f$export$2e2bcd8739ae039),
    styleTween: (0, $5070a248448a97a5$export$2e2bcd8739ae039),
    text: (0, $6342800ec70950ca$export$2e2bcd8739ae039),
    textTween: (0, $9f1bc20a2460e5ed$export$2e2bcd8739ae039),
    remove: (0, $cb9b289bbd8a5cca$export$2e2bcd8739ae039),
    tween: (0, $0ad9eafbcd422221$export$2e2bcd8739ae039),
    delay: (0, $38a4d10baa12874a$export$2e2bcd8739ae039),
    duration: (0, $2845074aeda664be$export$2e2bcd8739ae039),
    ease: (0, $f9ca8151f74aa145$export$2e2bcd8739ae039),
    easeVarying: (0, $322ecd376f11b354$export$2e2bcd8739ae039),
    end: (0, $3c666b0bd02de697$export$2e2bcd8739ae039),
    [Symbol.iterator]: $dc9976c0e92756f3$var$selection_prototype[Symbol.iterator]
};



function $1a98a755dde6c00c$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $1a98a755dde6c00c$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $1a98a755dde6c00c$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $ea06d27aed53055f$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $1a98a755dde6c00c$export$89238d3bc79d3ada)
};
function $ea06d27aed53055f$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $ea06d27aed53055f$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $dc9976c0e92756f3$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $dc9976c0e92756f3$export$9ffd10a3fbdc175b)(), (timing = $ea06d27aed53055f$var$defaultTiming).time = (0, $5e8c98c7b2f5bcf8$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $0358a71e6ed8b7a4$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $ea06d27aed53055f$var$inherit(node, id));
    }
    return new (0, $dc9976c0e92756f3$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $b6616ac03e7685f2$export$2e2bcd8739ae039).prototype.interrupt = (0, $7acc86f26e2f32bf$export$2e2bcd8739ae039);
(0, $b6616ac03e7685f2$export$2e2bcd8739ae039).prototype.transition = (0, $ea06d27aed53055f$export$2e2bcd8739ae039);







var $5f35f3588e583b8a$export$2e2bcd8739ae039 = (x)=>()=>x;


function $ce3356548fd64002$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $4bc172f34471b9ce$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $4bc172f34471b9ce$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


var $5fbf4df161b05b0e$var$MODE_DRAG = {
    name: "drag"
}, $5fbf4df161b05b0e$var$MODE_SPACE = {
    name: "space"
}, $5fbf4df161b05b0e$var$MODE_HANDLE = {
    name: "handle"
}, $5fbf4df161b05b0e$var$MODE_CENTER = {
    name: "center"
};
const { abs: $5fbf4df161b05b0e$var$abs, max: $5fbf4df161b05b0e$var$max, min: $5fbf4df161b05b0e$var$min } = Math;
function $5fbf4df161b05b0e$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $5fbf4df161b05b0e$var$number2(e) {
    return [
        $5fbf4df161b05b0e$var$number1(e[0]),
        $5fbf4df161b05b0e$var$number1(e[1])
    ];
}
var $5fbf4df161b05b0e$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($5fbf4df161b05b0e$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $5fbf4df161b05b0e$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($5fbf4df161b05b0e$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $5fbf4df161b05b0e$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($5fbf4df161b05b0e$var$type),
    input: function(xy) {
        return xy == null ? null : $5fbf4df161b05b0e$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $5fbf4df161b05b0e$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $5fbf4df161b05b0e$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $5fbf4df161b05b0e$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $5fbf4df161b05b0e$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $5fbf4df161b05b0e$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $5fbf4df161b05b0e$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $5fbf4df161b05b0e$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $5fbf4df161b05b0e$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $5fbf4df161b05b0e$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $5fbf4df161b05b0e$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $5fbf4df161b05b0e$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $5fbf4df161b05b0e$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $5fbf4df161b05b0e$export$979ace6c88860aa8() {
    return $5fbf4df161b05b0e$var$brush($5fbf4df161b05b0e$var$X);
}
function $5fbf4df161b05b0e$export$468748b530991c54() {
    return $5fbf4df161b05b0e$var$brush($5fbf4df161b05b0e$var$Y);
}
function $5fbf4df161b05b0e$export$2e2bcd8739ae039() {
    return $5fbf4df161b05b0e$var$brush($5fbf4df161b05b0e$var$XY);
}
function $5fbf4df161b05b0e$var$brush(dim) {
    var extent = $5fbf4df161b05b0e$var$defaultExtent, filter = $5fbf4df161b05b0e$var$defaultFilter, touchable = $5fbf4df161b05b0e$var$defaultTouchable, keys = true, listeners = (0, $a7ac57445b8c2673$export$2e2bcd8739ae039)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $5fbf4df161b05b0e$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $5fbf4df161b05b0e$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $5fbf4df161b05b0e$var$local(this).extent;
            (0, $b0ba9a260c958684$export$2e2bcd8739ae039)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $5fbf4df161b05b0e$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $5fbf4df161b05b0e$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $5fbf4df161b05b0e$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $790287a65f557be7$export$2e2bcd8739ae039)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $b41725ddfae0f3a3$export$2e2bcd8739ae039)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, $b0ba9a260c958684$export$2e2bcd8739ae039)(this), selection = $5fbf4df161b05b0e$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $b0ba9a260c958684$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $ce3356548fd64002$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $5fbf4df161b05b0e$var$MODE_DRAG : keys && event.altKey ? $5fbf4df161b05b0e$var$MODE_CENTER : $5fbf4df161b05b0e$var$MODE_HANDLE, signX = dim === $5fbf4df161b05b0e$var$Y ? null : $5fbf4df161b05b0e$var$signsX[type], signY = dim === $5fbf4df161b05b0e$var$X ? null : $5fbf4df161b05b0e$var$signsY[type], state = $5fbf4df161b05b0e$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $3c7b4c5122b1c4f6$export$2e2bcd8739ae039)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, $b41725ddfae0f3a3$export$2e2bcd8739ae039)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $5fbf4df161b05b0e$var$Y ? W : $5fbf4df161b05b0e$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $5fbf4df161b05b0e$var$X ? N : $5fbf4df161b05b0e$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $5fbf4df161b05b0e$var$Y ? E : $5fbf4df161b05b0e$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $5fbf4df161b05b0e$var$X ? S : $5fbf4df161b05b0e$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $b0ba9a260c958684$export$2e2bcd8739ae039)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $5fbf4df161b05b0e$var$cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $b0ba9a260c958684$export$2e2bcd8739ae039)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $b4bf2a47d576b8cb$export$2e2bcd8739ae039)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $3c7b4c5122b1c4f6$export$2e2bcd8739ae039)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($5fbf4df161b05b0e$var$abs(point.cur[0] - point[0]) > $5fbf4df161b05b0e$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $4bc172f34471b9ce$export$2e2bcd8739ae039)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $5fbf4df161b05b0e$var$MODE_SPACE:
                case $5fbf4df161b05b0e$var$MODE_DRAG:
                    if (signX) dx = $5fbf4df161b05b0e$var$max(W - w0, $5fbf4df161b05b0e$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $5fbf4df161b05b0e$var$max(N - n0, $5fbf4df161b05b0e$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $5fbf4df161b05b0e$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $5fbf4df161b05b0e$var$max(W, $5fbf4df161b05b0e$var$min(E, points[0][0])), e1 = $5fbf4df161b05b0e$var$max(W, $5fbf4df161b05b0e$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $5fbf4df161b05b0e$var$max(N, $5fbf4df161b05b0e$var$min(S, points[0][1])), s1 = $5fbf4df161b05b0e$var$max(N, $5fbf4df161b05b0e$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $5fbf4df161b05b0e$var$max(W - w0, $5fbf4df161b05b0e$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $5fbf4df161b05b0e$var$max(W - e0, $5fbf4df161b05b0e$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $5fbf4df161b05b0e$var$max(N - n0, $5fbf4df161b05b0e$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $5fbf4df161b05b0e$var$max(N - s0, $5fbf4df161b05b0e$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $5fbf4df161b05b0e$var$MODE_CENTER:
                    if (signX) w1 = $5fbf4df161b05b0e$var$max(W, $5fbf4df161b05b0e$var$min(E, w0 - dx * signX)), e1 = $5fbf4df161b05b0e$var$max(W, $5fbf4df161b05b0e$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $5fbf4df161b05b0e$var$max(N, $5fbf4df161b05b0e$var$min(S, n0 - dy * signY)), s1 = $5fbf4df161b05b0e$var$max(N, $5fbf4df161b05b0e$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $5fbf4df161b05b0e$var$flipX) overlay.attr("cursor", $5fbf4df161b05b0e$var$cursors[type = $5fbf4df161b05b0e$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $5fbf4df161b05b0e$var$flipY) overlay.attr("cursor", $5fbf4df161b05b0e$var$cursors[type = $5fbf4df161b05b0e$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $4bc172f34471b9ce$export$2e2561858db9bf47)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $b4bf2a47d576b8cb$export$833237748009e1e1)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $5fbf4df161b05b0e$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($5fbf4df161b05b0e$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $5fbf4df161b05b0e$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $5fbf4df161b05b0e$var$MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $5fbf4df161b05b0e$var$MODE_HANDLE || mode === $5fbf4df161b05b0e$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $5fbf4df161b05b0e$var$MODE_SPACE;
                        overlay.attr("cursor", $5fbf4df161b05b0e$var$cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $4bc172f34471b9ce$export$2e2bcd8739ae039)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === $5fbf4df161b05b0e$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $5fbf4df161b05b0e$var$MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $5fbf4df161b05b0e$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $5fbf4df161b05b0e$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $5fbf4df161b05b0e$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $5fbf4df161b05b0e$var$cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $4bc172f34471b9ce$export$2e2bcd8739ae039)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $5fbf4df161b05b0e$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $5f35f3588e583b8a$export$2e2bcd8739ae039)($5fbf4df161b05b0e$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $5f35f3588e583b8a$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $5f35f3588e583b8a$export$2e2bcd8739ae039)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}












function $80ddd0f02b18fe07$var$responseJson(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    if (response.status === 204 || response.status === 205) return;
    return response.json();
}
function $80ddd0f02b18fe07$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($80ddd0f02b18fe07$var$responseJson);
}


function $fca772d1316a3f0b$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $fca772d1316a3f0b$var$add(this.cover(x, y), x, y, d);
}
function $fca772d1316a3f0b$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $fca772d1316a3f0b$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$fca772d1316a3f0b$var$add(this, xz[i], yz[i], data[i]);
    return this;
}


function $bfd368192cb591cb$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}


function $fda476c2e958273c$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}


function $6803433b229d1c75$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}


function $9693224744984488$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}


function $635cef1a3464b141$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $9693224744984488$export$2e2bcd8739ae039)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $9693224744984488$export$2e2bcd8739ae039)(node[3], xm, ym, x2, y2), new (0, $9693224744984488$export$2e2bcd8739ae039)(node[2], x1, ym, xm, y2), new (0, $9693224744984488$export$2e2bcd8739ae039)(node[1], xm, y1, x2, ym), new (0, $9693224744984488$export$2e2bcd8739ae039)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}


function $b7599c3491a31e80$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $b7599c3491a31e80$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}


function $c0481da20bba2ba9$export$2e2bcd8739ae039() {
    return this._root;
}


function $4166da91c0a03f0c$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}



function $bd8e7ff454f19d87$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $9693224744984488$export$2e2bcd8739ae039)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $9693224744984488$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $9693224744984488$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $9693224744984488$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $9693224744984488$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
    }
    return this;
}



function $d2738d5fe91b9a36$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $9693224744984488$export$2e2bcd8739ae039)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $9693224744984488$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $9693224744984488$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $9693224744984488$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $9693224744984488$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}


function $8cce50e6a68f8637$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $8cce50e6a68f8637$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}


function $3f2d2cf35c23f473$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $3f2d2cf35c23f473$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}


function $ae405911b845ea00$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $ae405911b845ea00$var$Quadtree(x == null ? (0, $8cce50e6a68f8637$export$e6fafc98131d2a44) : x, y == null ? (0, $3f2d2cf35c23f473$export$6f0a21aeb844a64c) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $ae405911b845ea00$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $ae405911b845ea00$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $ae405911b845ea00$var$treeProto = $ae405911b845ea00$export$2e2bcd8739ae039.prototype = $ae405911b845ea00$var$Quadtree.prototype;
$ae405911b845ea00$var$treeProto.copy = function() {
    var copy = new $ae405911b845ea00$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $ae405911b845ea00$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $ae405911b845ea00$var$leaf_copy(child);
        }
    }
    return copy;
};
$ae405911b845ea00$var$treeProto.add = (0, $fca772d1316a3f0b$export$2e2bcd8739ae039);
$ae405911b845ea00$var$treeProto.addAll = (0, $fca772d1316a3f0b$export$32ed0561867ec8a1);
$ae405911b845ea00$var$treeProto.cover = (0, $bfd368192cb591cb$export$2e2bcd8739ae039);
$ae405911b845ea00$var$treeProto.data = (0, $fda476c2e958273c$export$2e2bcd8739ae039);
$ae405911b845ea00$var$treeProto.extent = (0, $6803433b229d1c75$export$2e2bcd8739ae039);
$ae405911b845ea00$var$treeProto.find = (0, $635cef1a3464b141$export$2e2bcd8739ae039);
$ae405911b845ea00$var$treeProto.remove = (0, $b7599c3491a31e80$export$2e2bcd8739ae039);
$ae405911b845ea00$var$treeProto.removeAll = (0, $b7599c3491a31e80$export$1cfc7aad5cb1833b);
$ae405911b845ea00$var$treeProto.root = (0, $c0481da20bba2ba9$export$2e2bcd8739ae039);
$ae405911b845ea00$var$treeProto.size = (0, $4166da91c0a03f0c$export$2e2bcd8739ae039);
$ae405911b845ea00$var$treeProto.visit = (0, $bd8e7ff454f19d87$export$2e2bcd8739ae039);
$ae405911b845ea00$var$treeProto.visitAfter = (0, $d2738d5fe91b9a36$export$2e2bcd8739ae039);
$ae405911b845ea00$var$treeProto.x = (0, $8cce50e6a68f8637$export$2e2bcd8739ae039);
$ae405911b845ea00$var$treeProto.y = (0, $3f2d2cf35c23f473$export$2e2bcd8739ae039);


function $b91c63e7df584e6a$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $452e41288f9cd0f9$export$2e2bcd8739ae039(random) {
    return (random() - 0.5) * 1e-6;
}


function $0e19b5ce15a83408$var$x(d) {
    return d.x + d.vx;
}
function $0e19b5ce15a83408$var$y(d) {
    return d.y + d.vy;
}
function $0e19b5ce15a83408$export$2e2bcd8739ae039(radius) {
    var nodes, radii, random, strength = 1, iterations = 1;
    if (typeof radius !== "function") radius = (0, $b91c63e7df584e6a$export$2e2bcd8739ae039)(radius == null ? 1 : +radius);
    function force() {
        var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
        for(var k = 0; k < iterations; ++k){
            tree = (0, $ae405911b845ea00$export$2e2bcd8739ae039)(nodes, $0e19b5ce15a83408$var$x, $0e19b5ce15a83408$var$y).visitAfter(prepare);
            for(i = 0; i < n; ++i){
                node = nodes[i];
                ri = radii[node.index], ri2 = ri * ri;
                xi = node.x + node.vx;
                yi = node.y + node.vy;
                tree.visit(apply);
            }
        }
        function apply(quad, x0, y0, x1, y1) {
            var data = quad.data, rj = quad.r, r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                    if (l < r * r) {
                        if (x === 0) x = (0, $452e41288f9cd0f9$export$2e2bcd8739ae039)(random), l += x * x;
                        if (y === 0) y = (0, $452e41288f9cd0f9$export$2e2bcd8739ae039)(random), l += y * y;
                        l = (r - (l = Math.sqrt(l))) / l * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        node.vy += (y *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        data.vy -= y * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
        }
    }
    function prepare(quad) {
        if (quad.data) return quad.r = radii[quad.data.index];
        for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        radii = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $b91c63e7df584e6a$export$2e2bcd8739ae039)(+_), initialize(), force) : radius;
    };
    return force;
}



// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $21fcb049fb99d2fa$var$a = 1664525;
const $21fcb049fb99d2fa$var$c = 1013904223;
const $21fcb049fb99d2fa$var$m = 4294967296; // 2^32
function $21fcb049fb99d2fa$export$2e2bcd8739ae039() {
    let s = 1;
    return ()=>(s = ($21fcb049fb99d2fa$var$a * s + $21fcb049fb99d2fa$var$c) % $21fcb049fb99d2fa$var$m) / $21fcb049fb99d2fa$var$m;
}


function $4e06c20dc82a7c26$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $4e06c20dc82a7c26$export$4a5767248b18ef41(d) {
    return d.y;
}
var $4e06c20dc82a7c26$var$initialRadius = 10, $4e06c20dc82a7c26$var$initialAngle = Math.PI * (3 - Math.sqrt(5));
function $4e06c20dc82a7c26$export$2e2bcd8739ae039(nodes) {
    var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, $5e8c98c7b2f5bcf8$export$9dc4ecf953986f04)(step), event = (0, $a7ac57445b8c2673$export$2e2bcd8739ae039)("tick", "end"), random = (0, $21fcb049fb99d2fa$export$2e2bcd8739ae039)();
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick(iterations) {
        var i, n = nodes.length, node;
        if (iterations === undefined) iterations = 1;
        for(var k = 0; k < iterations; ++k){
            alpha += (alphaTarget - alpha) * alphaDecay;
            forces.forEach(function(force) {
                force(alpha);
            });
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (node.fx == null) node.x += node.vx *= velocityDecay;
                else node.x = node.fx, node.vx = 0;
                if (node.fy == null) node.y += node.vy *= velocityDecay;
                else node.y = node.fy, node.vy = 0;
            }
        }
        return simulation;
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (node.fx != null) node.x = node.fx;
            if (node.fy != null) node.y = node.fy;
            if (isNaN(node.x) || isNaN(node.y)) {
                var radius = $4e06c20dc82a7c26$var$initialRadius * Math.sqrt(0.5 + i), angle = i * $4e06c20dc82a7c26$var$initialAngle;
                node.x = radius * Math.cos(angle);
                node.y = radius * Math.sin(angle);
            }
            if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes, random);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        randomSource: function(_) {
            return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function(x, y, radius) {
            var i = 0, n = nodes.length, dx, dy, d2, node, closest;
            if (radius == null) radius = Infinity;
            else radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - node.y;
                d2 = dx * dx + dy * dy;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}


function $9ac01369310c6f2e$export$2e2bcd8739ae039(x) {
    var strength = (0, $b91c63e7df584e6a$export$2e2bcd8739ae039)(0.1), nodes, strengths, xz;
    if (typeof x !== "function") x = (0, $b91c63e7df584e6a$export$2e2bcd8739ae039)(x == null ? 0 : +x);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        xz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $b91c63e7df584e6a$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $b91c63e7df584e6a$export$2e2bcd8739ae039)(+_), initialize(), force) : x;
    };
    return force;
}


function $69ee3e2a8f7a6868$export$2e2bcd8739ae039(y) {
    var strength = (0, $b91c63e7df584e6a$export$2e2bcd8739ae039)(0.1), nodes, strengths, yz;
    if (typeof y !== "function") y = (0, $b91c63e7df584e6a$export$2e2bcd8739ae039)(y == null ? 0 : +y);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        yz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $b91c63e7df584e6a$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $b91c63e7df584e6a$export$2e2bcd8739ae039)(+_), initialize(), force) : y;
    };
    return force;
}



var $781505731c5fcfa9$export$2e2bcd8739ae039 = (x)=>x;


function $15fd252faf959553$var$streamGeometry(geometry, stream) {
    if (geometry && $15fd252faf959553$var$streamGeometryType.hasOwnProperty(geometry.type)) $15fd252faf959553$var$streamGeometryType[geometry.type](geometry, stream);
}
var $15fd252faf959553$var$streamObjectType = {
    Feature: function(object, stream) {
        $15fd252faf959553$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$15fd252faf959553$var$streamGeometry(features[i].geometry, stream);
    }
};
var $15fd252faf959553$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $15fd252faf959553$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$15fd252faf959553$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $15fd252faf959553$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$15fd252faf959553$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$15fd252faf959553$var$streamGeometry(geometries[i], stream);
    }
};
function $15fd252faf959553$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $15fd252faf959553$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$15fd252faf959553$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $15fd252faf959553$export$2e2bcd8739ae039(object, stream) {
    if (object && $15fd252faf959553$var$streamObjectType.hasOwnProperty(object.type)) $15fd252faf959553$var$streamObjectType[object.type](object, stream);
    else $15fd252faf959553$var$streamGeometry(object, stream);
}


// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $d0e14437adcec8e2$export$bda7ba77fb86c375 {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function $d0e14437adcec8e2$export$61cb83f1a93e9fae(values, valueof) {
    const adder = new $d0e14437adcec8e2$export$bda7ba77fb86c375();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $d0e14437adcec8e2$export$5a6391da70c130da(values, valueof) {
    const adder = new $d0e14437adcec8e2$export$bda7ba77fb86c375();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}


var $7a78856c996976fc$export$6c421550c66a327d = 1e-6;
var $7a78856c996976fc$export$92c06fba281fe81b = 1e-12;
var $7a78856c996976fc$export$18c7bea995a110f = Math.PI;
var $7a78856c996976fc$export$e51408a300e8929a = $7a78856c996976fc$export$18c7bea995a110f / 2;
var $7a78856c996976fc$export$c39a5cba78ea0fc2 = $7a78856c996976fc$export$18c7bea995a110f / 4;
var $7a78856c996976fc$export$a4b4b4d4d776fe92 = $7a78856c996976fc$export$18c7bea995a110f * 2;
var $7a78856c996976fc$export$41fc368e1a942b97 = 180 / $7a78856c996976fc$export$18c7bea995a110f;
var $7a78856c996976fc$export$8449e153fbd325fc = $7a78856c996976fc$export$18c7bea995a110f / 180;
var $7a78856c996976fc$export$2335f513bbd82c6d = Math.abs;
var $7a78856c996976fc$export$628dc4eed22b0fbd = Math.atan;
var $7a78856c996976fc$export$b8b770ee6a0d9760 = Math.atan2;
var $7a78856c996976fc$export$50d414a77b60d802 = Math.cos;
var $7a78856c996976fc$export$803ce6b71a0a94b2 = Math.ceil;
var $7a78856c996976fc$export$b310ec824aaee37f = Math.exp;
var $7a78856c996976fc$export$a3fe094919f356fd = Math.floor;
var $7a78856c996976fc$export$f95c7888b62f8e9a = Math.hypot;
var $7a78856c996976fc$export$bef1f36f5486a6a3 = Math.log;
var $7a78856c996976fc$export$9c297f60e22e3389 = Math.pow;
var $7a78856c996976fc$export$5de3937cb4b592ed = Math.sin;
var $7a78856c996976fc$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $7a78856c996976fc$export$eba8049fb5020b81 = Math.sqrt;
var $7a78856c996976fc$export$fcdd3b0b3246a325 = Math.tan;
function $7a78856c996976fc$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $7a78856c996976fc$export$18c7bea995a110f : Math.acos(x);
}
function $7a78856c996976fc$export$41726bdb1fc63f(x) {
    return x > 1 ? $7a78856c996976fc$export$e51408a300e8929a : x < -1 ? -$7a78856c996976fc$export$e51408a300e8929a : Math.asin(x);
}
function $7a78856c996976fc$export$e808712c2966e662(x) {
    return (x = $7a78856c996976fc$export$5de3937cb4b592ed(x / 2)) * x;
}


function $05694e3f3ef354a1$export$2e2bcd8739ae039() {}


var $74d24869d056c881$var$areaSum = new (0, $d0e14437adcec8e2$export$bda7ba77fb86c375)(), $74d24869d056c881$var$areaRingSum = new (0, $d0e14437adcec8e2$export$bda7ba77fb86c375)(), $74d24869d056c881$var$x00, $74d24869d056c881$var$y00, $74d24869d056c881$var$x0, $74d24869d056c881$var$y0;
var $74d24869d056c881$var$areaStream = {
    point: (0, $05694e3f3ef354a1$export$2e2bcd8739ae039),
    lineStart: (0, $05694e3f3ef354a1$export$2e2bcd8739ae039),
    lineEnd: (0, $05694e3f3ef354a1$export$2e2bcd8739ae039),
    polygonStart: function() {
        $74d24869d056c881$var$areaStream.lineStart = $74d24869d056c881$var$areaRingStart;
        $74d24869d056c881$var$areaStream.lineEnd = $74d24869d056c881$var$areaRingEnd;
    },
    polygonEnd: function() {
        $74d24869d056c881$var$areaStream.lineStart = $74d24869d056c881$var$areaStream.lineEnd = $74d24869d056c881$var$areaStream.point = (0, $05694e3f3ef354a1$export$2e2bcd8739ae039);
        $74d24869d056c881$var$areaSum.add((0, $7a78856c996976fc$export$2335f513bbd82c6d)($74d24869d056c881$var$areaRingSum));
        $74d24869d056c881$var$areaRingSum = new (0, $d0e14437adcec8e2$export$bda7ba77fb86c375)();
    },
    result: function() {
        var area = $74d24869d056c881$var$areaSum / 2;
        $74d24869d056c881$var$areaSum = new (0, $d0e14437adcec8e2$export$bda7ba77fb86c375)();
        return area;
    }
};
function $74d24869d056c881$var$areaRingStart() {
    $74d24869d056c881$var$areaStream.point = $74d24869d056c881$var$areaPointFirst;
}
function $74d24869d056c881$var$areaPointFirst(x, y) {
    $74d24869d056c881$var$areaStream.point = $74d24869d056c881$var$areaPoint;
    $74d24869d056c881$var$x00 = $74d24869d056c881$var$x0 = x, $74d24869d056c881$var$y00 = $74d24869d056c881$var$y0 = y;
}
function $74d24869d056c881$var$areaPoint(x, y) {
    $74d24869d056c881$var$areaRingSum.add($74d24869d056c881$var$y0 * x - $74d24869d056c881$var$x0 * y);
    $74d24869d056c881$var$x0 = x, $74d24869d056c881$var$y0 = y;
}
function $74d24869d056c881$var$areaRingEnd() {
    $74d24869d056c881$var$areaPoint($74d24869d056c881$var$x00, $74d24869d056c881$var$y00);
}
var $74d24869d056c881$export$2e2bcd8739ae039 = $74d24869d056c881$var$areaStream;



var $bf358bc8c4fc33f2$var$x0 = Infinity, $bf358bc8c4fc33f2$var$y0 = $bf358bc8c4fc33f2$var$x0, $bf358bc8c4fc33f2$var$x1 = -$bf358bc8c4fc33f2$var$x0, $bf358bc8c4fc33f2$var$y1 = $bf358bc8c4fc33f2$var$x1;
var $bf358bc8c4fc33f2$var$boundsStream = {
    point: $bf358bc8c4fc33f2$var$boundsPoint,
    lineStart: (0, $05694e3f3ef354a1$export$2e2bcd8739ae039),
    lineEnd: (0, $05694e3f3ef354a1$export$2e2bcd8739ae039),
    polygonStart: (0, $05694e3f3ef354a1$export$2e2bcd8739ae039),
    polygonEnd: (0, $05694e3f3ef354a1$export$2e2bcd8739ae039),
    result: function() {
        var bounds = [
            [
                $bf358bc8c4fc33f2$var$x0,
                $bf358bc8c4fc33f2$var$y0
            ],
            [
                $bf358bc8c4fc33f2$var$x1,
                $bf358bc8c4fc33f2$var$y1
            ]
        ];
        $bf358bc8c4fc33f2$var$x1 = $bf358bc8c4fc33f2$var$y1 = -($bf358bc8c4fc33f2$var$y0 = $bf358bc8c4fc33f2$var$x0 = Infinity);
        return bounds;
    }
};
function $bf358bc8c4fc33f2$var$boundsPoint(x, y) {
    if (x < $bf358bc8c4fc33f2$var$x0) $bf358bc8c4fc33f2$var$x0 = x;
    if (x > $bf358bc8c4fc33f2$var$x1) $bf358bc8c4fc33f2$var$x1 = x;
    if (y < $bf358bc8c4fc33f2$var$y0) $bf358bc8c4fc33f2$var$y0 = y;
    if (y > $bf358bc8c4fc33f2$var$y1) $bf358bc8c4fc33f2$var$y1 = y;
}
var $bf358bc8c4fc33f2$export$2e2bcd8739ae039 = $bf358bc8c4fc33f2$var$boundsStream;



// TODO Enforce positive area for exterior, negative area for interior?
var $fd3413ce73d9346c$var$X0 = 0, $fd3413ce73d9346c$var$Y0 = 0, $fd3413ce73d9346c$var$Z0 = 0, $fd3413ce73d9346c$var$X1 = 0, $fd3413ce73d9346c$var$Y1 = 0, $fd3413ce73d9346c$var$Z1 = 0, $fd3413ce73d9346c$var$X2 = 0, $fd3413ce73d9346c$var$Y2 = 0, $fd3413ce73d9346c$var$Z2 = 0, $fd3413ce73d9346c$var$x00, $fd3413ce73d9346c$var$y00, $fd3413ce73d9346c$var$x0, $fd3413ce73d9346c$var$y0;
var $fd3413ce73d9346c$var$centroidStream = {
    point: $fd3413ce73d9346c$var$centroidPoint,
    lineStart: $fd3413ce73d9346c$var$centroidLineStart,
    lineEnd: $fd3413ce73d9346c$var$centroidLineEnd,
    polygonStart: function() {
        $fd3413ce73d9346c$var$centroidStream.lineStart = $fd3413ce73d9346c$var$centroidRingStart;
        $fd3413ce73d9346c$var$centroidStream.lineEnd = $fd3413ce73d9346c$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $fd3413ce73d9346c$var$centroidStream.point = $fd3413ce73d9346c$var$centroidPoint;
        $fd3413ce73d9346c$var$centroidStream.lineStart = $fd3413ce73d9346c$var$centroidLineStart;
        $fd3413ce73d9346c$var$centroidStream.lineEnd = $fd3413ce73d9346c$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $fd3413ce73d9346c$var$Z2 ? [
            $fd3413ce73d9346c$var$X2 / $fd3413ce73d9346c$var$Z2,
            $fd3413ce73d9346c$var$Y2 / $fd3413ce73d9346c$var$Z2
        ] : $fd3413ce73d9346c$var$Z1 ? [
            $fd3413ce73d9346c$var$X1 / $fd3413ce73d9346c$var$Z1,
            $fd3413ce73d9346c$var$Y1 / $fd3413ce73d9346c$var$Z1
        ] : $fd3413ce73d9346c$var$Z0 ? [
            $fd3413ce73d9346c$var$X0 / $fd3413ce73d9346c$var$Z0,
            $fd3413ce73d9346c$var$Y0 / $fd3413ce73d9346c$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $fd3413ce73d9346c$var$X0 = $fd3413ce73d9346c$var$Y0 = $fd3413ce73d9346c$var$Z0 = $fd3413ce73d9346c$var$X1 = $fd3413ce73d9346c$var$Y1 = $fd3413ce73d9346c$var$Z1 = $fd3413ce73d9346c$var$X2 = $fd3413ce73d9346c$var$Y2 = $fd3413ce73d9346c$var$Z2 = 0;
        return centroid;
    }
};
function $fd3413ce73d9346c$var$centroidPoint(x, y) {
    $fd3413ce73d9346c$var$X0 += x;
    $fd3413ce73d9346c$var$Y0 += y;
    ++$fd3413ce73d9346c$var$Z0;
}
function $fd3413ce73d9346c$var$centroidLineStart() {
    $fd3413ce73d9346c$var$centroidStream.point = $fd3413ce73d9346c$var$centroidPointFirstLine;
}
function $fd3413ce73d9346c$var$centroidPointFirstLine(x, y) {
    $fd3413ce73d9346c$var$centroidStream.point = $fd3413ce73d9346c$var$centroidPointLine;
    $fd3413ce73d9346c$var$centroidPoint($fd3413ce73d9346c$var$x0 = x, $fd3413ce73d9346c$var$y0 = y);
}
function $fd3413ce73d9346c$var$centroidPointLine(x, y) {
    var dx = x - $fd3413ce73d9346c$var$x0, dy = y - $fd3413ce73d9346c$var$y0, z = (0, $7a78856c996976fc$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $fd3413ce73d9346c$var$X1 += z * ($fd3413ce73d9346c$var$x0 + x) / 2;
    $fd3413ce73d9346c$var$Y1 += z * ($fd3413ce73d9346c$var$y0 + y) / 2;
    $fd3413ce73d9346c$var$Z1 += z;
    $fd3413ce73d9346c$var$centroidPoint($fd3413ce73d9346c$var$x0 = x, $fd3413ce73d9346c$var$y0 = y);
}
function $fd3413ce73d9346c$var$centroidLineEnd() {
    $fd3413ce73d9346c$var$centroidStream.point = $fd3413ce73d9346c$var$centroidPoint;
}
function $fd3413ce73d9346c$var$centroidRingStart() {
    $fd3413ce73d9346c$var$centroidStream.point = $fd3413ce73d9346c$var$centroidPointFirstRing;
}
function $fd3413ce73d9346c$var$centroidRingEnd() {
    $fd3413ce73d9346c$var$centroidPointRing($fd3413ce73d9346c$var$x00, $fd3413ce73d9346c$var$y00);
}
function $fd3413ce73d9346c$var$centroidPointFirstRing(x, y) {
    $fd3413ce73d9346c$var$centroidStream.point = $fd3413ce73d9346c$var$centroidPointRing;
    $fd3413ce73d9346c$var$centroidPoint($fd3413ce73d9346c$var$x00 = $fd3413ce73d9346c$var$x0 = x, $fd3413ce73d9346c$var$y00 = $fd3413ce73d9346c$var$y0 = y);
}
function $fd3413ce73d9346c$var$centroidPointRing(x, y) {
    var dx = x - $fd3413ce73d9346c$var$x0, dy = y - $fd3413ce73d9346c$var$y0, z = (0, $7a78856c996976fc$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $fd3413ce73d9346c$var$X1 += z * ($fd3413ce73d9346c$var$x0 + x) / 2;
    $fd3413ce73d9346c$var$Y1 += z * ($fd3413ce73d9346c$var$y0 + y) / 2;
    $fd3413ce73d9346c$var$Z1 += z;
    z = $fd3413ce73d9346c$var$y0 * x - $fd3413ce73d9346c$var$x0 * y;
    $fd3413ce73d9346c$var$X2 += z * ($fd3413ce73d9346c$var$x0 + x);
    $fd3413ce73d9346c$var$Y2 += z * ($fd3413ce73d9346c$var$y0 + y);
    $fd3413ce73d9346c$var$Z2 += z * 3;
    $fd3413ce73d9346c$var$centroidPoint($fd3413ce73d9346c$var$x0 = x, $fd3413ce73d9346c$var$y0 = y);
}
var $fd3413ce73d9346c$export$2e2bcd8739ae039 = $fd3413ce73d9346c$var$centroidStream;




function $8a51b1160a46943d$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$8a51b1160a46943d$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $7a78856c996976fc$export$a4b4b4d4d776fe92));
                break;
        }
    },
    result: (0, $05694e3f3ef354a1$export$2e2bcd8739ae039)
};





var $709da397f6b568f2$var$lengthSum = new (0, $d0e14437adcec8e2$export$bda7ba77fb86c375)(), $709da397f6b568f2$var$lengthRing, $709da397f6b568f2$var$x00, $709da397f6b568f2$var$y00, $709da397f6b568f2$var$x0, $709da397f6b568f2$var$y0;
var $709da397f6b568f2$var$lengthStream = {
    point: (0, $05694e3f3ef354a1$export$2e2bcd8739ae039),
    lineStart: function() {
        $709da397f6b568f2$var$lengthStream.point = $709da397f6b568f2$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($709da397f6b568f2$var$lengthRing) $709da397f6b568f2$var$lengthPoint($709da397f6b568f2$var$x00, $709da397f6b568f2$var$y00);
        $709da397f6b568f2$var$lengthStream.point = (0, $05694e3f3ef354a1$export$2e2bcd8739ae039);
    },
    polygonStart: function() {
        $709da397f6b568f2$var$lengthRing = true;
    },
    polygonEnd: function() {
        $709da397f6b568f2$var$lengthRing = null;
    },
    result: function() {
        var length = +$709da397f6b568f2$var$lengthSum;
        $709da397f6b568f2$var$lengthSum = new (0, $d0e14437adcec8e2$export$bda7ba77fb86c375)();
        return length;
    }
};
function $709da397f6b568f2$var$lengthPointFirst(x, y) {
    $709da397f6b568f2$var$lengthStream.point = $709da397f6b568f2$var$lengthPoint;
    $709da397f6b568f2$var$x00 = $709da397f6b568f2$var$x0 = x, $709da397f6b568f2$var$y00 = $709da397f6b568f2$var$y0 = y;
}
function $709da397f6b568f2$var$lengthPoint(x, y) {
    $709da397f6b568f2$var$x0 -= x, $709da397f6b568f2$var$y0 -= y;
    $709da397f6b568f2$var$lengthSum.add((0, $7a78856c996976fc$export$eba8049fb5020b81)($709da397f6b568f2$var$x0 * $709da397f6b568f2$var$x0 + $709da397f6b568f2$var$y0 * $709da397f6b568f2$var$y0));
    $709da397f6b568f2$var$x0 = x, $709da397f6b568f2$var$y0 = y;
}
var $709da397f6b568f2$export$2e2bcd8739ae039 = $709da397f6b568f2$var$lengthStream;


// Simple caching for constant-radius points.
let $08605c970909c78e$var$cacheDigits, $08605c970909c78e$var$cacheAppend, $08605c970909c78e$var$cacheRadius, $08605c970909c78e$var$cacheCircle;
class $08605c970909c78e$export$2e2bcd8739ae039 {
    constructor(digits){
        this._append = digits == null ? $08605c970909c78e$var$append : $08605c970909c78e$var$appendRound(digits);
        this._radius = 4.5;
        this._ = "";
    }
    pointRadius(_) {
        this._radius = +_;
        return this;
    }
    polygonStart() {
        this._line = 0;
    }
    polygonEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line === 0) this._ += "Z";
        this._point = NaN;
    }
    point(x, y) {
        switch(this._point){
            case 0:
                this._append`M${x},${y}`;
                this._point = 1;
                break;
            case 1:
                this._append`L${x},${y}`;
                break;
            default:
                this._append`M${x},${y}`;
                if (this._radius !== $08605c970909c78e$var$cacheRadius || this._append !== $08605c970909c78e$var$cacheAppend) {
                    const r = this._radius;
                    const s = this._;
                    this._ = ""; // stash the old string so we can cache the circle path fragment
                    this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`;
                    $08605c970909c78e$var$cacheRadius = r;
                    $08605c970909c78e$var$cacheAppend = this._append;
                    $08605c970909c78e$var$cacheCircle = this._;
                    this._ = s;
                }
                this._ += $08605c970909c78e$var$cacheCircle;
                break;
        }
    }
    result() {
        const result = this._;
        this._ = "";
        return result.length ? result : null;
    }
}
function $08605c970909c78e$var$append(strings) {
    let i = 1;
    this._ += strings[0];
    for(const j = strings.length; i < j; ++i)this._ += arguments[i] + strings[i];
}
function $08605c970909c78e$var$appendRound(digits) {
    const d = Math.floor(digits);
    if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
    if (d > 15) return $08605c970909c78e$var$append;
    if (d !== $08605c970909c78e$var$cacheDigits) {
        const k = 10 ** d;
        $08605c970909c78e$var$cacheDigits = d;
        $08605c970909c78e$var$cacheAppend = function append(strings) {
            let i = 1;
            this._ += strings[0];
            for(const j = strings.length; i < j; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
        };
    }
    return $08605c970909c78e$var$cacheAppend;
}


function $b96d7b82ad5f1f0a$export$2e2bcd8739ae039(projection, context) {
    let digits = 3, pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $15fd252faf959553$export$2e2bcd8739ae039)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $15fd252faf959553$export$2e2bcd8739ae039)(object, projectionStream((0, $74d24869d056c881$export$2e2bcd8739ae039)));
        return (0, $74d24869d056c881$export$2e2bcd8739ae039).result();
    };
    path.measure = function(object) {
        (0, $15fd252faf959553$export$2e2bcd8739ae039)(object, projectionStream((0, $709da397f6b568f2$export$2e2bcd8739ae039)));
        return (0, $709da397f6b568f2$export$2e2bcd8739ae039).result();
    };
    path.bounds = function(object) {
        (0, $15fd252faf959553$export$2e2bcd8739ae039)(object, projectionStream((0, $bf358bc8c4fc33f2$export$2e2bcd8739ae039)));
        return (0, $bf358bc8c4fc33f2$export$2e2bcd8739ae039).result();
    };
    path.centroid = function(object) {
        (0, $15fd252faf959553$export$2e2bcd8739ae039)(object, projectionStream((0, $fd3413ce73d9346c$export$2e2bcd8739ae039)));
        return (0, $fd3413ce73d9346c$export$2e2bcd8739ae039).result();
    };
    path.projection = function(_) {
        if (!arguments.length) return projection;
        projectionStream = _ == null ? (projection = null, $781505731c5fcfa9$export$2e2bcd8739ae039) : (projection = _).stream;
        return path;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $08605c970909c78e$export$2e2bcd8739ae039)(digits)) : new (0, $8a51b1160a46943d$export$2e2bcd8739ae039)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    path.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        if (context === null) contextStream = new (0, $08605c970909c78e$export$2e2bcd8739ae039)(digits);
        return path;
    };
    return path.projection(projection).digits(digits).context(context);
}








const $8d0e4a58a592b70f$var$e10 = Math.sqrt(50), $8d0e4a58a592b70f$var$e5 = Math.sqrt(10), $8d0e4a58a592b70f$var$e2 = Math.sqrt(2);
function $8d0e4a58a592b70f$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $8d0e4a58a592b70f$var$e10 ? 10 : error >= $8d0e4a58a592b70f$var$e5 ? 5 : error >= $8d0e4a58a592b70f$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $8d0e4a58a592b70f$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $8d0e4a58a592b70f$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $8d0e4a58a592b70f$var$tickSpec(stop, start, count) : $8d0e4a58a592b70f$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $8d0e4a58a592b70f$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $8d0e4a58a592b70f$var$tickSpec(start, stop, count)[2];
}
function $8d0e4a58a592b70f$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $8d0e4a58a592b70f$export$bc64d00cc98e7e95(stop, start, count) : $8d0e4a58a592b70f$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}


function $ecd45cada93f6422$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $55a235e3e687e941$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $0ca2436c8bed6aac$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $ecd45cada93f6422$export$2e2bcd8739ae039);
        compare2 = (d, x)=>(0, $ecd45cada93f6422$export$2e2bcd8739ae039)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $ecd45cada93f6422$export$2e2bcd8739ae039) || f === (0, $55a235e3e687e941$export$2e2bcd8739ae039) ? f : $0ca2436c8bed6aac$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $0ca2436c8bed6aac$var$zero() {
    return 0;
}


function $3759d3e2d0024f78$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $3759d3e2d0024f78$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $f5022086be3fef1e$var$ascendingBisect = (0, $0ca2436c8bed6aac$export$2e2bcd8739ae039)((0, $ecd45cada93f6422$export$2e2bcd8739ae039));
const $f5022086be3fef1e$export$4d945ad3ad5751b0 = $f5022086be3fef1e$var$ascendingBisect.right;
const $f5022086be3fef1e$export$df7d25c84ebd12a5 = $f5022086be3fef1e$var$ascendingBisect.left;
const $f5022086be3fef1e$export$c1cb828b1117c77b = (0, $0ca2436c8bed6aac$export$2e2bcd8739ae039)((0, $3759d3e2d0024f78$export$2e2bcd8739ae039)).center;
var $f5022086be3fef1e$export$2e2bcd8739ae039 = $f5022086be3fef1e$export$4d945ad3ad5751b0;


function $3d24ebb613a53be9$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $ae3094cf9ba6e4a2$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $0c3db18e8e03605c$export$2e2bcd8739ae039(x) {
    return +x;
}


var $361adc747438640a$var$unit = [
    0,
    1
];
function $361adc747438640a$export$f0954fd7d5368655(x) {
    return x;
}
function $361adc747438640a$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $ae3094cf9ba6e4a2$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $361adc747438640a$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $361adc747438640a$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $361adc747438640a$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $361adc747438640a$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $361adc747438640a$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $361adc747438640a$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $f5022086be3fef1e$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $361adc747438640a$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $361adc747438640a$export$6b468dcfb64c653c() {
    var domain = $361adc747438640a$var$unit, range = $361adc747438640a$var$unit, interpolate = (0, $790287a65f557be7$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $361adc747438640a$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $361adc747438640a$export$f0954fd7d5368655) clamp = $361adc747438640a$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $361adc747438640a$var$polymap : $361adc747438640a$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $f124178efa7c0f49$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $0c3db18e8e03605c$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $3d24ebb613a53be9$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $361adc747438640a$export$f0954fd7d5368655, rescale()) : clamp !== $361adc747438640a$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $361adc747438640a$export$2e2bcd8739ae039() {
    return $361adc747438640a$export$6b468dcfb64c653c()($361adc747438640a$export$f0954fd7d5368655, $361adc747438640a$export$f0954fd7d5368655);
}


function $9e6be01639ce3789$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $9e6be01639ce3789$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}



function $44c51fe0201b4ee1$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $44c51fe0201b4ee1$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $9134ab7cef599b03$export$2e2bcd8739ae039(x) {
    return x = (0, $44c51fe0201b4ee1$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $bd8868268228a309$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $07c881113da48a86$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $61e28160d6e81242$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $61e28160d6e81242$export$2e2bcd8739ae039(specifier) {
    if (!(match = $61e28160d6e81242$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $61e28160d6e81242$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$61e28160d6e81242$export$2e2bcd8739ae039.prototype = $61e28160d6e81242$export$963aac351db36ed4.prototype; // instanceof
function $61e28160d6e81242$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$61e28160d6e81242$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $fc7b3920643ffd4f$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $ca6bcb2074c57859$export$6863724d9a42263;
function $ca6bcb2074c57859$export$2e2bcd8739ae039(x, p) {
    var d = (0, $44c51fe0201b4ee1$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($ca6bcb2074c57859$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $44c51fe0201b4ee1$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $38edce9e084f1973$export$2e2bcd8739ae039(x, p) {
    var d = (0, $44c51fe0201b4ee1$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $c9f2be6cce89e371$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $44c51fe0201b4ee1$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $38edce9e084f1973$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $38edce9e084f1973$export$2e2bcd8739ae039),
    "s": (0, $ca6bcb2074c57859$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $a6974559fc79df18$export$2e2bcd8739ae039(x) {
    return x;
}


var $ae12fea5da57fb6c$var$map = Array.prototype.map, $ae12fea5da57fb6c$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $ae12fea5da57fb6c$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $a6974559fc79df18$export$2e2bcd8739ae039) : (0, $bd8868268228a309$export$2e2bcd8739ae039)($ae12fea5da57fb6c$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $a6974559fc79df18$export$2e2bcd8739ae039) : (0, $07c881113da48a86$export$2e2bcd8739ae039)($ae12fea5da57fb6c$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $61e28160d6e81242$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $c9f2be6cce89e371$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $c9f2be6cce89e371$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $fc7b3920643ffd4f$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $ae12fea5da57fb6c$var$prefixes[8 + (0, $ca6bcb2074c57859$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $61e28160d6e81242$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $9134ab7cef599b03$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $ae12fea5da57fb6c$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $8cdfb327b72c0d43$var$locale;
var $8cdfb327b72c0d43$export$d9468344d3651243;
var $8cdfb327b72c0d43$export$8d85692a469dde6f;
$8cdfb327b72c0d43$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $8cdfb327b72c0d43$export$2e2bcd8739ae039(definition) {
    $8cdfb327b72c0d43$var$locale = (0, $ae12fea5da57fb6c$export$2e2bcd8739ae039)(definition);
    $8cdfb327b72c0d43$export$d9468344d3651243 = $8cdfb327b72c0d43$var$locale.format;
    $8cdfb327b72c0d43$export$8d85692a469dde6f = $8cdfb327b72c0d43$var$locale.formatPrefix;
    return $8cdfb327b72c0d43$var$locale;
}


function $b16e9740b1bb8717$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $9134ab7cef599b03$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $0cc1f26c46aeacea$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $9134ab7cef599b03$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $9134ab7cef599b03$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $cd3e259059b6e036$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $9134ab7cef599b03$export$2e2bcd8739ae039)(max) - (0, $9134ab7cef599b03$export$2e2bcd8739ae039)(step)) + 1;
}


function $909e2bbb4a64d1a6$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $8d0e4a58a592b70f$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $61e28160d6e81242$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $0cc1f26c46aeacea$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $8cdfb327b72c0d43$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $cd3e259059b6e036$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $b16e9740b1bb8717$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $8cdfb327b72c0d43$export$d9468344d3651243)(specifier);
}


function $4e8668784d878b46$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $8d0e4a58a592b70f$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $909e2bbb4a64d1a6$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $8d0e4a58a592b70f$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $4e8668784d878b46$export$2e2bcd8739ae039() {
    var scale = (0, $361adc747438640a$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $361adc747438640a$export$784d13d8ee351f07)(scale, $4e8668784d878b46$export$2e2bcd8739ae039());
    };
    (0, $9e6be01639ce3789$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $4e8668784d878b46$export$16a5d4b4a61a274d(scale);
}



const $e5cfb632324bd21a$export$e4f898ab14d9d460 = Symbol("implicit");
function $e5cfb632324bd21a$export$2e2bcd8739ae039() {
    var index = new (0, $0992cd7728ed6f24$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $e5cfb632324bd21a$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $e5cfb632324bd21a$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $0992cd7728ed6f24$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $e5cfb632324bd21a$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $9e6be01639ce3789$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}

const $c5cfd992de5910bc$var$t0 = new Date, $c5cfd992de5910bc$var$t1 = new Date;
function $c5cfd992de5910bc$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $c5cfd992de5910bc$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $c5cfd992de5910bc$var$t0.setTime(+start), $c5cfd992de5910bc$var$t1.setTime(+end);
            floori($c5cfd992de5910bc$var$t0), floori($c5cfd992de5910bc$var$t1);
            return Math.floor(count($c5cfd992de5910bc$var$t0, $c5cfd992de5910bc$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}


const $736d866915ca4bd8$export$79ef0e34099623dc = 1000;
const $736d866915ca4bd8$export$683905d551c33fa9 = $736d866915ca4bd8$export$79ef0e34099623dc * 60;
const $736d866915ca4bd8$export$4157bf0c8e241659 = $736d866915ca4bd8$export$683905d551c33fa9 * 60;
const $736d866915ca4bd8$export$353686095f4fbf45 = $736d866915ca4bd8$export$4157bf0c8e241659 * 24;
const $736d866915ca4bd8$export$c241eb88520d5016 = $736d866915ca4bd8$export$353686095f4fbf45 * 7;
const $736d866915ca4bd8$export$ab95684df7020b26 = $736d866915ca4bd8$export$353686095f4fbf45 * 30;
const $736d866915ca4bd8$export$61f8ee2d834c6959 = $736d866915ca4bd8$export$353686095f4fbf45 * 365;


const $886d8e53d47ad67a$export$8888529b966033e5 = (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $736d866915ca4bd8$export$683905d551c33fa9)) / (0, $736d866915ca4bd8$export$353686095f4fbf45), (date)=>date.getDate() - 1);
const $886d8e53d47ad67a$export$6657a54f3034cf45 = $886d8e53d47ad67a$export$8888529b966033e5.range;
const $886d8e53d47ad67a$export$c8cbc42cefd47140 = (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $736d866915ca4bd8$export$353686095f4fbf45);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $886d8e53d47ad67a$export$d277e198508549a1 = $886d8e53d47ad67a$export$c8cbc42cefd47140.range;
const $886d8e53d47ad67a$export$fb065be2d7ea4a71 = (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $736d866915ca4bd8$export$353686095f4fbf45);
}, (date)=>{
    return Math.floor(date / (0, $736d866915ca4bd8$export$353686095f4fbf45));
});
const $886d8e53d47ad67a$export$a491caaf5e9481aa = $886d8e53d47ad67a$export$fb065be2d7ea4a71.range;



const $251f2cc61d387be6$export$46c68a5833bc315b = (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $736d866915ca4bd8$export$79ef0e34099623dc) - date.getMinutes() * (0, $736d866915ca4bd8$export$683905d551c33fa9));
}, (date, step)=>{
    date.setTime(+date + step * (0, $736d866915ca4bd8$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $736d866915ca4bd8$export$4157bf0c8e241659);
}, (date)=>{
    return date.getHours();
});
const $251f2cc61d387be6$export$fb843f9087cd5235 = $251f2cc61d387be6$export$46c68a5833bc315b.range;
const $251f2cc61d387be6$export$31f6f2b3c63ac75e = (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $736d866915ca4bd8$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $736d866915ca4bd8$export$4157bf0c8e241659);
}, (date)=>{
    return date.getUTCHours();
});
const $251f2cc61d387be6$export$6e7a76cd5f50b719 = $251f2cc61d387be6$export$31f6f2b3c63ac75e.range;



const $6cbd2c325912b552$export$a7e4c34a52f0576 = (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $736d866915ca4bd8$export$79ef0e34099623dc));
}, (date, step)=>{
    date.setTime(+date + step * (0, $736d866915ca4bd8$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $736d866915ca4bd8$export$683905d551c33fa9);
}, (date)=>{
    return date.getMinutes();
});
const $6cbd2c325912b552$export$186d65358374c0a2 = $6cbd2c325912b552$export$a7e4c34a52f0576.range;
const $6cbd2c325912b552$export$efe6712d6003761b = (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $736d866915ca4bd8$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $736d866915ca4bd8$export$683905d551c33fa9);
}, (date)=>{
    return date.getUTCMinutes();
});
const $6cbd2c325912b552$export$cedd563624e8ee50 = $6cbd2c325912b552$export$efe6712d6003761b.range;


const $7d75e3251510be16$export$7e1084fb688591c1 = (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $7d75e3251510be16$export$3e24aa839cd0f1c4 = $7d75e3251510be16$export$7e1084fb688591c1.range;
const $7d75e3251510be16$export$cd49b3d2bcfe50d5 = (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $7d75e3251510be16$export$49159f585997498 = $7d75e3251510be16$export$cd49b3d2bcfe50d5.range;



const $42a11819fdeb42a3$export$3d3c77ce7df7d30d = (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $736d866915ca4bd8$export$79ef0e34099623dc));
}, (start, end)=>{
    return (end - start) / (0, $736d866915ca4bd8$export$79ef0e34099623dc);
}, (date)=>{
    return date.getUTCSeconds();
});
const $42a11819fdeb42a3$export$4792e48abc550fa1 = $42a11819fdeb42a3$export$3d3c77ce7df7d30d.range;




const $d9081cbdb1236d50$export$edc5e5cb87280477 = (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$d9081cbdb1236d50$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $d9081cbdb1236d50$export$edc5e5cb87280477;
    return (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $d9081cbdb1236d50$export$9a27fac83d67afd3 = $d9081cbdb1236d50$export$edc5e5cb87280477.range;








function $ebb2c81979489592$var$timeWeekday(i) {
    return (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $736d866915ca4bd8$export$683905d551c33fa9)) / (0, $736d866915ca4bd8$export$c241eb88520d5016);
    });
}
const $ebb2c81979489592$export$22ee6205b762968c = $ebb2c81979489592$var$timeWeekday(0);
const $ebb2c81979489592$export$e79bbe0177cf1b01 = $ebb2c81979489592$var$timeWeekday(1);
const $ebb2c81979489592$export$57c0658c29f77708 = $ebb2c81979489592$var$timeWeekday(2);
const $ebb2c81979489592$export$3fbeef226c256e43 = $ebb2c81979489592$var$timeWeekday(3);
const $ebb2c81979489592$export$608689422d5cf9f4 = $ebb2c81979489592$var$timeWeekday(4);
const $ebb2c81979489592$export$548e5227aa183dca = $ebb2c81979489592$var$timeWeekday(5);
const $ebb2c81979489592$export$c56a3ad248908e19 = $ebb2c81979489592$var$timeWeekday(6);
const $ebb2c81979489592$export$eac514c8a8674eba = $ebb2c81979489592$export$22ee6205b762968c.range;
const $ebb2c81979489592$export$f7219b1481948356 = $ebb2c81979489592$export$e79bbe0177cf1b01.range;
const $ebb2c81979489592$export$77e22b12c5bed05b = $ebb2c81979489592$export$57c0658c29f77708.range;
const $ebb2c81979489592$export$b85d407a471809e8 = $ebb2c81979489592$export$3fbeef226c256e43.range;
const $ebb2c81979489592$export$c1bc1c49254c8855 = $ebb2c81979489592$export$608689422d5cf9f4.range;
const $ebb2c81979489592$export$3691a1557fff46f1 = $ebb2c81979489592$export$548e5227aa183dca.range;
const $ebb2c81979489592$export$b755452d02cba8d2 = $ebb2c81979489592$export$c56a3ad248908e19.range;
function $ebb2c81979489592$var$utcWeekday(i) {
    return (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $736d866915ca4bd8$export$c241eb88520d5016);
    });
}
const $ebb2c81979489592$export$4898b06303a92011 = $ebb2c81979489592$var$utcWeekday(0);
const $ebb2c81979489592$export$9cfc53b9cfafd080 = $ebb2c81979489592$var$utcWeekday(1);
const $ebb2c81979489592$export$2a6d545f77eceb15 = $ebb2c81979489592$var$utcWeekday(2);
const $ebb2c81979489592$export$a5c25d8ed64433c4 = $ebb2c81979489592$var$utcWeekday(3);
const $ebb2c81979489592$export$1db08111baec2f53 = $ebb2c81979489592$var$utcWeekday(4);
const $ebb2c81979489592$export$29265e34dd5921f7 = $ebb2c81979489592$var$utcWeekday(5);
const $ebb2c81979489592$export$85b74dad05049604 = $ebb2c81979489592$var$utcWeekday(6);
const $ebb2c81979489592$export$6f3e1c2b0f7d7880 = $ebb2c81979489592$export$4898b06303a92011.range;
const $ebb2c81979489592$export$1d2d8b858bb366f9 = $ebb2c81979489592$export$9cfc53b9cfafd080.range;
const $ebb2c81979489592$export$1d5f6785fc7f30f8 = $ebb2c81979489592$export$2a6d545f77eceb15.range;
const $ebb2c81979489592$export$7a75faf0e37ef4af = $ebb2c81979489592$export$a5c25d8ed64433c4.range;
const $ebb2c81979489592$export$417eb959611b2f2f = $ebb2c81979489592$export$1db08111baec2f53.range;
const $ebb2c81979489592$export$59d308db7af08c64 = $ebb2c81979489592$export$29265e34dd5921f7.range;
const $ebb2c81979489592$export$a124108a0a7f34c8 = $ebb2c81979489592$export$85b74dad05049604.range;




const $37dbb153524ee1c9$export$cd17cfe45df0c046 = (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$37dbb153524ee1c9$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $37dbb153524ee1c9$export$69a4e90dd2cc3bd1 = $37dbb153524ee1c9$export$cd17cfe45df0c046.range;
const $37dbb153524ee1c9$export$d5c3802e389714c4 = (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$37dbb153524ee1c9$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $c5cfd992de5910bc$export$1a539c8b2950ab40)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $37dbb153524ee1c9$export$3e24d311e17f5802 = $37dbb153524ee1c9$export$d5c3802e389714c4.range;


function $1c5b855b05372516$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $42a11819fdeb42a3$export$3d3c77ce7df7d30d),
            1,
            (0, $736d866915ca4bd8$export$79ef0e34099623dc)
        ],
        [
            (0, $42a11819fdeb42a3$export$3d3c77ce7df7d30d),
            5,
            5 * (0, $736d866915ca4bd8$export$79ef0e34099623dc)
        ],
        [
            (0, $42a11819fdeb42a3$export$3d3c77ce7df7d30d),
            15,
            15 * (0, $736d866915ca4bd8$export$79ef0e34099623dc)
        ],
        [
            (0, $42a11819fdeb42a3$export$3d3c77ce7df7d30d),
            30,
            30 * (0, $736d866915ca4bd8$export$79ef0e34099623dc)
        ],
        [
            minute,
            1,
            (0, $736d866915ca4bd8$export$683905d551c33fa9)
        ],
        [
            minute,
            5,
            5 * (0, $736d866915ca4bd8$export$683905d551c33fa9)
        ],
        [
            minute,
            15,
            15 * (0, $736d866915ca4bd8$export$683905d551c33fa9)
        ],
        [
            minute,
            30,
            30 * (0, $736d866915ca4bd8$export$683905d551c33fa9)
        ],
        [
            hour,
            1,
            (0, $736d866915ca4bd8$export$4157bf0c8e241659)
        ],
        [
            hour,
            3,
            3 * (0, $736d866915ca4bd8$export$4157bf0c8e241659)
        ],
        [
            hour,
            6,
            6 * (0, $736d866915ca4bd8$export$4157bf0c8e241659)
        ],
        [
            hour,
            12,
            12 * (0, $736d866915ca4bd8$export$4157bf0c8e241659)
        ],
        [
            day,
            1,
            (0, $736d866915ca4bd8$export$353686095f4fbf45)
        ],
        [
            day,
            2,
            2 * (0, $736d866915ca4bd8$export$353686095f4fbf45)
        ],
        [
            week,
            1,
            (0, $736d866915ca4bd8$export$c241eb88520d5016)
        ],
        [
            month,
            1,
            (0, $736d866915ca4bd8$export$ab95684df7020b26)
        ],
        [
            month,
            3,
            3 * (0, $736d866915ca4bd8$export$ab95684df7020b26)
        ],
        [
            year,
            1,
            (0, $736d866915ca4bd8$export$61f8ee2d834c6959)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $0ca2436c8bed6aac$export$2e2bcd8739ae039)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $8d0e4a58a592b70f$export$81087d9b915d4ede)(start / (0, $736d866915ca4bd8$export$61f8ee2d834c6959), stop / (0, $736d866915ca4bd8$export$61f8ee2d834c6959), count));
        if (i === 0) return (0, $d9081cbdb1236d50$export$edc5e5cb87280477).every(Math.max((0, $8d0e4a58a592b70f$export$81087d9b915d4ede)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$1c5b855b05372516$export$826ba5ae907e9767, $1c5b855b05372516$export$6262d8d056ea44c4] = $1c5b855b05372516$var$ticker((0, $37dbb153524ee1c9$export$d5c3802e389714c4), (0, $7d75e3251510be16$export$cd49b3d2bcfe50d5), (0, $ebb2c81979489592$export$4898b06303a92011), (0, $886d8e53d47ad67a$export$fb065be2d7ea4a71), (0, $251f2cc61d387be6$export$31f6f2b3c63ac75e), (0, $6cbd2c325912b552$export$efe6712d6003761b));
const [$1c5b855b05372516$export$60c76498552d28a6, $1c5b855b05372516$export$69511150134dd174] = $1c5b855b05372516$var$ticker((0, $37dbb153524ee1c9$export$cd17cfe45df0c046), (0, $7d75e3251510be16$export$7e1084fb688591c1), (0, $ebb2c81979489592$export$22ee6205b762968c), (0, $886d8e53d47ad67a$export$8888529b966033e5), (0, $251f2cc61d387be6$export$46c68a5833bc315b), (0, $6cbd2c325912b552$export$a7e4c34a52f0576));



function $b552ec0218c05f24$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $b552ec0218c05f24$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $b552ec0218c05f24$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $b552ec0218c05f24$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $b552ec0218c05f24$var$formatRe(locale_periods), periodLookup = $b552ec0218c05f24$var$formatLookup(locale_periods), weekdayRe = $b552ec0218c05f24$var$formatRe(locale_weekdays), weekdayLookup = $b552ec0218c05f24$var$formatLookup(locale_weekdays), shortWeekdayRe = $b552ec0218c05f24$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $b552ec0218c05f24$var$formatLookup(locale_shortWeekdays), monthRe = $b552ec0218c05f24$var$formatRe(locale_months), monthLookup = $b552ec0218c05f24$var$formatLookup(locale_months), shortMonthRe = $b552ec0218c05f24$var$formatRe(locale_shortMonths), shortMonthLookup = $b552ec0218c05f24$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $b552ec0218c05f24$var$formatDayOfMonth,
        "e": $b552ec0218c05f24$var$formatDayOfMonth,
        "f": $b552ec0218c05f24$var$formatMicroseconds,
        "g": $b552ec0218c05f24$var$formatYearISO,
        "G": $b552ec0218c05f24$var$formatFullYearISO,
        "H": $b552ec0218c05f24$var$formatHour24,
        "I": $b552ec0218c05f24$var$formatHour12,
        "j": $b552ec0218c05f24$var$formatDayOfYear,
        "L": $b552ec0218c05f24$var$formatMilliseconds,
        "m": $b552ec0218c05f24$var$formatMonthNumber,
        "M": $b552ec0218c05f24$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $b552ec0218c05f24$var$formatUnixTimestamp,
        "s": $b552ec0218c05f24$var$formatUnixTimestampSeconds,
        "S": $b552ec0218c05f24$var$formatSeconds,
        "u": $b552ec0218c05f24$var$formatWeekdayNumberMonday,
        "U": $b552ec0218c05f24$var$formatWeekNumberSunday,
        "V": $b552ec0218c05f24$var$formatWeekNumberISO,
        "w": $b552ec0218c05f24$var$formatWeekdayNumberSunday,
        "W": $b552ec0218c05f24$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $b552ec0218c05f24$var$formatYear,
        "Y": $b552ec0218c05f24$var$formatFullYear,
        "Z": $b552ec0218c05f24$var$formatZone,
        "%": $b552ec0218c05f24$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $b552ec0218c05f24$var$formatUTCDayOfMonth,
        "e": $b552ec0218c05f24$var$formatUTCDayOfMonth,
        "f": $b552ec0218c05f24$var$formatUTCMicroseconds,
        "g": $b552ec0218c05f24$var$formatUTCYearISO,
        "G": $b552ec0218c05f24$var$formatUTCFullYearISO,
        "H": $b552ec0218c05f24$var$formatUTCHour24,
        "I": $b552ec0218c05f24$var$formatUTCHour12,
        "j": $b552ec0218c05f24$var$formatUTCDayOfYear,
        "L": $b552ec0218c05f24$var$formatUTCMilliseconds,
        "m": $b552ec0218c05f24$var$formatUTCMonthNumber,
        "M": $b552ec0218c05f24$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $b552ec0218c05f24$var$formatUnixTimestamp,
        "s": $b552ec0218c05f24$var$formatUnixTimestampSeconds,
        "S": $b552ec0218c05f24$var$formatUTCSeconds,
        "u": $b552ec0218c05f24$var$formatUTCWeekdayNumberMonday,
        "U": $b552ec0218c05f24$var$formatUTCWeekNumberSunday,
        "V": $b552ec0218c05f24$var$formatUTCWeekNumberISO,
        "w": $b552ec0218c05f24$var$formatUTCWeekdayNumberSunday,
        "W": $b552ec0218c05f24$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $b552ec0218c05f24$var$formatUTCYear,
        "Y": $b552ec0218c05f24$var$formatUTCFullYear,
        "Z": $b552ec0218c05f24$var$formatUTCZone,
        "%": $b552ec0218c05f24$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $b552ec0218c05f24$var$parseDayOfMonth,
        "e": $b552ec0218c05f24$var$parseDayOfMonth,
        "f": $b552ec0218c05f24$var$parseMicroseconds,
        "g": $b552ec0218c05f24$var$parseYear,
        "G": $b552ec0218c05f24$var$parseFullYear,
        "H": $b552ec0218c05f24$var$parseHour24,
        "I": $b552ec0218c05f24$var$parseHour24,
        "j": $b552ec0218c05f24$var$parseDayOfYear,
        "L": $b552ec0218c05f24$var$parseMilliseconds,
        "m": $b552ec0218c05f24$var$parseMonthNumber,
        "M": $b552ec0218c05f24$var$parseMinutes,
        "p": parsePeriod,
        "q": $b552ec0218c05f24$var$parseQuarter,
        "Q": $b552ec0218c05f24$var$parseUnixTimestamp,
        "s": $b552ec0218c05f24$var$parseUnixTimestampSeconds,
        "S": $b552ec0218c05f24$var$parseSeconds,
        "u": $b552ec0218c05f24$var$parseWeekdayNumberMonday,
        "U": $b552ec0218c05f24$var$parseWeekNumberSunday,
        "V": $b552ec0218c05f24$var$parseWeekNumberISO,
        "w": $b552ec0218c05f24$var$parseWeekdayNumberSunday,
        "W": $b552ec0218c05f24$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $b552ec0218c05f24$var$parseYear,
        "Y": $b552ec0218c05f24$var$parseFullYear,
        "Z": $b552ec0218c05f24$var$parseZone,
        "%": $b552ec0218c05f24$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $b552ec0218c05f24$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $b552ec0218c05f24$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $b552ec0218c05f24$var$utcDate($b552ec0218c05f24$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $ebb2c81979489592$export$9cfc53b9cfafd080).ceil(week) : (0, $ebb2c81979489592$export$9cfc53b9cfafd080)(week);
                    week = (0, $886d8e53d47ad67a$export$c8cbc42cefd47140).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $b552ec0218c05f24$var$localDate($b552ec0218c05f24$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $ebb2c81979489592$export$e79bbe0177cf1b01).ceil(week) : (0, $ebb2c81979489592$export$e79bbe0177cf1b01)(week);
                    week = (0, $886d8e53d47ad67a$export$8888529b966033e5).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $b552ec0218c05f24$var$utcDate($b552ec0218c05f24$var$newDate(d.y, 0, 1)).getUTCDay() : $b552ec0218c05f24$var$localDate($b552ec0218c05f24$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $b552ec0218c05f24$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $b552ec0218c05f24$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $b552ec0218c05f24$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $b552ec0218c05f24$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $b552ec0218c05f24$var$numberRe = /^\s*\d+/, $b552ec0218c05f24$var$percentRe = /^%/, $b552ec0218c05f24$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $b552ec0218c05f24$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $b552ec0218c05f24$var$requote(s) {
    return s.replace($b552ec0218c05f24$var$requoteRe, "\\$&");
}
function $b552ec0218c05f24$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($b552ec0218c05f24$var$requote).join("|") + ")", "i");
}
function $b552ec0218c05f24$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $b552ec0218c05f24$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseWeekNumberSunday(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseWeekNumberISO(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseWeekNumberMonday(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseFullYear(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseYear(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseQuarter(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseMonthNumber(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseDayOfMonth(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseDayOfYear(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseHour24(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseMinutes(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseSeconds(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseMilliseconds(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseMicroseconds(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseLiteralPercent(d, string, i) {
    var n = $b552ec0218c05f24$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $b552ec0218c05f24$var$parseUnixTimestamp(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $b552ec0218c05f24$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $b552ec0218c05f24$var$formatDayOfMonth(d, p) {
    return $b552ec0218c05f24$var$pad(d.getDate(), p, 2);
}
function $b552ec0218c05f24$var$formatHour24(d, p) {
    return $b552ec0218c05f24$var$pad(d.getHours(), p, 2);
}
function $b552ec0218c05f24$var$formatHour12(d, p) {
    return $b552ec0218c05f24$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $b552ec0218c05f24$var$formatDayOfYear(d, p) {
    return $b552ec0218c05f24$var$pad(1 + (0, $886d8e53d47ad67a$export$8888529b966033e5).count((0, $37dbb153524ee1c9$export$cd17cfe45df0c046)(d), d), p, 3);
}
function $b552ec0218c05f24$var$formatMilliseconds(d, p) {
    return $b552ec0218c05f24$var$pad(d.getMilliseconds(), p, 3);
}
function $b552ec0218c05f24$var$formatMicroseconds(d, p) {
    return $b552ec0218c05f24$var$formatMilliseconds(d, p) + "000";
}
function $b552ec0218c05f24$var$formatMonthNumber(d, p) {
    return $b552ec0218c05f24$var$pad(d.getMonth() + 1, p, 2);
}
function $b552ec0218c05f24$var$formatMinutes(d, p) {
    return $b552ec0218c05f24$var$pad(d.getMinutes(), p, 2);
}
function $b552ec0218c05f24$var$formatSeconds(d, p) {
    return $b552ec0218c05f24$var$pad(d.getSeconds(), p, 2);
}
function $b552ec0218c05f24$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $b552ec0218c05f24$var$formatWeekNumberSunday(d, p) {
    return $b552ec0218c05f24$var$pad((0, $ebb2c81979489592$export$22ee6205b762968c).count((0, $37dbb153524ee1c9$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $b552ec0218c05f24$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $ebb2c81979489592$export$608689422d5cf9f4)(d) : (0, $ebb2c81979489592$export$608689422d5cf9f4).ceil(d);
}
function $b552ec0218c05f24$var$formatWeekNumberISO(d, p) {
    d = $b552ec0218c05f24$var$dISO(d);
    return $b552ec0218c05f24$var$pad((0, $ebb2c81979489592$export$608689422d5cf9f4).count((0, $37dbb153524ee1c9$export$cd17cfe45df0c046)(d), d) + ((0, $37dbb153524ee1c9$export$cd17cfe45df0c046)(d).getDay() === 4), p, 2);
}
function $b552ec0218c05f24$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $b552ec0218c05f24$var$formatWeekNumberMonday(d, p) {
    return $b552ec0218c05f24$var$pad((0, $ebb2c81979489592$export$e79bbe0177cf1b01).count((0, $37dbb153524ee1c9$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $b552ec0218c05f24$var$formatYear(d, p) {
    return $b552ec0218c05f24$var$pad(d.getFullYear() % 100, p, 2);
}
function $b552ec0218c05f24$var$formatYearISO(d, p) {
    d = $b552ec0218c05f24$var$dISO(d);
    return $b552ec0218c05f24$var$pad(d.getFullYear() % 100, p, 2);
}
function $b552ec0218c05f24$var$formatFullYear(d, p) {
    return $b552ec0218c05f24$var$pad(d.getFullYear() % 10000, p, 4);
}
function $b552ec0218c05f24$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $ebb2c81979489592$export$608689422d5cf9f4)(d) : (0, $ebb2c81979489592$export$608689422d5cf9f4).ceil(d);
    return $b552ec0218c05f24$var$pad(d.getFullYear() % 10000, p, 4);
}
function $b552ec0218c05f24$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $b552ec0218c05f24$var$pad(z / 60 | 0, "0", 2) + $b552ec0218c05f24$var$pad(z % 60, "0", 2);
}
function $b552ec0218c05f24$var$formatUTCDayOfMonth(d, p) {
    return $b552ec0218c05f24$var$pad(d.getUTCDate(), p, 2);
}
function $b552ec0218c05f24$var$formatUTCHour24(d, p) {
    return $b552ec0218c05f24$var$pad(d.getUTCHours(), p, 2);
}
function $b552ec0218c05f24$var$formatUTCHour12(d, p) {
    return $b552ec0218c05f24$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $b552ec0218c05f24$var$formatUTCDayOfYear(d, p) {
    return $b552ec0218c05f24$var$pad(1 + (0, $886d8e53d47ad67a$export$c8cbc42cefd47140).count((0, $37dbb153524ee1c9$export$d5c3802e389714c4)(d), d), p, 3);
}
function $b552ec0218c05f24$var$formatUTCMilliseconds(d, p) {
    return $b552ec0218c05f24$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $b552ec0218c05f24$var$formatUTCMicroseconds(d, p) {
    return $b552ec0218c05f24$var$formatUTCMilliseconds(d, p) + "000";
}
function $b552ec0218c05f24$var$formatUTCMonthNumber(d, p) {
    return $b552ec0218c05f24$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $b552ec0218c05f24$var$formatUTCMinutes(d, p) {
    return $b552ec0218c05f24$var$pad(d.getUTCMinutes(), p, 2);
}
function $b552ec0218c05f24$var$formatUTCSeconds(d, p) {
    return $b552ec0218c05f24$var$pad(d.getUTCSeconds(), p, 2);
}
function $b552ec0218c05f24$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $b552ec0218c05f24$var$formatUTCWeekNumberSunday(d, p) {
    return $b552ec0218c05f24$var$pad((0, $ebb2c81979489592$export$4898b06303a92011).count((0, $37dbb153524ee1c9$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $b552ec0218c05f24$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $ebb2c81979489592$export$1db08111baec2f53)(d) : (0, $ebb2c81979489592$export$1db08111baec2f53).ceil(d);
}
function $b552ec0218c05f24$var$formatUTCWeekNumberISO(d, p) {
    d = $b552ec0218c05f24$var$UTCdISO(d);
    return $b552ec0218c05f24$var$pad((0, $ebb2c81979489592$export$1db08111baec2f53).count((0, $37dbb153524ee1c9$export$d5c3802e389714c4)(d), d) + ((0, $37dbb153524ee1c9$export$d5c3802e389714c4)(d).getUTCDay() === 4), p, 2);
}
function $b552ec0218c05f24$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $b552ec0218c05f24$var$formatUTCWeekNumberMonday(d, p) {
    return $b552ec0218c05f24$var$pad((0, $ebb2c81979489592$export$9cfc53b9cfafd080).count((0, $37dbb153524ee1c9$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $b552ec0218c05f24$var$formatUTCYear(d, p) {
    return $b552ec0218c05f24$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $b552ec0218c05f24$var$formatUTCYearISO(d, p) {
    d = $b552ec0218c05f24$var$UTCdISO(d);
    return $b552ec0218c05f24$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $b552ec0218c05f24$var$formatUTCFullYear(d, p) {
    return $b552ec0218c05f24$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $b552ec0218c05f24$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $ebb2c81979489592$export$1db08111baec2f53)(d) : (0, $ebb2c81979489592$export$1db08111baec2f53).ceil(d);
    return $b552ec0218c05f24$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $b552ec0218c05f24$var$formatUTCZone() {
    return "+0000";
}
function $b552ec0218c05f24$var$formatLiteralPercent() {
    return "%";
}
function $b552ec0218c05f24$var$formatUnixTimestamp(d) {
    return +d;
}
function $b552ec0218c05f24$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $149f3ba5b2472001$var$locale;
var $149f3ba5b2472001$export$94f4d87fad5dcf9a;
var $149f3ba5b2472001$export$32b9cd16e1b8c8d2;
var $149f3ba5b2472001$export$1a08fe38f63ebbbb;
var $149f3ba5b2472001$export$3edae9cf8e233729;
$149f3ba5b2472001$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $149f3ba5b2472001$export$2e2bcd8739ae039(definition) {
    $149f3ba5b2472001$var$locale = (0, $b552ec0218c05f24$export$2e2bcd8739ae039)(definition);
    $149f3ba5b2472001$export$94f4d87fad5dcf9a = $149f3ba5b2472001$var$locale.format;
    $149f3ba5b2472001$export$32b9cd16e1b8c8d2 = $149f3ba5b2472001$var$locale.parse;
    $149f3ba5b2472001$export$1a08fe38f63ebbbb = $149f3ba5b2472001$var$locale.utcFormat;
    $149f3ba5b2472001$export$3edae9cf8e233729 = $149f3ba5b2472001$var$locale.utcParse;
    return $149f3ba5b2472001$var$locale;
}




function $8103168ef701a065$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}


function $291a8ccd3c3ae926$var$date(t) {
    return new Date(t);
}
function $291a8ccd3c3ae926$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $291a8ccd3c3ae926$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $361adc747438640a$export$2e2bcd8739ae039)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $291a8ccd3c3ae926$var$number)) : domain().map($291a8ccd3c3ae926$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $8103168ef701a065$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $361adc747438640a$export$784d13d8ee351f07)(scale, $291a8ccd3c3ae926$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $291a8ccd3c3ae926$export$2e2bcd8739ae039() {
    return (0, $9e6be01639ce3789$export$23c7bb9e6558da2a).apply($291a8ccd3c3ae926$export$56bbcdb8aca31149((0, $1c5b855b05372516$export$60c76498552d28a6), (0, $1c5b855b05372516$export$69511150134dd174), (0, $37dbb153524ee1c9$export$cd17cfe45df0c046), (0, $7d75e3251510be16$export$7e1084fb688591c1), (0, $ebb2c81979489592$export$22ee6205b762968c), (0, $886d8e53d47ad67a$export$8888529b966033e5), (0, $251f2cc61d387be6$export$46c68a5833bc315b), (0, $6cbd2c325912b552$export$a7e4c34a52f0576), (0, $42a11819fdeb42a3$export$3d3c77ce7df7d30d), (0, $149f3ba5b2472001$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}





function $ee6de28bce72be65$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $b6616ac03e7685f2$export$52baac22726c72bf)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $b6616ac03e7685f2$export$52baac22726c72bf)([
        (0, $b158ee8071bed608$export$2e2bcd8739ae039)(selector)
    ], (0, $b6616ac03e7685f2$export$e8e78c978b129247));
}


function $669fdc5ad079d9da$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}


const $cc0c88fb7c1a7f2a$export$2335f513bbd82c6d = Math.abs;
const $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760 = Math.atan2;
const $cc0c88fb7c1a7f2a$export$50d414a77b60d802 = Math.cos;
const $cc0c88fb7c1a7f2a$export$8960430cfd85939f = Math.max;
const $cc0c88fb7c1a7f2a$export$96ec731ed4dcb222 = Math.min;
const $cc0c88fb7c1a7f2a$export$5de3937cb4b592ed = Math.sin;
const $cc0c88fb7c1a7f2a$export$eba8049fb5020b81 = Math.sqrt;
const $cc0c88fb7c1a7f2a$export$6c421550c66a327d = 1e-12;
const $cc0c88fb7c1a7f2a$export$18c7bea995a110f = Math.PI;
const $cc0c88fb7c1a7f2a$export$e51408a300e8929a = $cc0c88fb7c1a7f2a$export$18c7bea995a110f / 2;
const $cc0c88fb7c1a7f2a$export$a4b4b4d4d776fe92 = 2 * $cc0c88fb7c1a7f2a$export$18c7bea995a110f;
function $cc0c88fb7c1a7f2a$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $cc0c88fb7c1a7f2a$export$18c7bea995a110f : Math.acos(x);
}
function $cc0c88fb7c1a7f2a$export$41726bdb1fc63f(x) {
    return x >= 1 ? $cc0c88fb7c1a7f2a$export$e51408a300e8929a : x <= -1 ? -$cc0c88fb7c1a7f2a$export$e51408a300e8929a : Math.asin(x);
}


const $07d47ae9a8cf2518$var$pi = Math.PI, $07d47ae9a8cf2518$var$tau = 2 * $07d47ae9a8cf2518$var$pi, $07d47ae9a8cf2518$var$epsilon = 1e-6, $07d47ae9a8cf2518$var$tauEpsilon = $07d47ae9a8cf2518$var$tau - $07d47ae9a8cf2518$var$epsilon;
function $07d47ae9a8cf2518$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $07d47ae9a8cf2518$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $07d47ae9a8cf2518$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $07d47ae9a8cf2518$export$4b2950bdac9b6ee9 {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $07d47ae9a8cf2518$var$append : $07d47ae9a8cf2518$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $07d47ae9a8cf2518$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $07d47ae9a8cf2518$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($07d47ae9a8cf2518$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $07d47ae9a8cf2518$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $07d47ae9a8cf2518$var$epsilon || Math.abs(this._y1 - y0) > $07d47ae9a8cf2518$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $07d47ae9a8cf2518$var$tau + $07d47ae9a8cf2518$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $07d47ae9a8cf2518$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $07d47ae9a8cf2518$var$epsilon) this._append`A${r},${r},0,${+(da >= $07d47ae9a8cf2518$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function $07d47ae9a8cf2518$export$bb654e07daaf8c3a() {
    return new $07d47ae9a8cf2518$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$07d47ae9a8cf2518$export$bb654e07daaf8c3a.prototype = $07d47ae9a8cf2518$export$4b2950bdac9b6ee9.prototype;
function $07d47ae9a8cf2518$export$e181c6ece8d9cc5f(digits = 3) {
    return new $07d47ae9a8cf2518$export$4b2950bdac9b6ee9(+digits);
}


function $f80d68b146a3b195$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $07d47ae9a8cf2518$export$4b2950bdac9b6ee9)(digits);
}


function $dd52c4a96adfae77$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $dd52c4a96adfae77$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $dd52c4a96adfae77$var$arcStartAngle(d) {
    return d.startAngle;
}
function $dd52c4a96adfae77$var$arcEndAngle(d) {
    return d.endAngle;
}
function $dd52c4a96adfae77$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $dd52c4a96adfae77$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $cc0c88fb7c1a7f2a$export$6c421550c66a327d)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $dd52c4a96adfae77$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $cc0c88fb7c1a7f2a$export$eba8049fb5020b81)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $cc0c88fb7c1a7f2a$export$eba8049fb5020b81)((0, $cc0c88fb7c1a7f2a$export$8960430cfd85939f)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $dd52c4a96adfae77$export$2e2bcd8739ae039() {
    var innerRadius = $dd52c4a96adfae77$var$arcInnerRadius, outerRadius = $dd52c4a96adfae77$var$arcOuterRadius, cornerRadius = (0, $669fdc5ad079d9da$export$2e2bcd8739ae039)(0), padRadius = null, startAngle = $dd52c4a96adfae77$var$arcStartAngle, endAngle = $dd52c4a96adfae77$var$arcEndAngle, padAngle = $dd52c4a96adfae77$var$arcPadAngle, context = null, path = (0, $f80d68b146a3b195$export$fb6e83118a5dcd45)(arc);
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $cc0c88fb7c1a7f2a$export$e51408a300e8929a), a1 = endAngle.apply(this, arguments) - (0, $cc0c88fb7c1a7f2a$export$e51408a300e8929a), da = (0, $cc0c88fb7c1a7f2a$export$2335f513bbd82c6d)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = path();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $cc0c88fb7c1a7f2a$export$6c421550c66a327d))) context.moveTo(0, 0);
        else if (da > (0, $cc0c88fb7c1a7f2a$export$a4b4b4d4d776fe92) - (0, $cc0c88fb7c1a7f2a$export$6c421550c66a327d)) {
            context.moveTo(r1 * (0, $cc0c88fb7c1a7f2a$export$50d414a77b60d802)(a0), r1 * (0, $cc0c88fb7c1a7f2a$export$5de3937cb4b592ed)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $cc0c88fb7c1a7f2a$export$6c421550c66a327d)) {
                context.moveTo(r0 * (0, $cc0c88fb7c1a7f2a$export$50d414a77b60d802)(a1), r0 * (0, $cc0c88fb7c1a7f2a$export$5de3937cb4b592ed)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $cc0c88fb7c1a7f2a$export$6c421550c66a327d) && (padRadius ? +padRadius.apply(this, arguments) : (0, $cc0c88fb7c1a7f2a$export$eba8049fb5020b81)(r0 * r0 + r1 * r1)), rc = (0, $cc0c88fb7c1a7f2a$export$96ec731ed4dcb222)((0, $cc0c88fb7c1a7f2a$export$2335f513bbd82c6d)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $cc0c88fb7c1a7f2a$export$6c421550c66a327d)) {
                var p0 = (0, $cc0c88fb7c1a7f2a$export$41726bdb1fc63f)(rp / r0 * (0, $cc0c88fb7c1a7f2a$export$5de3937cb4b592ed)(ap)), p1 = (0, $cc0c88fb7c1a7f2a$export$41726bdb1fc63f)(rp / r1 * (0, $cc0c88fb7c1a7f2a$export$5de3937cb4b592ed)(ap));
                if ((da0 -= p0 * 2) > (0, $cc0c88fb7c1a7f2a$export$6c421550c66a327d)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $cc0c88fb7c1a7f2a$export$6c421550c66a327d)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $cc0c88fb7c1a7f2a$export$50d414a77b60d802)(a01), y01 = r1 * (0, $cc0c88fb7c1a7f2a$export$5de3937cb4b592ed)(a01), x10 = r0 * (0, $cc0c88fb7c1a7f2a$export$50d414a77b60d802)(a10), y10 = r0 * (0, $cc0c88fb7c1a7f2a$export$5de3937cb4b592ed)(a10);
            // Apply rounded corners?
            if (rc > (0, $cc0c88fb7c1a7f2a$export$6c421550c66a327d)) {
                var x11 = r1 * (0, $cc0c88fb7c1a7f2a$export$50d414a77b60d802)(a11), y11 = r1 * (0, $cc0c88fb7c1a7f2a$export$5de3937cb4b592ed)(a11), x00 = r0 * (0, $cc0c88fb7c1a7f2a$export$50d414a77b60d802)(a00), y00 = r0 * (0, $cc0c88fb7c1a7f2a$export$5de3937cb4b592ed)(a00), oc;
                // Restrict the corner radius according to the sector angle. If this
                // intersection fails, it’s probably because the arc is too small, so
                // disable the corner radius entirely.
                if (da < (0, $cc0c88fb7c1a7f2a$export$18c7bea995a110f)) {
                    if (oc = $dd52c4a96adfae77$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $cc0c88fb7c1a7f2a$export$5de3937cb4b592ed)((0, $cc0c88fb7c1a7f2a$export$fd6306be3fde5b04)((ax * bx + ay * by) / ((0, $cc0c88fb7c1a7f2a$export$eba8049fb5020b81)(ax * ax + ay * ay) * (0, $cc0c88fb7c1a7f2a$export$eba8049fb5020b81)(bx * bx + by * by))) / 2), lc = (0, $cc0c88fb7c1a7f2a$export$eba8049fb5020b81)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, $cc0c88fb7c1a7f2a$export$96ec731ed4dcb222)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, $cc0c88fb7c1a7f2a$export$96ec731ed4dcb222)(rc, (r1 - lc) / (kc + 1));
                    } else rc0 = rc1 = 0;
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $cc0c88fb7c1a7f2a$export$6c421550c66a327d))) context.moveTo(x01, y01);
            else if (rc1 > (0, $cc0c88fb7c1a7f2a$export$6c421550c66a327d)) {
                t0 = $dd52c4a96adfae77$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $dd52c4a96adfae77$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t1.y11, t1.x11), (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $cc0c88fb7c1a7f2a$export$6c421550c66a327d)) || !(da0 > (0, $cc0c88fb7c1a7f2a$export$6c421550c66a327d))) context.lineTo(x10, y10);
            else if (rc0 > (0, $cc0c88fb7c1a7f2a$export$6c421550c66a327d)) {
                t0 = $dd52c4a96adfae77$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $dd52c4a96adfae77$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t1.y11, t1.x11), (0, $cc0c88fb7c1a7f2a$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $cc0c88fb7c1a7f2a$export$18c7bea995a110f) / 2;
        return [
            (0, $cc0c88fb7c1a7f2a$export$50d414a77b60d802)(a) * r,
            (0, $cc0c88fb7c1a7f2a$export$5de3937cb4b592ed)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $669fdc5ad079d9da$export$2e2bcd8739ae039)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $669fdc5ad079d9da$export$2e2bcd8739ae039)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $669fdc5ad079d9da$export$2e2bcd8739ae039)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $669fdc5ad079d9da$export$2e2bcd8739ae039)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $669fdc5ad079d9da$export$2e2bcd8739ae039)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $669fdc5ad079d9da$export$2e2bcd8739ae039)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $669fdc5ad079d9da$export$2e2bcd8739ae039)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

var $9ca51fcd6ee7408a$export$58adb3bec8346d0f = Array.prototype.slice;
function $9ca51fcd6ee7408a$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}



function $f7eb88c83fdeccb8$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}


function $84ce1c2b17df682e$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}


function $55d272f8642f740f$var$stackValue(d, key) {
    return d[key];
}
function $55d272f8642f740f$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $55d272f8642f740f$export$2e2bcd8739ae039() {
    var keys = (0, $669fdc5ad079d9da$export$2e2bcd8739ae039)([]), order = (0, $84ce1c2b17df682e$export$2e2bcd8739ae039), offset = (0, $f7eb88c83fdeccb8$export$2e2bcd8739ae039), value = $55d272f8642f740f$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $55d272f8642f740f$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $9ca51fcd6ee7408a$export$2e2bcd8739ae039)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $669fdc5ad079d9da$export$2e2bcd8739ae039)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $669fdc5ad079d9da$export$2e2bcd8739ae039)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $84ce1c2b17df682e$export$2e2bcd8739ae039) : typeof _ === "function" ? _ : (0, $669fdc5ad079d9da$export$2e2bcd8739ae039)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $f7eb88c83fdeccb8$export$2e2bcd8739ae039) : _, stack) : offset;
    };
    return stack;
}


function $c9ea0dfd380bfed7$export$2e2bcd8739ae039(series) {
    var sums = series.map($c9ea0dfd380bfed7$export$8a63f25cc62965f1);
    return (0, $84ce1c2b17df682e$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $c9ea0dfd380bfed7$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}


function $efcc082d23e2d92b$export$2e2bcd8739ae039(series) {
    return (0, $c9ea0dfd380bfed7$export$2e2bcd8739ae039)(series).reverse();
}








var $d40e51d77388cae0$var$epsilon2 = 1e-12;
function $d40e51d77388cae0$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $d40e51d77388cae0$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $d40e51d77388cae0$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $d40e51d77388cae0$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $d40e51d77388cae0$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $d40e51d77388cae0$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $d40e51d77388cae0$var$tanh(rho * s + r0) - $d40e51d77388cae0$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $d40e51d77388cae0$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);




var $34c7c49f353894c7$export$2e2bcd8739ae039 = (x)=>()=>x;


function $29d8c543e60e2a8c$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $516c17b726e283f8$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$516c17b726e283f8$export$563a914cafbdc389.prototype = {
    constructor: $516c17b726e283f8$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $516c17b726e283f8$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $516c17b726e283f8$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $516c17b726e283f8$export$f0954fd7d5368655 = new $516c17b726e283f8$export$563a914cafbdc389(1, 0, 0);
$516c17b726e283f8$export$2e2bcd8739ae039.prototype = $516c17b726e283f8$export$563a914cafbdc389.prototype;
function $516c17b726e283f8$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $516c17b726e283f8$export$f0954fd7d5368655;
    return node.__zoom;
}


function $0c225adc17c4f0db$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $0c225adc17c4f0db$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $1ae8025c01b6f5ac$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $1ae8025c01b6f5ac$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $1ae8025c01b6f5ac$var$defaultTransform() {
    return this.__zoom || (0, $516c17b726e283f8$export$f0954fd7d5368655);
}
function $1ae8025c01b6f5ac$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $1ae8025c01b6f5ac$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $1ae8025c01b6f5ac$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $1ae8025c01b6f5ac$export$2e2bcd8739ae039() {
    var filter = $1ae8025c01b6f5ac$var$defaultFilter, extent = $1ae8025c01b6f5ac$var$defaultExtent, constrain = $1ae8025c01b6f5ac$var$defaultConstrain, wheelDelta = $1ae8025c01b6f5ac$var$defaultWheelDelta, touchable = $1ae8025c01b6f5ac$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $d40e51d77388cae0$export$2e2bcd8739ae039), listeners = (0, $a7ac57445b8c2673$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $1ae8025c01b6f5ac$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $1ae8025c01b6f5ac$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $516c17b726e283f8$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $516c17b726e283f8$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $516c17b726e283f8$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $516c17b726e283f8$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $b0ba9a260c958684$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $29d8c543e60e2a8c$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $3c7b4c5122b1c4f6$export$2e2bcd8739ae039)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $b41725ddfae0f3a3$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $0c225adc17c4f0db$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $b0ba9a260c958684$export$2e2bcd8739ae039)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $3c7b4c5122b1c4f6$export$2e2bcd8739ae039)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $b4bf2a47d576b8cb$export$2e2bcd8739ae039)(event.view);
        (0, $0c225adc17c4f0db$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $b41725ddfae0f3a3$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved(event) {
            (0, $0c225adc17c4f0db$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $3c7b4c5122b1c4f6$export$2e2bcd8739ae039)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $b4bf2a47d576b8cb$export$833237748009e1e1)(event.view, g.moved);
            (0, $0c225adc17c4f0db$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $3c7b4c5122b1c4f6$export$2e2bcd8739ae039)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $0c225adc17c4f0db$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $b0ba9a260c958684$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $b0ba9a260c958684$export$2e2bcd8739ae039)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $0c225adc17c4f0db$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $3c7b4c5122b1c4f6$export$2e2bcd8739ae039)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $b41725ddfae0f3a3$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $0c225adc17c4f0db$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $3c7b4c5122b1c4f6$export$2e2bcd8739ae039)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $0c225adc17c4f0db$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $3c7b4c5122b1c4f6$export$2e2bcd8739ae039)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $b0ba9a260c958684$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $34c7c49f353894c7$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $34c7c49f353894c7$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $34c7c49f353894c7$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $34c7c49f353894c7$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}











function $6a6288c2207a1f36$export$5daf5a22d06b9116(repsSummaryData, maxForBeeswarm) {
    if (!repsSummaryData) return [];
    const repsData = [];
    // Add each matched contact, whether or not they have calls.
    repsSummaryData?.reps.forEach((r)=>{
        const expandedResult = {
            id: r.id,
            repInfo: r,
            total: 0,
            outcomes: [],
            topIssues: [],
            callResults: [],
            beeswarm: [],
            numVoicemail: 0,
            percentVM: 0,
            percentContact: 0,
            percentUnavailable: 0
        };
        // Add the call data, if it exists.
        const contactSummaryData = repsSummaryData.repsData.find((c)=>c.id === r.id);
        if (contactSummaryData !== undefined) {
            expandedResult.total = contactSummaryData.total;
            expandedResult.outcomes = contactSummaryData.outcomes;
            expandedResult.topIssues = contactSummaryData.topIssues;
            expandedResult.callResults = contactSummaryData.aggregatedResults;
            // Calculate calls per issue per day, in the user's time zone.
            expandedResult.barSeries = $6a6288c2207a1f36$var$aggregateCallResults(expandedResult.callResults);
            if (expandedResult.total <= maxForBeeswarm) // In-place expand to individual calls.
            $6a6288c2207a1f36$var$expandRepResults(expandedResult.callResults);
            // Calculate aggregated reachability stats.
            if (contactSummaryData.outcomes) {
                const vmOutcomes = contactSummaryData.outcomes.find((s)=>s.result === 'voicemail');
                const contactOutcomes = contactSummaryData.outcomes.find((s)=>s.result === 'contact');
                const unavailableOutcomes = contactSummaryData.outcomes.find((s)=>s.result === 'unavailable');
                const numVm = !vmOutcomes ? 0 : vmOutcomes.count;
                const numContact = !contactOutcomes ? 0 : contactOutcomes.count;
                const numUnavailable = !unavailableOutcomes ? 0 : unavailableOutcomes.count;
                if (contactSummaryData.total > 0) {
                    expandedResult.percentVM = numVm / contactSummaryData.total;
                    expandedResult.percentContact = numContact / contactSummaryData.total;
                    expandedResult.percentUnavailable = numUnavailable / contactSummaryData.total;
                }
            }
        }
        repsData.push(expandedResult);
    });
    return repsData;
}
const $6a6288c2207a1f36$var$expandRepResults = (results)=>{
    const addedPoints = [];
    // Add a unique ID for the D3 animation later.
    let indexForId = 0;
    results.forEach((r)=>{
        // Add an ID for this point, and subsequent IDs for its expanded points.
        r.id = indexForId++;
        r.selected = false;
        for(let i = 1; i < r.count; i++)// Expand the data based on the count to create enough dots.
        addedPoints.push({
            time: r.time,
            issue_id: r.issue_id,
            count: 1,
            selected: false,
            id: indexForId++
        });
    });
    results.push(...addedPoints);
};
const $6a6288c2207a1f36$var$aggregateCallResults = (results)=>{
    const finalDate = new Date();
    finalDate.setHours(0, 0, 0, 0);
    // Clip to avoid partial days, which would be confusing to explain.
    const earliestDate = finalDate.getTime() - 518400000;
    // Construct a map with time/issue_id keys -> count.
    const aggregatedMap = new Map();
    const issueIds = new Set();
    for (const r of results){
        const rDate = new Date(r.time * 1000);
        if (rDate.getTime() < earliestDate) continue;
        const dayTimestamp = rDate.setHours(0, 0, 0, 0) / 1000;
        const key = `${dayTimestamp}_${r.issue_id}`;
        const existing = aggregatedMap.get(key);
        if (existing) existing.count += r.count;
        else aggregatedMap.set(key, {
            time: dayTimestamp,
            issue_id: r.issue_id,
            count: r.count,
            selected: r.selected,
            id: r.id
        });
        issueIds.add(r.issue_id);
    }
    return $55d272f8642f740f$export$2e2bcd8739ae039().keys(issueIds).value(([, group], key)=>{
        const value = group.get(key);
        return value ? value.count : 0;
    }).order($efcc082d23e2d92b$export$2e2bcd8739ae039)($f15ffc2889c669d7$export$b610b8812bbcded9(aggregatedMap.values(), (d)=>d.time, (d)=>d.issue_id));
};
function $6a6288c2207a1f36$export$80a5e38dcf9837d9(statesResults, data) {
    const filteredStatesResults = statesResults.filter((stateResults)=>data.find((d)=>d.id === stateResults.id));
    const keyData = filteredStatesResults.reduce((agg, row)=>{
        if (!row.issueCounts || row.issueCounts.length === 0) return agg;
        const topIssue = row.issueCounts[0];
        let issueInKey = agg.find((i)=>topIssue.issue_id === i.issue_id);
        if (issueInKey === undefined) {
            issueInKey = {
                issue_id: topIssue.issue_id,
                name: topIssue.name,
                count: 0,
                slug: ''
            };
            agg.push(issueInKey);
        }
        issueInKey.count++;
        return agg;
    }, []);
    // Sort by number of states with this top issue.
    keyData.sort((a, b)=>b.count - a.count);
    return keyData;
}
function $6a6288c2207a1f36$export$a48ea3e6cd4672ef(usaData) {
    if (!usaData.usa.issueCounts) return {
        topIssueIds: [],
        issueIdToName: {}
    };
    const topIssueIds = usaData.usa.issueCounts.reduce((agg, row)=>{
        agg.push(row.issue_id);
        return agg;
    }, []);
    const issueIdToName = usaData.usa.issueCounts.reduce((agg, row)=>{
        if (!agg[row.issue_id]) agg[row.issue_id] = row.name;
        return agg;
    }, {});
    return {
        topIssueIds: topIssueIds,
        issueIdToName: issueIdToName
    };
}
// 2025 population data from census.gov.
const $6a6288c2207a1f36$var$POPULATION_DATA = {
    AS: 43268,
    GU: 169691,
    PR: 3184835,
    VI: 103792,
    AL: 5193088,
    AK: 737270,
    AZ: 7623818,
    AR: 3114791,
    CA: 39355309,
    CO: 6012561,
    CT: 3688496,
    DE: 1059952,
    DC: 693645,
    FL: 23462518,
    GA: 11302748,
    HI: 1432820,
    ID: 2029733,
    IL: 12719141,
    IN: 6973333,
    IA: 3238387,
    KS: 2977220,
    KY: 4606864,
    LA: 4618189,
    ME: 1414874,
    MD: 6265347,
    MA: 7154084,
    MI: 10127884,
    MN: 5830405,
    MS: 2954160,
    MO: 6270541,
    MP: 50946,
    MT: 1144694,
    NE: 2018006,
    NV: 3282188,
    NH: 1415342,
    NJ: 9548215,
    NM: 2125498,
    NY: 20002427,
    NC: 11197968,
    ND: 799358,
    OH: 11900510,
    OK: 4123288,
    OR: 4273586,
    PA: 13059432,
    RI: 1114521,
    SC: 5570274,
    SD: 935094,
    TN: 7315076,
    TX: 31709821,
    UT: 3538904,
    VT: 644663,
    VA: 8880107,
    WA: 8001020,
    WV: 1766147,
    WI: 5972787,
    WY: 588753
};
function $6a6288c2207a1f36$export$184c621c2471df58(id) {
    if ($6a6288c2207a1f36$var$POPULATION_DATA[id]) return $6a6288c2207a1f36$var$POPULATION_DATA[id];
    console.warn('Could not find population data for ' + id);
    // We will usually divide by population. Make sure to return something!
    return 1;
}
function $6a6288c2207a1f36$export$3b378a6955dba71a(totalCalls, state, scaledPopDenominator) {
    const scaledCalls = Math.round(totalCalls / $6a6288c2207a1f36$export$184c621c2471df58(state) * scaledPopDenominator * 10) / 10;
    return `${scaledCalls.toFixed(1)} calls per ${scaledPopDenominator.toLocaleString()} people`;
}
function $6a6288c2207a1f36$export$1cde4b99c1c83f07(urlParams, storage) {
    const key = $58e79092af177c1d$export$2ec53a4c598cbdd5.DISTRICT;
    if (urlParams.has(key)) {
        const urlDistrict = urlParams.get(key);
        if (urlDistrict && (urlDistrict.length === 4 || urlDistrict.length === 5)) return urlDistrict;
    }
    return storage ? storage.getItem(key) : null;
}
const $6a6288c2207a1f36$export$c0c950a4c4390c1a = 261.63; // Middle C
const $6a6288c2207a1f36$export$488bb1d68ae4806b = 523.25; // The next higher C
const $6a6288c2207a1f36$export$1a4df45fb8313799 = 0.2;
const $6a6288c2207a1f36$export$5fed0a46bd59e54d = 0.1;
function $6a6288c2207a1f36$export$b668c2e9e0b9869c(x, isSelected, beeswarmTargetWidth, sonificationDurationS) {
    const offsetSeconds = x / beeswarmTargetWidth * sonificationDurationS;
    const frequency = isSelected ? $6a6288c2207a1f36$export$488bb1d68ae4806b : $6a6288c2207a1f36$export$c0c950a4c4390c1a;
    const gain = isSelected ? $6a6288c2207a1f36$export$1a4df45fb8313799 : $6a6288c2207a1f36$export$5fed0a46bd59e54d;
    return {
        frequency: frequency,
        gain: gain,
        offsetSeconds: offsetSeconds
    };
}
function $6a6288c2207a1f36$export$853d048a5fc76514() {
    let x = (d)=>d[0];
    let y = (d)=>d[1];
    let r = (d)=>d[2];
    let ticks = 300;
    function beeswarm(data) {
        const entries = data.map((d)=>({
                x0: typeof x === 'function' ? x(d) : x,
                y0: typeof y === 'function' ? y(d) : y,
                r: typeof r === 'function' ? r(d) : r,
                x: 0,
                y: 0,
                data: d
            }));
        const simulation = $4e06c20dc82a7c26$export$2e2bcd8739ae039(entries).force('x', $9ac01369310c6f2e$export$2e2bcd8739ae039((d)=>d.x0)).force('y', $69ee3e2a8f7a6868$export$2e2bcd8739ae039((d)=>d.y0)).force('collide', $0e19b5ce15a83408$export$2e2bcd8739ae039((d)=>d.r));
        for(let i = 0; i < ticks; i++)simulation.tick();
        return entries;
    }
    beeswarm.x = (f)=>f ? (x = f, beeswarm) : x;
    beeswarm.y = (f)=>f ? (y = f, beeswarm) : y;
    beeswarm.r = (f)=>f ? (r = f, beeswarm) : r;
    beeswarm.ticks = (n)=>typeof n === 'number' ? (ticks = n, beeswarm) : ticks;
    return beeswarm;
}



function $66c5e2eee70ae25c$export$2e2bcd8739ae039(x) {
    return x;
}


function $00a25dc784ded3fd$export$2e2bcd8739ae039(transform) {
    if (transform == null) return 0, $66c5e2eee70ae25c$export$2e2bcd8739ae039;
    var x0, y0, kx = transform.scale[0], ky = transform.scale[1], dx = transform.translate[0], dy = transform.translate[1];
    return function(input, i) {
        if (!i) x0 = y0 = 0;
        var j = 2, n = input.length, output = new Array(n);
        output[0] = (x0 += input[0]) * kx + dx;
        output[1] = (y0 += input[1]) * ky + dy;
        while(j < n)output[j] = input[j], ++j;
        return output;
    };
}


function $3e2edda47709c0df$export$2e2bcd8739ae039(topology) {
    var t = (0, $00a25dc784ded3fd$export$2e2bcd8739ae039)(topology.transform), key, x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;
    function bboxPoint(p) {
        p = t(p);
        if (p[0] < x0) x0 = p[0];
        if (p[0] > x1) x1 = p[0];
        if (p[1] < y0) y0 = p[1];
        if (p[1] > y1) y1 = p[1];
    }
    function bboxGeometry(o) {
        switch(o.type){
            case "GeometryCollection":
                o.geometries.forEach(bboxGeometry);
                break;
            case "Point":
                bboxPoint(o.coordinates);
                break;
            case "MultiPoint":
                o.coordinates.forEach(bboxPoint);
                break;
        }
    }
    topology.arcs.forEach(function(arc) {
        var i = -1, n = arc.length, p;
        while(++i < n){
            p = t(arc[i], i);
            if (p[0] < x0) x0 = p[0];
            if (p[0] > x1) x1 = p[0];
            if (p[1] < y0) y0 = p[1];
            if (p[1] > y1) y1 = p[1];
        }
    });
    for(key in topology.objects)bboxGeometry(topology.objects[key]);
    return [
        x0,
        y0,
        x1,
        y1
    ];
}


function $532196cb3dfbac21$export$2e2bcd8739ae039(array, n) {
    var t, j = array.length, i = j - n;
    while(i < --j)t = array[i], array[i++] = array[j], array[j] = t;
}



function $9bf4e6a809db8c60$export$2e2bcd8739ae039(topology, o) {
    if (typeof o === "string") o = topology.objects[o];
    return o.type === "GeometryCollection" ? {
        type: "FeatureCollection",
        features: o.geometries.map(function(o) {
            return $9bf4e6a809db8c60$var$feature(topology, o);
        })
    } : $9bf4e6a809db8c60$var$feature(topology, o);
}
function $9bf4e6a809db8c60$var$feature(topology, o) {
    var id = o.id, bbox = o.bbox, properties = o.properties == null ? {} : o.properties, geometry = $9bf4e6a809db8c60$export$be5493f9613cbbe(topology, o);
    return id == null && bbox == null ? {
        type: "Feature",
        properties: properties,
        geometry: geometry
    } : bbox == null ? {
        type: "Feature",
        id: id,
        properties: properties,
        geometry: geometry
    } : {
        type: "Feature",
        id: id,
        bbox: bbox,
        properties: properties,
        geometry: geometry
    };
}
function $9bf4e6a809db8c60$export$be5493f9613cbbe(topology, o) {
    var transformPoint = (0, $00a25dc784ded3fd$export$2e2bcd8739ae039)(topology.transform), arcs = topology.arcs;
    function arc(i, points) {
        if (points.length) points.pop();
        for(var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k)points.push(transformPoint(a[k], k));
        if (i < 0) (0, $532196cb3dfbac21$export$2e2bcd8739ae039)(points, n);
    }
    function point(p) {
        return transformPoint(p);
    }
    function line(arcs) {
        var points = [];
        for(var i = 0, n = arcs.length; i < n; ++i)arc(arcs[i], points);
        if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
        return points;
    }
    function ring(arcs) {
        var points = line(arcs);
        while(points.length < 4)points.push(points[0]); // This may happen if an arc has only two points.
        return points;
    }
    function polygon(arcs) {
        return arcs.map(ring);
    }
    function geometry(o) {
        var type = o.type, coordinates;
        switch(type){
            case "GeometryCollection":
                return {
                    type: type,
                    geometries: o.geometries.map(geometry)
                };
            case "Point":
                coordinates = point(o.coordinates);
                break;
            case "MultiPoint":
                coordinates = o.coordinates.map(point);
                break;
            case "LineString":
                coordinates = line(o.arcs);
                break;
            case "MultiLineString":
                coordinates = o.arcs.map(line);
                break;
            case "Polygon":
                coordinates = polygon(o.arcs);
                break;
            case "MultiPolygon":
                coordinates = o.arcs.map(polygon);
                break;
            default:
                return null;
        }
        return {
            type: type,
            coordinates: coordinates
        };
    }
    return geometry(o);
}



function $bdcd75c0cfe35c52$export$2e2bcd8739ae039(topology, arcs) {
    var stitchedArcs = {}, fragmentByStart = {}, fragmentByEnd = {}, fragments = [], emptyIndex = -1;
    // Stitch empty arcs first, since they may be subsumed by other arcs.
    arcs.forEach(function(i, j) {
        var arc = topology.arcs[i < 0 ? ~i : i], t;
        if (arc.length < 3 && !arc[1][0] && !arc[1][1]) t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
    });
    arcs.forEach(function(i) {
        var e = ends(i), start = e[0], end = e[1], f, g;
        if (f = fragmentByEnd[start]) {
            delete fragmentByEnd[f.end];
            f.push(i);
            f.end = end;
            if (g = fragmentByStart[end]) {
                delete fragmentByStart[g.start];
                var fg = g === f ? f : f.concat(g);
                fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
            } else fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
        } else if (f = fragmentByStart[end]) {
            delete fragmentByStart[f.start];
            f.unshift(i);
            f.start = start;
            if (g = fragmentByEnd[start]) {
                delete fragmentByEnd[g.end];
                var gf = g === f ? f : g.concat(f);
                fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
            } else fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
        } else {
            f = [
                i
            ];
            fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
        }
    });
    function ends(i) {
        var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
        if (topology.transform) p1 = [
            0,
            0
        ], arc.forEach(function(dp) {
            p1[0] += dp[0], p1[1] += dp[1];
        });
        else p1 = arc[arc.length - 1];
        return i < 0 ? [
            p1,
            p0
        ] : [
            p0,
            p1
        ];
    }
    function flush(fragmentByEnd, fragmentByStart) {
        for(var k in fragmentByEnd){
            var f = fragmentByEnd[k];
            delete fragmentByStart[f.start];
            delete f.start;
            delete f.end;
            f.forEach(function(i) {
                stitchedArcs[i < 0 ? ~i : i] = 1;
            });
            fragments.push(f);
        }
    }
    flush(fragmentByEnd, fragmentByStart);
    flush(fragmentByStart, fragmentByEnd);
    arcs.forEach(function(i) {
        if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([
            i
        ]);
    });
    return fragments;
}


function $9805a33a3de7db70$export$2e2bcd8739ae039(topology) {
    return (0, $9bf4e6a809db8c60$export$be5493f9613cbbe)(topology, $9805a33a3de7db70$export$fc3815c78e52e7d6.apply(this, arguments));
}
function $9805a33a3de7db70$export$fc3815c78e52e7d6(topology, object, filter) {
    var arcs, i, n;
    if (arguments.length > 1) arcs = $9805a33a3de7db70$var$extractArcs(topology, object, filter);
    else for(i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i)arcs[i] = i;
    return {
        type: "MultiLineString",
        arcs: (0, $bdcd75c0cfe35c52$export$2e2bcd8739ae039)(topology, arcs)
    };
}
function $9805a33a3de7db70$var$extractArcs(topology, object, filter) {
    var arcs = [], geomsByArc = [], geom;
    function extract0(i) {
        var j = i < 0 ? ~i : i;
        (geomsByArc[j] || (geomsByArc[j] = [])).push({
            i: i,
            g: geom
        });
    }
    function extract1(arcs) {
        arcs.forEach(extract0);
    }
    function extract2(arcs) {
        arcs.forEach(extract1);
    }
    function extract3(arcs) {
        arcs.forEach(extract2);
    }
    function geometry(o) {
        switch(geom = o, o.type){
            case "GeometryCollection":
                o.geometries.forEach(geometry);
                break;
            case "LineString":
                extract1(o.arcs);
                break;
            case "MultiLineString":
            case "Polygon":
                extract2(o.arcs);
                break;
            case "MultiPolygon":
                extract3(o.arcs);
                break;
        }
    }
    geometry(object);
    geomsByArc.forEach(filter == null ? function(geoms) {
        arcs.push(geoms[0].i);
    } : function(geoms) {
        if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i);
    });
    return arcs;
}




function $c2867918843d7b98$var$planarRingArea(ring) {
    var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
    while(++i < n)a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
    return Math.abs(area); // Note: doubled area!
}
function $c2867918843d7b98$export$2e2bcd8739ae039(topology) {
    return (0, $9bf4e6a809db8c60$export$be5493f9613cbbe)(topology, $c2867918843d7b98$export$fa52272cf7935962.apply(this, arguments));
}
function $c2867918843d7b98$export$fa52272cf7935962(topology, objects) {
    var polygonsByArc = {}, polygons = [], groups = [];
    objects.forEach(geometry);
    function geometry(o) {
        switch(o.type){
            case "GeometryCollection":
                o.geometries.forEach(geometry);
                break;
            case "Polygon":
                extract(o.arcs);
                break;
            case "MultiPolygon":
                o.arcs.forEach(extract);
                break;
        }
    }
    function extract(polygon) {
        polygon.forEach(function(ring) {
            ring.forEach(function(arc) {
                (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
            });
        });
        polygons.push(polygon);
    }
    function area(ring) {
        return $c2867918843d7b98$var$planarRingArea((0, $9bf4e6a809db8c60$export$be5493f9613cbbe)(topology, {
            type: "Polygon",
            arcs: [
                ring
            ]
        }).coordinates[0]);
    }
    polygons.forEach(function(polygon) {
        if (!polygon._) {
            var group = [], neighbors = [
                polygon
            ];
            polygon._ = 1;
            groups.push(group);
            while(polygon = neighbors.pop()){
                group.push(polygon);
                polygon.forEach(function(ring) {
                    ring.forEach(function(arc) {
                        polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
                            if (!polygon._) {
                                polygon._ = 1;
                                neighbors.push(polygon);
                            }
                        });
                    });
                });
            }
        }
    });
    polygons.forEach(function(polygon) {
        delete polygon._;
    });
    return {
        type: "MultiPolygon",
        arcs: groups.map(function(polygons) {
            var arcs = [], n;
            // Extract the exterior (unique) arcs.
            polygons.forEach(function(polygon) {
                polygon.forEach(function(ring) {
                    ring.forEach(function(arc) {
                        if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) arcs.push(arc);
                    });
                });
            });
            // Stitch the arcs into one or more rings.
            arcs = (0, $bdcd75c0cfe35c52$export$2e2bcd8739ae039)(topology, arcs);
            // If more than one ring is returned,
            // at most one of these rings can be the exterior;
            // choose the one with the greatest absolute area.
            if ((n = arcs.length) > 1) {
                for(var i = 1, k = area(arcs[0]), ki, t; i < n; ++i)if ((ki = area(arcs[i])) > k) t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
            }
            return arcs;
        }).filter(function(arcs) {
            return arcs.length > 0;
        })
    };
}


function $a5c966b582187c7a$export$2e2bcd8739ae039(a, x) {
    var lo = 0, hi = a.length;
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
}


function $79b81af31e9194f8$export$2e2bcd8739ae039(objects) {
    var indexesByArc = {}, neighbors = objects.map(function() {
        return [];
    });
    function line(arcs, i) {
        arcs.forEach(function(a) {
            if (a < 0) a = ~a;
            var o = indexesByArc[a];
            if (o) o.push(i);
            else indexesByArc[a] = [
                i
            ];
        });
    }
    function polygon(arcs, i) {
        arcs.forEach(function(arc) {
            line(arc, i);
        });
    }
    function geometry(o, i) {
        if (o.type === "GeometryCollection") o.geometries.forEach(function(o) {
            geometry(o, i);
        });
        else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
    }
    var geometryType = {
        LineString: line,
        MultiLineString: polygon,
        Polygon: polygon,
        MultiPolygon: function(arcs, i) {
            arcs.forEach(function(arc) {
                polygon(arc, i);
            });
        }
    };
    objects.forEach(geometry);
    for(var i in indexesByArc){
        for(var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j)for(var k = j + 1; k < m; ++k){
            var ij = indexes[j], ik = indexes[k], n;
            if ((n = neighbors[ij])[i = (0, $a5c966b582187c7a$export$2e2bcd8739ae039)(n, ik)] !== ik) n.splice(i, 0, ik);
            if ((n = neighbors[ik])[i = (0, $a5c966b582187c7a$export$2e2bcd8739ae039)(n, ij)] !== ij) n.splice(i, 0, ij);
        }
    }
    return neighbors;
}




function $80beb6de1a1161e8$export$2e2bcd8739ae039(transform) {
    if (transform == null) return 0, $66c5e2eee70ae25c$export$2e2bcd8739ae039;
    var x0, y0, kx = transform.scale[0], ky = transform.scale[1], dx = transform.translate[0], dy = transform.translate[1];
    return function(input, i) {
        if (!i) x0 = y0 = 0;
        var j = 2, n = input.length, output = new Array(n), x1 = Math.round((input[0] - dx) / kx), y1 = Math.round((input[1] - dy) / ky);
        output[0] = x1 - x0, x0 = x1;
        output[1] = y1 - y0, y0 = y1;
        while(j < n)output[j] = input[j], ++j;
        return output;
    };
}


function $eb147239dc53ef55$export$2e2bcd8739ae039(topology, transform) {
    if (topology.transform) throw new Error("already quantized");
    if (!transform || !transform.scale) {
        if (!((n = Math.floor(transform)) >= 2)) throw new Error("n must be \u22652");
        box = topology.bbox || (0, $3e2edda47709c0df$export$2e2bcd8739ae039)(topology);
        var x0 = box[0], y0 = box[1], x1 = box[2], y1 = box[3], n;
        transform = {
            scale: [
                x1 - x0 ? (x1 - x0) / (n - 1) : 1,
                y1 - y0 ? (y1 - y0) / (n - 1) : 1
            ],
            translate: [
                x0,
                y0
            ]
        };
    } else box = topology.bbox;
    var t = (0, $80beb6de1a1161e8$export$2e2bcd8739ae039)(transform), box, key, inputs = topology.objects, outputs = {};
    function quantizePoint(point) {
        return t(point);
    }
    function quantizeGeometry(input) {
        var output;
        switch(input.type){
            case "GeometryCollection":
                output = {
                    type: "GeometryCollection",
                    geometries: input.geometries.map(quantizeGeometry)
                };
                break;
            case "Point":
                output = {
                    type: "Point",
                    coordinates: quantizePoint(input.coordinates)
                };
                break;
            case "MultiPoint":
                output = {
                    type: "MultiPoint",
                    coordinates: input.coordinates.map(quantizePoint)
                };
                break;
            default:
                return input;
        }
        if (input.id != null) output.id = input.id;
        if (input.bbox != null) output.bbox = input.bbox;
        if (input.properties != null) output.properties = input.properties;
        return output;
    }
    function quantizeArc(input) {
        var i = 0, j = 1, n = input.length, p, output = new Array(n); // pessimistic
        output[0] = t(input[0], 0);
        while(++i < n)if ((p = t(input[i], i))[0] || p[1]) output[j++] = p; // non-coincident points
        if (j === 1) output[j++] = [
            0,
            0
        ]; // an arc must have at least two points
        output.length = j;
        return output;
    }
    for(key in inputs)outputs[key] = quantizeGeometry(inputs[key]);
    return {
        type: "Topology",
        bbox: box,
        transform: transform,
        objects: outputs,
        arcs: topology.arcs.map(quantizeArc)
    };
}








const $de86a1079a091ab5$export$b339e6d5fd943d40 = 7; // In seconds.
const $de86a1079a091ab5$var$playTone = (context, frequency, gain, offsetSeconds)=>{
    const oscillator = context.createOscillator();
    const gainNode = context.createGain();
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(frequency, context.currentTime);
    oscillator.connect(gainNode);
    gainNode.connect(context.destination);
    gainNode.gain.setValueAtTime(gain, context.currentTime + offsetSeconds);
    oscillator.start(context.currentTime + offsetSeconds);
    oscillator.stop(context.currentTime + offsetSeconds + 0.15);
};
const $de86a1079a091ab5$var$playBackgroundTone = (context, durationSeconds)=>{
    const droneOsc = context.createOscillator();
    const droneGain = context.createGain();
    droneOsc.type = 'triangle'; // Some texture
    droneOsc.frequency.setValueAtTime(220, context.currentTime); // Low tone
    droneGain.gain.setValueAtTime(0.05, context.currentTime); // Subtle volume
    droneOsc.connect(droneGain);
    droneGain.connect(context.destination);
    droneOsc.start(context.currentTime);
    droneOsc.stop(context.currentTime + durationSeconds);
};
const $de86a1079a091ab5$export$ab6bf2d526806d73 = (context, beeswarm, beeswarmScale, beeswarmTargetWidth)=>{
    // We assume data has the oldest element first.
    for(let i = beeswarm.length - 1; i >= 0; i--){
        const item = beeswarm[i];
        // Skip things rendered too early. TODO: Maybe just start earlier instead.
        if (item.x < 0) continue;
        const { frequency: frequency, gain: gain, offsetSeconds: offsetSeconds } = (0, $6a6288c2207a1f36$export$b668c2e9e0b9869c)(item.x, item.data.selected, beeswarmTargetWidth, $de86a1079a091ab5$export$b339e6d5fd943d40);
        $de86a1079a091ab5$var$playTone(context, frequency, gain, offsetSeconds);
    }
    beeswarmScale.ticks().forEach((tick)=>{
        $de86a1079a091ab5$var$playTone(context, 212, 0.1, beeswarmScale(tick) / 85);
    });
    $de86a1079a091ab5$var$playBackgroundTone(context, $de86a1079a091ab5$export$b339e6d5fd943d40);
    return context.currentTime;
};


const $9f780b598065538f$export$ad5e43985b0d4023 = 600;
const $9f780b598065538f$export$4dc1b11d18d63ea = 'rgb(24, 117, 209)';
const $9f780b598065538f$export$e13cce2a2d16a9d4 = '#9467bd';
const $9f780b598065538f$export$e7a419f45e0cacee = '#ed3c1d';
const $9f780b598065538f$var$defaultColor = '#eee';
const $9f780b598065538f$var$beeswarmDefaultColor = '#ccc';
const $9f780b598065538f$export$875fee6b8c75cb95 = '#666';
const $9f780b598065538f$var$selectedStateStroke = 'rgba(255, 217, 52)';
const $9f780b598065538f$var$USA_TOPOJSON = 'https://cdn.jsdelivr.net/npm/us-atlas@2/us/10m.json';
const $9f780b598065538f$var$MIN_FOR_BEESWARM = 7;
const $9f780b598065538f$var$MAX_FOR_SONIFICATION = 1000;
const $9f780b598065538f$export$fc6f3774784d2638 = 3000;
const $9f780b598065538f$var$MIN_FOR_BARS = 100;
const $9f780b598065538f$var$SCALED_POP_DENOMINATOR = 10000;
const $9f780b598065538f$var$MAP_TABS = {
    TOP_CALLS: 'top_calls',
    SCALED_CALLS: 'scaled_calls',
    TOTAL_CALLS: 'total_calls'
};
const $9f780b598065538f$var$drawStateLabel = (parentState, stateName, contents, onClose)=>{
    const labelBox = $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_label').attr('hidden', null);
    labelBox.select('div.title').html(stateName);
    labelBox.select('div.contents').html(contents);
    labelBox.select('button#close_label_btn').on('click', function(event) {
        onClose(event);
    });
    $9f780b598065538f$var$updateStateLabelPosition(parentState);
};
const $9f780b598065538f$var$updateStateLabelPosition = (parent)=>{
    if (!parent) return;
    // The state's bounding box.
    const boundingBox = parent.getBBox();
    const label = $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_label');
    const labelWidth = 200;
    // SVG's bounding box.
    const svgBb = parent.parentElement.parentElement.getBoundingClientRect();
    // State has no bounds because it's a territory like PR, VI, etc.
    // Show the label in the middle.
    if (boundingBox.width === 0 || boundingBox.height === 0) {
        label.style('top', `${svgBb.height / 2}px`).style('left', `${(svgBb.width - labelWidth) / 2}px`).classed('leftLabel', null).classed('rightLabel', null);
        return;
    }
    // Thanks ChatGPT for the matrix conversion math.
    const matrix = parent.getScreenCTM();
    const point = parent.ownerSVGElement.createSVGPoint();
    point.x = boundingBox.x + 0.5 * boundingBox.width;
    point.y = boundingBox.y + 0.5 * boundingBox.height;
    const screenCoords = point.matrixTransform(matrix);
    const holderBb = $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_content').node().getBoundingClientRect();
    const svgOffsetY = svgBb.y - holderBb.y;
    screenCoords.y += svgOffsetY - 24; // 24 has to do with where the < is on the label.
    if (labelWidth + screenCoords.x > svgBb.width) {
        label.classed('rightLabel', true);
        label.classed('leftLabel', null);
        screenCoords.x -= labelWidth + 24;
    } else {
        label.classed('rightLabel', null);
        label.classed('leftLabel', true);
        screenCoords.x += 24;
    }
    // Check it is within the drawing bounds, with some reasonable buffer.
    if (screenCoords.y + 24 > svgBb.height + svgOffsetY + svgBb.y || screenCoords.y + 24 < svgBb.y + svgOffsetY || screenCoords.x > svgBb.width - 24 || screenCoords.x < -labelWidth / 2) label.attr('hidden', true);
    else label.attr('hidden', null);
    const yCoord = screenCoords.y - svgBb.y;
    const xCoord = screenCoords.x - svgBb.x;
    label.style('top', `${yCoord}px`).style('left', `${xCoord}px`);
};
const $9f780b598065538f$var$drawStateResults = (allStateResults, state, issueColor, duration)=>{
    $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_detail').attr('hidden', state === null ? true : null);
    // TODO: Use D3 to transform rather than clearing and redrawing everything, for better performance
    // and also so animation doesn't always start at 0.
    $b0ba9a260c958684$export$2e2bcd8739ae039('ol#top_five_state_holder').html('');
    const stateResults = allStateResults.find((d)=>d.id === state);
    if (stateResults) {
        $ee6de28bce72be65$export$2e2bcd8739ae039('div#total_state').html(stateResults.total.toLocaleString());
        $ee6de28bce72be65$export$2e2bcd8739ae039('div#state_name_subtitle').html(stateResults.name);
        $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_total_card').attr('hidden', null);
    }
    if (!stateResults || stateResults.total === 0) {
        $b0ba9a260c958684$export$2e2bcd8739ae039('h2#state_detail_title').html(`There were no calls in ${stateResults ? stateResults.name : state} recorded with 5 Calls, ${duration}`);
        if (!stateResults) $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_total_card').attr('hidden', true);
        return;
    }
    $b0ba9a260c958684$export$2e2bcd8739ae039('h2#state_detail_title').attr('class', 'detail_title').html(`Most called issues in ${stateResults.name}, ${duration}`);
    if (!stateResults || stateResults.total === 0) return;
    $9f780b598065538f$var$drawTopFiveIssues('ol#top_five_state_holder', stateResults.issueCounts, stateResults.id, `${stateResults.name}'s`, `in ${stateResults.name}`, duration, issueColor, stateResults.total, /* shouldShowBeeswarm= */ false);
};
const $9f780b598065538f$export$5474aa916fd55b45 = (usaData, state, issueColor, duration)=>{
    const topIssues = usaData.usa.issueCounts ? usaData.usa.issueCounts.slice(0, 5) : [];
    $ee6de28bce72be65$export$2e2bcd8739ae039('div#total_all').html(usaData.usa.total.toLocaleString());
    $9f780b598065538f$var$drawTopFiveIssues('ol#top_five_all_holder', topIssues, 'usa', 'nationwide', 'nationwide', duration, issueColor, usaData.usa.total, /* shouldShowBeeswarm= */ false);
    $9f780b598065538f$var$drawStateResults(usaData.states, state, issueColor, duration);
    $9f780b598065538f$var$drawUsaMap(usaData.states, issueColor, state, duration, (new_state)=>{
        $9f780b598065538f$var$drawStateResults(usaData.states, new_state, issueColor, duration);
    });
};
const $9f780b598065538f$var$drawTopFiveIssues = (holder, data, sectionId, countTextModifier, totalCountTextModifier, duration, issueColor, total, shouldShowBeeswarm)=>{
    const topFiveRow = $b0ba9a260c958684$export$2e2bcd8739ae039(holder).selectAll('li.top_five').data(data).enter().append('li').classed('top_five', true).attr('id', (d)=>`top_five_${sectionId}_${d.issue_id}`);
    const rowContent = topFiveRow.append('div').classed('top_five_item_holder', true).attr('title', (d)=>`${(d.count / total * 100).toFixed(1)}% of calls: ${d.name}`);
    const issueSection = rowContent.append('div').attr('class', 'top_five_issue_row').attr('id', (d)=>`issue_row_${sectionId}_${d.issue_id}`);
    const collapseIssueRow = (event, d)=>{
        if (!$9f780b598065538f$var$isValidActivation(event)) return;
        const row = $b0ba9a260c958684$export$2e2bcd8739ae039(`li#top_five_${sectionId}_${d.issue_id}`);
        row.select('button.issue_name').on('click', null).on('keydown', null).classed('short', true).attr('aria-expanded', false).transition().delay(500).attr('class', 'issue_name truncated').on('end', ()=>{
            row.select('div.row_detail').style('visibility', 'visible').attr('aria-hidden', true);
            row.on('click', expandIssueRow).on('keydown', expandIssueRow);
        });
        row.select('div.row_detail').classed('expanded', null);
        event.stopPropagation();
    };
    const expandIssueRow = (event, d)=>{
        if (!$9f780b598065538f$var$isValidActivation(event)) return;
        const row = $b0ba9a260c958684$export$2e2bcd8739ae039(`li#top_five_${sectionId}_${d.issue_id}`);
        row.select('button.issue_name').classed('truncated', false).attr('aria-expanded', true).on('click', collapseIssueRow).on('keydown', collapseIssueRow);
        row.select('div.row_detail').attr('aria-hidden', false).style('visibility', 'visible').classed('expanded', true);
        event.stopPropagation();
    };
    const rowDetails = rowContent.append('div').classed('row_detail', true).attr('aria-hidden', true).style('visibility', 'hidden');
    rowDetails.append('div').html((d)=>`${(d.count / total * 100).toFixed(1)}% of ${countTextModifier} calls in the ${duration}`);
    rowDetails.append('div').html((d)=>`${d.total_count.toLocaleString()} total calls ${totalCountTextModifier}`);
    rowDetails.append('div').html((d)=>{
        if (d.archived) // TODO: Add a link to the archive when possible.
        return 'This call is no longer active.';
        else return `<a href="/issue/${d.slug}">Make this call</a>`;
    });
    issueSection.append('button').classed('issue_name', true).classed('truncated', true).attr('aria-expanded', false).html((d)=>`${d.name}`).on('click', expandIssueRow).on('keydown', expandIssueRow);
    let stat;
    if (shouldShowBeeswarm) stat = issueSection.append('button').attr('title', 'Highlight these calls below');
    else stat = issueSection.append('div').style('color', (d)=>issueColor(d.issue_id));
    stat.attr('class', 'stat').html((d)=>`${d.count.toLocaleString()} call${d.count > 1 ? 's' : ''}`);
    const issueBarSvg = rowContent.append('div').attr('class', 'issue_bar_holder').append('svg').attr('width', '100%').attr('height', '.5rem').attr('title', (d)=>`${(d.count / total * 100).toFixed(1)}% of calls`);
    const issueBar = issueBarSvg.append('g').attr('aria-hidden', true);
    issueBar.append('rect').attr('width', '100%').attr('height', '.5rem').attr('y', 0).attr('x', 0).attr('fill', $9f780b598065538f$var$defaultColor).attr('stroke', '#555');
    issueBar.append('rect').attr('width', 0).attr('height', '.5rem').attr('y', 0).attr('x', 0).attr('fill', (d)=>issueColor(d.issue_id)).transition().delay(500).duration(1000).attr('width', (d)=>`${d.count / total * 100}%`);
};
const $9f780b598065538f$var$prepareMapKey = (maxTotal, minColor, maxColor, id, labelSuffix)=>{
    const scaleColor = $4e8668784d878b46$export$2e2bcd8739ae039([
        0,
        maxTotal
    ], [
        minColor,
        maxColor
    ]);
    const gradientHeight = 6;
    const keySvg = $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_key').append('svg').attr('id', id).style('overflow', 'visible').style('font-size', '1rem').style('line-height', '1').attr('height', `${gradientHeight}rem`).style('float', 'left').style('margin-right', '.5rem').attr('title', `Values from 0 to ${maxTotal} calls`);
    const gradient = keySvg.append('linearGradient').attr('id', `keyLinearGradient_${id}`).attr('x1', '0%').attr('y1', '0%').attr('x2', '0%').attr('y2', '100%');
    gradient.append('stop').attr('offset', '0%').attr('stop-color', maxColor);
    gradient.append('stop').attr('offset', '100%').attr('stop-color', minColor);
    keySvg.append('rect').attr('width', '16px').attr('height', '5rem').attr('y', '0.5rem').style('fill', `url(#keyLinearGradient_${id})`);
    keySvg.append('line').attr('stroke', 'black').attr('x1', 0).attr('x2', 20).attr('y1', '0.5rem').attr('y2', '0.5rem');
    keySvg.append('line').attr('stroke', 'black').attr('x1', 0).attr('x2', 20).attr('y1', '3rem').attr('y2', '3rem');
    keySvg.append('line').attr('stroke', 'black').attr('x1', 0).attr('x2', 20).attr('y1', '5.5rem').attr('y2', '5.5rem');
    const maxText = keySvg.append('text').attr('x', '24').attr('y', 0).attr('dy', '1rem').attr('fill', 'black').html(`${maxTotal.toLocaleString()} ${labelSuffix}`);
    keySvg.append('text').attr('x', '24').attr('y', `${gradientHeight / 2}rem`).attr('dy', '.5rem').attr('fill', 'black').html(`${(maxTotal / 2).toLocaleString()} ${labelSuffix}`);
    keySvg.append('text').attr('x', '24').attr('y', `${gradientHeight}rem`).attr('fill', 'black').html(`0 ${labelSuffix}`);
    keySvg.attr('width', maxText.node().getBBox().width + 24).style('display', 'none');
    return scaleColor;
};
const $9f780b598065538f$var$drawUsaMap = (statesResults, issueColor, initialState, duration, redrawStateResults)=>{
    // Draw USA map
    $80ddd0f02b18fe07$export$2e2bcd8739ae039($9f780b598065538f$var$USA_TOPOJSON).then((usa)=>{
        // The data is the states loaded from the topojson file.
        const data = $9bf4e6a809db8c60$export$2e2bcd8739ae039(usa, usa.objects.states).features;
        const territories = [
            {
                type: 'Feature',
                id: 'PR',
                properties: {
                    name: 'Puerto Rico'
                },
                geometry: {
                    type: 'Polygon',
                    coordinates: [
                        []
                    ]
                }
            },
            {
                type: 'Feature',
                id: 'AS',
                properties: {
                    name: 'American Samoa'
                },
                geometry: {
                    type: 'Polygon',
                    coordinates: [
                        []
                    ]
                }
            },
            {
                type: 'Feature',
                id: 'GU',
                properties: {
                    name: 'Guam'
                },
                geometry: {
                    type: 'Polygon',
                    coordinates: [
                        []
                    ]
                }
            },
            {
                type: 'Feature',
                id: 'VI',
                properties: {
                    name: 'Virgin Islands'
                },
                geometry: {
                    type: 'Polygon',
                    coordinates: [
                        []
                    ]
                }
            },
            {
                type: 'Feature',
                id: 'MP',
                properties: {
                    name: 'Northern Mariana Islands'
                },
                geometry: {
                    type: 'Polygon',
                    coordinates: [
                        []
                    ]
                }
            }
        ];
        data.push(...territories);
        // Alphabetize the states
        data.sort((a, b)=>a.properties.name.localeCompare(b.properties.name));
        data.forEach((d)=>{
            const stateResult = statesResults.find((s)=>s.name === d.properties.name);
            if (stateResult) d.id = stateResult.id;
            else // ID must not start with a number, which it does if the state data is missing and ID was not overwritten.
            d.id = '_' + d.id;
        });
        const keyData = (0, $6a6288c2207a1f36$export$80a5e38dcf9837d9)(statesResults, data);
        // Set up the key for the top issue tab.
        $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_key').append('ol').selectAll('.key').data(keyData).enter().append('li').attr('class', 'key').style('border-color', (d)=>issueColor(d.issue_id)).html((d)=>`<b>${d.count} state${d.count == 1 ? '' : 's'}</b>: ${d.name}`);
        // Set up the key for the total calls tab.
        let maxTotal = statesResults.reduce((agg, row)=>{
            if (row && row.total > agg) agg = row.total;
            return agg;
        }, 0);
        // Round the max to a round number.
        maxTotal = Math.ceil(maxTotal / 100) * 100;
        // Use colors linearly around `green`.
        const minColor = '#e3f6cf';
        const maxColor = '#488503';
        const totalColorScale = $9f780b598065538f$var$prepareMapKey(maxTotal, minColor, maxColor, 'total', 'calls');
        // Set up key data for the scaled count per population tab.
        let maxScaledTotal = statesResults.reduce((agg, row)=>{
            const population = (0, $6a6288c2207a1f36$export$184c621c2471df58)(row.id);
            if (row && population && row.total / population > agg) agg = row.total / population;
            return agg;
        }, 0) * $9f780b598065538f$var$SCALED_POP_DENOMINATOR;
        let scaledPopDenominator = $9f780b598065538f$var$SCALED_POP_DENOMINATOR;
        // If call counts are too low, scale up the denominator!
        // It should be a multiple of 10.
        if (maxScaledTotal != 0) while(maxScaledTotal < 10){
            scaledPopDenominator *= 10;
            maxScaledTotal *= 10;
        }
        // The maximum color on the scale is a round number: multiple of 5.
        maxScaledTotal = Math.ceil(maxScaledTotal / 5) * 5;
        // Use colors linearly around `purple`
        const minScaledColor = '#d7d1de';
        const maxScaledColor = '#6319a8';
        const scaledColorScale = $9f780b598065538f$var$prepareMapKey(maxScaledTotal, minScaledColor, maxScaledColor, 'scaled', `per ${scaledPopDenominator.toLocaleString()}`);
        let activeMapTab = $9f780b598065538f$var$MAP_TABS.TOP_CALLS;
        const mapTabClicked = (mode)=>{
            activeMapTab = mode;
            Object.values($9f780b598065538f$var$MAP_TABS).forEach((id)=>{
                $b0ba9a260c958684$export$2e2bcd8739ae039(`button#tab_${id}`).attr('tabindex', id === mode ? 0 : -1).classed('selected', id === mode).attr('aria-selected', id === mode);
            });
            $b0ba9a260c958684$export$2e2bcd8739ae039('#state_footnote_scaled').attr('hidden', mode === $9f780b598065538f$var$MAP_TABS.SCALED_CALLS ? null : true);
            const mapSection = $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_section');
            switch(mode){
                case $9f780b598065538f$var$MAP_TABS.TOTAL_CALLS:
                    mapSection.select('div#state_map').select('svg').selectAll('path').attr('fill', (d)=>{
                        const stateResult = statesResults.find((state)=>state.id === d.id);
                        const stateTotal = stateResult ? stateResult.total : 0;
                        return totalColorScale(stateTotal);
                    });
                    mapSection.select('h2.detail_title').html(`Total calls per state, ${duration}`);
                    mapSection.select('div.description').html('The number of calls by state. Select a state in the dropdown for more details below.');
                    $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_key_box').select('div.title').html('Total calls per state*');
                    $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_key').select('svg#total').style('display', null);
                    $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_key').select('svg#scaled').style('display', 'none');
                    $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_key').select('ol').style('display', 'none');
                    break;
                case $9f780b598065538f$var$MAP_TABS.TOP_CALLS:
                    $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_key_box').select('div.title').html('Top Issue Per State*');
                    $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_key').select('ol').style('display', null);
                    $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_key').select('svg#total').style('display', 'none');
                    $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_key').select('svg#scaled').style('display', 'none');
                    mapSection.select('div#state_map').select('svg').selectAll('path').attr('fill', (d)=>{
                        const stateResult = statesResults.find((state)=>state.id === d.id);
                        const stateTopIssues = stateResult ? stateResult.issueCounts : [];
                        if (stateTopIssues && stateTopIssues.length > 0) return issueColor(stateTopIssues[0].issue_id);
                        return $9f780b598065538f$var$beeswarmDefaultColor;
                    });
                    mapSection.select('h2.detail_title').html(`Top issue per state, ${duration}`);
                    mapSection.select('div.description').html('The most-called issue by state. Select a state in the dropdown for more details below.');
                    break;
                case $9f780b598065538f$var$MAP_TABS.SCALED_CALLS:
                    mapSection.select('div#state_map').select('svg').selectAll('path').attr('fill', (d)=>{
                        const stateResult = statesResults.find((state)=>state.id === d.id);
                        const stateTotal = stateResult ? stateResult.total : 0;
                        return scaledColorScale(stateTotal / (0, $6a6288c2207a1f36$export$184c621c2471df58)(d.id) * scaledPopDenominator);
                    });
                    mapSection.select('h2.detail_title').html(`Calls per ${scaledPopDenominator.toLocaleString()} people, ${duration}`);
                    mapSection.select('div.description').html(`Calls per ${scaledPopDenominator.toLocaleString()} people by state. ` + `Select a state in the dropdown for more details below.`);
                    $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_key_box').select('div.title').html(`Calls per ${scaledPopDenominator.toLocaleString()} people per state*`);
                    $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_key').select('svg#total').style('display', 'none');
                    $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_key').select('svg#scaled').style('display', null);
                    $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_key').select('ol').style('display', 'none');
                    break;
                default:
                    console.error(`Unhandled map tab mode: ${mode}`);
                    break;
            }
            if (selectedState) {
                const state_node = mapSection.select(`path#state_${selectedState}`).node();
                const state_feature = data.find((s)=>s.id === selectedState);
                const state_name = state_feature ? state_feature.properties.name : 'Unknown';
                const state_results = statesResults.find((s)=>s.id === selectedState);
                const total_calls = state_results ? state_results.total : 0;
                const state_issues = state_results ? state_results.issueCounts : [];
                let labelText = '';
                switch(mode){
                    case $9f780b598065538f$var$MAP_TABS.TOTAL_CALLS:
                        labelText = `${total_calls.toLocaleString()} call${total_calls == 1 ? '' : 's'}`;
                        break;
                    case $9f780b598065538f$var$MAP_TABS.TOP_CALLS:
                        {
                            const topIssue = state_issues && state_issues.length > 0 ? state_issues[0] : {
                                name: 'No recorded calls'
                            };
                            labelText = topIssue.name;
                            break;
                        }
                    case $9f780b598065538f$var$MAP_TABS.SCALED_CALLS:
                        labelText = (0, $6a6288c2207a1f36$export$3b378a6955dba71a)(total_calls, selectedState, scaledPopDenominator);
                        break;
                    default:
                        console.error(`Unhandled map tab mode: ${mode}`);
                        break;
                }
                $9f780b598065538f$var$drawStateLabel(state_node, state_name, labelText, deselectState);
            }
        };
        // Toggles between the three map tabs on arrow events.
        const map_tabs = [
            {
                id: $9f780b598065538f$var$MAP_TABS.TOP_CALLS,
                clickFn: ()=>mapTabClicked($9f780b598065538f$var$MAP_TABS.TOP_CALLS)
            },
            {
                id: $9f780b598065538f$var$MAP_TABS.SCALED_CALLS,
                clickFn: ()=>mapTabClicked($9f780b598065538f$var$MAP_TABS.SCALED_CALLS)
            },
            {
                id: $9f780b598065538f$var$MAP_TABS.TOTAL_CALLS,
                clickFn: ()=>mapTabClicked($9f780b598065538f$var$MAP_TABS.TOTAL_CALLS)
            }
        ];
        const handleMapTabEvent = (event)=>{
            const targetId = event.currentTarget.id;
            const currentIndex = map_tabs.findIndex((t)=>`tab_${t.id}` === targetId);
            if (currentIndex !== -1) $9f780b598065538f$export$b93cca2b152532b9(event, map_tabs, currentIndex, (e, tab)=>tab.clickFn());
        };
        let selectedState = null;
        let initialSelected = false;
        const width = 630;
        const height = 400;
        const svg = $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map').append('svg').style('width', '100%').style('height', 'auto').attr('viewBox', `0 0 ${width} ${height}`).attr('title', 'Map showing states colored by top issue. Select a state above.').on('pointerleave', ()=>{
            group.selectAll('.state-highlight-clone').remove();
        });
        const path = $b96d7b82ad5f1f0a$export$2e2bcd8739ae039();
        // Use the path to plot the US map based on the geometry data.
        const group = svg.append('g').attr('width', width).attr('height', '100%').style('overflow', 'visible')// Hide from screen readers because full text is below, and in a div, and the map is redundant
        .attr('aria-hidden', true);
        // Add them to the dropdown.
        $b0ba9a260c958684$export$2e2bcd8739ae039('select#state_select').on('input', (event)=>{
            const selectElement = event.target;
            const state = selectElement.options[selectElement.selectedIndex].id;
            if (state !== 'none') selectState(state);
            else deselectState();
        }).selectAll('option').data(data).enter().append('option').attr('selected', (d)=>d.id === initialState ? 'true' : null).attr('id', (d)=>d.id).html((d)=>d.properties.name);
        const deselectState = (event = null)=>{
            $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map_label').attr('hidden', true);
            if (selectedState !== null) {
                $b0ba9a260c958684$export$2e2bcd8739ae039('select#state_select').selectAll('option').attr('selected', null);
                group.select(`path#state_${selectedState}`).transition().attr('stroke', '#fff').attr('stroke-width', 1);
                selectedState = null;
                if (event) event.stopPropagation();
            }
        };
        const selectState = (state, event = null)=>{
            if (selectedState === state) {
                deselectState(event);
                return;
            }
            if (selectedState !== null) deselectState(event);
            $b0ba9a260c958684$export$2e2bcd8739ae039('select#state_select').selectAll(`option#${state}`).attr('selected', true);
            selectedState = state;
            group.selectAll('.state-highlight-clone').remove();
            const state_path = group.select(`path#state_${selectedState}`);
            const state_node = state_path.node();
            if (state_node) // Bring to front.
            state_node.parentNode.appendChild(state_node);
            const state_feature = data.find((s)=>s.id === selectedState);
            const state_name = state_feature ? state_feature.properties.name : 'Unknown';
            const state_results = statesResults.find((s)=>s.id === state);
            const total_calls = state_results ? state_results.total : 0;
            const state_issues = state_results ? state_results.issueCounts : [];
            const topIssue = state_issues && state_issues.length > 0 ? state_issues[0] : {
                name: 'No recorded calls'
            };
            $b0ba9a260c958684$export$2e2bcd8739ae039('div#state_map').select('svg').attr('title', `${state}'s top: ${topIssue.name}. Map showing states colored by top issue. Select a state above.`);
            let labelText = '';
            switch(activeMapTab){
                case $9f780b598065538f$var$MAP_TABS.TOP_CALLS:
                    labelText = topIssue.name;
                    break;
                case $9f780b598065538f$var$MAP_TABS.SCALED_CALLS:
                    labelText = (0, $6a6288c2207a1f36$export$3b378a6955dba71a)(total_calls, state, scaledPopDenominator);
                    break;
                case $9f780b598065538f$var$MAP_TABS.TOTAL_CALLS:
                    labelText = `${total_calls.toLocaleString()} calls`;
                    break;
                default:
                    console.error(`Unhandled map tab: ${activeMapTab}`);
                    break;
            }
            if (state_node) {
                $9f780b598065538f$var$drawStateLabel(state_node, state_name, labelText, deselectState);
                state_path.transition().attr('stroke', $9f780b598065538f$var$selectedStateStroke).attr('stroke-width', 3);
            }
            redrawStateResults(state);
        };
        // Draw the states
        group.selectAll('path').data(data).enter().append('path').attr('transform', `translate(0, 0) scale(0.66, 0.66)`).attr('stroke', '#fff').attr('stroke-width', 1).attr('stroke-linecap', 'round').style('cursor', 'pointer').attr('id', (d)=>'state_' + d.id).attr('fill', $9f780b598065538f$var$beeswarmDefaultColor).attr('d', path).transition().delay(500).duration(1000).attr('fill', (d)=>{
            const stateResult = statesResults.find((state)=>state.id === d.id);
            const stateTopIssues = stateResult ? stateResult.issueCounts : [];
            if (stateTopIssues && stateTopIssues.length > 0) return issueColor(stateTopIssues[0].issue_id);
            // Default grey for no calls at all.
            return $9f780b598065538f$var$beeswarmDefaultColor;
        }).on('end', function() {
            // After animation ends, can set interaction listeners. If they go off in the
            // middle of the animation it won't complete.
            $b0ba9a260c958684$export$2e2bcd8739ae039('button#tab_top_calls').on('click', ()=>mapTabClicked($9f780b598065538f$var$MAP_TABS.TOP_CALLS)).on('keydown', handleMapTabEvent);
            $b0ba9a260c958684$export$2e2bcd8739ae039('button#tab_total_calls').on('click', ()=>mapTabClicked($9f780b598065538f$var$MAP_TABS.TOTAL_CALLS)).on('keydown', handleMapTabEvent);
            $b0ba9a260c958684$export$2e2bcd8739ae039('button#tab_scaled_calls').on('click', ()=>mapTabClicked($9f780b598065538f$var$MAP_TABS.SCALED_CALLS)).on('keydown', handleMapTabEvent);
            if (initialState !== null && !initialSelected) {
                initialSelected = true;
                selectState(initialState);
            }
            // Track the state over which the pointer went down. If the pointer
            // goes up on the same state it went down on, that's a click.
            let pointerDownState = '';
            $b0ba9a260c958684$export$2e2bcd8739ae039(this).on('pointerover', function(event, d) {
                if (selectedState === d.id) return;
                if (this.parentNode) {
                    const parent = $b0ba9a260c958684$export$2e2bcd8739ae039(this.parentNode);
                    parent.selectAll(`.clone-${d.id}`).remove();
                    // Add a clone with no pointer interaction to visually bring this to the front.
                    const clone = $b0ba9a260c958684$export$2e2bcd8739ae039(this).clone(false).attr('class', `state-highlight-clone clone-${d.id}`).style('pointer-events', 'none').attr('stroke', '#fff').attr('stroke-width', 1);
                    this.parentNode.appendChild(clone.node());
                    clone.transition().attr('stroke-width', 2);
                    if (selectedState !== null) {
                        const selectedStateNode = group.select(`path#state_${selectedState}`).node();
                        if (selectedStateNode) this.parentNode.appendChild(selectedStateNode);
                    }
                }
            }).on('pointerdown', function(event, d) {
                pointerDownState = d.id;
            }).on('pointerup', function(event, d) {
                if (pointerDownState === d.id) selectState(d.id);
                pointerDownState = '';
            }).on('pointerout', function(event, d) {
                if (this.parentNode) $b0ba9a260c958684$export$2e2bcd8739ae039(this.parentNode).selectAll(`.clone-${d.id}`).transition().attr('stroke-width', 1).remove();
            });
        });
        const zoom = $1ae8025c01b6f5ac$export$2e2bcd8739ae039().extent([
            [
                0,
                0
            ],
            [
                width,
                height
            ]
        ]).translateExtent([
            [
                -width / 2,
                0
            ],
            [
                width * 2,
                height
            ]
        ]).scaleExtent([
            1,
            4
        ]).on('zoom', zoomed);
        svg.call(zoom);
        function zoomed(event) {
            group.attr('transform', event.transform.toString());
            if (selectedState !== null) $9f780b598065538f$var$updateStateLabelPosition(group.select(`path#state_${selectedState}`).node());
        }
    });
};
const $9f780b598065538f$var$inBeeswarmRange = (count)=>{
    return count >= $9f780b598065538f$var$MIN_FOR_BEESWARM && count <= $9f780b598065538f$export$fc6f3774784d2638;
};
const $9f780b598065538f$var$inBarRange = (count)=>{
    return count >= $9f780b598065538f$var$MIN_FOR_BARS;
};
const $9f780b598065538f$export$ac7f0c3f46b07209 = (repData, finalDate, district, issueColor, issueIdToName, duration)=>{
    const repCard = $b0ba9a260c958684$export$2e2bcd8739ae039('div#reps_section').append('div').attr('id', `card_${repData.id}`).attr('class', 'dashboard_card').attr('aria-labelledby', `tab_${repData.id}`).attr('role', 'tabpanel');
    const leftSide = repCard.append('div');
    const totalCard = leftSide.append('div').attr('class', 'total_card');
    totalCard.append('h2').attr('class', 'subtitle_detail').html(`Total calls, ${duration}`);
    totalCard.append('div').attr('class', 'highlight').html(repData.total.toLocaleString());
    const totalSubtitle = totalCard.append('div').attr('class', 'subtitle');
    totalSubtitle.append('img').attr('src', repData.repInfo.photoURL).style('float', 'left').attr('alt', '');
    const nameSubtitleSection = totalSubtitle.append('div').style('overflow', 'hidden');
    const nameDiv = nameSubtitleSection.append('div').attr('class', 'subtitle_main').html(`${repData.repInfo.name}`).node();
    let fontSize = 33;
    // Example long name case: FL-25's house rep.
    while(nameDiv.scrollWidth > nameDiv.clientWidth)nameDiv.style.fontSize = `${fontSize--}px`;
    let nameSubtitle = repData.repInfo.area === 'US House' ? 'House Representative' : repData.repInfo.area === 'US Senate' ? 'Senator' : repData.repInfo.area;
    if (repData.repInfo.party && repData.repInfo.party.length > 0) nameSubtitle += ` (${repData.repInfo.party[0]}-${repData.repInfo.area === 'US House' ? district : repData.repInfo.state})`;
    else nameSubtitle += ` (${repData.repInfo.state})`;
    nameSubtitleSection.append('div').attr('class', 'subtitle_secondary').html(nameSubtitle);
    const repDetail = repCard.append('div').attr('class', 'detail');
    if (repData.total == 0) {
        repDetail.append('div').html(`There were no calls to ${repData.repInfo.name} recorded via 5 Calls, ${duration}. Make your voice heard: see <a href="/all">all active issues</a>.`);
        return;
    }
    // At this point, this rep does have at least 1 call made to them.
    repDetail.append('h2').attr('class', 'detail_title').html(`Most called issues for ${repData.repInfo.name}, ${duration}`);
    repDetail.append('div').attr('class', 'description').html(()=>{
        let text = ''; //`The most-called issues for ${repData.repInfo.name} ${duration} from 5 Calls.`;
        if ($9f780b598065538f$var$inBeeswarmRange(repData.total) || $9f780b598065538f$var$inBarRange(repData.total)) text += ' Select a call count to see it highlighted below.';
        return text;
    });
    repDetail.append('ol').attr('id', `${repData.id}_top`);
    const topFiveHolderSelector = `ol#${repData.id}_top`;
    $9f780b598065538f$var$drawTopFiveIssues(topFiveHolderSelector, repData.topIssues, repData.id, `${repData.repInfo.name}'s`, `to ${repData.repInfo.name}`, duration, issueColor, repData.total, $9f780b598065538f$var$inBeeswarmRange(repData.total) || $9f780b598065538f$var$inBarRange(repData.total));
    const pieSize = 80;
    const size = 60;
    const reachability = leftSide.append('div').attr('class', 'reachability');
    reachability.append('h2').attr('class', 'detail_title').html('Reachability');
    reachability.append('div').attr('class', 'description').style('margin-bottom', '10px').html(`${repData.repInfo.name}'s availability, ${duration}.`);
    const callResultsGroup = reachability.append('svg').attr('width', pieSize).attr('height', pieSize).attr('aria-hidden', true) // Empty alt text because this graphic is redundant with the percentages.
    .style('float', 'left').style('align-content', 'center').style('margin-right', '16px').append('g').attr('transform', `translate(${pieSize / 2}, ${pieSize / 2})`);
    callResultsGroup.append('path').attr('fill', '#807dba').attr('stroke', '#fff').attr('d', $dd52c4a96adfae77$export$2e2bcd8739ae039()({
        innerRadius: size / 2,
        outerRadius: pieSize / 2,
        startAngle: 0,
        endAngle: 2 * Math.PI * repData.percentContact
    }));
    callResultsGroup.append('path').attr('fill', '#6a51a3').attr('stroke', '#fff').attr('d', $dd52c4a96adfae77$export$2e2bcd8739ae039()({
        innerRadius: size / 2,
        outerRadius: pieSize / 2,
        startAngle: 2 * Math.PI * repData.percentContact,
        endAngle: 2 * Math.PI * (repData.percentVM + repData.percentContact)
    }));
    callResultsGroup.append('path').attr('fill', '#4a1486').attr('stroke', '#fff').attr('d', $dd52c4a96adfae77$export$2e2bcd8739ae039()({
        innerRadius: size / 2,
        outerRadius: pieSize / 2,
        startAngle: 2 * Math.PI * (repData.percentVM + repData.percentContact),
        endAngle: 2 * Math.PI
    }));
    const resultsTextHolder = reachability.append('div').attr('class', 'reachability_stats');
    resultsTextHolder.append('div').html(`<span class="results_contact">${(repData.percentContact * 100).toFixed(0)}%</span> answered`);
    resultsTextHolder.append('div').html(`<span class="results_vm">${(repData.percentVM * 100).toFixed(0)}%</span> voicemail`);
    resultsTextHolder.append('div').html(`<span class="results_unavailable">${(repData.percentUnavailable * 100).toFixed(0)}%</span> unavailable`);
    // Draw beeswarm or bars async so that they don't block rendering.
    window.setTimeout(()=>{
        const dateFormatter = new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: 'numeric'
        });
        const dayTotals = (repData.barSeries.length > 0 ? repData.barSeries[0] : []).map((d)=>({
                time: d.data[0],
                total: Array.from(d.data[1].values()).reduce((sum, item)=>sum + item.count, 0),
                dayMap: d.data[1]
            })).sort((a, b)=>a.time - b.time);
        if ($9f780b598065538f$var$inBarRange(repData.total)) {
            const barParent = repCard.append('div').attr('id', `barParent_${repData.id}`);
            $9f780b598065538f$var$drawBarChart(barParent, repData, dayTotals, issueIdToName, issueColor, new Date(finalDate), duration, dateFormatter, $9f780b598065538f$var$inBeeswarmRange(repData.total) ? repData.topIssues[0].issue_id : null);
        }
        if ($9f780b598065538f$var$inBeeswarmRange(repData.total)) {
            const beeParent = repCard.append('div').attr('id', `beeParent_${repData.id}`);
            $9f780b598065538f$var$drawBeeswarm(beeParent, repData, dayTotals, issueIdToName, issueColor, finalDate, duration, dateFormatter);
            // Default show beeswarm.
            repCard.select(`div#barParent_${repData.id}`).attr('hidden', true);
        }
        if ($9f780b598065538f$var$inBarRange(repData.total) || $9f780b598065538f$var$inBeeswarmRange(repData.total)) $9f780b598065538f$var$appendCallDetailsTable(repCard, repData, dayTotals, dateFormatter, $9f780b598065538f$var$inBeeswarmRange(repData.total) ? repData.topIssues[0].issue_id : null);
        const onIssueSelected = function(event, d) {
            if (!$9f780b598065538f$var$isValidActivation(event)) return;
            if (!(event instanceof KeyboardEvent) && event.target === event.currentTarget) event.stopPropagation();
            if (selectedIssueId === d.issue_id) {
                // deselect
                const repTopIssues = new Set(repData.topIssues.map((issue)=>issue.issue_id));
                selectedIssueId = null;
                $b0ba9a260c958684$export$2e2bcd8739ae039(this).classed('selected', false).style('background-color', null).style('color', issueColor(d.issue_id)).attr('aria-pressed', false);
                $b0ba9a260c958684$export$2e2bcd8739ae039(`svg#beeswarm_svg_${repData.id}`).selectAll('circle').transition().delay(0).style('fill', $9f780b598065538f$var$beeswarmDefaultColor);
                $b0ba9a260c958684$export$2e2bcd8739ae039(`svg#bar_svg_${repData.id}`).select('g#bar_group').selectAll('rect').transition().delay(0).style('fill', (b)=>repTopIssues.has(b.key) ? issueColor(b.key) : $9f780b598065538f$var$defaultColor).style('stroke', (b)=>repTopIssues.has(b.key) ? issueColor(b.key) : $9f780b598065538f$var$defaultColor);
                $ee6de28bce72be65$export$2e2bcd8739ae039(`div#dot_key_${repData.id}`).style('display', 'none');
                // Update the dynamic table data for deselect
                const table = repCard.select(`.chart-data-table`);
                if (!table.empty()) {
                    table.select('.selected-issue-header').style('display', 'none').text('');
                    table.selectAll('.selected-issue-value').style('display', 'none').text('');
                }
            } else {
                // select
                selectedIssueId = d.issue_id;
                // Ensure everything else is deselected visually.
                $b0ba9a260c958684$export$2e2bcd8739ae039(topFiveHolderSelector).selectAll('button.stat').classed('selected', false).style('background-color', null).style('color', (i)=>issueColor(i.issue_id)).attr('aria-pressed', false);
                // Select just this one visually.
                $b0ba9a260c958684$export$2e2bcd8739ae039(this).classed('selected', true).style('background-color', issueColor(d.issue_id)).style('color', null).attr('aria-pressed', true);
                $b0ba9a260c958684$export$2e2bcd8739ae039(`svg#beeswarm_svg_${repData.id}`).selectAll('circle').transition().delay(0).style('fill', (d)=>d.data.issue_id === selectedIssueId ? issueColor(d.data.issue_id) : $9f780b598065538f$var$beeswarmDefaultColor);
                $b0ba9a260c958684$export$2e2bcd8739ae039(`svg#bar_svg_${repData.id}`).select('g#bar_group').selectAll('rect').transition().delay(0).style('fill', (d)=>d.key === selectedIssueId ? issueColor(d.key) : $9f780b598065538f$var$defaultColor).style('stroke', (d)=>d.key === selectedIssueId ? issueColor(d.key) : $9f780b598065538f$var$defaultColor);
                $ee6de28bce72be65$export$2e2bcd8739ae039(`div#dot_key_${repData.id}`).style('display', null).style('--dot-color', issueColor(d.issue_id)).html(`<i>${repData.topIssues.find((i)=>i.issue_id === d.issue_id)?.name}</i>`);
                // Update the dynamic table data for select
                const table = repCard.select(`.chart-data-table`);
                if (!table.empty()) {
                    const issueName = repData.topIssues.find((i)=>i.issue_id === d.issue_id)?.name || 'Selected Issue';
                    table.select('.selected-issue-header').style('display', null).text(issueName);
                    table.selectAll('.selected-issue-value').style('display', null).text((b)=>b.dayMap?.get(selectedIssueId)?.count || 0);
                }
            }
        };
        // Only show beeswarm if there's enough calls, but not if there's so many we will show the bar chart only.
        let selectedIssueId = $9f780b598065538f$var$inBeeswarmRange(repData.total) ? repData.topIssues[0].issue_id : null;
        const showCallsBtns = $b0ba9a260c958684$export$2e2bcd8739ae039(topFiveHolderSelector).selectAll('button.stat');
        showCallsBtns.on('pointerover', function(_, d) {
            if (selectedIssueId !== d.issue_id) {
                $b0ba9a260c958684$export$2e2bcd8739ae039(this).classed('selected', true).style('background-color', issueColor(d.issue_id)).style('color', null).attr('aria-pressed', true);
                $b0ba9a260c958684$export$2e2bcd8739ae039(`svg#beeswarm_svg_${repData.id}`).selectAll('circle').transition().delay(0).style('fill', (b)=>b.data.issue_id === selectedIssueId || b.data.issue_id === d.issue_id ? issueColor(b.data.issue_id) : $9f780b598065538f$var$beeswarmDefaultColor);
                $b0ba9a260c958684$export$2e2bcd8739ae039(`svg#bar_svg_${repData.id}`).select('g#bar_group').selectAll('rect').transition().delay(0).style('fill', (b)=>b.key === selectedIssueId || b.key === d.issue_id ? issueColor(b.key) : $9f780b598065538f$var$defaultColor).style('stroke', (b)=>b.key === selectedIssueId || b.key === d.issue_id ? issueColor(b.key) : $9f780b598065538f$var$defaultColor);
            }
        }).on('click', onIssueSelected).on('keydown', onIssueSelected).on('pointerout', function(_, d) {
            if (selectedIssueId !== d.issue_id) {
                $b0ba9a260c958684$export$2e2bcd8739ae039(this).classed('selected', false).style('background-color', null).style('color', issueColor(d.issue_id)).attr('aria-pressed', false);
                $b0ba9a260c958684$export$2e2bcd8739ae039(`svg#beeswarm_svg_${repData.id}`).selectAll('circle').transition().delay(0).style('fill', (d)=>d.data.issue_id === selectedIssueId ? issueColor(d.data.issue_id) : $9f780b598065538f$var$beeswarmDefaultColor);
                if (selectedIssueId === null) {
                    // Nothing is selected, reset to all colors on pointerout.
                    const repTopIssues = new Set(repData.topIssues.map((issue)=>issue.issue_id));
                    $b0ba9a260c958684$export$2e2bcd8739ae039(`svg#bar_svg_${repData.id}`).select('g#bar_group').selectAll('rect').transition().delay(0).style('fill', (b)=>repTopIssues.has(b.key) ? issueColor(b.key) : $9f780b598065538f$var$defaultColor).style('stroke', (b)=>repTopIssues.has(b.key) ? issueColor(b.key) : $9f780b598065538f$var$defaultColor);
                } else $b0ba9a260c958684$export$2e2bcd8739ae039(`svg#bar_svg_${repData.id}`).select('g#bar_group').selectAll('rect').transition().delay(0).style('fill', (b)=>b.key === selectedIssueId ? issueColor(b.key) : $9f780b598065538f$var$defaultColor).style('stroke', (b)=>b.key === selectedIssueId ? issueColor(b.key) : $9f780b598065538f$var$defaultColor);
            }
        });
        // Perform the initial selection.
        showCallsBtns.classed('selected', (d)=>d.issue_id === selectedIssueId).style('background-color', (d)=>d.issue_id === selectedIssueId ? issueColor(d.issue_id) : null).style('color', (d)=>d.issue_id === selectedIssueId ? null : issueColor(d.issue_id)).attr('aria-pressed', (d)=>d.issue_id === selectedIssueId);
    }, 0);
};
const $9f780b598065538f$var$appendGraphicsSection = (parentDiv, repData, duration)=>{
    parentDiv.attr('class', 'graphic_section');
    const description = parentDiv.append('div').attr('class', 'description');
    description.append('h2').html(`Calls to ${repData.repInfo.name}, ${duration}`);
    return description;
};
const $9f780b598065538f$var$drawBarChart = (parentDiv, repData, dayTotals, issueIdToName, issueColor, finalDate, duration, dateFormatter, initialIssueId)=>{
    const description = $9f780b598065538f$var$appendGraphicsSection(parentDiv, repData, duration);
    const paragraph = description.append('div');
    paragraph.append('span').html("Select call count above to highlight. Today's calls are still coming in! "); // TODO: Add sonification of bars.
    if ($9f780b598065538f$var$inBeeswarmRange(repData.total)) paragraph.append('button').attr('id', 'barOrBeeButton').html('View calls as dots').on('click', ()=>{
        $b0ba9a260c958684$export$2e2bcd8739ae039(`#beeParent_${repData.id}`).attr('hidden', null);
        $b0ba9a260c958684$export$2e2bcd8739ae039(`#barParent_${repData.id}`).attr('hidden', true);
    });
    const dotsKey = description.append('div').attr('class', 'dot_key');
    dotsKey.append('div').attr('class', 'dot').html('Other issues');
    dotsKey.append('div').attr('class', 'dot').attr('id', `dot_key_${repData.id}`).style('--dot-color', issueColor(initialIssueId)).html(initialIssueId ? issueIdToName[initialIssueId] : '').style('display', initialIssueId ? null : 'none');
    const svgBox = parentDiv.append('div').style('position', 'relative');
    svgBox.append('div').attr('id', 'dot_label').attr('class', 'overlayBox topLabel absolute').attr('hidden', true).append('div').attr('class', 'issue_long_name');
    $9f780b598065538f$var$drawBarChartSvg(parentDiv, svgBox, repData, dayTotals, issueIdToName, issueColor, finalDate, dateFormatter, initialIssueId);
};
const $9f780b598065538f$var$drawBarChartSvg = (parentDiv, svgBox, repData, dayTotals, issueIdToName, issueColor, finalDate, dateFormatter, initialIssueId)=>{
    if (!parentDiv.select(`svg#bar_svg_${repData.id}`).empty()) return;
    // Today
    finalDate.setHours(0, 0, 0, 0);
    const earliestDate = finalDate.getTime() - 518400000;
    const barChartScale = $291a8ccd3c3ae926$export$2e2bcd8739ae039().domain([
        earliestDate,
        finalDate.getTime()
    ]).range([
        40,
        $9f780b598065538f$export$ad5e43985b0d4023 - 45
    ]).nice();
    const svg = svgBox.append('svg').style('width', '100%').style('height', 'auto').attr('id', 'bar_svg_' + repData.id).style('margin-bottom', '1.5rem').style('overflow', 'hidden').on('pointerleave', ()=>{
        group.selectAll('.bar-highlight-clone').remove();
        parentDiv.select('div#dot_label').attr('hidden', true);
    });
    svg.attr('title', `Bars representing ${repData.total} calls, colored by issue, ordered by time on the x axis.`);
    const fillColor = $9f780b598065538f$var$defaultColor;
    const repTopIssues = new Set(repData.topIssues.map((issue)=>issue.issue_id));
    const selectBar = function(_, bar) {
        // Bounding box of the rect.
        const boundingBox = this.getBBox();
        const matrix = this.getScreenCTM();
        const point = this.ownerSVGElement.createSVGPoint();
        point.x = boundingBox.x + boundingBox.width * 2 / 3;
        point.y = boundingBox.y + boundingBox.height / 2;
        const screenCoords = point.matrixTransform(matrix);
        screenCoords.y += 4; // Slightly below
        // Bounding box of the SVG.
        const svgBb = this.parentElement.parentElement.getBoundingClientRect();
        const yCoord = screenCoords.y - svgBb.y;
        const xCoord = screenCoords.x - svgBb.x;
        const parentGroup = $b0ba9a260c958684$export$2e2bcd8739ae039(this.parentElement.parentElement);
        parentGroup.selectAll('.bar-highlight-clone').remove();
        // Bring a copy to the front visually.
        const clone = $b0ba9a260c958684$export$2e2bcd8739ae039(this).clone(false).attr('class', 'bar-highlight-clone').style('pointer-events', 'none').style('stroke', '#333');
        parentGroup.node().appendChild(clone.node());
        const count = bar.data[1].get(bar.key).count;
        const total = dayTotals.find((d)=>d.time === bar.data[0])?.total;
        parentDiv.select('div#dot_label').attr('hidden', null).style('top', `${yCoord}px`).style('left', `${xCoord}px`).select('div.issue_long_name').html(`${dateFormatter.format(new Date(bar.data[0] * 1000))}: ${total} calls.<br/>${count} for ${issueIdToName[bar.key]}`);
    };
    const width = $9f780b598065538f$export$ad5e43985b0d4023;
    const barWidth = width / 20;
    const y = $4e8668784d878b46$export$2e2bcd8739ae039().domain([
        0,
        $cc3dca62b9e77dd8$export$2e2bcd8739ae039(repData.barSeries, (d)=>$cc3dca62b9e77dd8$export$2e2bcd8739ae039(d, (d)=>d[1]))
    ]).rangeRound([
        $9f780b598065538f$export$ad5e43985b0d4023 / 3,
        0
    ]); // Target height
    svg.append('g').attr('aria-hidden', true).attr('transform', `translate(${20}, 0)`).call($b479890018e3ebe0$export$2749afb169a520d2(y).ticks(6, 's').tickSize(-$9f780b598065538f$export$ad5e43985b0d4023 + 25)).call((g)=>{
        g.selectAll('.domain').remove();
        g.selectAll('.tick line').attr('stroke', '#e6e6e6');
    });
    // Add outlines on the background.
    svg.append('g').attr('aria-hidden', true).selectAll('rect').data(dayTotals).enter().append('rect').attr('x', (d)=>barChartScale(d.time * 1000) - barWidth / 2).attr('width', barWidth).attr('y', (d)=>y(d.total)).attr('height', (d)=>y(0) - y(d.total)).attr('fill', 'none').attr('stroke', '#555').attr('stroke-width', 2).attr('stroke-dasharray', (d)=>new Date(d.time * 1000).getDate() === new Date().getDate() ? '2 2' : 'none');
    const group = svg.append('g').attr('id', 'bar_group');
    group.selectAll().data(repData.barSeries).enter().append('g').selectAll('rect').data((D)=>D.map((d)=>(d.key = D.key, d)), (d)=>d.key + d.time).enter().append('rect').attr('x', (d)=>barChartScale(d.data[0] * 1000) - barWidth / 2).attr('y', (d)=>y(d[1])).attr('height', (d)=>y(d[0]) - y(d[1])).attr('width', barWidth).on('pointerover', selectBar).on('click', selectBar).on('pointerout', function() {
        if (this.parentElement && this.parentElement.parentElement) $b0ba9a260c958684$export$2e2bcd8739ae039(this.parentElement.parentElement).selectAll('.bar-highlight-clone').remove();
        parentDiv.select('div#dot_label').attr('hidden', true);
    }).transition().delay(0).attr('stroke', (d)=>{
        if (initialIssueId) return d.key === initialIssueId ? issueColor(d.key) : fillColor;
        else return repTopIssues.has(d.key) ? issueColor(d.key) : fillColor;
    }).attr('fill', (d)=>{
        if (initialIssueId) return d.key === initialIssueId ? issueColor(d.key) : fillColor;
        else return repTopIssues.has(d.key) ? issueColor(d.key) : fillColor;
    });
    const height = group.node().getBBox().height;
    const axisHeight = 20;
    svg.attr('viewBox', `0 -1 ${width} ${height + axisHeight}`);
    // Add the axis.
    svg.append('g').attr('aria-hidden', true).attr('transform', `translate(0,${height})`).call($b479890018e3ebe0$export$e5cb22533a15e72e(barChartScale).tickSizeOuter(0).ticks($886d8e53d47ad67a$export$8888529b966033e5).tickFormat($149f3ba5b2472001$export$94f4d87fad5dcf9a('%a %-d'))).call((g)=>{
        g.selectAll('.domain').remove();
    });
};
const $9f780b598065538f$var$appendCallDetailsTable = (parentDiv, repData, dayTotals, dateFormatter, initialIssueId)=>{
    const details = parentDiv.append('details').attr('class', 'chart-data-details').attr('id', `table_details_${repData.id}`);
    details.append('summary').text('Show call data table');
    const table = details.append('table').attr('class', 'chart-data-table').attr('id', `data_table_${repData.id}`);
    table.append('caption').text(`Daily call counts to ${repData.repInfo.name}. Select a call count above for details.`);
    const theadRow = table.append('thead').append('tr');
    theadRow.append('th').attr('scope', 'col').style('width', '100px').text('Date');
    theadRow.append('th').attr('scope', 'col').style('width', '120px').text('Total Calls');
    theadRow.append('th').attr('scope', 'col').attr('class', 'selected-issue-header').style('display', initialIssueId !== null ? null : 'none').text(initialIssueId !== null ? repData.topIssues.find((i)=>i.issue_id === initialIssueId)?.name || 'Selected Issue' : null);
    const tbody = table.append('tbody');
    const rows = tbody.selectAll('tr').data(dayTotals).enter().append('tr');
    rows.append('td').text((d)=>dateFormatter.format(new Date(d.time * 1000)));
    rows.append('td').text((d)=>d.total);
    rows.append('td').attr('class', 'selected-issue-value').style('display', initialIssueId !== null ? null : 'none').text((d)=>initialIssueId !== null ? d.dayMap?.get(initialIssueId)?.count || 0 : '');
};
const $9f780b598065538f$var$drawBeeswarm = (parentDiv, repData, dayTotals, issueIdToName, issueColor, finalDate, duration, dateFormatter)=>{
    const beeswarmScale = $291a8ccd3c3ae926$export$2e2bcd8739ae039().domain([
        finalDate - 604800000,
        finalDate
    ]).range([
        25,
        $9f780b598065538f$export$ad5e43985b0d4023 - 25
    ]).nice();
    // Construct beeswarm data on-demand.
    repData.beeswarm = (0, $6a6288c2207a1f36$export$853d048a5fc76514)().y(300).x((e)=>beeswarmScale(new Date(e.time * 1000))) // seconds since epoch --> ms
    .r(repData.total > 500 ? 3 : repData.total > 300 ? 4 : repData.total > 100 ? 5 : repData.total > 50 ? 6 : 10)(repData.callResults);
    const description = $9f780b598065538f$var$appendGraphicsSection(parentDiv, repData, duration);
    let renderFrameId = null;
    let audioContext = null;
    const startSonification = function() {
        $b0ba9a260c958684$export$2e2bcd8739ae039(`button#sonify_btn_${repData.id}`).classed('active', true).on('click', stopSonification);
        const startAudioTime = 0;
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const animateD3Update = ()=>{
            const now = audioContext.currentTime;
            const elapsed = now - startAudioTime;
            const currentProgress = elapsed / (0, $de86a1079a091ab5$export$b339e6d5fd943d40);
            if (currentProgress >= 1) {
                // Playback is complete.
                $b0ba9a260c958684$export$2e2bcd8739ae039('svg#beeswarm_svg_' + repData.id).selectAll('g#playbackLine').select('line').attr('stroke', 'none');
                $ee6de28bce72be65$export$2e2bcd8739ae039(`button#sonify_btn_${repData.id}`).on('click', startSonification).classed('active', false);
                return;
            }
            $b0ba9a260c958684$export$2e2bcd8739ae039('svg#beeswarm_svg_' + repData.id).selectAll('g#playbackLine').attr('transform', `translate(${currentProgress * $9f780b598065538f$export$ad5e43985b0d4023}, 0)`);
            renderFrameId = requestAnimationFrame(animateD3Update);
        };
        $b0ba9a260c958684$export$2e2bcd8739ae039('svg#beeswarm_svg_' + repData.id).selectAll('g#playbackLine').select('line').attr('stroke', 'red');
        (0, $de86a1079a091ab5$export$ab6bf2d526806d73)(audioContext, repData.beeswarm, beeswarmScale, $9f780b598065538f$export$ad5e43985b0d4023);
        renderFrameId = requestAnimationFrame(animateD3Update);
    };
    const stopSonification = function() {
        if (renderFrameId) {
            cancelAnimationFrame(renderFrameId);
            renderFrameId = null;
        }
        if (audioContext) {
            audioContext.close();
            audioContext = null;
        }
        $b0ba9a260c958684$export$2e2bcd8739ae039('svg#beeswarm_svg_' + repData.id).selectAll('g#playbackLine').select('line').attr('stroke', 'none');
        $ee6de28bce72be65$export$2e2bcd8739ae039(`button#sonify_btn_${repData.id}`).on('click', startSonification).classed('active', false);
    };
    const paragraph = description.append('div');
    paragraph.append('span').html('Select call count above to highlight');
    if (repData.total <= $9f780b598065538f$var$MAX_FOR_SONIFICATION) {
        // Only add button to listen if there's a reasonable number of calls. Otherwise it's just
        // way too noisy.
        paragraph.append('span').html(' or ');
        paragraph.append('button').attr('id', `sonify_btn_${repData.id}`).html('listen').on('click', startSonification);
        paragraph.append('span').html(' to this chart. ');
    } else paragraph.append('span').html('. ');
    if ($9f780b598065538f$var$inBarRange(repData.total)) paragraph.append('button').attr('id', 'barOrBeeButton').html('View as bar chart').on('click', ()=>{
        $b0ba9a260c958684$export$2e2bcd8739ae039(`#beeParent_${repData.id}`).attr('hidden', true);
        $b0ba9a260c958684$export$2e2bcd8739ae039(`#barParent_${repData.id}`).attr('hidden', null);
    });
    const dotsKey = description.append('div').attr('class', 'dot_key');
    dotsKey.append('div').attr('class', 'dot').attr('aria-label', 'grey dot (lower pitch)').html('One call');
    dotsKey.append('div').attr('class', 'dot').attr('aria-label', 'colored dot (high pitch)').attr('id', `dot_key_${repData.id}`).style('--dot-color', issueColor(repData.topIssues[0].issue_id)).html(`<i>${repData.topIssues[0].name}</i>`);
    const svgBox = parentDiv.append('div').style('position', 'relative');
    svgBox.append('div').attr('id', 'dot_label').attr('class', 'overlayBox topLabel absolute').attr('hidden', true).append('div').attr('class', 'issue_long_name');
    // TODO maybe append close button if clicking makes it stay up.
    /**
   * Called when a dot on the beeswarm chart is selected by hover or click.
   * @param _ The event that caused the dot to be selected
   * @param dot The beeswarm node that was selected
   */ const selectDot = function(_, dot) {
        const parent = $b0ba9a260c958684$export$2e2bcd8739ae039(this.parentElement);
        parent.selectAll('.dot-highlight-clone').remove();
        // Bring a copy to the front visually.
        const clone = $b0ba9a260c958684$export$2e2bcd8739ae039(this).clone(false).attr('class', 'dot-highlight-clone').style('pointer-events', 'none').attr('stroke', '#333');
        parent.node().appendChild(clone.node());
        // Bounding box of the dot.
        const boundingBox = this.getBBox();
        const matrix = this.getScreenCTM();
        const point = this.ownerSVGElement.createSVGPoint();
        point.x = boundingBox.x + boundingBox.width / 2;
        point.y = boundingBox.y + boundingBox.height;
        const screenCoords = point.matrixTransform(matrix);
        screenCoords.x -= 28; // Has to do with the tab on the overlay box
        screenCoords.y += 4; // Slightly below
        // Bounding box of the SVG.
        const svgBb = this.parentElement.parentElement.getBoundingClientRect();
        const yCoord = screenCoords.y - svgBb.y;
        const xCoord = screenCoords.x - svgBb.x;
        parentDiv.select('div#dot_label').attr('hidden', null).style('top', `${yCoord}px`).style('left', `${xCoord}px`).select('div.issue_long_name')// Can't append every time! but this does get the :after working.
        .html(`${dateFormatter.format(new Date(dot.data.time * 1000))}: ${issueIdToName[dot.data.issue_id]}`);
    };
    const svg = svgBox.append('svg').style('width', '100%').style('height', 'auto').attr('id', 'beeswarm_svg_' + repData.id).style('margin-bottom', '1.5rem').style('overflow', 'visible').on('pointerleave', ()=>{
        group.selectAll('.dot-highlight-clone').remove();
        parentDiv.select('div#dot_label').attr('hidden', true);
    });
    if (!$9f780b598065538f$var$inBeeswarmRange(repData.total)) {
        // Skip drawing beeswarm.
        svg.attr('width', 0).attr('height', 0).attr('hidden', true);
        return;
    }
    svg.attr('title', `${repData.total} dots representing calls, ordered by time on the x axis.`);
    const initialIssueId = repData.topIssues[0].issue_id;
    const group = svg.append('g').attr('aria-hidden', true) // Not useful for screen readers
    .attr('id', 'beeswarm_g_' + repData.id);
    const middle = $9f780b598065538f$export$ad5e43985b0d4023 / 2;
    group.selectAll('circle').data(repData.beeswarm, // We've added the 'id' field to the call count to allow for transitions.
    (r)=>r.data.id).enter().append('circle').attr('stroke', `#fff4`).attr('cx', (d)=>d.x).attr('cy', (d)=>d.y).attr('r', (d)=>d.r).style('fill', $9f780b598065538f$var$beeswarmDefaultColor).on('pointerover', selectDot).on('click', selectDot).on('pointerout', function() {
        if (this.parentElement) $b0ba9a260c958684$export$2e2bcd8739ae039(this.parentElement).selectAll('.dot-highlight-clone').remove();
        parentDiv.select('div#dot_label').attr('hidden', true);
    }).transition().delay(0).style('fill', (d)=>initialIssueId === d.data.issue_id ? issueColor(d.data.issue_id) : $9f780b598065538f$var$beeswarmDefaultColor);
    const height = group.node().getBBox().height;
    const axisHeight = 20;
    group.attr('transform', `translate(0, -${middle - height / 2 - 1})`);
    svg.append('g').attr('id', 'playbackLine').append('line').attr('stroke', 'none').attr('stroke-width', '2').attr('x0', 0).attr('x1', 0).attr('y0', 0).attr('y1', height);
    svg.attr('viewBox', `0 0 ${$9f780b598065538f$export$ad5e43985b0d4023} ${height + axisHeight}`);
    // Add the axis.
    svg.append('g').attr('transform', `translate(0,${height})`).call($b479890018e3ebe0$export$e5cb22533a15e72e(beeswarmScale).tickSizeOuter(0).ticks($886d8e53d47ad67a$export$8888529b966033e5).tickFormat($149f3ba5b2472001$export$94f4d87fad5dcf9a('%a %-d')));
};
const $9f780b598065538f$var$isValidActivation = (event)=>{
    if (event instanceof KeyboardEvent) {
        if ((event.key === ' ' || event.key === 'Enter') && event.target === event.currentTarget) {
            event.preventDefault();
            return true;
        }
        return false;
    }
    // True for all non-keyboard events (mouse events).
    return true;
};
const $9f780b598065538f$export$b93cca2b152532b9 = (event, tabs, currentIndex, onSelect)=>{
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        // Find the next or previous tab
        const increment = event.key === 'ArrowLeft' ? -1 : 1;
        const nextIndex = (currentIndex + increment + tabs.length) % tabs.length;
        const nextTab = tabs[nextIndex];
        onSelect(event, nextTab);
        // Focus the new tab
        const buttonNode = $b0ba9a260c958684$export$2e2bcd8739ae039(`button#tab_${nextTab.id}`).node();
        buttonNode?.focus();
    }
};


const $7f4297784c6cf5da$var$defaultUsa = {
    id: 'usa',
    name: 'USA',
    total: 0,
    issueCounts: []
};
const $7f4297784c6cf5da$var$defaultUsaSummary = {
    usa: $7f4297784c6cf5da$var$defaultUsa,
    states: []
};
const $7f4297784c6cf5da$var$Dashboard = ()=>{
    const [usaData, setUsaData] = (0, $gIfym.useState)($7f4297784c6cf5da$var$defaultUsaSummary);
    const [repsData, setRepsData] = (0, $gIfym.useState)([]);
    const [district, setDistrict] = (0, $gIfym.useState)('');
    const [isLoading, setIsLoading] = (0, $gIfym.useState)(true);
    const [isError, setIsError] = (0, $gIfym.useState)(false);
    const isDrawn = (0, $gIfym.useRef)(false);
    (0, $gIfym.useEffect)(()=>{
        let active = true;
        async function requestDashboardData() {
            let districtId = (0, $6a6288c2207a1f36$export$1cde4b99c1c83f07)(new URLSearchParams(window.location.search), window.localStorage);
            let usaSummaryData = null;
            let repsSummaryData = null;
            try {
                if (districtId === null || districtId === undefined || districtId.length === 0) {
                    usaSummaryData = await (0, $c6a51ca48f202faf$export$73d276c9bf905e2e)().catch(()=>null);
                    districtId = '';
                } else [usaSummaryData, repsSummaryData] = await Promise.all([
                    (0, $c6a51ca48f202faf$export$73d276c9bf905e2e)().catch(()=>null),
                    (0, $c6a51ca48f202faf$export$de7b4a26c96c15c6)(districtId).catch(()=>null)
                ]);
            } catch  {
                if (active) {
                    setIsError(true);
                    setIsLoading(false);
                }
                return;
            }
            if (!active) return;
            if (usaSummaryData === null) {
                setIsError(true);
                setIsLoading(false);
                return;
            }
            const processedReps = (0, $6a6288c2207a1f36$export$5daf5a22d06b9116)(repsSummaryData, (0, $9f780b598065538f$export$fc6f3774784d2638));
            setUsaData(usaSummaryData);
            setRepsData(processedReps);
            setDistrict(districtId);
            setIsLoading(false);
        }
        requestDashboardData();
        // Sent by the location page.
        const handleUpdateReps = ()=>{
            // This is a bit of a hack; would be better to just pull in new
            // reps data, but first must detangle loading reps data from USA data.
            window.location.reload();
        };
        document.addEventListener($58e79092af177c1d$export$7ff69bf5c61582bf.UPDATE_REPS, handleUpdateReps);
        return ()=>{
            active = false;
            document.removeEventListener($58e79092af177c1d$export$7ff69bf5c61582bf.UPDATE_REPS, handleUpdateReps);
        };
    }, []);
    (0, $gIfym.useEffect)(()=>{
        if (isLoading) return;
        if (!usaData || usaData.states.length === 0 || !usaData.usa || usaData.usa.total === 0) return;
        if (isDrawn.current) return;
        isDrawn.current = true;
        const hasRepsData = repsData.length > 0;
        const duration = 'last 7 days';
        const { topIssueIds: topIssueIds, issueIdToName: issueIdToName } = (0, $6a6288c2207a1f36$export$a48ea3e6cd4672ef)(usaData);
        // Use consistent coloring throughout the dashboard.
        const issueColor = $e5cfb632324bd21a$export$2e2bcd8739ae039([
            (0, $9f780b598065538f$export$4dc1b11d18d63ea),
            (0, $9f780b598065538f$export$e13cce2a2d16a9d4),
            '#66a61e',
            '#e7298a',
            '#e6ab02',
            '#a6761d',
            '#1b9e77',
            (0, $9f780b598065538f$export$e7a419f45e0cacee),
            (0, $9f780b598065538f$export$875fee6b8c75cb95)
        ]).domain(topIssueIds);
        const top_tabs = [];
        top_tabs.push({
            index: 0,
            name: 'Your Reps',
            id: 'your_reps',
            selected: hasRepsData,
            drawn: false,
            controls: 'reps_section'
        });
        top_tabs.push({
            index: 1,
            name: 'Nationwide',
            id: 'usa',
            selected: !hasRepsData,
            drawn: false,
            controls: 'card_usa'
        });
        const tabs = [];
        if (repsData.length > 0) {
            let index = 0;
            repsData.forEach((r)=>tabs.push({
                    index: index++,
                    name: r.repInfo.name,
                    id: r.id,
                    selected: false,
                    drawn: false,
                    controls: `card_${r.id}`
                }));
            tabs[0].selected = true;
        }
        const handleTopNavClick = function(_, newTab) {
            top_tabs.forEach((t)=>t.selected = false);
            newTab.selected = true;
            topNavButtons.attr('aria-selected', (t)=>t.selected).attr('tabindex', (t)=>t.selected ? 0 : -1).attr('class', (t)=>t.selected ? 'selected' : null);
            if (newTab.id === 'usa') {
                $b0ba9a260c958684$export$2e2bcd8739ae039('div#reps_section').style('display', 'none');
                $b0ba9a260c958684$export$2e2bcd8739ae039(`div#card_usa.dashboard_card`).style('display', null);
                if (!top_tabs[1].drawn) {
                    // TODO: lookup instead of index for less brittle.
                    // Draw it the first time it is needed.
                    // TODO: Check with PR, DC that this works as expected.
                    let initialState = null;
                    if (district && district.length > 0) initialState = district.split('-')[0];
                    (0, $9f780b598065538f$export$5474aa916fd55b45)(usaData, initialState, issueColor, duration);
                    top_tabs[1].drawn = true;
                }
                $b0ba9a260c958684$export$2e2bcd8739ae039('div#nav').style('visibility', 'hidden').attr('aria-hidden', true);
            } else {
                $b0ba9a260c958684$export$2e2bcd8739ae039('div#reps_section').style('display', null);
                $b0ba9a260c958684$export$2e2bcd8739ae039(`div#card_usa.dashboard_card`).style('display', 'none');
                $b0ba9a260c958684$export$2e2bcd8739ae039('div#nav').style('visibility', 'visible').attr('aria-hidden', null);
                if (hasRepsData) {
                    const selectedRepId = tabs.find((t)=>t.selected === true).id;
                    $b0ba9a260c958684$export$2e2bcd8739ae039(`div#card_${selectedRepId}.dashboard_card`).style('display', null);
                } else if (district && district.length > 0) document.getElementById('location_error').removeAttribute('hidden');
                else document.getElementById('location_picker').removeAttribute('hidden');
            }
        };
        // Clean up any existing top nav buttons to prevent duplicates
        $b0ba9a260c958684$export$2e2bcd8739ae039('div#topNav').selectAll('*').remove();
        const topNavButtons = $b0ba9a260c958684$export$2e2bcd8739ae039('div#topNav').selectAll('button').data(top_tabs).enter().append('button').attr('role', 'tab').attr('aria-selected', (t)=>t.selected).attr('aria-controls', (t)=>t.controls).attr('tabindex', (t)=>t.selected ? 0 : -1).attr('id', (t)=>`tab_${t.id}`).attr('class', (t)=>t.selected ? 'selected' : null).html((t)=>t.name).on('keydown', function(event, t) {
            (0, $9f780b598065538f$export$b93cca2b152532b9)(event, top_tabs, t.index, (e, tab)=>handleTopNavClick(e, tab));
        });
        topNavButtons.on('click', handleTopNavClick);
        if (repsData.length) {
            const finalDate = Date.now();
            const handleRepTabClick = function(_, newTab) {
                tabs.forEach((t)=>t.selected = false);
                newTab.selected = true;
                navButtons.attr('aria-selected', (t)=>t.selected).attr('aria-controls', (t)=>t.controls).attr('tabindex', (t)=>t.selected ? 0 : -1).attr('id', (t)=>`tab_${t.id}`).attr('class', (t)=>t.selected ? 'selected' : null).on('keydown', function(event, t) {
                    (0, $9f780b598065538f$export$b93cca2b152532b9)(event, tabs, t.index, (e, tab)=>handleRepTabClick(e, tab));
                });
                $ee6de28bce72be65$export$2e2bcd8739ae039('div.dashboard_card').style('display', 'none');
                $b0ba9a260c958684$export$2e2bcd8739ae039(`div#card_${newTab.id}.dashboard_card`).style('display', null);
                // Ensure it's only drawn once.
                if (!newTab.drawn) {
                    (0, $9f780b598065538f$export$ac7f0c3f46b07209)(repsData.find((r)=>r.id === newTab.id), finalDate, district, issueColor, issueIdToName, duration);
                    newTab.drawn = true;
                }
            };
            // Clean up any existing nav buttons to prevent duplicates
            $b0ba9a260c958684$export$2e2bcd8739ae039('div#nav').selectAll('*').remove();
            const navButtons = $b0ba9a260c958684$export$2e2bcd8739ae039('div#nav').selectAll('button').data(tabs).enter().append('button').attr('role', 'tab').attr('aria-selected', (t)=>t.selected).attr('class', (t)=>t.selected ? 'selected' : null).html((t)=>t.name);
            navButtons.on('click', handleRepTabClick);
            handleRepTabClick(null, tabs.find((t)=>t.selected));
        }
        $ee6de28bce72be65$export$2e2bcd8739ae039('h2.subtitle_detail').html(`Total calls, ${duration}`);
        handleTopNavClick(null, top_tabs.find((t)=>t.selected));
        $b0ba9a260c958684$export$2e2bcd8739ae039('div#dashboard-content').style('visibility', 'visible');
        return ()=>{
            isDrawn.current = false;
            $b0ba9a260c958684$export$2e2bcd8739ae039('div#topNav').selectAll('*').remove();
            $b0ba9a260c958684$export$2e2bcd8739ae039('div#nav').selectAll('*').remove();
            $b0ba9a260c958684$export$2e2bcd8739ae039('div#reps_section').selectAll('.dashboard_card').remove();
            $b0ba9a260c958684$export$2e2bcd8739ae039('div#dashboard-content').style('visibility', 'hidden');
        };
    }, [
        isLoading,
        usaData,
        repsData,
        district
    ]);
    if (!isLoading && (isError || usaData.states.length === 0 || !usaData.usa || usaData.usa.total === 0)) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h2", {
                children: "Error loading the dashboard"
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                children: "Please try again later"
            })
        ]
    });
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        id: "dashboard-react-wrapper",
        children: isLoading && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h2", {
                    children: "Loading the latest data..."
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    id: "loader",
                    "aria-label": "loading icon",
                    role: "status"
                })
            ]
        })
    });
};
var $7f4297784c6cf5da$export$2e2bcd8739ae039 = $7f4297784c6cf5da$var$Dashboard;




var $gIfym = parcelRequire("gIfym");





const $f771b54619a63015$var$IssueSearch = ({ locationState: locationState })=>{
    const [state, setState] = (0, $gIfym.useState)({
        searchTerm: '',
        nationalIssues: [],
        stateIssues: {},
        isLoading: false,
        isSearchFocused: false,
        hasSearched: false,
        hasLoggedSearch: false
    });
    const searchInputRef = (0, $gIfym.useRef)(null);
    const fetchIssues = async ()=>{
        const response = await (0, (/*@__PURE__*/$parcel$interopDefault($211a2c8778873708$exports))).get($58e79092af177c1d$export$74281da0d93ff65a);
        return response.data;
    };
    const loadIssues = async ()=>{
        setState((prev)=>{
            if (prev.hasSearched) return prev;
            return {
                ...prev,
                isLoading: true
            };
        });
        try {
            const response = await fetchIssues();
            setState((prev)=>({
                    ...prev,
                    nationalIssues: response.issues,
                    stateIssues: response.stateIssues,
                    isLoading: false,
                    hasSearched: true
                }));
        } catch (error) {
            console.error('Failed to fetch issues:', error);
            setState((prev)=>({
                    ...prev,
                    isLoading: false
                }));
        }
    };
    // Load issues on mount if location is available, or when location becomes available
    (0, $gIfym.useEffect)(()=>{
        if (locationState) loadIssues();
    }, [
        locationState
    ]);
    // Listen for location loaded event and load issues immediately
    (0, $gIfym.useEffect)(()=>{
        const handleLocationLoaded = ()=>{
            if (!state.hasSearched) loadIssues();
        };
        document.addEventListener($58e79092af177c1d$export$7ff69bf5c61582bf.LOCATION_LOADED, handleLocationLoaded);
        // Also load issues on mount if no location is set (fallback for users without location)
        const timer = setTimeout(()=>{
            if (!locationState && !state.hasSearched) loadIssues();
        }, 100); // Reduced timeout since we have the event listener
        return ()=>{
            document.removeEventListener($58e79092af177c1d$export$7ff69bf5c61582bf.LOCATION_LOADED, handleLocationLoaded);
            clearTimeout(timer);
        };
    }, []);
    (0, $gIfym.useEffect)(()=>{
        // Hide static issues list only when we have loaded dynamic issues or when actively searching
        const staticSection = document.querySelector('.i-bar-list-section');
        if (staticSection) {
            const shouldHide = state.hasSearched && !state.isLoading || state.searchTerm.length >= 3;
            staticSection.style.display = shouldHide ? 'none' : '';
        }
    }, [
        state.searchTerm,
        state.hasSearched,
        state.isLoading
    ]);
    // Debounced search term tracking
    (0, $gIfym.useEffect)(()=>{
        if (state.searchTerm.length >= 3 && !state.hasLoggedSearch) {
            const timeoutId = setTimeout(()=>{
                (0, $c6a51ca48f202faf$export$921e5bdaeee2c590)(state.searchTerm);
                setState((prev)=>({
                        ...prev,
                        hasLoggedSearch: true
                    }));
            }, 1000); // Wait 1 second after user stops typing
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        state.searchTerm,
        state.hasLoggedSearch
    ]);
    const handleSearchFocus = async ()=>{
        if (!state.isSearchFocused) {
            setState((prev)=>({
                    ...prev,
                    isSearchFocused: true
                }));
            // Only load issues on focus if we don't have location
            if (!locationState && !state.hasSearched) await loadIssues();
        }
    };
    const handleSearchBlur = ()=>{
    // Don't hide search results on blur - keep them visible even when clicking outside
    // Results should remain visible until explicitly cleared or user starts a new search
    };
    const handleSearchChange = (e)=>{
        const searchTerm = e.target.value;
        setState((prev)=>({
                ...prev,
                searchTerm: searchTerm
            }));
    };
    const clearSearch = ()=>{
        setState((prev)=>({
                ...prev,
                searchTerm: '',
                isSearchFocused: false,
                hasLoggedSearch: false
            }));
        if (searchInputRef.current) searchInputRef.current.blur();
    };
    const isAllPage = window.location.pathname.startsWith('/all');
    const getOrderedIssues = ()=>{
        const userState = locationState?.state;
        const userStateIssues = userState ? (state.stateIssues[userState] || []).filter((issue)=>!issue.hidden && (isAllPage || issue.active)) : [];
        const nationalIssues = state.nationalIssues.filter((issue)=>!issue.hidden && issue.active);
        // Return user's state issues first, then national issues
        return [
            ...userStateIssues,
            ...nationalIssues
        ];
    };
    const getIssueState = (issue)=>{
        // Check if this issue exists in any state's issue array
        for (const [stateAbbr, stateIssuesArray] of Object.entries(state.stateIssues)){
            if (stateIssuesArray.some((stateIssue)=>stateIssue.id === issue.id)) return stateAbbr;
        }
        return null; // It's a national issue
    };
    const renderIssueItem = (issue)=>{
        const stateAbbr = getIssueState(issue);
        const stateName = stateAbbr ? (0, $abe909a3f4f45831$export$772c9c620e7f9ca7)(stateAbbr) : null;
        // Generate correct URL format: state issues use /state/<state name lowercase>/<slug>/, national issues use /issue/<slug>/
        const issueUrl = stateName ? `/state/${stateName.toLowerCase().replace(/\s+/g, '-')}/${issue.slug}/` : `/issue/${issue.slug}/`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("a", {
            className: "i-bar-item is-unsorted",
            href: issueUrl,
            style: {
                position: 'relative'
            },
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "i-bar-item-check",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "i-bar-check-completed",
                        "data-issue-id": issue.id,
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("i", {
                                className: "fa fa-phone"
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                className: "sr-only",
                                children: "Needs your calls"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("strong", {
                    children: issue.name
                }),
                stateName && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "i-bar-state-banner",
                    children: stateName
                })
            ]
        }, issue.id);
    };
    const filterIssues = (searchTerm)=>{
        if (!searchTerm || searchTerm.length < 3) return [];
        // Search across ALL issues from all states + national issues
        const allStateIssues = Object.values(state.stateIssues).flat().filter((issue)=>!issue.hidden);
        const searchableIssues = [
            ...allStateIssues,
            ...state.nationalIssues.filter((issue)=>!issue.hidden)
        ];
        const lowercaseSearch = searchTerm.toLowerCase();
        const filtered = searchableIssues.filter((issue)=>issue.name.toLowerCase().includes(lowercaseSearch) || issue.reason.toLowerCase().includes(lowercaseSearch) || issue.script.toLowerCase().includes(lowercaseSearch) || issue.slug.toLowerCase().includes(lowercaseSearch));
        // Create word boundary regex for whole-word matching
        const wholeWordRegex = new RegExp(`\\b${lowercaseSearch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
        // Sort with enhanced prioritization
        return filtered.sort((a, b)=>{
            // Check for whole-word matches in name
            const aNameWholeWord = wholeWordRegex.test(a.name);
            const bNameWholeWord = wholeWordRegex.test(b.name);
            // Check for any name matches (including partial)
            const aNameMatch = a.name.toLowerCase().includes(lowercaseSearch);
            const bNameMatch = b.name.toLowerCase().includes(lowercaseSearch);
            // Check for whole-word matches in any field
            const aAnyWholeWord = wholeWordRegex.test(a.name) || wholeWordRegex.test(a.reason) || wholeWordRegex.test(a.script) || wholeWordRegex.test(a.slug);
            const bAnyWholeWord = wholeWordRegex.test(b.name) || wholeWordRegex.test(b.reason) || wholeWordRegex.test(b.script) || wholeWordRegex.test(b.slug);
            // Priority order:
            // 1. Whole-word match in name
            // 2. Partial match in name
            // 3. Whole-word match in any field
            // 4. Partial match in any field
            if (aNameWholeWord && !bNameWholeWord) return -1;
            if (!aNameWholeWord && bNameWholeWord) return 1;
            if (aNameMatch && !bNameMatch) return -1;
            if (!aNameMatch && bNameMatch) return 1;
            if (aAnyWholeWord && !bAnyWholeWord) return -1;
            if (!aAnyWholeWord && bAnyWholeWord) return 1;
            return 0;
        }).slice(0, 10); // Limit to top 10 results
    };
    const filteredIssues = filterIssues(state.searchTerm);
    const orderedIssues = getOrderedIssues();
    const shouldShowSearchResults = state.searchTerm.length >= 3;
    // Fire event when search results are rendered to update issue completion status
    (0, $gIfym.useEffect)(()=>{
        if (shouldShowSearchResults || orderedIssues.length > 0 && state.hasSearched) // Use setTimeout to ensure DOM has been updated
        setTimeout(()=>{
            document.dispatchEvent(new CustomEvent($58e79092af177c1d$export$7ff69bf5c61582bf.SEARCH_RESULTS_RENDERED));
        }, 0);
    }, [
        filteredIssues,
        orderedIssues,
        shouldShowSearchResults,
        state.hasSearched
    ]);
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "i-bar-search",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "i-bar-search-field",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                        ref: searchInputRef,
                        type: "text",
                        placeholder: "Search all issues...",
                        value: state.searchTerm,
                        onChange: handleSearchChange,
                        onFocus: handleSearchFocus,
                        onBlur: handleSearchBlur,
                        className: "i-bar-search-input",
                        maxLength: 30
                    }),
                    state.searchTerm && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                        className: "i-bar-search-clear",
                        onClick: clearSearch,
                        type: "button",
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("i", {
                            className: "fa fa-times"
                        })
                    })
                ]
            }),
            (shouldShowSearchResults && !state.isLoading || !shouldShowSearchResults && orderedIssues.length > 0 && state.hasSearched) && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "i-bar-search-results",
                children: shouldShowSearchResults ? filteredIssues.length > 0 ? filteredIssues.map((issue)=>renderIssueItem(issue)) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: "i-bar-search-no-results",
                    children: [
                        "No issues found matching \u201C",
                        state.searchTerm,
                        "\u201D"
                    ]
                }) : orderedIssues.map((issue)=>renderIssueItem(issue))
            })
        ]
    });
};
var $f771b54619a63015$export$2e2bcd8739ae039 = (0, $b410c744327f470f$export$71260fd0c34a821)($f771b54619a63015$var$IssueSearch);




var $gIfym = parcelRequire("gIfym");

const $c728bd3ce94d7fff$var$FundraisingProgress = ({ target: target = 100000, current: current = 0, donateUrl: donateUrl = 'https://secure.actblue.com/donate/5calls-state' })=>{
    const [state, setState] = (0, $gIfym.useState)({
        currentAmount: current,
        targetAmount: target
    });
    (0, $gIfym.useEffect)(()=>{
        (0, $c6a51ca48f202faf$export$f9b588de50666abf)().then((donationData)=>{
            setState((prevState)=>({
                    ...prevState,
                    currentAmount: donationData.total
                }));
        }).catch((error)=>{
            console.error('Failed to fetch donation stats:', error);
            // Fallback to placeholder amount if API fails
            setState((prevState)=>({
                    ...prevState,
                    currentAmount: 12500
                }));
        });
    }, []);
    const progressPercentage = Math.min(state.currentAmount / state.targetAmount * 100, 100);
    const formatCurrency = (amount)=>{
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };
    const handleAmountClick = ()=>{
        window.open(donateUrl, '_blank', 'noopener,noreferrer');
    };
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "fundraising-progress",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "progress-header",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "progress-amounts",
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("a", {
                                href: donateUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "current-amount clickable-amount",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    handleAmountClick();
                                },
                                children: formatCurrency(state.currentAmount)
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("a", {
                                href: donateUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "target-amount clickable-amount",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    handleAmountClick();
                                },
                                children: [
                                    "of ",
                                    formatCurrency(state.targetAmount),
                                    " goal"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "progress-percentage",
                        children: [
                            Math.round(progressPercentage),
                            "%"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "progress-bar",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "progress-fill",
                    style: {
                        width: `${progressPercentage}%`
                    }
                })
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "donate-button-container",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("a", {
                    href: donateUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "button donate-button",
                    children: "Donate Now"
                })
            })
        ]
    });
};
var $c728bd3ce94d7fff$export$2e2bcd8739ae039 = $c728bd3ce94d7fff$var$FundraisingProgress;




var $gIfym = parcelRequire("gIfym");


const $77bec139f5bc74a9$var$SUBSCRIPTION_OPTIONS = [
    {
        id: 'wants_newsletter',
        name: 'Weekly Newsletter',
        description: 'Get a weekly summary of the most important issues and actions you can take.'
    },
    {
        id: 'wants_district',
        name: 'District Updates',
        description: 'Receive updates specific to your congressional district and representatives.'
    }
];
const $77bec139f5bc74a9$var$EmailSubscriptions = ()=>{
    const [subscriberId, setSubscriberId] = (0, $gIfym.useState)(null);
    const [preferences, setPreferences] = (0, $gIfym.useState)({});
    const [loading, setLoading] = (0, $gIfym.useState)(false);
    const [initialLoad, setInitialLoad] = (0, $gIfym.useState)(true);
    const [hasChanges, setHasChanges] = (0, $gIfym.useState)(false);
    (0, $gIfym.useEffect)(()=>{
        const initializeSubscriptions = async ()=>{
            // Check for subscriber ID in URL first, then localStorage
            const urlParams = new URLSearchParams(window.location.search);
            const urlSubId = urlParams.get('sub_id');
            const storedSubId = localStorage.getItem('subscriber');
            const subId = urlSubId || storedSubId;
            console.log('checking for subid...', subId);
            if (subId) {
                // User has subscriber ID - load preferences
                setSubscriberId(subId);
                // Store in localStorage if it came from URL
                if (urlSubId) localStorage.setItem('subscriber', urlSubId);
                // Initialize preferences with all options set to false
                const initialPrefs = {};
                $77bec139f5bc74a9$var$SUBSCRIPTION_OPTIONS.forEach((option)=>{
                    initialPrefs[option.id] = false;
                });
                setPreferences(initialPrefs);
                // Load their actual preferences
                try {
                    await loadPreferences(subId);
                } catch (error) {
                    console.error('Failed to load subscription preferences:', error);
                    (0, $bfb33a28c1c2ef06$export$b410431fab84fa58).error('Failed to load subscription preferences');
                }
            } else // No subscriber ID - just show message
            setInitialLoad(false);
        };
        initializeSubscriptions();
    }, []);
    const loadPreferences = async (subId)=>{
        setLoading(true);
        try {
            const prefs = await (0, $c6a51ca48f202faf$export$d79a4b8fce455323)(subId);
            setPreferences((prev)=>({
                    ...prev,
                    ...prefs
                }));
        } catch (error) {
            console.error('Failed to load preferences:', error);
            (0, $bfb33a28c1c2ef06$export$b410431fab84fa58).error('Failed to load your subscription preferences');
        } finally{
            setLoading(false);
            setInitialLoad(false);
        }
    };
    const handleToggle = (subscriptionId)=>{
        setPreferences((prev)=>({
                ...prev,
                [subscriptionId]: !prev[subscriptionId]
            }));
        setHasChanges(true);
    };
    const handlePreferencesSubmit = async (e)=>{
        e.preventDefault();
        if (!subscriberId) {
            (0, $bfb33a28c1c2ef06$export$b410431fab84fa58).error('No subscriber ID found');
            return;
        }
        setLoading(true);
        try {
            await (0, $c6a51ca48f202faf$export$71d9a332f1450004)(subscriberId, preferences);
            (0, $bfb33a28c1c2ef06$export$b410431fab84fa58).success('Your subscription preferences have been saved!');
            setHasChanges(false);
        } catch (error) {
            console.error('Failed to update preferences:', error);
            (0, $bfb33a28c1c2ef06$export$b410431fab84fa58).error('Failed to update your subscription preferences');
        } finally{
            setLoading(false);
        }
    };
    if (initialLoad && subscriberId) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        className: "subscriptions-loading",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
            children: "Loading your subscription preferences..."
        })
    });
    // Show message if no subscriber ID
    if (!subscriberId) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        className: "email-subscriptions",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: "no-subscriber-message",
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h2", {
                    children: "Email Link Required"
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                    children: "To manage your email subscription preferences, please use the link provided in one of our emails."
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                    children: "If you're not currently subscribed and would like to receive emails from 5 Calls, you can sign up using the newsletter form on our homepage."
                })
            ]
        })
    });
    // Show preferences form if subscriber ID exists
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        className: "email-subscriptions",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("form", {
            onSubmit: handlePreferencesSubmit,
            className: "subscriptions-form",
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: "subscription-options",
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h2", {
                            children: "Select Your Email Preferences"
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                            className: "options-description",
                            children: "Choose which types of emails you'd like to receive:"
                        }),
                        $77bec139f5bc74a9$var$SUBSCRIPTION_OPTIONS.map((option)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                className: "subscription-option",
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("label", {
                                    className: "checkbox-label",
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: Boolean(preferences[option.id]),
                                            onChange: ()=>handleToggle(option.id),
                                            disabled: loading
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                                            className: "option-details",
                                            children: [
                                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                                    className: "option-name",
                                                    children: option.name
                                                }),
                                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                                    className: "option-description",
                                                    children: option.description
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, option.id))
                    ]
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                            type: "submit",
                            className: "button primary",
                            disabled: loading || !hasChanges,
                            children: loading ? 'Saving...' : 'Save Preferences'
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                            className: "unsubscribe-note",
                            children: "Want to unsubscribe from all emails? Uncheck all options and save your preferences."
                        })
                    ]
                })
            ]
        })
    });
};
var $77bec139f5bc74a9$export$2e2bcd8739ae039 = $77bec139f5bc74a9$var$EmailSubscriptions;


var $df6ca661b897a314$exports = {};

$df6ca661b897a314$exports = (parcelRequire("bjWEU"));




(0, (/*@__PURE__*/$parcel$interopDefault($df6ca661b897a314$exports))).start('67e3931dbe1bbf48991ce7d682ceb676');
(0, $8fec4eb0f62d5de4$export$2e2bcd8739ae039).init({
    appId: '5fd4ca41-9f6c-4149-a312-ae3e71b35c0e',
    path: '/js/',
    serviceWorkerParam: {
        scope: '/js/'
    }
}).then(()=>{
    (0, $8fec4eb0f62d5de4$export$2e2bcd8739ae039).setExternalUserId((0, $e90bc56065a3c90c$export$2e2bcd8739ae039).callerID());
});
(0, (/*@__PURE__*/$parcel$interopDefault($9c8166cf7946f78b$exports)))(()=>{
    const district = $76569041ca315844$var$checkForDistrict();
    $76569041ca315844$var$checkForSubID(district);
    $76569041ca315844$var$checkForGCLID();
    $76569041ca315844$var$checkForReferral();
});
// Set the district tag in the newsletter form if district exists
const $76569041ca315844$var$checkForDistrict = ()=>{
    const district = localStorage.getItem((0, $58e79092af177c1d$export$2ec53a4c598cbdd5).DISTRICT);
    const districtTagInput = document.getElementById('district-tag');
    if (district && districtTagInput) districtTagInput.setAttribute('value', district);
    else if (districtTagInput) districtTagInput.remove();
    return district;
};
// sub_id is the subscriber id from buttondown that we send in emails
// if it exists, we want to store it so we can keep district info up to date
const $76569041ca315844$var$checkForSubID = (district)=>{
    const urlParams = new URLSearchParams(window.location.search);
    const subId = urlParams.get('sub_id');
    if (!subId) return;
    localStorage.setItem((0, $58e79092af177c1d$export$2ec53a4c598cbdd5).SUBSCRIBER, subId);
    // then remove it
    $76569041ca315844$var$removeParam('sub_id');
    // if there's already a district set, post it to the server
    if (district) (0, $c6a51ca48f202faf$export$873544188ab6667c)(subId, district);
};
const $76569041ca315844$var$checkForGCLID = ()=>{
    const urlParams = new URLSearchParams(window.location.search);
    const gclid = urlParams.get('gclid');
    if (!gclid) return;
    $76569041ca315844$var$removeParam('gclid');
    (0, $c6a51ca48f202faf$export$8d44ef4bb75c4dd6)(gclid);
};
const $76569041ca315844$var$checkForReferral = ()=>{
    const urlParams = new URLSearchParams(window.location.search);
    const refCode = urlParams.get('ref');
    if (!refCode) return;
    $76569041ca315844$var$removeParam('ref');
    (0, $c6a51ca48f202faf$export$a1833bc2b9721531)(refCode, window.location.pathname, null);
};
// Remove a param from URL without reloading the page
const $76569041ca315844$var$removeParam = (param)=>{
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete(param);
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
};
const $76569041ca315844$var$handleRootRenderError = (error, component)=>{
    if (`${error}`.includes('Minified React error #200')) ;
    else if (`${error}`.includes('Target container is not a DOM element.')) ;
    else console.error(`error loading ${component} component: ${error}`);
};
const $76569041ca315844$var$startComponentRenders = ()=>{
    const setupOutcomesFloating = ()=>{
        const scriptElement = document.getElementById('react-script');
        const outcomesElement = document.getElementById('react-outcomes');
        if (scriptElement && outcomesElement) {
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    if (entry.isIntersecting || entry.boundingClientRect.top <= 0) // Add class when script is in view or above viewport
                    outcomesElement.classList.add('outcomes-float');
                    else if (entry.boundingClientRect.top > 0) // Remove class when script is below viewport
                    outcomesElement.classList.remove('outcomes-float');
                });
            }, {
                threshold: 0,
                rootMargin: '0px'
            });
            observer.observe(scriptElement);
        }
    };
    // Call the setup after a short delay to ensure elements are rendered
    setTimeout(setupOutcomesFloating, 100);
    const getGroupFromPath = ()=>{
        const path = window.location.pathname;
        //eslint-disable-next-line
        const match = path.match(/\/groups\/([^\/]+)\/?$/);
        return match ? match[1] : null;
    };
    const islands = [
        {
            id: 'react-location',
            component: (0, $9c71a30a7953d981$export$2e2bcd8739ae039),
            hasStateProvider: true
        },
        {
            id: 'react-reps',
            component: (0, $cd098264dbb86b3b$export$2e2bcd8739ae039),
            hasStateProvider: true
        },
        {
            id: 'react-script',
            component: (0, $e8f52fff32e142fb$export$2e2bcd8739ae039),
            hasStateProvider: true
        },
        {
            id: 'react-outcomes',
            component: (0, $caeedc682adc97d4$export$2e2bcd8739ae039),
            hasStateProvider: true
        },
        {
            id: 'react-share',
            component: (0, $52c5cd1f6962a23d$export$2e2bcd8739ae039)
        },
        {
            id: 'react-phone',
            component: (0, $bac186090ef192a7$export$2e2bcd8739ae039)
        },
        {
            id: 'react-call-count',
            component: (0, $c380b6b98c2b3956$export$2e2bcd8739ae039)
        },
        {
            id: 'api-form',
            component: (0, $74944d1921030697$export$2e2bcd8739ae039)
        },
        {
            id: 'react-settings',
            component: (0, $14edbfa9de73b5fc$export$2e2bcd8739ae039)
        },
        {
            id: 'react-search',
            component: (0, $f771b54619a63015$export$2e2bcd8739ae039),
            hasStateProvider: true
        },
        {
            id: 'react-groupcounts',
            component: (0, $26e2d871a9745be4$export$2e2bcd8739ae039),
            condition: Boolean(getGroupFromPath())
        },
        {
            id: 'toast-container',
            component: ()=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bfb33a28c1c2ef06$export$f2815235e76a62b9), {
                    position: "top-center",
                    draggable: true,
                    transition: (0, $bfb33a28c1c2ef06$export$d8dc01b5c85a37b9)
                })
        },
        {
            id: 'react-dashboard',
            component: (0, $7f4297784c6cf5da$export$2e2bcd8739ae039)
        },
        {
            id: 'react-fundraising',
            component: (0, $c728bd3ce94d7fff$export$2e2bcd8739ae039)
        },
        {
            id: 'react-subscriptions',
            component: (0, $77bec139f5bc74a9$export$2e2bcd8739ae039)
        }
    ];
    islands.forEach(({ id: id, component: component, hasStateProvider: hasStateProvider, condition: condition })=>{
        try {
            if (condition === false) return;
            const element = document.getElementById(id);
            if (!element) return;
            const el = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(component);
            if (hasStateProvider) (0, $49079038e9e61aa0$exports.createRoot)(element).render(/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b410c744327f470f$export$2e2bcd8739ae039), {
                children: el
            }));
            else (0, $49079038e9e61aa0$exports.createRoot)(element).render(el);
        } catch (error) {
            $76569041ca315844$var$handleRootRenderError(error, id);
        }
    });
};
$76569041ca315844$var$startComponentRenders();


//# sourceMappingURL=react.772a366b.js.map
